import * as React$1 from 'react';
import React__default, { forwardRef, useContext, Children, isValidElement, cloneElement, useState, useEffect, useRef, useMemo, useImperativeHandle } from 'react';
import * as ReactDOM from 'react-dom';
import ReactDOM__default from 'react-dom';
import styled$4 from 'styled-components';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "/*\n! tailwindcss v3.3.7 | MIT License | https://tailwindcss.com\n*//*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n\n*,\n::before,\n::after {\n  box-sizing: border-box; /* 1 */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: #ECECEC; /* 2 */\n}\n\n::before,\n::after {\n  --tw-content: '';\n}\n\n/*\n1. Use a consistent sensible line-height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n3. Use a more readable tab size.\n4. Use the user's configured `sans` font-family by default.\n5. Use the user's configured `sans` font-feature-settings by default.\n6. Use the user's configured `sans` font-variation-settings by default.\n*/\n\nhtml {\n  line-height: 1.5; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -moz-tab-size: 4; /* 3 */\n  -o-tab-size: 4;\n     tab-size: 4; /* 3 */\n  font-family: HelveticaNowDisplay, \"Helvetica Neue\"; /* 4 */\n  font-feature-settings: normal; /* 5 */\n  font-variation-settings: normal; /* 6 */\n}\n\n/*\n1. Remove the margin in all browsers.\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/\n\nbody {\n  margin: 0; /* 1 */\n  line-height: inherit; /* 2 */\n}\n\n/*\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n3. Ensure horizontal rules are visible by default.\n*/\n\nhr {\n  height: 0; /* 1 */\n  color: inherit; /* 2 */\n  border-top-width: 1px; /* 3 */\n}\n\n/*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\n\nabbr:where([title]) {\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}\n\n/*\nRemove the default font size and weight for headings.\n*/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/*\nReset links to optimize for opt-in styling instead of opt-out.\n*/\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/*\nAdd the correct font weight in Edge and Safari.\n*/\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/*\n1. Use the user's configured `mono` font-family by default.\n2. Use the user's configured `mono` font-feature-settings by default.\n3. Use the user's configured `mono` font-variation-settings by default.\n4. Correct the odd `em` font sizing in all browsers.\n*/\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; /* 1 */\n  font-feature-settings: normal; /* 2 */\n  font-variation-settings: normal; /* 3 */\n  font-size: 1em; /* 4 */\n}\n\n/*\nAdd the correct font size in all browsers.\n*/\n\nsmall {\n  font-size: 80%;\n}\n\n/*\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/*\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n3. Remove gaps between table borders by default.\n*/\n\ntable {\n  text-indent: 0; /* 1 */\n  border-color: inherit; /* 2 */\n  border-collapse: collapse; /* 3 */\n}\n\n/*\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n3. Remove default padding in all browsers.\n*/\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-feature-settings: inherit; /* 1 */\n  font-variation-settings: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  font-weight: inherit; /* 1 */\n  line-height: inherit; /* 1 */\n  color: inherit; /* 1 */\n  margin: 0; /* 2 */\n  padding: 0; /* 3 */\n}\n\n/*\nRemove the inheritance of text transform in Edge and Firefox.\n*/\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Remove default button styles.\n*/\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button; /* 1 */\n  background-color: transparent; /* 2 */\n  background-image: none; /* 2 */\n}\n\n/*\nUse the modern Firefox focus style for all focusable elements.\n*/\n\n:-moz-focusring {\n  outline: auto;\n}\n\n/*\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\n\nprogress {\n  vertical-align: baseline;\n}\n\n/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n\n[type='search'] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/*\nAdd the correct display in Chrome and Safari.\n*/\n\nsummary {\n  display: list-item;\n}\n\n/*\nRemoves the default spacing and border for appropriate elements.\n*/\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  padding: 0;\n}\n\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*\nReset default styling for dialogs.\n*/\ndialog {\n  padding: 0;\n}\n\n/*\nPrevent resizing textareas horizontally by default.\n*/\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/\n\ninput::-moz-placeholder, textarea::-moz-placeholder {\n  opacity: 1; /* 1 */\n  color: #B1B1B1; /* 2 */\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1; /* 1 */\n  color: #B1B1B1; /* 2 */\n}\n\n/*\nSet the default cursor for buttons.\n*/\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/*\nMake sure disabled buttons don't get the pointer cursor.\n*/\n:disabled {\n  cursor: default;\n}\n\n/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block; /* 1 */\n  vertical-align: middle; /* 2 */\n}\n\n/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Make elements with the HTML hidden attribute stay hidden by default */\n[hidden] {\n  display: none;\n}\n\n*, ::before, ::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(15 46 255 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(15 46 255 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n.collapse {\n  visibility: collapse;\n}\n.fixed {\n  position: fixed;\n}\n.absolute {\n  position: absolute;\n}\n.relative {\n  position: relative;\n}\n.sticky {\n  position: sticky;\n}\n.inset-x-0 {\n  left: 0px;\n  right: 0px;\n}\n.bottom-20 {\n  bottom: 5rem;\n}\n.mx-1 {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n.mx-2 {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n.my-2 {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.my-3 {\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n.my-3\\.5 {\n  margin-top: 0.875rem;\n  margin-bottom: 0.875rem;\n}\n.my-4 {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n.-ml-1 {\n  margin-left: -0.25rem;\n}\n.mb-1 {\n  margin-bottom: 0.25rem;\n}\n.mb-2 {\n  margin-bottom: 0.5rem;\n}\n.mb-6 {\n  margin-bottom: 1.5rem;\n}\n.ml-1 {\n  margin-left: 0.25rem;\n}\n.ml-1\\.375 {\n  margin-left: 0.34375rem;\n}\n.ml-2 {\n  margin-left: 0.5rem;\n}\n.ml-2\\.5 {\n  margin-left: 0.625rem;\n}\n.ml-4 {\n  margin-left: 1rem;\n}\n.ml-6 {\n  margin-left: 1.5rem;\n}\n.mr-1 {\n  margin-right: 0.25rem;\n}\n.mr-2 {\n  margin-right: 0.5rem;\n}\n.mt-2 {\n  margin-top: 0.5rem;\n}\n.mt-3 {\n  margin-top: 0.75rem;\n}\n.mt-4 {\n  margin-top: 1rem;\n}\n.mt-6 {\n  margin-top: 1.5rem;\n}\n.mt-8 {\n  margin-top: 2rem;\n}\n.box-border {\n  box-sizing: border-box;\n}\n.block {\n  display: block;\n}\n.inline-block {\n  display: inline-block;\n}\n.flex {\n  display: flex;\n}\n.inline-flex {\n  display: inline-flex;\n}\n.table {\n  display: table;\n}\n.grid {\n  display: grid;\n}\n.hidden {\n  display: none;\n}\n.h-10 {\n  height: 2.5rem;\n}\n.h-4 {\n  height: 1rem;\n}\n.h-7 {\n  height: 1.75rem;\n}\n.h-8 {\n  height: 2rem;\n}\n.h-fit {\n  height: -moz-fit-content;\n  height: fit-content;\n}\n.h-full {\n  height: 100%;\n}\n.h-screen {\n  height: 100vh;\n}\n.w-80 {\n  width: 20rem;\n}\n.w-fit {\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.w-full {\n  width: 100%;\n}\n.w-px {\n  width: 1px;\n}\n.max-w-full {\n  max-width: 100%;\n}\n.flex-shrink-0 {\n  flex-shrink: 0;\n}\n.grow {\n  flex-grow: 1;\n}\n.-rotate-90 {\n  --tw-rotate: -90deg;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n.select-none {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n.flex-row {\n  flex-direction: row;\n}\n.flex-col {\n  flex-direction: column;\n}\n.items-center {\n  align-items: center;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-between {\n  justify-content: space-between;\n}\n.gap-2 {\n  gap: 0.5rem;\n}\n.gap-4 {\n  gap: 1rem;\n}\n.gap-x-2 {\n  -moz-column-gap: 0.5rem;\n       column-gap: 0.5rem;\n}\n.self-stretch {\n  align-self: stretch;\n}\n.overflow-auto {\n  overflow: auto;\n}\n.overflow-hidden {\n  overflow: hidden;\n}\n.overflow-visible {\n  overflow: visible;\n}\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.overflow-ellipsis {\n  text-overflow: ellipsis;\n}\n.whitespace-nowrap {\n  white-space: nowrap;\n}\n.border {\n  border-width: 1px;\n}\n.border-b {\n  border-bottom-width: 1px;\n}\n.border-gray-100 {\n  --tw-border-opacity: 1;\n  border-color: rgb(245 245 245 / var(--tw-border-opacity));\n}\n.border-gray-300 {\n  --tw-border-opacity: 1;\n  border-color: rgb(197 197 197 / var(--tw-border-opacity));\n}\n.bg-black-1000 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 0 0 / var(--tw-bg-opacity));\n}\n.bg-gray-200 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(236 236 236 / var(--tw-bg-opacity));\n}\n.bg-gray-400 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(177 177 177 / var(--tw-bg-opacity));\n}\n.p-2 {\n  padding: 0.5rem;\n}\n.p-4 {\n  padding: 1rem;\n}\n.p-8 {\n  padding: 2rem;\n}\n.px-14 {\n  padding-left: 3.5rem;\n  padding-right: 3.5rem;\n}\n.px-2 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.py-10 {\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n}\n.py-4 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.py-8 {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n.pl-1 {\n  padding-left: 0.25rem;\n}\n.pl-11 {\n  padding-left: 2.75rem;\n}\n.pl-4 {\n  padding-left: 1rem;\n}\n.text-center {\n  text-align: center;\n}\n.font-primary {\n  font-family: HelveticaNowDisplay;\n}\n.text-10 {\n  font-size: 10px;\n}\n.text-12 {\n  font-size: 12px;\n}\n.text-14 {\n  font-size: 14px;\n}\n.text-16 {\n  font-size: 16px;\n}\n.text-18 {\n  font-size: 18px;\n}\n.text-24 {\n  font-size: 24px;\n}\n.font-bold {\n  font-weight: 700;\n}\n.font-extrabold {\n  font-weight: 800;\n}\n.font-normal {\n  font-weight: 400;\n}\n.capitalize {\n  text-transform: capitalize;\n}\n.italic {\n  font-style: italic;\n}\n.leading-17\\.64 {\n  line-height: 17.64px;\n}\n.leading-6 {\n  line-height: 1.5rem;\n}\n.leading-8 {\n  line-height: 2rem;\n}\n.tracking-0\\.02 {\n  letter-spacing: 0.02em;\n}\n.text-black-1000 {\n  --tw-text-opacity: 1;\n  color: rgb(0 0 0 / var(--tw-text-opacity));\n}\n.text-blue-500 {\n  --tw-text-opacity: 1;\n  color: rgb(15 46 255 / var(--tw-text-opacity));\n}\n.text-gray-300 {\n  --tw-text-opacity: 1;\n  color: rgb(197 197 197 / var(--tw-text-opacity));\n}\n.text-gray-400 {\n  --tw-text-opacity: 1;\n  color: rgb(177 177 177 / var(--tw-text-opacity));\n}\n.text-gray-500 {\n  --tw-text-opacity: 1;\n  color: rgb(139 139 139 / var(--tw-text-opacity));\n}\n.text-gray-600 {\n  --tw-text-opacity: 1;\n  color: rgb(119 119 119 / var(--tw-text-opacity));\n}\n.text-gray-700 {\n  --tw-text-opacity: 1;\n  color: rgb(158 158 158 / var(--tw-text-opacity));\n}\n.text-gray-800 {\n  --tw-text-opacity: 1;\n  color: rgb(61 61 61 / var(--tw-text-opacity));\n}\n.text-limeGreen-500 {\n  --tw-text-opacity: 1;\n  color: rgb(0 213 76 / var(--tw-text-opacity));\n}\n.text-orange-500 {\n  --tw-text-opacity: 1;\n  color: rgb(255 77 0 / var(--tw-text-opacity));\n}\n.text-primary {\n  --tw-text-opacity: 1;\n  color: rgb(15 46 255 / var(--tw-text-opacity));\n}\n.text-red-500 {\n  --tw-text-opacity: 1;\n  color: rgb(255 17 17 / var(--tw-text-opacity));\n}\n.text-yellow-500 {\n  --tw-text-opacity: 1;\n  color: rgb(255 203 0 / var(--tw-text-opacity));\n}\n.underline {\n  text-decoration-line: underline;\n}\n.shadow {\n  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n.transition {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n.transition-transform {\n  transition-property: transform;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n.duration-200 {\n  transition-duration: 200ms;\n}\n.ease-in-out {\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.hover\\:bg-gray-100:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(245 245 245 / var(--tw-bg-opacity));\n}\n.hover\\:bg-gray-200:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(236 236 236 / var(--tw-bg-opacity));\n}\n.hover\\:font-extrabold:hover {\n  font-weight: 800;\n}\n.hover\\:text-blue-500:hover {\n  --tw-text-opacity: 1;\n  color: rgb(15 46 255 / var(--tw-text-opacity));\n}\n.hover\\:text-primary:hover {\n  --tw-text-opacity: 1;\n  color: rgb(15 46 255 / var(--tw-text-opacity));\n}\n.hover\\:underline:hover {\n  text-decoration-line: underline;\n}\n.hover\\:opacity-70:hover {\n  opacity: 0.7;\n}\n";
styleInject(css_248z);

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var TripOriginOutlined = {};

var interopRequireDefault$1 = {exports: {}};

(function (module) {
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (interopRequireDefault$1));

var interopRequireDefaultExports$1 = interopRequireDefault$1.exports;

var createSvgIcon$1 = {};

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }
  return function validate(...args) {
    return propType1(...args) || propType2(...args);
  };
}

function _extends$Y() {
  _extends$Y = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$Y.apply(this, arguments);
}

// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function isPlainObject$1(item) {
  if (typeof item !== 'object' || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (!isPlainObject$1(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach(key => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge$1(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends$Y({}, target) : target;
  if (isPlainObject$1(target) && isPlainObject$1(source)) {
    Object.keys(source).forEach(key => {
      if (isPlainObject$1(source[key]) &&
      // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject$1(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge$1(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject$1(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

var deepmerge = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: deepmerge$1,
  isPlainObject: isPlainObject$1
});

var propTypes = {exports: {}};

var reactIs$3 = {exports: {}};

var reactIs_production_min$2 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$2;

function requireReactIs_production_min$2 () {
	if (hasRequiredReactIs_production_min$2) return reactIs_production_min$2;
	hasRequiredReactIs_production_min$2 = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min$2.AsyncMode=l;reactIs_production_min$2.ConcurrentMode=m;reactIs_production_min$2.ContextConsumer=k;reactIs_production_min$2.ContextProvider=h;reactIs_production_min$2.Element=c;reactIs_production_min$2.ForwardRef=n;reactIs_production_min$2.Fragment=e;reactIs_production_min$2.Lazy=t;reactIs_production_min$2.Memo=r;reactIs_production_min$2.Portal=d;
	reactIs_production_min$2.Profiler=g;reactIs_production_min$2.StrictMode=f;reactIs_production_min$2.Suspense=p;reactIs_production_min$2.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min$2.isConcurrentMode=A;reactIs_production_min$2.isContextConsumer=function(a){return z(a)===k};reactIs_production_min$2.isContextProvider=function(a){return z(a)===h};reactIs_production_min$2.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min$2.isForwardRef=function(a){return z(a)===n};reactIs_production_min$2.isFragment=function(a){return z(a)===e};reactIs_production_min$2.isLazy=function(a){return z(a)===t};
	reactIs_production_min$2.isMemo=function(a){return z(a)===r};reactIs_production_min$2.isPortal=function(a){return z(a)===d};reactIs_production_min$2.isProfiler=function(a){return z(a)===g};reactIs_production_min$2.isStrictMode=function(a){return z(a)===f};reactIs_production_min$2.isSuspense=function(a){return z(a)===p};
	reactIs_production_min$2.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min$2.typeOf=z;
	return reactIs_production_min$2;
}

var reactIs_development$2 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$2;

function requireReactIs_development$2 () {
	if (hasRequiredReactIs_development$2) return reactIs_development$2;
	hasRequiredReactIs_development$2 = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$2.AsyncMode = AsyncMode;
	reactIs_development$2.ConcurrentMode = ConcurrentMode;
	reactIs_development$2.ContextConsumer = ContextConsumer;
	reactIs_development$2.ContextProvider = ContextProvider;
	reactIs_development$2.Element = Element;
	reactIs_development$2.ForwardRef = ForwardRef;
	reactIs_development$2.Fragment = Fragment;
	reactIs_development$2.Lazy = Lazy;
	reactIs_development$2.Memo = Memo;
	reactIs_development$2.Portal = Portal;
	reactIs_development$2.Profiler = Profiler;
	reactIs_development$2.StrictMode = StrictMode;
	reactIs_development$2.Suspense = Suspense;
	reactIs_development$2.isAsyncMode = isAsyncMode;
	reactIs_development$2.isConcurrentMode = isConcurrentMode;
	reactIs_development$2.isContextConsumer = isContextConsumer;
	reactIs_development$2.isContextProvider = isContextProvider;
	reactIs_development$2.isElement = isElement;
	reactIs_development$2.isForwardRef = isForwardRef;
	reactIs_development$2.isFragment = isFragment;
	reactIs_development$2.isLazy = isLazy;
	reactIs_development$2.isMemo = isMemo;
	reactIs_development$2.isPortal = isPortal;
	reactIs_development$2.isProfiler = isProfiler;
	reactIs_development$2.isStrictMode = isStrictMode;
	reactIs_development$2.isSuspense = isSuspense;
	reactIs_development$2.isValidElementType = isValidElementType;
	reactIs_development$2.typeOf = typeOf;
	  })();
	}
	return reactIs_development$2;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs$3.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs$3.exports = requireReactIs_production_min$2();
	} else {
	  reactIs$3.exports = requireReactIs_development$2();
	}
	return reactIs$3.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

function isClassComponent$1(elementType) {
  // elementType.prototype?.isReactComponent
  const {
    prototype = {}
  } = elementType;
  return Boolean(prototype.isReactComponent);
}
function acceptingRef(props, propName, componentName, location, propFullName) {
  const element = props[propName];
  const safePropName = propFullName || propName;
  if (element == null ||
  // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === 'undefined') {
    return null;
  }
  let warningHint;
  const elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */
  if (typeof elementType === 'function' && !isClassComponent$1(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }
  if (warningHint !== undefined) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }
  return null;
}
const elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
var elementAcceptingRef$1 = elementAcceptingRef;

function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  const {
    prototype = {}
  } = elementType;
  return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  const propValue = props[propName];
  const safePropName = propFullName || propName;
  if (propValue == null ||
  // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === 'undefined') {
    return null;
  }
  let warningHint;

  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */
  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }
  if (warningHint !== undefined) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }
  return null;
}
var elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef);

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.

const specialProperty = 'exact-prop: \u200b';
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }
  return _extends$Y({}, propTypes, {
    [specialProperty]: props => {
      const unsupportedProps = Object.keys(props).filter(prop => !propTypes.hasOwnProperty(prop));
      if (unsupportedProps.length > 0) {
        return new Error(`The following props are not supported: ${unsupportedProps.map(prop => `\`${prop}\``).join(', ')}. Please remove them.`);
      }
      return null;
    }
  });
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage$1(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe if we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;
  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

var formatMuiErrorMessage = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: formatMuiErrorMessage$1
});

var reactIs$2 = {exports: {}};

var reactIs_production_min$1 = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
	function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}reactIs_production_min$1.ContextConsumer=h;reactIs_production_min$1.ContextProvider=g;reactIs_production_min$1.Element=b;reactIs_production_min$1.ForwardRef=l;reactIs_production_min$1.Fragment=d;reactIs_production_min$1.Lazy=q;reactIs_production_min$1.Memo=p;reactIs_production_min$1.Portal=c;reactIs_production_min$1.Profiler=f;reactIs_production_min$1.StrictMode=e;reactIs_production_min$1.Suspense=m;
	reactIs_production_min$1.SuspenseList=n;reactIs_production_min$1.isAsyncMode=function(){return !1};reactIs_production_min$1.isConcurrentMode=function(){return !1};reactIs_production_min$1.isContextConsumer=function(a){return v(a)===h};reactIs_production_min$1.isContextProvider=function(a){return v(a)===g};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min$1.isForwardRef=function(a){return v(a)===l};reactIs_production_min$1.isFragment=function(a){return v(a)===d};reactIs_production_min$1.isLazy=function(a){return v(a)===q};reactIs_production_min$1.isMemo=function(a){return v(a)===p};
	reactIs_production_min$1.isPortal=function(a){return v(a)===c};reactIs_production_min$1.isProfiler=function(a){return v(a)===f};reactIs_production_min$1.isStrictMode=function(a){return v(a)===e};reactIs_production_min$1.isSuspense=function(a){return v(a)===m};reactIs_production_min$1.isSuspenseList=function(a){return v(a)===n};
	reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};reactIs_production_min$1.typeOf=v;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_SERVER_CONTEXT_TYPE:
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	function isSuspenseList(object) {
	  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
	}

	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.SuspenseList = SuspenseList;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isSuspenseList = isSuspenseList;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = requireReactIs_production_min$1();
} else {
  reactIs$2.exports = requireReactIs_development$1();
}

var reactIsExports$1 = reactIs$2.exports;

// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  const match = `${fn}`.match(fnNameMatchRegex);
  const name = match && match[1];
  return name || '';
}
function getFunctionComponentName(Component, fallback = '') {
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}

/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE11 support
 */
function getDisplayName$1(Component) {
  if (Component == null) {
    return undefined;
  }
  if (typeof Component === 'string') {
    return Component;
  }
  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
  if (typeof Component === 'object') {
    switch (Component.$$typeof) {
      case reactIsExports$1.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');
      case reactIsExports$1.Memo:
        return getWrappedName(Component, Component.type, 'memo');
      default:
        return undefined;
    }
  }
  return undefined;
}

var getDisplayName = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: getDisplayName$1,
  getFunctionName: getFunctionName
});

function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  const propValue = props[propName];
  const safePropName = propFullName || propName;
  if (propValue == null) {
    return null;
  }
  if (propValue && propValue.nodeType !== 1) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an HTMLElement.`);
  }
  return null;
}

const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
var refType$1 = refType;

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize$1(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`capitalize(string)\` expects a string argument.` : formatMuiErrorMessage$1(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var capitalize = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: capitalize$1
});

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }
    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {});
}

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce$1(func, wait = 166) {
  let timeout;
  function debounced(...args) {
    const later = () => {
      // @ts-ignore
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout);
  };
  return debounced;
}

function deprecatedPropType(validator, reason) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }
  return (props, propName, componentName, location, propFullName) => {
    const componentNameSafe = componentName || '<<anonymous>>';
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') {
      return new Error(`The ${location} \`${propFullNameSafe}\` of ` + `\`${componentNameSafe}\` is deprecated. ${reason}`);
    }
    return null;
  };
}

function isMuiElement(element, muiNames) {
  var _muiName, _element$type;
  return /*#__PURE__*/React$1.isValidElement(element) && muiNames.indexOf( // For server components `muiName` is avaialble in element.type._payload.value.muiName
  // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
  // eslint-disable-next-line no-underscore-dangle
  (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}

function requirePropFactory(componentNameInError, Component) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }

  // eslint-disable-next-line react/forbid-foreign-prop-types
  const prevPropTypes = Component ? _extends$Y({}, Component.propTypes) : null;
  const requireProp = requiredProp => (props, propName, componentName, location, propFullName, ...args) => {
    const propFullNameSafe = propFullName || propName;
    const defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];
    if (defaultTypeChecker) {
      const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
      if (typeCheckerResult) {
        return typeCheckerResult;
      }
    }
    if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
      return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
    }
    return null;
  };
  return requireProp;
}

/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */
const useEnhancedEffect = typeof window !== 'undefined' ? React$1.useLayoutEffect : React$1.useEffect;
var useEnhancedEffect$1 = useEnhancedEffect;

let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = React$1.useState(idOverride);
  const id = idOverride || defaultId;
  React$1.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the incrementing value for client-side rendering only.
      // We can't use it server-side.
      // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
}

// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = React$1['useId'.toString()];
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */
function useId(idOverride) {
  if (maybeReactUseId !== undefined) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
  return useGlobalId(idOverride);
}

function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  const propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== 'undefined') {
    return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
  }
  return null;
}

function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = 'value'
}) {
  // isControlled is ignored in the hook dependency lists as it should never change.
  const {
    current: isControlled
  } = React$1.useRef(controlled !== undefined);
  const [valueState, setValue] = React$1.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== 'production') {
    React$1.useEffect(() => {
      if (isControlled !== (controlled !== undefined)) {
        console.error([`MUI: A component is changing the ${isControlled ? '' : 'un'}controlled ${state} state of ${name} to be ${isControlled ? 'un' : ''}controlled.`, 'Elements should not switch from uncontrolled to controlled (or vice versa).', `Decide between using a controlled or uncontrolled ${name} ` + 'element for the lifetime of the component.', "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [state, name, controlled]);
    const {
      current: defaultValue
    } = React$1.useRef(defaultProp);
    React$1.useEffect(() => {
      if (!isControlled && !Object.is(defaultValue, defaultProp)) {
        console.error([`MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. ` + `To suppress this warning opt to use a controlled ${name}.`].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }
  const setValueIfUncontrolled = React$1.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */

function useEventCallback(fn) {
  const ref = React$1.useRef(fn);
  useEnhancedEffect$1(() => {
    ref.current = fn;
  });
  return React$1.useRef((...args) =>
  // @ts-expect-error hide `this`
  (0, ref.current)(...args)).current;
}

function useForkRef(...refs) {
  /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return React$1.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return instance => {
      refs.forEach(ref => {
        setRef(ref, instance);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

const UNINITIALIZED = {};

/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */
function useLazyRef(init, initArg) {
  const ref = React$1.useRef(UNINITIALIZED);
  if (ref.current === UNINITIALIZED) {
    ref.current = init(initArg);
  }
  return ref;
}

const EMPTY = [];

/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */
function useOnMount(fn) {
  /* eslint-disable react-hooks/exhaustive-deps */
  React$1.useEffect(fn, EMPTY);
  /* eslint-enable react-hooks/exhaustive-deps */
}

class Timeout {
  constructor() {
    this.currentId = null;
    this.clear = () => {
      if (this.currentId !== null) {
        clearTimeout(this.currentId);
        this.currentId = null;
      }
    };
    this.disposeEffect = () => {
      return this.clear;
    };
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(delay, fn) {
    this.clear();
    this.currentId = setTimeout(() => {
      this.currentId = null;
      fn();
    }, delay);
  }
}
function useTimeout() {
  const timeout = useLazyRef(Timeout.create).current;
  useOnMount(timeout.disposeEffect);
  return timeout;
}

let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
const hadFocusVisibleRecentlyTimeout = new Timeout();
const inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};

/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */
function focusTriggersKeyboardModality(node) {
  const {
    type,
    tagName
  } = node;
  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }
  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }
  if (node.isContentEditable) {
    return true;
  }
  return false;
}

/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}

/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}
function isFocusVisible(event) {
  const {
    target
  } = event;
  try {
    return target.matches(':focus-visible');
  } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  }

  // No need for validFocusTarget check. The user does that by attaching it to
  // focusable events only.
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
  const ref = React$1.useCallback(node => {
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  const isFocusVisibleRef = React$1.useRef(false);

  /**
   * Should be called if a blur event is fired
   */
  function handleBlurVisible() {
    // checking against potential state variable does not suffice if we focus and blur synchronously.
    // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
    // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
    // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
    // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
    if (isFocusVisibleRef.current) {
      // To detect a tab/window switch, we look for a blur event followed
      // rapidly by a visibility change.
      // If we don't see a visibility change within 100ms, it's probably a
      // regular focus change.
      hadFocusVisibleRecently = true;
      hadFocusVisibleRecentlyTimeout.start(100, () => {
        hadFocusVisibleRecently = false;
      });
      isFocusVisibleRef.current = false;
      return true;
    }
    return false;
  }

  /**
   * Should be called if a blur event is fired
   */
  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }
    return false;
  }
  return {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref
  };
}

// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function getScrollbarSize(doc) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
  const documentWidth = doc.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}

const usePreviousProps = value => {
  const ref = React$1.useRef({});
  React$1.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
var usePreviousProps$1 = usePreviousProps;

function getTypeByValue(value) {
  const valueType = typeof value;
  switch (valueType) {
    case 'number':
      if (Number.isNaN(value)) {
        return 'NaN';
      }
      if (!Number.isFinite(value)) {
        return 'Infinity';
      }
      if (value !== Math.floor(value)) {
        return 'float';
      }
      return 'number';
    case 'object':
      if (value === null) {
        return 'null';
      }
      return value.constructor.name;
    default:
      return valueType;
  }
}

// IE 11 support
function ponyfillIsInteger(x) {
  // eslint-disable-next-line no-restricted-globals
  return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
}
const isInteger = Number.isInteger || ponyfillIsInteger;
function requiredInteger(props, propName, componentName, location) {
  const propValue = props[propName];
  if (propValue == null || !isInteger(propValue)) {
    const propType = getTypeByValue(propValue);
    return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
  }
  return null;
}
function validator(props, propName, ...other) {
  const propValue = props[propName];
  if (propValue === undefined) {
    return null;
  }
  return requiredInteger(props, propName, ...other);
}
function validatorNoop() {
  return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
var integerPropType = process.env.NODE_ENV === 'production' ? validatorNoop : validator;

/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */
function resolveProps(defaultProps, props) {
  const output = _extends$Y({}, props);
  Object.keys(defaultProps).forEach(propName => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = _extends$Y({}, defaultProps[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        // Reduce the iteration if the slot props is empty
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        // Reduce the iteration if the default slot props is empty
        output[propName] = slotProps;
      } else {
        output[propName] = _extends$Y({}, slotProps);
        Object.keys(defaultSlotProps).forEach(slotPropName => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}

function composeClasses$1(slots, getUtilityClass, classes = undefined) {
  const output = {};
  Object.keys(slots).forEach(
  // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  slot => {
    output[slot] = slots[slot].reduce((acc, key) => {
      if (key) {
        const utilityClass = getUtilityClass(key);
        if (utilityClass !== '') {
          acc.push(utilityClass);
        }
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
      }
      return acc;
    }, []).join(' ');
  });
  return output;
}

const defaultGenerator = componentName => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
var ClassNameGenerator$1 = ClassNameGenerator;

const globalStateClasses = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  open: 'open',
  readOnly: 'readOnly',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator$1.generate(componentName)}-${slot}`;
}

function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
  const result = {};
  slots.forEach(slot => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}

function clamp$1(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
  return Math.max(min, Math.min(val, max));
}

var clamp = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: clamp$1
});

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
function isHostComponent(element) {
  return typeof element === 'string';
}

/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */

/**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */
function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === undefined || isHostComponent(elementType)) {
    return otherProps;
  }
  return _extends$Y({}, otherProps, {
    ownerState: _extends$Y({}, otherProps.ownerState, ownerState)
  });
}

function r$1(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r$1(e[t]))&&(n&&(n+=" "),n+=f);}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx$1(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r$1(e))&&(n&&(n+=" "),n+=t);return n}

/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */
function extractEventHandlers(object, excludeKeys = []) {
  if (object === undefined) {
    return {};
  }
  const result = {};
  Object.keys(object).filter(prop => prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}

/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */
function omitEventHandlers(object) {
  if (object === undefined) {
    return {};
  }
  const result = {};
  Object.keys(object).filter(prop => !(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}

/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */
function mergeSlotProps(parameters) {
  const {
    getSlotProps,
    additionalProps,
    externalSlotProps,
    externalForwardedProps,
    className
  } = parameters;
  if (!getSlotProps) {
    // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
    // so we can simply merge all the props without having to worry about extracting event handlers.
    const joinedClasses = clsx$1(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = _extends$Y({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = _extends$Y({}, additionalProps, externalForwardedProps, externalSlotProps);
    if (joinedClasses.length > 0) {
      props.className = joinedClasses;
    }
    if (Object.keys(mergedStyle).length > 0) {
      props.style = mergedStyle;
    }
    return {
      props,
      internalRef: undefined
    };
  }

  // In this case, getSlotProps is responsible for calling the external event handlers.
  // We don't need to include them in the merged props because of this.

  const eventHandlers = extractEventHandlers(_extends$Y({}, externalForwardedProps, externalSlotProps));
  const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  const internalSlotProps = getSlotProps(eventHandlers);

  // The order of classes is important here.
  // Emotion (that we use in libraries consuming Base UI) depends on this order
  // to properly override style. It requires the most important classes to be last
  // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
  const joinedClasses = clsx$1(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
  const mergedStyle = _extends$Y({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
  const props = _extends$Y({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }
  return {
    props,
    internalRef: internalSlotProps.ref
  };
}

/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */
function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === 'function') {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}

const _excluded$1p = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */
function useSlotProps(parameters) {
  var _parameters$additiona;
  const {
      elementType,
      externalSlotProps,
      ownerState,
      skipResolvingSlotProps = false
    } = parameters,
    rest = _objectWithoutPropertiesLoose$4(parameters, _excluded$1p);
  const resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
  const {
    props: mergedProps,
    internalRef
  } = mergeSlotProps(_extends$Y({}, rest, {
    externalSlotProps: resolvedComponentsProps
  }));
  const ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
  const props = appendOwnerState(elementType, _extends$Y({}, mergedProps, {
    ref
  }), ownerState);
  return props;
}

function _extends$X() {
  _extends$X = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$X.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=React__default,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	var React = React__default;

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
	var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator';
	function getIteratorFn(maybeIterable) {
	  if (maybeIterable === null || typeof maybeIterable !== 'object') {
	    return null;
	  }

	  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

	  if (typeof maybeIterator === 'function') {
	    return maybeIterator;
	  }

	  return null;
	}

	var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	function error(format) {
	  {
	    {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      printWarning('error', format, args);
	    }
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    } // eslint-disable-next-line react-internal/safe-string-coercion


	    var argsWithFormat = args.map(function (item) {
	      return String(item);
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function getWrappedName(outerType, innerType, wrapperName) {
	  var displayName = outerType.displayName;

	  if (displayName) {
	    return displayName;
	  }

	  var functionName = innerType.displayName || innerType.name || '';
	  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
	} // Keep in sync with react-reconciler/getComponentNameFromFiber


	function getContextName(type) {
	  return type.displayName || 'Context';
	} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


	function getComponentNameFromType(type) {
	  if (type == null) {
	    // Host root, text node or just invalid type.
	    return null;
	  }

	  {
	    if (typeof type.tag === 'number') {
	      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
	    }
	  }

	  if (typeof type === 'function') {
	    return type.displayName || type.name || null;
	  }

	  if (typeof type === 'string') {
	    return type;
	  }

	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'Fragment';

	    case REACT_PORTAL_TYPE:
	      return 'Portal';

	    case REACT_PROFILER_TYPE:
	      return 'Profiler';

	    case REACT_STRICT_MODE_TYPE:
	      return 'StrictMode';

	    case REACT_SUSPENSE_TYPE:
	      return 'Suspense';

	    case REACT_SUSPENSE_LIST_TYPE:
	      return 'SuspenseList';

	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_CONTEXT_TYPE:
	        var context = type;
	        return getContextName(context) + '.Consumer';

	      case REACT_PROVIDER_TYPE:
	        var provider = type;
	        return getContextName(provider._context) + '.Provider';

	      case REACT_FORWARD_REF_TYPE:
	        return getWrappedName(type, type.render, 'ForwardRef');

	      case REACT_MEMO_TYPE:
	        var outerName = type.displayName || null;

	        if (outerName !== null) {
	          return outerName;
	        }

	        return getComponentNameFromType(type.type) || 'Memo';

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            return getComponentNameFromType(init(payload));
	          } catch (x) {
	            return null;
	          }
	        }

	      // eslint-disable-next-line no-fallthrough
	    }
	  }

	  return null;
	}

	var assign = Object.assign;

	// Helpers to patch console.logs to avoid logging during side-effect free
	// replaying on render function. This currently only patches the object
	// lazily which won't cover if the log function was extracted eagerly.
	// We could also eagerly patch the method.
	var disabledDepth = 0;
	var prevLog;
	var prevInfo;
	var prevWarn;
	var prevError;
	var prevGroup;
	var prevGroupCollapsed;
	var prevGroupEnd;

	function disabledLog() {}

	disabledLog.__reactDisabledLog = true;
	function disableLogs() {
	  {
	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      prevLog = console.log;
	      prevInfo = console.info;
	      prevWarn = console.warn;
	      prevError = console.error;
	      prevGroup = console.group;
	      prevGroupCollapsed = console.groupCollapsed;
	      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	      var props = {
	        configurable: true,
	        enumerable: true,
	        value: disabledLog,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        info: props,
	        log: props,
	        warn: props,
	        error: props,
	        group: props,
	        groupCollapsed: props,
	        groupEnd: props
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    disabledDepth++;
	  }
	}
	function reenableLogs() {
	  {
	    disabledDepth--;

	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      var props = {
	        configurable: true,
	        enumerable: true,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        log: assign({}, props, {
	          value: prevLog
	        }),
	        info: assign({}, props, {
	          value: prevInfo
	        }),
	        warn: assign({}, props, {
	          value: prevWarn
	        }),
	        error: assign({}, props, {
	          value: prevError
	        }),
	        group: assign({}, props, {
	          value: prevGroup
	        }),
	        groupCollapsed: assign({}, props, {
	          value: prevGroupCollapsed
	        }),
	        groupEnd: assign({}, props, {
	          value: prevGroupEnd
	        })
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    if (disabledDepth < 0) {
	      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	    }
	  }
	}

	var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	var prefix;
	function describeBuiltInComponentFrame(name, source, ownerFn) {
	  {
	    if (prefix === undefined) {
	      // Extract the VM specific prefix used by each line.
	      try {
	        throw Error();
	      } catch (x) {
	        var match = x.stack.trim().match(/\n( *(at )?)/);
	        prefix = match && match[1] || '';
	      }
	    } // We use the prefix to ensure our stacks line up with native stack frames.


	    return '\n' + prefix + name;
	  }
	}
	var reentry = false;
	var componentFrameCache;

	{
	  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	  componentFrameCache = new PossiblyWeakMap();
	}

	function describeNativeComponentFrame(fn, construct) {
	  // If something asked for a stack inside a fake render, it should get ignored.
	  if ( !fn || reentry) {
	    return '';
	  }

	  {
	    var frame = componentFrameCache.get(fn);

	    if (frame !== undefined) {
	      return frame;
	    }
	  }

	  var control;
	  reentry = true;
	  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	  Error.prepareStackTrace = undefined;
	  var previousDispatcher;

	  {
	    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	    // for warnings.

	    ReactCurrentDispatcher.current = null;
	    disableLogs();
	  }

	  try {
	    // This should throw.
	    if (construct) {
	      // Something should be setting the props in the constructor.
	      var Fake = function () {
	        throw Error();
	      }; // $FlowFixMe


	      Object.defineProperty(Fake.prototype, 'props', {
	        set: function () {
	          // We use a throwing setter instead of frozen or non-writable props
	          // because that won't throw in a non-strict mode function.
	          throw Error();
	        }
	      });

	      if (typeof Reflect === 'object' && Reflect.construct) {
	        // We construct a different control for this case to include any extra
	        // frames added by the construct call.
	        try {
	          Reflect.construct(Fake, []);
	        } catch (x) {
	          control = x;
	        }

	        Reflect.construct(fn, [], Fake);
	      } else {
	        try {
	          Fake.call();
	        } catch (x) {
	          control = x;
	        }

	        fn.call(Fake.prototype);
	      }
	    } else {
	      try {
	        throw Error();
	      } catch (x) {
	        control = x;
	      }

	      fn();
	    }
	  } catch (sample) {
	    // This is inlined manually because closure doesn't do it for us.
	    if (sample && control && typeof sample.stack === 'string') {
	      // This extracts the first frame from the sample that isn't also in the control.
	      // Skipping one frame that we assume is the frame that calls the two.
	      var sampleLines = sample.stack.split('\n');
	      var controlLines = control.stack.split('\n');
	      var s = sampleLines.length - 1;
	      var c = controlLines.length - 1;

	      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	        // We expect at least one stack frame to be shared.
	        // Typically this will be the root most one. However, stack frames may be
	        // cut off due to maximum stack limits. In this case, one maybe cut off
	        // earlier than the other. We assume that the sample is longer or the same
	        // and there for cut off earlier. So we should find the root most frame in
	        // the sample somewhere in the control.
	        c--;
	      }

	      for (; s >= 1 && c >= 0; s--, c--) {
	        // Next we find the first one that isn't the same which should be the
	        // frame that called our sample function and the control.
	        if (sampleLines[s] !== controlLines[c]) {
	          // In V8, the first line is describing the message but other VMs don't.
	          // If we're about to return the first line, and the control is also on the same
	          // line, that's a pretty good indicator that our sample threw at same line as
	          // the control. I.e. before we entered the sample frame. So we ignore this result.
	          // This can happen if you passed a class to function component, or non-function.
	          if (s !== 1 || c !== 1) {
	            do {
	              s--;
	              c--; // We may still have similar intermediate frames from the construct call.
	              // The next one that isn't the same should be our match though.

	              if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
	                // but we have a user-provided "displayName"
	                // splice it in to make the stack more readable.


	                if (fn.displayName && _frame.includes('<anonymous>')) {
	                  _frame = _frame.replace('<anonymous>', fn.displayName);
	                }

	                {
	                  if (typeof fn === 'function') {
	                    componentFrameCache.set(fn, _frame);
	                  }
	                } // Return the line we found.


	                return _frame;
	              }
	            } while (s >= 1 && c >= 0);
	          }

	          break;
	        }
	      }
	    }
	  } finally {
	    reentry = false;

	    {
	      ReactCurrentDispatcher.current = previousDispatcher;
	      reenableLogs();
	    }

	    Error.prepareStackTrace = previousPrepareStackTrace;
	  } // Fallback to just using the name if we couldn't make it throw.


	  var name = fn ? fn.displayName || fn.name : '';
	  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

	  {
	    if (typeof fn === 'function') {
	      componentFrameCache.set(fn, syntheticFrame);
	    }
	  }

	  return syntheticFrame;
	}
	function describeFunctionComponentFrame(fn, source, ownerFn) {
	  {
	    return describeNativeComponentFrame(fn, false);
	  }
	}

	function shouldConstruct(Component) {
	  var prototype = Component.prototype;
	  return !!(prototype && prototype.isReactComponent);
	}

	function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

	  if (type == null) {
	    return '';
	  }

	  if (typeof type === 'function') {
	    {
	      return describeNativeComponentFrame(type, shouldConstruct(type));
	    }
	  }

	  if (typeof type === 'string') {
	    return describeBuiltInComponentFrame(type);
	  }

	  switch (type) {
	    case REACT_SUSPENSE_TYPE:
	      return describeBuiltInComponentFrame('Suspense');

	    case REACT_SUSPENSE_LIST_TYPE:
	      return describeBuiltInComponentFrame('SuspenseList');
	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_FORWARD_REF_TYPE:
	        return describeFunctionComponentFrame(type.render);

	      case REACT_MEMO_TYPE:
	        // Memo may contain any component type so we recursively resolve it.
	        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            // Lazy may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	          } catch (x) {}
	        }
	    }
	  }

	  return '';
	}

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	var loggedTypeFailures = {};
	var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame.setExtraStackFrame(null);
	    }
	  }
	}

	function checkPropTypes(typeSpecs, values, location, componentName, element) {
	  {
	    // $FlowFixMe This is okay but Flow doesn't know it.
	    var has = Function.call.bind(hasOwnProperty);

	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.

	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            // eslint-disable-next-line react-internal/prod-error-codes
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }

	          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error$1 = ex;
	        }

	        if (error$1 && !(error$1 instanceof Error)) {
	          setCurrentlyValidatingElement(element);

	          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

	          setCurrentlyValidatingElement(null);
	        }

	        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error$1.message] = true;
	          setCurrentlyValidatingElement(element);

	          error('Failed %s type: %s', location, error$1.message);

	          setCurrentlyValidatingElement(null);
	        }
	      }
	    }
	  }
	}

	var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

	function isArray(a) {
	  return isArrayImpl(a);
	}

	/*
	 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
	 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
	 *
	 * The functions in this module will throw an easier-to-understand,
	 * easier-to-debug exception with a clear errors message message explaining the
	 * problem. (Instead of a confusing exception thrown inside the implementation
	 * of the `value` object).
	 */
	// $FlowFixMe only called in DEV, so void return is not possible.
	function typeName(value) {
	  {
	    // toStringTag is needed for namespaced types like Temporal.Instant
	    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
	    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
	    return type;
	  }
	} // $FlowFixMe only called in DEV, so void return is not possible.


	function willCoercionThrow(value) {
	  {
	    try {
	      testStringCoercion(value);
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	}

	function testStringCoercion(value) {
	  // If you ended up here by following an exception call stack, here's what's
	  // happened: you supplied an object or symbol value to React (as a prop, key,
	  // DOM attribute, CSS property, string ref, etc.) and when React tried to
	  // coerce it to a string using `'' + value`, an exception was thrown.
	  //
	  // The most common types that will cause this exception are `Symbol` instances
	  // and Temporal objects like `Temporal.Instant`. But any object that has a
	  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
	  // exception. (Library authors do this to prevent users from using built-in
	  // numeric operators like `+` or comparison operators like `>=` because custom
	  // methods are needed to perform accurate arithmetic or comparison.)
	  //
	  // To fix the problem, coerce this object or symbol value to a string before
	  // passing it to React. The most reliable way is usually `String(value)`.
	  //
	  // To find which value is throwing, check the browser or debugger console.
	  // Before this exception was thrown, there should be `console.error` output
	  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
	  // problem and how that type was used: key, atrribute, input value prop, etc.
	  // In most cases, this console output also shows the component and its
	  // ancestor components where the exception happened.
	  //
	  // eslint-disable-next-line react-internal/safe-string-coercion
	  return '' + value;
	}
	function checkKeyStringCoercion(value) {
	  {
	    if (willCoercionThrow(value)) {
	      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

	      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	    }
	  }
	}

	var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	var specialPropKeyWarningShown;
	var specialPropRefWarningShown;
	var didWarnAboutStringRefs;

	{
	  didWarnAboutStringRefs = {};
	}

	function hasValidRef(config) {
	  {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.ref !== undefined;
	}

	function hasValidKey(config) {
	  {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.key !== undefined;
	}

	function warnIfStringRefCannotBeAutoConverted(config, self) {
	  {
	    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
	      var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

	      if (!didWarnAboutStringRefs[componentName]) {
	        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);

	        didWarnAboutStringRefs[componentName] = true;
	      }
	    }
	  }
	}

	function defineKeyPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;

	        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingKey.isReactWarning = true;
	    Object.defineProperty(props, 'key', {
	      get: warnAboutAccessingKey,
	      configurable: true
	    });
	  }
	}

	function defineRefPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;

	        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingRef.isReactWarning = true;
	    Object.defineProperty(props, 'ref', {
	      get: warnAboutAccessingRef,
	      configurable: true
	    });
	  }
	}
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, instanceof check
	 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} props
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} owner
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @internal
	 */


	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allows us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };

	  {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.

	    Object.defineProperty(element._store, 'validated', {
	      configurable: false,
	      enumerable: false,
	      writable: true,
	      value: false
	    }); // self and source are DEV only properties.

	    Object.defineProperty(element, '_self', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: self
	    }); // Two elements created in two different places should be considered
	    // equal for testing purposes and therefore we hide it from enumeration.

	    Object.defineProperty(element, '_source', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: source
	    });

	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }

	  return element;
	};
	/**
	 * https://github.com/reactjs/rfcs/pull/107
	 * @param {*} type
	 * @param {object} props
	 * @param {string} key
	 */

	function jsxDEV(type, config, maybeKey, source, self) {
	  {
	    var propName; // Reserved names are extracted

	    var props = {};
	    var key = null;
	    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
	    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
	    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
	    // but as an intermediary step, we will use jsxDEV for everything except
	    // <div {...props} key="Hi" />, because we aren't currently able to tell if
	    // key is explicitly declared to be undefined or not.

	    if (maybeKey !== undefined) {
	      {
	        checkKeyStringCoercion(maybeKey);
	      }

	      key = '' + maybeKey;
	    }

	    if (hasValidKey(config)) {
	      {
	        checkKeyStringCoercion(config.key);
	      }

	      key = '' + config.key;
	    }

	    if (hasValidRef(config)) {
	      ref = config.ref;
	      warnIfStringRefCannotBeAutoConverted(config, self);
	    } // Remaining properties are added to a new props object


	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    } // Resolve default props


	    if (type && type.defaultProps) {
	      var defaultProps = type.defaultProps;

	      for (propName in defaultProps) {
	        if (props[propName] === undefined) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    }

	    if (key || ref) {
	      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

	      if (key) {
	        defineKeyPropWarningGetter(props, displayName);
	      }

	      if (ref) {
	        defineRefPropWarningGetter(props, displayName);
	      }
	    }

	    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	  }
	}

	var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
	var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement$1(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
	    }
	  }
	}

	var propTypesMisspellWarningShown;

	{
	  propTypesMisspellWarningShown = false;
	}
	/**
	 * Verifies the object is a ReactElement.
	 * See https://reactjs.org/docs/react-api.html#isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a ReactElement.
	 * @final
	 */


	function isValidElement(object) {
	  {
	    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  }
	}

	function getDeclarationErrorAddendum() {
	  {
	    if (ReactCurrentOwner$1.current) {
	      var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

	      if (name) {
	        return '\n\nCheck the render method of `' + name + '`.';
	      }
	    }

	    return '';
	  }
	}

	function getSourceInfoErrorAddendum(source) {
	  {
	    if (source !== undefined) {
	      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
	      var lineNumber = source.lineNumber;
	      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
	    }

	    return '';
	  }
	}
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */


	var ownerHasKeyUseWarning = {};

	function getCurrentComponentErrorInfo(parentType) {
	  {
	    var info = getDeclarationErrorAddendum();

	    if (!info) {
	      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

	      if (parentName) {
	        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
	      }
	    }

	    return info;
	  }
	}
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */


	function validateExplicitKey(element, parentType) {
	  {
	    if (!element._store || element._store.validated || element.key != null) {
	      return;
	    }

	    element._store.validated = true;
	    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

	    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
	      return;
	    }

	    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
	    // property, it may be the creator of the child that's responsible for
	    // assigning it a key.

	    var childOwner = '';

	    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
	      // Give the component that originally created this child.
	      childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
	    }

	    setCurrentlyValidatingElement$1(element);

	    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

	    setCurrentlyValidatingElement$1(null);
	  }
	}
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */


	function validateChildKeys(node, parentType) {
	  {
	    if (typeof node !== 'object') {
	      return;
	    }

	    if (isArray(node)) {
	      for (var i = 0; i < node.length; i++) {
	        var child = node[i];

	        if (isValidElement(child)) {
	          validateExplicitKey(child, parentType);
	        }
	      }
	    } else if (isValidElement(node)) {
	      // This element was passed in a valid location.
	      if (node._store) {
	        node._store.validated = true;
	      }
	    } else if (node) {
	      var iteratorFn = getIteratorFn(node);

	      if (typeof iteratorFn === 'function') {
	        // Entry iterators used to provide implicit keys,
	        // but now we print a separate warning for them later.
	        if (iteratorFn !== node.entries) {
	          var iterator = iteratorFn.call(node);
	          var step;

	          while (!(step = iterator.next()).done) {
	            if (isValidElement(step.value)) {
	              validateExplicitKey(step.value, parentType);
	            }
	          }
	        }
	      }
	    }
	  }
	}
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */


	function validatePropTypes(element) {
	  {
	    var type = element.type;

	    if (type === null || type === undefined || typeof type === 'string') {
	      return;
	    }

	    var propTypes;

	    if (typeof type === 'function') {
	      propTypes = type.propTypes;
	    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
	    // Inner props are checked in the reconciler.
	    type.$$typeof === REACT_MEMO_TYPE)) {
	      propTypes = type.propTypes;
	    } else {
	      return;
	    }

	    if (propTypes) {
	      // Intentionally inside to avoid triggering lazy initializers:
	      var name = getComponentNameFromType(type);
	      checkPropTypes(propTypes, element.props, 'prop', name, element);
	    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
	      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

	      var _name = getComponentNameFromType(type);

	      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
	    }

	    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
	      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
	    }
	  }
	}
	/**
	 * Given a fragment, validate that it can only be provided with fragment props
	 * @param {ReactElement} fragment
	 */


	function validateFragmentProps(fragment) {
	  {
	    var keys = Object.keys(fragment.props);

	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];

	      if (key !== 'children' && key !== 'key') {
	        setCurrentlyValidatingElement$1(fragment);

	        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

	        setCurrentlyValidatingElement$1(null);
	        break;
	      }
	    }

	    if (fragment.ref !== null) {
	      setCurrentlyValidatingElement$1(fragment);

	      error('Invalid attribute `ref` supplied to `React.Fragment`.');

	      setCurrentlyValidatingElement$1(null);
	    }
	  }
	}

	function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
	  {
	    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.

	    if (!validType) {
	      var info = '';

	      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
	      }

	      var sourceInfo = getSourceInfoErrorAddendum(source);

	      if (sourceInfo) {
	        info += sourceInfo;
	      } else {
	        info += getDeclarationErrorAddendum();
	      }

	      var typeString;

	      if (type === null) {
	        typeString = 'null';
	      } else if (isArray(type)) {
	        typeString = 'array';
	      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
	        typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
	        info = ' Did you accidentally export a JSX literal instead of a component?';
	      } else {
	        typeString = typeof type;
	      }

	      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
	    }

	    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.

	    if (element == null) {
	      return element;
	    } // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)


	    if (validType) {
	      var children = props.children;

	      if (children !== undefined) {
	        if (isStaticChildren) {
	          if (isArray(children)) {
	            for (var i = 0; i < children.length; i++) {
	              validateChildKeys(children[i], type);
	            }

	            if (Object.freeze) {
	              Object.freeze(children);
	            }
	          } else {
	            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
	          }
	        } else {
	          validateChildKeys(children, type);
	        }
	      }
	    }

	    if (type === REACT_FRAGMENT_TYPE) {
	      validateFragmentProps(element);
	    } else {
	      validatePropTypes(element);
	    }

	    return element;
	  }
	} // These two functions exist to still get child warnings in dev
	// even with the prod transform. This means that jsxDEV is purely
	// opt-in behavior for better messages but that we won't stop
	// giving you warnings if you use production apis.

	function jsxWithValidationStatic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, true);
	  }
	}
	function jsxWithValidationDynamic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, false);
	  }
	}

	var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
	// for now we can ship identical prod functions

	var jsxs =  jsxWithValidationStatic ;

	reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
	reactJsxRuntime_development.jsx = jsx;
	reactJsxRuntime_development.jsxs = jsxs;
	  })();
	}
	return reactJsxRuntime_development;
}

var hasRequiredJsxRuntime;

function requireJsxRuntime () {
	if (hasRequiredJsxRuntime) return jsxRuntime.exports;
	hasRequiredJsxRuntime = 1;

	if (process.env.NODE_ENV === 'production') {
	  jsxRuntime.exports = requireReactJsxRuntime_production_min();
	} else {
	  jsxRuntime.exports = requireReactJsxRuntime_development();
	}
	return jsxRuntime.exports;
}

var jsxRuntimeExports = requireJsxRuntime();

const PropsContext = /*#__PURE__*/React$1.createContext(undefined);
function DefaultPropsProvider({
  value,
  children
}) {
  return /*#__PURE__*/jsxRuntimeExports.jsx(PropsContext.Provider, {
    value: value,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? DefaultPropsProvider.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object
} : void 0;
function getThemeProps$1(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name]) {
    return props;
  }
  const config = theme.components[name];
  if (config.defaultProps) {
    // compatible with v5 signature
    return resolveProps(config.defaultProps, props);
  }
  if (!config.styleOverrides && !config.variants) {
    // v6 signature, no property 'defaultProps'
    return resolveProps(config, props);
  }
  return props;
}
function useDefaultProps$1({
  props,
  name
}) {
  const ctx = React$1.useContext(PropsContext);
  return getThemeProps$1({
    props,
    name,
    theme: {
      components: ctx
    }
  });
}

process.env.NODE_ENV !== "production" ? {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object.isRequired
} : void 0;
function useDefaultProps(params) {
  return useDefaultProps$1(params);
}

var createStyled$3 = {};

var interopRequireDefault = {exports: {}};

(function (module) {
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (interopRequireDefault));

var interopRequireDefaultExports = interopRequireDefault.exports;

var _extends$W = {exports: {}};

var hasRequired_extends;

function require_extends () {
	if (hasRequired_extends) return _extends$W.exports;
	hasRequired_extends = 1;
	(function (module) {
		function _extends() {
		  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
		    for (var i = 1; i < arguments.length; i++) {
		      var source = arguments[i];
		      for (var key in source) {
		        if (Object.prototype.hasOwnProperty.call(source, key)) {
		          target[key] = source[key];
		        }
		      }
		    }
		    return target;
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
		  return _extends.apply(this, arguments);
		}
		module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (_extends$W));
	return _extends$W.exports;
}

var objectWithoutPropertiesLoose = {exports: {}};

var hasRequiredObjectWithoutPropertiesLoose;

function requireObjectWithoutPropertiesLoose () {
	if (hasRequiredObjectWithoutPropertiesLoose) return objectWithoutPropertiesLoose.exports;
	hasRequiredObjectWithoutPropertiesLoose = 1;
	(function (module) {
		function _objectWithoutPropertiesLoose(source, excluded) {
		  if (source == null) return {};
		  var target = {};
		  var sourceKeys = Object.keys(source);
		  var key, i;
		  for (i = 0; i < sourceKeys.length; i++) {
		    key = sourceKeys[i];
		    if (excluded.indexOf(key) >= 0) continue;
		    target[key] = source[key];
		  }
		  return target;
		}
		module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (objectWithoutPropertiesLoose));
	return objectWithoutPropertiesLoose.exports;
}

function _extends$V() {
  _extends$V = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$V.apply(this, arguments);
}

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize$1(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign$1 = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash$2 (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match$2 (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign$1(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash$2(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match$2(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser$5 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$5 ? undefined : weakMemoize(function () {
  return memoize$1(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser$5 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser$5) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser$5) {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs$1 = requireReactIs();
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;

var isBrowser$4 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$4 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$4 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$4 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$3 = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React$1['useInsertion' + 'Effect'] ? React$1['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$3 ? syncFallback : useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || React$1.useLayoutEffect;

var isBrowser$2 = typeof document !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */React$1.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser$2) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/React$1.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext$2 = /* #__PURE__ */React$1.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ThemeContext$2.displayName = 'EmotionThemeContext';
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';

var Insertion$2 = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser$2 && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React$1.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, React$1.useContext(ThemeContext$2));

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Insertion$2, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/React$1.createElement(WrappedComponent, newProps));
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var pkg = {
	name: "@emotion/react",
	version: "11.11.1",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"import": "./dist/emotion-react.cjs.mjs",
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": {
			types: {
				"import": "./macro.d.mts",
				"default": "./macro.d.ts"
			},
			"default": "./macro.js"
		}
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.*"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.11.0",
		"@emotion/cache": "^11.11.0",
		"@emotion/serialize": "^1.1.2",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
		"@emotion/utils": "^1.2.1",
		"@emotion/weak-memoize": "^0.3.1",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.11.0",
		"@emotion/css-prettifier": "1.1.3",
		"@emotion/server": "11.11.0",
		"@emotion/styled": "11.11.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": {
					types: {
						"import": "./macro.d.mts",
						"default": "./macro.d.ts"
					},
					"default": "./macro.js"
				}
			}
		}
	}
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && ( // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, React$1.useContext(ThemeContext$2));

  if (!isBrowser$2) {
    var _ref;

    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }

    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);

    if (shouldCache) {
      return null;
    }

    return /*#__PURE__*/React$1.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = React$1.useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (process.env.NODE_ENV !== 'production') {
  Global.displayName = 'EmotionGlobal';
}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (process.env.NODE_ENV !== 'production' && arg.styles !== undefined && arg.name !== undefined) {
              console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
            }

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge$2(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    var rules = '';

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);

      if (!isBrowser$2 && res !== undefined) {
        rules += res;
      }
    }

    if (!isBrowser$2) {
      return rules;
    }
  });

  if (!isBrowser$2 && rules.length !== 0) {
    var _ref2;

    return /*#__PURE__*/React$1.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function (serialized) {
      return serialized.name;
    }).join(' '), _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge$2(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React$1.useContext(ThemeContext$2)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Insertion$1, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

if (process.env.NODE_ENV !== 'production') {
  ClassNames.displayName = 'EmotionClassNames';
}

if (process.env.NODE_ENV !== 'production') {
  var isBrowser$1 = typeof document !== 'undefined'; // #1727, #2905 for some reason Jest and Vitest evaluate modules twice if some consuming module gets mocked

  var isTestEnv = typeof jest !== 'undefined' || typeof vi !== 'undefined';

  if (isBrowser$1 && !isTestEnv) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var globalContext = // $FlowIgnore
    typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
    : isBrowser$1 ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";

    if (globalContext[globalKey]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }

    globalContext[globalKey] = true;
  }
}

var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var isBrowser = typeof document !== 'undefined';

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React$1.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var createStyled$2 = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = withEmotionCache(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = React$1.useContext(ThemeContext$2);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/React$1.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends$V({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled$2.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

let cache;
if (typeof document === 'object') {
  cache = createCache({
    key: 'css',
    prepend: true
  });
}
function StyledEngineProvider(props) {
  const {
    injectFirst,
    children
  } = props;
  return injectFirst && cache ? /*#__PURE__*/jsxRuntimeExports.jsx(CacheProvider, {
    value: cache,
    children: children
  }) : children;
}
process.env.NODE_ENV !== "production" ? StyledEngineProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: PropTypes.bool
} : void 0;

function isEmpty$4(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles$2(props) {
  const {
    styles,
    defaultTheme = {}
  } = props;
  const globalStyles = typeof styles === 'function' ? themeInput => styles(isEmpty$4(themeInput) ? defaultTheme : themeInput) : styles;
  return /*#__PURE__*/jsxRuntimeExports.jsx(Global, {
    styles: globalStyles
  });
}
process.env.NODE_ENV !== "production" ? GlobalStyles$2.propTypes = {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
} : void 0;

/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$3(tag, options) {
  const stylesFactory = newStyled(tag, options);
  if (process.env.NODE_ENV !== 'production') {
    return (...styles) => {
      const component = typeof tag === 'string' ? `"${tag}"` : 'component';
      if (styles.length === 0) {
        console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join('\n'));
      } else if (styles.some(style => style === undefined)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }
      return stylesFactory(...styles);
    };
  }
  return stylesFactory;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const internal_processStyles = (tag, processor) => {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};

var styledEngine = /*#__PURE__*/Object.freeze({
  __proto__: null,
  GlobalStyles: GlobalStyles$2,
  StyledEngineProvider: StyledEngineProvider,
  ThemeContext: ThemeContext$2,
  css: css,
  default: styled$3,
  internal_processStyles: internal_processStyles,
  keyframes: keyframes
});

var require$$1$1 = /*@__PURE__*/getAugmentedNamespace(styledEngine);

var require$$4 = /*@__PURE__*/getAugmentedNamespace(deepmerge);

var require$$5 = /*@__PURE__*/getAugmentedNamespace(capitalize);

var require$$6 = /*@__PURE__*/getAugmentedNamespace(getDisplayName);

function _extends$U() {
  _extends$U = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$U.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

const _excluded$1o = ["values", "unit", "step"];
const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || [];
  // Sort in ascending order
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends$U({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
      // The breakpoint **start** at this value.
      // For instance with the first breakpoint xs: [xs, sm).
      values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
      },
      unit = 'px',
      step = 5
    } = breakpoints,
    other = _objectWithoutPropertiesLoose$2(breakpoints, _excluded$1o);
  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return _extends$U({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}

const shape = {
  borderRadius: 4
};
var shape$1 = shape;

const responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
var responsivePropType$1 = responsivePropType;

function merge$1(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge$1(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}

// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values$1[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values$1).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
  const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
  const mergedOutput = [emptyBreakpoints, ...styles].reduce((prev, next) => deepmerge$1(prev, next), {});
  return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}

// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  // fixed value
  if (typeof breakpointValues !== 'object') {
    return {};
  }
  const base = {};
  const breakpointsKeys = Object.keys(themeBreakpoints);
  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach((breakpoint, i) => {
      if (i < breakpointValues.length) {
        base[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach(breakpoint => {
      if (breakpointValues[breakpoint] != null) {
        base[breakpoint] = true;
      }
    });
  }
  return base;
}
function resolveBreakpointValues({
  values: breakpointValues,
  breakpoints: themeBreakpoints,
  base: customBase
}) {
  const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  const keys = Object.keys(base);
  if (keys.length === 0) {
    return breakpointValues;
  }
  let previous;
  return keys.reduce((acc, breakpoint, i) => {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (typeof breakpointValues === 'object') {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }
    return acc;
  }, {});
}

function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  // Check if CSS variables are used
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue$1(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style$2(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue$1(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue$1(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize$1(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? {
    [prop]: responsivePropType$1
  } : {};
  fn.filterProps = [prop];
  return fn;
}

function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}

const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
};

// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = memoize(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        }
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (!Number.isInteger(abs)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.` + `You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join('\n'));
        } else if (abs > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`].join('\n'));
        }
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== 'production') {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, 'It should be a number, an array or a function.'].join('\n'));
  }
  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue$1(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }
  const abs = Math.abs(propValue);
  const transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === 'number') {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue$1(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style$1(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge$1, {});
}
function margin(props) {
  return style$1(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== 'production' ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style$1(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== 'production' ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== 'production' ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};

// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.

function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  }

  // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://m2.material.io/design/layout/understanding-layout.html
  const transform = createUnarySpacing({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== 'production') {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };
  spacing.mui = true;
  return spacing;
}

function compose$1(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge$1(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? styles.reduce((acc, style) => Object.assign(acc, style.propTypes), {}) : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}

function borderTransform(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
  return style$2({
    prop,
    themeKey: 'borders',
    transform
  });
}
const border = createBorderStyle('border', borderTransform);
const borderTop = createBorderStyle('borderTop', borderTransform);
const borderRight = createBorderStyle('borderRight', borderTransform);
const borderBottom = createBorderStyle('borderBottom', borderTransform);
const borderLeft = createBorderStyle('borderLeft', borderTransform);
const borderColor = createBorderStyle('borderColor');
const borderTopColor = createBorderStyle('borderTopColor');
const borderRightColor = createBorderStyle('borderRightColor');
const borderBottomColor = createBorderStyle('borderBottomColor');
const borderLeftColor = createBorderStyle('borderLeftColor');
const outline = createBorderStyle('outline', borderTransform);
const outlineColor = createBorderStyle('outlineColor');

// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, 'shape.borderRadius', 4, 'borderRadius');
    const styleFromPropValue = propValue => ({
      borderRadius: getValue$1(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== 'production' ? {
  borderRadius: responsivePropType$1
} : {};
borderRadius.filterProps = ['borderRadius'];
compose$1(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);

// false positive
// eslint-disable-next-line react/function-component-definition
const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'gap');
    const styleFromPropValue = propValue => ({
      gap: getValue$1(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== 'production' ? {
  gap: responsivePropType$1
} : {};
gap.filterProps = ['gap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'columnGap');
    const styleFromPropValue = propValue => ({
      columnGap: getValue$1(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  columnGap: responsivePropType$1
} : {};
columnGap.filterProps = ['columnGap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'rowGap');
    const styleFromPropValue = propValue => ({
      rowGap: getValue$1(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  rowGap: responsivePropType$1
} : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = style$2({
  prop: 'gridColumn'
});
const gridRow = style$2({
  prop: 'gridRow'
});
const gridAutoFlow = style$2({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = style$2({
  prop: 'gridAutoColumns'
});
const gridAutoRows = style$2({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = style$2({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = style$2({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = style$2({
  prop: 'gridTemplateAreas'
});
const gridArea = style$2({
  prop: 'gridArea'
});
compose$1(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);

function paletteTransform(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }
  return value;
}
const color$1 = style$2({
  prop: 'color',
  themeKey: 'palette',
  transform: paletteTransform
});
const bgcolor = style$2({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const backgroundColor = style$2({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
compose$1(color$1, bgcolor, backgroundColor);

function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = style$2({
  prop: 'width',
  transform: sizingTransform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme, _props$theme2;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || values$1[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = style$2({
  prop: 'minWidth',
  transform: sizingTransform
});
const height = style$2({
  prop: 'height',
  transform: sizingTransform
});
const maxHeight = style$2({
  prop: 'maxHeight',
  transform: sizingTransform
});
const minHeight = style$2({
  prop: 'minHeight',
  transform: sizingTransform
});
style$2({
  prop: 'size',
  cssProperty: 'width',
  transform: sizingTransform
});
style$2({
  prop: 'size',
  cssProperty: 'height',
  transform: sizingTransform
});
const boxSizing = style$2({
  prop: 'boxSizing'
});
compose$1(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);

const defaultSxConfig = {
  // borders
  border: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderTop: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderRight: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderBottom: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderLeft: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderColor: {
    themeKey: 'palette'
  },
  borderTopColor: {
    themeKey: 'palette'
  },
  borderRightColor: {
    themeKey: 'palette'
  },
  borderBottomColor: {
    themeKey: 'palette'
  },
  borderLeftColor: {
    themeKey: 'palette'
  },
  outline: {
    themeKey: 'borders',
    transform: borderTransform
  },
  outlineColor: {
    themeKey: 'palette'
  },
  borderRadius: {
    themeKey: 'shape.borderRadius',
    style: borderRadius
  },
  // palette
  color: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: 'palette',
    cssProperty: 'backgroundColor',
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: value => ({
      '@media print': {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: 'zIndex'
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: 'shadows'
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: 'typography'
  },
  fontSize: {
    themeKey: 'typography'
  },
  fontStyle: {
    themeKey: 'typography'
  },
  fontWeight: {
    themeKey: 'typography'
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: 'typography'
  }
};
var defaultSxConfig$1 = defaultSxConfig;

function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style
    } = options;
    if (val == null) {
      return null;
    }

    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && val === 'inherit') {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style) {
      return style(props);
    }
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue$1(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue$1(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize$1(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }
    const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : defaultSxConfig$1;

    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (config[styleKey]) {
              css = merge$1(css, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, x => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme
                });
              } else {
                css = merge$1(css, breakpointsValues);
              }
            }
          } else {
            css = merge$1(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx;
}
const styleFunctionSx$1 = unstable_createStyleFunctionSx();
styleFunctionSx$1.filterProps = ['sx'];
var styleFunctionSx$2 = styleFunctionSx$1;

/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */
function applyStyles$2(key, styles) {
  // @ts-expect-error this is 'any' type
  const theme = this;
  if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
    // If CssVarsProvider is used as a provider,
    // returns '* :where([data-mui-color-scheme="light|dark"]) &'
    const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
    return {
      [selector]: styles
    };
  }
  if (theme.palette.mode === key) {
    return styles;
  }
  return {};
}

const _excluded$1n = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$3(options = {}, ...args) {
  const {
      breakpoints: breakpointsInput = {},
      palette: paletteInput = {},
      spacing: spacingInput,
      shape: shapeInput = {}
    } = options,
    other = _objectWithoutPropertiesLoose$2(options, _excluded$1n);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge$1({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: _extends$U({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: _extends$U({}, shape$1, shapeInput)
  }, other);
  muiTheme.applyStyles = applyStyles$2;
  muiTheme = args.reduce((acc, argument) => deepmerge$1(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = _extends$U({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$2({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}

var createTheme$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: createTheme$3,
  private_createBreakpoints: createBreakpoints,
  unstable_applyStyles: applyStyles$2
});

var require$$7 = /*@__PURE__*/getAugmentedNamespace(createTheme$2);

const _excluded$1m = ["sx"];
const splitProps = props => {
  var _props$theme$unstable, _props$theme;
  const result = {
    systemProps: {},
    otherProps: {}
  };
  const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : defaultSxConfig$1;
  Object.keys(props).forEach(prop => {
    if (config[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp(props) {
  const {
      sx: inSx
    } = props,
    other = _objectWithoutPropertiesLoose$2(props, _excluded$1m);
  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === 'function') {
    finalSx = (...args) => {
      const result = inSx(...args);
      if (!isPlainObject$1(result)) {
        return systemProps;
      }
      return _extends$U({}, systemProps, result);
    };
  } else {
    finalSx = _extends$U({}, systemProps, inSx);
  }
  return _extends$U({}, otherProps, {
    sx: finalSx
  });
}

var styleFunctionSx = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: styleFunctionSx$2,
  extendSxProp: extendSxProp,
  unstable_createStyleFunctionSx: unstable_createStyleFunctionSx,
  unstable_defaultSxConfig: defaultSxConfig$1
});

var require$$8 = /*@__PURE__*/getAugmentedNamespace(styleFunctionSx);

var _interopRequireDefault$7 = interopRequireDefaultExports;
Object.defineProperty(createStyled$3, "__esModule", {
  value: true
});
var _default = createStyled$3.default = createStyled$1;
createStyled$3.shouldForwardProp = shouldForwardProp$1;
createStyled$3.systemDefaultTheme = void 0;
var _extends2 = _interopRequireDefault$7(require_extends());
var _objectWithoutPropertiesLoose2 = _interopRequireDefault$7(requireObjectWithoutPropertiesLoose());
var _styledEngine$1 = _interopRequireWildcard$1(require$$1$1);
var _deepmerge = require$$4;
var _capitalize = _interopRequireDefault$7(require$$5);
var _getDisplayName = _interopRequireDefault$7(require$$6);
var _createTheme = _interopRequireDefault$7(require$$7);
var _styleFunctionSx = _interopRequireDefault$7(require$$8);
const _excluded$1l = ["ownerState"],
  _excluded2$9 = ["variants"],
  _excluded3$4 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
/* eslint-disable no-underscore-dangle */
function _getRequireWildcardCache$1(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function isEmpty$3(obj) {
  return Object.keys(obj).length === 0;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag$1(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}

// Update /system/styled/#api in case if this changes
function shouldForwardProp$1(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme$2 = createStyled$3.systemDefaultTheme = (0, _createTheme.default)();
const lowercaseFirstLetter$1 = string => {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme$1({
  defaultTheme,
  theme,
  themeId
}) {
  return isEmpty$3(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver$1(slot) {
  if (!slot) {
    return null;
  }
  return (props, styles) => styles[slot];
}
function processStyleArg$1(callableStyle, _ref) {
  let {
      ownerState
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded$1l);
  const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, _extends2.default)({
    ownerState
  }, props)) : callableStyle;
  if (Array.isArray(resolvedStylesArg)) {
    return resolvedStylesArg.flatMap(resolvedStyle => processStyleArg$1(resolvedStyle, (0, _extends2.default)({
      ownerState
    }, props)));
  }
  if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
    const {
        variants = []
      } = resolvedStylesArg,
      otherStyles = (0, _objectWithoutPropertiesLoose2.default)(resolvedStylesArg, _excluded2$9);
    let result = otherStyles;
    variants.forEach(variant => {
      let isMatch = true;
      if (typeof variant.props === 'function') {
        isMatch = variant.props((0, _extends2.default)({
          ownerState
        }, props, ownerState));
      } else {
        Object.keys(variant.props).forEach(key => {
          if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
            isMatch = false;
          }
        });
      }
      if (isMatch) {
        if (!Array.isArray(result)) {
          result = [result];
        }
        result.push(typeof variant.style === 'function' ? variant.style((0, _extends2.default)({
          ownerState
        }, props, ownerState)) : variant.style);
      }
    });
    return result;
  }
  return resolvedStylesArg;
}
function createStyled$1(input = {}) {
  const {
    themeId,
    defaultTheme = systemDefaultTheme$2,
    rootShouldForwardProp = shouldForwardProp$1,
    slotShouldForwardProp = shouldForwardProp$1
  } = input;
  const systemSx = props => {
    return (0, _styleFunctionSx.default)((0, _extends2.default)({}, props, {
      theme: resolveTheme$1((0, _extends2.default)({}, props, {
        defaultTheme,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    (0, _styledEngine$1.internal_processStyles)(tag, styles => styles.filter(style => !(style != null && style.__mui_systemSx)));
    const {
        name: componentName,
        slot: componentSlot,
        skipVariantsResolver: inputSkipVariantsResolver,
        skipSx: inputSkipSx,
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver$1(lowercaseFirstLetter$1(componentSlot))
      } = inputOptions,
      options = (0, _objectWithoutPropertiesLoose2.default)(inputOptions, _excluded3$4);

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver :
    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
    const skipSx = inputSkipSx || false;
    let label;
    if (process.env.NODE_ENV !== 'production') {
      if (componentName) {
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = `${componentName}-${lowercaseFirstLetter$1(componentSlot || 'Root')}`;
      }
    }
    let shouldForwardPropOption = shouldForwardProp$1;

    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    if (componentSlot === 'Root' || componentSlot === 'root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag$1(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    const defaultStyledResolver = (0, _styledEngine$1.default)(tag, (0, _extends2.default)({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const transformStyleArg = stylesArg => {
      // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, _deepmerge.isPlainObject)(stylesArg)) {
        return props => processStyleArg$1(stylesArg, (0, _extends2.default)({}, props, {
          theme: resolveTheme$1({
            theme: props.theme,
            defaultTheme,
            themeId
          })
        }));
      }
      return stylesArg;
    };
    const muiStyledResolver = (styleArg, ...expressions) => {
      let transformedStyleArg = transformStyleArg(styleArg);
      const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme$1((0, _extends2.default)({}, props, {
            defaultTheme,
            themeId
          }));
          if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
            return null;
          }
          const styleOverrides = theme.components[componentName].styleOverrides;
          const resolvedStyleOverrides = {};
          // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
          Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
            resolvedStyleOverrides[slotKey] = processStyleArg$1(slotStyle, (0, _extends2.default)({}, props, {
              theme
            }));
          });
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          var _theme$components;
          const theme = resolveTheme$1((0, _extends2.default)({}, props, {
            defaultTheme,
            themeId
          }));
          const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
          return processStyleArg$1({
            variants: themeVariants
          }, (0, _extends2.default)({}, props, {
            theme
          }));
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill('');
        // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (process.env.NODE_ENV !== 'production') {
        let displayName;
        if (componentName) {
          displayName = `${componentName}${(0, _capitalize.default)(componentSlot || '')}`;
        }
        if (displayName === undefined) {
          displayName = `Styled(${(0, _getDisplayName.default)(tag)})`;
        }
        Component.displayName = displayName;
      }
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}

function createMixins(breakpoints, mixins) {
  return _extends$X({
    toolbar: {
      minHeight: 56,
      [breakpoints.up('xs')]: {
        '@media (orientation: landscape)': {
          minHeight: 48
        }
      },
      [breakpoints.up('sm')]: {
        minHeight: 64
      }
    }
  }, mixins);
}

var colorManipulator = {};

var require$$1 = /*@__PURE__*/getAugmentedNamespace(formatMuiErrorMessage);

var require$$2 = /*@__PURE__*/getAugmentedNamespace(clamp);

var _interopRequireDefault$6 = interopRequireDefaultExports;
Object.defineProperty(colorManipulator, "__esModule", {
  value: true
});
var alpha_1 = colorManipulator.alpha = alpha$1;
colorManipulator.blend = blend;
colorManipulator.colorChannel = void 0;
var darken_1 = colorManipulator.darken = darken;
colorManipulator.decomposeColor = decomposeColor$1;
var emphasize_1 = colorManipulator.emphasize = emphasize;
var getContrastRatio_1 = colorManipulator.getContrastRatio = getContrastRatio;
colorManipulator.getLuminance = getLuminance;
colorManipulator.hexToRgb = hexToRgb$1;
colorManipulator.hslToRgb = hslToRgb;
var lighten_1 = colorManipulator.lighten = lighten;
colorManipulator.private_safeAlpha = private_safeAlpha;
colorManipulator.private_safeColorChannel = void 0;
colorManipulator.private_safeDarken = private_safeDarken;
colorManipulator.private_safeEmphasize = private_safeEmphasize;
colorManipulator.private_safeLighten = private_safeLighten;
colorManipulator.recomposeColor = recomposeColor$1;
colorManipulator.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault$6(require$$1);
var _clamp = _interopRequireDefault$6(require$$2);
/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clampWrapper$1(value, min = 0, max = 1) {
  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
    }
  }
  return (0, _clamp.default)(value, min, max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb$1(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor$1(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor$1(hexToRgb$1(color));
  }
  const marker = color.indexOf('(');
  const type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, _formatMuiErrorMessage2.default)(9, color));
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, _formatMuiErrorMessage2.default)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}

/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */
const colorChannel = color => {
  const decomposedColor = decomposeColor$1(color);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
colorManipulator.colorChannel = colorChannel;
const private_safeColorChannel = (color, warning) => {
  try {
    return colorChannel(color);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
};

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
colorManipulator.private_safeColorChannel = private_safeColorChannel;
function recomposeColor$1(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }
  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }
  return `${type}(${values})`;
}

/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }
  const {
    values
  } = decomposeColor$1(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}

/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */
function hslToRgb(color) {
  color = decomposeColor$1(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor$1({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor$1(color);
  let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor$1(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });

  // Truncate at 3 digits
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha$1(color, value) {
  color = decomposeColor$1(color);
  value = clampWrapper$1(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }
  return recomposeColor$1(color);
}
function private_safeAlpha(color, value, warning) {
  try {
    return alpha$1(color, value);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor$1(color);
  coefficient = clampWrapper$1(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor$1(color);
}
function private_safeDarken(color, coefficient, warning) {
  try {
    return darken(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor$1(color);
  coefficient = clampWrapper$1(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor$1(color);
}
function private_safeLighten(color, coefficient, warning) {
  try {
    return lighten(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
  try {
    return emphasize(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */
function blend(background, overlay, opacity, gamma = 1.0) {
  const blendChannel = (b, o) => Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
  const backgroundColor = decomposeColor$1(background);
  const overlayColor = decomposeColor$1(overlay);
  const rgb = [blendChannel(backgroundColor.values[0], overlayColor.values[0]), blendChannel(backgroundColor.values[1], overlayColor.values[1]), blendChannel(backgroundColor.values[2], overlayColor.values[2])];
  return recomposeColor$1({
    type: 'rgb',
    values: rgb
  });
}

const common = {
  black: '#000',
  white: '#fff'
};
var common$1 = common;

const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
};
var grey$1 = grey;

const purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
var purple$1 = purple;

const red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var red$1 = red;

const orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var orange$1 = orange;

const blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var blue$1 = blue;

const lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
var lightBlue$1 = lightBlue;

const green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var green$1 = green;

const _excluded$1k = ["mode", "contrastThreshold", "tonalOffset"];
const light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.6)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    default: common$1.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: common$1.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#121212',
    default: '#121212'
  },
  action: {
    active: common$1.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten_1(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken_1(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: blue$1[200],
      light: blue$1[50],
      dark: blue$1[400]
    };
  }
  return {
    main: blue$1[700],
    light: blue$1[400],
    dark: blue$1[800]
  };
}
function getDefaultSecondary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: purple$1[200],
      light: purple$1[50],
      dark: purple$1[400]
    };
  }
  return {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}
function getDefaultError(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: red$1[500],
      light: red$1[300],
      dark: red$1[700]
    };
  }
  return {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}
function getDefaultInfo(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: lightBlue$1[400],
      light: lightBlue$1[300],
      dark: lightBlue$1[700]
    };
  }
  return {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}
function getDefaultSuccess(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: green$1[400],
      light: green$1[300],
      dark: green$1[700]
    };
  }
  return {
    main: green$1[800],
    light: green$1[500],
    dark: green$1[900]
  };
}
function getDefaultWarning(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: orange$1[400],
      light: orange$1[300],
      dark: orange$1[700]
    };
  }
  return {
    main: '#ed6c02',
    // closest to orange[800] that pass 3:1.
    light: orange$1[500],
    dark: orange$1[900]
  };
}
function createPalette(palette) {
  const {
      mode = 'light',
      contrastThreshold = 3,
      tonalOffset = 0.2
    } = palette,
    other = _objectWithoutPropertiesLoose$3(palette, _excluded$1k);
  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode);

  // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
  function getContrastText(background) {
    const contrastText = getContrastRatio_1(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== 'production') {
      const contrast = getContrastRatio_1(background, contrastText);
      if (contrast < 3) {
        console.error([`MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`, 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }
    return contrastText;
  }
  const augmentColor = ({
    color,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color = _extends$X({}, color);
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    if (!color.hasOwnProperty('main')) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.` : formatMuiErrorMessage$1(11, name ? ` (${name})` : '', mainShade));
    }
    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage$1(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
    return color;
  };
  const modes = {
    dark,
    light
  };
  if (process.env.NODE_ENV !== 'production') {
    if (!modes[mode]) {
      console.error(`MUI: The palette mode \`${mode}\` is not supported.`);
    }
  }
  const paletteOutput = deepmerge$1(_extends$X({
    // A collection of common colors.
    common: _extends$X({}, common$1),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: 'primary'
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: 'secondary',
      mainShade: 'A400',
      lightShade: 'A200',
      darkShade: 'A700'
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: 'error'
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: 'warning'
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: 'info'
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: 'success'
    }),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}

const _excluded$1j = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round$3(value) {
  return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */
function createTypography(palette, typography) {
  const _ref = typeof typography === 'function' ? typography(palette) : typography,
    {
      fontFamily = defaultFontFamily,
      // The default font size of the Material Specification.
      fontSize = 14,
      // px
      fontWeightLight = 300,
      fontWeightRegular = 400,
      fontWeightMedium = 500,
      fontWeightBold = 700,
      // Tell MUI what's the font-size on the html element.
      // 16px is the default font-size used by browsers.
      htmlFontSize = 16,
      // Apply the CSS properties to all the variants.
      allVariants,
      pxToRem: pxToRem2
    } = _ref,
    other = _objectWithoutPropertiesLoose$3(_ref, _excluded$1j);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('MUI: `fontSize` is required to be a number.');
    }
    if (typeof htmlFontSize !== 'number') {
      console.error('MUI: `htmlFontSize` is required to be a number.');
    }
  }
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || (size => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => _extends$X({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round$3(letterSpacing / size)}em`
  } : {}, casing, allVariants);
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: 'inherit',
      fontWeight: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      letterSpacing: 'inherit'
    }
  };
  return deepmerge$1(_extends$X({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep
  });
}

const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(',');
}

// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$1 = shadows;

const _excluded$1i = ["duration", "easing", "delay"];
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }
  const constant = height / 36;

  // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
  const mergedEasing = _extends$X({}, easing, inputTransitions.easing);
  const mergedDuration = _extends$X({}, duration, inputTransitions.duration);
  const create = (props = ['all'], options = {}) => {
    const {
        duration: durationOption = mergedDuration.standard,
        easing: easingOption = mergedEasing.easeInOut,
        delay = 0
      } = options,
      other = _objectWithoutPropertiesLoose$3(options, _excluded$1i);
    if (process.env.NODE_ENV !== 'production') {
      const isString = value => typeof value === 'string';
      // IE11 support, replace with Number.isNaN
      // eslint-disable-next-line no-restricted-globals
      const isNumber = value => !isNaN(parseFloat(value));
      if (!isString(props) && !Array.isArray(props)) {
        console.error('MUI: Argument "props" must be a string or Array.');
      }
      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
      }
      if (!isString(easingOption)) {
        console.error('MUI: Argument "easing" must be a string.');
      }
      if (!isNumber(delay) && !isString(delay)) {
        console.error('MUI: Argument "delay" must be a number or a string.');
      }
      if (typeof options !== 'object') {
        console.error(['MUI: Secong argument of transition.create must be an object.', "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join('\n'));
      }
      if (Object.keys(other).length !== 0) {
        console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(',')}].`);
      }
    }
    return (Array.isArray(props) ? props : [props]).map(animatedProp => `${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
  };
  return _extends$X({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;

const _excluded$1h = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme$1(options = {}, ...args) {
  const {
      mixins: mixinsInput = {},
      palette: paletteInput = {},
      transitions: transitionsInput = {},
      typography: typographyInput = {}
    } = options,
    other = _objectWithoutPropertiesLoose$3(options, _excluded$1h);
  if (options.vars) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`vars\` is a private field used for CSS variables support.
Please use another name.` : formatMuiErrorMessage$1(18));
  }
  const palette = createPalette(paletteInput);
  const systemTheme = createTheme$3(options);
  let muiTheme = deepmerge$1(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$1.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: _extends$X({}, zIndex$1)
  });
  muiTheme = deepmerge$1(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => deepmerge$1(acc, argument), muiTheme);
  if (process.env.NODE_ENV !== 'production') {
    // TODO v6: Refactor to use globalStateClassesMapping from @mui/utils once `readOnly` state class is used in Rating component.
    const stateClasses = ['active', 'checked', 'completed', 'disabled', 'error', 'expanded', 'focused', 'focusVisible', 'required', 'selected'];
    const traverse = (node, component) => {
      let key;

      // eslint-disable-next-line guard-for-in, no-restricted-syntax
      for (key in node) {
        const child = node[key];
        if (stateClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            const stateClass = generateUtilityClass('', key);
            console.error([`MUI: The \`${component}\` component increases ` + `the CSS specificity of the \`${key}\` internal state.`, 'You can not override it like this: ', JSON.stringify(node, null, 2), '', `Instead, you need to use the '&.${stateClass}' syntax:`, JSON.stringify({
              root: {
                [`&.${stateClass}`]: child
              }
            }, null, 2), '', 'https://mui.com/r/state-classes-guide'].join('\n'));
          }
          // Remove the style to prevent global conflicts.
          node[key] = {};
        }
      }
    };
    Object.keys(muiTheme.components).forEach(component => {
      const styleOverrides = muiTheme.components[component].styleOverrides;
      if (styleOverrides && component.indexOf('Mui') === 0) {
        traverse(styleOverrides, component);
      }
    });
  }
  muiTheme.unstable_sxConfig = _extends$X({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$2({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}

const defaultTheme$2 = createTheme$1();
var defaultTheme$3 = defaultTheme$2;

var THEME_ID = '$$material';

// copied from @mui/system/createStyled
function slotShouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}

const rootShouldForwardProp$1 = prop => slotShouldForwardProp(prop) && prop !== 'classes';
var rootShouldForwardProp$2 = rootShouldForwardProp$1;

const styled$1 = _default({
  themeId: THEME_ID,
  defaultTheme: defaultTheme$3,
  rootShouldForwardProp: rootShouldForwardProp$2
});
var styled$2 = styled$1;

function getSvgIconUtilityClass(slot) {
  return generateUtilityClass('MuiSvgIcon', slot);
}
generateUtilityClasses('MuiSvgIcon', ['root', 'colorPrimary', 'colorSecondary', 'colorAction', 'colorError', 'colorDisabled', 'fontSizeInherit', 'fontSizeSmall', 'fontSizeMedium', 'fontSizeLarge']);

const _excluded$1g = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"];
const useUtilityClasses$11 = ownerState => {
  const {
    color,
    fontSize,
    classes
  } = ownerState;
  const slots = {
    root: ['root', color !== 'inherit' && `color${capitalize$1(color)}`, `fontSize${capitalize$1(fontSize)}`]
  };
  return composeClasses$1(slots, getSvgIconUtilityClass, classes);
};
const SvgIconRoot = styled$2('svg', {
  name: 'MuiSvgIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'inherit' && styles[`color${capitalize$1(ownerState.color)}`], styles[`fontSize${capitalize$1(ownerState.fontSize)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
  return {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
    flexShrink: 0,
    transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
      duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
    }),
    fontSize: {
      inherit: 'inherit',
      small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
      medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
      large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
    }[ownerState.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : {
      action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
      disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
      inherit: undefined
    }[ownerState.color]
  };
});
const SvgIcon = /*#__PURE__*/React$1.forwardRef(function SvgIcon(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiSvgIcon'
  });
  const {
      children,
      className,
      color = 'inherit',
      component = 'svg',
      fontSize = 'medium',
      htmlColor,
      inheritViewBox = false,
      titleAccess,
      viewBox = '0 0 24 24'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$1g);
  const hasSvgAsChild = /*#__PURE__*/React$1.isValidElement(children) && children.type === 'svg';
  const ownerState = _extends$X({}, props, {
    color,
    component,
    fontSize,
    instanceFontSize: inProps.fontSize,
    inheritViewBox,
    viewBox,
    hasSvgAsChild
  });
  const more = {};
  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }
  const classes = useUtilityClasses$11(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsxs(SvgIconRoot, _extends$X({
    as: component,
    className: clsx(classes.root, className),
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, more, other, hasSvgAsChild && children.props, {
    ownerState: ownerState,
    children: [hasSvgAsChild ? children.props.children : children, titleAccess ? /*#__PURE__*/jsxRuntimeExports.jsx("title", {
      children: titleAccess
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'action', 'disabled', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'large', 'medium', 'small']), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = SvgIcon;

function createSvgIcon(path, displayName) {
  function Component(props, ref) {
    return /*#__PURE__*/jsxRuntimeExports.jsx(SvgIcon$1, _extends$X({
      "data-testid": `${displayName}Icon`,
      ref: ref
    }, props, {
      children: path
    }));
  }
  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = `${displayName}Icon`;
  }
  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/React$1.memo( /*#__PURE__*/React$1.forwardRef(Component));
}

// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const unstable_ClassNameGenerator = {
  configure: generator => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(['MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.', '', "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", '', 'The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401', '', 'The updated documentation: https://mui.com/guides/classname-generator/'].join('\n'));
    }
    ClassNameGenerator$1.configure(generator);
  }
};

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  capitalize: capitalize$1,
  createChainedFunction: createChainedFunction,
  createSvgIcon: createSvgIcon,
  debounce: debounce$1,
  deprecatedPropType: deprecatedPropType,
  isMuiElement: isMuiElement,
  ownerDocument: ownerDocument,
  ownerWindow: ownerWindow,
  requirePropFactory: requirePropFactory,
  setRef: setRef,
  unstable_ClassNameGenerator: unstable_ClassNameGenerator,
  unstable_useEnhancedEffect: useEnhancedEffect$1,
  unstable_useId: useId,
  unsupportedProp: unsupportedProp,
  useControlled: useControlled,
  useEventCallback: useEventCallback,
  useForkRef: useForkRef,
  useIsFocusVisible: useIsFocusVisible
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(utils);

var hasRequiredCreateSvgIcon;

function requireCreateSvgIcon () {
	if (hasRequiredCreateSvgIcon) return createSvgIcon$1;
	hasRequiredCreateSvgIcon = 1;
	(function (exports) {
		'use client';

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		Object.defineProperty(exports, "default", {
		  enumerable: true,
		  get: function () {
		    return _utils.createSvgIcon;
		  }
		});
		var _utils = require$$0; 
	} (createSvgIcon$1));
	return createSvgIcon$1;
}

var _interopRequireDefault$5 = interopRequireDefaultExports$1;
Object.defineProperty(TripOriginOutlined, "__esModule", {
  value: true
});
var default_1$6 = TripOriginOutlined.default = void 0;
var _createSvgIcon$5 = _interopRequireDefault$5(requireCreateSvgIcon());
var _jsxRuntime$5 = requireJsxRuntime();
default_1$6 = TripOriginOutlined.default = (0, _createSvgIcon$5.default)( /*#__PURE__*/(0, _jsxRuntime$5.jsx)("path", {
  d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12m10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6"
}), 'TripOriginOutlined');

function isObjectEmpty$1(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$4(defaultTheme = null) {
  const contextTheme = React$1.useContext(ThemeContext$2);
  return !contextTheme || isObjectEmpty$1(contextTheme) ? defaultTheme : contextTheme;
}

const systemDefaultTheme$1 = createTheme$3();
function useTheme$3(defaultTheme = systemDefaultTheme$1) {
  return useTheme$4(defaultTheme);
}

function GlobalStyles$1({
  styles,
  themeId,
  defaultTheme = {}
}) {
  const upperTheme = useTheme$3(defaultTheme);
  const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
  return /*#__PURE__*/jsxRuntimeExports.jsx(GlobalStyles$2, {
    styles: globalStyles
  });
}
process.env.NODE_ENV !== "production" ? GlobalStyles$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: PropTypes.object,
  /**
   * @ignore
   */
  styles: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool]),
  /**
   * @ignore
   */
  themeId: PropTypes.string
} : void 0;

const _excluded$1f = ["className", "component"];
function createBox(options = {}) {
  const {
    themeId,
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName
  } = options;
  const BoxRoot = styled$3('div', {
    shouldForwardProp: prop => prop !== 'theme' && prop !== 'sx' && prop !== 'as'
  })(styleFunctionSx$2);
  const Box = /*#__PURE__*/React$1.forwardRef(function Box(inProps, ref) {
    const theme = useTheme$3(defaultTheme);
    const _extendSxProp = extendSxProp(inProps),
      {
        className,
        component = 'div'
      } = _extendSxProp,
      other = _objectWithoutPropertiesLoose$2(_extendSxProp, _excluded$1f);
    return /*#__PURE__*/jsxRuntimeExports.jsx(BoxRoot, _extends$U({
      as: component,
      ref: ref,
      className: clsx(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme
    }, other));
  });
  return Box;
}

const _excluded$1e = ["ownerState"],
  _excluded2$8 = ["variants"],
  _excluded3$3 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function isEmpty$2(obj) {
  return Object.keys(obj).length === 0;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}

// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = createTheme$3();
const lowercaseFirstLetter = string => {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({
  defaultTheme,
  theme,
  themeId
}) {
  return isEmpty$2(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (props, styles) => styles[slot];
}
function processStyleArg(callableStyle, _ref) {
  let {
      ownerState
    } = _ref,
    props = _objectWithoutPropertiesLoose$2(_ref, _excluded$1e);
  const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle(_extends$U({
    ownerState
  }, props)) : callableStyle;
  if (Array.isArray(resolvedStylesArg)) {
    return resolvedStylesArg.flatMap(resolvedStyle => processStyleArg(resolvedStyle, _extends$U({
      ownerState
    }, props)));
  }
  if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
    const {
        variants = []
      } = resolvedStylesArg,
      otherStyles = _objectWithoutPropertiesLoose$2(resolvedStylesArg, _excluded2$8);
    let result = otherStyles;
    variants.forEach(variant => {
      let isMatch = true;
      if (typeof variant.props === 'function') {
        isMatch = variant.props(_extends$U({
          ownerState
        }, props, ownerState));
      } else {
        Object.keys(variant.props).forEach(key => {
          if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
            isMatch = false;
          }
        });
      }
      if (isMatch) {
        if (!Array.isArray(result)) {
          result = [result];
        }
        result.push(typeof variant.style === 'function' ? variant.style(_extends$U({
          ownerState
        }, props, ownerState)) : variant.style);
      }
    });
    return result;
  }
  return resolvedStylesArg;
}
function createStyled(input = {}) {
  const {
    themeId,
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  const systemSx = props => {
    return styleFunctionSx$2(_extends$U({}, props, {
      theme: resolveTheme(_extends$U({}, props, {
        defaultTheme,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    internal_processStyles(tag, styles => styles.filter(style => !(style != null && style.__mui_systemSx)));
    const {
        name: componentName,
        slot: componentSlot,
        skipVariantsResolver: inputSkipVariantsResolver,
        skipSx: inputSkipSx,
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot))
      } = inputOptions,
      options = _objectWithoutPropertiesLoose$2(inputOptions, _excluded3$3);

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver :
    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
    const skipSx = inputSkipSx || false;
    let label;
    if (process.env.NODE_ENV !== 'production') {
      if (componentName) {
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = `${componentName}-${lowercaseFirstLetter(componentSlot || 'Root')}`;
      }
    }
    let shouldForwardPropOption = shouldForwardProp;

    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    if (componentSlot === 'Root' || componentSlot === 'root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    const defaultStyledResolver = styled$3(tag, _extends$U({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const transformStyleArg = stylesArg => {
      // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || isPlainObject$1(stylesArg)) {
        return props => processStyleArg(stylesArg, _extends$U({}, props, {
          theme: resolveTheme({
            theme: props.theme,
            defaultTheme,
            themeId
          })
        }));
      }
      return stylesArg;
    };
    const muiStyledResolver = (styleArg, ...expressions) => {
      let transformedStyleArg = transformStyleArg(styleArg);
      const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme(_extends$U({}, props, {
            defaultTheme,
            themeId
          }));
          if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
            return null;
          }
          const styleOverrides = theme.components[componentName].styleOverrides;
          const resolvedStyleOverrides = {};
          // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
          Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
            resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, _extends$U({}, props, {
              theme
            }));
          });
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          var _theme$components;
          const theme = resolveTheme(_extends$U({}, props, {
            defaultTheme,
            themeId
          }));
          const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
          return processStyleArg({
            variants: themeVariants
          }, _extends$U({}, props, {
            theme
          }));
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill('');
        // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (process.env.NODE_ENV !== 'production') {
        let displayName;
        if (componentName) {
          displayName = `${componentName}${capitalize$1(componentSlot || '')}`;
        }
        if (displayName === undefined) {
          displayName = `Styled(${getDisplayName$1(tag)})`;
        }
        Component.displayName = displayName;
      }
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}

const styled = createStyled();
var systemStyled = styled;

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return resolveProps(theme.components[name].defaultProps, props);
}

function useThemeProps({
  props,
  name,
  defaultTheme,
  themeId
}) {
  let theme = useTheme$3(defaultTheme);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  const mergedProps = getThemeProps({
    theme,
    name,
    props
  });
  return mergedProps;
}

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clampWrapper(value, min = 0, max = 1) {
  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
    }
  }
  return clamp$1(value, min, max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  const marker = color.indexOf('(');
  const type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage$1(9, color));
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage$1(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }
  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }
  return `${type}(${values})`;
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha(color, value) {
  color = decomposeColor(color);
  value = clampWrapper(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }
  return recomposeColor(color);
}

function _extends$T() {
  _extends$T = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$T.apply(this, arguments);
}

const ThemeContext = /*#__PURE__*/React$1.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}
var ThemeContext$1 = ThemeContext;

function useTheme$2() {
  const theme = React$1.useContext(ThemeContext$1);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$1.useDebugValue(theme);
  }
  return theme;
}

const hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    const mergedTheme = localTheme(outerTheme);
    if (process.env.NODE_ENV !== 'production') {
      if (!mergedTheme) {
        console.error(['MUI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }
    return mergedTheme;
  }
  return _extends$T({}, outerTheme, localTheme);
}

/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
function ThemeProvider$2(props) {
  const {
    children,
    theme: localTheme
  } = props;
  const outerTheme = useTheme$2();
  if (process.env.NODE_ENV !== 'production') {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['MUI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }
  const theme = React$1.useMemo(() => {
    const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
    if (output != null) {
      output[nested] = outerTheme !== null;
    }
    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/jsxRuntimeExports.jsx(ThemeContext$1.Provider, {
    value: theme,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? ThemeProvider$2.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider$2.propTypes = exactProp(ThemeProvider$2.propTypes) : void 0;
}

const _excluded$1d = ["value"];
const RtlContext = /*#__PURE__*/React$1.createContext();
function RtlProvider(_ref) {
  let {
      value
    } = _ref,
    props = _objectWithoutPropertiesLoose$2(_ref, _excluded$1d);
  return /*#__PURE__*/jsxRuntimeExports.jsx(RtlContext.Provider, _extends$U({
    value: value != null ? value : true
  }, props));
}
process.env.NODE_ENV !== "production" ? RtlProvider.propTypes = {
  children: PropTypes.node,
  value: PropTypes.bool
} : void 0;
const useRtl = () => {
  const value = React$1.useContext(RtlContext);
  return value != null ? value : false;
};

const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
  return React$1.useMemo(() => {
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    if (typeof localTheme === 'function') {
      const mergedTheme = localTheme(resolvedTheme);
      const result = themeId ? _extends$U({}, upperTheme, {
        [themeId]: mergedTheme
      }) : mergedTheme;
      // must return a function for the private theme to NOT merge with the upper theme.
      // see the test case "use provided theme from a callback" in ThemeProvider.test.js
      if (isPrivate) {
        return () => result;
      }
      return result;
    }
    return themeId ? _extends$U({}, upperTheme, {
      [themeId]: localTheme
    }) : _extends$U({}, upperTheme, localTheme);
  }, [themeId, upperTheme, localTheme, isPrivate]);
}

/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */
function ThemeProvider$1(props) {
  const {
    children,
    theme: localTheme,
    themeId
  } = props;
  const upperTheme = useTheme$4(EMPTY_THEME);
  const upperPrivateTheme = useTheme$2() || EMPTY_THEME;
  if (process.env.NODE_ENV !== 'production') {
    if (upperTheme === null && typeof localTheme === 'function' || themeId && upperTheme && !upperTheme[themeId] && typeof localTheme === 'function') {
      console.error(['MUI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }
  const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
  const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
  const rtlValue = engineTheme.direction === 'rtl';
  return /*#__PURE__*/jsxRuntimeExports.jsx(ThemeProvider$2, {
    theme: privateTheme,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(ThemeContext$2.Provider, {
      value: engineTheme,
      children: /*#__PURE__*/jsxRuntimeExports.jsx(RtlProvider, {
        value: rtlValue,
        children: /*#__PURE__*/jsxRuntimeExports.jsx(DefaultPropsProvider, {
          value: engineTheme == null ? void 0 : engineTheme.components,
          children: children
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" ? ThemeProvider$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: PropTypes.string
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider$1.propTypes = exactProp(ThemeProvider$1.propTypes) : void 0;
}

const _excluded$1c = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"];
const defaultTheme$1 = createTheme$3();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = systemStyled('div', {
  name: 'MuiStack',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
});
function useThemePropsDefault(props) {
  return useThemeProps({
    props,
    name: 'MuiStack',
    defaultTheme: defaultTheme$1
  });
}

/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */
function joinChildren(children, separator) {
  const childrenArray = React$1.Children.toArray(children).filter(Boolean);
  return childrenArray.reduce((output, child, index) => {
    output.push(child);
    if (index < childrenArray.length - 1) {
      output.push( /*#__PURE__*/React$1.cloneElement(separator, {
        key: `separator-${index}`
      }));
    }
    return output;
  }, []);
}
const getSideFromDirection = direction => {
  return {
    row: 'Left',
    'row-reverse': 'Right',
    column: 'Top',
    'column-reverse': 'Bottom'
  }[direction];
};
const style = ({
  ownerState,
  theme
}) => {
  let styles = _extends$U({
    display: 'flex',
    flexDirection: 'column'
  }, handleBreakpoints({
    theme
  }, resolveBreakpointValues({
    values: ownerState.direction,
    breakpoints: theme.breakpoints.values
  }), propValue => ({
    flexDirection: propValue
  })));
  if (ownerState.spacing) {
    const transformer = createUnarySpacing(theme);
    const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint) => {
      if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) {
        acc[breakpoint] = true;
      }
      return acc;
    }, {});
    const directionValues = resolveBreakpointValues({
      values: ownerState.direction,
      base
    });
    const spacingValues = resolveBreakpointValues({
      values: ownerState.spacing,
      base
    });
    if (typeof directionValues === 'object') {
      Object.keys(directionValues).forEach((breakpoint, index, breakpoints) => {
        const directionValue = directionValues[breakpoint];
        if (!directionValue) {
          const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
          directionValues[breakpoint] = previousDirectionValue;
        }
      });
    }
    const styleFromPropValue = (propValue, breakpoint) => {
      if (ownerState.useFlexGap) {
        return {
          gap: getValue$1(transformer, propValue)
        };
      }
      return {
        // The useFlexGap={false} implement relies on each child to give up control of the margin.
        // We need to reset the margin to avoid double spacing.
        '& > :not(style):not(style)': {
          margin: 0
        },
        '& > :not(style) ~ :not(style)': {
          [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: getValue$1(transformer, propValue)
        }
      };
    };
    styles = deepmerge$1(styles, handleBreakpoints({
      theme
    }, spacingValues, styleFromPropValue));
  }
  styles = mergeBreakpointsInOrder(theme.breakpoints, styles);
  return styles;
};
function createStack(options = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent,
    useThemeProps = useThemePropsDefault,
    componentName = 'MuiStack'
  } = options;
  const useUtilityClasses = () => {
    const slots = {
      root: ['root']
    };
    return composeClasses$1(slots, slot => generateUtilityClass(componentName, slot), {});
  };
  const StackRoot = createStyledComponent(style);
  const Stack = /*#__PURE__*/React$1.forwardRef(function Grid(inProps, ref) {
    const themeProps = useThemeProps(inProps);
    const props = extendSxProp(themeProps); // `color` type conflicts with html color attribute.
    const {
        component = 'div',
        direction = 'column',
        spacing = 0,
        divider,
        children,
        className,
        useFlexGap = false
      } = props,
      other = _objectWithoutPropertiesLoose$2(props, _excluded$1c);
    const ownerState = {
      direction,
      spacing,
      useFlexGap
    };
    const classes = useUtilityClasses();
    return /*#__PURE__*/jsxRuntimeExports.jsx(StackRoot, _extends$U({
      as: component,
      ownerState: ownerState,
      ref: ref,
      className: clsx(classes.root, className)
    }, other, {
      children: divider ? joinChildren(children, divider) : children
    }));
  });
  process.env.NODE_ENV !== "production" ? Stack.propTypes /* remove-proptypes */ = {
    children: PropTypes.node,
    direction: PropTypes.oneOfType([PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), PropTypes.arrayOf(PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), PropTypes.object]),
    divider: PropTypes.node,
    spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
    sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
  } : void 0;
  return Stack;
}

// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}

// Emulate the sass function "unitless"
function toUnitless(length) {
  return parseFloat(length);
}

function useTheme$1() {
  const theme = useTheme$3(defaultTheme$3);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$1.useDebugValue(theme);
  }
  return theme[THEME_ID] || theme;
}

const _excluded$1b = ["theme"];
function ThemeProvider(_ref) {
  let {
      theme: themeInput
    } = _ref,
    props = _objectWithoutPropertiesLoose$3(_ref, _excluded$1b);
  const scopedTheme = themeInput[THEME_ID];
  return /*#__PURE__*/jsxRuntimeExports.jsx(ThemeProvider$1, _extends$X({}, props, {
    themeId: scopedTheme ? THEME_ID : undefined,
    theme: scopedTheme || themeInput
  }));
}
process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const getOverlayAlpha = elevation => {
  let alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return (alphaValue / 100).toFixed(2);
};
var getOverlayAlpha$1 = getOverlayAlpha;

var reactIs = {exports: {}};

var reactIs_production_min = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
	function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=g;reactIs_production_min.Element=b;reactIs_production_min.ForwardRef=l;reactIs_production_min.Fragment=d;reactIs_production_min.Lazy=q;reactIs_production_min.Memo=p;reactIs_production_min.Portal=c;reactIs_production_min.Profiler=f;reactIs_production_min.StrictMode=e;reactIs_production_min.Suspense=m;
	reactIs_production_min.SuspenseList=n;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return v(a)===h};reactIs_production_min.isContextProvider=function(a){return v(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return v(a)===l};reactIs_production_min.isFragment=function(a){return v(a)===d};reactIs_production_min.isLazy=function(a){return v(a)===q};reactIs_production_min.isMemo=function(a){return v(a)===p};
	reactIs_production_min.isPortal=function(a){return v(a)===c};reactIs_production_min.isProfiler=function(a){return v(a)===f};reactIs_production_min.isStrictMode=function(a){return v(a)===e};reactIs_production_min.isSuspense=function(a){return v(a)===m};reactIs_production_min.isSuspenseList=function(a){return v(a)===n};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};reactIs_production_min.typeOf=v;
	return reactIs_production_min;
}

var reactIs_development = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_SERVER_CONTEXT_TYPE:
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	function isSuspenseList(object) {
	  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
	}

	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.SuspenseList = SuspenseList;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isSuspenseList = isSuspenseList;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = requireReactIs_production_min();
} else {
  reactIs.exports = requireReactIs_development();
}

var reactIsExports = reactIs.exports;

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop$1() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$1,
  onEntering: noop$1,
  onEntered: noop$1,
  onExit: noop$1,
  onExiting: noop$1,
  onExited: noop$1
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$V({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
var TransitionGroup$1 = TransitionGroup;

const reflow = node => node.scrollTop;
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;
  const {
    timeout,
    easing,
    style = {}
  } = props;
  return {
    duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
    delay: style.transitionDelay
  };
}

function getCollapseUtilityClass(slot) {
  return generateUtilityClass('MuiCollapse', slot);
}
generateUtilityClasses('MuiCollapse', ['root', 'horizontal', 'vertical', 'entered', 'hidden', 'wrapper', 'wrapperInner']);

const _excluded$1a = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"];
const useUtilityClasses$10 = ownerState => {
  const {
    orientation,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${orientation}`],
    entered: ['entered'],
    hidden: ['hidden'],
    wrapper: ['wrapper', `${orientation}`],
    wrapperInner: ['wrapperInner', `${orientation}`]
  };
  return composeClasses$1(slots, getCollapseUtilityClass, classes);
};
const CollapseRoot = styled$2('div', {
  name: 'MuiCollapse',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.state === 'entered' && styles.entered, ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  height: 0,
  overflow: 'hidden',
  transition: theme.transitions.create('height')
}, ownerState.orientation === 'horizontal' && {
  height: 'auto',
  width: 0,
  transition: theme.transitions.create('width')
}, ownerState.state === 'entered' && _extends$X({
  height: 'auto',
  overflow: 'visible'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto'
}), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
  visibility: 'hidden'
}));
const CollapseWrapper = styled$2('div', {
  name: 'MuiCollapse',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => styles.wrapper
})(({
  ownerState
}) => _extends$X({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: 'flex',
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));
const CollapseWrapperInner = styled$2('div', {
  name: 'MuiCollapse',
  slot: 'WrapperInner',
  overridesResolver: (props, styles) => styles.wrapperInner
})(({
  ownerState
}) => _extends$X({
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));

/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Collapse = /*#__PURE__*/React$1.forwardRef(function Collapse(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiCollapse'
  });
  const {
      addEndListener,
      children,
      className,
      collapsedSize: collapsedSizeProp = '0px',
      component,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      orientation = 'vertical',
      style,
      timeout = duration.standard,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = Transition$1
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$1a);
  const ownerState = _extends$X({}, props, {
    orientation,
    collapsedSize: collapsedSizeProp
  });
  const classes = useUtilityClasses$10(ownerState);
  const theme = useTheme$1();
  const timer = useTimeout();
  const wrapperRef = React$1.useRef(null);
  const autoTransitionDuration = React$1.useRef();
  const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
  const isHorizontal = orientation === 'horizontal';
  const size = isHorizontal ? 'width' : 'height';
  const nodeRef = React$1.useRef(null);
  const handleRef = useForkRef(ref, nodeRef);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const getWrapperSize = () => wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    if (wrapperRef.current && isHorizontal) {
      // Set absolute position to get the size of collapsed content
      wrapperRef.current.style.position = 'absolute';
    }
    node.style[size] = collapsedSize;
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const wrapperSize = getWrapperSize();
    if (wrapperRef.current && isHorizontal) {
      // After the size is read reset the position back to default
      wrapperRef.current.style.position = '';
    }
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    if (timeout === 'auto') {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }
    node.style[size] = `${wrapperSize}px`;
    node.style.transitionTimingFunction = transitionTimingFunction;
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback((node, isAppearing) => {
    node.style[size] = 'auto';
    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  const handleExit = normalizedTransitionCallback(node => {
    node.style[size] = `${getWrapperSize()}px`;
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleExiting = normalizedTransitionCallback(node => {
    const wrapperSize = getWrapperSize();
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    if (timeout === 'auto') {
      // TODO: rename getAutoHeightDuration to something more generic (width support)
      // Actually it just calculates animation duration based on size
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }
    node.style[size] = collapsedSize;
    node.style.transitionTimingFunction = transitionTimingFunction;
    if (onExiting) {
      onExiting(node);
    }
  });
  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.start(autoTransitionDuration.current || 0, next);
    }
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/jsxRuntimeExports.jsx(TransitionComponent, _extends$X({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => /*#__PURE__*/jsxRuntimeExports.jsx(CollapseRoot, _extends$X({
      as: component,
      className: clsx(classes.root, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedSize === '0px' && classes.hidden
      }[state]),
      style: _extends$X({
        [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
      }, style),
      ref: handleRef
    }, childProps, {
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: _extends$X({}, ownerState, {
        state
      }),
      children: /*#__PURE__*/jsxRuntimeExports.jsx(CollapseWrapper, {
        ownerState: _extends$X({}, ownerState, {
          state
        }),
        className: classes.wrapper,
        ref: wrapperRef,
        children: /*#__PURE__*/jsxRuntimeExports.jsx(CollapseWrapperInner, {
          ownerState: _extends$X({}, ownerState, {
            state
          }),
          className: classes.wrapperInner,
          children: children
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Collapse.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Collapse.muiSupportAuto = true;
var Collapse$1 = Collapse;

function getPaperUtilityClass(slot) {
  return generateUtilityClass('MuiPaper', slot);
}
generateUtilityClasses('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);

const _excluded$19 = ["className", "component", "elevation", "square", "variant"];
const useUtilityClasses$$ = ownerState => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && `elevation${elevation}`]
  };
  return composeClasses$1(slots, getPaperUtilityClass, classes);
};
const PaperRoot = styled$2('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$overlays;
  return _extends$X({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create('box-shadow')
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === 'outlined' && {
    border: `1px solid ${(theme.vars || theme).palette.divider}`
  }, ownerState.variant === 'elevation' && _extends$X({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === 'dark' && {
    backgroundImage: `linear-gradient(${alpha_1('#fff', getOverlayAlpha$1(ownerState.elevation))}, ${alpha_1('#fff', getOverlayAlpha$1(ownerState.elevation))})`
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
const Paper = /*#__PURE__*/React$1.forwardRef(function Paper(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiPaper'
  });
  const {
      className,
      component = 'div',
      elevation = 1,
      square = false,
      variant = 'elevation'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$19);
  const ownerState = _extends$X({}, props, {
    component,
    elevation,
    square,
    variant
  });
  const classes = useUtilityClasses$$(ownerState);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const theme = useTheme$1();
    if (theme.shadows[elevation] === undefined) {
      console.error([`MUI: The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${elevation}]\` is defined.`].join('\n'));
    }
  }
  return /*#__PURE__*/jsxRuntimeExports.jsx(PaperRoot, _extends$X({
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Paper.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, props => {
    const {
      elevation,
      variant
    } = props;
    if (elevation > 0 && variant === 'outlined') {
      return new Error(`MUI: Combining \`elevation={${elevation}}\` with \`variant="${variant}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`);
    }
    return null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['elevation', 'outlined']), PropTypes.string])
} : void 0;
var Paper$1 = Paper;

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */
const AccordionContext = /*#__PURE__*/React$1.createContext({});
if (process.env.NODE_ENV !== 'production') {
  AccordionContext.displayName = 'AccordionContext';
}
var AccordionContext$1 = AccordionContext;

const _excluded$18 = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"],
  _excluded2$7 = ["component", "slots", "slotProps"],
  _excluded3$2 = ["component"];
/**
 * An internal function to create a Material UI slot.
 *
 * This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
 * while Base UI does not need to support leaf component customization.
 *
 * @param {string} name: name of the slot
 * @param {object} parameters
 * @returns {[Slot, slotProps]} The slot's React component and the slot's props
 *
 * Note: the returned slot's props
 * - will never contain `component` prop.
 * - might contain `as` prop.
 */
function useSlot(
/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */
name, parameters) {
  const {
      className,
      elementType: initialElementType,
      ownerState,
      externalForwardedProps,
      getSlotOwnerState,
      internalForwardedProps
    } = parameters,
    useSlotPropsParams = _objectWithoutPropertiesLoose$3(parameters, _excluded$18);
  const {
      component: rootComponent,
      slots = {
        [name]: undefined
      },
      slotProps = {
        [name]: undefined
      }
    } = externalForwardedProps,
    other = _objectWithoutPropertiesLoose$3(externalForwardedProps, _excluded2$7);
  const elementType = slots[name] || initialElementType;

  // `slotProps[name]` can be a callback that receives the component's ownerState.
  // `resolvedComponentsProps` is always a plain object.
  const resolvedComponentsProps = resolveComponentProps(slotProps[name], ownerState);
  const _mergeSlotProps = mergeSlotProps(_extends$X({
      className
    }, useSlotPropsParams, {
      externalForwardedProps: name === 'root' ? other : undefined,
      externalSlotProps: resolvedComponentsProps
    })),
    {
      props: {
        component: slotComponent
      },
      internalRef
    } = _mergeSlotProps,
    mergedProps = _objectWithoutPropertiesLoose$3(_mergeSlotProps.props, _excluded3$2);
  const ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
  const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
  const finalOwnerState = _extends$X({}, ownerState, slotOwnerState);
  const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
  const props = appendOwnerState(elementType, _extends$X({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
    as: LeafComponent
  }, {
    ref
  }), finalOwnerState);
  Object.keys(slotOwnerState).forEach(propName => {
    delete props[propName];
  });
  return [elementType, props];
}

function getAccordionUtilityClass(slot) {
  return generateUtilityClass('MuiAccordion', slot);
}
const accordionClasses = generateUtilityClasses('MuiAccordion', ['root', 'rounded', 'expanded', 'disabled', 'gutters', 'region']);
var accordionClasses$1 = accordionClasses;

const _excluded$17 = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "slots", "slotProps", "TransitionComponent", "TransitionProps"];
const useUtilityClasses$_ = ownerState => {
  const {
    classes,
    square,
    expanded,
    disabled,
    disableGutters
  } = ownerState;
  const slots = {
    root: ['root', !square && 'rounded', expanded && 'expanded', disabled && 'disabled', !disableGutters && 'gutters'],
    region: ['region']
  };
  return composeClasses$1(slots, getAccordionUtilityClass, classes);
};
const AccordionRoot = styled$2(Paper$1, {
  name: 'MuiAccordion',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${accordionClasses$1.region}`]: styles.region
    }, styles.root, !ownerState.square && styles.rounded, !ownerState.disableGutters && styles.gutters];
  }
})(({
  theme
}) => {
  const transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    position: 'relative',
    transition: theme.transitions.create(['margin'], transition),
    overflowAnchor: 'none',
    // Keep the same scrolling position
    '&::before': {
      position: 'absolute',
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (theme.vars || theme).palette.divider,
      transition: theme.transitions.create(['opacity', 'background-color'], transition)
    },
    '&:first-of-type': {
      '&::before': {
        display: 'none'
      }
    },
    [`&.${accordionClasses$1.expanded}`]: {
      '&::before': {
        opacity: 0
      },
      '&:first-of-type': {
        marginTop: 0
      },
      '&:last-of-type': {
        marginBottom: 0
      },
      '& + &': {
        '&::before': {
          display: 'none'
        }
      }
    },
    [`&.${accordionClasses$1.disabled}`]: {
      backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    }
  };
}, ({
  theme
}) => ({
  variants: [{
    props: props => !props.square,
    style: {
      borderRadius: 0,
      '&:first-of-type': {
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
      },
      '&:last-of-type': {
        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: props => !props.disableGutters,
    style: {
      [`&.${accordionClasses$1.expanded}`]: {
        margin: '16px 0'
      }
    }
  }]
}));
const Accordion = /*#__PURE__*/React$1.forwardRef(function Accordion(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiAccordion'
  });
  const {
      children: childrenProp,
      className,
      defaultExpanded = false,
      disabled = false,
      disableGutters = false,
      expanded: expandedProp,
      onChange,
      square = false,
      slots = {},
      slotProps = {},
      TransitionComponent: TransitionComponentProp,
      TransitionProps: TransitionPropsProp
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$17);
  const [expanded, setExpandedState] = useControlled({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'Accordion',
    state: 'expanded'
  });
  const handleChange = React$1.useCallback(event => {
    setExpandedState(!expanded);
    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);
  const [summary, ...children] = React$1.Children.toArray(childrenProp);
  const contextValue = React$1.useMemo(() => ({
    expanded,
    disabled,
    disableGutters,
    toggle: handleChange
  }), [expanded, disabled, disableGutters, handleChange]);
  const ownerState = _extends$X({}, props, {
    square,
    disabled,
    disableGutters,
    expanded
  });
  const classes = useUtilityClasses$_(ownerState);
  const backwardCompatibleSlots = _extends$X({
    transition: TransitionComponentProp
  }, slots);
  const backwardCompatibleSlotProps = _extends$X({
    transition: TransitionPropsProp
  }, slotProps);
  const [TransitionSlot, transitionProps] = useSlot('transition', {
    elementType: Collapse$1,
    externalForwardedProps: {
      slots: backwardCompatibleSlots,
      slotProps: backwardCompatibleSlotProps
    },
    ownerState
  });
  return /*#__PURE__*/jsxRuntimeExports.jsxs(AccordionRoot, _extends$X({
    className: clsx(classes.root, className),
    ref: ref,
    ownerState: ownerState,
    square: square
  }, other, {
    children: [/*#__PURE__*/jsxRuntimeExports.jsx(AccordionContext$1.Provider, {
      value: contextValue,
      children: summary
    }), /*#__PURE__*/jsxRuntimeExports.jsx(TransitionSlot, _extends$X({
      in: expanded,
      timeout: "auto"
    }, transitionProps, {
      children: /*#__PURE__*/jsxRuntimeExports.jsx("div", {
        "aria-labelledby": summary.props.id,
        id: summary.props['aria-controls'],
        role: "region",
        className: classes.region,
        children: children
      })
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? Accordion.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: chainPropTypes(PropTypes.node.isRequired, props => {
    const summary = React$1.Children.toArray(props.children)[0];
    if (reactIsExports.isFragment(summary)) {
      return new Error("MUI: The Accordion doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }
    if (! /*#__PURE__*/React$1.isValidElement(summary)) {
      return new Error('MUI: Expected the first child of Accordion to be a valid element.');
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: PropTypes.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: PropTypes.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    transition: PropTypes.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionProps: PropTypes.object
} : void 0;
var Accordion$1 = Accordion;

function getAccordionDetailsUtilityClass(slot) {
  return generateUtilityClass('MuiAccordionDetails', slot);
}
generateUtilityClasses('MuiAccordionDetails', ['root']);

const _excluded$16 = ["className"];
const useUtilityClasses$Z = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses$1(slots, getAccordionDetailsUtilityClass, classes);
};
const AccordionDetailsRoot = styled$2('div', {
  name: 'MuiAccordionDetails',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  padding: theme.spacing(1, 2, 2)
}));
const AccordionDetails = /*#__PURE__*/React$1.forwardRef(function AccordionDetails(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiAccordionDetails'
  });
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$16);
  const ownerState = props;
  const classes = useUtilityClasses$Z(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(AccordionDetailsRoot, _extends$X({
    className: clsx(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? AccordionDetails.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var AccordionDetails$1 = AccordionDetails;

function Ripple(props) {
  const {
    className,
    classes,
    pulsate = false,
    rippleX,
    rippleY,
    rippleSize,
    in: inProp,
    onExited,
    timeout
  } = props;
  const [leaving, setLeaving] = React$1.useState(false);
  const rippleClassName = clsx(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  const rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  const childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  if (!inProp && !leaving) {
    setLeaving(true);
  }
  React$1.useEffect(() => {
    if (!inProp && onExited != null) {
      // react-transition-group#onExited
      const timeoutId = setTimeout(onExited, timeout);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    return undefined;
  }, [onExited, inProp, timeout]);
  return /*#__PURE__*/jsxRuntimeExports.jsx("span", {
    className: rippleClassName,
    style: rippleStyles,
    children: /*#__PURE__*/jsxRuntimeExports.jsx("span", {
      className: childClassName
    })
  });
}
process.env.NODE_ENV !== "production" ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;

const touchRippleClasses = generateUtilityClasses('MuiTouchRipple', ['root', 'ripple', 'rippleVisible', 'ripplePulsate', 'child', 'childLeaving', 'childPulsate']);
var touchRippleClasses$1 = touchRippleClasses;

const _excluded$15 = ["center", "classes", "className"];
let _$3 = t => t,
  _t$3,
  _t2$3,
  _t3$3,
  _t4$3;
const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = keyframes(_t$3 || (_t$3 = _$3`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const exitKeyframe = keyframes(_t2$3 || (_t2$3 = _$3`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const pulsateKeyframe = keyframes(_t3$3 || (_t3$3 = _$3`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const TouchRippleRoot = styled$2('span', {
  name: 'MuiTouchRipple',
  slot: 'Root'
})({
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: 'inherit'
});

// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const TouchRippleRipple = styled$2(Ripple, {
  name: 'MuiTouchRipple',
  slot: 'Ripple'
})(_t4$3 || (_t4$3 = _$3`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), touchRippleClasses$1.rippleVisible, enterKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, touchRippleClasses$1.ripplePulsate, ({
  theme
}) => theme.transitions.duration.shorter, touchRippleClasses$1.child, touchRippleClasses$1.childLeaving, exitKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, touchRippleClasses$1.childPulsate, pulsateKeyframe, ({
  theme
}) => theme.transitions.easing.easeInOut);

/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */
const TouchRipple = /*#__PURE__*/React$1.forwardRef(function TouchRipple(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTouchRipple'
  });
  const {
      center: centerProp = false,
      classes = {},
      className
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$15);
  const [ripples, setRipples] = React$1.useState([]);
  const nextKey = React$1.useRef(0);
  const rippleCallback = React$1.useRef(null);
  React$1.useEffect(() => {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]);

  // Used to filter out mouse emulated events on mobile.
  const ignoringMouseDown = React$1.useRef(false);
  // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.
  const startTimer = useTimeout();

  // This is the hook called once the previous timeout is ready.
  const startTimerCommit = React$1.useRef(null);
  const container = React$1.useRef(null);
  const startCommit = React$1.useCallback(params => {
    const {
      pulsate,
      rippleX,
      rippleY,
      rippleSize,
      cb
    } = params;
    setRipples(oldRipples => [...oldRipples, /*#__PURE__*/jsxRuntimeExports.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx(classes.ripple, touchRippleClasses$1.ripple),
        rippleVisible: clsx(classes.rippleVisible, touchRippleClasses$1.rippleVisible),
        ripplePulsate: clsx(classes.ripplePulsate, touchRippleClasses$1.ripplePulsate),
        child: clsx(classes.child, touchRippleClasses$1.child),
        childLeaving: clsx(classes.childLeaving, touchRippleClasses$1.childLeaving),
        childPulsate: clsx(classes.childPulsate, touchRippleClasses$1.childPulsate)
      },
      timeout: DURATION,
      pulsate: pulsate,
      rippleX: rippleX,
      rippleY: rippleY,
      rippleSize: rippleSize
    }, nextKey.current)]);
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  const start = React$1.useCallback((event = {}, options = {}, cb = () => {}) => {
    const {
      pulsate = false,
      center = centerProp || options.pulsate,
      fakeElement = false // For test purposes
    } = options;
    if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }
    if ((event == null ? void 0 : event.type) === 'touchstart') {
      ignoringMouseDown.current = true;
    }
    const element = fakeElement ? null : container.current;
    const rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };

    // Get the size of the ripple
    let rippleX;
    let rippleY;
    let rippleSize;
    if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      const {
        clientX,
        clientY
      } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }
    if (center) {
      rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);

      // For some reason the animation is broken on Mobile Chrome if the size is even.
      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    }

    // Touche devices
    if (event != null && event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = () => {
          startCommit({
            pulsate,
            rippleX,
            rippleY,
            rippleSize,
            cb
          });
        };
        // Delay the execution of the ripple effect.
        // We have to make a tradeoff with this delay value.
        startTimer.start(DELAY_RIPPLE, () => {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        });
      }
    } else {
      startCommit({
        pulsate,
        rippleX,
        rippleY,
        rippleSize,
        cb
      });
    }
  }, [centerProp, startCommit, startTimer]);
  const pulsate = React$1.useCallback(() => {
    start({}, {
      pulsate: true
    });
  }, [start]);
  const stop = React$1.useCallback((event, cb) => {
    startTimer.clear();

    // The touch interaction occurs too quickly.
    // We still want to show ripple effect.
    if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.start(0, () => {
        stop(event, cb);
      });
      return;
    }
    startTimerCommit.current = null;
    setRipples(oldRipples => {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }
      return oldRipples;
    });
    rippleCallback.current = cb;
  }, [startTimer]);
  React$1.useImperativeHandle(ref, () => ({
    pulsate,
    start,
    stop
  }), [pulsate, start, stop]);
  return /*#__PURE__*/jsxRuntimeExports.jsx(TouchRippleRoot, _extends$X({
    className: clsx(touchRippleClasses$1.root, classes.root, className),
    ref: container
  }, other, {
    children: /*#__PURE__*/jsxRuntimeExports.jsx(TransitionGroup$1, {
      component: null,
      exit: true,
      children: ripples
    })
  }));
});
process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
var TouchRipple$1 = TouchRipple;

function getButtonBaseUtilityClass(slot) {
  return generateUtilityClass('MuiButtonBase', slot);
}
const buttonBaseClasses = generateUtilityClasses('MuiButtonBase', ['root', 'disabled', 'focusVisible']);
var buttonBaseClasses$1 = buttonBaseClasses;

const _excluded$14 = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"];
const useUtilityClasses$Y = ownerState => {
  const {
    disabled,
    focusVisible,
    focusVisibleClassName,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', focusVisible && 'focusVisible']
  };
  const composedClasses = composeClasses$1(slots, getButtonBaseUtilityClass, classes);
  if (focusVisible && focusVisibleClassName) {
    composedClasses.root += ` ${focusVisibleClassName}`;
  }
  return composedClasses;
};
const ButtonBaseRoot = styled$2('button', {
  name: 'MuiButtonBase',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  boxSizing: 'border-box',
  WebkitTapHighlightColor: 'transparent',
  backgroundColor: 'transparent',
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: 'pointer',
  userSelect: 'none',
  verticalAlign: 'middle',
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  textDecoration: 'none',
  // So we take precedent over the style of a native <a /> element.
  color: 'inherit',
  '&::-moz-focus-inner': {
    borderStyle: 'none' // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses$1.disabled}`]: {
    pointerEvents: 'none',
    // Disable link interactions
    cursor: 'default'
  },
  '@media print': {
    colorAdjust: 'exact'
  }
});

/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */
const ButtonBase = /*#__PURE__*/React$1.forwardRef(function ButtonBase(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiButtonBase'
  });
  const {
      action,
      centerRipple = false,
      children,
      className,
      component = 'button',
      disabled = false,
      disableRipple = false,
      disableTouchRipple = false,
      focusRipple = false,
      LinkComponent = 'a',
      onBlur,
      onClick,
      onContextMenu,
      onDragLeave,
      onFocus,
      onFocusVisible,
      onKeyDown,
      onKeyUp,
      onMouseDown,
      onMouseLeave,
      onMouseUp,
      onTouchEnd,
      onTouchMove,
      onTouchStart,
      tabIndex = 0,
      TouchRippleProps,
      touchRippleRef,
      type
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$14);
  const buttonRef = React$1.useRef(null);
  const rippleRef = React$1.useRef(null);
  const handleRippleRef = useForkRef(rippleRef, touchRippleRef);
  const {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible();
  const [focusVisible, setFocusVisible] = React$1.useState(false);
  if (disabled && focusVisible) {
    setFocusVisible(false);
  }
  React$1.useImperativeHandle(action, () => ({
    focusVisible: () => {
      setFocusVisible(true);
      buttonRef.current.focus();
    }
  }), []);
  const [mountedState, setMountedState] = React$1.useState(false);
  React$1.useEffect(() => {
    setMountedState(true);
  }, []);
  const enableTouchRipple = mountedState && !disableRipple && !disabled;
  React$1.useEffect(() => {
    if (focusVisible && focusRipple && !disableRipple && mountedState) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible, mountedState]);
  function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
    return useEventCallback(event => {
      if (eventCallback) {
        eventCallback(event);
      }
      const ignore = skipRippleAction;
      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }
      return true;
    });
  }
  const handleMouseDown = useRippleHandler('start', onMouseDown);
  const handleContextMenu = useRippleHandler('stop', onContextMenu);
  const handleDragLeave = useRippleHandler('stop', onDragLeave);
  const handleMouseUp = useRippleHandler('stop', onMouseUp);
  const handleMouseLeave = useRippleHandler('stop', event => {
    if (focusVisible) {
      event.preventDefault();
    }
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  const handleTouchStart = useRippleHandler('start', onTouchStart);
  const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  const handleTouchMove = useRippleHandler('stop', onTouchMove);
  const handleBlur = useRippleHandler('stop', event => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  }, false);
  const handleFocus = useEventCallback(event => {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }
    if (onFocus) {
      onFocus(event);
    }
  });
  const isNonNativeButton = () => {
    const button = buttonRef.current;
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };

  /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */
  const keydownRef = React$1.useRef(false);
  const handleKeyDown = useEventCallback(event => {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      rippleRef.current.stop(event, () => {
        rippleRef.current.start(event);
      });
    }
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }

    // Keyboard accessibility for non interactive elements
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();
      if (onClick) {
        onClick(event);
      }
    }
  });
  const handleKeyUp = useEventCallback(event => {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      rippleRef.current.stop(event, () => {
        rippleRef.current.pulsate(event);
      });
    }
    if (onKeyUp) {
      onKeyUp(event);
    }

    // Keyboard accessibility for non interactive elements
    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  let ComponentProp = component;
  if (ComponentProp === 'button' && (other.href || other.to)) {
    ComponentProp = LinkComponent;
  }
  const buttonProps = {};
  if (ComponentProp === 'button') {
    buttonProps.type = type === undefined ? 'button' : type;
    buttonProps.disabled = disabled;
  } else {
    if (!other.href && !other.to) {
      buttonProps.role = 'button';
    }
    if (disabled) {
      buttonProps['aria-disabled'] = disabled;
    }
  }
  const handleRef = useForkRef(ref, focusVisibleRef, buttonRef);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$1.useEffect(() => {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['MUI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }
  const ownerState = _extends$X({}, props, {
    centerRipple,
    component,
    disabled,
    disableRipple,
    disableTouchRipple,
    focusRipple,
    tabIndex,
    focusVisible
  });
  const classes = useUtilityClasses$Y(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsxs(ButtonBaseRoot, _extends$X({
    as: ComponentProp,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    onBlur: handleBlur,
    onClick: onClick,
    onContextMenu: handleContextMenu,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex,
    type: type
  }, buttonProps, other, {
    children: [children, enableTouchRipple ?
    /*#__PURE__*/
    /* TouchRipple is only needed client-side, x2 boost on the server. */
    jsxRuntimeExports.jsx(TouchRipple$1, _extends$X({
      ref: handleRippleRef,
      center: centerRipple
    }, TouchRippleProps)) : null]
  }));
});
process.env.NODE_ENV !== "production" ? ButtonBase.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType$1,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes /* @typescript-to-proptypes-ignore */.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string])
} : void 0;
var ButtonBase$1 = ButtonBase;

function getAccordionSummaryUtilityClass(slot) {
  return generateUtilityClass('MuiAccordionSummary', slot);
}
const accordionSummaryClasses = generateUtilityClasses('MuiAccordionSummary', ['root', 'expanded', 'focusVisible', 'disabled', 'gutters', 'contentGutters', 'content', 'expandIconWrapper']);
var accordionSummaryClasses$1 = accordionSummaryClasses;

const _excluded$13 = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"];
const useUtilityClasses$X = ownerState => {
  const {
    classes,
    expanded,
    disabled,
    disableGutters
  } = ownerState;
  const slots = {
    root: ['root', expanded && 'expanded', disabled && 'disabled', !disableGutters && 'gutters'],
    focusVisible: ['focusVisible'],
    content: ['content', expanded && 'expanded', !disableGutters && 'contentGutters'],
    expandIconWrapper: ['expandIconWrapper', expanded && 'expanded']
  };
  return composeClasses$1(slots, getAccordionSummaryUtilityClass, classes);
};
const AccordionSummaryRoot = styled$2(ButtonBase$1, {
  name: 'MuiAccordionSummary',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  const transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    display: 'flex',
    minHeight: 48,
    padding: theme.spacing(0, 2),
    transition: theme.transitions.create(['min-height', 'background-color'], transition),
    [`&.${accordionSummaryClasses$1.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette.action.focus
    },
    [`&.${accordionSummaryClasses$1.disabled}`]: {
      opacity: (theme.vars || theme).palette.action.disabledOpacity
    },
    [`&:hover:not(.${accordionSummaryClasses$1.disabled})`]: {
      cursor: 'pointer'
    },
    variants: [{
      props: props => !props.disableGutters,
      style: {
        [`&.${accordionSummaryClasses$1.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
});
const AccordionSummaryContent = styled$2('div', {
  name: 'MuiAccordionSummary',
  slot: 'Content',
  overridesResolver: (props, styles) => styles.content
})(({
  theme
}) => ({
  display: 'flex',
  flexGrow: 1,
  margin: '12px 0',
  variants: [{
    props: props => !props.disableGutters,
    style: {
      transition: theme.transitions.create(['margin'], {
        duration: theme.transitions.duration.shortest
      }),
      [`&.${accordionSummaryClasses$1.expanded}`]: {
        margin: '20px 0'
      }
    }
  }]
}));
const AccordionSummaryExpandIconWrapper = styled$2('div', {
  name: 'MuiAccordionSummary',
  slot: 'ExpandIconWrapper',
  overridesResolver: (props, styles) => styles.expandIconWrapper
})(({
  theme
}) => ({
  display: 'flex',
  color: (theme.vars || theme).palette.action.active,
  transform: 'rotate(0deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${accordionSummaryClasses$1.expanded}`]: {
    transform: 'rotate(180deg)'
  }
}));
const AccordionSummary = /*#__PURE__*/React$1.forwardRef(function AccordionSummary(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiAccordionSummary'
  });
  const {
      children,
      className,
      expandIcon,
      focusVisibleClassName,
      onClick
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$13);
  const {
    disabled = false,
    disableGutters,
    expanded,
    toggle
  } = React$1.useContext(AccordionContext$1);
  const handleChange = event => {
    if (toggle) {
      toggle(event);
    }
    if (onClick) {
      onClick(event);
    }
  };
  const ownerState = _extends$X({}, props, {
    expanded,
    disabled,
    disableGutters
  });
  const classes = useUtilityClasses$X(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsxs(AccordionSummaryRoot, _extends$X({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: clsx(classes.root, className),
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    onClick: handleChange,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/jsxRuntimeExports.jsx(AccordionSummaryContent, {
      className: classes.content,
      ownerState: ownerState,
      children: children
    }), expandIcon && /*#__PURE__*/jsxRuntimeExports.jsx(AccordionSummaryExpandIconWrapper, {
      className: classes.expandIconWrapper,
      ownerState: ownerState,
      children: expandIcon
    })]
  }));
});
process.env.NODE_ENV !== "production" ? AccordionSummary.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var AccordionSummary$1 = AccordionSummary;

function getAlertUtilityClass(slot) {
  return generateUtilityClass('MuiAlert', slot);
}
const alertClasses = generateUtilityClasses('MuiAlert', ['root', 'action', 'icon', 'message', 'filled', 'colorSuccess', 'colorInfo', 'colorWarning', 'colorError', 'filledSuccess', 'filledInfo', 'filledWarning', 'filledError', 'outlined', 'outlinedSuccess', 'outlinedInfo', 'outlinedWarning', 'outlinedError', 'standard', 'standardSuccess', 'standardInfo', 'standardWarning', 'standardError']);
var alertClasses$1 = alertClasses;

function getIconButtonUtilityClass(slot) {
  return generateUtilityClass('MuiIconButton', slot);
}
const iconButtonClasses = generateUtilityClasses('MuiIconButton', ['root', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'colorError', 'colorInfo', 'colorSuccess', 'colorWarning', 'edgeStart', 'edgeEnd', 'sizeSmall', 'sizeMedium', 'sizeLarge']);
var iconButtonClasses$1 = iconButtonClasses;

const _excluded$12 = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"];
const useUtilityClasses$W = ownerState => {
  const {
    classes,
    disabled,
    color,
    edge,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', color !== 'default' && `color${capitalize$1(color)}`, edge && `edge${capitalize$1(edge)}`, `size${capitalize$1(size)}`]
  };
  return composeClasses$1(slots, getIconButtonUtilityClass, classes);
};
const IconButtonRoot = styled$2(ButtonBase$1, {
  name: 'MuiIconButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${capitalize$1(ownerState.color)}`], ownerState.edge && styles[`edge${capitalize$1(ownerState.edge)}`], styles[`size${capitalize$1(ownerState.size)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  textAlign: 'center',
  flex: '0 0 auto',
  fontSize: theme.typography.pxToRem(24),
  padding: 8,
  borderRadius: '50%',
  overflow: 'visible',
  // Explicitly set the default value to solve a bug on IE11.
  color: (theme.vars || theme).palette.action.active,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  })
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha_1(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}), ({
  theme,
  ownerState
}) => {
  var _palette;
  const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
  return _extends$X({}, ownerState.color === 'inherit' && {
    color: 'inherit'
  }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && _extends$X({
    color: palette == null ? void 0 : palette.main
  }, !ownerState.disableRipple && {
    '&:hover': _extends$X({}, palette && {
      backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha_1(palette.main, theme.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    })
  }), ownerState.size === 'small' && {
    padding: 5,
    fontSize: theme.typography.pxToRem(18)
  }, ownerState.size === 'large' && {
    padding: 12,
    fontSize: theme.typography.pxToRem(28)
  }, {
    [`&.${iconButtonClasses$1.disabled}`]: {
      backgroundColor: 'transparent',
      color: (theme.vars || theme).palette.action.disabled
    }
  });
});

/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */
const IconButton = /*#__PURE__*/React$1.forwardRef(function IconButton(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiIconButton'
  });
  const {
      edge = false,
      children,
      className,
      color = 'default',
      disabled = false,
      disableFocusRipple = false,
      size = 'medium'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$12);
  const ownerState = _extends$X({}, props, {
    edge,
    color,
    disabled,
    disableFocusRipple,
    size
  });
  const classes = useUtilityClasses$W(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(IconButtonRoot, _extends$X({
    className: clsx(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other, {
    ownerState: ownerState,
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? IconButton.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: chainPropTypes(PropTypes.node, props => {
    const found = React$1.Children.toArray(props.children).some(child => /*#__PURE__*/React$1.isValidElement(child) && child.props.onClick);
    if (found) {
      return new Error(['MUI: You are providing an onClick event listener to a child of a button element.', 'Prefer applying it to the IconButton directly.', 'This guarantees that the whole <button> will be responsive to click events.'].join('\n'));
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(['end', 'start', false]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['small', 'medium', 'large']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var IconButton$1 = IconButton;

var SuccessOutlinedIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

var ReportProblemOutlinedIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

var ErrorOutlineIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

var InfoOutlinedIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

var ClearIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

const _excluded$11 = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"];
const useUtilityClasses$V = ownerState => {
  const {
    variant,
    color,
    severity,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$1(color || severity)}`, `${variant}${capitalize$1(color || severity)}`, `${variant}`],
    icon: ['icon'],
    message: ['message'],
    action: ['action']
  };
  return composeClasses$1(slots, getAlertUtilityClass, classes);
};
const AlertRoot = styled$2(Paper$1, {
  name: 'MuiAlert',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${capitalize$1(ownerState.color || ownerState.severity)}`]];
  }
})(({
  theme
}) => {
  const getColor = theme.palette.mode === 'light' ? darken_1 : lighten_1;
  const getBackgroundColor = theme.palette.mode === 'light' ? lighten_1 : darken_1;
  return _extends$X({}, theme.typography.body2, {
    backgroundColor: 'transparent',
    display: 'flex',
    padding: '6px 16px',
    variants: [...Object.entries(theme.palette).filter(([, value]) => value.main && value.light).map(([color]) => ({
      props: {
        colorSeverity: color,
        variant: 'standard'
      },
      style: {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
        [`& .${alertClasses$1.icon}`]: theme.vars ? {
          color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
          color: theme.palette[color].main
        }
      }
    })), ...Object.entries(theme.palette).filter(([, value]) => value.main && value.light).map(([color]) => ({
      props: {
        colorSeverity: color,
        variant: 'outlined'
      },
      style: {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
        [`& .${alertClasses$1.icon}`]: theme.vars ? {
          color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
          color: theme.palette[color].main
        }
      }
    })), ...Object.entries(theme.palette).filter(([, value]) => value.main && value.dark).map(([color]) => ({
      props: {
        colorSeverity: color,
        variant: 'filled'
      },
      style: _extends$X({
        fontWeight: theme.typography.fontWeightMedium
      }, theme.vars ? {
        color: theme.vars.palette.Alert[`${color}FilledColor`],
        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
      } : {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
        color: theme.palette.getContrastText(theme.palette[color].main)
      })
    }))]
  });
});
const AlertIcon = styled$2('div', {
  name: 'MuiAlert',
  slot: 'Icon',
  overridesResolver: (props, styles) => styles.icon
})({
  marginRight: 12,
  padding: '7px 0',
  display: 'flex',
  fontSize: 22,
  opacity: 0.9
});
const AlertMessage = styled$2('div', {
  name: 'MuiAlert',
  slot: 'Message',
  overridesResolver: (props, styles) => styles.message
})({
  padding: '8px 0',
  minWidth: 0,
  overflow: 'auto'
});
const AlertAction = styled$2('div', {
  name: 'MuiAlert',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '4px 0 0 16px',
  marginLeft: 'auto',
  marginRight: -8
});
const defaultIconMapping = {
  success: /*#__PURE__*/jsxRuntimeExports.jsx(SuccessOutlinedIcon, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/jsxRuntimeExports.jsx(ReportProblemOutlinedIcon, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/jsxRuntimeExports.jsx(ErrorOutlineIcon, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/jsxRuntimeExports.jsx(InfoOutlinedIcon, {
    fontSize: "inherit"
  })
};
const Alert = /*#__PURE__*/React$1.forwardRef(function Alert(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiAlert'
  });
  const {
      action,
      children,
      className,
      closeText = 'Close',
      color,
      components = {},
      componentsProps = {},
      icon,
      iconMapping = defaultIconMapping,
      onClose,
      role = 'alert',
      severity = 'success',
      slotProps = {},
      slots = {},
      variant = 'standard'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$11);
  const ownerState = _extends$X({}, props, {
    color,
    severity,
    variant,
    colorSeverity: color || severity
  });
  const classes = useUtilityClasses$V(ownerState);
  const externalForwardedProps = {
    slots: _extends$X({
      closeButton: components.CloseButton,
      closeIcon: components.CloseIcon
    }, slots),
    slotProps: _extends$X({}, componentsProps, slotProps)
  };
  const [CloseButtonSlot, closeButtonProps] = useSlot('closeButton', {
    elementType: IconButton$1,
    externalForwardedProps,
    ownerState
  });
  const [CloseIconSlot, closeIconProps] = useSlot('closeIcon', {
    elementType: ClearIcon,
    externalForwardedProps,
    ownerState
  });
  return /*#__PURE__*/jsxRuntimeExports.jsxs(AlertRoot, _extends$X({
    role: role,
    elevation: 0,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other, {
    children: [icon !== false ? /*#__PURE__*/jsxRuntimeExports.jsx(AlertIcon, {
      ownerState: ownerState,
      className: classes.icon,
      children: icon || iconMapping[severity] || defaultIconMapping[severity]
    }) : null, /*#__PURE__*/jsxRuntimeExports.jsx(AlertMessage, {
      ownerState: ownerState,
      className: classes.message,
      children: children
    }), action != null ? /*#__PURE__*/jsxRuntimeExports.jsx(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: action
    }) : null, action == null && onClose ? /*#__PURE__*/jsxRuntimeExports.jsx(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: /*#__PURE__*/jsxRuntimeExports.jsx(CloseButtonSlot, _extends$X({
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose
      }, closeButtonProps, {
        children: /*#__PURE__*/jsxRuntimeExports.jsx(CloseIconSlot, _extends$X({
          fontSize: "small"
        }, closeIconProps))
      }))
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? Alert.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: PropTypes.node,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: PropTypes.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  components: PropTypes.shape({
    CloseButton: PropTypes.elementType,
    CloseIcon: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    closeButton: PropTypes.object,
    closeIcon: PropTypes.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: PropTypes.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: PropTypes.shape({
    error: PropTypes.node,
    info: PropTypes.node,
    success: PropTypes.node,
    warning: PropTypes.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: PropTypes.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    closeButton: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    closeIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    closeButton: PropTypes.elementType,
    closeIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['filled', 'outlined', 'standard']), PropTypes.string])
} : void 0;
var Alert$1 = Alert;

function getTypographyUtilityClass(slot) {
  return generateUtilityClass('MuiTypography', slot);
}
generateUtilityClasses('MuiTypography', ['root', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'inherit', 'button', 'caption', 'overline', 'alignLeft', 'alignRight', 'alignCenter', 'alignJustify', 'noWrap', 'gutterBottom', 'paragraph']);

const _excluded$10 = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];
const useUtilityClasses$U = ownerState => {
  const {
    align,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, ownerState.align !== 'inherit' && `align${capitalize$1(align)}`, gutterBottom && 'gutterBottom', noWrap && 'noWrap', paragraph && 'paragraph']
  };
  return composeClasses$1(slots, getTypographyUtilityClass, classes);
};
const TypographyRoot = styled$2('span', {
  name: 'MuiTypography',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.variant && styles[ownerState.variant], ownerState.align !== 'inherit' && styles[`align${capitalize$1(ownerState.align)}`], ownerState.noWrap && styles.noWrap, ownerState.gutterBottom && styles.gutterBottom, ownerState.paragraph && styles.paragraph];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  margin: 0
}, ownerState.variant === 'inherit' && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: 'inherit'
}, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
  textAlign: ownerState.align
}, ownerState.noWrap && {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, ownerState.gutterBottom && {
  marginBottom: '0.35em'
}, ownerState.paragraph && {
  marginBottom: 16
}));
const defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  inherit: 'p'
};

// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};
const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};
const Typography = /*#__PURE__*/React$1.forwardRef(function Typography(inProps, ref) {
  const themeProps = useDefaultProps({
    props: inProps,
    name: 'MuiTypography'
  });
  const color = transformDeprecatedColors(themeProps.color);
  const props = extendSxProp(_extends$X({}, themeProps, {
    color
  }));
  const {
      align = 'inherit',
      className,
      component,
      gutterBottom = false,
      noWrap = false,
      paragraph = false,
      variant = 'body1',
      variantMapping = defaultVariantMapping
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$10);
  const ownerState = _extends$X({}, props, {
    align,
    color,
    className,
    component,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    variantMapping
  });
  const Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  const classes = useUtilityClasses$U(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(TypographyRoot, _extends$X({
    as: Component,
    ref: ref,
    ownerState: ownerState,
    className: clsx(classes.root, className)
  }, other));
});
process.env.NODE_ENV !== "production" ? Typography.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['body1', 'body2', 'button', 'caption', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'inherit', 'overline', 'subtitle1', 'subtitle2']), PropTypes.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes /* @typescript-to-proptypes-ignore */.object
} : void 0;
var Typography$1 = Typography;

// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function createFilterOptions(config = {}) {
  const {
    ignoreAccents = true,
    ignoreCase = true,
    limit,
    matchFrom = 'any',
    stringify,
    trim = false
  } = config;
  return (options, {
    inputValue,
    getOptionLabel
  }) => {
    let input = trim ? inputValue.trim() : inputValue;
    if (ignoreCase) {
      input = input.toLowerCase();
    }
    if (ignoreAccents) {
      input = stripDiacritics(input);
    }
    const filteredOptions = !input ? options : options.filter(option => {
      let candidate = (stringify || getOptionLabel)(option);
      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }
      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }
      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
  };
}

// To replace with .findIndex() once we stop IE11 support.
function findIndex$1(array, comp) {
  for (let i = 0; i < array.length; i += 1) {
    if (comp(array[i])) {
      return i;
    }
  }
  return -1;
}
const defaultFilterOptions = createFilterOptions();

// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const pageSize = 5;
const defaultIsActiveElementInListbox = listboxRef => {
  var _listboxRef$current$p;
  return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function useAutocomplete(props) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = defaultIsActiveElementInListbox,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui',
    autoComplete = false,
    autoHighlight = false,
    autoSelect = false,
    blurOnSelect = false,
    clearOnBlur = !props.freeSolo,
    clearOnEscape = false,
    componentName = 'useAutocomplete',
    defaultValue = props.multiple ? [] : null,
    disableClearable = false,
    disableCloseOnSelect = false,
    disabled: disabledProp,
    disabledItemsFocusable = false,
    disableListWrap = false,
    filterOptions = defaultFilterOptions,
    filterSelectedOptions = false,
    freeSolo = false,
    getOptionDisabled,
    getOptionKey,
    getOptionLabel: getOptionLabelProp = option => {
      var _option$label;
      return (_option$label = option.label) != null ? _option$label : option;
    },
    groupBy,
    handleHomeEndKeys = !props.freeSolo,
    id: idProp,
    includeInputInList = false,
    inputValue: inputValueProp,
    isOptionEqualToValue = (option, value) => option === value,
    multiple = false,
    onChange,
    onClose,
    onHighlightChange,
    onInputChange,
    onOpen,
    open: openProp,
    openOnFocus = false,
    options,
    readOnly = false,
    selectOnFocus = !props.freeSolo,
    value: valueProp
  } = props;
  const id = useId(idProp);
  let getOptionLabel = getOptionLabelProp;
  getOptionLabel = option => {
    const optionLabel = getOptionLabelProp(option);
    if (typeof optionLabel !== 'string') {
      if (process.env.NODE_ENV !== 'production') {
        const erroneousReturn = optionLabel === undefined ? 'undefined' : `${typeof optionLabel} (${optionLabel})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${componentName} returned ${erroneousReturn} instead of a string for ${JSON.stringify(option)}.`);
      }
      return String(optionLabel);
    }
    return optionLabel;
  };
  const ignoreFocus = React$1.useRef(false);
  const firstFocus = React$1.useRef(true);
  const inputRef = React$1.useRef(null);
  const listboxRef = React$1.useRef(null);
  const [anchorEl, setAnchorEl] = React$1.useState(null);
  const [focusedTag, setFocusedTag] = React$1.useState(-1);
  const defaultHighlighted = autoHighlight ? 0 : -1;
  const highlightedIndexRef = React$1.useRef(defaultHighlighted);
  const [value, setValueState] = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: componentName
  });
  const [inputValue, setInputValueState] = useControlled({
    controlled: inputValueProp,
    default: '',
    name: componentName,
    state: 'inputValue'
  });
  const [focused, setFocused] = React$1.useState(false);
  const resetInputValue = React$1.useCallback((event, newValue) => {
    // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
    // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
    const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
    if (!isOptionSelected && !clearOnBlur) {
      return;
    }
    let newInputValue;
    if (multiple) {
      newInputValue = '';
    } else if (newValue == null) {
      newInputValue = '';
    } else {
      const optionLabel = getOptionLabel(newValue);
      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
    }
    if (inputValue === newInputValue) {
      return;
    }
    setInputValueState(newInputValue);
    if (onInputChange) {
      onInputChange(event, newInputValue, 'reset');
    }
  }, [getOptionLabel, inputValue, multiple, onInputChange, setInputValueState, clearOnBlur, value]);
  const [open, setOpenState] = useControlled({
    controlled: openProp,
    default: false,
    name: componentName,
    state: 'open'
  });
  const [inputPristine, setInputPristine] = React$1.useState(true);
  const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
  const popupOpen = open && !readOnly;
  const filteredOptions = popupOpen ? filterOptions(options.filter(option => {
    if (filterSelectedOptions && (multiple ? value : [value]).some(value2 => value2 !== null && isOptionEqualToValue(option, value2))) {
      return false;
    }
    return true;
  }),
  // we use the empty string to manipulate `filterOptions` to not filter any options
  // i.e. the filter predicate always returns true
  {
    inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
    getOptionLabel
  }) : [];
  const previousProps = usePreviousProps$1({
    filteredOptions,
    value,
    inputValue
  });
  React$1.useEffect(() => {
    const valueChange = value !== previousProps.value;
    if (focused && !valueChange) {
      return;
    }

    // Only reset the input's value when freeSolo if the component's value changes.
    if (freeSolo && !valueChange) {
      return;
    }
    resetInputValue(null, value);
  }, [value, resetInputValue, focused, previousProps.value, freeSolo]);
  const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
  if (process.env.NODE_ENV !== 'production') {
    if (value !== null && !freeSolo && options.length > 0) {
      const missingValue = (multiple ? value : [value]).filter(value2 => !options.some(option => isOptionEqualToValue(option, value2)));
      if (missingValue.length > 0) {
        console.warn([`MUI: The value provided to ${componentName} is invalid.`, `None of the options match with \`${missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0])}\`.`, 'You can use the `isOptionEqualToValue` prop to customize the equality test.'].join('\n'));
      }
    }
  }
  const focusTag = useEventCallback(tagToFocus => {
    if (tagToFocus === -1) {
      inputRef.current.focus();
    } else {
      anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    }
  });

  // Ensure the focusedTag is never inconsistent
  React$1.useEffect(() => {
    if (multiple && focusedTag > value.length - 1) {
      setFocusedTag(-1);
      focusTag(-1);
    }
  }, [value, multiple, focusedTag, focusTag]);
  function validOptionIndex(index, direction) {
    if (!listboxRef.current || index < 0 || index >= filteredOptions.length) {
      return -1;
    }
    let nextFocus = index;
    while (true) {
      const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);

      // Same logic as MenuList.js
      const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
      if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) {
        // The next option is available
        return nextFocus;
      }

      // The next option is disabled, move to the next element.
      // with looped index
      if (direction === 'next') {
        nextFocus = (nextFocus + 1) % filteredOptions.length;
      } else {
        nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
      }

      // We end up with initial index, that means we don't have available options.
      // All of them are disabled
      if (nextFocus === index) {
        return -1;
      }
    }
  }
  const setHighlightedIndex = useEventCallback(({
    event,
    index,
    reason = 'auto'
  }) => {
    highlightedIndexRef.current = index;

    // does the index exist?
    if (index === -1) {
      inputRef.current.removeAttribute('aria-activedescendant');
    } else {
      inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
    }
    if (onHighlightChange) {
      onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
    }
    if (!listboxRef.current) {
      return;
    }
    const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
    if (prev) {
      prev.classList.remove(`${unstable_classNamePrefix}-focused`);
      prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
    }
    let listboxNode = listboxRef.current;
    if (listboxRef.current.getAttribute('role') !== 'listbox') {
      listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
    }

    // "No results"
    if (!listboxNode) {
      return;
    }
    if (index === -1) {
      listboxNode.scrollTop = 0;
      return;
    }
    const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
    if (!option) {
      return;
    }
    option.classList.add(`${unstable_classNamePrefix}-focused`);
    if (reason === 'keyboard') {
      option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
    }

    // Scroll active descendant into view.
    // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
    // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
    // Consider this API instead once it has a better browser support:
    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
      const element = option;
      const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      const elementBottom = element.offsetTop + element.offsetHeight;
      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
      }
    }
  });
  const changeHighlightedIndex = useEventCallback(({
    event,
    diff,
    direction = 'next',
    reason = 'auto'
  }) => {
    if (!popupOpen) {
      return;
    }
    const getNextIndex = () => {
      const maxIndex = filteredOptions.length - 1;
      if (diff === 'reset') {
        return defaultHighlighted;
      }
      if (diff === 'start') {
        return 0;
      }
      if (diff === 'end') {
        return maxIndex;
      }
      const newIndex = highlightedIndexRef.current + diff;
      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }
        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
          return 0;
        }
        return maxIndex;
      }
      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }
        if (disableListWrap || Math.abs(diff) > 1) {
          return maxIndex;
        }
        return 0;
      }
      return newIndex;
    };
    const nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex({
      index: nextIndex,
      reason,
      event
    });

    // Sync the content of the input with the highlighted option.
    if (autoComplete && diff !== 'reset') {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        const option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option;

        // The portion of the selected suggestion that has not been typed by the user,
        // a completion string, appears inline after the input cursor in the textbox.
        const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
        if (index === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  });
  const getPreviousHighlightedOptionIndex = () => {
    const isSameValue = (value1, value2) => {
      const label1 = value1 ? getOptionLabel(value1) : '';
      const label2 = value2 ? getOptionLabel(value2) : '';
      return label1 === label2;
    };
    if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i) => getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
      const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
      if (previousHighlightedOption) {
        return findIndex$1(filteredOptions, option => {
          return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
        });
      }
    }
    return -1;
  };
  const syncHighlightedIndex = React$1.useCallback(() => {
    if (!popupOpen) {
      return;
    }

    // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
    // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
    const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
    if (previousHighlightedOptionIndex !== -1) {
      highlightedIndexRef.current = previousHighlightedOptionIndex;
      return;
    }
    const valueItem = multiple ? value[0] : value;

    // The popup is empty, reset
    if (filteredOptions.length === 0 || valueItem == null) {
      changeHighlightedIndex({
        diff: 'reset'
      });
      return;
    }
    if (!listboxRef.current) {
      return;
    }

    // Synchronize the value with the highlighted index
    if (valueItem != null) {
      const currentOption = filteredOptions[highlightedIndexRef.current];

      // Keep the current highlighted index if possible
      if (multiple && currentOption && findIndex$1(value, val => isOptionEqualToValue(currentOption, val)) !== -1) {
        return;
      }
      const itemIndex = findIndex$1(filteredOptions, optionItem => isOptionEqualToValue(optionItem, valueItem));
      if (itemIndex === -1) {
        changeHighlightedIndex({
          diff: 'reset'
        });
      } else {
        setHighlightedIndex({
          index: itemIndex
        });
      }
      return;
    }

    // Prevent the highlighted index to leak outside the boundaries.
    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
      setHighlightedIndex({
        index: filteredOptions.length - 1
      });
      return;
    }

    // Restore the focus to the previous index.
    setHighlightedIndex({
      index: highlightedIndexRef.current
    });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
  // Only sync the highlighted index when the option switch between empty and not
  filteredOptions.length,
  // Don't sync the highlighted index with the value when multiple
  // eslint-disable-next-line react-hooks/exhaustive-deps
  multiple ? false : value, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, popupOpen, inputValue, multiple]);
  const handleListboxRef = useEventCallback(node => {
    setRef(listboxRef, node);
    if (!node) {
      return;
    }
    syncHighlightedIndex();
  });
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$1.useEffect(() => {
      if (!inputRef.current || inputRef.current.nodeName !== 'INPUT') {
        if (inputRef.current && inputRef.current.nodeName === 'TEXTAREA') {
          console.warn([`A textarea element was provided to ${componentName} where input was expected.`, `This is not a supported scenario but it may work under certain conditions.`, `A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).`, `Make sure to test keyboard navigation and add custom event handlers if necessary.`].join('\n'));
        } else {
          console.error([`MUI: Unable to find the input element. It was resolved to ${inputRef.current} while an HTMLInputElement was expected.`, `Instead, ${componentName} expects an input element.`, '', componentName === 'useAutocomplete' ? 'Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed.' : 'Make sure you have customized the input component correctly.'].join('\n'));
        }
      }
    }, [componentName]);
  }
  React$1.useEffect(() => {
    syncHighlightedIndex();
  }, [syncHighlightedIndex]);
  const handleOpen = event => {
    if (open) {
      return;
    }
    setOpenState(true);
    setInputPristine(true);
    if (onOpen) {
      onOpen(event);
    }
  };
  const handleClose = (event, reason) => {
    if (!open) {
      return;
    }
    setOpenState(false);
    if (onClose) {
      onClose(event, reason);
    }
  };
  const handleValue = (event, newValue, reason, details) => {
    if (multiple) {
      if (value.length === newValue.length && value.every((val, i) => val === newValue[i])) {
        return;
      }
    } else if (value === newValue) {
      return;
    }
    if (onChange) {
      onChange(event, newValue, reason, details);
    }
    setValueState(newValue);
  };
  const isTouch = React$1.useRef(false);
  const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options') => {
    let reason = reasonProp;
    let newValue = option;
    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];
      if (process.env.NODE_ENV !== 'production') {
        const matches = newValue.filter(val => isOptionEqualToValue(option, val));
        if (matches.length > 1) {
          console.error([`MUI: The \`isOptionEqualToValue\` method of ${componentName} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${matches.length} matches.`].join('\n'));
        }
      }
      const itemIndex = findIndex$1(newValue, valueItem => isOptionEqualToValue(option, valueItem));
      if (itemIndex === -1) {
        newValue.push(option);
      } else if (origin !== 'freeSolo') {
        newValue.splice(itemIndex, 1);
        reason = 'removeOption';
      }
    }
    resetInputValue(event, newValue);
    handleValue(event, newValue, reason, {
      option
    });
    if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) {
      handleClose(event, reason);
    }
    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
      inputRef.current.blur();
    }
  };
  function validTagIndex(index, direction) {
    if (index === -1) {
      return -1;
    }
    let nextFocus = index;
    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }
      const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);

      // Same logic as MenuList.js
      if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }
  const handleFocusTag = (event, direction) => {
    if (!multiple) {
      return;
    }
    if (inputValue === '') {
      handleClose(event, 'toggleInput');
    }
    let nextTag = focusedTag;
    if (focusedTag === -1) {
      if (inputValue === '' && direction === 'previous') {
        nextTag = value.length - 1;
      }
    } else {
      nextTag += direction === 'next' ? 1 : -1;
      if (nextTag < 0) {
        nextTag = 0;
      }
      if (nextTag === value.length) {
        nextTag = -1;
      }
    }
    nextTag = validTagIndex(nextTag, direction);
    setFocusedTag(nextTag);
    focusTag(nextTag);
  };
  const handleClear = event => {
    ignoreFocus.current = true;
    setInputValueState('');
    if (onInputChange) {
      onInputChange(event, '', 'clear');
    }
    handleValue(event, multiple ? [] : null, 'clear');
  };
  const handleKeyDown = other => event => {
    if (other.onKeyDown) {
      other.onKeyDown(event);
    }
    if (event.defaultMuiPrevented) {
      return;
    }
    if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
      setFocusedTag(-1);
      focusTag(-1);
    }

    // Wait until IME is settled.
    if (event.which !== 229) {
      switch (event.key) {
        case 'Home':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'start',
              direction: 'next',
              reason: 'keyboard',
              event
            });
          }
          break;
        case 'End':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'end',
              direction: 'previous',
              reason: 'keyboard',
              event
            });
          }
          break;
        case 'PageUp':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: -pageSize,
            direction: 'previous',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'PageDown':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: pageSize,
            direction: 'next',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'ArrowDown':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: 1,
            direction: 'next',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'ArrowUp':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: -1,
            direction: 'previous',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'ArrowLeft':
          handleFocusTag(event, 'previous');
          break;
        case 'ArrowRight':
          handleFocusTag(event, 'next');
          break;
        case 'Enter':
          if (highlightedIndexRef.current !== -1 && popupOpen) {
            const option = filteredOptions[highlightedIndexRef.current];
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;

            // Avoid early form validation, let the end-users continue filling the form.
            event.preventDefault();
            if (disabled) {
              return;
            }
            selectNewValue(event, option, 'selectOption');

            // Move the selection to the end.
            if (autoComplete) {
              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
          } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
            if (multiple) {
              // Allow people to add new values before they submit the form.
              event.preventDefault();
            }
            selectNewValue(event, inputValue, 'createOption', 'freeSolo');
          }
          break;
        case 'Escape':
          if (popupOpen) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault();
            // Avoid the Modal to handle the event.
            event.stopPropagation();
            handleClose(event, 'escape');
          } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault();
            // Avoid the Modal to handle the event.
            event.stopPropagation();
            handleClear(event);
          }
          break;
        case 'Backspace':
          // Remove the value on the left of the "cursor"
          if (multiple && !readOnly && inputValue === '' && value.length > 0) {
            const index = focusedTag === -1 ? value.length - 1 : focusedTag;
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
              option: value[index]
            });
          }
          break;
        case 'Delete':
          // Remove the value on the right of the "cursor"
          if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
            const index = focusedTag;
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
              option: value[index]
            });
          }
          break;
      }
    }
  };
  const handleFocus = event => {
    setFocused(true);
    if (openOnFocus && !ignoreFocus.current) {
      handleOpen(event);
    }
  };
  const handleBlur = event => {
    // Ignore the event when using the scrollbar with IE11
    if (unstable_isActiveElementInListbox(listboxRef)) {
      inputRef.current.focus();
      return;
    }
    setFocused(false);
    firstFocus.current = true;
    ignoreFocus.current = false;
    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
      selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
    } else if (autoSelect && freeSolo && inputValue !== '') {
      selectNewValue(event, inputValue, 'blur', 'freeSolo');
    } else if (clearOnBlur) {
      resetInputValue(event, value);
    }
    handleClose(event, 'blur');
  };
  const handleInputChange = event => {
    const newValue = event.target.value;
    if (inputValue !== newValue) {
      setInputValueState(newValue);
      setInputPristine(false);
      if (onInputChange) {
        onInputChange(event, newValue, 'input');
      }
    }
    if (newValue === '') {
      if (!disableClearable && !multiple) {
        handleValue(event, null, 'clear');
      }
    } else {
      handleOpen(event);
    }
  };
  const handleOptionMouseMove = event => {
    const index = Number(event.currentTarget.getAttribute('data-option-index'));
    if (highlightedIndexRef.current !== index) {
      setHighlightedIndex({
        event,
        index,
        reason: 'mouse'
      });
    }
  };
  const handleOptionTouchStart = event => {
    setHighlightedIndex({
      event,
      index: Number(event.currentTarget.getAttribute('data-option-index')),
      reason: 'touch'
    });
    isTouch.current = true;
  };
  const handleOptionClick = event => {
    const index = Number(event.currentTarget.getAttribute('data-option-index'));
    selectNewValue(event, filteredOptions[index], 'selectOption');
    isTouch.current = false;
  };
  const handleTagDelete = index => event => {
    const newValue = value.slice();
    newValue.splice(index, 1);
    handleValue(event, newValue, 'removeOption', {
      option: value[index]
    });
  };
  const handlePopupIndicator = event => {
    if (open) {
      handleClose(event, 'toggleInput');
    } else {
      handleOpen(event);
    }
  };

  // Prevent input blur when interacting with the combobox
  const handleMouseDown = event => {
    // Prevent focusing the input if click is anywhere outside the Autocomplete
    if (!event.currentTarget.contains(event.target)) {
      return;
    }
    if (event.target.getAttribute('id') !== id) {
      event.preventDefault();
    }
  };

  // Focus the input when interacting with the combobox
  const handleClick = event => {
    // Prevent focusing the input if click is anywhere outside the Autocomplete
    if (!event.currentTarget.contains(event.target)) {
      return;
    }
    inputRef.current.focus();
    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.select();
    }
    firstFocus.current = false;
  };
  const handleInputMouseDown = event => {
    if (!disabledProp && (inputValue === '' || !open)) {
      handlePopupIndicator(event);
    }
  };
  let dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  let groupedOptions = filteredOptions;
  if (groupBy) {
    // used to keep track of key and indexes in the result array
    const indexBy = new Map();
    let warn = false;
    groupedOptions = filteredOptions.reduce((acc, option, index) => {
      const group = groupBy(option);
      if (acc.length > 0 && acc[acc.length - 1].group === group) {
        acc[acc.length - 1].options.push(option);
      } else {
        if (process.env.NODE_ENV !== 'production') {
          if (indexBy.get(group) && !warn) {
            console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${componentName} returns duplicated headers.`, 'You can solve the issue by sorting the options with the output of `groupBy`.');
            warn = true;
          }
          indexBy.set(group, true);
        }
        acc.push({
          key: index,
          index,
          group,
          options: [option]
        });
      }
      return acc;
    }, []);
  }
  if (disabledProp && focused) {
    handleBlur();
  }
  return {
    getRootProps: (other = {}) => _extends$X({
      'aria-owns': listboxAvailable ? `${id}-listbox` : null
    }, other, {
      onKeyDown: handleKeyDown(other),
      onMouseDown: handleMouseDown,
      onClick: handleClick
    }),
    getInputLabelProps: () => ({
      id: `${id}-label`,
      htmlFor: id
    }),
    getInputProps: () => ({
      id,
      value: inputValue,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onChange: handleInputChange,
      onMouseDown: handleInputMouseDown,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      'aria-activedescendant': popupOpen ? '' : null,
      'aria-autocomplete': autoComplete ? 'both' : 'list',
      'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
      'aria-expanded': listboxAvailable,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: 'off',
      ref: inputRef,
      autoCapitalize: 'none',
      spellCheck: 'false',
      role: 'combobox',
      disabled: disabledProp
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: 'button',
      onClick: handleClear
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: 'button',
      onClick: handlePopupIndicator
    }),
    getTagProps: ({
      index
    }) => _extends$X({
      key: index,
      'data-tag-index': index,
      tabIndex: -1
    }, !readOnly && {
      onDelete: handleTagDelete(index)
    }),
    getListboxProps: () => ({
      role: 'listbox',
      id: `${id}-listbox`,
      'aria-labelledby': `${id}-label`,
      ref: handleListboxRef,
      onMouseDown: event => {
        // Prevent blur
        event.preventDefault();
      }
    }),
    getOptionProps: ({
      index,
      option
    }) => {
      var _getOptionKey;
      const selected = (multiple ? value : [value]).some(value2 => value2 != null && isOptionEqualToValue(option, value2));
      const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
        tabIndex: -1,
        role: 'option',
        id: `${id}-option-${index}`,
        onMouseMove: handleOptionMouseMove,
        onClick: handleOptionClick,
        onTouchStart: handleOptionTouchStart,
        'data-option-index': index,
        'aria-disabled': disabled,
        'aria-selected': selected
      };
    },
    id,
    inputValue,
    value,
    dirty,
    expanded: popupOpen && anchorEl,
    popupOpen,
    focused: focused || focusedTag !== -1,
    anchorEl,
    setAnchorEl,
    focusedTag,
    groupedOptions
  };
}

var useThemeWithoutDefault = {};

Object.defineProperty(useThemeWithoutDefault, "__esModule", {
  value: true
});
var default_1$5 = useThemeWithoutDefault.default = void 0;
var React = _interopRequireWildcard(React__default);
var _styledEngine = require$$1$1;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
  const contextTheme = React.useContext(_styledEngine.ThemeContext);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
default_1$5 = useThemeWithoutDefault.default = useTheme;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement$2(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement$2(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement$2(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max$1 = Math.max;
var min$1 = Math.min;
var round$2 = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement$2(element)) {
    scaleX = element.offsetWidth > 0 ? round$2(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$2(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement$2(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement$2(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement$2(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min, value, max) {
  return max$1(min, min$1(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$2(x * dpr) / dpr || 0,
    y: round$2(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max$1(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max$1(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max$1(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement$2(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$2(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max$1(rect.top, accRect.top);
    accRect.right = min$1(rect.right, accRect.right);
    accRect.bottom = min$1(rect.bottom, accRect.bottom);
    accRect.left = max$1(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$1(min, tetherMin) : min, offset, tether ? max$1(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement$2(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$2(rect.width) / element.offsetWidth || 1;
  var scaleY = round$2(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement$2(offsetParent);
  var offsetParentIsScaled = isHTMLElement$2(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement$2(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

function getContainer$1(container) {
  return typeof container === 'function' ? container() : container;
}

/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */
const Portal = /*#__PURE__*/React$1.forwardRef(function Portal(props, forwardedRef) {
  const {
    children,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = React$1.useState(null);
  // @ts-expect-error TODO upstream fix
  const handleRef = useForkRef( /*#__PURE__*/React$1.isValidElement(children) ? children.ref : null, forwardedRef);
  useEnhancedEffect$1(() => {
    if (!disablePortal) {
      setMountNode(getContainer$1(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect$1(() => {
    if (mountNode && !disablePortal) {
      setRef(forwardedRef, mountNode);
      return () => {
        setRef(forwardedRef, null);
      };
    }
    return undefined;
  }, [forwardedRef, mountNode, disablePortal]);
  if (disablePortal) {
    if ( /*#__PURE__*/React$1.isValidElement(children)) {
      const newProps = {
        ref: handleRef
      };
      return /*#__PURE__*/React$1.cloneElement(children, newProps);
    }
    return /*#__PURE__*/jsxRuntimeExports.jsx(React$1.Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/jsxRuntimeExports.jsx(React$1.Fragment, {
    children: mountNode ? /*#__PURE__*/ReactDOM.createPortal(children, mountNode) : mountNode
  });
});
process.env.NODE_ENV !== "production" ? Portal.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  Portal['propTypes' + ''] = exactProp(Portal.propTypes);
}
var Portal$1 = Portal;

function getPopperUtilityClass(slot) {
  return generateUtilityClass('MuiPopper', slot);
}
generateUtilityClasses('MuiPopper', ['root']);

const _excluded$$ = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"],
  _excluded2$6 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function flipPlacement(placement, direction) {
  if (direction === 'ltr') {
    return placement;
  }
  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';
    case 'bottom-start':
      return 'bottom-end';
    case 'top-end':
      return 'top-start';
    case 'top-start':
      return 'top-end';
    default:
      return placement;
  }
}
function resolveAnchorEl$1(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function isHTMLElement$1(element) {
  return element.nodeType !== undefined;
}
function isVirtualElement(element) {
  return !isHTMLElement$1(element);
}
const useUtilityClasses$T = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses$1(slots, getPopperUtilityClass, classes);
};
const defaultPopperOptions = {};
const PopperTooltip = /*#__PURE__*/React$1.forwardRef(function PopperTooltip(props, forwardedRef) {
  var _slots$root;
  const {
      anchorEl,
      children,
      direction,
      disablePortal,
      modifiers,
      open,
      placement: initialPlacement,
      popperOptions,
      popperRef: popperRefProp,
      slotProps = {},
      slots = {},
      TransitionProps
      // @ts-ignore internal logic
      // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$$);
  const tooltipRef = React$1.useRef(null);
  const ownRef = useForkRef(tooltipRef, forwardedRef);
  const popperRef = React$1.useRef(null);
  const handlePopperRef = useForkRef(popperRef, popperRefProp);
  const handlePopperRefRef = React$1.useRef(handlePopperRef);
  useEnhancedEffect$1(() => {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  React$1.useImperativeHandle(popperRefProp, () => popperRef.current, []);
  const rtlPlacement = flipPlacement(initialPlacement, direction);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */
  const [placement, setPlacement] = React$1.useState(rtlPlacement);
  const [resolvedAnchorElement, setResolvedAnchorElement] = React$1.useState(resolveAnchorEl$1(anchorEl));
  React$1.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.forceUpdate();
    }
  });
  React$1.useEffect(() => {
    if (anchorEl) {
      setResolvedAnchorElement(resolveAnchorEl$1(anchorEl));
    }
  }, [anchorEl]);
  useEnhancedEffect$1(() => {
    if (!resolvedAnchorElement || !open) {
      return undefined;
    }
    const handlePopperUpdate = data => {
      setPlacement(data.placement);
    };
    if (process.env.NODE_ENV !== 'production') {
      if (resolvedAnchorElement && isHTMLElement$1(resolvedAnchorElement) && resolvedAnchorElement.nodeType === 1) {
        const box = resolvedAnchorElement.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }
    }
    let popperModifiers = [{
      name: 'preventOverflow',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'flip',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'onUpdate',
      enabled: true,
      phase: 'afterWrite',
      fn: ({
        state
      }) => {
        handlePopperUpdate(state);
      }
    }];
    if (modifiers != null) {
      popperModifiers = popperModifiers.concat(modifiers);
    }
    if (popperOptions && popperOptions.modifiers != null) {
      popperModifiers = popperModifiers.concat(popperOptions.modifiers);
    }
    const popper = createPopper(resolvedAnchorElement, tooltipRef.current, _extends$X({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: popperModifiers
    }));
    handlePopperRefRef.current(popper);
    return () => {
      popper.destroy();
      handlePopperRefRef.current(null);
    };
  }, [resolvedAnchorElement, disablePortal, modifiers, open, popperOptions, rtlPlacement]);
  const childProps = {
    placement: placement
  };
  if (TransitionProps !== null) {
    childProps.TransitionProps = TransitionProps;
  }
  const classes = useUtilityClasses$T(props);
  const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    additionalProps: {
      role: 'tooltip',
      ref: ownRef
    },
    ownerState: props,
    className: classes.root
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx(Root, _extends$X({}, rootProps, {
    children: typeof children === 'function' ? children(childProps) : children
  }));
});

/**
 * @ignore - internal component.
 */
const Popper$2 = /*#__PURE__*/React$1.forwardRef(function Popper(props, forwardedRef) {
  const {
      anchorEl,
      children,
      container: containerProp,
      direction = 'ltr',
      disablePortal = false,
      keepMounted = false,
      modifiers,
      open,
      placement = 'bottom',
      popperOptions = defaultPopperOptions,
      popperRef,
      style,
      transition = false,
      slotProps = {},
      slots = {}
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded2$6);
  const [exited, setExited] = React$1.useState(true);
  const handleEnter = () => {
    setExited(false);
  };
  const handleExited = () => {
    setExited(true);
  };
  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container
  let container;
  if (containerProp) {
    container = containerProp;
  } else if (anchorEl) {
    const resolvedAnchorEl = resolveAnchorEl$1(anchorEl);
    container = resolvedAnchorEl && isHTMLElement$1(resolvedAnchorEl) ? ownerDocument(resolvedAnchorEl).body : ownerDocument(null).body;
  }
  const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
  const transitionProps = transition ? {
    in: open,
    onEnter: handleEnter,
    onExited: handleExited
  } : undefined;
  return /*#__PURE__*/jsxRuntimeExports.jsx(Portal$1, {
    disablePortal: disablePortal,
    container: container,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(PopperTooltip, _extends$X({
      anchorEl: anchorEl,
      direction: direction,
      disablePortal: disablePortal,
      modifiers: modifiers,
      ref: forwardedRef,
      open: transition ? !exited : open,
      placement: placement,
      popperOptions: popperOptions,
      popperRef: popperRef,
      slotProps: slotProps,
      slots: slots
    }, other, {
      style: _extends$X({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: 'fixed',
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display
      }, style),
      TransitionProps: transitionProps,
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? Popper$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), props => {
    if (props.open) {
      const resolvedAnchorEl = resolveAnchorEl$1(props.anchorEl);
      if (resolvedAnchorEl && isHTMLElement$1(resolvedAnchorEl) && resolvedAnchorEl.nodeType === 1) {
        const box = resolvedAnchorEl.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.getBoundingClientRect !== 'function' || isVirtualElement(resolvedAnchorEl) && resolvedAnchorEl.contextElement != null && resolvedAnchorEl.contextElement.nodeType !== 1) {
        return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a virtualElement ', '(https://popper.js.org/docs/v2/virtual-elements/).'].join('\n'));
      }
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes.oneOf(['ltr', 'rtl']),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(['afterMain', 'afterRead', 'afterWrite', 'beforeMain', 'beforeRead', 'beforeWrite', 'main', 'read', 'write']),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
    strategy: PropTypes.oneOf(['absolute', 'fixed'])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType$1,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
} : void 0;
var BasePopper = Popper$2;

const _excluded$_ = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"];
const PopperRoot = styled$2(BasePopper, {
  name: 'MuiPopper',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});

/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */
const Popper = /*#__PURE__*/React$1.forwardRef(function Popper(inProps, ref) {
  var _slots$root;
  const theme = default_1$5();
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiPopper'
  });
  const {
      anchorEl,
      component,
      components,
      componentsProps,
      container,
      disablePortal,
      keepMounted,
      modifiers,
      open,
      placement,
      popperOptions,
      popperRef,
      transition,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$_);
  const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
  const otherProps = _extends$X({
    anchorEl,
    container,
    disablePortal,
    keepMounted,
    modifiers,
    open,
    placement,
    popperOptions,
    popperRef,
    transition
  }, other);
  return /*#__PURE__*/jsxRuntimeExports.jsx(PopperRoot, _extends$X({
    as: component,
    direction: theme == null ? void 0 : theme.direction,
    slots: {
      root: RootComponent
    },
    slotProps: slotProps != null ? slotProps : componentsProps
  }, otherProps, {
    ref: ref
  }));
});
process.env.NODE_ENV !== "production" ? Popper.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * Popper render function or node.
   */
  children: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(['afterMain', 'afterRead', 'afterWrite', 'beforeMain', 'beforeRead', 'beforeWrite', 'main', 'read', 'write']),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
    strategy: PropTypes.oneOf(['absolute', 'fixed'])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType$1,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
} : void 0;
var Popper$1 = Popper;

function getListSubheaderUtilityClass(slot) {
  return generateUtilityClass('MuiListSubheader', slot);
}
generateUtilityClasses('MuiListSubheader', ['root', 'colorPrimary', 'colorInherit', 'gutters', 'inset', 'sticky']);

const _excluded$Z = ["className", "color", "component", "disableGutters", "disableSticky", "inset"];
const useUtilityClasses$S = ownerState => {
  const {
    classes,
    color,
    disableGutters,
    inset,
    disableSticky
  } = ownerState;
  const slots = {
    root: ['root', color !== 'default' && `color${capitalize$1(color)}`, !disableGutters && 'gutters', inset && 'inset', !disableSticky && 'sticky']
  };
  return composeClasses$1(slots, getListSubheaderUtilityClass, classes);
};
const ListSubheaderRoot = styled$2('li', {
  name: 'MuiListSubheader',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${capitalize$1(ownerState.color)}`], !ownerState.disableGutters && styles.gutters, ownerState.inset && styles.inset, !ownerState.disableSticky && styles.sticky];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  boxSizing: 'border-box',
  lineHeight: '48px',
  listStyle: 'none',
  color: (theme.vars || theme).palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.pxToRem(14)
}, ownerState.color === 'primary' && {
  color: (theme.vars || theme).palette.primary.main
}, ownerState.color === 'inherit' && {
  color: 'inherit'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.inset && {
  paddingLeft: 72
}, !ownerState.disableSticky && {
  position: 'sticky',
  top: 0,
  zIndex: 1,
  backgroundColor: (theme.vars || theme).palette.background.paper
}));
const ListSubheader = /*#__PURE__*/React$1.forwardRef(function ListSubheader(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiListSubheader'
  });
  const {
      className,
      color = 'default',
      component = 'li',
      disableGutters = false,
      disableSticky = false,
      inset = false
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$Z);
  const ownerState = _extends$X({}, props, {
    color,
    component,
    disableGutters,
    disableSticky,
    inset
  });
  const classes = useUtilityClasses$S(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(ListSubheaderRoot, _extends$X({
    as: component,
    className: clsx(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other));
});
ListSubheader.muiSkipListHighlight = true;
process.env.NODE_ENV !== "production" ? ListSubheader.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary']),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: PropTypes.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var ListSubheader$1 = ListSubheader;

var CancelIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

function getChipUtilityClass(slot) {
  return generateUtilityClass('MuiChip', slot);
}
const chipClasses = generateUtilityClasses('MuiChip', ['root', 'sizeSmall', 'sizeMedium', 'colorError', 'colorInfo', 'colorPrimary', 'colorSecondary', 'colorSuccess', 'colorWarning', 'disabled', 'clickable', 'clickableColorPrimary', 'clickableColorSecondary', 'deletable', 'deletableColorPrimary', 'deletableColorSecondary', 'outlined', 'filled', 'outlinedPrimary', 'outlinedSecondary', 'filledPrimary', 'filledSecondary', 'avatar', 'avatarSmall', 'avatarMedium', 'avatarColorPrimary', 'avatarColorSecondary', 'icon', 'iconSmall', 'iconMedium', 'iconColorPrimary', 'iconColorSecondary', 'label', 'labelSmall', 'labelMedium', 'deleteIcon', 'deleteIconSmall', 'deleteIconMedium', 'deleteIconColorPrimary', 'deleteIconColorSecondary', 'deleteIconOutlinedColorPrimary', 'deleteIconOutlinedColorSecondary', 'deleteIconFilledColorPrimary', 'deleteIconFilledColorSecondary', 'focusVisible']);
var chipClasses$1 = chipClasses;

const _excluded$Y = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"];
const useUtilityClasses$R = ownerState => {
  const {
    classes,
    disabled,
    size,
    color,
    iconColor,
    onDelete,
    clickable,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant, disabled && 'disabled', `size${capitalize$1(size)}`, `color${capitalize$1(color)}`, clickable && 'clickable', clickable && `clickableColor${capitalize$1(color)}`, onDelete && 'deletable', onDelete && `deletableColor${capitalize$1(color)}`, `${variant}${capitalize$1(color)}`],
    label: ['label', `label${capitalize$1(size)}`],
    avatar: ['avatar', `avatar${capitalize$1(size)}`, `avatarColor${capitalize$1(color)}`],
    icon: ['icon', `icon${capitalize$1(size)}`, `iconColor${capitalize$1(iconColor)}`],
    deleteIcon: ['deleteIcon', `deleteIcon${capitalize$1(size)}`, `deleteIconColor${capitalize$1(color)}`, `deleteIcon${capitalize$1(variant)}Color${capitalize$1(color)}`]
  };
  return composeClasses$1(slots, getChipUtilityClass, classes);
};
const ChipRoot = styled$2('div', {
  name: 'MuiChip',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      color,
      iconColor,
      clickable,
      onDelete,
      size,
      variant
    } = ownerState;
    return [{
      [`& .${chipClasses$1.avatar}`]: styles.avatar
    }, {
      [`& .${chipClasses$1.avatar}`]: styles[`avatar${capitalize$1(size)}`]
    }, {
      [`& .${chipClasses$1.avatar}`]: styles[`avatarColor${capitalize$1(color)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: styles.icon
    }, {
      [`& .${chipClasses$1.icon}`]: styles[`icon${capitalize$1(size)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: styles[`iconColor${capitalize$1(iconColor)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles.deleteIcon
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIcon${capitalize$1(size)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIconColor${capitalize$1(color)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIcon${capitalize$1(variant)}Color${capitalize$1(color)}`]
    }, styles.root, styles[`size${capitalize$1(size)}`], styles[`color${capitalize$1(color)}`], clickable && styles.clickable, clickable && color !== 'default' && styles[`clickableColor${capitalize$1(color)})`], onDelete && styles.deletable, onDelete && color !== 'default' && styles[`deletableColor${capitalize$1(color)}`], styles[variant], styles[`${variant}${capitalize$1(color)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
  return _extends$X({
    maxWidth: '100%',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(13),
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 32,
    color: (theme.vars || theme).palette.text.primary,
    backgroundColor: (theme.vars || theme).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create(['background-color', 'box-shadow']),
    // reset cursor explicitly in case ButtonBase is used
    cursor: 'unset',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: 'none',
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    [`&.${chipClasses$1.disabled}`]: {
      opacity: (theme.vars || theme).palette.action.disabledOpacity,
      pointerEvents: 'none'
    },
    [`& .${chipClasses$1.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
      fontSize: theme.typography.pxToRem(12)
    },
    [`& .${chipClasses$1.avatarColorPrimary}`]: {
      color: (theme.vars || theme).palette.primary.contrastText,
      backgroundColor: (theme.vars || theme).palette.primary.dark
    },
    [`& .${chipClasses$1.avatarColorSecondary}`]: {
      color: (theme.vars || theme).palette.secondary.contrastText,
      backgroundColor: (theme.vars || theme).palette.secondary.dark
    },
    [`& .${chipClasses$1.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: theme.typography.pxToRem(10)
    },
    [`& .${chipClasses$1.icon}`]: _extends$X({
      marginLeft: 5,
      marginRight: -6
    }, ownerState.size === 'small' && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, ownerState.iconColor === ownerState.color && _extends$X({
      color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
    }, ownerState.color !== 'default' && {
      color: 'inherit'
    })),
    [`& .${chipClasses$1.deleteIcon}`]: _extends$X({
      WebkitTapHighlightColor: 'transparent',
      color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : alpha_1(theme.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : alpha_1(theme.palette.text.primary, 0.4)
      }
    }, ownerState.size === 'small' && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, ownerState.color !== 'default' && {
      color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : alpha_1(theme.palette[ownerState.color].contrastText, 0.7),
      '&:hover, &:active': {
        color: (theme.vars || theme).palette[ownerState.color].contrastText
      }
    })
  }, ownerState.size === 'small' && {
    height: 24
  }, ownerState.color !== 'default' && {
    backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
    color: (theme.vars || theme).palette[ownerState.color].contrastText
  }, ownerState.onDelete && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : alpha_1(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  }, ownerState.onDelete && ownerState.color !== 'default' && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
    }
  });
}, ({
  theme,
  ownerState
}) => _extends$X({}, ownerState.clickable && {
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : alpha_1(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : alpha_1(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
  },
  '&:active': {
    boxShadow: (theme.vars || theme).shadows[1]
  }
}, ownerState.clickable && ownerState.color !== 'default' && {
  [`&:hover, &.${chipClasses$1.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
  }
}), ({
  theme,
  ownerState
}) => _extends$X({}, ownerState.variant === 'outlined' && {
  backgroundColor: 'transparent',
  border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: (theme.vars || theme).palette.action.hover
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`& .${chipClasses$1.avatar}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.icon}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${chipClasses$1.deleteIconSmall}`]: {
    marginRight: 3
  }
}, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
  color: (theme.vars || theme).palette[ownerState.color].main,
  border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : alpha_1(theme.palette[ownerState.color].main, 0.7)}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha_1(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : alpha_1(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : alpha_1(theme.palette[ownerState.color].main, 0.7),
    '&:hover, &:active': {
      color: (theme.vars || theme).palette[ownerState.color].main
    }
  }
}));
const ChipLabel = styled$2('span', {
  name: 'MuiChip',
  slot: 'Label',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      size
    } = ownerState;
    return [styles.label, styles[`label${capitalize$1(size)}`]];
  }
})(({
  ownerState
}) => _extends$X({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: 'nowrap'
}, ownerState.variant === 'outlined' && {
  paddingLeft: 11,
  paddingRight: 11
}, ownerState.size === 'small' && {
  paddingLeft: 8,
  paddingRight: 8
}, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
  paddingLeft: 7,
  paddingRight: 7
}));
function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}

/**
 * Chips represent complex entities in small blocks, such as a contact.
 */
const Chip = /*#__PURE__*/React$1.forwardRef(function Chip(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiChip'
  });
  const {
      avatar: avatarProp,
      className,
      clickable: clickableProp,
      color = 'default',
      component: ComponentProp,
      deleteIcon: deleteIconProp,
      disabled = false,
      icon: iconProp,
      label,
      onClick,
      onDelete,
      onKeyDown,
      onKeyUp,
      size = 'medium',
      variant = 'filled',
      tabIndex,
      skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$Y);
  const chipRef = React$1.useRef(null);
  const handleRef = useForkRef(chipRef, ref);
  const handleDeleteIconClick = event => {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();
    if (onDelete) {
      onDelete(event);
    }
  };
  const handleKeyDown = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // Will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  const handleKeyUp = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }
    if (onKeyUp) {
      onKeyUp(event);
    }
  };
  const clickable = clickableProp !== false && onClick ? true : clickableProp;
  const component = clickable || onDelete ? ButtonBase$1 : ComponentProp || 'div';
  const ownerState = _extends$X({}, props, {
    component,
    disabled,
    size,
    color,
    iconColor: /*#__PURE__*/React$1.isValidElement(iconProp) ? iconProp.props.color || color : color,
    onDelete: !!onDelete,
    clickable,
    variant
  });
  const classes = useUtilityClasses$R(ownerState);
  const moreProps = component === ButtonBase$1 ? _extends$X({
    component: ComponentProp || 'div',
    focusVisibleClassName: classes.focusVisible
  }, onDelete && {
    disableRipple: true
  }) : {};
  let deleteIcon = null;
  if (onDelete) {
    deleteIcon = deleteIconProp && /*#__PURE__*/React$1.isValidElement(deleteIconProp) ? ( /*#__PURE__*/React$1.cloneElement(deleteIconProp, {
      className: clsx(deleteIconProp.props.className, classes.deleteIcon),
      onClick: handleDeleteIconClick
    })) : /*#__PURE__*/jsxRuntimeExports.jsx(CancelIcon, {
      className: clsx(classes.deleteIcon),
      onClick: handleDeleteIconClick
    });
  }
  let avatar = null;
  if (avatarProp && /*#__PURE__*/React$1.isValidElement(avatarProp)) {
    avatar = /*#__PURE__*/React$1.cloneElement(avatarProp, {
      className: clsx(classes.avatar, avatarProp.props.className)
    });
  }
  let icon = null;
  if (iconProp && /*#__PURE__*/React$1.isValidElement(iconProp)) {
    icon = /*#__PURE__*/React$1.cloneElement(iconProp, {
      className: clsx(classes.icon, iconProp.props.className)
    });
  }
  if (process.env.NODE_ENV !== 'production') {
    if (avatar && icon) {
      console.error('MUI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }
  return /*#__PURE__*/jsxRuntimeExports.jsxs(ChipRoot, _extends$X({
    as: component,
    className: clsx(classes.root, className),
    disabled: clickable && disabled ? true : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef,
    tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
    ownerState: ownerState
  }, moreProps, other, {
    children: [avatar || icon, /*#__PURE__*/jsxRuntimeExports.jsx(ChipLabel, {
      className: clsx(classes.label),
      ownerState: ownerState,
      children: label
    }), deleteIcon]
  }));
});
process.env.NODE_ENV !== "production" ? Chip.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: PropTypes.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: PropTypes.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Icon element.
   */
  icon: PropTypes.element,
  /**
   * The content of the component.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  tabIndex: PropTypes.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['filled', 'outlined']), PropTypes.string])
} : void 0;
var Chip$1 = Chip;

const _excluded$X = ["onChange", "maxRows", "minRows", "style", "value"];
function getStyleValue(value) {
  return parseInt(value, 10) || 0;
}
const styles$2 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
function isEmpty$1(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}

/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */
const TextareaAutosize = /*#__PURE__*/React$1.forwardRef(function TextareaAutosize(props, forwardedRef) {
  const {
      onChange,
      maxRows,
      minRows = 1,
      style,
      value
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$X);
  const {
    current: isControlled
  } = React$1.useRef(value != null);
  const inputRef = React$1.useRef(null);
  const handleRef = useForkRef(forwardedRef, inputRef);
  const heightRef = React$1.useRef(null);
  const shadowRef = React$1.useRef(null);
  const calculateTextareaStyles = React$1.useCallback(() => {
    const input = inputRef.current;
    const containerWindow = ownerWindow(input);
    const computedStyle = containerWindow.getComputedStyle(input);

    // If input's width is shrunk and it's not visible, don't sync height.
    if (computedStyle.width === '0px') {
      return {
        outerHeightStyle: 0,
        overflowing: false
      };
    }
    const inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';
    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }
    const boxSizing = computedStyle.boxSizing;
    const padding = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
    const border = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);

    // The height of the inner content
    const innerHeight = inputShallow.scrollHeight;

    // Measure height of a textarea with a single row
    inputShallow.value = 'x';
    const singleRowHeight = inputShallow.scrollHeight;

    // The height of the outer content
    let outerHeight = innerHeight;
    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }
    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }
    outerHeight = Math.max(outerHeight, singleRowHeight);

    // Take the box sizing into account for applying this value as a style.
    const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
    return {
      outerHeightStyle,
      overflowing
    };
  }, [maxRows, minRows, props.placeholder]);
  const syncHeight = React$1.useCallback(() => {
    const textareaStyles = calculateTextareaStyles();
    if (isEmpty$1(textareaStyles)) {
      return;
    }
    const outerHeightStyle = textareaStyles.outerHeightStyle;
    const input = inputRef.current;
    if (heightRef.current !== outerHeightStyle) {
      heightRef.current = outerHeightStyle;
      input.style.height = `${outerHeightStyle}px`;
    }
    input.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
  }, [calculateTextareaStyles]);
  useEnhancedEffect$1(() => {
    const handleResize = () => {
      syncHeight();
    };
    // Workaround a "ResizeObserver loop completed with undelivered notifications" error
    // in test.
    // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
    // Also see https://github.com/mui/mui-x/issues/8733
    let rAF;
    const rAFHandleResize = () => {
      cancelAnimationFrame(rAF);
      rAF = requestAnimationFrame(() => {
        handleResize();
      });
    };
    const debounceHandleResize = debounce$1(handleResize);
    const input = inputRef.current;
    const containerWindow = ownerWindow(input);
    containerWindow.addEventListener('resize', debounceHandleResize);
    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(process.env.NODE_ENV === 'test' ? rAFHandleResize : handleResize);
      resizeObserver.observe(input);
    }
    return () => {
      debounceHandleResize.clear();
      cancelAnimationFrame(rAF);
      containerWindow.removeEventListener('resize', debounceHandleResize);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [calculateTextareaStyles, syncHeight]);
  useEnhancedEffect$1(() => {
    syncHeight();
  });
  const handleChange = event => {
    if (!isControlled) {
      syncHeight();
    }
    if (onChange) {
      onChange(event);
    }
  };
  return /*#__PURE__*/jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/*#__PURE__*/jsxRuntimeExports.jsx("textarea", _extends$X({
      value: value,
      onChange: handleChange,
      ref: handleRef
      // Apply the rows prop to get a "correct" first SSR paint
      ,
      rows: minRows,
      style: style
    }, other)), /*#__PURE__*/jsxRuntimeExports.jsx("textarea", {
      "aria-hidden": true,
      className: props.className,
      readOnly: true,
      ref: shadowRef,
      tabIndex: -1,
      style: _extends$X({}, styles$2.shadow, style, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" ? TextareaAutosize.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  placeholder: PropTypes.string,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
} : void 0;
var TextareaAutosize$1 = TextareaAutosize;

function formControlState({
  props,
  states,
  muiFormControl
}) {
  return states.reduce((acc, state) => {
    acc[state] = props[state];
    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }
    return acc;
  }, {});
}

/**
 * @ignore - internal component.
 */
const FormControlContext = /*#__PURE__*/React$1.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}
var FormControlContext$1 = FormControlContext;

function useFormControl() {
  return React$1.useContext(FormControlContext$1);
}

function GlobalStyles(props) {
  return /*#__PURE__*/jsxRuntimeExports.jsx(GlobalStyles$1, _extends$X({}, props, {
    defaultTheme: defaultTheme$3,
    themeId: THEME_ID
  }));
}
process.env.NODE_ENV !== "production" ? GlobalStyles.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool])
} : void 0;

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
}

// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function isFilled(obj, SSR = false) {
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
}

// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
function isAdornedStart(obj) {
  return obj.startAdornment;
}

function getInputBaseUtilityClass(slot) {
  return generateUtilityClass('MuiInputBase', slot);
}
const inputBaseClasses = generateUtilityClasses('MuiInputBase', ['root', 'formControl', 'focused', 'disabled', 'adornedStart', 'adornedEnd', 'error', 'sizeSmall', 'multiline', 'colorSecondary', 'fullWidth', 'hiddenLabel', 'readOnly', 'input', 'inputSizeSmall', 'inputMultiline', 'inputTypeSearch', 'inputAdornedStart', 'inputAdornedEnd', 'inputHiddenLabel']);
var inputBaseClasses$1 = inputBaseClasses;

const _excluded$W = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"];
const rootOverridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.formControl && styles.formControl, ownerState.startAdornment && styles.adornedStart, ownerState.endAdornment && styles.adornedEnd, ownerState.error && styles.error, ownerState.size === 'small' && styles.sizeSmall, ownerState.multiline && styles.multiline, ownerState.color && styles[`color${capitalize$1(ownerState.color)}`], ownerState.fullWidth && styles.fullWidth, ownerState.hiddenLabel && styles.hiddenLabel];
};
const inputOverridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.input, ownerState.size === 'small' && styles.inputSizeSmall, ownerState.multiline && styles.inputMultiline, ownerState.type === 'search' && styles.inputTypeSearch, ownerState.startAdornment && styles.inputAdornedStart, ownerState.endAdornment && styles.inputAdornedEnd, ownerState.hiddenLabel && styles.inputHiddenLabel];
};
const useUtilityClasses$Q = ownerState => {
  const {
    classes,
    color,
    disabled,
    error,
    endAdornment,
    focused,
    formControl,
    fullWidth,
    hiddenLabel,
    multiline,
    readOnly,
    size,
    startAdornment,
    type
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$1(color)}`, disabled && 'disabled', error && 'error', fullWidth && 'fullWidth', focused && 'focused', formControl && 'formControl', size && size !== 'medium' && `size${capitalize$1(size)}`, multiline && 'multiline', startAdornment && 'adornedStart', endAdornment && 'adornedEnd', hiddenLabel && 'hiddenLabel', readOnly && 'readOnly'],
    input: ['input', disabled && 'disabled', type === 'search' && 'inputTypeSearch', multiline && 'inputMultiline', size === 'small' && 'inputSizeSmall', hiddenLabel && 'inputHiddenLabel', startAdornment && 'inputAdornedStart', endAdornment && 'inputAdornedEnd', readOnly && 'readOnly']
  };
  return composeClasses$1(slots, getInputBaseUtilityClass, classes);
};
const InputBaseRoot = styled$2('div', {
  name: 'MuiInputBase',
  slot: 'Root',
  overridesResolver: rootOverridesResolver
})(({
  theme,
  ownerState
}) => _extends$X({}, theme.typography.body1, {
  color: (theme.vars || theme).palette.text.primary,
  lineHeight: '1.4375em',
  // 23px
  boxSizing: 'border-box',
  // Prevent padding issue with fullWidth.
  position: 'relative',
  cursor: 'text',
  display: 'inline-flex',
  alignItems: 'center',
  [`&.${inputBaseClasses$1.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled,
    cursor: 'default'
  }
}, ownerState.multiline && _extends$X({
  padding: '4px 0 5px'
}, ownerState.size === 'small' && {
  paddingTop: 1
}), ownerState.fullWidth && {
  width: '100%'
}));
const InputBaseComponent = styled$2('input', {
  name: 'MuiInputBase',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  const placeholder = _extends$X({
    color: 'currentColor'
  }, theme.vars ? {
    opacity: theme.vars.opacity.inputPlaceholder
  } : {
    opacity: light ? 0.42 : 0.5
  }, {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  });
  const placeholderHidden = {
    opacity: '0 !important'
  };
  const placeholderVisible = theme.vars ? {
    opacity: theme.vars.opacity.inputPlaceholder
  } : {
    opacity: light ? 0.42 : 0.5
  };
  return _extends$X({
    font: 'inherit',
    letterSpacing: 'inherit',
    color: 'currentColor',
    padding: '4px 0 5px',
    border: 0,
    boxSizing: 'content-box',
    background: 'none',
    height: '1.4375em',
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: 'transparent',
    display: 'block',
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: '100%',
    // Fix IE11 width issue
    animationName: 'mui-auto-fill-cancel',
    animationDuration: '10ms',
    '&::-webkit-input-placeholder': placeholder,
    '&::-moz-placeholder': placeholder,
    // Firefox 19+
    '&:-ms-input-placeholder': placeholder,
    // IE11
    '&::-ms-input-placeholder': placeholder,
    // Edge
    '&:focus': {
      outline: 0
    },
    // Reset Firefox invalid required input style
    '&:invalid': {
      boxShadow: 'none'
    },
    '&::-webkit-search-decoration': {
      // Remove the padding when type=search.
      WebkitAppearance: 'none'
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses$1.formControl} &`]: {
      '&::-webkit-input-placeholder': placeholderHidden,
      '&::-moz-placeholder': placeholderHidden,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholderHidden,
      // IE11
      '&::-ms-input-placeholder': placeholderHidden,
      // Edge
      '&:focus::-webkit-input-placeholder': placeholderVisible,
      '&:focus::-moz-placeholder': placeholderVisible,
      // Firefox 19+
      '&:focus:-ms-input-placeholder': placeholderVisible,
      // IE11
      '&:focus::-ms-input-placeholder': placeholderVisible // Edge
    },
    [`&.${inputBaseClasses$1.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
    },
    '&:-webkit-autofill': {
      animationDuration: '5000s',
      animationName: 'mui-auto-fill'
    }
  }, ownerState.size === 'small' && {
    paddingTop: 1
  }, ownerState.multiline && {
    height: 'auto',
    resize: 'none',
    padding: 0,
    paddingTop: 0
  }, ownerState.type === 'search' && {
    // Improve type search style.
    MozAppearance: 'textfield'
  });
});
const inputGlobalStyles = /*#__PURE__*/jsxRuntimeExports.jsx(GlobalStyles, {
  styles: {
    '@keyframes mui-auto-fill': {
      from: {
        display: 'block'
      }
    },
    '@keyframes mui-auto-fill-cancel': {
      from: {
        display: 'block'
      }
    }
  }
});

/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */
const InputBase = /*#__PURE__*/React$1.forwardRef(function InputBase(inProps, ref) {
  var _slotProps$input;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiInputBase'
  });
  const {
      'aria-describedby': ariaDescribedby,
      autoComplete,
      autoFocus,
      className,
      components = {},
      componentsProps = {},
      defaultValue,
      disabled,
      disableInjectingGlobalStyles,
      endAdornment,
      fullWidth = false,
      id,
      inputComponent = 'input',
      inputProps: inputPropsProp = {},
      inputRef: inputRefProp,
      maxRows,
      minRows,
      multiline = false,
      name,
      onBlur,
      onChange,
      onClick,
      onFocus,
      onKeyDown,
      onKeyUp,
      placeholder,
      readOnly,
      renderSuffix,
      rows,
      slotProps = {},
      slots = {},
      startAdornment,
      type = 'text',
      value: valueProp
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$W);
  const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
  const {
    current: isControlled
  } = React$1.useRef(value != null);
  const inputRef = React$1.useRef();
  const handleInputRefWarning = React$1.useCallback(instance => {
    if (process.env.NODE_ENV !== 'production') {
      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
        console.error(['MUI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `ref` prop.', 'Make sure the `ref` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  const handleInputRef = useForkRef(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
  const [focused, setFocused] = React$1.useState(false);
  const muiFormControl = useFormControl();
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$1.useEffect(() => {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }
      return undefined;
    }, [muiFormControl]);
  }
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'size', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused;

  // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.
  React$1.useEffect(() => {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);
      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  const onFilled = muiFormControl && muiFormControl.onFilled;
  const onEmpty = muiFormControl && muiFormControl.onEmpty;
  const checkDirty = React$1.useCallback(obj => {
    if (isFilled(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect$1(() => {
    if (isControlled) {
      checkDirty({
        value
      });
    }
  }, [value, checkDirty, isControlled]);
  const handleFocus = event => {
    // Fix a bug with IE11 where the focus/blur events are triggered
    // while the component is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }
    if (onFocus) {
      onFocus(event);
    }
    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };
  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }
    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };
  const handleChange = (event, ...args) => {
    if (!isControlled) {
      const element = event.target || inputRef.current;
      if (element == null) {
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Expected valid input target. Did you use a custom \`inputComponent\` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info.` : formatMuiErrorMessage$1(1));
      }
      checkDirty({
        value: element.value
      });
    }
    if (inputPropsProp.onChange) {
      inputPropsProp.onChange(event, ...args);
    }

    // Perform in the willUpdate
    if (onChange) {
      onChange(event, ...args);
    }
  };

  // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).
  React$1.useEffect(() => {
    checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleClick = event => {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }
    if (onClick) {
      onClick(event);
    }
  };
  let InputComponent = inputComponent;
  let inputProps = inputPropsProp;
  if (multiline && InputComponent === 'input') {
    if (rows) {
      if (process.env.NODE_ENV !== 'production') {
        if (minRows || maxRows) {
          console.warn('MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set.');
        }
      }
      inputProps = _extends$X({
        type: undefined,
        minRows: rows,
        maxRows: rows
      }, inputProps);
    } else {
      inputProps = _extends$X({
        type: undefined,
        maxRows,
        minRows
      }, inputProps);
    }
    InputComponent = TextareaAutosize$1;
  }
  const handleAutoFill = event => {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };
  React$1.useEffect(() => {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  const ownerState = _extends$X({}, props, {
    color: fcs.color || 'primary',
    disabled: fcs.disabled,
    endAdornment,
    error: fcs.error,
    focused: fcs.focused,
    formControl: muiFormControl,
    fullWidth,
    hiddenLabel: fcs.hiddenLabel,
    multiline,
    size: fcs.size,
    startAdornment,
    type
  });
  const classes = useUtilityClasses$Q(ownerState);
  const Root = slots.root || components.Root || InputBaseRoot;
  const rootProps = slotProps.root || componentsProps.root || {};
  const Input = slots.input || components.Input || InputBaseComponent;
  inputProps = _extends$X({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
  return /*#__PURE__*/jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [!disableInjectingGlobalStyles && inputGlobalStyles, /*#__PURE__*/jsxRuntimeExports.jsxs(Root, _extends$X({}, rootProps, !isHostComponent(Root) && {
      ownerState: _extends$X({}, ownerState, rootProps.ownerState)
    }, {
      ref: ref,
      onClick: handleClick
    }, other, {
      className: clsx(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
      children: [startAdornment, /*#__PURE__*/jsxRuntimeExports.jsx(FormControlContext$1.Provider, {
        value: null,
        children: /*#__PURE__*/jsxRuntimeExports.jsx(Input, _extends$X({
          ownerState: ownerState,
          "aria-invalid": fcs.error,
          "aria-describedby": ariaDescribedby,
          autoComplete: autoComplete,
          autoFocus: autoFocus,
          defaultValue: defaultValue,
          disabled: fcs.disabled,
          id: id,
          onAnimationStart: handleAutoFill,
          name: name,
          placeholder: placeholder,
          readOnly: readOnly,
          required: fcs.required,
          rows: rows,
          value: value,
          onKeyDown: onKeyDown,
          onKeyUp: onKeyUp,
          type: type
        }, inputProps, !isHostComponent(Input) && {
          as: InputComponent,
          ownerState: _extends$X({}, ownerState, inputProps.ownerState)
        }, {
          ref: handleInputRef,
          className: clsx(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
          onBlur: handleBlur,
          onChange: handleChange,
          onFocus: handleFocus
        }))
      }), endAdornment, renderSuffix ? renderSuffix(_extends$X({}, fcs, {
        startAdornment
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" ? InputBase.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  'aria-describedby': PropTypes.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: elementTypeAcceptingRef$1,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(['dense', 'none']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The size of the component.
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
var InputBase$1 = InputBase;

function getInputUtilityClass(slot) {
  return generateUtilityClass('MuiInput', slot);
}
const inputClasses = _extends$X({}, inputBaseClasses$1, generateUtilityClasses('MuiInput', ['root', 'underline', 'input']));
var inputClasses$1 = inputClasses;

function getOutlinedInputUtilityClass(slot) {
  return generateUtilityClass('MuiOutlinedInput', slot);
}
const outlinedInputClasses = _extends$X({}, inputBaseClasses$1, generateUtilityClasses('MuiOutlinedInput', ['root', 'notchedOutline', 'input']));
var outlinedInputClasses$1 = outlinedInputClasses;

function getFilledInputUtilityClass(slot) {
  return generateUtilityClass('MuiFilledInput', slot);
}
const filledInputClasses = _extends$X({}, inputBaseClasses$1, generateUtilityClasses('MuiFilledInput', ['root', 'underline', 'input']));
var filledInputClasses$1 = filledInputClasses;

var ArrowDropDownIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

function getAutocompleteUtilityClass(slot) {
  return generateUtilityClass('MuiAutocomplete', slot);
}
const autocompleteClasses = generateUtilityClasses('MuiAutocomplete', ['root', 'expanded', 'fullWidth', 'focused', 'focusVisible', 'tag', 'tagSizeSmall', 'tagSizeMedium', 'hasPopupIcon', 'hasClearIcon', 'inputRoot', 'input', 'inputFocused', 'endAdornment', 'clearIndicator', 'popupIndicator', 'popupIndicatorOpen', 'popper', 'popperDisablePortal', 'paper', 'listbox', 'loading', 'noOptions', 'option', 'groupLabel', 'groupUl']);
var autocompleteClasses$1 = autocompleteClasses;

var _ClearIcon, _ArrowDropDownIcon;
const _excluded$V = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionKey", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "readOnly", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "slotProps", "value"],
  _excluded2$5 = ["ref"],
  _excluded3$1 = ["key"],
  _excluded4 = ["key"];
const useUtilityClasses$P = ownerState => {
  const {
    classes,
    disablePortal,
    expanded,
    focused,
    fullWidth,
    hasClearIcon,
    hasPopupIcon,
    inputFocused,
    popupOpen,
    size
  } = ownerState;
  const slots = {
    root: ['root', expanded && 'expanded', focused && 'focused', fullWidth && 'fullWidth', hasClearIcon && 'hasClearIcon', hasPopupIcon && 'hasPopupIcon'],
    inputRoot: ['inputRoot'],
    input: ['input', inputFocused && 'inputFocused'],
    tag: ['tag', `tagSize${capitalize$1(size)}`],
    endAdornment: ['endAdornment'],
    clearIndicator: ['clearIndicator'],
    popupIndicator: ['popupIndicator', popupOpen && 'popupIndicatorOpen'],
    popper: ['popper', disablePortal && 'popperDisablePortal'],
    paper: ['paper'],
    listbox: ['listbox'],
    loading: ['loading'],
    noOptions: ['noOptions'],
    option: ['option'],
    groupLabel: ['groupLabel'],
    groupUl: ['groupUl']
  };
  return composeClasses$1(slots, getAutocompleteUtilityClass, classes);
};
const AutocompleteRoot = styled$2('div', {
  name: 'MuiAutocomplete',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      fullWidth,
      hasClearIcon,
      hasPopupIcon,
      inputFocused,
      size
    } = ownerState;
    return [{
      [`& .${autocompleteClasses$1.tag}`]: styles.tag
    }, {
      [`& .${autocompleteClasses$1.tag}`]: styles[`tagSize${capitalize$1(size)}`]
    }, {
      [`& .${autocompleteClasses$1.inputRoot}`]: styles.inputRoot
    }, {
      [`& .${autocompleteClasses$1.input}`]: styles.input
    }, {
      [`& .${autocompleteClasses$1.input}`]: inputFocused && styles.inputFocused
    }, styles.root, fullWidth && styles.fullWidth, hasPopupIcon && styles.hasPopupIcon, hasClearIcon && styles.hasClearIcon];
  }
})({
  [`&.${autocompleteClasses$1.focused} .${autocompleteClasses$1.clearIndicator}`]: {
    visibility: 'visible'
  },
  /* Avoid double tap issue on iOS */
  '@media (pointer: fine)': {
    [`&:hover .${autocompleteClasses$1.clearIndicator}`]: {
      visibility: 'visible'
    }
  },
  [`& .${autocompleteClasses$1.tag}`]: {
    margin: 3,
    maxWidth: 'calc(100% - 6px)'
  },
  [`& .${autocompleteClasses$1.inputRoot}`]: {
    [`.${autocompleteClasses$1.hasPopupIcon}&, .${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 26 + 4
    },
    [`.${autocompleteClasses$1.hasPopupIcon}.${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 52 + 4
    },
    [`& .${autocompleteClasses$1.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${inputClasses$1.root}`]: {
    paddingBottom: 1,
    '& .MuiInput-input': {
      padding: '4px 4px 4px 0px'
    }
  },
  [`& .${inputClasses$1.root}.${inputBaseClasses$1.sizeSmall}`]: {
    [`& .${inputClasses$1.input}`]: {
      padding: '2px 4px 3px 0'
    }
  },
  [`& .${outlinedInputClasses$1.root}`]: {
    padding: 9,
    [`.${autocompleteClasses$1.hasPopupIcon}&, .${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 26 + 4 + 9
    },
    [`.${autocompleteClasses$1.hasPopupIcon}.${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 52 + 4 + 9
    },
    [`& .${autocompleteClasses$1.input}`]: {
      padding: '7.5px 4px 7.5px 5px'
    },
    [`& .${autocompleteClasses$1.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${outlinedInputClasses$1.root}.${inputBaseClasses$1.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${autocompleteClasses$1.input}`]: {
      padding: '2.5px 4px 2.5px 8px'
    }
  },
  [`& .${filledInputClasses$1.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${autocompleteClasses$1.hasPopupIcon}&, .${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 26 + 4 + 9
    },
    [`.${autocompleteClasses$1.hasPopupIcon}.${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 52 + 4 + 9
    },
    [`& .${filledInputClasses$1.input}`]: {
      padding: '7px 4px'
    },
    [`& .${autocompleteClasses$1.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${filledInputClasses$1.root}.${inputBaseClasses$1.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${filledInputClasses$1.input}`]: {
      padding: '2.5px 4px'
    }
  },
  [`& .${inputBaseClasses$1.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${filledInputClasses$1.root}.${inputBaseClasses$1.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${autocompleteClasses$1.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${filledInputClasses$1.root}.${inputBaseClasses$1.hiddenLabel}.${inputBaseClasses$1.sizeSmall}`]: {
    [`& .${autocompleteClasses$1.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${autocompleteClasses$1.input}`]: {
    flexGrow: 1,
    textOverflow: 'ellipsis',
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: true
    },
    style: {
      width: '100%'
    }
  }, {
    props: {
      size: 'small'
    },
    style: {
      [`& .${autocompleteClasses$1.tag}`]: {
        margin: 2,
        maxWidth: 'calc(100% - 4px)'
      }
    }
  }, {
    props: {
      inputFocused: true
    },
    style: {
      [`& .${autocompleteClasses$1.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: true
    },
    style: {
      [`& .${autocompleteClasses$1.inputRoot}`]: {
        flexWrap: 'wrap'
      }
    }
  }]
});
const AutocompleteEndAdornment = styled$2('div', {
  name: 'MuiAutocomplete',
  slot: 'EndAdornment',
  overridesResolver: (props, styles) => styles.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translate(0, -50%)'
});
const AutocompleteClearIndicator = styled$2(IconButton$1, {
  name: 'MuiAutocomplete',
  slot: 'ClearIndicator',
  overridesResolver: (props, styles) => styles.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: 'hidden'
});
const AutocompletePopupIndicator = styled$2(IconButton$1, {
  name: 'MuiAutocomplete',
  slot: 'PopupIndicator',
  overridesResolver: ({
    ownerState
  }, styles) => _extends$X({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: true
    },
    style: {
      transform: 'rotate(180deg)'
    }
  }]
});
const AutocompletePopper = styled$2(Popper$1, {
  name: 'MuiAutocomplete',
  slot: 'Popper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${autocompleteClasses$1.option}`]: styles.option
    }, styles.popper, ownerState.disablePortal && styles.popperDisablePortal];
  }
})(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.modal,
  variants: [{
    props: {
      disablePortal: true
    },
    style: {
      position: 'absolute'
    }
  }]
}));
const AutocompletePaper = styled$2(Paper$1, {
  name: 'MuiAutocomplete',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})(({
  theme
}) => _extends$X({}, theme.typography.body1, {
  overflow: 'auto'
}));
const AutocompleteLoading = styled$2('div', {
  name: 'MuiAutocomplete',
  slot: 'Loading',
  overridesResolver: (props, styles) => styles.loading
})(({
  theme
}) => ({
  color: (theme.vars || theme).palette.text.secondary,
  padding: '14px 16px'
}));
const AutocompleteNoOptions = styled$2('div', {
  name: 'MuiAutocomplete',
  slot: 'NoOptions',
  overridesResolver: (props, styles) => styles.noOptions
})(({
  theme
}) => ({
  color: (theme.vars || theme).palette.text.secondary,
  padding: '14px 16px'
}));
const AutocompleteListbox = styled$2('div', {
  name: 'MuiAutocomplete',
  slot: 'Listbox',
  overridesResolver: (props, styles) => styles.listbox
})(({
  theme
}) => ({
  listStyle: 'none',
  margin: 0,
  padding: '8px 0',
  maxHeight: '40vh',
  overflow: 'auto',
  position: 'relative',
  [`& .${autocompleteClasses$1.option}`]: {
    minHeight: 48,
    display: 'flex',
    overflow: 'hidden',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    paddingTop: 6,
    boxSizing: 'border-box',
    outline: '0',
    WebkitTapHighlightColor: 'transparent',
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [theme.breakpoints.up('sm')]: {
      minHeight: 'auto'
    },
    [`&.${autocompleteClasses$1.focused}`]: {
      backgroundColor: (theme.vars || theme).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (theme.vars || theme).palette.action.disabledOpacity,
      pointerEvents: 'none'
    },
    [`&.${autocompleteClasses$1.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      [`&.${autocompleteClasses$1.focused}`]: {
        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: (theme.vars || theme).palette.action.selected
        }
      },
      [`&.${autocompleteClasses$1.focusVisible}`]: {
        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
      }
    }
  }
}));
const AutocompleteGroupLabel = styled$2(ListSubheader$1, {
  name: 'MuiAutocomplete',
  slot: 'GroupLabel',
  overridesResolver: (props, styles) => styles.groupLabel
})(({
  theme
}) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
  top: -8
}));
const AutocompleteGroupUl = styled$2('ul', {
  name: 'MuiAutocomplete',
  slot: 'GroupUl',
  overridesResolver: (props, styles) => styles.groupUl
})({
  padding: 0,
  [`& .${autocompleteClasses$1.option}`]: {
    paddingLeft: 24
  }
});
const Autocomplete = /*#__PURE__*/React$1.forwardRef(function Autocomplete(inProps, ref) {
  var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiAutocomplete'
  });

  /* eslint-disable @typescript-eslint/no-unused-vars */
  const {
      autoComplete = false,
      autoHighlight = false,
      autoSelect = false,
      blurOnSelect = false,
      ChipProps,
      className,
      clearIcon = _ClearIcon || (_ClearIcon = /*#__PURE__*/jsxRuntimeExports.jsx(ClearIcon, {
        fontSize: "small"
      })),
      clearOnBlur = !props.freeSolo,
      clearOnEscape = false,
      clearText = 'Clear',
      closeText = 'Close',
      componentsProps = {},
      defaultValue = props.multiple ? [] : null,
      disableClearable = false,
      disableCloseOnSelect = false,
      disabled = false,
      disabledItemsFocusable = false,
      disableListWrap = false,
      disablePortal = false,
      filterSelectedOptions = false,
      forcePopupIcon = 'auto',
      freeSolo = false,
      fullWidth = false,
      getLimitTagsText = more => `+${more}`,
      getOptionLabel: getOptionLabelProp,
      groupBy,
      handleHomeEndKeys = !props.freeSolo,
      includeInputInList = false,
      limitTags = -1,
      ListboxComponent = 'ul',
      ListboxProps,
      loading = false,
      loadingText = 'Loading…',
      multiple = false,
      noOptionsText = 'No options',
      openOnFocus = false,
      openText = 'Open',
      PaperComponent = Paper$1,
      PopperComponent = Popper$1,
      popupIcon = _ArrowDropDownIcon || (_ArrowDropDownIcon = /*#__PURE__*/jsxRuntimeExports.jsx(ArrowDropDownIcon, {})),
      readOnly = false,
      renderGroup: renderGroupProp,
      renderInput,
      renderOption: renderOptionProp,
      renderTags,
      selectOnFocus = !props.freeSolo,
      size = 'medium',
      slotProps = {}
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$V);
  /* eslint-enable @typescript-eslint/no-unused-vars */

  const {
    getRootProps,
    getInputProps,
    getInputLabelProps,
    getPopupIndicatorProps,
    getClearProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    value,
    dirty,
    expanded,
    id,
    popupOpen,
    focused,
    focusedTag,
    anchorEl,
    setAnchorEl,
    inputValue,
    groupedOptions
  } = useAutocomplete(_extends$X({}, props, {
    componentName: 'Autocomplete'
  }));
  const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
  const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
  const {
    onMouseDown: handleInputMouseDown
  } = getInputProps();
  const {
    ref: externalListboxRef
  } = ListboxProps != null ? ListboxProps : {};
  const _getListboxProps = getListboxProps(),
    {
      ref: listboxRef
    } = _getListboxProps,
    otherListboxProps = _objectWithoutPropertiesLoose$3(_getListboxProps, _excluded2$5);
  const combinedListboxRef = useForkRef(listboxRef, externalListboxRef);
  const defaultGetOptionLabel = option => {
    var _option$label;
    return (_option$label = option.label) != null ? _option$label : option;
  };
  const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;

  // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
  const ownerState = _extends$X({}, props, {
    disablePortal,
    expanded,
    focused,
    fullWidth,
    getOptionLabel,
    hasClearIcon,
    hasPopupIcon,
    inputFocused: focusedTag === -1,
    popupOpen,
    size
  });
  const classes = useUtilityClasses$P(ownerState);
  let startAdornment;
  if (multiple && value.length > 0) {
    const getCustomizedTagProps = params => _extends$X({
      className: classes.tag,
      disabled
    }, getTagProps(params));
    if (renderTags) {
      startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
    } else {
      startAdornment = value.map((option, index) => {
        const _getCustomizedTagProp = getCustomizedTagProps({
            index
          }),
          {
            key
          } = _getCustomizedTagProp,
          customTagProps = _objectWithoutPropertiesLoose$3(_getCustomizedTagProp, _excluded3$1);
        return /*#__PURE__*/jsxRuntimeExports.jsx(Chip$1, _extends$X({
          label: getOptionLabel(option),
          size: size
        }, customTagProps, ChipProps), key);
      });
    }
  }
  if (limitTags > -1 && Array.isArray(startAdornment)) {
    const more = startAdornment.length - limitTags;
    if (!focused && more > 0) {
      startAdornment = startAdornment.splice(0, limitTags);
      startAdornment.push( /*#__PURE__*/jsxRuntimeExports.jsx("span", {
        className: classes.tag,
        children: getLimitTagsText(more)
      }, startAdornment.length));
    }
  }
  const defaultRenderGroup = params => /*#__PURE__*/jsxRuntimeExports.jsxs("li", {
    children: [/*#__PURE__*/jsxRuntimeExports.jsx(AutocompleteGroupLabel, {
      className: classes.groupLabel,
      ownerState: ownerState,
      component: "div",
      children: params.group
    }), /*#__PURE__*/jsxRuntimeExports.jsx(AutocompleteGroupUl, {
      className: classes.groupUl,
      ownerState: ownerState,
      children: params.children
    })]
  }, params.key);
  const renderGroup = renderGroupProp || defaultRenderGroup;
  const defaultRenderOption = (props2, option) => {
    // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
    const {
        key
      } = props2,
      otherProps = _objectWithoutPropertiesLoose$3(props2, _excluded4);
    return /*#__PURE__*/jsxRuntimeExports.jsx("li", _extends$X({}, otherProps, {
      children: getOptionLabel(option)
    }), key);
  };
  const renderOption = renderOptionProp || defaultRenderOption;
  const renderListOption = (option, index) => {
    const optionProps = getOptionProps({
      option,
      index
    });
    return renderOption(_extends$X({}, optionProps, {
      className: classes.option
    }), option, {
      selected: optionProps['aria-selected'],
      index,
      inputValue
    }, ownerState);
  };
  const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
  const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
  const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
  const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
  const renderAutocompletePopperChildren = children => /*#__PURE__*/jsxRuntimeExports.jsx(AutocompletePopper, _extends$X({
    as: PopperComponent,
    disablePortal: disablePortal,
    style: {
      width: anchorEl ? anchorEl.clientWidth : null
    },
    ownerState: ownerState,
    role: "presentation",
    anchorEl: anchorEl,
    open: popupOpen
  }, popperSlotProps, {
    className: clsx(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
    children: /*#__PURE__*/jsxRuntimeExports.jsx(AutocompletePaper, _extends$X({
      ownerState: ownerState,
      as: PaperComponent
    }, paperSlotProps, {
      className: clsx(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
      children: children
    }))
  }));
  let autocompletePopper = null;
  if (groupedOptions.length > 0) {
    autocompletePopper = renderAutocompletePopperChildren( /*#__PURE__*/jsxRuntimeExports.jsx(AutocompleteListbox, _extends$X({
      as: ListboxComponent,
      className: classes.listbox,
      ownerState: ownerState
    }, otherListboxProps, ListboxProps, {
      ref: combinedListboxRef,
      children: groupedOptions.map((option, index) => {
        if (groupBy) {
          return renderGroup({
            key: option.key,
            group: option.group,
            children: option.options.map((option2, index2) => renderListOption(option2, option.index + index2))
          });
        }
        return renderListOption(option, index);
      })
    })));
  } else if (loading && groupedOptions.length === 0) {
    autocompletePopper = renderAutocompletePopperChildren( /*#__PURE__*/jsxRuntimeExports.jsx(AutocompleteLoading, {
      className: classes.loading,
      ownerState: ownerState,
      children: loadingText
    }));
  } else if (groupedOptions.length === 0 && !freeSolo && !loading) {
    autocompletePopper = renderAutocompletePopperChildren( /*#__PURE__*/jsxRuntimeExports.jsx(AutocompleteNoOptions, {
      className: classes.noOptions,
      ownerState: ownerState,
      role: "presentation",
      onMouseDown: event => {
        // Prevent input blur when interacting with the "no options" content
        event.preventDefault();
      },
      children: noOptionsText
    }));
  }
  return /*#__PURE__*/jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/*#__PURE__*/jsxRuntimeExports.jsx(AutocompleteRoot, _extends$X({
      ref: ref,
      className: clsx(classes.root, className),
      ownerState: ownerState
    }, getRootProps(other), {
      children: renderInput({
        id,
        disabled,
        fullWidth: true,
        size: size === 'small' ? 'small' : undefined,
        InputLabelProps: getInputLabelProps(),
        InputProps: _extends$X({
          ref: setAnchorEl,
          className: classes.inputRoot,
          startAdornment,
          onClick: event => {
            if (event.target === event.currentTarget) {
              handleInputMouseDown(event);
            }
          }
        }, (hasClearIcon || hasPopupIcon) && {
          endAdornment: /*#__PURE__*/jsxRuntimeExports.jsxs(AutocompleteEndAdornment, {
            className: classes.endAdornment,
            ownerState: ownerState,
            children: [hasClearIcon ? /*#__PURE__*/jsxRuntimeExports.jsx(AutocompleteClearIndicator, _extends$X({}, getClearProps(), {
              "aria-label": clearText,
              title: clearText,
              ownerState: ownerState
            }, clearIndicatorSlotProps, {
              className: clsx(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
              children: clearIcon
            })) : null, hasPopupIcon ? /*#__PURE__*/jsxRuntimeExports.jsx(AutocompletePopupIndicator, _extends$X({}, getPopupIndicatorProps(), {
              disabled: disabled,
              "aria-label": popupOpen ? closeText : openText,
              title: popupOpen ? closeText : openText,
              ownerState: ownerState
            }, popupIndicatorSlotProps, {
              className: clsx(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
              children: popupIcon
            })) : null]
          })
        }),
        inputProps: _extends$X({
          className: classes.input,
          disabled,
          readOnly
        }, getInputProps())
      })
    })), anchorEl ? autocompletePopper : null]
  });
});
process.env.NODE_ENV !== "production" ? Autocomplete.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: PropTypes.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: PropTypes.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: PropTypes.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: PropTypes.oneOfType([PropTypes.oneOf(['mouse', 'touch']), PropTypes.bool]),
  /**
   * Props applied to the [`Chip`](/material-ui/api/chip/) element.
   */
  ChipProps: PropTypes.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: PropTypes.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: PropTypes.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: PropTypes.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: PropTypes.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    clearIndicator: PropTypes.object,
    paper: PropTypes.object,
    popper: PropTypes.object,
    popupIndicator: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: chainPropTypes(PropTypes.any, props => {
    if (props.multiple && props.defaultValue !== undefined && !Array.isArray(props.defaultValue)) {
      return new Error(['MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.', `However, ${props.defaultValue} was provided.`].join('\n'));
    }
    return null;
  }),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: PropTypes.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: PropTypes.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: PropTypes.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: PropTypes.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: PropTypes.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: PropTypes.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: PropTypes.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: PropTypes.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */
  groupBy: PropTypes.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: PropTypes.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: PropTypes.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: PropTypes.bool,
  /**
   * The input value.
   */
  inputValue: PropTypes.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: PropTypes.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: integerPropType,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   */
  ListboxComponent: PropTypes.elementType,
  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: PropTypes.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: PropTypes.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: PropTypes.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: PropTypes.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: PropTypes.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: PropTypes.string,
  /**
   * Array of options.
   */
  options: PropTypes.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   */
  PaperComponent: PropTypes.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   */
  PopperComponent: PropTypes.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: PropTypes.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: PropTypes.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: PropTypes.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: PropTypes.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: PropTypes.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['small', 'medium']), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    clearIndicator: PropTypes.object,
    paper: PropTypes.object,
    popper: PropTypes.object,
    popupIndicator: PropTypes.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: chainPropTypes(PropTypes.any, props => {
    if (props.multiple && props.value !== undefined && !Array.isArray(props.value)) {
      return new Error(['MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.', `However, ${props.value} was provided.`].join('\n'));
    }
    return null;
  })
} : void 0;
var Autocomplete$1 = Autocomplete;

const _excluded$U = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
const styles$1 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};

/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Fade = /*#__PURE__*/React$1.forwardRef(function Fade(props, ref) {
  const theme = useTheme$1();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = Transition$1
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$U);
  const nodeRef = React$1.useRef(null);
  const handleRef = useForkRef(nodeRef, children.ref, ref);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    reflow(node); // So the animation always start from the start.

    const transitionProps = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/jsxRuntimeExports.jsx(TransitionComponent, _extends$X({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef ,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/React$1.cloneElement(children, _extends$X({
        style: _extends$X({
          opacity: 0,
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles$1[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Fade.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
var Fade$1 = Fade;

function getBackdropUtilityClass(slot) {
  return generateUtilityClass('MuiBackdrop', slot);
}
generateUtilityClasses('MuiBackdrop', ['root', 'invisible']);

const _excluded$T = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"];
const useUtilityClasses$O = ownerState => {
  const {
    classes,
    invisible
  } = ownerState;
  const slots = {
    root: ['root', invisible && 'invisible']
  };
  return composeClasses$1(slots, getBackdropUtilityClass, classes);
};
const BackdropRoot = styled$2('div', {
  name: 'MuiBackdrop',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.invisible && styles.invisible];
  }
})(({
  ownerState
}) => _extends$X({
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitTapHighlightColor: 'transparent'
}, ownerState.invisible && {
  backgroundColor: 'transparent'
}));
const Backdrop = /*#__PURE__*/React$1.forwardRef(function Backdrop(inProps, ref) {
  var _slotProps$root, _ref, _slots$root;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiBackdrop'
  });
  const {
      children,
      className,
      component = 'div',
      components = {},
      componentsProps = {},
      invisible = false,
      open,
      slotProps = {},
      slots = {},
      TransitionComponent = Fade$1,
      transitionDuration
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$T);
  const ownerState = _extends$X({}, props, {
    component,
    invisible
  });
  const classes = useUtilityClasses$O(ownerState);
  const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
  return /*#__PURE__*/jsxRuntimeExports.jsx(TransitionComponent, _extends$X({
    in: open,
    timeout: transitionDuration
  }, other, {
    children: /*#__PURE__*/jsxRuntimeExports.jsx(BackdropRoot, _extends$X({
      "aria-hidden": true
    }, rootSlotProps, {
      as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
      className: clsx(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
      ownerState: _extends$X({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
      classes: classes,
      ref: ref,
      children: children
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Backdrop.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
var Backdrop$1 = Backdrop;

const boxClasses = generateUtilityClasses('MuiBox', ['root']);
var boxClasses$1 = boxClasses;

const defaultTheme = createTheme$1();
const Box = createBox({
  themeId: THEME_ID,
  defaultTheme,
  defaultClassName: boxClasses$1.root,
  generateClassName: ClassNameGenerator$1.generate
});
process.env.NODE_ENV !== "production" ? Box.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var Box$1 = Box;

var MoreHorizIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');

const _excluded$S = ["slots", "slotProps"];
const BreadcrumbCollapsedButton = styled$2(ButtonBase$1)(({
  theme
}) => _extends$X({
  display: 'flex',
  marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
  marginRight: `calc(${theme.spacing(1)} * 0.5)`
}, theme.palette.mode === 'light' ? {
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[700]
} : {
  backgroundColor: theme.palette.grey[700],
  color: theme.palette.grey[100]
}, {
  borderRadius: 2,
  '&:hover, &:focus': _extends$X({}, theme.palette.mode === 'light' ? {
    backgroundColor: theme.palette.grey[200]
  } : {
    backgroundColor: theme.palette.grey[600]
  }),
  '&:active': _extends$X({
    boxShadow: theme.shadows[0]
  }, theme.palette.mode === 'light' ? {
    backgroundColor: emphasize_1(theme.palette.grey[200], 0.12)
  } : {
    backgroundColor: emphasize_1(theme.palette.grey[600], 0.12)
  })
}));
const BreadcrumbCollapsedIcon = styled$2(MoreHorizIcon)({
  width: 24,
  height: 16
});

/**
 * @ignore - internal component.
 */
function BreadcrumbCollapsed(props) {
  const {
      slots = {},
      slotProps = {}
    } = props,
    otherProps = _objectWithoutPropertiesLoose$3(props, _excluded$S);
  const ownerState = props;
  return /*#__PURE__*/jsxRuntimeExports.jsx("li", {
    children: /*#__PURE__*/jsxRuntimeExports.jsx(BreadcrumbCollapsedButton, _extends$X({
      focusRipple: true
    }, otherProps, {
      ownerState: ownerState,
      children: /*#__PURE__*/jsxRuntimeExports.jsx(BreadcrumbCollapsedIcon, _extends$X({
        as: slots.CollapsedIcon,
        ownerState: ownerState
      }, slotProps.collapsedIcon))
    }))
  });
}
process.env.NODE_ENV !== "production" ? BreadcrumbCollapsed.propTypes = {
  /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */
  slotProps: PropTypes.shape({
    collapsedIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    CollapsedIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object
} : void 0;

function getBreadcrumbsUtilityClass(slot) {
  return generateUtilityClass('MuiBreadcrumbs', slot);
}
const breadcrumbsClasses = generateUtilityClasses('MuiBreadcrumbs', ['root', 'ol', 'li', 'separator']);
var breadcrumbsClasses$1 = breadcrumbsClasses;

const _excluded$R = ["children", "className", "component", "slots", "slotProps", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"];
const useUtilityClasses$N = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    li: ['li'],
    ol: ['ol'],
    separator: ['separator']
  };
  return composeClasses$1(slots, getBreadcrumbsUtilityClass, classes);
};
const BreadcrumbsRoot = styled$2(Typography$1, {
  name: 'MuiBreadcrumbs',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [{
      [`& .${breadcrumbsClasses$1.li}`]: styles.li
    }, styles.root];
  }
})({});
const BreadcrumbsOl = styled$2('ol', {
  name: 'MuiBreadcrumbs',
  slot: 'Ol',
  overridesResolver: (props, styles) => styles.ol
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: 0,
  margin: 0,
  listStyle: 'none'
});
const BreadcrumbsSeparator = styled$2('li', {
  name: 'MuiBreadcrumbs',
  slot: 'Separator',
  overridesResolver: (props, styles) => styles.separator
})({
  display: 'flex',
  userSelect: 'none',
  marginLeft: 8,
  marginRight: 8
});
function insertSeparators(items, className, separator, ownerState) {
  return items.reduce((acc, current, index) => {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/jsxRuntimeExports.jsx(BreadcrumbsSeparator, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        children: separator
      }, `separator-${index}`));
    } else {
      acc.push(current);
    }
    return acc;
  }, []);
}
const Breadcrumbs$1 = /*#__PURE__*/React$1.forwardRef(function Breadcrumbs(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiBreadcrumbs'
  });
  const {
      children,
      className,
      component = 'nav',
      slots = {},
      slotProps = {},
      expandText = 'Show path',
      itemsAfterCollapse = 1,
      itemsBeforeCollapse = 1,
      maxItems = 8,
      separator = '/'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$R);
  const [expanded, setExpanded] = React$1.useState(false);
  const ownerState = _extends$X({}, props, {
    component,
    expanded,
    expandText,
    itemsAfterCollapse,
    itemsBeforeCollapse,
    maxItems,
    separator
  });
  const classes = useUtilityClasses$N(ownerState);
  const collapsedIconSlotProps = useSlotProps({
    elementType: slots.CollapsedIcon,
    externalSlotProps: slotProps.collapsedIcon,
    ownerState
  });
  const listRef = React$1.useRef(null);
  const renderItemsBeforeAndAfter = allItems => {
    const handleClickExpand = () => {
      setExpanded(true);

      // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.
      // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
      // By moving it to some link/button at least we have some announcement.
      const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
      if (focusable) {
        focusable.focus();
      }
    };

    // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem
    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(['MUI: You have provided an invalid combination of props to the Breadcrumbs.', `itemsAfterCollapse={${itemsAfterCollapse}} + itemsBeforeCollapse={${itemsBeforeCollapse}} >= maxItems={${maxItems}}`].join('\n'));
      }
      return allItems;
    }
    return [...allItems.slice(0, itemsBeforeCollapse), /*#__PURE__*/jsxRuntimeExports.jsx(BreadcrumbCollapsed, {
      "aria-label": expandText,
      slots: {
        CollapsedIcon: slots.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: collapsedIconSlotProps
      },
      onClick: handleClickExpand
    }, "ellipsis"), ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)];
  };
  const allItems = React$1.Children.toArray(children).filter(child => {
    if (process.env.NODE_ENV !== 'production') {
      if (reactIsExports.isFragment(child)) {
        console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    return /*#__PURE__*/React$1.isValidElement(child);
  }).map((child, index) => /*#__PURE__*/jsxRuntimeExports.jsx("li", {
    className: classes.li,
    children: child
  }, `child-${index}`));
  return /*#__PURE__*/jsxRuntimeExports.jsx(BreadcrumbsRoot, _extends$X({
    ref: ref,
    component: component,
    color: "text.secondary",
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsxRuntimeExports.jsx(BreadcrumbsOl, {
      className: classes.ol,
      ref: listRef,
      ownerState: ownerState,
      children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
    })
  }));
});
process.env.NODE_ENV !== "production" ? Breadcrumbs$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Show path'
   */
  expandText: PropTypes.string,
  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */
  itemsAfterCollapse: integerPropType,
  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */
  itemsBeforeCollapse: integerPropType,
  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */
  maxItems: integerPropType,
  /**
   * Custom separator node.
   * @default '/'
   */
  separator: PropTypes.node,
  /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */
  slotProps: PropTypes.shape({
    collapsedIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    CollapsedIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var MBreadcrumbs = Breadcrumbs$1;

function getButtonUtilityClass(slot) {
  return generateUtilityClass('MuiButton', slot);
}
const buttonClasses = generateUtilityClasses('MuiButton', ['root', 'text', 'textInherit', 'textPrimary', 'textSecondary', 'textSuccess', 'textError', 'textInfo', 'textWarning', 'outlined', 'outlinedInherit', 'outlinedPrimary', 'outlinedSecondary', 'outlinedSuccess', 'outlinedError', 'outlinedInfo', 'outlinedWarning', 'contained', 'containedInherit', 'containedPrimary', 'containedSecondary', 'containedSuccess', 'containedError', 'containedInfo', 'containedWarning', 'disableElevation', 'focusVisible', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'colorSuccess', 'colorError', 'colorInfo', 'colorWarning', 'textSizeSmall', 'textSizeMedium', 'textSizeLarge', 'outlinedSizeSmall', 'outlinedSizeMedium', 'outlinedSizeLarge', 'containedSizeSmall', 'containedSizeMedium', 'containedSizeLarge', 'sizeMedium', 'sizeSmall', 'sizeLarge', 'fullWidth', 'startIcon', 'endIcon', 'icon', 'iconSizeSmall', 'iconSizeMedium', 'iconSizeLarge']);
var buttonClasses$1 = buttonClasses;

/**
 * @ignore - internal component.
 */
const ButtonGroupContext = /*#__PURE__*/React$1.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ButtonGroupContext.displayName = 'ButtonGroupContext';
}
var ButtonGroupContext$1 = ButtonGroupContext;

/**
 * @ignore - internal component.
 */
const ButtonGroupButtonContext = /*#__PURE__*/React$1.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  ButtonGroupButtonContext.displayName = 'ButtonGroupButtonContext';
}
var ButtonGroupButtonContext$1 = ButtonGroupButtonContext;

const _excluded$Q = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"];
const useUtilityClasses$M = ownerState => {
  const {
    color,
    disableElevation,
    fullWidth,
    size,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, `${variant}${capitalize$1(color)}`, `size${capitalize$1(size)}`, `${variant}Size${capitalize$1(size)}`, `color${capitalize$1(color)}`, disableElevation && 'disableElevation', fullWidth && 'fullWidth'],
    label: ['label'],
    startIcon: ['icon', 'startIcon', `iconSize${capitalize$1(size)}`],
    endIcon: ['icon', 'endIcon', `iconSize${capitalize$1(size)}`]
  };
  const composedClasses = composeClasses$1(slots, getButtonUtilityClass, classes);
  return _extends$X({}, classes, composedClasses);
};
const commonIconStyles = ownerState => _extends$X({}, ownerState.size === 'small' && {
  '& > *:nth-of-type(1)': {
    fontSize: 18
  }
}, ownerState.size === 'medium' && {
  '& > *:nth-of-type(1)': {
    fontSize: 20
  }
}, ownerState.size === 'large' && {
  '& > *:nth-of-type(1)': {
    fontSize: 22
  }
});
const ButtonRoot = styled$2(ButtonBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp$2(prop) || prop === 'classes',
  name: 'MuiButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${capitalize$1(ownerState.color)}`], styles[`size${capitalize$1(ownerState.size)}`], styles[`${ownerState.variant}Size${capitalize$1(ownerState.size)}`], ownerState.color === 'inherit' && styles.colorInherit, ownerState.disableElevation && styles.disableElevation, ownerState.fullWidth && styles.fullWidth];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$palette$getCon, _theme$palette;
  const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
  const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
  return _extends$X({}, theme.typography.button, {
    minWidth: 64,
    padding: '6px 16px',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
      duration: theme.transitions.duration.short
    }),
    '&:hover': _extends$X({
      textDecoration: 'none',
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha_1(theme.palette.text.primary, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha_1(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
      border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha_1(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'contained' && {
      backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
      boxShadow: (theme.vars || theme).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: (theme.vars || theme).shadows[2],
        backgroundColor: (theme.vars || theme).palette.grey[300]
      }
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
      }
    }),
    '&:active': _extends$X({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[8]
    }),
    [`&.${buttonClasses$1.focusVisible}`]: _extends$X({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[6]
    }),
    [`&.${buttonClasses$1.disabled}`]: _extends$X({
      color: (theme.vars || theme).palette.action.disabled
    }, ownerState.variant === 'outlined' && {
      border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
    }, ownerState.variant === 'contained' && {
      color: (theme.vars || theme).palette.action.disabled,
      boxShadow: (theme.vars || theme).shadows[0],
      backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    })
  }, ownerState.variant === 'text' && {
    padding: '6px 8px'
  }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.variant === 'outlined' && {
    padding: '5px 15px',
    border: '1px solid currentColor'
  }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main,
    border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${alpha_1(theme.palette[ownerState.color].main, 0.5)}`
  }, ownerState.variant === 'contained' && {
    color: theme.vars ?
    // this is safe because grey does not change between default light/dark mode
    theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
    backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
    boxShadow: (theme.vars || theme).shadows[2]
  }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].contrastText,
    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.color === 'inherit' && {
    color: 'inherit',
    borderColor: 'currentColor'
  }, ownerState.size === 'small' && ownerState.variant === 'text' && {
    padding: '4px 5px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'text' && {
    padding: '8px 11px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
    padding: '3px 9px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
    padding: '7px 21px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
    padding: '4px 10px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
    padding: '8px 22px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.fullWidth && {
    width: '100%'
  });
}, ({
  ownerState
}) => ownerState.disableElevation && {
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none'
  },
  [`&.${buttonClasses$1.focusVisible}`]: {
    boxShadow: 'none'
  },
  '&:active': {
    boxShadow: 'none'
  },
  [`&.${buttonClasses$1.disabled}`]: {
    boxShadow: 'none'
  }
});
const ButtonStartIcon = styled$2('span', {
  name: 'MuiButton',
  slot: 'StartIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.startIcon, styles[`iconSize${capitalize$1(ownerState.size)}`]];
  }
})(({
  ownerState
}) => _extends$X({
  display: 'inherit',
  marginRight: 8,
  marginLeft: -4
}, ownerState.size === 'small' && {
  marginLeft: -2
}, commonIconStyles(ownerState)));
const ButtonEndIcon = styled$2('span', {
  name: 'MuiButton',
  slot: 'EndIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.endIcon, styles[`iconSize${capitalize$1(ownerState.size)}`]];
  }
})(({
  ownerState
}) => _extends$X({
  display: 'inherit',
  marginRight: -4,
  marginLeft: 8
}, ownerState.size === 'small' && {
  marginRight: -2
}, commonIconStyles(ownerState)));
const Button$1 = /*#__PURE__*/React$1.forwardRef(function Button(inProps, ref) {
  // props priority: `inProps` > `contextProps` > `themeDefaultProps`
  const contextProps = React$1.useContext(ButtonGroupContext$1);
  const buttonGroupButtonContextPositionClassName = React$1.useContext(ButtonGroupButtonContext$1);
  const resolvedProps = resolveProps(contextProps, inProps);
  const props = useDefaultProps({
    props: resolvedProps,
    name: 'MuiButton'
  });
  const {
      children,
      color = 'primary',
      component = 'button',
      className,
      disabled = false,
      disableElevation = false,
      disableFocusRipple = false,
      endIcon: endIconProp,
      focusVisibleClassName,
      fullWidth = false,
      size = 'medium',
      startIcon: startIconProp,
      type,
      variant = 'text'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$Q);
  const ownerState = _extends$X({}, props, {
    color,
    component,
    disabled,
    disableElevation,
    disableFocusRipple,
    fullWidth,
    size,
    type,
    variant
  });
  const classes = useUtilityClasses$M(ownerState);
  const startIcon = startIconProp && /*#__PURE__*/jsxRuntimeExports.jsx(ButtonStartIcon, {
    className: classes.startIcon,
    ownerState: ownerState,
    children: startIconProp
  });
  const endIcon = endIconProp && /*#__PURE__*/jsxRuntimeExports.jsx(ButtonEndIcon, {
    className: classes.endIcon,
    ownerState: ownerState,
    children: endIconProp
  });
  const positionClassName = buttonGroupButtonContextPositionClassName || '';
  return /*#__PURE__*/jsxRuntimeExports.jsxs(ButtonRoot, _extends$X({
    ownerState: ownerState,
    className: clsx(contextProps.className, classes.root, className, positionClassName),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other, {
    classes: classes,
    children: [startIcon, children, endIcon]
  }));
});
process.env.NODE_ENV !== "production" ? Button$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning']), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['small', 'medium', 'large']), PropTypes.string]),
  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['contained', 'outlined', 'text']), PropTypes.string])
} : void 0;
var MuiButton = Button$1;

function getSwitchBaseUtilityClass(slot) {
  return generateUtilityClass('PrivateSwitchBase', slot);
}
generateUtilityClasses('PrivateSwitchBase', ['root', 'checked', 'disabled', 'input', 'edgeStart', 'edgeEnd']);

const _excluded$P = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"];
const useUtilityClasses$L = ownerState => {
  const {
    classes,
    checked,
    disabled,
    edge
  } = ownerState;
  const slots = {
    root: ['root', checked && 'checked', disabled && 'disabled', edge && `edge${capitalize$1(edge)}`],
    input: ['input']
  };
  return composeClasses$1(slots, getSwitchBaseUtilityClass, classes);
};
const SwitchBaseRoot = styled$2(ButtonBase$1)(({
  ownerState
}) => _extends$X({
  padding: 9,
  borderRadius: '50%'
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}));
const SwitchBaseInput = styled$2('input', {
  shouldForwardProp: rootShouldForwardProp$2
})({
  cursor: 'inherit',
  position: 'absolute',
  opacity: 0,
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
});

/**
 * @ignore - internal component.
 */
const SwitchBase = /*#__PURE__*/React$1.forwardRef(function SwitchBase(props, ref) {
  const {
      autoFocus,
      checked: checkedProp,
      checkedIcon,
      className,
      defaultChecked,
      disabled: disabledProp,
      disableFocusRipple = false,
      edge = false,
      icon,
      id,
      inputProps,
      inputRef,
      name,
      onBlur,
      onChange,
      onFocus,
      readOnly,
      required = false,
      tabIndex,
      type,
      value
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$P);
  const [checked, setCheckedState] = useControlled({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  });
  const muiFormControl = useFormControl();
  const handleFocus = event => {
    if (onFocus) {
      onFocus(event);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };
  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };
  const handleInputChange = event => {
    // Workaround for https://github.com/facebook/react/issues/9023
    if (event.nativeEvent.defaultPrevented) {
      return;
    }
    const newChecked = event.target.checked;
    setCheckedState(newChecked);
    if (onChange) {
      // TODO v6: remove the second argument.
      onChange(event, newChecked);
    }
  };
  let disabled = disabledProp;
  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }
  const hasLabelFor = type === 'checkbox' || type === 'radio';
  const ownerState = _extends$X({}, props, {
    checked,
    disabled,
    disableFocusRipple,
    edge
  });
  const classes = useUtilityClasses$L(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsxs(SwitchBaseRoot, _extends$X({
    component: "span",
    className: clsx(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/jsxRuntimeExports.jsx(SwitchBaseInput, _extends$X({
      autoFocus: autoFocus,
      checked: checkedProp,
      defaultChecked: defaultChecked,
      className: classes.input,
      disabled: disabled,
      id: hasLabelFor ? id : undefined,
      name: name,
      onChange: handleInputChange,
      readOnly: readOnly,
      ref: inputRef,
      required: required,
      ownerState: ownerState,
      tabIndex: tabIndex,
      type: type
    }, type === 'checkbox' && value === undefined ? {} : {
      value
    }, inputProps)), checked ? checkedIcon : icon]
  }));
});

// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.
process.env.NODE_ENV !== "production" ? SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(['end', 'start', false]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /*
   * @ignore
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,
  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
var SwitchBase$1 = SwitchBase;

var CheckBoxOutlineBlankIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

var CheckBoxIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

var IndeterminateCheckBoxIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

function getCheckboxUtilityClass(slot) {
  return generateUtilityClass('MuiCheckbox', slot);
}
const checkboxClasses = generateUtilityClasses('MuiCheckbox', ['root', 'checked', 'disabled', 'indeterminate', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium']);
var checkboxClasses$1 = checkboxClasses;

const _excluded$O = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"];
const useUtilityClasses$K = ownerState => {
  const {
    classes,
    indeterminate,
    color,
    size
  } = ownerState;
  const slots = {
    root: ['root', indeterminate && 'indeterminate', `color${capitalize$1(color)}`, `size${capitalize$1(size)}`]
  };
  const composedClasses = composeClasses$1(slots, getCheckboxUtilityClass, classes);
  return _extends$X({}, classes, composedClasses);
};
const CheckboxRoot = styled$2(SwitchBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp$2(prop) || prop === 'classes',
  name: 'MuiCheckbox',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.indeterminate && styles.indeterminate, styles[`size${capitalize$1(ownerState.size)}`], ownerState.color !== 'default' && styles[`color${capitalize$1(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha_1(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${checkboxClasses$1.checked}, &.${checkboxClasses$1.indeterminate}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  },
  [`&.${checkboxClasses$1.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}));
const defaultCheckedIcon$1 = /*#__PURE__*/jsxRuntimeExports.jsx(CheckBoxIcon, {});
const defaultIcon$1 = /*#__PURE__*/jsxRuntimeExports.jsx(CheckBoxOutlineBlankIcon, {});
const defaultIndeterminateIcon = /*#__PURE__*/jsxRuntimeExports.jsx(IndeterminateCheckBoxIcon, {});
const Checkbox = /*#__PURE__*/React$1.forwardRef(function Checkbox(inProps, ref) {
  var _icon$props$fontSize, _indeterminateIcon$pr;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiCheckbox'
  });
  const {
      checkedIcon = defaultCheckedIcon$1,
      color = 'primary',
      icon: iconProp = defaultIcon$1,
      indeterminate = false,
      indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon,
      inputProps,
      size = 'medium',
      className
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$O);
  const icon = indeterminate ? indeterminateIconProp : iconProp;
  const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  const ownerState = _extends$X({}, props, {
    color,
    indeterminate,
    size
  });
  const classes = useUtilityClasses$K(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(CheckboxRoot, _extends$X({
    type: "checkbox",
    inputProps: _extends$X({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/React$1.cloneElement(icon, {
      fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
    }),
    checkedIcon: /*#__PURE__*/React$1.cloneElement(indeterminateIcon, {
      fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
    }),
    ownerState: ownerState,
    ref: ref,
    className: clsx(classes.root, className)
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? Checkbox.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: PropTypes.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: PropTypes.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
var Checkbox$1 = Checkbox;

function getCircularProgressUtilityClass(slot) {
  return generateUtilityClass('MuiCircularProgress', slot);
}
generateUtilityClasses('MuiCircularProgress', ['root', 'determinate', 'indeterminate', 'colorPrimary', 'colorSecondary', 'svg', 'circle', 'circleDeterminate', 'circleIndeterminate', 'circleDisableShrink']);

const _excluded$N = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let _$2 = t => t,
  _t$2,
  _t2$2,
  _t3$2,
  _t4$2;
const SIZE = 44;
const circularRotateKeyframe = keyframes(_t$2 || (_t$2 = _$2`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const circularDashKeyframe = keyframes(_t2$2 || (_t2$2 = _$2`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const useUtilityClasses$J = ownerState => {
  const {
    classes,
    variant,
    color,
    disableShrink
  } = ownerState;
  const slots = {
    root: ['root', variant, `color${capitalize$1(color)}`],
    svg: ['svg'],
    circle: ['circle', `circle${capitalize$1(variant)}`, disableShrink && 'circleDisableShrink']
  };
  return composeClasses$1(slots, getCircularProgressUtilityClass, classes);
};
const CircularProgressRoot = styled$2('span', {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`color${capitalize$1(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => _extends$X({
  display: 'inline-block'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('transform')
}, ownerState.color !== 'inherit' && {
  color: (theme.vars || theme).palette[ownerState.color].main
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && css(_t3$2 || (_t3$2 = _$2`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe));
const CircularProgressSVG = styled$2('svg', {
  name: 'MuiCircularProgress',
  slot: 'Svg',
  overridesResolver: (props, styles) => styles.svg
})({
  display: 'block' // Keeps the progress centered
});
const CircularProgressCircle = styled$2('circle', {
  name: 'MuiCircularProgress',
  slot: 'Circle',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.circle, styles[`circle${capitalize$1(ownerState.variant)}`], ownerState.disableShrink && styles.circleDisableShrink];
  }
})(({
  ownerState,
  theme
}) => _extends$X({
  stroke: 'currentColor'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('stroke-dashoffset')
}, ownerState.variant === 'indeterminate' && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: '80px, 200px',
  strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && !ownerState.disableShrink && css(_t4$2 || (_t4$2 = _$2`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe));

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const CircularProgress = /*#__PURE__*/React$1.forwardRef(function CircularProgress(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiCircularProgress'
  });
  const {
      className,
      color = 'primary',
      disableShrink = false,
      size = 40,
      style,
      thickness = 3.6,
      value = 0,
      variant = 'indeterminate'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$N);
  const ownerState = _extends$X({}, props, {
    color,
    disableShrink,
    size,
    thickness,
    value,
    variant
  });
  const classes = useUtilityClasses$J(ownerState);
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};
  if (variant === 'determinate') {
    const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
    rootStyle.transform = 'rotate(-90deg)';
  }
  return /*#__PURE__*/jsxRuntimeExports.jsx(CircularProgressRoot, _extends$X({
    className: clsx(classes.root, className),
    style: _extends$X({
      width: size,
      height: size
    }, rootStyle, style),
    ownerState: ownerState,
    ref: ref,
    role: "progressbar"
  }, rootProps, other, {
    children: /*#__PURE__*/jsxRuntimeExports.jsx(CircularProgressSVG, {
      className: classes.svg,
      ownerState: ownerState,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: /*#__PURE__*/jsxRuntimeExports.jsx(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState: ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })
    })
  }));
});
process.env.NODE_ENV !== "production" ? CircularProgress.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: chainPropTypes(PropTypes.bool, props => {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('MUI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }
    return null;
  }),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: PropTypes.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(['determinate', 'indeterminate'])
} : void 0;
var CircularProgress$1 = CircularProgress;

// Is a vertical scrollbar displayed?
function isOverflowing(container) {
  const doc = ownerDocument(container);
  if (doc.body === container) {
    return ownerWindow(container).innerWidth > doc.documentElement.clientWidth;
  }
  return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, show) {
  if (show) {
    element.setAttribute('aria-hidden', 'true');
  } else {
    element.removeAttribute('aria-hidden');
  }
}
function getPaddingRight(element) {
  return parseInt(ownerWindow(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
  // The forbidden HTML tags are the ones from ARIA specification that
  // can be children of body and can't have aria-hidden attribute.
  // cf. https://www.w3.org/TR/html-aria/#docconformance
  const forbiddenTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE', 'LINK', 'MAP', 'META', 'NOSCRIPT', 'PICTURE', 'COL', 'COLGROUP', 'PARAM', 'SLOT', 'SOURCE', 'TRACK'];
  const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
  const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
  return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
  const blacklist = [mountElement, currentElement, ...elementsToExclude];
  [].forEach.call(container.children, element => {
    const isNotExcludedElement = blacklist.indexOf(element) === -1;
    const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
    if (isNotExcludedElement && isNotForbiddenElement) {
      ariaHidden(element, show);
    }
  });
}
function findIndexOf(items, callback) {
  let idx = -1;
  items.some((item, index) => {
    if (callback(item)) {
      idx = index;
      return true;
    }
    return false;
  });
  return idx;
}
function handleContainer(containerInfo, props) {
  const restoreStyle = [];
  const container = containerInfo.container;
  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      const scrollbarSize = getScrollbarSize(ownerDocument(container));
      restoreStyle.push({
        value: container.style.paddingRight,
        property: 'padding-right',
        el: container
      });
      // Use computed style, here to get the real padding to add our scrollbar width.
      container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;

      // .mui-fixed is a global helper.
      const fixedElements = ownerDocument(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedElements, element => {
        restoreStyle.push({
          value: element.style.paddingRight,
          property: 'padding-right',
          el: element
        });
        element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
      });
    }
    let scrollContainer;
    if (container.parentNode instanceof DocumentFragment) {
      scrollContainer = ownerDocument(container).body;
    } else {
      // Support html overflow-y: auto for scroll stability between pages
      // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
      const parent = container.parentElement;
      const containerWindow = ownerWindow(container);
      scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
    }

    // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.
    restoreStyle.push({
      value: scrollContainer.style.overflow,
      property: 'overflow',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowX,
      property: 'overflow-x',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowY,
      property: 'overflow-y',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }
  const restore = () => {
    restoreStyle.forEach(({
      value,
      el,
      property
    }) => {
      if (value) {
        el.style.setProperty(property, value);
      } else {
        el.style.removeProperty(property);
      }
    });
  };
  return restore;
}
function getHiddenSiblings(container) {
  const hiddenSiblings = [];
  [].forEach.call(container.children, element => {
    if (element.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(element);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
class ModalManager {
  constructor() {
    this.containers = void 0;
    this.modals = void 0;
    this.modals = [];
    this.containers = [];
  }
  add(modal, container) {
    let modalIndex = this.modals.indexOf(modal);
    if (modalIndex !== -1) {
      return modalIndex;
    }
    modalIndex = this.modals.length;
    this.modals.push(modal);

    // If the modal we are adding is already in the DOM.
    if (modal.modalRef) {
      ariaHidden(modal.modalRef, false);
    }
    const hiddenSiblings = getHiddenSiblings(container);
    ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
    const containerIndex = findIndexOf(this.containers, item => item.container === container);
    if (containerIndex !== -1) {
      this.containers[containerIndex].modals.push(modal);
      return modalIndex;
    }
    this.containers.push({
      modals: [modal],
      container,
      restore: null,
      hiddenSiblings
    });
    return modalIndex;
  }
  mount(modal, props) {
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    if (!containerInfo.restore) {
      containerInfo.restore = handleContainer(containerInfo, props);
    }
  }
  remove(modal, ariaHiddenState = true) {
    const modalIndex = this.modals.indexOf(modal);
    if (modalIndex === -1) {
      return modalIndex;
    }
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
    this.modals.splice(modalIndex, 1);

    // If that was the last modal in a container, clean up the container.
    if (containerInfo.modals.length === 0) {
      // The modal might be closed before it had the chance to be mounted in the DOM.
      if (containerInfo.restore) {
        containerInfo.restore();
      }
      if (modal.modalRef) {
        // In case the modal wasn't in the DOM yet.
        ariaHidden(modal.modalRef, ariaHiddenState);
      }
      ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
      this.containers.splice(containerIndex, 1);
    } else {
      // Otherwise make sure the next top modal is visible to a screen reader.
      const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
      // as soon as a modal is adding its modalRef is undefined. it can't set
      // aria-hidden because the dom element doesn't exist either
      // when modal was unmounted before modalRef gets null
      if (nextTop.modalRef) {
        ariaHidden(nextTop.modalRef, false);
      }
    }
    return modalIndex;
  }
  isTopModal(modal) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
  }
}

// Inspired by https://github.com/focus-trap/tabbable
const candidatesSelector = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'].join(',');
function getTabIndex(node) {
  const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
  if (!Number.isNaN(tabindexAttr)) {
    return tabindexAttr;
  }

  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.
  if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }
  return node.tabIndex;
}
function isNonTabbableRadio(node) {
  if (node.tagName !== 'INPUT' || node.type !== 'radio') {
    return false;
  }
  if (!node.name) {
    return false;
  }
  const getRadio = selector => node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
  let roving = getRadio(`[name="${node.name}"]:checked`);
  if (!roving) {
    roving = getRadio(`[name="${node.name}"]`);
  }
  return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
  if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) {
    return false;
  }
  return true;
}
function defaultGetTabbable(root) {
  const regularTabNodes = [];
  const orderedTabNodes = [];
  Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i) => {
    const nodeTabIndex = getTabIndex(node);
    if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
      return;
    }
    if (nodeTabIndex === 0) {
      regularTabNodes.push(node);
    } else {
      orderedTabNodes.push({
        documentOrder: i,
        tabIndex: nodeTabIndex,
        node: node
      });
    }
  });
  return orderedTabNodes.sort((a, b) => a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map(a => a.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
  return true;
}

/**
 * @ignore - internal component.
 */
function FocusTrap(props) {
  const {
    children,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableRestoreFocus = false,
    getTabbable = defaultGetTabbable,
    isEnabled = defaultIsEnabled,
    open
  } = props;
  const ignoreNextEnforceFocus = React$1.useRef(false);
  const sentinelStart = React$1.useRef(null);
  const sentinelEnd = React$1.useRef(null);
  const nodeToRestore = React$1.useRef(null);
  const reactFocusEventTarget = React$1.useRef(null);
  // This variable is useful when disableAutoFocus is true.
  // It waits for the active element to move into the component to activate.
  const activated = React$1.useRef(false);
  const rootRef = React$1.useRef(null);
  // @ts-expect-error TODO upstream fix
  const handleRef = useForkRef(children.ref, rootRef);
  const lastKeydown = React$1.useRef(null);
  React$1.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    activated.current = !disableAutoFocus;
  }, [disableAutoFocus, open]);
  React$1.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    const doc = ownerDocument(rootRef.current);
    if (!rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(['MUI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
        }
        rootRef.current.setAttribute('tabIndex', '-1');
      }
      if (activated.current) {
        rootRef.current.focus();
      }
    }
    return () => {
      // restoreLastFocus()
      if (!disableRestoreFocus) {
        // In IE11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE11 have a focus method.
        // Once IE11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          ignoreNextEnforceFocus.current = true;
          nodeToRestore.current.focus();
        }
        nodeToRestore.current = null;
      }
    };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  React$1.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    const doc = ownerDocument(rootRef.current);
    const loopFocus = nativeEvent => {
      lastKeydown.current = nativeEvent;
      if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') {
        return;
      }

      // Make sure the next tab starts from the right place.
      // doc.activeElement refers to the origin.
      if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;
        if (sentinelEnd.current) {
          sentinelEnd.current.focus();
        }
      }
    };
    const contain = () => {
      const rootElement = rootRef.current;

      // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.
      if (rootElement === null) {
        return;
      }
      if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      // The focus is already inside
      if (rootElement.contains(doc.activeElement)) {
        return;
      }

      // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
      if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) {
        return;
      }

      // if the focus event is not coming from inside the children's react tree, reset the refs
      if (doc.activeElement !== reactFocusEventTarget.current) {
        reactFocusEventTarget.current = null;
      } else if (reactFocusEventTarget.current !== null) {
        return;
      }
      if (!activated.current) {
        return;
      }
      let tabbable = [];
      if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
        tabbable = getTabbable(rootRef.current);
      }

      // one of the sentinel nodes was focused, so move the focus
      // to the first/last tabbable element inside the focus trap
      if (tabbable.length > 0) {
        var _lastKeydown$current, _lastKeydown$current2;
        const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
        const focusNext = tabbable[0];
        const focusPrevious = tabbable[tabbable.length - 1];
        if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
          if (isShiftTab) {
            focusPrevious.focus();
          } else {
            focusNext.focus();
          }
        }
        // no tabbable elements in the trap focus or the focus was outside of the focus trap
      } else {
        rootElement.focus();
      }
    };
    doc.addEventListener('focusin', contain);
    doc.addEventListener('keydown', loopFocus, true);

    // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
    // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    // Instead, we can look if the active element was restored on the BODY element.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
    const interval = setInterval(() => {
      if (doc.activeElement && doc.activeElement.tagName === 'BODY') {
        contain();
      }
    }, 50);
    return () => {
      clearInterval(interval);
      doc.removeEventListener('focusin', contain);
      doc.removeEventListener('keydown', loopFocus, true);
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);
  const onFocus = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
    reactFocusEventTarget.current = event.target;
    const childrenPropsHandler = children.props.onFocus;
    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };
  const handleFocusSentinel = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
  };
  return /*#__PURE__*/jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/*#__PURE__*/jsxRuntimeExports.jsx("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelStart,
      "data-testid": "sentinelStart"
    }), /*#__PURE__*/React$1.cloneElement(children, {
      ref: handleRef,
      onFocus
    }), /*#__PURE__*/jsxRuntimeExports.jsx("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelEnd,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" ? FocusTrap.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  FocusTrap['propTypes' + ''] = exactProp(FocusTrap.propTypes);
}

function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}
function getHasTransition(children) {
  return children ? children.props.hasOwnProperty('in') : false;
}

// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const defaultManager = new ModalManager();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */
function useModal(parameters) {
  const {
    container,
    disableEscapeKeyDown = false,
    disableScrollLock = false,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = defaultManager,
    closeAfterTransition = false,
    onTransitionEnter,
    onTransitionExited,
    children,
    onClose,
    open,
    rootRef
  } = parameters;

  // @ts-ignore internal logic
  const modal = React$1.useRef({});
  const mountNodeRef = React$1.useRef(null);
  const modalRef = React$1.useRef(null);
  const handleRef = useForkRef(modalRef, rootRef);
  const [exited, setExited] = React$1.useState(!open);
  const hasTransition = getHasTransition(children);
  let ariaHiddenProp = true;
  if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) {
    ariaHiddenProp = false;
  }
  const getDoc = () => ownerDocument(mountNodeRef.current);
  const getModal = () => {
    modal.current.modalRef = modalRef.current;
    modal.current.mount = mountNodeRef.current;
    return modal.current;
  };
  const handleMounted = () => {
    manager.mount(getModal(), {
      disableScrollLock
    });

    // Fix a bug on Chrome where the scroll isn't initially 0.
    if (modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  };
  const handleOpen = useEventCallback(() => {
    const resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer);

    // The element was already mounted.
    if (modalRef.current) {
      handleMounted();
    }
  });
  const isTopModal = React$1.useCallback(() => manager.isTopModal(getModal()), [manager]);
  const handlePortalRef = useEventCallback(node => {
    mountNodeRef.current = node;
    if (!node) {
      return;
    }
    if (open && isTopModal()) {
      handleMounted();
    } else if (modalRef.current) {
      ariaHidden(modalRef.current, ariaHiddenProp);
    }
  });
  const handleClose = React$1.useCallback(() => {
    manager.remove(getModal(), ariaHiddenProp);
  }, [ariaHiddenProp, manager]);
  React$1.useEffect(() => {
    return () => {
      handleClose();
    };
  }, [handleClose]);
  React$1.useEffect(() => {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
  const createHandleKeyDown = otherHandlers => event => {
    var _otherHandlers$onKeyD;
    (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);

    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || event.which === 229 ||
    // Wait until IME is settled.
    !isTopModal()) {
      return;
    }
    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();
      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };
  const createHandleBackdropClick = otherHandlers => event => {
    var _otherHandlers$onClic;
    (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
    if (event.target !== event.currentTarget) {
      return;
    }
    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const getRootProps = (otherHandlers = {}) => {
    const propsEventHandlers = extractEventHandlers(parameters);

    // The custom event handlers shouldn't be spread on the root element
    delete propsEventHandlers.onTransitionEnter;
    delete propsEventHandlers.onTransitionExited;
    const externalEventHandlers = _extends$X({}, propsEventHandlers, otherHandlers);
    return _extends$X({
      role: 'presentation'
    }, externalEventHandlers, {
      onKeyDown: createHandleKeyDown(externalEventHandlers),
      ref: handleRef
    });
  };
  const getBackdropProps = (otherHandlers = {}) => {
    const externalEventHandlers = otherHandlers;
    return _extends$X({
      'aria-hidden': true
    }, externalEventHandlers, {
      onClick: createHandleBackdropClick(externalEventHandlers),
      open
    });
  };
  const getTransitionProps = () => {
    const handleEnter = () => {
      setExited(false);
      if (onTransitionEnter) {
        onTransitionEnter();
      }
    };
    const handleExited = () => {
      setExited(true);
      if (onTransitionExited) {
        onTransitionExited();
      }
      if (closeAfterTransition) {
        handleClose();
      }
    };
    return {
      onEnter: createChainedFunction(handleEnter, children == null ? void 0 : children.props.onEnter),
      onExited: createChainedFunction(handleExited, children == null ? void 0 : children.props.onExited)
    };
  };
  return {
    getRootProps,
    getBackdropProps,
    getTransitionProps,
    rootRef: handleRef,
    portalRef: handlePortalRef,
    isTopModal,
    exited,
    hasTransition
  };
}

function getModalUtilityClass(slot) {
  return generateUtilityClass('MuiModal', slot);
}
generateUtilityClasses('MuiModal', ['root', 'hidden', 'backdrop']);

const _excluded$M = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"];
const useUtilityClasses$I = ownerState => {
  const {
    open,
    exited,
    classes
  } = ownerState;
  const slots = {
    root: ['root', !open && exited && 'hidden'],
    backdrop: ['backdrop']
  };
  return composeClasses$1(slots, getModalUtilityClass, classes);
};
const ModalRoot = styled$2('div', {
  name: 'MuiModal',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.open && ownerState.exited && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  position: 'fixed',
  zIndex: (theme.vars || theme).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !ownerState.open && ownerState.exited && {
  visibility: 'hidden'
}));
const ModalBackdrop = styled$2(Backdrop$1, {
  name: 'MuiModal',
  slot: 'Backdrop',
  overridesResolver: (props, styles) => {
    return styles.backdrop;
  }
})({
  zIndex: -1
});

/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */
const Modal = /*#__PURE__*/React$1.forwardRef(function Modal(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
  const props = useDefaultProps({
    name: 'MuiModal',
    props: inProps
  });
  const {
      BackdropComponent = ModalBackdrop,
      BackdropProps,
      className,
      closeAfterTransition = false,
      children,
      container,
      component,
      components = {},
      componentsProps = {},
      disableAutoFocus = false,
      disableEnforceFocus = false,
      disableEscapeKeyDown = false,
      disablePortal = false,
      disableRestoreFocus = false,
      disableScrollLock = false,
      hideBackdrop = false,
      keepMounted = false,
      onBackdropClick,
      open,
      slotProps,
      slots
      // eslint-disable-next-line react/prop-types
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$M);
  const propsWithDefaults = _extends$X({}, props, {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  });
  const {
    getRootProps,
    getBackdropProps,
    getTransitionProps,
    portalRef,
    isTopModal,
    exited,
    hasTransition
  } = useModal(_extends$X({}, propsWithDefaults, {
    rootRef: ref
  }));
  const ownerState = _extends$X({}, propsWithDefaults, {
    exited
  });
  const classes = useUtilityClasses$I(ownerState);
  const childProps = {};
  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = '-1';
  }

  // It's a Transition like component
  if (hasTransition) {
    const {
      onEnter,
      onExited
    } = getTransitionProps();
    childProps.onEnter = onEnter;
    childProps.onExited = onExited;
  }
  const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : ModalRoot;
  const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
  const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
  const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
  const rootProps = useSlotProps({
    elementType: RootSlot,
    externalSlotProps: rootSlotProps,
    externalForwardedProps: other,
    getSlotProps: getRootProps,
    additionalProps: {
      ref,
      as: component
    },
    ownerState,
    className: clsx(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
  });
  const backdropProps = useSlotProps({
    elementType: BackdropSlot,
    externalSlotProps: backdropSlotProps,
    additionalProps: BackdropProps,
    getSlotProps: otherHandlers => {
      return getBackdropProps(_extends$X({}, otherHandlers, {
        onClick: e => {
          if (onBackdropClick) {
            onBackdropClick(e);
          }
          if (otherHandlers != null && otherHandlers.onClick) {
            otherHandlers.onClick(e);
          }
        }
      }));
    },
    className: clsx(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
    ownerState
  });
  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }
  return /*#__PURE__*/jsxRuntimeExports.jsx(Portal$1, {
    ref: portalRef,
    container: container,
    disablePortal: disablePortal,
    children: /*#__PURE__*/jsxRuntimeExports.jsxs(RootSlot, _extends$X({}, rootProps, {
      children: [!hideBackdrop && BackdropComponent ? /*#__PURE__*/jsxRuntimeExports.jsx(BackdropSlot, _extends$X({}, backdropProps)) : null, /*#__PURE__*/jsxRuntimeExports.jsx(FocusTrap, {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        isEnabled: isTopModal,
        open: open,
        children: /*#__PURE__*/React$1.cloneElement(children, childProps)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" ? Modal.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes.object,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Backdrop: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var Modal$1 = Modal;

function getDialogUtilityClass(slot) {
  return generateUtilityClass('MuiDialog', slot);
}
const dialogClasses = generateUtilityClasses('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
var dialogClasses$1 = dialogClasses;

const DialogContext = /*#__PURE__*/React$1.createContext({});
if (process.env.NODE_ENV !== 'production') {
  DialogContext.displayName = 'DialogContext';
}
var DialogContext$1 = DialogContext;

const _excluded$L = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
const DialogBackdrop = styled$2(Backdrop$1, {
  name: 'MuiDialog',
  slot: 'Backdrop',
  overrides: (props, styles) => styles.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
});
const useUtilityClasses$H = ownerState => {
  const {
    classes,
    scroll,
    maxWidth,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ['root'],
    container: ['container', `scroll${capitalize$1(scroll)}`],
    paper: ['paper', `paperScroll${capitalize$1(scroll)}`, `paperWidth${capitalize$1(String(maxWidth))}`, fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
  };
  return composeClasses$1(slots, getDialogUtilityClass, classes);
};
const DialogRoot = styled$2(Modal$1, {
  name: 'MuiDialog',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  '@media print': {
    // Use !important to override the Modal inline-style.
    position: 'absolute !important'
  }
});
const DialogContainer = styled$2('div', {
  name: 'MuiDialog',
  slot: 'Container',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.container, styles[`scroll${capitalize$1(ownerState.scroll)}`]];
  }
})(({
  ownerState
}) => _extends$X({
  height: '100%',
  '@media print': {
    height: 'auto'
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, ownerState.scroll === 'body' && {
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  '&::after': {
    content: '""',
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    width: '0'
  }
}));
const DialogPaper = styled$2(Paper$1, {
  name: 'MuiDialog',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`scrollPaper${capitalize$1(ownerState.scroll)}`], styles[`paperWidth${capitalize$1(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  margin: 32,
  position: 'relative',
  overflowY: 'auto',
  // Fix IE11 issue, to remove at some point.
  '@media print': {
    overflowY: 'visible',
    boxShadow: 'none'
  }
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100% - 64px)'
}, ownerState.scroll === 'body' && {
  display: 'inline-block',
  verticalAlign: 'middle',
  textAlign: 'left' // 'initial' doesn't work on IE11
}, !ownerState.maxWidth && {
  maxWidth: 'calc(100% - 64px)'
}, ownerState.maxWidth === 'xs' && {
  maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
  maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.fullWidth && {
  width: 'calc(100% - 64px)'
}, ownerState.fullScreen && {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: 'none',
  borderRadius: 0,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    margin: 0,
    maxWidth: '100%'
  }
}));

/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */
const Dialog = /*#__PURE__*/React$1.forwardRef(function Dialog(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiDialog'
  });
  const theme = useTheme$1();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      'aria-describedby': ariaDescribedby,
      'aria-labelledby': ariaLabelledbyProp,
      BackdropComponent,
      BackdropProps,
      children,
      className,
      disableEscapeKeyDown = false,
      fullScreen = false,
      fullWidth = false,
      maxWidth = 'sm',
      onBackdropClick,
      onClick,
      onClose,
      open,
      PaperComponent = Paper$1,
      PaperProps = {},
      scroll = 'paper',
      TransitionComponent = Fade$1,
      transitionDuration = defaultTransitionDuration,
      TransitionProps
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$L);
  const ownerState = _extends$X({}, props, {
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth,
    scroll
  });
  const classes = useUtilityClasses$H(ownerState);
  const backdropClick = React$1.useRef();
  const handleMouseDown = event => {
    // We don't want to close the dialog when clicking the dialog content.
    // Make sure the event starts and ends on the same DOM element.
    backdropClick.current = event.target === event.currentTarget;
  };
  const handleBackdropClick = event => {
    if (onClick) {
      onClick(event);
    }

    // Ignore the events not coming from the "backdrop".
    if (!backdropClick.current) {
      return;
    }
    backdropClick.current = null;
    if (onBackdropClick) {
      onBackdropClick(event);
    }
    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const ariaLabelledby = useId(ariaLabelledbyProp);
  const dialogContextValue = React$1.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  return /*#__PURE__*/jsxRuntimeExports.jsx(DialogRoot, _extends$X({
    className: clsx(classes.root, className),
    closeAfterTransition: true,
    components: {
      Backdrop: DialogBackdrop
    },
    componentsProps: {
      backdrop: _extends$X({
        transitionDuration,
        as: BackdropComponent
      }, BackdropProps)
    },
    disableEscapeKeyDown: disableEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref,
    onClick: handleBackdropClick,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsxRuntimeExports.jsx(TransitionComponent, _extends$X({
      appear: true,
      in: open,
      timeout: transitionDuration,
      role: "presentation"
    }, TransitionProps, {
      children: /*#__PURE__*/jsxRuntimeExports.jsx(DialogContainer, {
        className: clsx(classes.container),
        onMouseDown: handleMouseDown,
        ownerState: ownerState,
        children: /*#__PURE__*/jsxRuntimeExports.jsx(DialogPaper, _extends$X({
          as: PaperComponent,
          elevation: 24,
          role: "dialog",
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledby
        }, PaperProps, {
          className: clsx(classes.paper, PaperProps.className),
          ownerState: ownerState,
          children: /*#__PURE__*/jsxRuntimeExports.jsx(DialogContext$1.Provider, {
            value: dialogContextValue,
            children: children
          })
        }))
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Dialog.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  'aria-describedby': PropTypes.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  'aria-labelledby': PropTypes.string,
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: PropTypes.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]), PropTypes.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: PropTypes.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: PropTypes.oneOf(['body', 'paper']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: PropTypes.object
} : void 0;
var Dialog$1 = Dialog;

function getDialogActionsUtilityClass(slot) {
  return generateUtilityClass('MuiDialogActions', slot);
}
generateUtilityClasses('MuiDialogActions', ['root', 'spacing']);

const _excluded$K = ["className", "disableSpacing"];
const useUtilityClasses$G = ownerState => {
  const {
    classes,
    disableSpacing
  } = ownerState;
  const slots = {
    root: ['root', !disableSpacing && 'spacing']
  };
  return composeClasses$1(slots, getDialogActionsUtilityClass, classes);
};
const DialogActionsRoot = styled$2('div', {
  name: 'MuiDialogActions',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disableSpacing && styles.spacing];
  }
})(({
  ownerState
}) => _extends$X({
  display: 'flex',
  alignItems: 'center',
  padding: 8,
  justifyContent: 'flex-end',
  flex: '0 0 auto'
}, !ownerState.disableSpacing && {
  '& > :not(style) ~ :not(style)': {
    marginLeft: 8
  }
}));
const DialogActions = /*#__PURE__*/React$1.forwardRef(function DialogActions(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiDialogActions'
  });
  const {
      className,
      disableSpacing = false
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$K);
  const ownerState = _extends$X({}, props, {
    disableSpacing
  });
  const classes = useUtilityClasses$G(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(DialogActionsRoot, _extends$X({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogActions.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var DialogActions$1 = DialogActions;

function getDialogContentUtilityClass(slot) {
  return generateUtilityClass('MuiDialogContent', slot);
}
generateUtilityClasses('MuiDialogContent', ['root', 'dividers']);

function getDialogTitleUtilityClass(slot) {
  return generateUtilityClass('MuiDialogTitle', slot);
}
const dialogTitleClasses = generateUtilityClasses('MuiDialogTitle', ['root']);
var dialogTitleClasses$1 = dialogTitleClasses;

const _excluded$J = ["className", "dividers"];
const useUtilityClasses$F = ownerState => {
  const {
    classes,
    dividers
  } = ownerState;
  const slots = {
    root: ['root', dividers && 'dividers']
  };
  return composeClasses$1(slots, getDialogContentUtilityClass, classes);
};
const DialogContentRoot = styled$2('div', {
  name: 'MuiDialogContent',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.dividers && styles.dividers];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  flex: '1 1 auto',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  overflowY: 'auto',
  padding: '20px 24px'
}, ownerState.dividers ? {
  padding: '16px 24px',
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
} : {
  [`.${dialogTitleClasses$1.root} + &`]: {
    paddingTop: 0
  }
}));
const DialogContent = /*#__PURE__*/React$1.forwardRef(function DialogContent(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiDialogContent'
  });
  const {
      className,
      dividers = false
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$J);
  const ownerState = _extends$X({}, props, {
    dividers
  });
  const classes = useUtilityClasses$F(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(DialogContentRoot, _extends$X({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogContent.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var DialogContent$1 = DialogContent;

const _excluded$I = ["className", "id"];
const useUtilityClasses$E = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses$1(slots, getDialogTitleUtilityClass, classes);
};
const DialogTitleRoot = styled$2(Typography$1, {
  name: 'MuiDialogTitle',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  padding: '16px 24px',
  flex: '0 0 auto'
});
const DialogTitle = /*#__PURE__*/React$1.forwardRef(function DialogTitle(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiDialogTitle'
  });
  const {
      className,
      id: idProp
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$I);
  const ownerState = props;
  const classes = useUtilityClasses$E(ownerState);
  const {
    titleId = idProp
  } = React$1.useContext(DialogContext$1);
  return /*#__PURE__*/jsxRuntimeExports.jsx(DialogTitleRoot, _extends$X({
    component: "h2",
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref,
    variant: "h6",
    id: idProp != null ? idProp : titleId
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogTitle.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  id: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var DialogTitle$1 = DialogTitle;

function getDividerUtilityClass(slot) {
  return generateUtilityClass('MuiDivider', slot);
}
const dividerClasses = generateUtilityClasses('MuiDivider', ['root', 'absolute', 'fullWidth', 'inset', 'middle', 'flexItem', 'light', 'vertical', 'withChildren', 'withChildrenVertical', 'textAlignRight', 'textAlignLeft', 'wrapper', 'wrapperVertical']);
var dividerClasses$1 = dividerClasses;

const _excluded$H = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"];
const useUtilityClasses$D = ownerState => {
  const {
    absolute,
    children,
    classes,
    flexItem,
    light,
    orientation,
    textAlign,
    variant
  } = ownerState;
  const slots = {
    root: ['root', absolute && 'absolute', variant, light && 'light', orientation === 'vertical' && 'vertical', flexItem && 'flexItem', children && 'withChildren', children && orientation === 'vertical' && 'withChildrenVertical', textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight', textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'],
    wrapper: ['wrapper', orientation === 'vertical' && 'wrapperVertical']
  };
  return composeClasses$1(slots, getDividerUtilityClass, classes);
};
const DividerRoot = styled$2('div', {
  name: 'MuiDivider',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.absolute && styles.absolute, styles[ownerState.variant], ownerState.light && styles.light, ownerState.orientation === 'vertical' && styles.vertical, ownerState.flexItem && styles.flexItem, ownerState.children && styles.withChildren, ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: 'solid',
  borderColor: (theme.vars || theme).palette.divider,
  borderBottomWidth: 'thin'
}, ownerState.absolute && {
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%'
}, ownerState.light && {
  borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : alpha_1(theme.palette.divider, 0.08)
}, ownerState.variant === 'inset' && {
  marginLeft: 72
}, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2)
}, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1)
}, ownerState.orientation === 'vertical' && {
  height: '100%',
  borderBottomWidth: 0,
  borderRightWidth: 'thin'
}, ownerState.flexItem && {
  alignSelf: 'stretch',
  height: 'auto'
}), ({
  ownerState
}) => _extends$X({}, ownerState.children && {
  display: 'flex',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  border: 0,
  borderTopStyle: 'solid',
  borderLeftStyle: 'solid',
  '&::before, &::after': {
    content: '""',
    alignSelf: 'center'
  }
}), ({
  theme,
  ownerState
}) => _extends$X({}, ownerState.children && ownerState.orientation !== 'vertical' && {
  '&::before, &::after': {
    width: '100%',
    borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
    borderTopStyle: 'inherit'
  }
}), ({
  theme,
  ownerState
}) => _extends$X({}, ownerState.children && ownerState.orientation === 'vertical' && {
  flexDirection: 'column',
  '&::before, &::after': {
    height: '100%',
    borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
    borderLeftStyle: 'inherit'
  }
}), ({
  ownerState
}) => _extends$X({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '90%'
  },
  '&::after': {
    width: '10%'
  }
}, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '10%'
  },
  '&::after': {
    width: '90%'
  }
}));
const DividerWrapper = styled$2('span', {
  name: 'MuiDivider',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.wrapper, ownerState.orientation === 'vertical' && styles.wrapperVertical];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  display: 'inline-block',
  paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
  paddingRight: `calc(${theme.spacing(1)} * 1.2)`
}, ownerState.orientation === 'vertical' && {
  paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
}));
const Divider = /*#__PURE__*/React$1.forwardRef(function Divider(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiDivider'
  });
  const {
      absolute = false,
      children,
      className,
      component = children ? 'div' : 'hr',
      flexItem = false,
      light = false,
      orientation = 'horizontal',
      role = component !== 'hr' ? 'separator' : undefined,
      textAlign = 'center',
      variant = 'fullWidth'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$H);
  const ownerState = _extends$X({}, props, {
    absolute,
    component,
    flexItem,
    light,
    orientation,
    role,
    textAlign,
    variant
  });
  const classes = useUtilityClasses$D(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(DividerRoot, _extends$X({
    as: component,
    className: clsx(classes.root, className),
    role: role,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children ? /*#__PURE__*/jsxRuntimeExports.jsx(DividerWrapper, {
      className: classes.wrapper,
      ownerState: ownerState,
      children: children
    }) : null
  }));
});

/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */
Divider.muiSkipListHighlight = true;
process.env.NODE_ENV !== "production" ? Divider.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: PropTypes.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */
  light: PropTypes.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * @ignore
   */
  role: PropTypes /* @typescript-to-proptypes-ignore */.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: PropTypes.oneOf(['center', 'left', 'right']),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['fullWidth', 'inset', 'middle']), PropTypes.string])
} : void 0;
var Divider$1 = Divider;

const _excluded$G = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function getTranslateValue(direction, node, resolvedContainer) {
  const rect = node.getBoundingClientRect();
  const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
  const containerWindow = ownerWindow(node);
  let transform;
  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    const computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }
  let offsetX = 0;
  let offsetY = 0;
  if (transform && transform !== 'none' && typeof transform === 'string') {
    const transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }
  if (direction === 'left') {
    if (containerRect) {
      return `translateX(${containerRect.right + offsetX - rect.left}px)`;
    }
    return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
  }
  if (direction === 'right') {
    if (containerRect) {
      return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
    }
    return `translateX(-${rect.left + rect.width - offsetX}px)`;
  }
  if (direction === 'up') {
    if (containerRect) {
      return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
    }
    return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
  }

  // direction === 'down'
  if (containerRect) {
    return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
  }
  return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function resolveContainer(containerPropProp) {
  return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function setTranslateValue(direction, node, containerProp) {
  const resolvedContainer = resolveContainer(containerProp);
  const transform = getTranslateValue(direction, node, resolvedContainer);
  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}

/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Slide = /*#__PURE__*/React$1.forwardRef(function Slide(props, ref) {
  const theme = useTheme$1();
  const defaultEasing = {
    enter: theme.transitions.easing.easeOut,
    exit: theme.transitions.easing.sharp
  };
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      container: containerProp,
      direction = 'down',
      easing: easingProp = defaultEasing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = Transition$1
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$G);
  const childrenRef = React$1.useRef(null);
  const handleRef = useForkRef(children.ref, childrenRef, ref);
  const normalizedTransitionCallback = callback => isAppearing => {
    if (callback) {
      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (isAppearing === undefined) {
        callback(childrenRef.current);
      } else {
        callback(childrenRef.current, isAppearing);
      }
    }
  };
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    setTranslateValue(direction, node, containerProp);
    reflow(node);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const transitionProps = getTransitionProps({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', _extends$X({}, transitionProps));
    node.style.transition = theme.transitions.create('transform', _extends$X({}, transitionProps));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = getTransitionProps({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    setTranslateValue(direction, node, containerProp);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(node => {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';
    if (onExited) {
      onExited(node);
    }
  });
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(childrenRef.current, next);
    }
  };
  const updatePosition = React$1.useCallback(() => {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, containerProp);
    }
  }, [direction, containerProp]);
  React$1.useEffect(() => {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }
    const handleResize = debounce$1(() => {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    });
    const containerWindow = ownerWindow(childrenRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp, containerProp]);
  React$1.useEffect(() => {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/jsxRuntimeExports.jsx(TransitionComponent, _extends$X({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    appear: appear,
    in: inProp,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/React$1.cloneElement(children, _extends$X({
        ref: handleRef,
        style: _extends$X({
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, style, children.props.style)
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Slide.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), props => {
    if (props.open) {
      const resolvedContainer = resolveContainer(props.container);
      if (resolvedContainer && resolvedContainer.nodeType === 1) {
        const box = resolvedContainer.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `container` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedContainer || typeof resolvedContainer.getBoundingClientRect !== 'function' || resolvedContainer.contextElement != null && resolvedContainer.contextElement.nodeType !== 1) {
        return new Error(['MUI: The `container` prop provided to the component is invalid.', 'It should be an HTML element instance.'].join('\n'));
      }
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: PropTypes.oneOf(['down', 'left', 'right', 'up']),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
var Slide$1 = Slide;

function getDrawerUtilityClass(slot) {
  return generateUtilityClass('MuiDrawer', slot);
}
generateUtilityClasses('MuiDrawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);

const _excluded$F = ["BackdropProps"],
  _excluded2$4 = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"];
const overridesResolver$3 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked, styles.modal];
};
const useUtilityClasses$C = ownerState => {
  const {
    classes,
    anchor,
    variant
  } = ownerState;
  const slots = {
    root: ['root'],
    docked: [(variant === 'permanent' || variant === 'persistent') && 'docked'],
    modal: ['modal'],
    paper: ['paper', `paperAnchor${capitalize$1(anchor)}`, variant !== 'temporary' && `paperAnchorDocked${capitalize$1(anchor)}`]
  };
  return composeClasses$1(slots, getDrawerUtilityClass, classes);
};
const DrawerRoot = styled$2(Modal$1, {
  name: 'MuiDrawer',
  slot: 'Root',
  overridesResolver: overridesResolver$3
})(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.drawer
}));
const DrawerDockedRoot = styled$2('div', {
  shouldForwardProp: rootShouldForwardProp$2,
  name: 'MuiDrawer',
  slot: 'Docked',
  skipVariantsResolver: false,
  overridesResolver: overridesResolver$3
})({
  flex: '0 0 auto'
});
const DrawerPaper = styled$2(Paper$1, {
  name: 'MuiDrawer',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`paperAnchor${capitalize$1(ownerState.anchor)}`], ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${capitalize$1(ownerState.anchor)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flex: '1 0 auto',
  zIndex: (theme.vars || theme).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  // temporary style
  position: 'fixed',
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, ownerState.anchor === 'left' && {
  left: 0
}, ownerState.anchor === 'top' && {
  top: 0,
  left: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'right' && {
  right: 0
}, ownerState.anchor === 'bottom' && {
  top: 'auto',
  left: 0,
  bottom: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
  borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
  borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
}));
const oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor({
  direction
}, anchor) {
  return direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}

/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */
const Drawer$1 = /*#__PURE__*/React$1.forwardRef(function Drawer(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiDrawer'
  });
  const theme = useTheme$1();
  const isRtl = useRtl();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      anchor: anchorProp = 'left',
      BackdropProps,
      children,
      className,
      elevation = 16,
      hideBackdrop = false,
      ModalProps: {
        BackdropProps: BackdropPropsProp
      } = {},
      onClose,
      open = false,
      PaperProps = {},
      SlideProps,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = Slide$1,
      transitionDuration = defaultTransitionDuration,
      variant = 'temporary'
    } = props,
    ModalProps = _objectWithoutPropertiesLoose$3(props.ModalProps, _excluded$F),
    other = _objectWithoutPropertiesLoose$3(props, _excluded2$4);

  // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.
  const mounted = React$1.useRef(false);
  React$1.useEffect(() => {
    mounted.current = true;
  }, []);
  const anchorInvariant = getAnchor({
    direction: isRtl ? 'rtl' : 'ltr'
  }, anchorProp);
  const anchor = anchorProp;
  const ownerState = _extends$X({}, props, {
    anchor,
    elevation,
    open,
    variant
  }, other);
  const classes = useUtilityClasses$C(ownerState);
  const drawer = /*#__PURE__*/jsxRuntimeExports.jsx(DrawerPaper, _extends$X({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: clsx(classes.paper, PaperProps.className),
    ownerState: ownerState,
    children: children
  }));
  if (variant === 'permanent') {
    return /*#__PURE__*/jsxRuntimeExports.jsx(DrawerDockedRoot, _extends$X({
      className: clsx(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: drawer
    }));
  }
  const slidingDrawer = /*#__PURE__*/jsxRuntimeExports.jsx(TransitionComponent, _extends$X({
    in: open,
    direction: oppositeDirection[anchorInvariant],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps, {
    children: drawer
  }));
  if (variant === 'persistent') {
    return /*#__PURE__*/jsxRuntimeExports.jsx(DrawerDockedRoot, _extends$X({
      className: clsx(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: slidingDrawer
    }));
  }

  // variant === temporary
  return /*#__PURE__*/jsxRuntimeExports.jsx(DrawerRoot, _extends$X({
    BackdropProps: _extends$X({}, BackdropProps, BackdropPropsProp, {
      transitionDuration
    }),
    className: clsx(classes.root, classes.modal, className),
    open: open,
    ownerState: ownerState,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    ref: ref
  }, other, ModalProps, {
    children: slidingDrawer
  }));
});
process.env.NODE_ENV !== "production" ? Drawer$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),
  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: integerPropType,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Props applied to the [`Modal`](/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: PropTypes.object,
  /**
   * Props applied to the [`Slide`](/material-ui/api/slide/) element.
   */
  SlideProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
var MDrawer = Drawer$1;

const _excluded$E = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"];
const useUtilityClasses$B = ownerState => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ['root', !disableUnderline && 'underline'],
    input: ['input']
  };
  const composedClasses = composeClasses$1(slots, getFilledInputUtilityClass, classes);
  return _extends$X({}, classes, composedClasses);
};
const FilledInputRoot = styled$2(InputBaseRoot, {
  shouldForwardProp: prop => rootShouldForwardProp$2(prop) || prop === 'classes',
  name: 'MuiFilledInput',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [...rootOverridesResolver(props, styles), !ownerState.disableUnderline && styles.underline];
  }
})(({
  theme,
  ownerState
}) => {
  var _palette;
  const light = theme.palette.mode === 'light';
  const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
  const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
  const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
  return _extends$X({
    position: 'relative',
    backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
    borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
    borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeOut
    }),
    '&:hover': {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
      }
    },
    [`&.${filledInputClasses$1.focused}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
    },
    [`&.${filledInputClasses$1.disabled}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
    }
  }, !ownerState.disableUnderline && {
    '&::after': {
      borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: 'absolute',
      right: 0,
      transform: 'scaleX(0)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },
    [`&.${filledInputClasses$1.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: 'scaleX(1) translateX(0)'
    },
    [`&.${filledInputClasses$1.error}`]: {
      '&::before, &::after': {
        borderBottomColor: (theme.vars || theme).palette.error.main
      }
    },
    '&::before': {
      borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },
    [`&:hover:not(.${filledInputClasses$1.disabled}, .${filledInputClasses$1.error}):before`]: {
      borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
    },
    [`&.${filledInputClasses$1.disabled}:before`]: {
      borderBottomStyle: 'dotted'
    }
  }, ownerState.startAdornment && {
    paddingLeft: 12
  }, ownerState.endAdornment && {
    paddingRight: 12
  }, ownerState.multiline && _extends$X({
    padding: '25px 12px 8px'
  }, ownerState.size === 'small' && {
    paddingTop: 21,
    paddingBottom: 4
  }, ownerState.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, ownerState.hiddenLabel && ownerState.size === 'small' && {
    paddingTop: 8,
    paddingBottom: 9
  }));
});
const FilledInputInput = styled$2(InputBaseComponent, {
  name: 'MuiFilledInput',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})(({
  theme,
  ownerState
}) => _extends$X({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !theme.vars && {
  '&:-webkit-autofill': {
    WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
    WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
    caretColor: theme.palette.mode === 'light' ? null : '#fff',
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit'
  }
}, theme.vars && {
  '&:-webkit-autofill': {
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit'
  },
  [theme.getColorSchemeSelector('dark')]: {
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px #266798 inset',
      WebkitTextFillColor: '#fff',
      caretColor: '#fff'
    }
  }
}, ownerState.size === 'small' && {
  paddingTop: 21,
  paddingBottom: 4
}, ownerState.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, ownerState.startAdornment && {
  paddingLeft: 0
}, ownerState.endAdornment && {
  paddingRight: 0
}, ownerState.hiddenLabel && ownerState.size === 'small' && {
  paddingTop: 8,
  paddingBottom: 9
}, ownerState.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
}));
const FilledInput = /*#__PURE__*/React$1.forwardRef(function FilledInput(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$input;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiFilledInput'
  });
  const {
      components = {},
      componentsProps: componentsPropsProp,
      fullWidth = false,
      // declare here to prevent spreading to DOM
      inputComponent = 'input',
      multiline = false,
      slotProps,
      slots = {},
      type = 'text'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$E);
  const ownerState = _extends$X({}, props, {
    fullWidth,
    inputComponent,
    multiline,
    type
  });
  const classes = useUtilityClasses$B(props);
  const filledInputComponentsProps = {
    root: {
      ownerState
    },
    input: {
      ownerState
    }
  };
  const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? deepmerge$1(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
  const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : FilledInputRoot;
  const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : FilledInputInput;
  return /*#__PURE__*/jsxRuntimeExports.jsx(InputBase$1, _extends$X({
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    componentsProps: componentsProps,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? FilledInput.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['primary', 'secondary']), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(['dense', 'none']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
FilledInput.muiName = 'Input';
var FilledInput$1 = FilledInput;

function getFormControlUtilityClasses(slot) {
  return generateUtilityClass('MuiFormControl', slot);
}
generateUtilityClasses('MuiFormControl', ['root', 'marginNone', 'marginNormal', 'marginDense', 'fullWidth', 'disabled']);

const _excluded$D = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"];
const useUtilityClasses$A = ownerState => {
  const {
    classes,
    margin,
    fullWidth
  } = ownerState;
  const slots = {
    root: ['root', margin !== 'none' && `margin${capitalize$1(margin)}`, fullWidth && 'fullWidth']
  };
  return composeClasses$1(slots, getFormControlUtilityClasses, classes);
};
const FormControlRoot = styled$2('div', {
  name: 'MuiFormControl',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return _extends$X({}, styles.root, styles[`margin${capitalize$1(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
  }
})(({
  ownerState
}) => _extends$X({
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'relative',
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: 'top'
}, ownerState.margin === 'normal' && {
  marginTop: 16,
  marginBottom: 8
}, ownerState.margin === 'dense' && {
  marginTop: 8,
  marginBottom: 4
}, ownerState.fullWidth && {
  width: '100%'
}));

/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */
const FormControl = /*#__PURE__*/React$1.forwardRef(function FormControl(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiFormControl'
  });
  const {
      children,
      className,
      color = 'primary',
      component = 'div',
      disabled = false,
      error = false,
      focused: visuallyFocused,
      fullWidth = false,
      hiddenLabel = false,
      margin = 'none',
      required = false,
      size = 'medium',
      variant = 'outlined'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$D);
  const ownerState = _extends$X({}, props, {
    color,
    component,
    disabled,
    error,
    fullWidth,
    hiddenLabel,
    margin,
    required,
    size,
    variant
  });
  const classes = useUtilityClasses$A(ownerState);
  const [adornedStart, setAdornedStart] = React$1.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialAdornedStart = false;
    if (children) {
      React$1.Children.forEach(children, child => {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }
        const input = isMuiElement(child, ['Select']) ? child.props.input : child;
        if (input && isAdornedStart(input.props)) {
          initialAdornedStart = true;
        }
      });
    }
    return initialAdornedStart;
  });
  const [filled, setFilled] = React$1.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialFilled = false;
    if (children) {
      React$1.Children.forEach(children, child => {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }
        if (isFilled(child.props, true) || isFilled(child.props.inputProps, true)) {
          initialFilled = true;
        }
      });
    }
    return initialFilled;
  });
  const [focusedState, setFocused] = React$1.useState(false);
  if (disabled && focusedState) {
    setFocused(false);
  }
  const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
  let registerEffect;
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const registeredInput = React$1.useRef(false);
    registerEffect = () => {
      if (registeredInput.current) {
        console.error(['MUI: There are multiple `InputBase` components inside a FormControl.', 'This creates visual inconsistencies, only use one `InputBase`.'].join('\n'));
      }
      registeredInput.current = true;
      return () => {
        registeredInput.current = false;
      };
    };
  }
  const childContext = React$1.useMemo(() => {
    return {
      adornedStart,
      setAdornedStart,
      color,
      disabled,
      error,
      filled,
      focused,
      fullWidth,
      hiddenLabel,
      size,
      onBlur: () => {
        setFocused(false);
      },
      onEmpty: () => {
        setFilled(false);
      },
      onFilled: () => {
        setFilled(true);
      },
      onFocus: () => {
        setFocused(true);
      },
      registerEffect,
      required,
      variant
    };
  }, [adornedStart, color, disabled, error, filled, focused, fullWidth, hiddenLabel, registerEffect, required, size, variant]);
  return /*#__PURE__*/jsxRuntimeExports.jsx(FormControlContext$1.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(FormControlRoot, _extends$X({
      as: component,
      ownerState: ownerState,
      className: clsx(classes.root, className),
      ref: ref
    }, other, {
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? FormControl.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var FormControl$1 = FormControl;

const Stack = createStack({
  createStyledComponent: styled$2('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles) => styles.root
  }),
  useThemeProps: inProps => useDefaultProps({
    props: inProps,
    name: 'MuiStack'
  })
});
process.env.NODE_ENV !== "production" ? Stack.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: PropTypes.oneOfType([PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), PropTypes.arrayOf(PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), PropTypes.object]),
  /**
   * Add an element between each child.
   */
  divider: PropTypes.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: PropTypes.bool
} : void 0;
var Stack$1 = Stack;

function getFormControlLabelUtilityClasses(slot) {
  return generateUtilityClass('MuiFormControlLabel', slot);
}
const formControlLabelClasses = generateUtilityClasses('MuiFormControlLabel', ['root', 'labelPlacementStart', 'labelPlacementTop', 'labelPlacementBottom', 'disabled', 'label', 'error', 'required', 'asterisk']);
var formControlLabelClasses$1 = formControlLabelClasses;

const _excluded$C = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"];
const useUtilityClasses$z = ownerState => {
  const {
    classes,
    disabled,
    labelPlacement,
    error,
    required
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', `labelPlacement${capitalize$1(labelPlacement)}`, error && 'error', required && 'required'],
    label: ['label', disabled && 'disabled'],
    asterisk: ['asterisk', error && 'error']
  };
  return composeClasses$1(slots, getFormControlLabelUtilityClasses, classes);
};
const FormControlLabelRoot = styled$2('label', {
  name: 'MuiFormControlLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${formControlLabelClasses$1.label}`]: styles.label
    }, styles.root, styles[`labelPlacement${capitalize$1(ownerState.labelPlacement)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  // For correct alignment with the text.
  verticalAlign: 'middle',
  WebkitTapHighlightColor: 'transparent',
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${formControlLabelClasses$1.disabled}`]: {
    cursor: 'default'
  }
}, ownerState.labelPlacement === 'start' && {
  flexDirection: 'row-reverse',
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, ownerState.labelPlacement === 'top' && {
  flexDirection: 'column-reverse',
  marginLeft: 16
}, ownerState.labelPlacement === 'bottom' && {
  flexDirection: 'column',
  marginLeft: 16
}, {
  [`& .${formControlLabelClasses$1.label}`]: {
    [`&.${formControlLabelClasses$1.disabled}`]: {
      color: (theme.vars || theme).palette.text.disabled
    }
  }
}));
const AsteriskComponent$1 = styled$2('span', {
  name: 'MuiFormControlLabel',
  slot: 'Asterisk',
  overridesResolver: (props, styles) => styles.asterisk
})(({
  theme
}) => ({
  [`&.${formControlLabelClasses$1.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));

/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */
const FormControlLabel = /*#__PURE__*/React$1.forwardRef(function FormControlLabel(inProps, ref) {
  var _ref, _slotProps$typography;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiFormControlLabel'
  });
  const {
      className,
      componentsProps = {},
      control,
      disabled: disabledProp,
      disableTypography,
      label: labelProp,
      labelPlacement = 'end',
      required: requiredProp,
      slotProps = {}
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$C);
  const muiFormControl = useFormControl();
  const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
  const required = requiredProp != null ? requiredProp : control.props.required;
  const controlProps = {
    disabled,
    required
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(key => {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['error']
  });
  const ownerState = _extends$X({}, props, {
    disabled,
    labelPlacement,
    required,
    error: fcs.error
  });
  const classes = useUtilityClasses$z(ownerState);
  const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
  let label = labelProp;
  if (label != null && label.type !== Typography$1 && !disableTypography) {
    label = /*#__PURE__*/jsxRuntimeExports.jsx(Typography$1, _extends$X({
      component: "span"
    }, typographySlotProps, {
      className: clsx(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
      children: label
    }));
  }
  return /*#__PURE__*/jsxRuntimeExports.jsxs(FormControlLabelRoot, _extends$X({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/React$1.cloneElement(control, controlProps), required ? /*#__PURE__*/jsxRuntimeExports.jsxs(Stack$1, {
      display: "block",
      children: [label, /*#__PURE__*/jsxRuntimeExports.jsxs(AsteriskComponent$1, {
        ownerState: ownerState,
        "aria-hidden": true,
        className: classes.asterisk,
        children: ["\u2009", '*']
      })]
    }) : label]
  }));
});
process.env.NODE_ENV !== "production" ? FormControlLabel.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    typography: PropTypes.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: PropTypes.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: PropTypes.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: PropTypes.oneOf(['bottom', 'end', 'start', 'top']),
  /**
   * @ignore
   */
  name: PropTypes.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    typography: PropTypes.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
var FormControlLabel$1 = FormControlLabel;

function getFormGroupUtilityClass(slot) {
  return generateUtilityClass('MuiFormGroup', slot);
}
generateUtilityClasses('MuiFormGroup', ['root', 'row', 'error']);

const _excluded$B = ["className", "row"];
const useUtilityClasses$y = ownerState => {
  const {
    classes,
    row,
    error
  } = ownerState;
  const slots = {
    root: ['root', row && 'row', error && 'error']
  };
  return composeClasses$1(slots, getFormGroupUtilityClass, classes);
};
const FormGroupRoot = styled$2('div', {
  name: 'MuiFormGroup',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.row && styles.row];
  }
})(({
  ownerState
}) => _extends$X({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap'
}, ownerState.row && {
  flexDirection: 'row'
}));

/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */
const FormGroup = /*#__PURE__*/React$1.forwardRef(function FormGroup(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiFormGroup'
  });
  const {
      className,
      row = false
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$B);
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['error']
  });
  const ownerState = _extends$X({}, props, {
    row,
    error: fcs.error
  });
  const classes = useUtilityClasses$y(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(FormGroupRoot, _extends$X({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? FormGroup.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var FormGroup$1 = FormGroup;

function getFormHelperTextUtilityClasses(slot) {
  return generateUtilityClass('MuiFormHelperText', slot);
}
const formHelperTextClasses = generateUtilityClasses('MuiFormHelperText', ['root', 'error', 'disabled', 'sizeSmall', 'sizeMedium', 'contained', 'focused', 'filled', 'required']);
var formHelperTextClasses$1 = formHelperTextClasses;

var _span$3;
const _excluded$A = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"];
const useUtilityClasses$x = ownerState => {
  const {
    classes,
    contained,
    size,
    disabled,
    error,
    filled,
    focused,
    required
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', error && 'error', size && `size${capitalize$1(size)}`, contained && 'contained', focused && 'focused', filled && 'filled', required && 'required']
  };
  return composeClasses$1(slots, getFormHelperTextUtilityClasses, classes);
};
const FormHelperTextRoot = styled$2('p', {
  name: 'MuiFormHelperText',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.size && styles[`size${capitalize$1(ownerState.size)}`], ownerState.contained && styles.contained, ownerState.filled && styles.filled];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  color: (theme.vars || theme).palette.text.secondary
}, theme.typography.caption, {
  textAlign: 'left',
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${formHelperTextClasses$1.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${formHelperTextClasses$1.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}, ownerState.size === 'small' && {
  marginTop: 4
}, ownerState.contained && {
  marginLeft: 14,
  marginRight: 14
}));
const FormHelperText = /*#__PURE__*/React$1.forwardRef(function FormHelperText(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiFormHelperText'
  });
  const {
      children,
      className,
      component = 'p'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$A);
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['variant', 'size', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  const ownerState = _extends$X({}, props, {
    component,
    contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
    variant: fcs.variant,
    size: fcs.size,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });
  const classes = useUtilityClasses$x(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(FormHelperTextRoot, _extends$X({
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other, {
    children: children === ' ' ? // notranslate needed while Google Translate will not fix zero-width space issue
    _span$3 || (_span$3 = /*#__PURE__*/jsxRuntimeExports.jsx("span", {
      className: "notranslate",
      children: "\u200B"
    })) : children
  }));
});
process.env.NODE_ENV !== "production" ? FormHelperText.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['filled', 'outlined', 'standard']), PropTypes.string])
} : void 0;
var FormHelperText$1 = FormHelperText;

function getFormLabelUtilityClasses(slot) {
  return generateUtilityClass('MuiFormLabel', slot);
}
const formLabelClasses = generateUtilityClasses('MuiFormLabel', ['root', 'colorSecondary', 'focused', 'disabled', 'error', 'filled', 'required', 'asterisk']);
var formLabelClasses$1 = formLabelClasses;

const _excluded$z = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"];
const useUtilityClasses$w = ownerState => {
  const {
    classes,
    color,
    focused,
    disabled,
    error,
    filled,
    required
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$1(color)}`, disabled && 'disabled', error && 'error', filled && 'filled', focused && 'focused', required && 'required'],
    asterisk: ['asterisk', error && 'error']
  };
  return composeClasses$1(slots, getFormLabelUtilityClasses, classes);
};
const FormLabelRoot = styled$2('label', {
  name: 'MuiFormLabel',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return _extends$X({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  color: (theme.vars || theme).palette.text.secondary
}, theme.typography.body1, {
  lineHeight: '1.4375em',
  padding: 0,
  position: 'relative',
  [`&.${formLabelClasses$1.focused}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  },
  [`&.${formLabelClasses$1.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${formLabelClasses$1.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));
const AsteriskComponent = styled$2('span', {
  name: 'MuiFormLabel',
  slot: 'Asterisk',
  overridesResolver: (props, styles) => styles.asterisk
})(({
  theme
}) => ({
  [`&.${formLabelClasses$1.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));
const FormLabel = /*#__PURE__*/React$1.forwardRef(function FormLabel(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiFormLabel'
  });
  const {
      children,
      className,
      component = 'label'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$z);
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  const ownerState = _extends$X({}, props, {
    color: fcs.color || 'primary',
    component,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });
  const classes = useUtilityClasses$w(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsxs(FormLabelRoot, _extends$X({
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other, {
    children: [children, fcs.required && /*#__PURE__*/jsxRuntimeExports.jsxs(AsteriskComponent, {
      ownerState: ownerState,
      "aria-hidden": true,
      className: classes.asterisk,
      children: ["\u2009", '*']
    })]
  }));
});
process.env.NODE_ENV !== "production" ? FormLabel.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['error', 'info', 'primary', 'secondary', 'success', 'warning']), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var FormLabel$1 = FormLabel;

const _excluded$y = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function getScale(value) {
  return `scale(${value}, ${value ** 2})`;
}
const styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};

/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */
const isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);

/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Grow = /*#__PURE__*/React$1.forwardRef(function Grow(props, ref) {
  const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = 'auto',
      // eslint-disable-next-line react/prop-types
      TransitionComponent = Transition$1
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$y);
  const timer = useTimeout();
  const autoTimeout = React$1.useRef();
  const theme = useTheme$1();
  const nodeRef = React$1.useRef(null);
  const handleRef = useForkRef(nodeRef, children.ref, ref);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    reflow(node); // So the animation always start from the start.

    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    let duration;
    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }
    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: isWebKit154 ? duration : duration * 0.666,
      delay,
      easing: transitionTimingFunction
    })].join(',');
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    let duration;
    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }
    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: isWebKit154 ? duration : duration * 0.666,
      delay: isWebKit154 ? delay : delay || duration * 0.333,
      easing: transitionTimingFunction
    })].join(',');
    node.style.opacity = 0;
    node.style.transform = getScale(0.75);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.start(autoTimeout.current || 0, next);
    }
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/jsxRuntimeExports.jsx(TransitionComponent, _extends$X({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/React$1.cloneElement(children, _extends$X({
        style: _extends$X({
          opacity: 0,
          transform: getScale(0.75),
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Grow.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Grow.muiSupportAuto = true;
var Grow$1 = Grow;

const _excluded$x = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"];
const useUtilityClasses$v = ownerState => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ['root', !disableUnderline && 'underline'],
    input: ['input']
  };
  const composedClasses = composeClasses$1(slots, getInputUtilityClass, classes);
  return _extends$X({}, classes, composedClasses);
};
const InputRoot = styled$2(InputBaseRoot, {
  shouldForwardProp: prop => rootShouldForwardProp$2(prop) || prop === 'classes',
  name: 'MuiInput',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [...rootOverridesResolver(props, styles), !ownerState.disableUnderline && styles.underline];
  }
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  if (theme.vars) {
    bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
  }
  return _extends$X({
    position: 'relative'
  }, ownerState.formControl && {
    'label + &': {
      marginTop: 16
    }
  }, !ownerState.disableUnderline && {
    '&::after': {
      borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: 'absolute',
      right: 0,
      transform: 'scaleX(0)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },
    [`&.${inputClasses$1.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: 'scaleX(1) translateX(0)'
    },
    [`&.${inputClasses$1.error}`]: {
      '&::before, &::after': {
        borderBottomColor: (theme.vars || theme).palette.error.main
      }
    },
    '&::before': {
      borderBottom: `1px solid ${bottomLineColor}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },
    [`&:hover:not(.${inputClasses$1.disabled}, .${inputClasses$1.error}):before`]: {
      borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        borderBottom: `1px solid ${bottomLineColor}`
      }
    },
    [`&.${inputClasses$1.disabled}:before`]: {
      borderBottomStyle: 'dotted'
    }
  });
});
const InputInput = styled$2(InputBaseComponent, {
  name: 'MuiInput',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})({});
const Input = /*#__PURE__*/React$1.forwardRef(function Input(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$input;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiInput'
  });
  const {
      disableUnderline,
      components = {},
      componentsProps: componentsPropsProp,
      fullWidth = false,
      inputComponent = 'input',
      multiline = false,
      slotProps,
      slots = {},
      type = 'text'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$x);
  const classes = useUtilityClasses$v(props);
  const ownerState = {
    disableUnderline
  };
  const inputComponentsProps = {
    root: {
      ownerState
    }
  };
  const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? deepmerge$1(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
  const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : InputRoot;
  const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : InputInput;
  return /*#__PURE__*/jsxRuntimeExports.jsx(InputBase$1, _extends$X({
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    slotProps: componentsProps,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? Input.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['primary', 'secondary']), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(['dense', 'none']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
Input.muiName = 'Input';
var Input$1 = Input;

function getInputAdornmentUtilityClass(slot) {
  return generateUtilityClass('MuiInputAdornment', slot);
}
const inputAdornmentClasses = generateUtilityClasses('MuiInputAdornment', ['root', 'filled', 'standard', 'outlined', 'positionStart', 'positionEnd', 'disablePointerEvents', 'hiddenLabel', 'sizeSmall']);
var inputAdornmentClasses$1 = inputAdornmentClasses;

var _span$2;
const _excluded$w = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"];
const overridesResolver$2 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, styles[`position${capitalize$1(ownerState.position)}`], ownerState.disablePointerEvents === true && styles.disablePointerEvents, styles[ownerState.variant]];
};
const useUtilityClasses$u = ownerState => {
  const {
    classes,
    disablePointerEvents,
    hiddenLabel,
    position,
    size,
    variant
  } = ownerState;
  const slots = {
    root: ['root', disablePointerEvents && 'disablePointerEvents', position && `position${capitalize$1(position)}`, variant, hiddenLabel && 'hiddenLabel', size && `size${capitalize$1(size)}`]
  };
  return composeClasses$1(slots, getInputAdornmentUtilityClass, classes);
};
const InputAdornmentRoot = styled$2('div', {
  name: 'MuiInputAdornment',
  slot: 'Root',
  overridesResolver: overridesResolver$2
})(({
  theme,
  ownerState
}) => _extends$X({
  display: 'flex',
  height: '0.01em',
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: '2em',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  color: (theme.vars || theme).palette.action.active
}, ownerState.variant === 'filled' && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${inputAdornmentClasses$1.positionStart}&:not(.${inputAdornmentClasses$1.hiddenLabel})`]: {
    marginTop: 16
  }
}, ownerState.position === 'start' && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, ownerState.position === 'end' && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, ownerState.disablePointerEvents === true && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: 'none'
}));
const InputAdornment = /*#__PURE__*/React$1.forwardRef(function InputAdornment(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiInputAdornment'
  });
  const {
      children,
      className,
      component = 'div',
      disablePointerEvents = false,
      disableTypography = false,
      position,
      variant: variantProp
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$w);
  const muiFormControl = useFormControl() || {};
  let variant = variantProp;
  if (variantProp && muiFormControl.variant) {
    if (process.env.NODE_ENV !== 'production') {
      if (variantProp === muiFormControl.variant) {
        console.error('MUI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
      }
    }
  }
  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }
  const ownerState = _extends$X({}, props, {
    hiddenLabel: muiFormControl.hiddenLabel,
    size: muiFormControl.size,
    disablePointerEvents,
    position,
    variant
  });
  const classes = useUtilityClasses$u(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(FormControlContext$1.Provider, {
    value: null,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(InputAdornmentRoot, _extends$X({
      as: component,
      ownerState: ownerState,
      className: clsx(classes.root, className),
      ref: ref
    }, other, {
      children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/jsxRuntimeExports.jsx(Typography$1, {
        color: "text.secondary",
        children: children
      }) : /*#__PURE__*/jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [position === 'start' ? ( /* notranslate needed while Google Translate will not fix zero-width space issue */_span$2 || (_span$2 = /*#__PURE__*/jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          children: "\u200B"
        }))) : null, children]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" ? InputAdornment.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: PropTypes.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(['end', 'start']).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var InputAdornment$1 = InputAdornment;

function getInputLabelUtilityClasses(slot) {
  return generateUtilityClass('MuiInputLabel', slot);
}
generateUtilityClasses('MuiInputLabel', ['root', 'focused', 'disabled', 'error', 'required', 'asterisk', 'formControl', 'sizeSmall', 'shrink', 'animated', 'standard', 'filled', 'outlined']);

const _excluded$v = ["disableAnimation", "margin", "shrink", "variant", "className"];
const useUtilityClasses$t = ownerState => {
  const {
    classes,
    formControl,
    size,
    shrink,
    disableAnimation,
    variant,
    required
  } = ownerState;
  const slots = {
    root: ['root', formControl && 'formControl', !disableAnimation && 'animated', shrink && 'shrink', size && size !== 'normal' && `size${capitalize$1(size)}`, variant],
    asterisk: [required && 'asterisk']
  };
  const composedClasses = composeClasses$1(slots, getInputLabelUtilityClasses, classes);
  return _extends$X({}, classes, composedClasses);
};
const InputLabelRoot = styled$2(FormLabel$1, {
  shouldForwardProp: prop => rootShouldForwardProp$2(prop) || prop === 'classes',
  name: 'MuiInputLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${formLabelClasses$1.asterisk}`]: styles.asterisk
    }, styles.root, ownerState.formControl && styles.formControl, ownerState.size === 'small' && styles.sizeSmall, ownerState.shrink && styles.shrink, !ownerState.disableAnimation && styles.animated, ownerState.focused && styles.focused, styles[ownerState.variant]];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  display: 'block',
  transformOrigin: 'top left',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%'
}, ownerState.formControl && {
  position: 'absolute',
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: 'translate(0, 20px) scale(1)'
}, ownerState.size === 'small' && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: 'translate(0, 17px) scale(1)'
}, ownerState.shrink && {
  transform: 'translate(0, -1.5px) scale(0.75)',
  transformOrigin: 'top left',
  maxWidth: '133%'
}, !ownerState.disableAnimation && {
  transition: theme.transitions.create(['color', 'transform', 'max-width'], {
    duration: theme.transitions.duration.shorter,
    easing: theme.transitions.easing.easeOut
  })
}, ownerState.variant === 'filled' && _extends$X({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(12px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 13px) scale(1)'
}, ownerState.shrink && _extends$X({
  userSelect: 'none',
  pointerEvents: 'auto',
  transform: 'translate(12px, 7px) scale(0.75)',
  maxWidth: 'calc(133% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 4px) scale(0.75)'
})), ownerState.variant === 'outlined' && _extends$X({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(14px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(14px, 9px) scale(1)'
}, ownerState.shrink && {
  userSelect: 'none',
  pointerEvents: 'auto',
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: 'calc(133% - 32px)',
  transform: 'translate(14px, -9px) scale(0.75)'
})));
const InputLabel = /*#__PURE__*/React$1.forwardRef(function InputLabel(inProps, ref) {
  const props = useDefaultProps({
    name: 'MuiInputLabel',
    props: inProps
  });
  const {
      disableAnimation = false,
      shrink: shrinkProp,
      className
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$v);
  const muiFormControl = useFormControl();
  let shrink = shrinkProp;
  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['size', 'variant', 'required', 'focused']
  });
  const ownerState = _extends$X({}, props, {
    disableAnimation,
    formControl: muiFormControl,
    shrink,
    size: fcs.size,
    variant: fcs.variant,
    required: fcs.required,
    focused: fcs.focused
  });
  const classes = useUtilityClasses$t(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(InputLabelRoot, _extends$X({
    "data-shrink": shrink,
    ownerState: ownerState,
    ref: ref,
    className: clsx(classes.root, className)
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? InputLabel.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['error', 'info', 'primary', 'secondary', 'success', 'warning']), PropTypes.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['normal', 'small']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var InputLabel$1 = InputLabel;

function getLinearProgressUtilityClass(slot) {
  return generateUtilityClass('MuiLinearProgress', slot);
}
generateUtilityClasses('MuiLinearProgress', ['root', 'colorPrimary', 'colorSecondary', 'determinate', 'indeterminate', 'buffer', 'query', 'dashed', 'dashedColorPrimary', 'dashedColorSecondary', 'bar', 'barColorPrimary', 'barColorSecondary', 'bar1Indeterminate', 'bar1Determinate', 'bar1Buffer', 'bar2Indeterminate', 'bar2Buffer']);

const _excluded$u = ["className", "color", "value", "valueBuffer", "variant"];
let _$1 = t => t,
  _t$1,
  _t2$1,
  _t3$1,
  _t4$1,
  _t5,
  _t6;
const TRANSITION_DURATION = 4; // seconds
const indeterminate1Keyframe = keyframes(_t$1 || (_t$1 = _$1`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const indeterminate2Keyframe = keyframes(_t2$1 || (_t2$1 = _$1`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const bufferKeyframe = keyframes(_t3$1 || (_t3$1 = _$1`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const useUtilityClasses$s = ownerState => {
  const {
    classes,
    variant,
    color
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$1(color)}`, variant],
    dashed: ['dashed', `dashedColor${capitalize$1(color)}`],
    bar1: ['bar', `barColor${capitalize$1(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate', variant === 'determinate' && 'bar1Determinate', variant === 'buffer' && 'bar1Buffer'],
    bar2: ['bar', variant !== 'buffer' && `barColor${capitalize$1(color)}`, variant === 'buffer' && `color${capitalize$1(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate', variant === 'buffer' && 'bar2Buffer']
  };
  return composeClasses$1(slots, getLinearProgressUtilityClass, classes);
};
const getColorShade = (theme, color) => {
  if (color === 'inherit') {
    return 'currentColor';
  }
  if (theme.vars) {
    return theme.vars.palette.LinearProgress[`${color}Bg`];
  }
  return theme.palette.mode === 'light' ? lighten_1(theme.palette[color].main, 0.62) : darken_1(theme.palette[color].main, 0.5);
};
const LinearProgressRoot = styled$2('span', {
  name: 'MuiLinearProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${capitalize$1(ownerState.color)}`], styles[ownerState.variant]];
  }
})(({
  ownerState,
  theme
}) => _extends$X({
  position: 'relative',
  overflow: 'hidden',
  display: 'block',
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  '@media print': {
    colorAdjust: 'exact'
  },
  backgroundColor: getColorShade(theme, ownerState.color)
}, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
  backgroundColor: 'none',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'currentColor',
    opacity: 0.3
  }
}, ownerState.variant === 'buffer' && {
  backgroundColor: 'transparent'
}, ownerState.variant === 'query' && {
  transform: 'rotate(180deg)'
}));
const LinearProgressDashed = styled$2('span', {
  name: 'MuiLinearProgress',
  slot: 'Dashed',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.dashed, styles[`dashedColor${capitalize$1(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => {
  const backgroundColor = getColorShade(theme, ownerState.color);
  return _extends$X({
    position: 'absolute',
    marginTop: 0,
    height: '100%',
    width: '100%'
  }, ownerState.color === 'inherit' && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
    backgroundSize: '10px 10px',
    backgroundPosition: '0 -23px'
  });
}, css(_t4$1 || (_t4$1 = _$1`
    animation: ${0} 3s infinite linear;
  `), bufferKeyframe));
const LinearProgressBar1 = styled$2('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar1',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${capitalize$1(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate, ownerState.variant === 'determinate' && styles.bar1Determinate, ownerState.variant === 'buffer' && styles.bar1Buffer];
  }
})(({
  ownerState,
  theme
}) => _extends$X({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left',
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
}, ownerState.variant === 'determinate' && {
  transition: `transform .${TRANSITION_DURATION}s linear`
}, ownerState.variant === 'buffer' && {
  zIndex: 1,
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && css(_t5 || (_t5 = _$1`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), indeterminate1Keyframe));
const LinearProgressBar2 = styled$2('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar2',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${capitalize$1(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate, ownerState.variant === 'buffer' && styles.bar2Buffer];
  }
})(({
  ownerState,
  theme
}) => _extends$X({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left'
}, ownerState.variant !== 'buffer' && {
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
}, ownerState.color === 'inherit' && {
  opacity: 0.3
}, ownerState.variant === 'buffer' && {
  backgroundColor: getColorShade(theme, ownerState.color),
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && css(_t6 || (_t6 = _$1`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), indeterminate2Keyframe));

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const LinearProgress = /*#__PURE__*/React$1.forwardRef(function LinearProgress(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiLinearProgress'
  });
  const {
      className,
      color = 'primary',
      value,
      valueBuffer,
      variant = 'indeterminate'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$u);
  const ownerState = _extends$X({}, props, {
    color,
    variant
  });
  const classes = useUtilityClasses$s(ownerState);
  const isRtl = useRtl();
  const rootProps = {};
  const inlineStyles = {
    bar1: {},
    bar2: {}
  };
  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      let transform = value - 100;
      if (isRtl) {
        transform = -transform;
      }
      inlineStyles.bar1.transform = `translateX(${transform}%)`;
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('MUI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
    }
  }
  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      let transform = (valueBuffer || 0) - 100;
      if (isRtl) {
        transform = -transform;
      }
      inlineStyles.bar2.transform = `translateX(${transform}%)`;
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('MUI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
    }
  }
  return /*#__PURE__*/jsxRuntimeExports.jsxs(LinearProgressRoot, _extends$X({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other, {
    children: [variant === 'buffer' ? /*#__PURE__*/jsxRuntimeExports.jsx(LinearProgressDashed, {
      className: classes.dashed,
      ownerState: ownerState
    }) : null, /*#__PURE__*/jsxRuntimeExports.jsx(LinearProgressBar1, {
      className: classes.bar1,
      ownerState: ownerState,
      style: inlineStyles.bar1
    }), variant === 'determinate' ? null : /*#__PURE__*/jsxRuntimeExports.jsx(LinearProgressBar2, {
      className: classes.bar2,
      ownerState: ownerState,
      style: inlineStyles.bar2
    })]
  }));
});
process.env.NODE_ENV !== "production" ? LinearProgress.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'primary', 'secondary']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
} : void 0;
var LinearProgress$1 = LinearProgress;

/**
 * @ignore - internal component.
 */
const ListContext = /*#__PURE__*/React$1.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ListContext.displayName = 'ListContext';
}
var ListContext$1 = ListContext;

function getListUtilityClass(slot) {
  return generateUtilityClass('MuiList', slot);
}
generateUtilityClasses('MuiList', ['root', 'padding', 'dense', 'subheader']);

const _excluded$t = ["children", "className", "component", "dense", "disablePadding", "subheader"];
const useUtilityClasses$r = ownerState => {
  const {
    classes,
    disablePadding,
    dense,
    subheader
  } = ownerState;
  const slots = {
    root: ['root', !disablePadding && 'padding', dense && 'dense', subheader && 'subheader']
  };
  return composeClasses$1(slots, getListUtilityClass, classes);
};
const ListRoot = styled$2('ul', {
  name: 'MuiList',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disablePadding && styles.padding, ownerState.dense && styles.dense, ownerState.subheader && styles.subheader];
  }
})(({
  ownerState
}) => _extends$X({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  position: 'relative'
}, !ownerState.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.subheader && {
  paddingTop: 0
}));
const List$1 = /*#__PURE__*/React$1.forwardRef(function List(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiList'
  });
  const {
      children,
      className,
      component = 'ul',
      dense = false,
      disablePadding = false,
      subheader
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$t);
  const context = React$1.useMemo(() => ({
    dense
  }), [dense]);
  const ownerState = _extends$X({}, props, {
    component,
    dense,
    disablePadding
  });
  const classes = useUtilityClasses$r(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(ListContext$1.Provider, {
    value: context,
    children: /*#__PURE__*/jsxRuntimeExports.jsxs(ListRoot, _extends$X({
      as: component,
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [subheader, children]
    }))
  });
});
process.env.NODE_ENV !== "production" ? List$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var MList = List$1;

function getListItemUtilityClass(slot) {
  return generateUtilityClass('MuiListItem', slot);
}
const listItemClasses = generateUtilityClasses('MuiListItem', ['root', 'container', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'padding', 'button', 'secondaryAction', 'selected']);
var listItemClasses$1 = listItemClasses;

const listItemButtonClasses = generateUtilityClasses('MuiListItemButton', ['root', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'selected']);
var listItemButtonClasses$1 = listItemButtonClasses;

function getListItemSecondaryActionClassesUtilityClass(slot) {
  return generateUtilityClass('MuiListItemSecondaryAction', slot);
}
generateUtilityClasses('MuiListItemSecondaryAction', ['root', 'disableGutters']);

const _excluded$s = ["className"];
const useUtilityClasses$q = ownerState => {
  const {
    disableGutters,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disableGutters && 'disableGutters']
  };
  return composeClasses$1(slots, getListItemSecondaryActionClassesUtilityClass, classes);
};
const ListItemSecondaryActionRoot = styled$2('div', {
  name: 'MuiListItemSecondaryAction',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.disableGutters && styles.disableGutters];
  }
})(({
  ownerState
}) => _extends$X({
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)'
}, ownerState.disableGutters && {
  right: 0
}));

/**
 * Must be used as the last child of ListItem to function properly.
 */
const ListItemSecondaryAction = /*#__PURE__*/React$1.forwardRef(function ListItemSecondaryAction(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiListItemSecondaryAction'
  });
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$s);
  const context = React$1.useContext(ListContext$1);
  const ownerState = _extends$X({}, props, {
    disableGutters: context.disableGutters
  });
  const classes = useUtilityClasses$q(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(ListItemSecondaryActionRoot, _extends$X({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListItemSecondaryAction.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var ListItemSecondaryAction$1 = ListItemSecondaryAction;

const _excluded$r = ["className"],
  _excluded2$3 = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"];
const overridesResolver$1 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters, !ownerState.disablePadding && styles.padding, ownerState.button && styles.button, ownerState.hasSecondaryAction && styles.secondaryAction];
};
const useUtilityClasses$p = ownerState => {
  const {
    alignItems,
    button,
    classes,
    dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', !disableGutters && 'gutters', !disablePadding && 'padding', divider && 'divider', disabled && 'disabled', button && 'button', alignItems === 'flex-start' && 'alignItemsFlexStart', hasSecondaryAction && 'secondaryAction', selected && 'selected'],
    container: ['container']
  };
  return composeClasses$1(slots, getListItemUtilityClass, classes);
};
const ListItemRoot = styled$2('div', {
  name: 'MuiListItem',
  slot: 'Root',
  overridesResolver: overridesResolver$1
})(({
  theme,
  ownerState
}) => _extends$X({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  width: '100%',
  boxSizing: 'border-box',
  textAlign: 'left'
}, !ownerState.disablePadding && _extends$X({
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!ownerState.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!ownerState.secondaryAction && {
  [`& > .${listItemButtonClasses$1.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${listItemClasses$1.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${listItemClasses$1.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${listItemClasses$1.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${listItemClasses$1.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  }
}, ownerState.alignItems === 'flex-start' && {
  alignItems: 'flex-start'
}, ownerState.divider && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
  backgroundClip: 'padding-box'
}, ownerState.button && {
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${listItemClasses$1.selected}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  }
}, ownerState.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}));
const ListItemContainer = styled$2('li', {
  name: 'MuiListItem',
  slot: 'Container',
  overridesResolver: (props, styles) => styles.container
})({
  position: 'relative'
});

/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */
const ListItem = /*#__PURE__*/React$1.forwardRef(function ListItem(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiListItem'
  });
  const {
      alignItems = 'center',
      autoFocus = false,
      button = false,
      children: childrenProp,
      className,
      component: componentProp,
      components = {},
      componentsProps = {},
      ContainerComponent = 'li',
      ContainerProps: {
        className: ContainerClassName
      } = {},
      dense = false,
      disabled = false,
      disableGutters = false,
      disablePadding = false,
      divider = false,
      focusVisibleClassName,
      secondaryAction,
      selected = false,
      slotProps = {},
      slots = {}
    } = props,
    ContainerProps = _objectWithoutPropertiesLoose$3(props.ContainerProps, _excluded$r),
    other = _objectWithoutPropertiesLoose$3(props, _excluded2$3);
  const context = React$1.useContext(ListContext$1);
  const childContext = React$1.useMemo(() => ({
    dense: dense || context.dense || false,
    alignItems,
    disableGutters
  }), [alignItems, context.dense, dense, disableGutters]);
  const listItemRef = React$1.useRef(null);
  useEnhancedEffect$1(() => {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('MUI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  const children = React$1.Children.toArray(childrenProp);

  // v4 implementation, deprecated in v5, will be removed in v6
  const hasSecondaryAction = children.length && isMuiElement(children[children.length - 1], ['ListItemSecondaryAction']);
  const ownerState = _extends$X({}, props, {
    alignItems,
    autoFocus,
    button,
    dense: childContext.dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  });
  const classes = useUtilityClasses$p(ownerState);
  const handleRef = useForkRef(listItemRef, ref);
  const Root = slots.root || components.Root || ListItemRoot;
  const rootProps = slotProps.root || componentsProps.root || {};
  const componentProps = _extends$X({
    className: clsx(classes.root, rootProps.className, className),
    disabled
  }, other);
  let Component = componentProp || 'li';
  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = clsx(listItemClasses$1.focusVisible, focusVisibleClassName);
    Component = ButtonBase$1;
  }

  // v4 implementation, deprecated in v5, will be removed in v6
  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component;

    // Avoid nesting of li > li.
    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }
    return /*#__PURE__*/jsxRuntimeExports.jsx(ListContext$1.Provider, {
      value: childContext,
      children: /*#__PURE__*/jsxRuntimeExports.jsxs(ListItemContainer, _extends$X({
        as: ContainerComponent,
        className: clsx(classes.container, ContainerClassName),
        ref: handleRef,
        ownerState: ownerState
      }, ContainerProps, {
        children: [/*#__PURE__*/jsxRuntimeExports.jsx(Root, _extends$X({}, rootProps, !isHostComponent(Root) && {
          as: Component,
          ownerState: _extends$X({}, ownerState, rootProps.ownerState)
        }, componentProps, {
          children: children
        })), children.pop()]
      }))
    });
  }
  return /*#__PURE__*/jsxRuntimeExports.jsx(ListContext$1.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsxRuntimeExports.jsxs(Root, _extends$X({}, rootProps, {
      as: Component,
      ref: handleRef
    }, !isHostComponent(Root) && {
      ownerState: _extends$X({}, ownerState, rootProps.ownerState)
    }, componentProps, {
      children: [children, secondaryAction && /*#__PURE__*/jsxRuntimeExports.jsx(ListItemSecondaryAction$1, {
        children: secondaryAction
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" ? ListItem.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: PropTypes.oneOf(['center', 'flex-start']),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  button: PropTypes.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, props => {
    const children = React$1.Children.toArray(props.children);

    // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
    let secondaryActionIndex = -1;
    for (let i = children.length - 1; i >= 0; i -= 1) {
      const child = children[i];
      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    }

    //  is ListItemSecondaryAction the last child of ListItem
    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('MUI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: elementTypeAcceptingRef$1,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: PropTypes.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: PropTypes.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  selected: PropTypes.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var ListItem$1 = ListItem;

function getListItemIconUtilityClass(slot) {
  return generateUtilityClass('MuiListItemIcon', slot);
}
const listItemIconClasses = generateUtilityClasses('MuiListItemIcon', ['root', 'alignItemsFlexStart']);
var listItemIconClasses$1 = listItemIconClasses;

const _excluded$q = ["className"];
const useUtilityClasses$o = ownerState => {
  const {
    alignItems,
    classes
  } = ownerState;
  const slots = {
    root: ['root', alignItems === 'flex-start' && 'alignItemsFlexStart']
  };
  return composeClasses$1(slots, getListItemIconUtilityClass, classes);
};
const ListItemIconRoot = styled$2('div', {
  name: 'MuiListItemIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  minWidth: 56,
  color: (theme.vars || theme).palette.action.active,
  flexShrink: 0,
  display: 'inline-flex'
}, ownerState.alignItems === 'flex-start' && {
  marginTop: 8
}));

/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */
const ListItemIcon = /*#__PURE__*/React$1.forwardRef(function ListItemIcon(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiListItemIcon'
  });
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$q);
  const context = React$1.useContext(ListContext$1);
  const ownerState = _extends$X({}, props, {
    alignItems: context.alignItems
  });
  const classes = useUtilityClasses$o(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(ListItemIconRoot, _extends$X({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListItemIcon.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var ListItemIcon$1 = ListItemIcon;

const listItemTextClasses = generateUtilityClasses('MuiListItemText', ['root', 'multiline', 'dense', 'inset', 'primary', 'secondary']);
var listItemTextClasses$1 = listItemTextClasses;

const _excluded$p = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }
  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }
  return disableListWrap ? null : list.firstChild;
}
function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }
  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }
  return disableListWrap ? null : list.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }
  let text = nextFocus.innerText;
  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }
  text = text.trim().toLowerCase();
  if (text.length === 0) {
    return false;
  }
  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }
  return text.indexOf(textCriteria.keys.join('')) === 0;
}
function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  let wrappedOnce = false;
  let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return false;
      }
      wrappedOnce = true;
    }

    // Same logic as useAutocomplete.js
    const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return true;
    }
  }
  return false;
}

/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */
const MenuList$1 = /*#__PURE__*/React$1.forwardRef(function MenuList(props, ref) {
  const {
      // private
      // eslint-disable-next-line react/prop-types
      actions,
      autoFocus = false,
      autoFocusItem = false,
      children,
      className,
      disabledItemsFocusable = false,
      disableListWrap = false,
      onKeyDown,
      variant = 'selectedMenu'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$p);
  const listRef = React$1.useRef(null);
  const textCriteriaRef = React$1.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect$1(() => {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  React$1.useImperativeHandle(actions, () => ({
    adjustStyleForScrollbar: (containerElement, {
      direction
    }) => {
      // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.
      const noExplicitWidth = !listRef.current.style.width;
      if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
        const scrollbarSize = `${getScrollbarSize(ownerDocument(containerElement))}px`;
        listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
        listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
      }
      return listRef.current;
    }
  }), []);
  const handleKeyDown = event => {
    const list = listRef.current;
    const key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */
    const currentFocus = ownerDocument(list).activeElement;
    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      const criteria = textCriteriaRef.current;
      const lowerKey = key.toLowerCase();
      const currTime = performance.now();
      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }
      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  const handleRef = useForkRef(listRef, ref);

  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */
  let activeItemIndex = -1;
  // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback
  React$1.Children.forEach(children, (child, index) => {
    if (! /*#__PURE__*/React$1.isValidElement(child)) {
      if (activeItemIndex === index) {
        activeItemIndex += 1;
        if (activeItemIndex >= children.length) {
          // there are no focusable items within the list.
          activeItemIndex = -1;
        }
      }
      return;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (reactIsExports.isFragment(child)) {
        console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
    if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
      activeItemIndex += 1;
      if (activeItemIndex >= children.length) {
        // there are no focusable items within the list.
        activeItemIndex = -1;
      }
    }
  });
  const items = React$1.Children.map(children, (child, index) => {
    if (index === activeItemIndex) {
      const newChildProps = {};
      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }
      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }
      return /*#__PURE__*/React$1.cloneElement(child, newChildProps);
    }
    return child;
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx(MList, _extends$X({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other, {
    children: items
  }));
});
process.env.NODE_ENV !== "production" ? MenuList$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
var MMenuList = MenuList$1;

function getPopoverUtilityClass(slot) {
  return generateUtilityClass('MuiPopover', slot);
}
generateUtilityClasses('MuiPopover', ['root', 'paper']);

const _excluded$o = ["onEntering"],
  _excluded2$2 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"],
  _excluded3 = ["slotProps"];
function getOffsetTop(rect, vertical) {
  let offset = 0;
  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }
  return offset;
}
function getOffsetLeft(rect, horizontal) {
  let offset = 0;
  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }
  return offset;
}
function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(n => typeof n === 'number' ? `${n}px` : n).join(' ');
}
function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const useUtilityClasses$n = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper']
  };
  return composeClasses$1(slots, getPopoverUtilityClass, classes);
};
const PopoverRoot = styled$2(Modal$1, {
  name: 'MuiPopover',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const PopoverPaper = styled$2(Paper$1, {
  name: 'MuiPopover',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  position: 'absolute',
  overflowY: 'auto',
  overflowX: 'hidden',
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: 'calc(100% - 32px)',
  maxHeight: 'calc(100% - 32px)',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Popover = /*#__PURE__*/React$1.forwardRef(function Popover(inProps, ref) {
  var _slotProps$paper, _slots$root, _slots$paper;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiPopover'
  });
  const {
      action,
      anchorEl,
      anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
      },
      anchorPosition,
      anchorReference = 'anchorEl',
      children,
      className,
      container: containerProp,
      elevation = 8,
      marginThreshold = 16,
      open,
      PaperProps: PaperPropsProp = {},
      slots,
      slotProps,
      transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
      },
      TransitionComponent = Grow$1,
      transitionDuration: transitionDurationProp = 'auto',
      TransitionProps: {
        onEntering
      } = {},
      disableScrollLock = false
    } = props,
    TransitionProps = _objectWithoutPropertiesLoose$3(props.TransitionProps, _excluded$o),
    other = _objectWithoutPropertiesLoose$3(props, _excluded2$2);
  const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
  const paperRef = React$1.useRef();
  const handlePaperRef = useForkRef(paperRef, externalPaperSlotProps.ref);
  const ownerState = _extends$X({}, props, {
    anchorOrigin,
    anchorReference,
    elevation,
    marginThreshold,
    externalPaperSlotProps,
    transformOrigin,
    TransitionComponent,
    transitionDuration: transitionDurationProp,
    TransitionProps
  });
  const classes = useUtilityClasses$n(ownerState);

  // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)
  const getAnchorOffset = React$1.useCallback(() => {
    if (anchorReference === 'anchorPosition') {
      if (process.env.NODE_ENV !== 'production') {
        if (!anchorPosition) {
          console.error('MUI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }
      return anchorPosition;
    }
    const resolvedAnchorEl = resolveAnchorEl(anchorEl);

    // If an anchor element wasn't provided, just use the parent body element of this Popover
    const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : ownerDocument(paperRef.current).body;
    const anchorRect = anchorElement.getBoundingClientRect();
    if (process.env.NODE_ENV !== 'production') {
      const box = anchorElement.getBoundingClientRect();
      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]);

  // Returns the base transform origin using the element
  const getTransformOrigin = React$1.useCallback(elemRect => {
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical),
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  const getPositioningStyle = React$1.useCallback(element => {
    const elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    };

    // Get the transform origin point on the element itself
    const elemTransformOrigin = getTransformOrigin(elemRect);
    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    }

    // Get the offset of the anchoring element
    const anchorOffset = getAnchorOffset();

    // Calculate element positioning
    let top = anchorOffset.top - elemTransformOrigin.vertical;
    let left = anchorOffset.left - elemTransformOrigin.horizontal;
    const bottom = top + elemRect.height;
    const right = left + elemRect.width;

    // Use the parent window of the anchorEl if provided
    const containerWindow = ownerWindow(resolveAnchorEl(anchorEl));

    // Window thresholds taking required margin into account
    const heightThreshold = containerWindow.innerHeight - marginThreshold;
    const widthThreshold = containerWindow.innerWidth - marginThreshold;

    // Check if the vertical axis needs shifting
    if (marginThreshold !== null && top < marginThreshold) {
      const diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (marginThreshold !== null && bottom > heightThreshold) {
      const diff = bottom - heightThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['MUI: The popover component is too tall.', `Some part of it can not be seen on the screen (${elemRect.height - heightThreshold}px).`, 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    }

    // Check if the horizontal axis needs shifting
    if (marginThreshold !== null && left < marginThreshold) {
      const diff = left - marginThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    } else if (right > widthThreshold) {
      const diff = right - widthThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    }
    return {
      top: `${Math.round(top)}px`,
      left: `${Math.round(left)}px`,
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getTransformOrigin, marginThreshold]);
  const [isPositioned, setIsPositioned] = React$1.useState(open);
  const setPositioningStyles = React$1.useCallback(() => {
    const element = paperRef.current;
    if (!element) {
      return;
    }
    const positioning = getPositioningStyle(element);
    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }
    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }
    element.style.transformOrigin = positioning.transformOrigin;
    setIsPositioned(true);
  }, [getPositioningStyle]);
  React$1.useEffect(() => {
    if (disableScrollLock) {
      window.addEventListener('scroll', setPositioningStyles);
    }
    return () => window.removeEventListener('scroll', setPositioningStyles);
  }, [anchorEl, disableScrollLock, setPositioningStyles]);
  const handleEntering = (element, isAppearing) => {
    if (onEntering) {
      onEntering(element, isAppearing);
    }
    setPositioningStyles();
  };
  const handleExited = () => {
    setIsPositioned(false);
  };
  React$1.useEffect(() => {
    if (open) {
      setPositioningStyles();
    }
  });
  React$1.useImperativeHandle(action, () => open ? {
    updatePosition: () => {
      setPositioningStyles();
    }
  } : null, [open, setPositioningStyles]);
  React$1.useEffect(() => {
    if (!open) {
      return undefined;
    }
    const handleResize = debounce$1(() => {
      setPositioningStyles();
    });
    const containerWindow = ownerWindow(anchorEl);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [anchorEl, open, setPositioningStyles]);
  let transitionDuration = transitionDurationProp;
  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  }

  // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container
  const container = containerProp || (anchorEl ? ownerDocument(resolveAnchorEl(anchorEl)).body : undefined);
  const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : PopoverRoot;
  const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : PopoverPaper;
  const paperProps = useSlotProps({
    elementType: PaperSlot,
    externalSlotProps: _extends$X({}, externalPaperSlotProps, {
      style: isPositioned ? externalPaperSlotProps.style : _extends$X({}, externalPaperSlotProps.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation,
      ref: handlePaperRef
    },
    ownerState,
    className: clsx(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
  });
  const _useSlotProps = useSlotProps({
      elementType: RootSlot,
      externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
      externalForwardedProps: other,
      additionalProps: {
        ref,
        slotProps: {
          backdrop: {
            invisible: true
          }
        },
        container,
        open
      },
      ownerState,
      className: clsx(classes.root, className)
    }),
    {
      slotProps: rootSlotPropsProp
    } = _useSlotProps,
    rootProps = _objectWithoutPropertiesLoose$3(_useSlotProps, _excluded3);
  return /*#__PURE__*/jsxRuntimeExports.jsx(RootSlot, _extends$X({}, rootProps, !isHostComponent(RootSlot) && {
    slotProps: rootSlotPropsProp,
    disableScrollLock
  }, {
    children: /*#__PURE__*/jsxRuntimeExports.jsx(TransitionComponent, _extends$X({
      appear: true,
      in: open,
      onEntering: handleEntering,
      onExited: handleExited,
      timeout: transitionDuration
    }, TransitionProps, {
      children: /*#__PURE__*/jsxRuntimeExports.jsx(PaperSlot, _extends$X({}, paperProps, {
        children: children
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Popover.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType$1,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), props => {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      const resolvedAnchorEl = resolveAnchorEl(props.anchorEl);
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        const box = resolvedAnchorEl.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', `It should be an Element or PopoverVirtualElement instance but it's \`${resolvedAnchorEl}\` instead.`].join('\n'));
      }
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: PropTypes /* @typescript-to-proptypes-ignore */.shape({
    component: elementTypeAcceptingRef$1
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object
} : void 0;
var Popover$1 = Popover;

function getMenuUtilityClass(slot) {
  return generateUtilityClass('MuiMenu', slot);
}
generateUtilityClasses('MuiMenu', ['root', 'paper', 'list']);

const _excluded$n = ["onEntering"],
  _excluded2$1 = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"];
const RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
const LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
const useUtilityClasses$m = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper'],
    list: ['list']
  };
  return composeClasses$1(slots, getMenuUtilityClass, classes);
};
const MenuRoot = styled$2(Popover$1, {
  shouldForwardProp: prop => rootShouldForwardProp$2(prop) || prop === 'classes',
  name: 'MuiMenu',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const MenuPaper = styled$2(PopoverPaper, {
  name: 'MuiMenu',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: 'calc(100% - 96px)',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch'
});
const MenuMenuList = styled$2(MMenuList, {
  name: 'MuiMenu',
  slot: 'List',
  overridesResolver: (props, styles) => styles.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Menu = /*#__PURE__*/React$1.forwardRef(function Menu(inProps, ref) {
  var _slots$paper, _slotProps$paper;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiMenu'
  });
  const {
      autoFocus = true,
      children,
      className,
      disableAutoFocusItem = false,
      MenuListProps = {},
      onClose,
      open,
      PaperProps = {},
      PopoverClasses,
      transitionDuration = 'auto',
      TransitionProps: {
        onEntering
      } = {},
      variant = 'selectedMenu',
      slots = {},
      slotProps = {}
    } = props,
    TransitionProps = _objectWithoutPropertiesLoose$3(props.TransitionProps, _excluded$n),
    other = _objectWithoutPropertiesLoose$3(props, _excluded2$1);
  const isRtl = useRtl();
  const ownerState = _extends$X({}, props, {
    autoFocus,
    disableAutoFocusItem,
    MenuListProps,
    onEntering,
    PaperProps,
    transitionDuration,
    TransitionProps,
    variant
  });
  const classes = useUtilityClasses$m(ownerState);
  const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  const menuListActionsRef = React$1.useRef(null);
  const handleEntering = (element, isAppearing) => {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, {
        direction: isRtl ? 'rtl' : 'ltr'
      });
    }
    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };
  const handleListKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault();
      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };

  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */
  let activeItemIndex = -1;
  // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback
  React$1.Children.map(children, (child, index) => {
    if (! /*#__PURE__*/React$1.isValidElement(child)) {
      return;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (reactIsExports.isFragment(child)) {
        console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : MenuPaper;
  const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
  const rootSlotProps = useSlotProps({
    elementType: slots.root,
    externalSlotProps: slotProps.root,
    ownerState,
    className: [classes.root, className]
  });
  const paperSlotProps = useSlotProps({
    elementType: PaperSlot,
    externalSlotProps: paperExternalSlotProps,
    ownerState,
    className: classes.paper
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx(MenuRoot, _extends$X({
    onClose: onClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: isRtl ? 'right' : 'left'
    },
    transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      paper: PaperSlot,
      root: slots.root
    },
    slotProps: {
      root: rootSlotProps,
      paper: paperSlotProps
    },
    open: open,
    ref: ref,
    transitionDuration: transitionDuration,
    TransitionProps: _extends$X({
      onEntering: handleEntering
    }, TransitionProps),
    ownerState: ownerState
  }, other, {
    classes: PopoverClasses,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(MenuMenuList, _extends$X({
      onKeyDown: handleListKeyDown,
      actions: menuListActionsRef,
      autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
      autoFocusItem: autoFocusItem,
      variant: variant
    }, MenuListProps, {
      className: clsx(classes.list, MenuListProps.className),
      children: children
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Menu.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: PropTypes.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
var Menu$1 = Menu;

function getMenuItemUtilityClass(slot) {
  return generateUtilityClass('MuiMenuItem', slot);
}
const menuItemClasses = generateUtilityClasses('MuiMenuItem', ['root', 'focusVisible', 'dense', 'disabled', 'divider', 'gutters', 'selected']);
var menuItemClasses$1 = menuItemClasses;

const _excluded$m = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"];
const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
};
const useUtilityClasses$l = ownerState => {
  const {
    disabled,
    dense,
    divider,
    disableGutters,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', disabled && 'disabled', !disableGutters && 'gutters', divider && 'divider', selected && 'selected']
  };
  const composedClasses = composeClasses$1(slots, getMenuItemUtilityClass, classes);
  return _extends$X({}, classes, composedClasses);
};
const MenuItemRoot = styled$2(ButtonBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp$2(prop) || prop === 'classes',
  name: 'MuiMenuItem',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => _extends$X({}, theme.typography.body1, {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: 'border-box',
  whiteSpace: 'nowrap'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.divider && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
  backgroundClip: 'padding-box'
}, {
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${menuItemClasses$1.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${menuItemClasses$1.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${menuItemClasses$1.selected}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  },
  [`&.${menuItemClasses$1.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${menuItemClasses$1.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  },
  [`& + .${dividerClasses$1.root}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  [`& + .${dividerClasses$1.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses$1.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses$1.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses$1.root}`]: {
    minWidth: 36
  }
}, !ownerState.dense && {
  [theme.breakpoints.up('sm')]: {
    minHeight: 'auto'
  }
}, ownerState.dense && _extends$X({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, theme.typography.body2, {
  [`& .${listItemIconClasses$1.root} svg`]: {
    fontSize: '1.25rem'
  }
})));
const MenuItem = /*#__PURE__*/React$1.forwardRef(function MenuItem(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiMenuItem'
  });
  const {
      autoFocus = false,
      component = 'li',
      dense = false,
      divider = false,
      disableGutters = false,
      focusVisibleClassName,
      role = 'menuitem',
      tabIndex: tabIndexProp,
      className
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$m);
  const context = React$1.useContext(ListContext$1);
  const childContext = React$1.useMemo(() => ({
    dense: dense || context.dense || false,
    disableGutters
  }), [context.dense, dense, disableGutters]);
  const menuItemRef = React$1.useRef(null);
  useEnhancedEffect$1(() => {
    if (autoFocus) {
      if (menuItemRef.current) {
        menuItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('MUI: Unable to set focus to a MenuItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  const ownerState = _extends$X({}, props, {
    dense: childContext.dense,
    divider,
    disableGutters
  });
  const classes = useUtilityClasses$l(props);
  const handleRef = useForkRef(menuItemRef, ref);
  let tabIndex;
  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }
  return /*#__PURE__*/jsxRuntimeExports.jsx(ListContext$1.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(MenuItemRoot, _extends$X({
      ref: handleRef,
      role: role,
      tabIndex: tabIndex,
      component: component,
      focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
      className: clsx(classes.root, className)
    }, other, {
      ownerState: ownerState,
      classes: classes
    }))
  });
});
process.env.NODE_ENV !== "production" ? MenuItem.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * @ignore
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  role: PropTypes /* @typescript-to-proptypes-ignore */.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number
} : void 0;
var MenuItem$1 = MenuItem;

function getNativeSelectUtilityClasses(slot) {
  return generateUtilityClass('MuiNativeSelect', slot);
}
const nativeSelectClasses = generateUtilityClasses('MuiNativeSelect', ['root', 'select', 'multiple', 'filled', 'outlined', 'standard', 'disabled', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput', 'error']);
var nativeSelectClasses$1 = nativeSelectClasses;

const _excluded$l = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"];
const useUtilityClasses$k = ownerState => {
  const {
    classes,
    variant,
    disabled,
    multiple,
    open,
    error
  } = ownerState;
  const slots = {
    select: ['select', variant, disabled && 'disabled', multiple && 'multiple', error && 'error'],
    icon: ['icon', `icon${capitalize$1(variant)}`, open && 'iconOpen', disabled && 'disabled']
  };
  return composeClasses$1(slots, getNativeSelectUtilityClasses, classes);
};
const nativeSelectSelectStyles = ({
  ownerState,
  theme
}) => _extends$X({
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: 'none',
  borderRadius: 0,
  // Reset
  cursor: 'pointer',
  '&:focus': _extends$X({}, theme.vars ? {
    backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
  }, {
    borderRadius: 0 // Reset Chrome style
  }),
  // Remove IE11 arrow
  '&::-ms-expand': {
    display: 'none'
  },
  [`&.${nativeSelectClasses$1.disabled}`]: {
    cursor: 'default'
  },
  '&[multiple]': {
    height: 'auto'
  },
  '&:not([multiple]) option, &:not([multiple]) optgroup': {
    backgroundColor: (theme.vars || theme).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  '&&&': {
    paddingRight: 24,
    minWidth: 16 // So it doesn't collapse.
  }
}, ownerState.variant === 'filled' && {
  '&&&': {
    paddingRight: 32
  }
}, ownerState.variant === 'outlined' && {
  borderRadius: (theme.vars || theme).shape.borderRadius,
  '&:focus': {
    borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
  },
  '&&&': {
    paddingRight: 32
  }
});
const NativeSelectSelect = styled$2('select', {
  name: 'MuiNativeSelect',
  slot: 'Select',
  shouldForwardProp: rootShouldForwardProp$2,
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.select, styles[ownerState.variant], ownerState.error && styles.error, {
      [`&.${nativeSelectClasses$1.multiple}`]: styles.multiple
    }];
  }
})(nativeSelectSelectStyles);
const nativeSelectIconStyles = ({
  ownerState,
  theme
}) => _extends$X({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: 'absolute',
  right: 0,
  top: 'calc(50% - .5em)',
  // Center vertically, height is 1em
  pointerEvents: 'none',
  // Don't block pointer events on the select under the icon.
  color: (theme.vars || theme).palette.action.active,
  [`&.${nativeSelectClasses$1.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}, ownerState.open && {
  transform: 'rotate(180deg)'
}, ownerState.variant === 'filled' && {
  right: 7
}, ownerState.variant === 'outlined' && {
  right: 7
});
const NativeSelectIcon = styled$2('svg', {
  name: 'MuiNativeSelect',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, ownerState.variant && styles[`icon${capitalize$1(ownerState.variant)}`], ownerState.open && styles.iconOpen];
  }
})(nativeSelectIconStyles);

/**
 * @ignore - internal component.
 */
const NativeSelectInput = /*#__PURE__*/React$1.forwardRef(function NativeSelectInput(props, ref) {
  const {
      className,
      disabled,
      error,
      IconComponent,
      inputRef,
      variant = 'standard'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$l);
  const ownerState = _extends$X({}, props, {
    disabled,
    variant,
    error
  });
  const classes = useUtilityClasses$k(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/*#__PURE__*/jsxRuntimeExports.jsx(NativeSelectSelect, _extends$X({
      ownerState: ownerState,
      className: clsx(classes.select, className),
      disabled: disabled,
      ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/jsxRuntimeExports.jsx(NativeSelectIcon, {
      as: IconComponent,
      ownerState: ownerState,
      className: classes.icon
    })]
  });
});
process.env.NODE_ENV !== "production" ? NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType$1,
  /**
   * @ignore
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
var NativeSelectInput$1 = NativeSelectInput;

var _span$1;
const _excluded$k = ["children", "classes", "className", "label", "notched"];
const NotchedOutlineRoot$1 = styled$2('fieldset', {
  shouldForwardProp: rootShouldForwardProp$2
})({
  textAlign: 'left',
  position: 'absolute',
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: '0 8px',
  pointerEvents: 'none',
  borderRadius: 'inherit',
  borderStyle: 'solid',
  borderWidth: 1,
  overflow: 'hidden',
  minWidth: '0%'
});
const NotchedOutlineLegend = styled$2('legend', {
  shouldForwardProp: rootShouldForwardProp$2
})(({
  ownerState,
  theme
}) => _extends$X({
  float: 'unset',
  // Fix conflict with bootstrap
  width: 'auto',
  // Fix conflict with bootstrap
  overflow: 'hidden'
}, !ownerState.withLabel && {
  padding: 0,
  lineHeight: '11px',
  // sync with `height` in `legend` styles
  transition: theme.transitions.create('width', {
    duration: 150,
    easing: theme.transitions.easing.easeOut
  })
}, ownerState.withLabel && _extends$X({
  display: 'block',
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: '0.75em',
  visibility: 'hidden',
  maxWidth: 0.01,
  transition: theme.transitions.create('max-width', {
    duration: 50,
    easing: theme.transitions.easing.easeOut
  }),
  whiteSpace: 'nowrap',
  '& > span': {
    paddingLeft: 5,
    paddingRight: 5,
    display: 'inline-block',
    opacity: 0,
    visibility: 'visible'
  }
}, ownerState.notched && {
  maxWidth: '100%',
  transition: theme.transitions.create('max-width', {
    duration: 100,
    easing: theme.transitions.easing.easeOut,
    delay: 50
  })
})));

/**
 * @ignore - internal component.
 */
function NotchedOutline(props) {
  const {
      className,
      label,
      notched
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$k);
  const withLabel = label != null && label !== '';
  const ownerState = _extends$X({}, props, {
    notched,
    withLabel
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx(NotchedOutlineRoot$1, _extends$X({
    "aria-hidden": true,
    className: className,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsxRuntimeExports.jsx(NotchedOutlineLegend, {
      ownerState: ownerState,
      children: withLabel ? /*#__PURE__*/jsxRuntimeExports.jsx("span", {
        children: label
      }) : // notranslate needed while Google Translate will not fix zero-width space issue
      _span$1 || (_span$1 = /*#__PURE__*/jsxRuntimeExports.jsx("span", {
        className: "notranslate",
        children: "\u200B"
      }))
    })
  }));
}
process.env.NODE_ENV !== "production" ? NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The label.
   */
  label: PropTypes.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;

const _excluded$j = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"];
const useUtilityClasses$j = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    notchedOutline: ['notchedOutline'],
    input: ['input']
  };
  const composedClasses = composeClasses$1(slots, getOutlinedInputUtilityClass, classes);
  return _extends$X({}, classes, composedClasses);
};
const OutlinedInputRoot = styled$2(InputBaseRoot, {
  shouldForwardProp: prop => rootShouldForwardProp$2(prop) || prop === 'classes',
  name: 'MuiOutlinedInput',
  slot: 'Root',
  overridesResolver: rootOverridesResolver
})(({
  theme,
  ownerState
}) => {
  const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return _extends$X({
    position: 'relative',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    [`&:hover .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      [`&:hover .${outlinedInputClasses$1.notchedOutline}`]: {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
      }
    },
    [`&.${outlinedInputClasses$1.focused} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette[ownerState.color].main,
      borderWidth: 2
    },
    [`&.${outlinedInputClasses$1.error} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.error.main
    },
    [`&.${outlinedInputClasses$1.disabled} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.action.disabled
    }
  }, ownerState.startAdornment && {
    paddingLeft: 14
  }, ownerState.endAdornment && {
    paddingRight: 14
  }, ownerState.multiline && _extends$X({
    padding: '16.5px 14px'
  }, ownerState.size === 'small' && {
    padding: '8.5px 14px'
  }));
});
const NotchedOutlineRoot = styled$2(NotchedOutline, {
  name: 'MuiOutlinedInput',
  slot: 'NotchedOutline',
  overridesResolver: (props, styles) => styles.notchedOutline
})(({
  theme
}) => {
  const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
  };
});
const OutlinedInputInput = styled$2(InputBaseComponent, {
  name: 'MuiOutlinedInput',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})(({
  theme,
  ownerState
}) => _extends$X({
  padding: '16.5px 14px'
}, !theme.vars && {
  '&:-webkit-autofill': {
    WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
    WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
    caretColor: theme.palette.mode === 'light' ? null : '#fff',
    borderRadius: 'inherit'
  }
}, theme.vars && {
  '&:-webkit-autofill': {
    borderRadius: 'inherit'
  },
  [theme.getColorSchemeSelector('dark')]: {
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px #266798 inset',
      WebkitTextFillColor: '#fff',
      caretColor: '#fff'
    }
  }
}, ownerState.size === 'small' && {
  padding: '8.5px 14px'
}, ownerState.multiline && {
  padding: 0
}, ownerState.startAdornment && {
  paddingLeft: 0
}, ownerState.endAdornment && {
  paddingRight: 0
}));
const OutlinedInput = /*#__PURE__*/React$1.forwardRef(function OutlinedInput(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiOutlinedInput'
  });
  const {
      components = {},
      fullWidth = false,
      inputComponent = 'input',
      label,
      multiline = false,
      notched,
      slots = {},
      type = 'text'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$j);
  const classes = useUtilityClasses$j(props);
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['color', 'disabled', 'error', 'focused', 'hiddenLabel', 'size', 'required']
  });
  const ownerState = _extends$X({}, props, {
    color: fcs.color || 'primary',
    disabled: fcs.disabled,
    error: fcs.error,
    focused: fcs.focused,
    formControl: muiFormControl,
    fullWidth,
    hiddenLabel: fcs.hiddenLabel,
    multiline,
    size: fcs.size,
    type
  });
  const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : OutlinedInputRoot;
  const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : OutlinedInputInput;
  return /*#__PURE__*/jsxRuntimeExports.jsx(InputBase$1, _extends$X({
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    renderSuffix: state => /*#__PURE__*/jsxRuntimeExports.jsx(NotchedOutlineRoot, {
      ownerState: ownerState,
      className: classes.notchedOutline,
      label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [label, "\u2009", '*']
      })) : label,
      notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: _extends$X({}, classes, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" ? OutlinedInput.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['primary', 'secondary']), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: PropTypes.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(['dense', 'none']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
OutlinedInput.muiName = 'Input';
var OutlinedInput$1 = OutlinedInput;

var RadioButtonUncheckedIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

var RadioButtonCheckedIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

const RadioButtonIconRoot = styled$2('span', {
  shouldForwardProp: rootShouldForwardProp$2
})({
  position: 'relative',
  display: 'flex'
});
const RadioButtonIconBackground = styled$2(RadioButtonUncheckedIcon)({
  // Scale applied to prevent dot misalignment in Safari
  transform: 'scale(1)'
});
const RadioButtonIconDot = styled$2(RadioButtonCheckedIcon)(({
  theme,
  ownerState
}) => _extends$X({
  left: 0,
  position: 'absolute',
  transform: 'scale(0)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.shortest
  })
}, ownerState.checked && {
  transform: 'scale(1)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.shortest
  })
}));

/**
 * @ignore - internal component.
 */
function RadioButtonIcon(props) {
  const {
    checked = false,
    classes = {},
    fontSize
  } = props;
  const ownerState = _extends$X({}, props, {
    checked
  });
  return /*#__PURE__*/jsxRuntimeExports.jsxs(RadioButtonIconRoot, {
    className: classes.root,
    ownerState: ownerState,
    children: [/*#__PURE__*/jsxRuntimeExports.jsx(RadioButtonIconBackground, {
      fontSize: fontSize,
      className: classes.background,
      ownerState: ownerState
    }), /*#__PURE__*/jsxRuntimeExports.jsx(RadioButtonIconDot, {
      fontSize: fontSize,
      className: classes.dot,
      ownerState: ownerState
    })]
  });
}
process.env.NODE_ENV !== "production" ? RadioButtonIcon.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: PropTypes.oneOf(['small', 'medium'])
} : void 0;

/**
 * @ignore - internal component.
 */
const RadioGroupContext = /*#__PURE__*/React$1.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  RadioGroupContext.displayName = 'RadioGroupContext';
}
var RadioGroupContext$1 = RadioGroupContext;

function useRadioGroup() {
  return React$1.useContext(RadioGroupContext$1);
}

function getRadioUtilityClass(slot) {
  return generateUtilityClass('MuiRadio', slot);
}
const radioClasses = generateUtilityClasses('MuiRadio', ['root', 'checked', 'disabled', 'colorPrimary', 'colorSecondary', 'sizeSmall']);
var radioClasses$1 = radioClasses;

const _excluded$i = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"];
const useUtilityClasses$i = ownerState => {
  const {
    classes,
    color,
    size
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$1(color)}`, size !== 'medium' && `size${capitalize$1(size)}`]
  };
  return _extends$X({}, classes, composeClasses$1(slots, getRadioUtilityClass, classes));
};
const RadioRoot = styled$2(SwitchBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp$2(prop) || prop === 'classes',
  name: 'MuiRadio',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.size !== 'medium' && styles[`size${capitalize$1(ownerState.size)}`], styles[`color${capitalize$1(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha_1(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${radioClasses$1.checked}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  }
}, {
  [`&.${radioClasses$1.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}));
function areEqualValues$1(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  }

  // The value could be a number, the DOM will stringify it anyway.
  return String(a) === String(b);
}
const defaultCheckedIcon = /*#__PURE__*/jsxRuntimeExports.jsx(RadioButtonIcon, {
  checked: true
});
const defaultIcon = /*#__PURE__*/jsxRuntimeExports.jsx(RadioButtonIcon, {});
const Radio = /*#__PURE__*/React$1.forwardRef(function Radio(inProps, ref) {
  var _defaultIcon$props$fo, _defaultCheckedIcon$p;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiRadio'
  });
  const {
      checked: checkedProp,
      checkedIcon = defaultCheckedIcon,
      color = 'primary',
      icon = defaultIcon,
      name: nameProp,
      onChange: onChangeProp,
      size = 'medium',
      className
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$i);
  const ownerState = _extends$X({}, props, {
    color,
    size
  });
  const classes = useUtilityClasses$i(ownerState);
  const radioGroup = useRadioGroup();
  let checked = checkedProp;
  const onChange = createChainedFunction(onChangeProp, radioGroup && radioGroup.onChange);
  let name = nameProp;
  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = areEqualValues$1(radioGroup.value, props.value);
    }
    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }
  return /*#__PURE__*/jsxRuntimeExports.jsx(RadioRoot, _extends$X({
    type: "radio",
    icon: /*#__PURE__*/React$1.cloneElement(icon, {
      fontSize: (_defaultIcon$props$fo = defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
    }),
    checkedIcon: /*#__PURE__*/React$1.cloneElement(checkedIcon, {
      fontSize: (_defaultCheckedIcon$p = defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
    }),
    ownerState: ownerState,
    classes: classes,
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref,
    className: clsx(classes.root, className)
  }, other));
});
process.env.NODE_ENV !== "production" ? Radio.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
var Radio$1 = Radio;

function getRadioGroupUtilityClass(slot) {
  return generateUtilityClass('MuiRadioGroup', slot);
}
generateUtilityClasses('MuiRadioGroup', ['root', 'row', 'error']);

const _excluded$h = ["actions", "children", "className", "defaultValue", "name", "onChange", "value"];
const useUtilityClasses$h = props => {
  const {
    classes,
    row,
    error
  } = props;
  const slots = {
    root: ['root', row && 'row', error && 'error']
  };
  return composeClasses$1(slots, getRadioGroupUtilityClass, classes);
};
const RadioGroup$1 = /*#__PURE__*/React$1.forwardRef(function RadioGroup(props, ref) {
  const {
      // private
      // eslint-disable-next-line react/prop-types
      actions,
      children,
      className,
      defaultValue,
      name: nameProp,
      onChange,
      value: valueProp
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$h);
  const rootRef = React$1.useRef(null);
  const classes = useUtilityClasses$h(props);
  const [value, setValueState] = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'RadioGroup'
  });
  React$1.useImperativeHandle(actions, () => ({
    focus: () => {
      let input = rootRef.current.querySelector('input:not(:disabled):checked');
      if (!input) {
        input = rootRef.current.querySelector('input:not(:disabled)');
      }
      if (input) {
        input.focus();
      }
    }
  }), []);
  const handleRef = useForkRef(ref, rootRef);
  const name = useId(nameProp);
  const contextValue = React$1.useMemo(() => ({
    name,
    onChange(event) {
      setValueState(event.target.value);
      if (onChange) {
        onChange(event, event.target.value);
      }
    },
    value
  }), [name, onChange, setValueState, value]);
  return /*#__PURE__*/jsxRuntimeExports.jsx(RadioGroupContext$1.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(FormGroup$1, _extends$X({
      role: "radiogroup",
      ref: handleRef,
      className: clsx(classes.root, className)
    }, other, {
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? RadioGroup$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: PropTypes.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
var MRadioGroup = RadioGroup$1;

function getSelectUtilityClasses(slot) {
  return generateUtilityClass('MuiSelect', slot);
}
const selectClasses = generateUtilityClasses('MuiSelect', ['root', 'select', 'multiple', 'filled', 'outlined', 'standard', 'disabled', 'focused', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput', 'error']);
var selectClasses$1 = selectClasses;

var _span;
const _excluded$g = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"];
const SelectSelect = styled$2('div', {
  name: 'MuiSelect',
  slot: 'Select',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [
    // Win specificity over the input base
    {
      [`&.${selectClasses$1.select}`]: styles.select
    }, {
      [`&.${selectClasses$1.select}`]: styles[ownerState.variant]
    }, {
      [`&.${selectClasses$1.error}`]: styles.error
    }, {
      [`&.${selectClasses$1.multiple}`]: styles.multiple
    }];
  }
})(nativeSelectSelectStyles, {
  // Win specificity over the input base
  [`&.${selectClasses$1.select}`]: {
    height: 'auto',
    // Resets for multiple select with chips
    minHeight: '1.4375em',
    // Required for select\text-field height consistency
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
});
const SelectIcon = styled$2('svg', {
  name: 'MuiSelect',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, ownerState.variant && styles[`icon${capitalize$1(ownerState.variant)}`], ownerState.open && styles.iconOpen];
  }
})(nativeSelectIconStyles);
const SelectNativeInput = styled$2('input', {
  shouldForwardProp: prop => slotShouldForwardProp(prop) && prop !== 'classes',
  name: 'MuiSelect',
  slot: 'NativeInput',
  overridesResolver: (props, styles) => styles.nativeInput
})({
  bottom: 0,
  left: 0,
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
  width: '100%',
  boxSizing: 'border-box'
});
function areEqualValues(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  }

  // The value could be a number, the DOM will stringify it anyway.
  return String(a) === String(b);
}
function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
const useUtilityClasses$g = ownerState => {
  const {
    classes,
    variant,
    disabled,
    multiple,
    open,
    error
  } = ownerState;
  const slots = {
    select: ['select', variant, disabled && 'disabled', multiple && 'multiple', error && 'error'],
    icon: ['icon', `icon${capitalize$1(variant)}`, open && 'iconOpen', disabled && 'disabled'],
    nativeInput: ['nativeInput']
  };
  return composeClasses$1(slots, getSelectUtilityClasses, classes);
};

/**
 * @ignore - internal component.
 */
const SelectInput = /*#__PURE__*/React$1.forwardRef(function SelectInput(props, ref) {
  var _MenuProps$slotProps;
  const {
      'aria-describedby': ariaDescribedby,
      'aria-label': ariaLabel,
      autoFocus,
      autoWidth,
      children,
      className,
      defaultOpen,
      defaultValue,
      disabled,
      displayEmpty,
      error = false,
      IconComponent,
      inputRef: inputRefProp,
      labelId,
      MenuProps = {},
      multiple,
      name,
      onBlur,
      onChange,
      onClose,
      onFocus,
      onOpen,
      open: openProp,
      readOnly,
      renderValue,
      SelectDisplayProps = {},
      tabIndex: tabIndexProp
      // catching `type` from Input which makes no sense for SelectInput
      ,

      value: valueProp,
      variant = 'standard'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$g);
  const [value, setValueState] = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  });
  const [openState, setOpenState] = useControlled({
    controlled: openProp,
    default: defaultOpen,
    name: 'Select'
  });
  const inputRef = React$1.useRef(null);
  const displayRef = React$1.useRef(null);
  const [displayNode, setDisplayNode] = React$1.useState(null);
  const {
    current: isOpenControlled
  } = React$1.useRef(openProp != null);
  const [menuMinWidthState, setMenuMinWidthState] = React$1.useState();
  const handleRef = useForkRef(ref, inputRefProp);
  const handleDisplayRef = React$1.useCallback(node => {
    displayRef.current = node;
    if (node) {
      setDisplayNode(node);
    }
  }, []);
  const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
  React$1.useImperativeHandle(handleRef, () => ({
    focus: () => {
      displayRef.current.focus();
    },
    node: inputRef.current,
    value
  }), [value]);

  // Resize menu on `defaultOpen` automatic toggle.
  React$1.useEffect(() => {
    if (defaultOpen && openState && displayNode && !isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
      displayRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayNode, autoWidth]);
  // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
  // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
  React$1.useEffect(() => {
    if (autoFocus) {
      displayRef.current.focus();
    }
  }, [autoFocus]);
  React$1.useEffect(() => {
    if (!labelId) {
      return undefined;
    }
    const label = ownerDocument(displayRef.current).getElementById(labelId);
    if (label) {
      const handler = () => {
        if (getSelection().isCollapsed) {
          displayRef.current.focus();
        }
      };
      label.addEventListener('click', handler);
      return () => {
        label.removeEventListener('click', handler);
      };
    }
    return undefined;
  }, [labelId]);
  const update = (open, event) => {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }
    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
      setOpenState(open);
    }
  };
  const handleMouseDown = event => {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    }
    // Hijack the default focus behavior.
    event.preventDefault();
    displayRef.current.focus();
    update(true, event);
  };
  const handleClose = event => {
    update(false, event);
  };
  const childrenArray = React$1.Children.toArray(children);

  // Support autofill.
  const handleChange = event => {
    const child = childrenArray.find(childItem => childItem.props.value === event.target.value);
    if (child === undefined) {
      return;
    }
    setValueState(child.props.value);
    if (onChange) {
      onChange(event, child);
    }
  };
  const handleItemClick = child => event => {
    let newValue;

    // We use the tabindex attribute to signal the available options.
    if (!event.currentTarget.hasAttribute('tabindex')) {
      return;
    }
    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];
      const itemIndex = value.indexOf(child.props.value);
      if (itemIndex === -1) {
        newValue.push(child.props.value);
      } else {
        newValue.splice(itemIndex, 1);
      }
    } else {
      newValue = child.props.value;
    }
    if (child.props.onClick) {
      child.props.onClick(event);
    }
    if (value !== newValue) {
      setValueState(newValue);
      if (onChange) {
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
          writable: true,
          value: {
            value: newValue,
            name
          }
        });
        onChange(clonedEvent, child);
      }
    }
    if (!multiple) {
      update(false, event);
    }
  };
  const handleKeyDown = event => {
    if (!readOnly) {
      const validKeys = [' ', 'ArrowUp', 'ArrowDown',
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      'Enter'];
      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };
  const open = displayNode !== null && openState;
  const handleBlur = event => {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      // Preact support, target is read only property on a native event.
      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value,
          name
        }
      });
      onBlur(event);
    }
  };
  delete other['aria-invalid'];
  let display;
  let displaySingle;
  const displayMultiple = [];
  let computeDisplay = false;
  let foundMatch = false;

  // No need to display any value if the field is empty.
  if (isFilled({
    value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }
  const items = childrenArray.map(child => {
    if (! /*#__PURE__*/React$1.isValidElement(child)) {
      return null;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (reactIsExports.isFragment(child)) {
        console.error(["MUI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    let selected;
    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`value\` prop must be an array when using the \`Select\` component with \`multiple\`.` : formatMuiErrorMessage$1(2));
      }
      selected = value.some(v => areEqualValues(v, child.props.value));
      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);
      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }
    if (selected) {
      foundMatch = true;
    }
    return /*#__PURE__*/React$1.cloneElement(child, {
      'aria-selected': selected ? 'true' : 'false',
      onClick: handleItemClick(child),
      onKeyUp: event => {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }
        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.
    });
  });
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$1.useEffect(() => {
      if (!foundMatch && !multiple && value !== '') {
        const values = childrenArray.map(child => child.props.value);
        console.warn([`MUI: You have provided an out-of-range value \`${value}\` for the select ${name ? `(name="${name}") ` : ''}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${values.filter(x => x != null).map(x => `\`${x}\``).join(', ') || '""'}.`].join('\n'));
      }
    }, [foundMatch, childrenArray, multiple, name, value]);
  }
  if (computeDisplay) {
    if (multiple) {
      if (displayMultiple.length === 0) {
        display = null;
      } else {
        display = displayMultiple.reduce((output, child, index) => {
          output.push(child);
          if (index < displayMultiple.length - 1) {
            output.push(', ');
          }
          return output;
        }, []);
      }
    } else {
      display = displaySingle;
    }
  }

  // Avoid performing a layout computation in the render method.
  let menuMinWidth = menuMinWidthState;
  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = anchorElement.clientWidth;
  }
  let tabIndex;
  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }
  const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
  const ownerState = _extends$X({}, props, {
    variant,
    value,
    open,
    error
  });
  const classes = useUtilityClasses$g(ownerState);
  const paperProps = _extends$X({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
  const listboxId = useId();
  return /*#__PURE__*/jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/*#__PURE__*/jsxRuntimeExports.jsx(SelectSelect, _extends$X({
      ref: handleDisplayRef,
      tabIndex: tabIndex,
      role: "combobox",
      "aria-controls": listboxId,
      "aria-disabled": disabled ? 'true' : undefined,
      "aria-expanded": open ? 'true' : 'false',
      "aria-haspopup": "listbox",
      "aria-label": ariaLabel,
      "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
      "aria-describedby": ariaDescribedby,
      onKeyDown: handleKeyDown,
      onMouseDown: disabled || readOnly ? null : handleMouseDown,
      onBlur: handleBlur,
      onFocus: onFocus
    }, SelectDisplayProps, {
      ownerState: ownerState,
      className: clsx(SelectDisplayProps.className, classes.select, className)
      // The id is required for proper a11y
      ,
      id: buttonId,
      children: isEmpty(display) ? // notranslate needed while Google Translate will not fix zero-width space issue
      _span || (_span = /*#__PURE__*/jsxRuntimeExports.jsx("span", {
        className: "notranslate",
        children: "\u200B"
      })) : display
    })), /*#__PURE__*/jsxRuntimeExports.jsx(SelectNativeInput, _extends$X({
      "aria-invalid": error,
      value: Array.isArray(value) ? value.join(',') : value,
      name: name,
      ref: inputRef,
      "aria-hidden": true,
      onChange: handleChange,
      tabIndex: -1,
      disabled: disabled,
      className: classes.nativeInput,
      autoFocus: autoFocus,
      ownerState: ownerState
    }, other)), /*#__PURE__*/jsxRuntimeExports.jsx(SelectIcon, {
      as: IconComponent,
      className: classes.icon,
      ownerState: ownerState
    }), /*#__PURE__*/jsxRuntimeExports.jsx(Menu$1, _extends$X({
      id: `menu-${name || ''}`,
      anchorEl: anchorElement,
      open: open,
      onClose: handleClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    }, MenuProps, {
      MenuListProps: _extends$X({
        'aria-labelledby': labelId,
        role: 'listbox',
        'aria-multiselectable': multiple ? 'true' : undefined,
        disableListWrap: true,
        id: listboxId
      }, MenuProps.MenuListProps),
      slotProps: _extends$X({}, MenuProps.slotProps, {
        paper: _extends$X({}, paperProps, {
          style: _extends$X({
            minWidth: menuMinWidth
          }, paperProps != null ? paperProps.style : null)
        })
      }),
      children: items
    }))]
  });
});
process.env.NODE_ENV !== "production" ? SelectInput.propTypes = {
  /**
   * @ignore
   */
  'aria-describedby': PropTypes.string,
  /**
   * @ignore
   */
  'aria-label': PropTypes.string,
  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType$1,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * @ignore
   */
  readOnly: PropTypes.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  type: PropTypes.any,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
var SelectInput$1 = SelectInput;

const _excluded$f = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"],
  _excluded2 = ["root"];
const useUtilityClasses$f = ownerState => {
  const {
    classes
  } = ownerState;
  return classes;
};
const styledRootConfig = {
  name: 'MuiSelect',
  overridesResolver: (props, styles) => styles.root,
  shouldForwardProp: prop => rootShouldForwardProp$2(prop) && prop !== 'variant',
  slot: 'Root'
};
const StyledInput = styled$2(Input$1, styledRootConfig)('');
const StyledOutlinedInput = styled$2(OutlinedInput$1, styledRootConfig)('');
const StyledFilledInput = styled$2(FilledInput$1, styledRootConfig)('');
const Select$1 = /*#__PURE__*/React$1.forwardRef(function Select(inProps, ref) {
  const props = useDefaultProps({
    name: 'MuiSelect',
    props: inProps
  });
  const {
      autoWidth = false,
      children,
      classes: classesProp = {},
      className,
      defaultOpen = false,
      displayEmpty = false,
      IconComponent = ArrowDropDownIcon,
      id,
      input,
      inputProps,
      label,
      labelId,
      MenuProps,
      multiple = false,
      native = false,
      onClose,
      onOpen,
      open,
      renderValue,
      SelectDisplayProps,
      variant: variantProp = 'outlined'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$f);
  const inputComponent = native ? NativeSelectInput$1 : SelectInput$1;
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['variant', 'error']
  });
  const variant = fcs.variant || variantProp;
  const ownerState = _extends$X({}, props, {
    variant,
    classes: classesProp
  });
  const classes = useUtilityClasses$f(ownerState);
  const restOfClasses = _objectWithoutPropertiesLoose$3(classes, _excluded2);
  const InputComponent = input || {
    standard: /*#__PURE__*/jsxRuntimeExports.jsx(StyledInput, {
      ownerState: ownerState
    }),
    outlined: /*#__PURE__*/jsxRuntimeExports.jsx(StyledOutlinedInput, {
      label: label,
      ownerState: ownerState
    }),
    filled: /*#__PURE__*/jsxRuntimeExports.jsx(StyledFilledInput, {
      ownerState: ownerState
    })
  }[variant];
  const inputComponentRef = useForkRef(ref, InputComponent.ref);
  return /*#__PURE__*/jsxRuntimeExports.jsx(React$1.Fragment, {
    children: /*#__PURE__*/React$1.cloneElement(InputComponent, _extends$X({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent,
      inputProps: _extends$X({
        children,
        error: fcs.error,
        IconComponent,
        variant,
        type: undefined,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple
      }, native ? {
        id
      } : {
        autoWidth,
        defaultOpen,
        displayEmpty,
        labelId,
        MenuProps,
        onClose,
        onOpen,
        open,
        renderValue,
        SelectDisplayProps: _extends$X({
          id
        }, SelectDisplayProps)
      }, inputProps, {
        classes: inputProps ? deepmerge$1(restOfClasses, inputProps.classes) : restOfClasses
      }, input ? input.props.inputProps : {})
    }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
      notched: true
    } : {}, {
      ref: inputComponentRef,
      className: clsx(InputComponent.props.className, className, classes.root)
    }, !input && {
      variant
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? Select$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: PropTypes.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: PropTypes.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: PropTypes.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.oneOfType([PropTypes.oneOf(['']), PropTypes.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
Select$1.muiName = 'Select';
var MSelect = Select$1;

function getSkeletonUtilityClass(slot) {
  return generateUtilityClass('MuiSkeleton', slot);
}
generateUtilityClasses('MuiSkeleton', ['root', 'text', 'rectangular', 'rounded', 'circular', 'pulse', 'wave', 'withChildren', 'fitContent', 'heightAuto']);

const _excluded$e = ["animation", "className", "component", "height", "style", "variant", "width"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
const useUtilityClasses$e = ownerState => {
  const {
    classes,
    variant,
    animation,
    hasChildren,
    width,
    height
  } = ownerState;
  const slots = {
    root: ['root', variant, animation, hasChildren && 'withChildren', hasChildren && !width && 'fitContent', hasChildren && !height && 'heightAuto']
  };
  return composeClasses$1(slots, getSkeletonUtilityClass, classes);
};
const pulseKeyframe = keyframes(_t || (_t = _`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const waveKeyframe = keyframes(_t2 || (_t2 = _`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const SkeletonRoot = styled$2('span', {
  name: 'MuiSkeleton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.animation !== false && styles[ownerState.animation], ownerState.hasChildren && styles.withChildren, ownerState.hasChildren && !ownerState.width && styles.fitContent, ownerState.hasChildren && !ownerState.height && styles.heightAuto];
  }
})(({
  theme,
  ownerState
}) => {
  const radiusUnit = getUnit(theme.shape.borderRadius) || 'px';
  const radiusValue = toUnitless(theme.shape.borderRadius);
  return _extends$X({
    display: 'block',
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
    height: '1.2em'
  }, ownerState.variant === 'text' && {
    marginTop: 0,
    marginBottom: 0,
    height: 'auto',
    transformOrigin: '0 55%',
    transform: 'scale(1, 0.60)',
    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
    '&:empty:before': {
      content: '"\\00a0"'
    }
  }, ownerState.variant === 'circular' && {
    borderRadius: '50%'
  }, ownerState.variant === 'rounded' && {
    borderRadius: (theme.vars || theme).shape.borderRadius
  }, ownerState.hasChildren && {
    '& > *': {
      visibility: 'hidden'
    }
  }, ownerState.hasChildren && !ownerState.width && {
    maxWidth: 'fit-content'
  }, ownerState.hasChildren && !ownerState.height && {
    height: 'auto'
  });
}, ({
  ownerState
}) => ownerState.animation === 'pulse' && css(_t3 || (_t3 = _`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), pulseKeyframe), ({
  ownerState,
  theme
}) => ownerState.animation === 'wave' && css(_t4 || (_t4 = _`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), waveKeyframe, (theme.vars || theme).palette.action.hover));
const Skeleton = /*#__PURE__*/React$1.forwardRef(function Skeleton(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiSkeleton'
  });
  const {
      animation = 'pulse',
      className,
      component = 'span',
      height,
      style,
      variant = 'text',
      width
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$e);
  const ownerState = _extends$X({}, props, {
    animation,
    component,
    variant,
    hasChildren: Boolean(other.children)
  });
  const classes = useUtilityClasses$e(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(SkeletonRoot, _extends$X({
    as: component,
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    style: _extends$X({
      width,
      height
    }, style)
  }));
});
process.env.NODE_ENV !== "production" ? Skeleton.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: PropTypes.oneOf(['pulse', 'wave', false]),
  /**
   * Optional children to infer width and height from.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['circular', 'rectangular', 'rounded', 'text']), PropTypes.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : void 0;
var Skeleton$1 = Skeleton;

function getTooltipUtilityClass(slot) {
  return generateUtilityClass('MuiTooltip', slot);
}
const tooltipClasses = generateUtilityClasses('MuiTooltip', ['popper', 'popperInteractive', 'popperArrow', 'popperClose', 'tooltip', 'tooltipArrow', 'touch', 'tooltipPlacementLeft', 'tooltipPlacementRight', 'tooltipPlacementTop', 'tooltipPlacementBottom', 'arrow']);
var tooltipClasses$1 = tooltipClasses;

const _excluded$d = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function round$1(value) {
  return Math.round(value * 1e5) / 1e5;
}
const useUtilityClasses$d = ownerState => {
  const {
    classes,
    disableInteractive,
    arrow,
    touch,
    placement
  } = ownerState;
  const slots = {
    popper: ['popper', !disableInteractive && 'popperInteractive', arrow && 'popperArrow'],
    tooltip: ['tooltip', arrow && 'tooltipArrow', touch && 'touch', `tooltipPlacement${capitalize$1(placement.split('-')[0])}`],
    arrow: ['arrow']
  };
  return composeClasses$1(slots, getTooltipUtilityClass, classes);
};
const TooltipPopper = styled$2(Popper$1, {
  name: 'MuiTooltip',
  slot: 'Popper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.popper, !ownerState.disableInteractive && styles.popperInteractive, ownerState.arrow && styles.popperArrow, !ownerState.open && styles.popperClose];
  }
})(({
  theme,
  ownerState,
  open
}) => _extends$X({
  zIndex: (theme.vars || theme).zIndex.tooltip,
  pointerEvents: 'none'
}, !ownerState.disableInteractive && {
  pointerEvents: 'auto'
}, !open && {
  pointerEvents: 'none'
}, ownerState.arrow && {
  [`&[data-popper-placement*="bottom"] .${tooltipClasses$1.arrow}`]: {
    top: 0,
    marginTop: '-0.71em',
    '&::before': {
      transformOrigin: '0 100%'
    }
  },
  [`&[data-popper-placement*="top"] .${tooltipClasses$1.arrow}`]: {
    bottom: 0,
    marginBottom: '-0.71em',
    '&::before': {
      transformOrigin: '100% 0'
    }
  },
  [`&[data-popper-placement*="right"] .${tooltipClasses$1.arrow}`]: _extends$X({}, !ownerState.isRtl ? {
    left: 0,
    marginLeft: '-0.71em'
  } : {
    right: 0,
    marginRight: '-0.71em'
  }, {
    height: '1em',
    width: '0.71em',
    '&::before': {
      transformOrigin: '100% 100%'
    }
  }),
  [`&[data-popper-placement*="left"] .${tooltipClasses$1.arrow}`]: _extends$X({}, !ownerState.isRtl ? {
    right: 0,
    marginRight: '-0.71em'
  } : {
    left: 0,
    marginLeft: '-0.71em'
  }, {
    height: '1em',
    width: '0.71em',
    '&::before': {
      transformOrigin: '0 0'
    }
  })
}));
const TooltipTooltip = styled$2('div', {
  name: 'MuiTooltip',
  slot: 'Tooltip',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.tooltip, ownerState.touch && styles.touch, ownerState.arrow && styles.tooltipArrow, styles[`tooltipPlacement${capitalize$1(ownerState.placement.split('-')[0])}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : alpha_1(theme.palette.grey[700], 0.92),
  borderRadius: (theme.vars || theme).shape.borderRadius,
  color: (theme.vars || theme).palette.common.white,
  fontFamily: theme.typography.fontFamily,
  padding: '4px 8px',
  fontSize: theme.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: 'break-word',
  fontWeight: theme.typography.fontWeightMedium
}, ownerState.arrow && {
  position: 'relative',
  margin: 0
}, ownerState.touch && {
  padding: '8px 16px',
  fontSize: theme.typography.pxToRem(14),
  lineHeight: `${round$1(16 / 14)}em`,
  fontWeight: theme.typography.fontWeightRegular
}, {
  [`.${tooltipClasses$1.popper}[data-popper-placement*="left"] &`]: _extends$X({
    transformOrigin: 'right center'
  }, !ownerState.isRtl ? _extends$X({
    marginRight: '14px'
  }, ownerState.touch && {
    marginRight: '24px'
  }) : _extends$X({
    marginLeft: '14px'
  }, ownerState.touch && {
    marginLeft: '24px'
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="right"] &`]: _extends$X({
    transformOrigin: 'left center'
  }, !ownerState.isRtl ? _extends$X({
    marginLeft: '14px'
  }, ownerState.touch && {
    marginLeft: '24px'
  }) : _extends$X({
    marginRight: '14px'
  }, ownerState.touch && {
    marginRight: '24px'
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="top"] &`]: _extends$X({
    transformOrigin: 'center bottom',
    marginBottom: '14px'
  }, ownerState.touch && {
    marginBottom: '24px'
  }),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="bottom"] &`]: _extends$X({
    transformOrigin: 'center top',
    marginTop: '14px'
  }, ownerState.touch && {
    marginTop: '24px'
  })
}));
const TooltipArrow = styled$2('span', {
  name: 'MuiTooltip',
  slot: 'Arrow',
  overridesResolver: (props, styles) => styles.arrow
})(({
  theme
}) => ({
  overflow: 'hidden',
  position: 'absolute',
  width: '1em',
  height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */,
  boxSizing: 'border-box',
  color: theme.vars ? theme.vars.palette.Tooltip.bg : alpha_1(theme.palette.grey[700], 0.9),
  '&::before': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: 'currentColor',
    transform: 'rotate(45deg)'
  }
}));
let hystersisOpen = false;
const hystersisTimer = new Timeout();
let cursorPosition = {
  x: 0,
  y: 0
};
function composeEventHandler(handler, eventHandler) {
  return (event, ...params) => {
    if (eventHandler) {
      eventHandler(event, ...params);
    }
    handler(event, ...params);
  };
}

// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const Tooltip = /*#__PURE__*/React$1.forwardRef(function Tooltip(inProps, ref) {
  var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTooltip'
  });
  const {
      arrow = false,
      children: childrenProp,
      components = {},
      componentsProps = {},
      describeChild = false,
      disableFocusListener = false,
      disableHoverListener = false,
      disableInteractive: disableInteractiveProp = false,
      disableTouchListener = false,
      enterDelay = 100,
      enterNextDelay = 0,
      enterTouchDelay = 700,
      followCursor = false,
      id: idProp,
      leaveDelay = 0,
      leaveTouchDelay = 1500,
      onClose,
      onOpen,
      open: openProp,
      placement = 'bottom',
      PopperComponent: PopperComponentProp,
      PopperProps = {},
      slotProps = {},
      slots = {},
      title,
      TransitionComponent: TransitionComponentProp = Grow$1,
      TransitionProps
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$d);

  // to prevent runtime errors, developers will need to provide a child as a React element anyway.
  const children = /*#__PURE__*/React$1.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/jsxRuntimeExports.jsx("span", {
    children: childrenProp
  });
  const theme = useTheme$1();
  const isRtl = useRtl();
  const [childNode, setChildNode] = React$1.useState();
  const [arrowRef, setArrowRef] = React$1.useState(null);
  const ignoreNonTouchEvents = React$1.useRef(false);
  const disableInteractive = disableInteractiveProp || followCursor;
  const closeTimer = useTimeout();
  const enterTimer = useTimeout();
  const leaveTimer = useTimeout();
  const touchTimer = useTimeout();
  const [openState, setOpenState] = useControlled({
    controlled: openProp,
    default: false,
    name: 'Tooltip',
    state: 'open'
  });
  let open = openState;
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {
      current: isControlled
    } = React$1.useRef(openProp !== undefined);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$1.useEffect(() => {
      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
        console.error(['MUI: You are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
      }
    }, [title, childNode, isControlled]);
  }
  const id = useId(idProp);
  const prevUserSelect = React$1.useRef();
  const stopTouchInteraction = useEventCallback(() => {
    if (prevUserSelect.current !== undefined) {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      prevUserSelect.current = undefined;
    }
    touchTimer.clear();
  });
  React$1.useEffect(() => stopTouchInteraction, [stopTouchInteraction]);
  const handleOpen = event => {
    hystersisTimer.clear();
    hystersisOpen = true;

    // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
    setOpenState(true);
    if (onOpen && !open) {
      onOpen(event);
    }
  };
  const handleClose = useEventCallback(
  /**
   * @param {React.SyntheticEvent | Event} event
   */
  event => {
    hystersisTimer.start(800 + leaveDelay, () => {
      hystersisOpen = false;
    });
    setOpenState(false);
    if (onClose && open) {
      onClose(event);
    }
    closeTimer.start(theme.transitions.duration.shortest, () => {
      ignoreNonTouchEvents.current = false;
    });
  });
  const handleMouseOver = event => {
    if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
      return;
    }

    // Remove the title ahead of time.
    // We don't want to wait for the next render commit.
    // We would risk displaying two tooltips at the same time (native + this one).
    if (childNode) {
      childNode.removeAttribute('title');
    }
    enterTimer.clear();
    leaveTimer.clear();
    if (enterDelay || hystersisOpen && enterNextDelay) {
      enterTimer.start(hystersisOpen ? enterNextDelay : enterDelay, () => {
        handleOpen(event);
      });
    } else {
      handleOpen(event);
    }
  };
  const handleMouseLeave = event => {
    enterTimer.clear();
    leaveTimer.start(leaveDelay, () => {
      handleClose(event);
    });
  };
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible();
  // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
  // We just need to re-render the Tooltip if the focus-visible state changes.
  const [, setChildIsFocusVisible] = React$1.useState(false);
  const handleBlur = event => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setChildIsFocusVisible(false);
      handleMouseLeave(event);
    }
  };
  const handleFocus = event => {
    // Workaround for https://github.com/facebook/react/issues/7769
    // The autoFocus of React might trigger the event before the componentDidMount.
    // We need to account for this eventuality.
    if (!childNode) {
      setChildNode(event.currentTarget);
    }
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setChildIsFocusVisible(true);
      handleMouseOver(event);
    }
  };
  const detectTouchStart = event => {
    ignoreNonTouchEvents.current = true;
    const childrenProps = children.props;
    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
  };
  const handleTouchStart = event => {
    detectTouchStart(event);
    leaveTimer.clear();
    closeTimer.clear();
    stopTouchInteraction();
    prevUserSelect.current = document.body.style.WebkitUserSelect;
    // Prevent iOS text selection on long-tap.
    document.body.style.WebkitUserSelect = 'none';
    touchTimer.start(enterTouchDelay, () => {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      handleMouseOver(event);
    });
  };
  const handleTouchEnd = event => {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }
    stopTouchInteraction();
    leaveTimer.start(leaveTouchDelay, () => {
      handleClose(event);
    });
  };
  React$1.useEffect(() => {
    if (!open) {
      return undefined;
    }

    /**
     * @param {KeyboardEvent} nativeEvent
     */
    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        handleClose(nativeEvent);
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleClose, open]);
  const handleRef = useForkRef(children.ref, focusVisibleRef, setChildNode, ref);

  // There is no point in displaying an empty tooltip.
  // So we exclude all falsy values, except 0, which is valid.
  if (!title && title !== 0) {
    open = false;
  }
  const popperRef = React$1.useRef();
  const handleMouseMove = event => {
    const childrenProps = children.props;
    if (childrenProps.onMouseMove) {
      childrenProps.onMouseMove(event);
    }
    cursorPosition = {
      x: event.clientX,
      y: event.clientY
    };
    if (popperRef.current) {
      popperRef.current.update();
    }
  };
  const nameOrDescProps = {};
  const titleIsString = typeof title === 'string';
  if (describeChild) {
    nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
    nameOrDescProps['aria-describedby'] = open ? id : null;
  } else {
    nameOrDescProps['aria-label'] = titleIsString ? title : null;
    nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
  }
  const childrenProps = _extends$X({}, nameOrDescProps, other, children.props, {
    className: clsx(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  }, followCursor ? {
    onMouseMove: handleMouseMove
  } : {});
  if (process.env.NODE_ENV !== 'production') {
    childrenProps['data-mui-internal-clone-element'] = true;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$1.useEffect(() => {
      if (childNode && !childNode.getAttribute('data-mui-internal-clone-element')) {
        console.error(['MUI: The `children` component of the Tooltip is not forwarding its props correctly.', 'Please make sure that props are spread on the same element that the ref is applied to.'].join('\n'));
      }
    }, [childNode]);
  }
  const interactiveWrapperListeners = {};
  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }
  if (!disableHoverListener) {
    childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
    childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
    if (!disableInteractive) {
      interactiveWrapperListeners.onMouseOver = handleMouseOver;
      interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
    }
  }
  if (!disableFocusListener) {
    childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
    childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);
    if (!disableInteractive) {
      interactiveWrapperListeners.onFocus = handleFocus;
      interactiveWrapperListeners.onBlur = handleBlur;
    }
  }
  if (process.env.NODE_ENV !== 'production') {
    if (children.props.title) {
      console.error(['MUI: You have provided a `title` prop to the child of <Tooltip />.', `Remove this title prop \`${children.props.title}\` or the Tooltip component.`].join('\n'));
    }
  }
  const popperOptions = React$1.useMemo(() => {
    var _PopperProps$popperOp;
    let tooltipModifiers = [{
      name: 'arrow',
      enabled: Boolean(arrowRef),
      options: {
        element: arrowRef,
        padding: 4
      }
    }];
    if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) {
      tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
    }
    return _extends$X({}, PopperProps.popperOptions, {
      modifiers: tooltipModifiers
    });
  }, [arrowRef, PopperProps]);
  const ownerState = _extends$X({}, props, {
    isRtl,
    arrow,
    disableInteractive,
    placement,
    PopperComponentProp,
    touch: ignoreNonTouchEvents.current
  });
  const classes = useUtilityClasses$d(ownerState);
  const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : TooltipPopper;
  const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : Grow$1;
  const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : TooltipTooltip;
  const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : TooltipArrow;
  const popperProps = appendOwnerState(PopperComponent, _extends$X({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
    className: clsx(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
  }), ownerState);
  const transitionProps = appendOwnerState(TransitionComponent, _extends$X({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
  const tooltipProps = appendOwnerState(TooltipComponent, _extends$X({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
    className: clsx(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
  }), ownerState);
  const tooltipArrowProps = appendOwnerState(ArrowComponent, _extends$X({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
    className: clsx(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
  }), ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/*#__PURE__*/React$1.cloneElement(children, childrenProps), /*#__PURE__*/jsxRuntimeExports.jsx(PopperComponent, _extends$X({
      as: PopperComponentProp != null ? PopperComponentProp : Popper$1,
      placement: placement,
      anchorEl: followCursor ? {
        getBoundingClientRect: () => ({
          top: cursorPosition.y,
          left: cursorPosition.x,
          right: cursorPosition.x,
          bottom: cursorPosition.y,
          width: 0,
          height: 0
        })
      } : childNode,
      popperRef: popperRef,
      open: childNode ? open : false,
      id: id,
      transition: true
    }, interactiveWrapperListeners, popperProps, {
      popperOptions: popperOptions,
      children: ({
        TransitionProps: TransitionPropsInner
      }) => /*#__PURE__*/jsxRuntimeExports.jsx(TransitionComponent, _extends$X({
        timeout: theme.transitions.duration.shorter
      }, TransitionPropsInner, transitionProps, {
        children: /*#__PURE__*/jsxRuntimeExports.jsxs(TooltipComponent, _extends$X({}, tooltipProps, {
          children: [title, arrow ? /*#__PURE__*/jsxRuntimeExports.jsx(ArrowComponent, _extends$X({}, tooltipArrowProps, {
            ref: setArrowRef
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" ? Tooltip.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: PropTypes.bool,
  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Arrow: PropTypes.elementType,
    Popper: PropTypes.elementType,
    Tooltip: PropTypes.elementType,
    Transition: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    arrow: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    transition: PropTypes.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: PropTypes.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: PropTypes.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: PropTypes.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: PropTypes.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: PropTypes.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: PropTypes.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: PropTypes.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: PropTypes.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: PropTypes.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: PropTypes.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: PropTypes.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    arrow: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    transition: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    arrow: PropTypes.elementType,
    popper: PropTypes.elementType,
    tooltip: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: PropTypes.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: PropTypes.object
} : void 0;
var Tooltip$1 = Tooltip;

/**
 * Provides information about the current step in Stepper.
 */
const StepperContext = /*#__PURE__*/React$1.createContext({});
if (process.env.NODE_ENV !== 'production') {
  StepperContext.displayName = 'StepperContext';
}
var StepperContext$1 = StepperContext;

/**
 * Provides information about the current step in Stepper.
 */
const StepContext = /*#__PURE__*/React$1.createContext({});
if (process.env.NODE_ENV !== 'production') {
  StepContext.displayName = 'StepContext';
}
var StepContext$1 = StepContext;

function getStepUtilityClass(slot) {
  return generateUtilityClass('MuiStep', slot);
}
generateUtilityClasses('MuiStep', ['root', 'horizontal', 'vertical', 'alternativeLabel', 'completed']);

const _excluded$c = ["active", "children", "className", "component", "completed", "disabled", "expanded", "index", "last"];
const useUtilityClasses$c = ownerState => {
  const {
    classes,
    orientation,
    alternativeLabel,
    completed
  } = ownerState;
  const slots = {
    root: ['root', orientation, alternativeLabel && 'alternativeLabel', completed && 'completed']
  };
  return composeClasses$1(slots, getStepUtilityClass, classes);
};
const StepRoot = styled$2('div', {
  name: 'MuiStep',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel, ownerState.completed && styles.completed];
  }
})(({
  ownerState
}) => _extends$X({}, ownerState.orientation === 'horizontal' && {
  paddingLeft: 8,
  paddingRight: 8
}, ownerState.alternativeLabel && {
  flex: 1,
  position: 'relative'
}));
const Step = /*#__PURE__*/React$1.forwardRef(function Step(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiStep'
  });
  const {
      active: activeProp,
      children,
      className,
      component = 'div',
      completed: completedProp,
      disabled: disabledProp,
      expanded = false,
      index,
      last
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$c);
  const {
    activeStep,
    connector,
    alternativeLabel,
    orientation,
    nonLinear
  } = React$1.useContext(StepperContext$1);
  let [active = false, completed = false, disabled = false] = [activeProp, completedProp, disabledProp];
  if (activeStep === index) {
    active = activeProp !== undefined ? activeProp : true;
  } else if (!nonLinear && activeStep > index) {
    completed = completedProp !== undefined ? completedProp : true;
  } else if (!nonLinear && activeStep < index) {
    disabled = disabledProp !== undefined ? disabledProp : true;
  }
  const contextValue = React$1.useMemo(() => ({
    index,
    last,
    expanded,
    icon: index + 1,
    active,
    completed,
    disabled
  }), [index, last, expanded, active, completed, disabled]);
  const ownerState = _extends$X({}, props, {
    active,
    orientation,
    alternativeLabel,
    completed,
    disabled,
    expanded,
    component
  });
  const classes = useUtilityClasses$c(ownerState);
  const newChildren = /*#__PURE__*/jsxRuntimeExports.jsxs(StepRoot, _extends$X({
    as: component,
    className: clsx(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [connector && alternativeLabel && index !== 0 ? connector : null, children]
  }));
  return /*#__PURE__*/jsxRuntimeExports.jsx(StepContext$1.Provider, {
    value: contextValue,
    children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/jsxRuntimeExports.jsxs(React$1.Fragment, {
      children: [connector, newChildren]
    }) : newChildren
  });
});
process.env.NODE_ENV !== "production" ? Step.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: PropTypes.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: PropTypes.bool,
  /**
   * Expand the step.
   * @default false
   */
  expanded: PropTypes.bool,
  /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  index: integerPropType,
  /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  last: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var Step$1 = Step;

function getStepConnectorUtilityClass(slot) {
  return generateUtilityClass('MuiStepConnector', slot);
}
generateUtilityClasses('MuiStepConnector', ['root', 'horizontal', 'vertical', 'alternativeLabel', 'active', 'completed', 'disabled', 'line', 'lineHorizontal', 'lineVertical']);

const _excluded$b = ["className"];
const useUtilityClasses$b = ownerState => {
  const {
    classes,
    orientation,
    alternativeLabel,
    active,
    completed,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', orientation, alternativeLabel && 'alternativeLabel', active && 'active', completed && 'completed', disabled && 'disabled'],
    line: ['line', `line${capitalize$1(orientation)}`]
  };
  return composeClasses$1(slots, getStepConnectorUtilityClass, classes);
};
const StepConnectorRoot = styled$2('div', {
  name: 'MuiStepConnector',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel, ownerState.completed && styles.completed];
  }
})(({
  ownerState
}) => _extends$X({
  flex: '1 1 auto'
}, ownerState.orientation === 'vertical' && {
  marginLeft: 12 // half icon
}, ownerState.alternativeLabel && {
  position: 'absolute',
  top: 8 + 4,
  left: 'calc(-50% + 20px)',
  right: 'calc(50% + 20px)'
}));
const StepConnectorLine = styled$2('span', {
  name: 'MuiStepConnector',
  slot: 'Line',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.line, styles[`line${capitalize$1(ownerState.orientation)}`]];
  }
})(({
  ownerState,
  theme
}) => {
  const borderColor = theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600];
  return _extends$X({
    display: 'block',
    borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor
  }, ownerState.orientation === 'horizontal' && {
    borderTopStyle: 'solid',
    borderTopWidth: 1
  }, ownerState.orientation === 'vertical' && {
    borderLeftStyle: 'solid',
    borderLeftWidth: 1,
    minHeight: 24
  });
});
const StepConnector = /*#__PURE__*/React$1.forwardRef(function StepConnector(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiStepConnector'
  });
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$b);
  const {
    alternativeLabel,
    orientation = 'horizontal'
  } = React$1.useContext(StepperContext$1);
  const {
    active,
    disabled,
    completed
  } = React$1.useContext(StepContext$1);
  const ownerState = _extends$X({}, props, {
    alternativeLabel,
    orientation,
    active,
    completed,
    disabled
  });
  const classes = useUtilityClasses$b(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(StepConnectorRoot, _extends$X({
    className: clsx(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsxRuntimeExports.jsx(StepConnectorLine, {
      className: classes.line,
      ownerState: ownerState
    })
  }));
});
process.env.NODE_ENV !== "production" ? StepConnector.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var StepConnector$1 = StepConnector;

function getStepperUtilityClass(slot) {
  return generateUtilityClass('MuiStepper', slot);
}
generateUtilityClasses('MuiStepper', ['root', 'horizontal', 'vertical', 'nonLinear', 'alternativeLabel']);

const _excluded$a = ["activeStep", "alternativeLabel", "children", "className", "component", "connector", "nonLinear", "orientation"];
const useUtilityClasses$a = ownerState => {
  const {
    orientation,
    nonLinear,
    alternativeLabel,
    classes
  } = ownerState;
  const slots = {
    root: ['root', orientation, nonLinear && 'nonLinear', alternativeLabel && 'alternativeLabel']
  };
  return composeClasses$1(slots, getStepperUtilityClass, classes);
};
const StepperRoot = styled$2('div', {
  name: 'MuiStepper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel, ownerState.nonLinear && styles.nonLinear];
  }
})(({
  ownerState
}) => _extends$X({
  display: 'flex'
}, ownerState.orientation === 'horizontal' && {
  flexDirection: 'row',
  alignItems: 'center'
}, ownerState.orientation === 'vertical' && {
  flexDirection: 'column'
}, ownerState.alternativeLabel && {
  alignItems: 'flex-start'
}));
const defaultConnector = /*#__PURE__*/jsxRuntimeExports.jsx(StepConnector$1, {});
const Stepper = /*#__PURE__*/React$1.forwardRef(function Stepper(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiStepper'
  });
  const {
      activeStep = 0,
      alternativeLabel = false,
      children,
      className,
      component = 'div',
      connector = defaultConnector,
      nonLinear = false,
      orientation = 'horizontal'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$a);
  const ownerState = _extends$X({}, props, {
    nonLinear,
    alternativeLabel,
    orientation,
    component
  });
  const classes = useUtilityClasses$a(ownerState);
  const childrenArray = React$1.Children.toArray(children).filter(Boolean);
  const steps = childrenArray.map((step, index) => {
    return /*#__PURE__*/React$1.cloneElement(step, _extends$X({
      index,
      last: index + 1 === childrenArray.length
    }, step.props));
  });
  const contextValue = React$1.useMemo(() => ({
    activeStep,
    alternativeLabel,
    connector,
    nonLinear,
    orientation
  }), [activeStep, alternativeLabel, connector, nonLinear, orientation]);
  return /*#__PURE__*/jsxRuntimeExports.jsx(StepperContext$1.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(StepperRoot, _extends$X({
      as: component,
      ownerState: ownerState,
      className: clsx(classes.root, className),
      ref: ref
    }, other, {
      children: steps
    }))
  });
});
process.env.NODE_ENV !== "production" ? Stepper.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */
  activeStep: integerPropType,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */
  alternativeLabel: PropTypes.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */
  connector: PropTypes.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */
  nonLinear: PropTypes.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var Stepper$1 = Stepper;

function getSwitchUtilityClass(slot) {
  return generateUtilityClass('MuiSwitch', slot);
}
const switchClasses = generateUtilityClasses('MuiSwitch', ['root', 'edgeStart', 'edgeEnd', 'switchBase', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium', 'checked', 'disabled', 'input', 'thumb', 'track']);
var switchClasses$1 = switchClasses;

const _excluded$9 = ["className", "color", "edge", "size", "sx"];
const useUtilityClasses$9 = ownerState => {
  const {
    classes,
    edge,
    size,
    color,
    checked,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', edge && `edge${capitalize$1(edge)}`, `size${capitalize$1(size)}`],
    switchBase: ['switchBase', `color${capitalize$1(color)}`, checked && 'checked', disabled && 'disabled'],
    thumb: ['thumb'],
    track: ['track'],
    input: ['input']
  };
  const composedClasses = composeClasses$1(slots, getSwitchUtilityClass, classes);
  return _extends$X({}, classes, composedClasses);
};
const SwitchRoot = styled$2('span', {
  name: 'MuiSwitch',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.edge && styles[`edge${capitalize$1(ownerState.edge)}`], styles[`size${capitalize$1(ownerState.size)}`]];
  }
})({
  display: 'inline-flex',
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: 'hidden',
  padding: 12,
  boxSizing: 'border-box',
  position: 'relative',
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: 'middle',
  // For correct alignment with the text.
  '@media print': {
    colorAdjust: 'exact'
  },
  variants: [{
    props: {
      edge: 'start'
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: 'end'
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: 'small'
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${switchClasses$1.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${switchClasses$1.switchBase}`]: {
        padding: 4,
        [`&.${switchClasses$1.checked}`]: {
          transform: 'translateX(16px)'
        }
      }
    }
  }]
});
const SwitchSwitchBase = styled$2(SwitchBase$1, {
  name: 'MuiSwitch',
  slot: 'SwitchBase',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.switchBase, {
      [`& .${switchClasses$1.input}`]: styles.input
    }, ownerState.color !== 'default' && styles[`color${capitalize$1(ownerState.color)}`]];
  }
})(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
  transition: theme.transitions.create(['left', 'transform'], {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${switchClasses$1.checked}`]: {
    transform: 'translateX(20px)'
  },
  [`&.${switchClasses$1.disabled}`]: {
    color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
  },
  [`&.${switchClasses$1.checked} + .${switchClasses$1.track}`]: {
    opacity: 0.5
  },
  [`&.${switchClasses$1.disabled} + .${switchClasses$1.track}`]: {
    opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
  },
  [`& .${switchClasses$1.input}`]: {
    left: '-100%',
    width: '300%'
  }
}), ({
  theme
}) => ({
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha_1(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  variants: [...Object.entries(theme.palette).filter(([, value]) => value.main && value.light) // check all the used fields in the style below
  .map(([color]) => ({
    props: {
      color
    },
    style: {
      [`&.${switchClasses$1.checked}`]: {
        color: (theme.vars || theme).palette[color].main,
        '&:hover': {
          backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha_1(theme.palette[color].main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        [`&.${switchClasses$1.disabled}`]: {
          color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? lighten_1(theme.palette[color].main, 0.62) : darken_1(theme.palette[color].main, 0.55)}`
        }
      },
      [`&.${switchClasses$1.checked} + .${switchClasses$1.track}`]: {
        backgroundColor: (theme.vars || theme).palette[color].main
      }
    }
  }))]
}));
const SwitchTrack = styled$2('span', {
  name: 'MuiSwitch',
  slot: 'Track',
  overridesResolver: (props, styles) => styles.track
})(({
  theme
}) => ({
  height: '100%',
  width: '100%',
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: theme.transitions.create(['opacity', 'background-color'], {
    duration: theme.transitions.duration.shortest
  }),
  backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
  opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
}));
const SwitchThumb = styled$2('span', {
  name: 'MuiSwitch',
  slot: 'Thumb',
  overridesResolver: (props, styles) => styles.thumb
})(({
  theme
}) => ({
  boxShadow: (theme.vars || theme).shadows[1],
  backgroundColor: 'currentColor',
  width: 20,
  height: 20,
  borderRadius: '50%'
}));
const Switch$1 = /*#__PURE__*/React$1.forwardRef(function Switch(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiSwitch'
  });
  const {
      className,
      color = 'primary',
      edge = false,
      size = 'medium',
      sx
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$9);
  const ownerState = _extends$X({}, props, {
    color,
    edge,
    size
  });
  const classes = useUtilityClasses$9(ownerState);
  const icon = /*#__PURE__*/jsxRuntimeExports.jsx(SwitchThumb, {
    className: classes.thumb,
    ownerState: ownerState
  });
  return /*#__PURE__*/jsxRuntimeExports.jsxs(SwitchRoot, {
    className: clsx(classes.root, className),
    sx: sx,
    ownerState: ownerState,
    children: [/*#__PURE__*/jsxRuntimeExports.jsx(SwitchSwitchBase, _extends$X({
      type: "checkbox",
      icon: icon,
      checkedIcon: icon,
      ref: ref,
      ownerState: ownerState
    }, other, {
      classes: _extends$X({}, classes, {
        root: classes.switchBase
      })
    })), /*#__PURE__*/jsxRuntimeExports.jsx(SwitchTrack, {
      className: classes.track,
      ownerState: ownerState
    })]
  });
});
process.env.NODE_ENV !== "production" ? Switch$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(['end', 'start', false]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
var MSwitch = Switch$1;

/**
 * @ignore - internal component.
 */
const TableContext = /*#__PURE__*/React$1.createContext();
if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'TableContext';
}
var TableContext$1 = TableContext;

function getTableUtilityClass(slot) {
  return generateUtilityClass('MuiTable', slot);
}
generateUtilityClasses('MuiTable', ['root', 'stickyHeader']);

const _excluded$8 = ["className", "component", "padding", "size", "stickyHeader"];
const useUtilityClasses$8 = ownerState => {
  const {
    classes,
    stickyHeader
  } = ownerState;
  const slots = {
    root: ['root', stickyHeader && 'stickyHeader']
  };
  return composeClasses$1(slots, getTableUtilityClass, classes);
};
const TableRoot$1 = styled$2('table', {
  name: 'MuiTable',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.stickyHeader && styles.stickyHeader];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  display: 'table',
  width: '100%',
  borderCollapse: 'collapse',
  borderSpacing: 0,
  '& caption': _extends$X({}, theme.typography.body2, {
    padding: theme.spacing(2),
    color: (theme.vars || theme).palette.text.secondary,
    textAlign: 'left',
    captionSide: 'bottom'
  })
}, ownerState.stickyHeader && {
  borderCollapse: 'separate'
}));
const defaultComponent$3 = 'table';
const Table$2 = /*#__PURE__*/React$1.forwardRef(function Table(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTable'
  });
  const {
      className,
      component = defaultComponent$3,
      padding = 'normal',
      size = 'medium',
      stickyHeader = false
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$8);
  const ownerState = _extends$X({}, props, {
    component,
    padding,
    size,
    stickyHeader
  });
  const classes = useUtilityClasses$8(ownerState);
  const table = React$1.useMemo(() => ({
    padding,
    size,
    stickyHeader
  }), [padding, size, stickyHeader]);
  return /*#__PURE__*/jsxRuntimeExports.jsx(TableContext$1.Provider, {
    value: table,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(TableRoot$1, _extends$X({
      as: component,
      role: component === defaultComponent$3 ? null : 'table',
      ref: ref,
      className: clsx(classes.root, className),
      ownerState: ownerState
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? Table$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: PropTypes.oneOf(['checkbox', 'none', 'normal']),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */
  stickyHeader: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var MuiTable = Table$2;

/**
 * @ignore - internal component.
 */
const Tablelvl2Context = /*#__PURE__*/React$1.createContext();
if (process.env.NODE_ENV !== 'production') {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}
var Tablelvl2Context$1 = Tablelvl2Context;

function getTableBodyUtilityClass(slot) {
  return generateUtilityClass('MuiTableBody', slot);
}
generateUtilityClasses('MuiTableBody', ['root']);

const _excluded$7 = ["className", "component"];
const useUtilityClasses$7 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses$1(slots, getTableBodyUtilityClass, classes);
};
const TableBodyRoot = styled$2('tbody', {
  name: 'MuiTableBody',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-row-group'
});
const tablelvl2$1 = {
  variant: 'body'
};
const defaultComponent$2 = 'tbody';
const TableBody = /*#__PURE__*/React$1.forwardRef(function TableBody(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTableBody'
  });
  const {
      className,
      component = defaultComponent$2
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$7);
  const ownerState = _extends$X({}, props, {
    component
  });
  const classes = useUtilityClasses$7(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(Tablelvl2Context$1.Provider, {
    value: tablelvl2$1,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(TableBodyRoot, _extends$X({
      className: clsx(classes.root, className),
      as: component,
      ref: ref,
      role: component === defaultComponent$2 ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? TableBody.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var TableBody$1 = TableBody;

function getTableCellUtilityClass(slot) {
  return generateUtilityClass('MuiTableCell', slot);
}
const tableCellClasses = generateUtilityClasses('MuiTableCell', ['root', 'head', 'body', 'footer', 'sizeSmall', 'sizeMedium', 'paddingCheckbox', 'paddingNone', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'stickyHeader']);
var tableCellClasses$1 = tableCellClasses;

const _excluded$6 = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"];
const useUtilityClasses$6 = ownerState => {
  const {
    classes,
    variant,
    align,
    padding,
    size,
    stickyHeader
  } = ownerState;
  const slots = {
    root: ['root', variant, stickyHeader && 'stickyHeader', align !== 'inherit' && `align${capitalize$1(align)}`, padding !== 'normal' && `padding${capitalize$1(padding)}`, `size${capitalize$1(size)}`]
  };
  return composeClasses$1(slots, getTableCellUtilityClass, classes);
};
const TableCellRoot = styled$2('td', {
  name: 'MuiTableCell',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`size${capitalize$1(ownerState.size)}`], ownerState.padding !== 'normal' && styles[`padding${capitalize$1(ownerState.padding)}`], ownerState.align !== 'inherit' && styles[`align${capitalize$1(ownerState.align)}`], ownerState.stickyHeader && styles.stickyHeader];
  }
})(({
  theme,
  ownerState
}) => _extends$X({}, theme.typography.body2, {
  display: 'table-cell',
  verticalAlign: 'inherit',
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? lighten_1(alpha_1(theme.palette.divider, 1), 0.88) : darken_1(alpha_1(theme.palette.divider, 1), 0.68)}`,
  textAlign: 'left',
  padding: 16
}, ownerState.variant === 'head' && {
  color: (theme.vars || theme).palette.text.primary,
  lineHeight: theme.typography.pxToRem(24),
  fontWeight: theme.typography.fontWeightMedium
}, ownerState.variant === 'body' && {
  color: (theme.vars || theme).palette.text.primary
}, ownerState.variant === 'footer' && {
  color: (theme.vars || theme).palette.text.secondary,
  lineHeight: theme.typography.pxToRem(21),
  fontSize: theme.typography.pxToRem(12)
}, ownerState.size === 'small' && {
  padding: '6px 16px',
  [`&.${tableCellClasses$1.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: '0 12px 0 16px',
    '& > *': {
      padding: 0
    }
  }
}, ownerState.padding === 'checkbox' && {
  width: 48,
  // prevent the checkbox column from growing
  padding: '0 0 0 4px'
}, ownerState.padding === 'none' && {
  padding: 0
}, ownerState.align === 'left' && {
  textAlign: 'left'
}, ownerState.align === 'center' && {
  textAlign: 'center'
}, ownerState.align === 'right' && {
  textAlign: 'right',
  flexDirection: 'row-reverse'
}, ownerState.align === 'justify' && {
  textAlign: 'justify'
}, ownerState.stickyHeader && {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: (theme.vars || theme).palette.background.default
}));

/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */
const TableCell = /*#__PURE__*/React$1.forwardRef(function TableCell(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTableCell'
  });
  const {
      align = 'inherit',
      className,
      component: componentProp,
      padding: paddingProp,
      scope: scopeProp,
      size: sizeProp,
      sortDirection,
      variant: variantProp
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$6);
  const table = React$1.useContext(TableContext$1);
  const tablelvl2 = React$1.useContext(Tablelvl2Context$1);
  const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  let component;
  if (componentProp) {
    component = componentProp;
  } else {
    component = isHeadCell ? 'th' : 'td';
  }
  let scope = scopeProp;
  // scope is not a valid attribute for <td/> elements.
  // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
  if (component === 'td') {
    scope = undefined;
  } else if (!scope && isHeadCell) {
    scope = 'col';
  }
  const variant = variantProp || tablelvl2 && tablelvl2.variant;
  const ownerState = _extends$X({}, props, {
    align,
    component,
    padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
    size: sizeProp || (table && table.size ? table.size : 'medium'),
    sortDirection,
    stickyHeader: variant === 'head' && table && table.stickyHeader,
    variant
  });
  const classes = useUtilityClasses$6(ownerState);
  let ariaSort = null;
  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }
  return /*#__PURE__*/jsxRuntimeExports.jsx(TableCellRoot, _extends$X({
    as: component,
    ref: ref,
    className: clsx(classes.root, className),
    "aria-sort": ariaSort,
    scope: scope,
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? TableCell.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: PropTypes.oneOf(['checkbox', 'none', 'normal']),
  /**
   * Set scope attribute.
   */
  scope: PropTypes.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: PropTypes.oneOf(['asc', 'desc', false]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['body', 'footer', 'head']), PropTypes.string])
} : void 0;
var TableCell$1 = TableCell;

function getTableContainerUtilityClass(slot) {
  return generateUtilityClass('MuiTableContainer', slot);
}
generateUtilityClasses('MuiTableContainer', ['root']);

const _excluded$5 = ["className", "component"];
const useUtilityClasses$5 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses$1(slots, getTableContainerUtilityClass, classes);
};
const TableContainerRoot = styled$2('div', {
  name: 'MuiTableContainer',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  width: '100%',
  overflowX: 'auto'
});
const TableContainer = /*#__PURE__*/React$1.forwardRef(function TableContainer(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTableContainer'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$5);
  const ownerState = _extends$X({}, props, {
    component
  });
  const classes = useUtilityClasses$5(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(TableContainerRoot, _extends$X({
    ref: ref,
    as: component,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? TableContainer.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Table`.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var TableContainer$1 = TableContainer;

function getTableHeadUtilityClass(slot) {
  return generateUtilityClass('MuiTableHead', slot);
}
generateUtilityClasses('MuiTableHead', ['root']);

const _excluded$4 = ["className", "component"];
const useUtilityClasses$4 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses$1(slots, getTableHeadUtilityClass, classes);
};
const TableHeadRoot = styled$2('thead', {
  name: 'MuiTableHead',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-header-group'
});
const tablelvl2 = {
  variant: 'head'
};
const defaultComponent$1 = 'thead';
const TableHead = /*#__PURE__*/React$1.forwardRef(function TableHead(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTableHead'
  });
  const {
      className,
      component = defaultComponent$1
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$4);
  const ownerState = _extends$X({}, props, {
    component
  });
  const classes = useUtilityClasses$4(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(Tablelvl2Context$1.Provider, {
    value: tablelvl2,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(TableHeadRoot, _extends$X({
      as: component,
      className: clsx(classes.root, className),
      ref: ref,
      role: component === defaultComponent$1 ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? TableHead.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var TableHead$1 = TableHead;

function getTableRowUtilityClass(slot) {
  return generateUtilityClass('MuiTableRow', slot);
}
const tableRowClasses = generateUtilityClasses('MuiTableRow', ['root', 'selected', 'hover', 'head', 'footer']);
var tableRowClasses$1 = tableRowClasses;

const _excluded$3 = ["className", "component", "hover", "selected"];
const useUtilityClasses$3 = ownerState => {
  const {
    classes,
    selected,
    hover,
    head,
    footer
  } = ownerState;
  const slots = {
    root: ['root', selected && 'selected', hover && 'hover', head && 'head', footer && 'footer']
  };
  return composeClasses$1(slots, getTableRowUtilityClass, classes);
};
const TableRowRoot = styled$2('tr', {
  name: 'MuiTableRow',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.head && styles.head, ownerState.footer && styles.footer];
  }
})(({
  theme
}) => ({
  color: 'inherit',
  display: 'table-row',
  verticalAlign: 'middle',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${tableRowClasses$1.hover}:hover`]: {
    backgroundColor: (theme.vars || theme).palette.action.hover
  },
  [`&.${tableRowClasses$1.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    '&:hover': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : alpha_1(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
    }
  }
}));
const defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */
const TableRow = /*#__PURE__*/React$1.forwardRef(function TableRow(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTableRow'
  });
  const {
      className,
      component = defaultComponent,
      hover = false,
      selected = false
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$3);
  const tablelvl2 = React$1.useContext(Tablelvl2Context$1);
  const ownerState = _extends$X({}, props, {
    component,
    hover,
    selected,
    head: tablelvl2 && tablelvl2.variant === 'head',
    footer: tablelvl2 && tablelvl2.variant === 'footer'
  });
  const classes = useUtilityClasses$3(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsx(TableRowRoot, _extends$X({
    as: component,
    ref: ref,
    className: clsx(classes.root, className),
    role: component === defaultComponent ? null : 'row',
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? TableRow.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: PropTypes.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var TableRow$1 = TableRow;

var ArrowDownwardIcon = createSvgIcon( /*#__PURE__*/jsxRuntimeExports.jsx("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');

function getTableSortLabelUtilityClass(slot) {
  return generateUtilityClass('MuiTableSortLabel', slot);
}
const tableSortLabelClasses = generateUtilityClasses('MuiTableSortLabel', ['root', 'active', 'icon', 'iconDirectionDesc', 'iconDirectionAsc']);
var tableSortLabelClasses$1 = tableSortLabelClasses;

const _excluded$2 = ["active", "children", "className", "direction", "hideSortIcon", "IconComponent"];
const useUtilityClasses$2 = ownerState => {
  const {
    classes,
    direction,
    active
  } = ownerState;
  const slots = {
    root: ['root', active && 'active'],
    icon: ['icon', `iconDirection${capitalize$1(direction)}`]
  };
  return composeClasses$1(slots, getTableSortLabelUtilityClass, classes);
};
const TableSortLabelRoot = styled$2(ButtonBase$1, {
  name: 'MuiTableSortLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.active && styles.active];
  }
})(({
  theme
}) => ({
  cursor: 'pointer',
  display: 'inline-flex',
  justifyContent: 'flex-start',
  flexDirection: 'inherit',
  alignItems: 'center',
  '&:focus': {
    color: (theme.vars || theme).palette.text.secondary
  },
  '&:hover': {
    color: (theme.vars || theme).palette.text.secondary,
    [`& .${tableSortLabelClasses$1.icon}`]: {
      opacity: 0.5
    }
  },
  [`&.${tableSortLabelClasses$1.active}`]: {
    color: (theme.vars || theme).palette.text.primary,
    [`& .${tableSortLabelClasses$1.icon}`]: {
      opacity: 1,
      color: (theme.vars || theme).palette.text.secondary
    }
  }
}));
const TableSortLabelIcon = styled$2('span', {
  name: 'MuiTableSortLabel',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, styles[`iconDirection${capitalize$1(ownerState.direction)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$X({
  fontSize: 18,
  marginRight: 4,
  marginLeft: 4,
  opacity: 0,
  transition: theme.transitions.create(['opacity', 'transform'], {
    duration: theme.transitions.duration.shorter
  }),
  userSelect: 'none'
}, ownerState.direction === 'desc' && {
  transform: 'rotate(0deg)'
}, ownerState.direction === 'asc' && {
  transform: 'rotate(180deg)'
}));

/**
 * A button based label for placing inside `TableCell` for column sorting.
 */
const TableSortLabel = /*#__PURE__*/React$1.forwardRef(function TableSortLabel(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTableSortLabel'
  });
  const {
      active = false,
      children,
      className,
      direction = 'asc',
      hideSortIcon = false,
      IconComponent = ArrowDownwardIcon
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$2);
  const ownerState = _extends$X({}, props, {
    active,
    direction,
    hideSortIcon,
    IconComponent
  });
  const classes = useUtilityClasses$2(ownerState);
  return /*#__PURE__*/jsxRuntimeExports.jsxs(TableSortLabelRoot, _extends$X({
    className: clsx(classes.root, className),
    component: "span",
    disableRipple: true,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [children, hideSortIcon && !active ? null : /*#__PURE__*/jsxRuntimeExports.jsx(TableSortLabelIcon, {
      as: IconComponent,
      className: clsx(classes.icon),
      ownerState: ownerState
    })]
  }));
});
process.env.NODE_ENV !== "production" ? TableSortLabel.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */
  active: PropTypes.bool,
  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The current sort direction.
   * @default 'asc'
   */
  direction: PropTypes.oneOf(['asc', 'desc']),
  /**
   * Hide sort icon when active is false.
   * @default false
   */
  hideSortIcon: PropTypes.bool,
  /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */
  IconComponent: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var TableSortLabel$1 = TableSortLabel;

function getTextFieldUtilityClass(slot) {
  return generateUtilityClass('MuiTextField', slot);
}
generateUtilityClasses('MuiTextField', ['root']);

const _excluded$1 = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"];
const variantComponent = {
  standard: Input$1,
  filled: FilledInput$1,
  outlined: OutlinedInput$1
};
const useUtilityClasses$1 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses$1(slots, getTextFieldUtilityClass, classes);
};
const TextFieldRoot = styled$2(FormControl$1, {
  name: 'MuiTextField',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});

/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */
const TextField = /*#__PURE__*/React$1.forwardRef(function TextField(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTextField'
  });
  const {
      autoComplete,
      autoFocus = false,
      children,
      className,
      color = 'primary',
      defaultValue,
      disabled = false,
      error = false,
      FormHelperTextProps,
      fullWidth = false,
      helperText,
      id: idOverride,
      InputLabelProps,
      inputProps,
      InputProps,
      inputRef,
      label,
      maxRows,
      minRows,
      multiline = false,
      name,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      required = false,
      rows,
      select = false,
      SelectProps,
      type,
      value,
      variant = 'outlined'
    } = props,
    other = _objectWithoutPropertiesLoose$3(props, _excluded$1);
  const ownerState = _extends$X({}, props, {
    autoFocus,
    color,
    disabled,
    error,
    fullWidth,
    multiline,
    required,
    select,
    variant
  });
  const classes = useUtilityClasses$1(ownerState);
  if (process.env.NODE_ENV !== 'production') {
    if (select && !children) {
      console.error('MUI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }
  const InputMore = {};
  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }
    InputMore.label = label;
  }
  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }
    InputMore['aria-describedby'] = undefined;
  }
  const id = useId(idOverride);
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const inputLabelId = label && id ? `${id}-label` : undefined;
  const InputComponent = variantComponent[variant];
  const InputElement = /*#__PURE__*/jsxRuntimeExports.jsx(InputComponent, _extends$X({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    maxRows: maxRows,
    minRows: minRows,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return /*#__PURE__*/jsxRuntimeExports.jsxs(TextFieldRoot, _extends$X({
    className: clsx(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    ref: ref,
    required: required,
    color: color,
    variant: variant,
    ownerState: ownerState
  }, other, {
    children: [label != null && label !== '' && /*#__PURE__*/jsxRuntimeExports.jsx(InputLabel$1, _extends$X({
      htmlFor: id,
      id: inputLabelId
    }, InputLabelProps, {
      children: label
    })), select ? /*#__PURE__*/jsxRuntimeExports.jsx(MSelect, _extends$X({
      "aria-describedby": helperTextId,
      id: id,
      labelId: inputLabelId,
      value: value,
      input: InputElement
    }, SelectProps, {
      children: children
    })) : InputElement, helperText && /*#__PURE__*/jsxRuntimeExports.jsx(FormHelperText$1, _extends$X({
      id: helperTextId
    }, FormHelperTextProps, {
      children: helperText
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? TextField.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: PropTypes.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: PropTypes.object,
  /**
   * The size of the component.
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes /* @typescript-to-proptypes-ignore */.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var MTextField = TextField;

var _circle$1;
function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }
var SvgEllipse = function SvgEllipse(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React$1.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5,
    stroke: "currentColor",
    strokeWidth: 3
  })));
};

var _circle;
function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React$1.createElement("circle", {
    cx: 6,
    cy: 6.5,
    r: 4.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 3
  })));
};

var basicFrontSize$1 = 'text-14';
var statusMap$1 = {
    added: {
        color: 'text-limeGreen-500',
        text: 'Added',
        fontSize: basicFrontSize$1,
        Icon: SvgEllipse,
    },
    modified: {
        color: 'text-yellow-500',
        text: 'Modified',
        fontSize: basicFrontSize$1,
        Icon: SvgEllipse,
    },
    renamed: {
        color: 'text-yellow-500',
        text: 'Renamed',
        fontSize: basicFrontSize$1,
        Icon: SvgEllipse,
    },
    deleted: {
        color: 'text-gray-400',
        text: 'Deleted',
        fontSize: basicFrontSize$1,
        Icon: SvgEllipse,
    },
    restored: {
        color: 'text-blue-500',
        text: 'Restored',
        fontSize: basicFrontSize$1,
        Icon: SvgEllipse,
    },
    approved: {
        color: 'text-limeGreen-500',
        text: 'Added',
        fontSize: basicFrontSize$1,
        Icon: SvgCircle,
    },
    editing: {
        color: 'text-yellow-500',
        text: 'Editing',
        fontSize: basicFrontSize$1,
        Icon: SvgCircle,
    },
    reviewing: {
        color: 'text-yellow-500',
        text: 'Reviewing',
        fontSize: basicFrontSize$1,
        Icon: SvgCircle,
    },
    deprecated: {
        color: 'text-gray-400',
        text: 'Deprecated',
        fontSize: basicFrontSize$1,
        Icon: SvgCircle,
    },
    conflicted: {
        color: 'text-red-500',
        text: 'Conflicted',
        fontSize: basicFrontSize$1,
        Icon: SvgCircle,
    },
    conflictAdded: {
        color: 'text-red-500',
        text: 'Added',
        fontSize: basicFrontSize$1,
        Icon: SvgCircle,
    },
    conflictModified: {
        color: 'text-red-500',
        text: 'Modified',
        fontSize: basicFrontSize$1,
        Icon: SvgCircle,
    },
    conflictDeleted: {
        color: 'text-red-500',
        text: 'Deleted',
        fontSize: basicFrontSize$1,
        Icon: SvgCircle,
    },
    locked: {
        color: 'text-grey-500',
        text: 'Locked',
        fontSize: basicFrontSize$1,
        Icon: SvgEllipse,
    },
    illegalName: {
        color: 'text-red-500',
        text: 'Illegal Name',
        fontSize: basicFrontSize$1,
        Icon: SvgCircle,
        infoTooltip: 'This file can\'t be uploaded because its path contains an illegal character: * "  < > : | ?',
    },
};

var _path$g, _path2$5;
function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$g || (_path$g = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M8.572 11.429V6.857H6.286V8H7.43v3.429H5.715v1.143h4.571v-1.143zM8.002 3.429a.857.857 0 1 0 0 1.714.857.857 0 0 0 0-1.714"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M8 16A8 8 0 1 1 8-.001 8 8 0 0 1 8 16M8 1.143a6.857 6.857 0 1 0 0 13.714A6.857 6.857 0 0 0 8 1.143"
  })));
};

// ./src/stories/Button.js
var WorkflowStatus = function (props) {
    var _a = props.status, status = _a === void 0 ? 'modified' : _a, style = props.style, textStyle = props.textStyle;
    var statusInfo = statusMap$1[status];
    var /* Icon, */ infoTooltip = statusInfo.infoTooltip;
    var tooltip = null;
    if (infoTooltip) {
        var tooltipIcon = (React__default.createElement("div", null,
            React__default.createElement(SvgInformation, { className: 'pl-1 overflow-visible text-blue-500' })));
        tooltip = (React__default.createElement("div", { className: 'flex h-full justify-center items-center' },
            React__default.createElement(Tooltip$1, { title: infoTooltip, placement: 'right', componentsProps: {
                    tooltip: {
                        sx: { backgroundColor: 'black', maxWidth: 'none' },
                    },
                    arrow: { sx: { color: 'black' } },
                }, arrow: true }, tooltipIcon)));
    }
    return (React__default.createElement("div", { className: 'flex items-center', style: style },
        React__default.createElement(default_1$6, { className: "".concat(statusInfo.color) }),
        React__default.createElement("span", { className: "ml-1 ".concat(statusInfo.fontSize), style: textStyle }, statusInfo.text),
        tooltip));
};

var _g$v;
function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
var SvgSynced$1 = function SvgSynced(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g$v || (_g$v = /*#__PURE__*/React$1.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#synced_svg__clip0_284_33448)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "m10.5 16.06-3.75-3.75 1.06-1.06 2.69 2.69 5.689-5.69 1.061 1.061z"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M12 1.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18"
  }))));
};

var _g$u;
function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g$u || (_g$u = /*#__PURE__*/React$1.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#downArrow_svg__clip0_342_17036)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M12 22.5a10.5 10.5 0 1 1 0-21 10.5 10.5 0 0 1 0 21M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18"
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "m16.954 13.273-.637-.637-4.006 4.006V6.085h-.897v10.557l-4.006-4.006-.637.637 5.092 5.09z"
  }))));
};

var _g$t;
function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
var SvgUpArrow = function SvgUpArrow(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g$t || (_g$t = /*#__PURE__*/React$1.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#upArrow_svg__clip0_531_39624)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M12 22.833a10.5 10.5 0 1 1 0-20.999 10.5 10.5 0 0 1 0 21m0-19.5a9 9 0 1 0 0 18 9 9 0 0 0 0-18"
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "m6.773 11.06.636.637 4.006-4.006v10.558h.898V7.69l4.006 4.006.636-.636-5.091-5.092z"
  }))));
};

var _g$s;
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
var SvgConflict = function SvgConflict(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _g$s || (_g$s = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#conflict_svg__clip0_342_17162)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M12 2.167a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21m0 19.5a9 9 0 1 1 0-18.001 9 9 0 0 1 0 18"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M12.75 6.667h-1.5v8.25h1.5zM12 17.167a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25"
  }))));
};

var _g$r;
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
var SvgPartially = function SvgPartially(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g$r || (_g$r = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#partially_svg__clip0_391_15087)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M12.5 2a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21m0 19.5a9 9 0 1 1 0-18 9 9 0 0 1 0 18"
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M7.5 10c5 0 5 5.75 10 5.75"
  }))));
};

var _g$q;
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
var SvgForbidden = function SvgForbidden(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g$q || (_g$q = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#forbidden_svg__clip0_513_33096)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M12.5 2a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21m0 19.5a9 9 0 1 1 0-18 9 9 0 0 1 0 18"
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "m8.227 16.712 8.486-8.485"
  }))));
};

var basicFrontSize = 'text-14';
var statusMap = {
    synced: {
        color: 'text-limeGreen-500',
        text: 'Synced',
        fontSize: basicFrontSize,
        Icon: SvgSynced$1,
    },
    downloading: {
        color: 'text-gray-500',
        text: 'Downloading',
        fontSize: basicFrontSize,
        Icon: SvgDownArrow,
    },
    folderDownloading: {
        color: 'text-gray-500',
        text: 'Downloading...',
        fontSize: basicFrontSize,
        Icon: SvgDownArrow,
    },
    uploading: {
        color: 'text-gray-500',
        text: 'Uploading',
        fontSize: basicFrontSize,
        Icon: SvgUpArrow,
    },
    conflict: {
        color: 'text-orange-500',
        text: 'Conflict',
        fontSize: basicFrontSize,
        Icon: SvgConflict,
    },
    partialSyncFailed: {
        color: 'text-orange-500',
        text: 'Contains Errors',
        fontSize: basicFrontSize,
        Icon: SvgPartially,
    },
    partially: {
        color: 'text-yellow-500',
        text: 'Partially synced',
        fontSize: basicFrontSize,
        Icon: SvgPartially,
    },
    notSynced: {
        color: 'text-gray-500',
        text: 'Not synced',
        fontSize: basicFrontSize,
        Icon: SvgPartially,
    },
    syncing: {
        color: 'text-gray-500',
        text: 'Syncing...',
        fontSize: basicFrontSize,
        Icon: SvgPartially,
    },
    syncFailed: {
        color: 'text-red-500',
        text: 'Sync failed',
        fontSize: basicFrontSize,
        Icon: SvgPartially,
    },
    notConnected: {
        color: 'text-gray-400',
        text: 'Not Connected',
        fontSize: basicFrontSize,
        Icon: SvgForbidden,
    },
    uploadFailed: {
        color: 'text-orange-500',
        textColor: 'text-orange-500',
        text: 'Upload Failed',
        fontSize: basicFrontSize,
        Icon: SvgUpArrow,
    },
    conflictResolved: {
        color: 'text-black-1000',
        text: 'Conflict Resolved',
        fontSize: basicFrontSize,
        Icon: SvgSynced$1,
    },
    uploadPending: {
        color: 'text-gray-500',
        text: 'Upload queued...',
        fontSize: basicFrontSize,
        Icon: SvgUpArrow,
    },
    uploadCompleted: {
        color: 'text-black-1000',
        text: 'Upload completed.',
        fontSize: basicFrontSize,
        Icon: SvgUpArrow,
    },
    downloadPending: {
        color: 'text-gray-500',
        text: 'Download queued...',
        fontSize: basicFrontSize,
        Icon: SvgDownArrow,
    },
    downloadCompleted: {
        color: 'text-black-1000',
        text: 'Download completed.',
        fontSize: basicFrontSize,
        Icon: SvgDownArrow,
    },
    toBeContributed: {
        color: 'text-black-1000',
        text: 'To be contributed.',
        fontSize: basicFrontSize,
        Icon: SvgSynced$1,
    },
    none: {
        color: 'text-black-1000',
        text: '一',
        fontSize: basicFrontSize,
        Icon: null,
    },
};

var SyncStatus = function (props) {
    var _a;
    var style = props.style, additionalStyle = props.additionalStyle, textStyle = props.textStyle, additional = props.additional, customIcon = props.customIcon, status = props.status, onRenderStatus = props.onRenderStatus;
    var statusInfo = statusMap[status];
    var Icon = statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.Icon;
    return (React__default.createElement("section", { className: 'flex items-center', style: style },
        customIcon || (Icon && React__default.createElement(Icon, { className: "".concat(statusInfo.color) })),
        React__default.createElement("span", { className: "text-14 ml-1.375 ".concat(statusInfo.fontSize, " ").concat((statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.textColor) || ''), style: textStyle }, (_a = onRenderStatus === null || onRenderStatus === void 0 ? void 0 : onRenderStatus(status)) !== null && _a !== void 0 ? _a : statusInfo.text),
        React__default.createElement("span", { className: 'flex-row ml-1 text-12 text-gray-500 leading-17.64', style: additionalStyle }, additional)));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var defaultOptions$1 = {};
function getDefaultOptions() {
  return defaultOptions$1;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}

var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE
};

var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}

/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result;

  // Check for the difference of less than month
  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign * difference);

    // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign;

    // Check for cases of one full calendar month
    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign * (difference - Number(isLastMonthNotFull));
  }

  // Prevent negative zero
  return result === 0 ? 0 : result;
}

/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters$3.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters$3.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$1 = formatters;

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance$1 = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var formatDistance$2 = formatDistance$1;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$1 = formatRelative;

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance$2,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

function assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      target[property] = object[property];
    }
  }
  return target;
}

function cloneObject$1(object) {
  return assign({}, object);
}

var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;

/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */

function formatDistance(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale;
  requiredArgs(2, arguments);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  if (!locale.formatDistance) {
    throw new RangeError('locale must contain formatDistance property');
  }
  var comparison = compareAsc(dirtyDate, dirtyBaseDate);
  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }
  var localizeOptions = assign(cloneObject$1(options), {
    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
    comparison: comparison
  });
  var dateLeft;
  var dateRight;
  if (comparison > 0) {
    dateLeft = toDate(dirtyBaseDate);
    dateRight = toDate(dirtyDate);
  } else {
    dateLeft = toDate(dirtyDate);
    dateRight = toDate(dirtyBaseDate);
  }
  var seconds = differenceInSeconds(dateRight, dateLeft);
  var offsetInSeconds = (getTimezoneOffsetInMilliseconds(dateRight) - getTimezoneOffsetInMilliseconds(dateLeft)) / 1000;
  var minutes = Math.round((seconds - offsetInSeconds) / 60);
  var months;

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options !== null && options !== void 0 && options.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance('halfAMinute', 0, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', minutes, localizeOptions);
      }
    }

    // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return locale.formatDistance('xMinutes', minutes, localizeOptions);

    // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale.formatDistance('aboutXHours', 1, localizeOptions);

    // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return locale.formatDistance('aboutXHours', hours, localizeOptions);

    // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale.formatDistance('xDays', 1, localizeOptions);

    // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions);

    // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('aboutXMonths', months, localizeOptions);
  }
  months = differenceInMonths(dateRight, dateLeft);

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('xMonths', nearestMonth, localizeOptions);

    // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12;
    var years = Math.floor(months / 12);

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance('aboutXYears', years, localizeOptions);

      // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance('overXYears', years, localizeOptions);

      // N years 9 months up to N year 12 months
    } else {
      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
  }
}

// Disabled theme for easy of development while federating module.
var AvatarStyled = styled$4.div(function (_a) {
    var /* theme, */ size = _a.size, selected = _a.selected, bg = _a.bg;
    var styleSheet = {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 100,
        // border: `1px solid ${theme.color.wfWhite}`,
        border: '1px solid white',
        boxSizing: 'border-box',
        backgroundColor: bg,
    };
    if (size === 'small') {
        styleSheet.width = 18;
        styleSheet.height = 18;
    }
    if (size === 'normal') {
        styleSheet.width = 24;
        styleSheet.height = 24;
    }
    if (size === 'medium') {
        styleSheet.width = 32;
        styleSheet.height = 32;
    }
    if (size === 'xmedium') {
        styleSheet.width = 44;
        styleSheet.height = 44;
    }
    if (size === 'large') {
        styleSheet.width = 56;
        styleSheet.height = 56;
    }
    if (selected) {
        // styleSheet.border = `1px solid ${theme.color.wfBlue}`;
        styleSheet.border = '1px solid #0f2eff';
    }
    return styleSheet;
});
var AvatarImgStyled = styled$4.img(function () { return ({
    display: 'block',
    borderRadius: 100,
}); });
var AvatarNameStyled = styled$4.span(function (_a) {
    var /* theme, */ size = _a.size;
    var styleSheet = {
        textAlign: 'center',
        // color: `${theme.color.wfWhite}`,
        color: 'white',
        // fontSize: `${theme.font.size.default}`,
        fontSize: '1rem',
    };
    if (size === 'small') {
        // styleSheet.fontSize = `${theme.font.size.small}`;
        styleSheet.fontSize = '0.875rem';
    }
    if (size === 'normal') {
        // styleSheet.fontSize = `${theme.font.size.default}`;
        styleSheet.fontSize = '1rem';
    }
    if (size === 'medium') {
        // styleSheet.fontSize = `${theme.font.size.medium}`;
        styleSheet.fontSize = '1.25rem';
    }
    if (size === 'large') {
        // styleSheet.fontSize = `${theme.font.size.large}`;
        styleSheet.fontSize = '1.875rem';
    }
    return styleSheet;
});

var Avatar = function (_a) {
    var onClick = _a.onClick, src = _a.src, alt = _a.alt, _b = _a.name, name = _b === void 0 ? '?' : _b, _c = _a.size, size = _c === void 0 ? 'normal' : _c, rest = __rest(_a, ["onClick", "src", "alt", "name", "size"]);
    var fallBackChar = name.charAt(0).toUpperCase();
    var bg = '#0f2eff';
    if ([
        'A',
        'C',
        'E',
        'G',
        'I',
        'K',
        'M',
        'O',
        'Q',
        'S',
        'U',
        'W',
        'Y',
        'Z',
    ].includes(fallBackChar)) {
        bg = '#FFCB00';
    }
    if (name === '?')
        bg = 'transparent';
    return (React__default.createElement(AvatarStyled, __assign({ bg: bg, onClick: onClick, size: size }, rest), src ? (React__default.createElement(AvatarImgStyled, { src: src, alt: alt })) : (React__default.createElement(AvatarNameStyled, { size: size }, fallBackChar))));
};

var renderContributionPayload = function (props) {
    var contributionDate = props.contributionDate, onCheckInsClick = props.onCheckInsClick, _a = props.numContributions, numContributions = _a === void 0 ? 0 : _a;
    return (React__default.createElement("section", { className: 'flex items-center' },
        React__default.createElement("span", { className: 'text-10 font-normal' }, formatDistance(new Date(contributionDate), new Date(), {
            addSuffix: true,
        })),
        React__default.createElement("div", { className: 'w-px h-4 bg-black-1000 mx-2' }),
        React__default.createElement("span", { className: 'text-primary text-10 cursor-pointer', onClick: onCheckInsClick }, "".concat(numContributions, " Contributions"))));
};
var LastContributionView = function (props) {
    var className = props.className, style = props.style, leftSectionStyle = props.leftSectionStyle, rightSectionStyle = props.rightSectionStyle, mAvatar = props.mAvatar, username = props.username, usernameStyle = props.usernameStyle, avatarAlt = props.avatarAlt, avatarUrl = props.avatarUrl, propsAvatarName = props.avatarName, title = props.title, description = props.description, descriptionStyle = props.descriptionStyle;
    var avatarName = propsAvatarName;
    if (!avatarName)
        avatarName = username;
    var separator = Boolean(title) && Boolean(description) ? ' - ' : '';
    return (React__default.createElement("section", { className: "flex items-center justify-between px-2 py-4 border border-gray-300 h-7 ".concat(className), style: style },
        React__default.createElement("div", { className: 'flex justify-center items-center truncate', style: leftSectionStyle },
            React__default.createElement("div", { className: 'flex justify-center items-center flex-shrink-0' },
                React__default.createElement(Avatar, __assign({ src: avatarUrl, alt: avatarAlt, name: avatarName }, mAvatar))),
            React__default.createElement("div", { className: 'ml-1 text-10 text-black-1000 font-bold', style: usernameStyle }, username),
            React__default.createElement("div", { className: 'ml-2 flex justify-center items-center truncate', style: descriptionStyle },
                React__default.createElement("span", { className: 'text-10 text-black-1000 truncate' }, title),
                React__default.createElement("span", { className: 'mx-1' }, separator),
                React__default.createElement("span", { className: 'text-10 text-gray-600 truncate', style: { flexShrink: 99999999 } }, description))),
        React__default.createElement("div", { className: 'ml-1 flex justify-center items-center flex-shrink-0', style: rightSectionStyle }, renderContributionPayload({
            contributionDate: props.contributionDate,
            numContributions: props.numContributions,
            onCheckInsClick: props.onCheckInsClick,
        }))));
};

var _rect$g, _g$p;
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
var SvgDefault$2 = function SvgDefault(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$g || (_rect$g = /*#__PURE__*/React$1.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E6ECFF",
    rx: 16
  })), _g$p || (_g$p = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#default_svg__clip0_319_14049)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#0F2EFF",
    d: "m22.411 12.156-6.154-3.423a.532.532 0 0 0-.517 0l-6.154 3.422a.502.502 0 0 0-.186.18.472.472 0 0 0-.068.243v6.844c0 .086.024.17.068.244a.5.5 0 0 0 .186.178l6.154 3.423a.531.531 0 0 0 .517 0l6.154-3.422a.5.5 0 0 0 .186-.18.47.47 0 0 0 .068-.243v-6.844a.471.471 0 0 0-.068-.244.501.501 0 0 0-.186-.178m-6.412-2.434 5.136 2.856-5.136 2.856-5.136-2.856zm-5.641 3.707 5.128 2.852v5.712l-5.128-2.851zm6.154 8.564v-5.712l5.128-2.852v5.713z"
  }))));
};

var _rect$f, _g$o;
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
var SvgChange$1 = function SvgChange(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$f || (_rect$f = /*#__PURE__*/React$1.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E6ECFF",
    rx: 16
  })), _g$o || (_g$o = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#change_svg__clip0_344_21780)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#0F2EFF",
    d: "m22.411 12.156-6.154-3.423a.532.532 0 0 0-.517 0l-6.154 3.422a.502.502 0 0 0-.186.18.472.472 0 0 0-.068.243v6.844c0 .086.024.17.068.244a.5.5 0 0 0 .186.178l6.154 3.423a.531.531 0 0 0 .517 0l6.154-3.422a.5.5 0 0 0 .186-.18.47.47 0 0 0 .068-.243v-6.844a.471.471 0 0 0-.068-.244.501.501 0 0 0-.186-.178m-6.412-2.434 5.136 2.856-5.136 2.856-5.136-2.856zm-5.641 3.707 5.128 2.852v5.712l-5.128-2.851zm6.154 8.564v-5.712l5.128-2.852v5.713z"
  }), /*#__PURE__*/React$1.createElement("circle", {
    cx: 21,
    cy: 11,
    r: 3,
    fill: "#00D54C"
  }))));
};

var _rect$e, _g$n, _rect2$7;
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
var SvgLock$2 = function SvgLock(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$e || (_rect$e = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#ECECEC",
    rx: 15.5
  })), _g$n || (_g$n = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#lock_svg__clip0_579_35623)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#444",
    d: "m22.411 12.156-6.154-3.423a.532.532 0 0 0-.517 0l-6.154 3.422a.502.502 0 0 0-.186.18.472.472 0 0 0-.068.243v6.844c0 .086.024.17.068.244a.5.5 0 0 0 .186.178l6.154 3.423a.531.531 0 0 0 .517 0l6.154-3.422a.5.5 0 0 0 .186-.18.47.47 0 0 0 .068-.243v-6.844a.471.471 0 0 0-.068-.244.501.501 0 0 0-.186-.178m-6.412-2.434 5.136 2.856-5.136 2.856-5.136-2.856zm-5.641 3.707 5.128 2.852v5.712l-5.128-2.851zm6.154 8.564v-5.712l5.128-2.852v5.713z"
  }))), _rect2$7 || (_rect2$7 = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#C5C5C5",
    rx: 15.5
  })));
};

var _rect$d, _g$m, _rect2$6;
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var SvgChecked$1 = function SvgChecked(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$d || (_rect$d = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#E6ECFF",
    rx: 15.5
  })), _g$m || (_g$m = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#checked_svg__clip0_391_15111)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#0F2EFF",
    d: "m22.411 12.155-6.154-3.422a.532.532 0 0 0-.517 0l-6.154 3.422a.502.502 0 0 0-.186.18.472.472 0 0 0-.068.243v6.844c0 .086.024.17.068.244a.502.502 0 0 0 .186.178l6.154 3.423a.532.532 0 0 0 .517 0l6.154-3.422a.501.501 0 0 0 .186-.18.471.471 0 0 0 .068-.243v-6.844a.471.471 0 0 0-.068-.244.502.502 0 0 0-.186-.179m-6.412-2.433 5.136 2.856-5.136 2.856-5.136-2.856zm-5.641 3.707 5.128 2.852v5.712l-5.128-2.851zm6.154 8.564v-5.712l5.128-2.852v5.713z"
  }), /*#__PURE__*/React$1.createElement("rect", {
    width: 8,
    height: 8,
    x: 16,
    y: 9,
    fill: "#0F2EFF",
    rx: 2
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.15 11.962a.25.25 0 0 1 0 .354l-2.25 2.25a.25.25 0 0 1-.354 0l-1.25-1.25a.25.25 0 1 1 .353-.354l1.074 1.073 2.073-2.073a.25.25 0 0 1 .353 0",
    clipRule: "evenodd"
  }))), _rect2$6 || (_rect2$6 = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#0F2EFF",
    rx: 15.5
  })));
};

var _rect$c, _rect2$5, _path$f, _rect3$2;
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
var SvgHoverChecked = function SvgHoverChecked(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$c || (_rect$c = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#E6ECFF",
    rx: 15.5
  })), _rect2$5 || (_rect2$5 = /*#__PURE__*/React$1.createElement("rect", {
    width: 12,
    height: 12,
    x: 10,
    y: 10,
    fill: "#0F2EFF",
    rx: 2
  })), _path$f || (_path$f = /*#__PURE__*/React$1.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.222 14.443a.375.375 0 0 1 0 .53l-3.375 3.375a.375.375 0 0 1-.53 0l-1.875-1.875a.375.375 0 1 1 .53-.53l1.61 1.61 3.11-3.11a.375.375 0 0 1 .53 0",
    clipRule: "evenodd"
  })), _rect3$2 || (_rect3$2 = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#0F2EFF",
    rx: 15.5
  })));
};

var _rect$b, _rect2$4, _rect3$1;
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
var SvgHoverPartiallyChecked = function SvgHoverPartiallyChecked(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$b || (_rect$b = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#E6ECFF",
    rx: 15.5
  })), _rect2$4 || (_rect2$4 = /*#__PURE__*/React$1.createElement("rect", {
    width: 12,
    height: 12,
    x: 10,
    y: 10,
    fill: "#0F2EFF",
    rx: 2
  })), _rect3$1 || (_rect3$1 = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#0F2EFF",
    rx: 15.5
  })), /*#__PURE__*/React$1.createElement("path", {
    d: "M12.823 16.124h6.751",
    style: {
      fill: "#762929",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 1.534,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers",
      strokeDasharray: "none"
    }
  }));
};

var _rect$a, _rect2$3, _rect3;
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
var SvgHoverUnchecked = function SvgHoverUnchecked(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$a || (_rect$a = /*#__PURE__*/React$1.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E6ECFF",
    rx: 16
  })), _rect2$3 || (_rect2$3 = /*#__PURE__*/React$1.createElement("rect", {
    width: 11,
    height: 11,
    x: 10.5,
    y: 10.5,
    fill: "#fff",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React$1.createElement("rect", {
    width: 11,
    height: 11,
    x: 10.5,
    y: 10.5,
    stroke: "#ADADAD",
    rx: 1.5
  })));
};

var _rect$9, _g$l;
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
var SvgDefault$1 = function SvgDefault(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$9 || (_rect$9 = /*#__PURE__*/React$1.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E6ECFF",
    rx: 16
  })), _g$l || (_g$l = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#default_svg__clip0_319_14068)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#0F2EFF",
    d: "m13.699 11.654 1.628 1.684.277.292h6.109v7.234H10.284v-9.21zm0-.987h-3.415a.935.935 0 0 0-.673.289 1.006 1.006 0 0 0-.279.698v9.21c0 .262.1.513.279.699.179.185.42.289.673.289h11.429a.935.935 0 0 0 .673-.29c.179-.185.28-.436.28-.698V13.63c0-.262-.101-.514-.28-.699a.935.935 0 0 0-.673-.289h-5.714l-1.624-1.684a.923.923 0 0 0-.676-.291"
  }))));
};

var _rect$8, _g$k;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
var SvgChange = function SvgChange(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$8 || (_rect$8 = /*#__PURE__*/React$1.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E6ECFF",
    rx: 16
  })), _g$k || (_g$k = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#change_svg__clip0_344_21798)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#0F2EFF",
    d: "m13.703 11.654 1.628 1.684.276.292h6.11v7.234H10.288v-9.21zm0-.987h-3.415a.935.935 0 0 0-.673.289 1.006 1.006 0 0 0-.28.698v9.21c0 .262.101.513.28.699.178.185.42.289.673.289h11.429a.935.935 0 0 0 .673-.29c.179-.185.28-.436.28-.698V13.63c0-.262-.101-.514-.28-.699a.935.935 0 0 0-.673-.289h-5.714l-1.624-1.684a.923.923 0 0 0-.676-.291"
  }), /*#__PURE__*/React$1.createElement("circle", {
    cx: 21,
    cy: 12,
    r: 3,
    fill: "#00D54C"
  }))));
};

var _rect$7, _g$j, _rect2$2;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
var SvgChecked = function SvgChecked(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$7 || (_rect$7 = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#E6ECFF",
    rx: 15.5
  })), _g$j || (_g$j = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#checked_svg__clip0_391_15096)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#0F2EFF",
    d: "m13.699 11.654 1.628 1.684.277.292h6.109v7.234H10.284v-9.21zm0-.987h-3.415a.935.935 0 0 0-.673.289 1.006 1.006 0 0 0-.279.698v9.21c0 .262.1.513.279.698.179.186.42.29.673.29h11.429a.935.935 0 0 0 .673-.29c.179-.185.28-.436.28-.698V13.63c0-.262-.101-.514-.28-.699a.935.935 0 0 0-.673-.29h-5.714l-1.624-1.683a.923.923 0 0 0-.676-.291"
  }), /*#__PURE__*/React$1.createElement("rect", {
    width: 8,
    height: 8,
    x: 16,
    y: 9,
    fill: "#0F2EFF",
    rx: 2
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.15 11.962a.25.25 0 0 1 0 .354l-2.25 2.25a.25.25 0 0 1-.354 0l-1.25-1.25a.25.25 0 1 1 .353-.354l1.074 1.073 2.073-2.073a.25.25 0 0 1 .353 0",
    clipRule: "evenodd"
  }))), _rect2$2 || (_rect2$2 = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#0F2EFF",
    rx: 15.5
  })));
};

var _rect$6, _g$i, _rect2$1;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
var SvgPartiallyChecked = function SvgPartiallyChecked(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$6 || (_rect$6 = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#E6ECFF",
    rx: 15.5
  })), _g$i || (_g$i = /*#__PURE__*/React$1.createElement("g", {
    fill: "#0F2EFF",
    clipPath: "url(#partiallyChecked_svg__clip0_391_15096)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "m13.699 11.654 1.628 1.684.277.292h6.109v7.234H10.284v-9.21zm0-.987h-3.415a.935.935 0 0 0-.673.289 1.006 1.006 0 0 0-.279.698v9.21c0 .262.1.513.279.698.179.186.42.29.673.29h11.429a.935.935 0 0 0 .673-.29c.179-.185.28-.436.28-.698V13.63c0-.262-.101-.514-.28-.699a.935.935 0 0 0-.673-.29h-5.714l-1.624-1.683a.923.923 0 0 0-.676-.291"
  }), /*#__PURE__*/React$1.createElement("rect", {
    width: 8,
    height: 8,
    x: 16,
    y: 9,
    rx: 2
  }))), _rect2$1 || (_rect2$1 = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#0F2EFF",
    rx: 15.5
  })), /*#__PURE__*/React$1.createElement("path", {
    d: "M18.198 13.155h4.172",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }));
};

var _rect$5, _g$h, _rect2;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
var SvgLock$1 = function SvgLock(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect$5 || (_rect$5 = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#ECECEC",
    rx: 15.5
  })), _g$h || (_g$h = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#lock_svg__clip0_579_35633)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#444",
    d: "m13.699 11.654 1.628 1.684.277.292h6.109v7.234H10.284v-9.21zm0-.987h-3.415a.935.935 0 0 0-.673.289 1.006 1.006 0 0 0-.279.698v9.21c0 .262.1.513.279.699.179.185.42.289.673.289h11.429a.935.935 0 0 0 .673-.29c.179-.185.28-.436.28-.698V13.63c0-.262-.101-.514-.28-.699a.935.935 0 0 0-.673-.289h-5.714l-1.624-1.684a.923.923 0 0 0-.676-.291"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React$1.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#C5C5C5",
    rx: 15.5
  })));
};

var _g$g;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
var SvgDisconnected = function SvgDisconnected(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g$g || (_g$g = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#disconnected_svg__clip0_256_10360)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.993 7.007 8.55 4.481H3.429v13.815h8.57v1.482H3.43c-.38 0-.743-.156-1.01-.434A1.51 1.51 0 0 1 2 18.296V4.481c0-.393.15-.77.418-1.047A1.403 1.403 0 0 1 3.428 3H8.55c.189 0 .375.038.55.113.173.075.331.185.464.324L12 5.963h8.571c.38 0 .743.156 1.01.434.268.278.419.654.419 1.047V12h-1.429V7.444h-9.164z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3,
    d: "m17.758 16.869 3.111-3.112.889.89-3.111 3.11 3.11 3.112-.888.888-3.111-3.11-3.111 3.11-.89-.888 3.112-3.112-3.111-3.11.889-.89z"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeWidth: 2,
    d: "m7.367 54.467-.707.707.707.707 2.91 2.91.706.706.708-.707 45.254-45.254.708-.708-.708-.707-2.909-2.909-.707-.707-.707.707z"
  }))));
};

var _g$f;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
var SvgUnconnected = function SvgUnconnected(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g$f || (_g$f = /*#__PURE__*/React$1.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#unconnected_svg__clip0_256_10354)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "m8.55 4.481 2.443 2.526.414.437h9.164v10.852H3.43V4.481zM8.55 3H3.429c-.38 0-.743.156-1.01.434A1.51 1.51 0 0 0 2 4.48v13.815c0 .393.15.77.418 1.048.268.277.632.434 1.01.434h17.143c.38 0 .743-.156 1.01-.434A1.51 1.51 0 0 0 22 18.296V7.444c0-.393-.15-.77-.418-1.047a1.403 1.403 0 0 0-1.01-.434H12L9.564 3.437a1.427 1.427 0 0 0-.465-.324A1.384 1.384 0 0 0 8.55 3"
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.75,
    d: "m2.763 20.425-.265.265.265.265 1.091 1.091.265.265.265-.265 16.971-16.97.265-.265-.265-.266-1.09-1.09-.266-.266-.265.266z"
  }))));
};

var _g$e;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
var SvgSynced = function SvgSynced(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g$e || (_g$e = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#synced_svg__clip0_256_10100)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.993 7.007 8.55 4.481H3.429v13.815h8.57v1.482H3.43c-.38 0-.743-.156-1.01-.434A1.51 1.51 0 0 1 2 18.296V4.481c0-.393.15-.77.418-1.047A1.403 1.403 0 0 1 3.428 3H8.55c.189 0 .375.038.55.113.173.075.331.185.464.324L12 5.963h8.571c.38 0 .743.156 1.01.434.268.278.419.654.419 1.047V12h-1.429V7.444h-9.164z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#00D54C",
    d: "m16.848 20.099-3.348-3.35.946-.945 2.402 2.4 5.08-5.079.947.947z"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeWidth: 2,
    d: "m7.367 54.467-.707.707.707.707 2.91 2.91.706.706.708-.707 45.254-45.254.708-.708-.708-.707-2.909-2.909-.707-.707-.707.707z"
  }))));
};

function useHoverStatus(elementRef) {
    var _a = useState(false), isHovered = _a[0], setIsHovered = _a[1];
    // eslint-disable-next-line consistent-return
    useEffect(function () {
        var element = elementRef.current;
        var handleMouseEnter = function () {
            setIsHovered(true);
        };
        var handleMouseLeave = function () {
            setIsHovered(false);
        };
        if (element) {
            element.addEventListener('mouseenter', handleMouseEnter);
            element.addEventListener('mouseleave', handleMouseLeave);
            return function () {
                element.removeEventListener('mouseenter', handleMouseEnter);
                element.removeEventListener('mouseleave', handleMouseLeave);
            };
        }
    }, [elementRef]);
    return [isHovered, setIsHovered];
}

var getFileStatusIcon = function (fileStatus, svgProps) {
    switch (fileStatus) {
        case 'change':
            return React__default.createElement(SvgChange$1, __assign({}, svgProps));
        case 'lock':
            return React__default.createElement(SvgLock$2, __assign({}, svgProps));
        default:
            return React__default.createElement(SvgDefault$2, __assign({}, svgProps));
    }
};
var getFolderStatusIcon = function (fileStatus, svgProps) {
    switch (fileStatus) {
        case 'change':
            return React__default.createElement(SvgChange, __assign({}, svgProps));
        case 'lock':
            return React__default.createElement(SvgLock$1, __assign({}, svgProps));
        case 'disconnected':
            return (React__default.createElement(SvgDisconnected, __assign({ className: 'text-orange-500' }, svgProps)));
        case 'unconnected':
            return React__default.createElement(SvgUnconnected, __assign({ className: 'text-gray-400' }, svgProps));
        case 'synced':
            return React__default.createElement(SvgSynced, __assign({}, svgProps));
        case 'remoteContributions':
            return React__default.createElement(SvgSynced, __assign({}, svgProps));
        case 'syncing':
            return React__default.createElement(SvgSynced, __assign({}, svgProps));
        case 'contributing':
            return React__default.createElement(SvgSynced, __assign({}, svgProps));
        case 'pulling':
            return React__default.createElement(SvgSynced, __assign({}, svgProps));
        default:
            return React__default.createElement(SvgDefault$1, __assign({}, svgProps));
    }
};
var getIcon = function (type, isHovered, selection, fileStatus, svgProps, disabled) {
    if (type === 'file') {
        if (disabled)
            return getFileStatusIcon(fileStatus, __assign(__assign({}, svgProps), { opacity: 0.5 }));
        if (isHovered) {
            if (selection === 'selected')
                return React__default.createElement(SvgHoverChecked, __assign({}, svgProps));
            return React__default.createElement(SvgHoverUnchecked, __assign({}, svgProps));
        }
        if (selection === 'selected')
            return React__default.createElement(SvgChecked$1, __assign({}, svgProps));
        return getFileStatusIcon(fileStatus, svgProps);
    }
    if (type === 'folder') {
        if (disabled)
            return getFolderStatusIcon(fileStatus, __assign(__assign({}, svgProps), { opacity: 0.5 }));
        if (isHovered) {
            if (selection === 'selected')
                return React__default.createElement(SvgHoverChecked, __assign({}, svgProps));
            if (selection === 'partiallySelected')
                return React__default.createElement(SvgHoverPartiallyChecked, __assign({}, svgProps));
            return React__default.createElement(SvgHoverUnchecked, __assign({}, svgProps));
        }
        if (selection === 'selected')
            return React__default.createElement(SvgChecked, __assign({}, svgProps));
        if (selection === 'partiallySelected')
            return React__default.createElement(SvgPartiallyChecked, __assign({}, svgProps));
        return getFolderStatusIcon(fileStatus, svgProps);
    }
    return null;
};
var FileIcon = function (props) {
    var _a = props.type, type = _a === void 0 ? 'file' : _a, svgProps = props.svgProps, onClick = props.onClick, selection = props.selection, fileStatus = props.fileStatus, disabled = props.disabled;
    var elementRef = useRef(null);
    var _b = useHoverStatus(elementRef), isHovered = _b[0], setHovered = _b[1];
    var lastCheck = useRef(Date.now());
    var checkHover = function (e) {
        if (Date.now() - lastCheck.current < 32)
            return;
        lastCheck.current = Date.now();
        if (elementRef.current) {
            var mouseOver = elementRef.current.contains(e.target);
            if (mouseOver) {
                setHovered(true);
            }
            else {
                setHovered(false);
            }
        }
    };
    // Hack because mouseenter events in useHoverStatus are lost sometimes
    // The condition and the throttling makes this fairly lightweight
    // eslint-disable-next-line consistent-return
    useEffect(function () {
        if (isHovered) {
            window.addEventListener('mousemove', checkHover, true);
            return function () {
                window.removeEventListener('mousemove', checkHover, true);
            };
        }
    }, [isHovered]);
    var icon = getIcon(type, isHovered && Boolean(onClick), selection, fileStatus, svgProps, disabled);
    return (React__default.createElement("div", { className: "".concat(onClick && !disabled ? 'cursor-pointer' : '', " w-fit"), ref: elementRef, onClick: function () {
            if (disabled)
                return;
            onClick === null || onClick === void 0 ? void 0 : onClick();
        } },
        React__default.createElement("div", null, icon)));
};

var _g$d;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
var SvgDefault = function SvgDefault(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _g$d || (_g$d = /*#__PURE__*/React$1.createElement("g", {
    fill: "#000",
    clipPath: "url(#default_svg__clip0_290_13674)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "m22.803 11.95 6.514 6.736 1.105 1.166H54.86V48.79H9.145V11.95zm0-3.95H9.145c-1.01 0-1.979.416-2.693 1.157a4.026 4.026 0 0 0-1.116 2.793v36.84c0 1.048.401 2.053 1.116 2.793a3.742 3.742 0 0 0 2.693 1.157H54.86c1.011 0 1.98-.416 2.694-1.157a4.026 4.026 0 0 0 1.116-2.793V19.852a4.026 4.026 0 0 0-1.115-2.794 3.742 3.742 0 0 0-2.694-1.157H32.003l-6.496-6.736a3.805 3.805 0 0 0-1.24-.863A3.692 3.692 0 0 0 22.803 8"
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m7.367 54.467-.707.707.707.707 2.91 2.91.706.706.708-.707 45.254-45.254.708-.708-.708-.707-2.909-2.909-.707-.707-.707.707z"
  }))));
};

var _g$c;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
var SvgNoChange = function SvgNoChange(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _g$c || (_g$c = /*#__PURE__*/React$1.createElement("g", {
    fill: "#000",
    clipPath: "url(#noChange_svg__clip0_396_41530)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "m29.317 18.686-6.514-6.736H9.145v36.84h22.856v3.95H9.145c-1.01 0-1.979-.416-2.693-1.157a4.026 4.026 0 0 1-1.116-2.793V11.95c0-1.047.401-2.052 1.116-2.793A3.742 3.742 0 0 1 9.145 8h13.658c.502 0 1 .102 1.464.302.465.2.886.493 1.24.863l6.496 6.736H54.86c1.01 0 1.98.416 2.694 1.157a4.026 4.026 0 0 1 1.115 2.794V32h-3.81V19.852H30.423z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m7.367 54.467-.707.707.707.707 2.91 2.91.706.706.708-.707 45.254-45.254.708-.708-.708-.707-2.909-2.909-.707-.707-.707.707z"
  }), /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#noChange_svg__clip1_396_41530)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "m44.15 43.636 6.25-5.619 6.25 5.618v8.523h-3.399v-6h-6v6h-3.1zm-1.5-.669L40 45.35l1.003 1.116 1.648-1.482v8.674h6.1v-6h3v6h6.4v-8.674l1.648 1.482 1.003-1.116-2.651-2.383v-.059h-.066L50.401 36l-7.684 6.908h-.066z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "m50.4 38.017.335-.372a.5.5 0 0 0-.668 0zm-6.25 5.619-.334-.372a.5.5 0 0 0-.165.372zm12.5 0h.5a.5.5 0 0 0-.165-.372zm0 8.522v.5a.5.5 0 0 0 .5-.5zm-3.399 0h-.5a.5.5 0 0 0 .5.5zm0-6h.5a.5.5 0 0 0-.5-.5zm-6 0v-.5a.5.5 0 0 0-.5.5zm0 6v.5a.5.5 0 0 0 .5-.5zm-3.1 0h-.5a.5.5 0 0 0 .5.5zM40 45.35l-.334-.372a.5.5 0 0 0-.038.706zm2.65-2.383.335.372a.5.5 0 0 0 .166-.372zm-1.647 3.499-.372.334a.5.5 0 0 0 .706.038zm1.648-1.482h.5a.5.5 0 0 0-.835-.372zm0 8.674h-.5a.5.5 0 0 0 .5.5zm6.1 0v.5a.5.5 0 0 0 .5-.5zm0-6v-.5a.5.5 0 0 0-.5.5zm3 0h.5a.5.5 0 0 0-.5-.5zm0 6h-.5a.5.5 0 0 0 .5.5zm6.4 0v.5a.5.5 0 0 0 .5-.5zm0-8.674.334-.372a.5.5 0 0 0-.834.372zm1.648 1.482-.334.372a.5.5 0 0 0 .706-.038zm1.003-1.116.372.334a.5.5 0 0 0-.038-.706zm-2.651-2.383h-.5a.5.5 0 0 0 .165.372zm0-.059h.5a.5.5 0 0 0-.5-.5zm-.066 0-.334.372a.5.5 0 0 0 .334.128zM50.401 36l.334-.372a.5.5 0 0 0-.668 0zm-7.684 6.908v.5a.5.5 0 0 0 .334-.128zm-.066 0v-.5a.5.5 0 0 0-.5.5zm7.416-5.263-6.25 5.619.668.744 6.25-5.62zm6.918 5.619-6.25-5.619-.668.744 6.25 5.618zm-.834.371v8.523h1v-8.522zm.5 8.023h-3.4v1h3.4zm-2.9.5v-6h-1v6zm-.5-6.5h-6v1h6zm-6.5.5v6h1v-6zm.5 5.5h-3.1v1h3.1zm-2.6.5v-8.522h-1v8.522zm-4.317-6.436 2.651-2.383-.669-.743-2.65 2.382zm1.04.41-1.002-1.116-.744.669 1.003 1.115zm.942-1.52-1.648 1.482.67.744 1.647-1.482zm-.165.372v8.674h1v-8.674zm.5 9.174h6.1v-1h-6.1zm6.6-.5v-6h-1v6zm-.5-5.5h3v-1h-3zm2.5-.5v6h1v-6zm.5 6.5h6.4v-1h-6.4zm6.9-.5v-8.674h-1v8.674zm1.482-7.564-1.648-1.482-.669.744 1.649 1.482zm.297-1.078-1.003 1.116.744.668 1.003-1.115zm-2.614-1.677 2.651 2.383.67-.744-2.652-2.383zm.835-.372v-.059h-1v.059zm-.5-.559h-.066v1h.066zm-8.084-6.036 7.684 6.908.668-.744-7.684-6.908zM43.05 43.28l7.684-6.908-.668-.744-7.685 6.908zm-.334-.872h-.066v1h.066zm-.566.5v.06h1v-.06z"
  })))));
};

var _g$b;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
var SvgNoCheckout = function SvgNoCheckout(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _g$b || (_g$b = /*#__PURE__*/React$1.createElement("g", {
    fill: "#000",
    clipPath: "url(#noCheckout_svg__clip0_290_13682)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "m29.317 18.686-6.514-6.736H9.145v36.84h22.856v3.95H9.145c-1.01 0-1.979-.416-2.693-1.157a4.026 4.026 0 0 1-1.116-2.793V11.95c0-1.047.401-2.052 1.116-2.793A3.742 3.742 0 0 1 9.145 8h13.658c.502 0 1 .102 1.464.302.465.2.886.493 1.24.863l6.496 6.736H54.86c1.01 0 1.98.416 2.694 1.157a4.026 4.026 0 0 1 1.115 2.794V32h-3.81V19.852H30.423z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "m57.223 45.685-.865-.865-5.447 5.446V35.913h-1.22v14.353l-5.446-5.446-.865.865 6.921 6.921z"
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m7.367 54.467-.707.707.707.707 2.91 2.91.706.706.708-.707 45.254-45.254.708-.708-.708-.707-2.909-2.909-.707-.707-.707.707z"
  }))));
};

var _g$a;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var SvgUpToDate = function SvgUpToDate(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _g$a || (_g$a = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#upToDate_svg__clip0_410_19747)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m29.317 18.686-6.514-6.736H9.145v36.84h22.856v3.95H9.145c-1.01 0-1.979-.416-2.693-1.157a4.026 4.026 0 0 1-1.116-2.793V11.95c0-1.047.401-2.052 1.116-2.793A3.742 3.742 0 0 1 9.145 8h13.658c.502 0 1 .102 1.464.302.465.2.886.493 1.24.863l6.496 6.736H54.86c1.01 0 1.98.416 2.694 1.157a4.026 4.026 0 0 1 1.115 2.794V32h-3.81V19.852H30.423z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeWidth: 2,
    d: "m54.036 9.212-.707-.707-.707.707L7.367 54.467l-.707.707.707.707 2.91 2.91.706.706.708-.707 45.254-45.254.708-.708-.708-.707z"
  }), /*#__PURE__*/React$1.createElement("g", {
    fill: "#00D54C",
    clipPath: "url(#upToDate_svg__clip1_410_19747)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "m48.5 49.06-3.75-3.75 1.06-1.06 2.69 2.69 5.689-5.69 1.061 1.061z"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M50 34.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21M50 54a9 9 0 1 1 0-17.999A9 9 0 0 1 50 54"
  })))));
};

var _g$9;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var SvgNoContribute = function SvgNoContribute(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    fill: "none"
  }, props), _g$9 || (_g$9 = /*#__PURE__*/React$1.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#noContribute_svg__clip0_290_13674)"
  }, /*#__PURE__*/React$1.createElement("mask", {
    id: "noContribute_svg__a",
    width: 24,
    height: 16,
    x: 40,
    y: 40,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#fff",
    d: "M40 40h24v16H40z"
  }), /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "M57.804 47.862a4.707 4.707 0 0 0-8.544-2.877 1.883 1.883 0 0 0-3.061 1.556 2.941 2.941 0 1 0 2.67 3.227 4.707 4.707 0 0 0 7.611 1.213 2.354 2.354 0 1 0 1.324-3.12",
    clipRule: "evenodd"
  })), /*#__PURE__*/React$1.createElement("path", {
    d: "m57.804 47.862-2.998-.098a3 3 0 0 0 4.072 2.899zm-8.544-2.877-1.883 2.336a3 3 0 0 0 4.33-.6zm-3.061 1.556-.26 2.989a3 3 0 0 0 3.257-3.13zm2.67 3.227 2.695-1.316a3 3 0 0 0-5.681 1.017zm7.611 1.213 2.76-1.176a3 3 0 0 0-4.914-.911zm-1.673-3.275-.001.058 5.997.195c.002-.084.004-.168.004-.253zM53.1 46c.943 0 1.707.764 1.707 1.706h6A7.706 7.706 0 0 0 53.1 40zm-1.394.722A1.7 1.7 0 0 1 53.1 46v-6a7.7 7.7 0 0 0-6.286 3.248zm-3.626.847c-.263 0-.512-.094-.703-.248l3.766-4.672a4.875 4.875 0 0 0-3.063-1.08zm1.117-1.117c0 .617-.5 1.117-1.117 1.117v-6a4.883 4.883 0 0 0-4.883 4.883zm-.001-.051v.05h-6c0 .077.003.154.006.23zM45.94 49.53h-.001l.518-5.978a5.994 5.994 0 0 0-.517-.022zM46 49.47v.003a.084.084 0 0 1-.006.021.053.053 0 0 1-.011.018.053.053 0 0 1-.018.011.08.08 0 0 1-.021.006h-.003v-6A5.941 5.941 0 0 0 40 49.47zm-.059-.058h.003a.079.079 0 0 1 .021.006c.01.003.015.008.018.01a.053.053 0 0 1 .011.018.088.088 0 0 1 .006.022v.002h-6a5.941 5.941 0 0 0 5.941 5.942zm-.058.056a.08.08 0 0 1 .008-.026.05.05 0 0 1 .01-.014.059.059 0 0 1 .018-.011.082.082 0 0 1 .015-.004l.005-.001h.002v6a5.942 5.942 0 0 0 5.912-5.346zm7.217-.056c-.67 0-1.255-.386-1.536-.96l-5.392 2.63a7.707 7.707 0 0 0 6.928 4.33zm1.226-.52c-.314.324-.744.52-1.226.52v6a7.693 7.693 0 0 0 5.535-2.344zm4.32.52c.272 0 .498.167.594.392l-5.52 2.352a5.353 5.353 0 0 0 4.926 3.256zm-.647.647c0-.358.29-.648.647-.648v6a5.353 5.353 0 0 0 5.353-5.352zm.647.646a.647.647 0 0 1-.647-.647h6a5.353 5.353 0 0 0-5.353-5.352zm.232-.043a.653.653 0 0 1-.232.044v-6c-.67 0-1.317.124-1.915.353z",
    mask: "url(#noContribute_svg__a)"
  }), /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "m30.282 18.686-6.515-6.736H10.11v36.84H36v3.95H10.11c-1.01 0-1.979-.416-2.693-1.157A4.026 4.026 0 0 1 6.3 48.79V11.95c0-1.047.401-2.052 1.116-2.793A3.742 3.742 0 0 1 10.11 8h13.657c.503 0 1 .102 1.465.302.464.2.886.493 1.24.863l6.495 6.736h22.858c1.01 0 1.979.416 2.693 1.157a4.026 4.026 0 0 1 1.116 2.794V35h-3.81V19.852H31.388z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m8.332 54.467-.707.707.707.707 2.91 2.91.706.706.707-.707L57.91 13.536l.707-.708-.707-.707-2.909-2.909-.707-.707-.707.707z"
  }))));
};

var EmptyDriveState = function (props) {
    var _a;
    var _b = props.status, status = _b === void 0 ? 'default' : _b, title = props.title, description = props.description, titleStyle = props.titleStyle, descriptionStyle = props.descriptionStyle, iconStyle = props.iconStyle, rest = __rest(props, ["status", "title", "description", "titleStyle", "descriptionStyle", "iconStyle"]);
    var emptyDriveMap = {
        default: {
            icon: React__default.createElement(SvgDefault, null),
            title: 'Files will appear here once you or one of your collaborators check them in  from a Local Folder.',
            description: '',
        },
        noChange: {
            icon: React__default.createElement(SvgNoChange, null),
            title: 'No Local Changes.',
            description: 'You haven’t locked, made changes or added new files to your connected folder yet.',
        },
        noCheckout: {
            icon: React__default.createElement(SvgNoCheckout, null),
            title: 'No checked-out files.',
            description: 'Check-out files from the Cloud Drive to let others know you’re working on them locally',
        },
        upToDate: {
            icon: React__default.createElement(SvgUpToDate, null),
            title: 'Your files are up to date',
            description: 'Check-out files from the Project Drive to start working on them locally',
        },
        noContribute: {
            icon: React__default.createElement(SvgNoContribute, null),
            title: 'No Files contributed to Cloud Drive yet.',
            description: '',
        },
    };
    return (React__default.createElement("div", __assign({}, rest, { className: 'flex justify-center items-center flex-col' }),
        React__default.createElement("div", { style: iconStyle }, emptyDriveMap[status].icon),
        React__default.createElement("div", { style: titleStyle, className: 'mt-6 text-lg font-extrabold' }, title || emptyDriveMap[status].title),
        ((_a = emptyDriveMap[status]) === null || _a === void 0 ? void 0 : _a.description) && (React__default.createElement("div", { className: 'flex mt-4 justify-center items-center', style: descriptionStyle },
            React__default.createElement(SvgInformation, { className: 'mr-2' }),
            description || emptyDriveMap[status].description))));
};

function _extends$p() {
  _extends$p = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$p.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function composeClasses(slots, getUtilityClass, classes = undefined) {
  const output = {};
  Object.keys(slots).forEach(
  // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  slot => {
    output[slot] = slots[slot].reduce((acc, key) => {
      if (key) {
        const utilityClass = getUtilityClass(key);
        if (utilityClass !== '') {
          acc.push(utilityClass);
        }
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
      }
      return acc;
    }, []).join(' ');
  });
  return output;
}

function getLoadingButtonUtilityClass(slot) {
  return generateUtilityClass('MuiLoadingButton', slot);
}
const loadingButtonClasses = generateUtilityClasses('MuiLoadingButton', ['root', 'loading', 'loadingIndicator', 'loadingIndicatorCenter', 'loadingIndicatorStart', 'loadingIndicatorEnd', 'endIconLoadingEnd', 'startIconLoadingStart']);
var loadingButtonClasses$1 = loadingButtonClasses;

const _excluded = ["children", "disabled", "id", "loading", "loadingIndicator", "loadingPosition", "variant"];
const useUtilityClasses = ownerState => {
  const {
    loading,
    loadingPosition,
    classes
  } = ownerState;
  const slots = {
    root: ['root', loading && 'loading'],
    startIcon: [loading && `startIconLoading${capitalize$1(loadingPosition)}`],
    endIcon: [loading && `endIconLoading${capitalize$1(loadingPosition)}`],
    loadingIndicator: ['loadingIndicator', loading && `loadingIndicator${capitalize$1(loadingPosition)}`]
  };
  const composedClasses = composeClasses(slots, getLoadingButtonUtilityClass, classes);
  return _extends$p({}, classes, composedClasses);
};

// TODO use `import { rootShouldForwardProp } from '../styles/styled';` once move to core
const rootShouldForwardProp = prop => prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as' && prop !== 'classes';
const LoadingButtonRoot = styled$2(MuiButton, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiLoadingButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [styles.root, styles.startIconLoadingStart && {
      [`& .${loadingButtonClasses$1.startIconLoadingStart}`]: styles.startIconLoadingStart
    }, styles.endIconLoadingEnd && {
      [`& .${loadingButtonClasses$1.endIconLoadingEnd}`]: styles.endIconLoadingEnd
    }];
  }
})(({
  ownerState,
  theme
}) => _extends$p({
  [`& .${loadingButtonClasses$1.startIconLoadingStart}, & .${loadingButtonClasses$1.endIconLoadingEnd}`]: {
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.short
    }),
    opacity: 0
  }
}, ownerState.loadingPosition === 'center' && {
  transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color'], {
    duration: theme.transitions.duration.short
  }),
  [`&.${loadingButtonClasses$1.loading}`]: {
    color: 'transparent'
  }
}, ownerState.loadingPosition === 'start' && ownerState.fullWidth && {
  [`& .${loadingButtonClasses$1.startIconLoadingStart}, & .${loadingButtonClasses$1.endIconLoadingEnd}`]: {
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.short
    }),
    opacity: 0,
    marginRight: -8
  }
}, ownerState.loadingPosition === 'end' && ownerState.fullWidth && {
  [`& .${loadingButtonClasses$1.startIconLoadingStart}, & .${loadingButtonClasses$1.endIconLoadingEnd}`]: {
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.short
    }),
    opacity: 0,
    marginLeft: -8
  }
}));
const LoadingButtonLoadingIndicator = styled$2('span', {
  name: 'MuiLoadingButton',
  slot: 'LoadingIndicator',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.loadingIndicator, styles[`loadingIndicator${capitalize$1(ownerState.loadingPosition)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$p({
  position: 'absolute',
  visibility: 'visible',
  display: 'flex'
}, ownerState.loadingPosition === 'start' && (ownerState.variant === 'outlined' || ownerState.variant === 'contained') && {
  left: ownerState.size === 'small' ? 10 : 14
}, ownerState.loadingPosition === 'start' && ownerState.variant === 'text' && {
  left: 6
}, ownerState.loadingPosition === 'center' && {
  left: '50%',
  transform: 'translate(-50%)',
  color: (theme.vars || theme).palette.action.disabled
}, ownerState.loadingPosition === 'end' && (ownerState.variant === 'outlined' || ownerState.variant === 'contained') && {
  right: ownerState.size === 'small' ? 10 : 14
}, ownerState.loadingPosition === 'end' && ownerState.variant === 'text' && {
  right: 6
}, ownerState.loadingPosition === 'start' && ownerState.fullWidth && {
  position: 'relative',
  left: -10
}, ownerState.loadingPosition === 'end' && ownerState.fullWidth && {
  position: 'relative',
  right: -10
}));
const LoadingButton = /*#__PURE__*/React$1.forwardRef(function LoadingButton(inProps, ref) {
  const contextProps = React$1.useContext(ButtonGroupContext$1);
  const resolvedProps = resolveProps(contextProps, inProps);
  const props = useDefaultProps({
    props: resolvedProps,
    name: 'MuiLoadingButton'
  });
  const {
      children,
      disabled = false,
      id: idProp,
      loading = false,
      loadingIndicator: loadingIndicatorProp,
      loadingPosition = 'center',
      variant = 'text'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const id = useId(idProp);
  const loadingIndicator = loadingIndicatorProp != null ? loadingIndicatorProp : /*#__PURE__*/jsxRuntimeExports.jsx(CircularProgress$1, {
    "aria-labelledby": id,
    color: "inherit",
    size: 16
  });
  const ownerState = _extends$p({}, props, {
    disabled,
    loading,
    loadingIndicator,
    loadingPosition,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const loadingButtonLoadingIndicator = loading ? /*#__PURE__*/jsxRuntimeExports.jsx(LoadingButtonLoadingIndicator, {
    className: classes.loadingIndicator,
    ownerState: ownerState,
    children: loadingIndicator
  }) : null;
  return /*#__PURE__*/jsxRuntimeExports.jsxs(LoadingButtonRoot, _extends$p({
    disabled: disabled || loading,
    id: id,
    ref: ref
  }, other, {
    variant: variant,
    classes: classes,
    ownerState: ownerState,
    children: [ownerState.loadingPosition === 'end' ? children : loadingButtonLoadingIndicator, ownerState.loadingPosition === 'end' ? loadingButtonLoadingIndicator : children]
  }));
});
process.env.NODE_ENV !== "production" ? LoadingButton.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * @ignore
   */
  id: PropTypes.string,
  /**
   * If `true`, the loading indicator is shown and the button becomes disabled.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default we render a `CircularProgress` that is labelled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: PropTypes.node,
  /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */
  loadingPosition: chainPropTypes(PropTypes.oneOf(['start', 'end', 'center']), props => {
    if (props.loadingPosition === 'start' && !props.startIcon) {
      return new Error(`MUI: The loadingPosition="start" should be used in combination with startIcon.`);
    }
    if (props.loadingPosition === 'end' && !props.endIcon) {
      return new Error(`MUI: The loadingPosition="end" should be used in combination with endIcon.`);
    }
    return null;
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['contained', 'outlined', 'text']), PropTypes.string])
} : void 0;
var LoadingButton$1 = LoadingButton;

var global$2 = {
    // Layout
    layout: {
        maxWidth: '1440px',
        paddingInline: '4vw',
    },
    // Border radius
    borderRadius: {
        xsmall: '0.2em',
        small: '0.3em',
        medium: '1em',
        large: '1.5em',
        xlarge: '3em',
    },
    // Spacing
    spacing: {
        xsmall: '0.25rem',
        small: '0.5rem',
        default: '1rem',
        medium: '1.5rem',
        large: '2rem',
        xlarge: '3rem',
        xxlarge: '4rem',
    },
};

// Wikifactory Theme colors
var color = {
    // WF colors
    wfWhite: '#ffffff',
    wfBlack: '#000000',
    wfGrey: '#3d3d3d',
    wfGrey900: '#444444',
    wfGrey800: '#5D5D5D',
    wfGrey700: '#727272',
    wfGrey600: '#838383',
    wfGrey500: '#909090',
    wfGrey400: '#adadad',
    wfGrey300: '#cfcfcf',
    wfGrey200: '#e6e6e6',
    wfGrey100: '#ECECEC',
    wfYellow: '#ffcb00',
    wfYellow900: '#FED119',
    wfYellow800: '#FFD632',
    wfYellow700: '#FFDB4D',
    wfYellow600: '#FFE066',
    wfYellow500: '#FFE680',
    wfYellow400: '#FFEB99',
    wfYellow300: '#FFEFB2',
    wfYellow200: '#FFF4CC',
    wfYellow100: '#FFFAE6',
    wfBlue: '#0f2eff',
    wfBlue900: '#1950FF',
    wfBlue800: '#3363FF',
    wfBlue700: '#4D76FF',
    wfBlue600: '#658BFF',
    wfBlue500: '#809DFF',
    wfBlue400: '#98B1FF',
    wfBlue300: '#B2C4FF',
    wfBlue200: '#CCD8FF',
    wfBlue100: '#E6ECFF',
    wfGreen: '#00d54c',
    wfGreen900: '#19D46E',
    wfGreen800: '#33D97E',
    wfGreen700: '#4CDE8E',
    wfGreen600: '#67E39E',
    wfGreen500: '#80E7AF',
    wfGreen400: '#98ECBF',
    wfGreen300: '#B2F1CF',
    wfGreen200: '#CCF6DF',
    wfGreen100: '#E6FBEF',
    wfRed: '#ff1111',
    wfOrange: '#ff4d00',
    wfOrange900: '#FF6E18',
    wfOrange800: '#FF7D34',
    wfOrange700: '#FF8E4C',
    wfOrange600: '#FF9E66',
    wfOrange500: '#FFAE7F',
    wfOrange400: '#FFBE98',
    wfOrange300: '#FFCFB2',
    wfOrange200: '#FFDECC',
    wfOrange100: '#FFEFE6',
    wfPurple: '#9000ff',
    wfPurple900: '#8F40FF',
    wfPurple800: '#9C56FF',
    wfPurple700: '#A86BFF',
    wfPurple600: '#B57FFF',
    wfPurple500: '#C095FF',
    wfPurple400: '#CDAAFF',
    wfPurple300: '#DAC0FE',
    wfPurple200: '#E6D5FF',
    wfPurple100: '#F3EAFF',
    wfPink: '#ff00ff',
    // Theme colors
    primary: '#0f2eff',
    primaryLight: '#809DFF',
    primaryLightest: '#E6ECFF',
    primaryDark: '#00218E',
};

var font$1 = {
    // Font family
    family: {
        primary: 'HelveticaNowDisplay',
    },
    // Font weight
    weight: {
        regular: '300',
        xbold: '900',
    },
    // Line-height
    lineHeight: {
        small: '1',
        medium: '1.5',
        large: '2',
    },
    // Font Sizes
    size: {
        xsmall: '0.75rem',
        small: '0.875rem',
        default: '1rem',
        medium: '1.25rem',
        xmedium: '1.5rem',
        large: '1.875rem',
        xlarge: '3rem',
        xxlarge: '3.75rem',
    },
};

var breakpoints$1 = {
    // Breakpoints
    xsmall: '20em', // +/- 320px
    small: '26em', // +/- 416px
    medium: '40em', // +/- 640px
    large: '59em', // +/- 944px
    xlarge: '78em', // +/- 1248px
};

// Icons Theme paths
var icons$1 = {
    add: {
        path: 'M 13.375 10.625 L 13.375 1 L 10.625 1 L 10.625 10.625 L 1 10.625 L 1 13.375 L 10.625 13.375 L 10.625 23 L 13.375 23 L 13.375 13.375 L 23 13.375 L 23 10.625 L 13.375 10.625 Z',
    },
    aerospace: {
        path: 'M 5.156 17.729 L 11.439 11.446 L 12.55 12.557 L 6.267 18.84 L 5.156 17.729 Z  M 12.786 22.999 C 12.687 23 12.588 22.981 12.496 22.944 C 12.234 22.84 12.048 22.603 12.009 22.324 L 11.223 16.824 L 12.794 16.604 L 13.383 20.744 L 15.929 18.694 L 15.929 12.786 C 15.928 12.577 16.01 12.376 16.157 12.228 L 19.354 9.03 C 20.685 7.708 21.432 5.909 21.429 4.033 L 21.429 2.572 L 19.967 2.572 C 18.092 2.569 16.292 3.315 14.97 4.646 L 11.773 7.844 C 11.625 7.991 11.424 8.073 11.215 8.072 L 5.307 8.072 L 3.256 10.633 L 7.397 11.222 L 7.177 12.794 L 1.677 12.008 C 1.398 11.969 1.161 11.783 1.056 11.521 C 0.951 11.257 0.996 10.956 1.174 10.735 L 4.317 6.807 C 4.464 6.616 4.689 6.503 4.93 6.5 L 10.893 6.5 L 13.855 3.531 C 15.472 1.904 17.674 0.993 19.967 1.001 L 21.429 1.001 C 22.296 1.001 23 1.704 23 2.572 L 23 4.033 C 23.008 6.327 22.097 8.528 20.47 10.146 L 17.5 13.108 L 17.5 19.071 C 17.499 19.31 17.389 19.536 17.202 19.684 L 13.273 22.826 C 13.135 22.937 12.964 22.998 12.786 22.999 Z',
    },
    agriculture: {
        path: 'M 15.793 2.517 L 15.793 4.479 L 12.759 7.513 L 12.759 1 L 11.241 1 L 11.241 7.513 L 8.207 4.479 L 8.207 2.517 L 6.69 2.517 L 6.69 14.655 C 6.694 17.292 8.632 19.527 11.241 19.905 L 11.241 23 L 12.759 23 L 12.759 19.905 C 15.368 19.527 17.306 17.292 17.31 14.655 L 17.31 2.517 L 15.793 2.517 Z  M 11.241 18.371 C 9.477 18.009 8.209 16.457 8.207 14.655 L 8.207 12.693 L 11.241 15.728 L 11.241 18.371 Z  M 11.241 13.582 L 8.207 10.548 L 8.207 6.624 L 11.241 9.659 L 11.241 13.582 Z  M 12.759 9.659 L 15.793 6.624 L 15.793 10.548 L 12.759 13.582 L 12.759 9.659 Z  M 12.759 18.371 L 12.759 15.728 L 15.793 12.693 L 15.793 14.655 C 15.791 16.457 14.523 18.009 12.759 18.371 L 12.759 18.371 Z',
    },
    arrow_down: {
        path: 'M 20.8 14.2 L 19.59 12.99 L 12.88 19.59 L 12.88 1 L 11.12 1 L 11.12 19.59 L 4.41 12.99 L 3.2 14.2 L 12 23 L 20.8 14.2 Z',
    },
    arrow_left: {
        path: 'M 9.8 20.8 L 11.01 19.59 L 4.41 12.88 L 23 12.88 L 23 11.12 L 4.41 11.12 L 11.01 4.41 L 9.8 3.2 L 1 12 L 9.8 20.8 Z',
    },
    arrow_right: {
        path: 'M 14.2 3.2 L 12.99 4.41 L 19.59 11.12 L 1 11.12 L 1 12.88 L 19.59 12.88 L 12.99 19.59 L 14.2 20.8 L 23 12 L 14.2 3.2 Z',
    },
    arrow_up: {
        path: 'M 3.2 9.8 L 4.41 11.01 L 11.12 4.41 L 11.12 23 L 12.88 23 L 12.88 4.41 L 19.59 11.01 L 20.8 9.8 L 12 1 L 3.2 9.8 Z',
    },
    assembly: {
        path: 'M 11.153 7.238 L 11.153 18.411 L 39 18.411 L 39 7.238 L 11.153 7.238 Z  M 36.469 15.878 L 13.687 15.878 L 13.687 9.771 L 36.467 9.771 L 36.467 15.878 L 36.469 15.878 Z  M 11.153 32.882 L 39 32.882 L 39 21.709 L 11.153 21.709 L 11.153 32.882 Z  M 13.687 24.242 L 36.467 24.242 L 36.467 30.349 L 13.687 30.349 L 13.687 24.242 Z  M 3.533 6.964 L 1 6.964 L 1 33.036 L 3.533 33.036 L 3.533 27.896 L 7.94 27.896 L 7.94 25.362 L 3.533 25.362 L 3.533 15.04 L 7.94 15.04 L 7.94 12.507 L 3.533 12.507 L 3.533 6.964 Z',
        customStroke: '0.5px',
    },
    attachment: {
        path: 'M 21.473 14.27 L 9.73 2.527 C 7.772 0.491 4.562 0.491 2.527 2.448 C 0.491 4.406 0.491 7.694 2.527 9.651 C 2.527 9.651 2.605 9.73 2.605 9.73 L 4.797 12 L 5.893 10.904 L 3.623 8.633 C 2.292 7.302 2.292 5.032 3.623 3.701 C 4.954 2.37 7.224 2.292 8.555 3.623 C 8.555 3.623 8.555 3.623 8.633 3.701 L 20.299 15.367 C 21.708 16.698 21.708 18.968 20.377 20.299 C 19.046 21.708 16.776 21.708 15.445 20.377 C 15.445 20.377 15.445 20.377 15.367 20.299 L 9.573 14.505 C 8.79 13.722 8.868 12.47 9.573 11.765 C 10.356 11.06 11.53 11.06 12.313 11.765 L 15.523 14.975 L 16.619 13.879 C 16.619 13.879 13.331 10.591 13.331 10.591 C 11.922 9.26 9.73 9.338 8.399 10.747 C 7.146 12.078 7.146 14.192 8.399 15.601 L 14.27 21.473 C 16.228 23.509 19.438 23.509 21.473 21.552 C 23.509 19.594 23.509 16.306 21.473 14.27 C 21.473 14.349 21.473 14.27 21.473 14.27 L 21.473 14.27 Z',
    },
    automation: {
        path: 'M 11.082 12.916 C 7.797 12.916 5.124 10.243 5.124 6.959 C 5.124 3.673 7.797 1 11.082 1 C 11.335 1 11.541 1.206 11.541 1.459 L 11.541 12.459 C 11.541 12.712 11.335 12.916 11.082 12.916 Z  M 10.624 1.937 C 8.035 2.169 6.041 4.33 6.041 6.959 C 6.041 9.586 8.035 11.747 10.624 11.98 L 10.624 1.937 Z  M 2.374 23 C 2.121 23 1.916 22.794 1.916 22.541 C 1.916 17.487 6.028 13.375 11.082 13.375 C 11.335 13.375 11.541 13.581 11.541 13.834 L 11.541 22.541 C 11.541 22.794 11.335 23 11.082 23 L 2.374 23 Z  M 10.624 22.084 L 10.624 14.304 C 6.429 14.535 3.076 17.888 2.845 22.084 L 10.624 22.084 Z  M 12.916 12.916 C 12.665 12.916 12.459 12.712 12.457 12.461 C 12.456 12.208 12.661 12.002 12.913 12 C 13.066 11.999 13.22 11.991 13.374 11.976 L 13.374 10.974 C 13.374 10.758 13.521 10.575 13.73 10.527 C 14.131 10.435 14.511 10.276 14.858 10.056 C 14.932 10.009 15.017 9.984 15.104 9.984 C 15.226 9.984 15.341 10.032 15.429 10.118 L 16.139 10.829 C 16.375 10.633 16.59 10.417 16.787 10.182 L 16.075 9.47 C 15.922 9.317 15.897 9.082 16.013 8.9 C 16.234 8.552 16.392 8.173 16.485 7.771 C 16.532 7.564 16.716 7.416 16.931 7.416 L 17.934 7.416 C 17.948 7.264 17.956 7.108 17.957 6.956 C 17.956 6.805 17.948 6.653 17.934 6.5 L 16.931 6.5 C 16.716 6.5 16.532 6.354 16.485 6.145 C 16.392 5.743 16.233 5.364 16.013 5.016 C 15.899 4.836 15.925 4.597 16.075 4.446 L 16.787 3.734 C 16.59 3.499 16.375 3.283 16.139 3.087 L 15.429 3.797 C 15.341 3.885 15.226 3.934 15.104 3.934 C 15.017 3.934 14.932 3.909 14.858 3.863 C 14.51 3.642 14.131 3.483 13.729 3.39 C 13.52 3.342 13.374 3.158 13.374 2.944 L 13.374 1.941 C 13.22 1.926 13.066 1.918 12.913 1.916 C 12.66 1.915 12.456 1.709 12.457 1.456 C 12.459 1.204 12.665 1 12.916 1 C 13.251 1.002 13.584 1.032 13.911 1.09 C 14.131 1.127 14.291 1.317 14.291 1.541 L 14.291 2.594 C 14.544 2.675 14.792 2.779 15.028 2.902 L 15.773 2.155 C 15.86 2.068 15.974 2.02 16.097 2.02 C 16.193 2.02 16.285 2.05 16.364 2.105 C 16.908 2.493 17.38 2.966 17.767 3.509 C 17.898 3.692 17.877 3.94 17.718 4.099 L 16.971 4.845 C 17.096 5.082 17.2 5.329 17.28 5.584 L 18.333 5.584 C 18.556 5.584 18.746 5.743 18.785 5.963 C 18.842 6.292 18.872 6.626 18.874 6.956 C 18.872 7.29 18.842 7.625 18.785 7.954 C 18.746 8.174 18.556 8.334 18.333 8.334 L 17.28 8.334 C 17.2 8.588 17.096 8.835 16.972 9.071 L 17.719 9.819 C 17.877 9.977 17.899 10.226 17.769 10.408 C 17.381 10.952 16.909 11.425 16.364 11.812 C 16.287 11.867 16.194 11.898 16.098 11.898 C 15.976 11.898 15.86 11.849 15.774 11.763 L 15.028 11.016 C 14.791 11.14 14.544 11.244 14.29 11.324 L 14.29 12.377 C 14.29 12.6 14.131 12.789 13.911 12.828 C 13.581 12.885 13.246 12.916 12.918 12.918 C 12.918 12.918 12.916 12.918 12.916 12.918 L 12.916 12.918 L 12.916 12.916 Z  M 12.916 9.25 C 12.663 9.25 12.457 9.044 12.457 8.791 C 12.457 8.538 12.663 8.334 12.916 8.334 C 13.674 8.334 14.291 7.716 14.291 6.959 C 14.291 6.2 13.674 5.584 12.916 5.584 C 12.663 5.584 12.457 5.378 12.457 5.125 C 12.457 4.872 12.663 4.666 12.916 4.666 C 14.179 4.666 15.207 5.694 15.207 6.959 C 15.207 8.222 14.179 9.25 12.916 9.25 Z  M 21.624 23 C 21.373 23 21.168 22.796 21.166 22.544 C 21.164 22.239 21.144 21.931 21.108 21.625 L 19.653 21.625 C 19.436 21.625 19.247 21.471 19.203 21.259 C 19.089 20.704 18.9 20.167 18.644 19.664 C 18.553 19.486 18.588 19.272 18.729 19.131 L 19.82 18.042 C 19.314 17.264 18.687 16.585 17.954 16.018 L 16.911 17.062 C 16.826 17.148 16.71 17.195 16.587 17.195 C 16.5 17.195 16.414 17.171 16.34 17.124 C 15.811 16.788 15.237 16.532 14.631 16.364 C 14.433 16.309 14.294 16.128 14.294 15.922 L 14.294 14.41 C 13.84 14.332 13.378 14.293 12.916 14.291 C 12.793 14.291 12.679 14.244 12.591 14.157 C 12.505 14.071 12.457 13.955 12.457 13.832 C 12.457 13.581 12.663 13.375 12.916 13.375 C 13.565 13.376 14.216 13.446 14.85 13.582 C 15.06 13.627 15.212 13.816 15.212 14.03 L 15.212 15.581 C 15.664 15.73 16.101 15.924 16.516 16.159 L 17.585 15.089 C 17.671 15.003 17.787 14.956 17.91 14.956 C 18.005 14.956 18.096 14.984 18.174 15.039 C 19.246 15.792 20.128 16.746 20.797 17.874 C 20.904 18.055 20.874 18.284 20.726 18.432 L 19.607 19.549 C 19.776 19.923 19.912 20.311 20.017 20.709 L 21.507 20.709 C 21.732 20.709 21.922 20.869 21.958 21.091 C 22.038 21.569 22.081 22.056 22.084 22.539 C 22.086 22.792 21.881 22.998 21.628 23 C 21.628 23 21.628 23 21.627 23 L 21.624 23 Z  M 16.582 23 C 16.329 23 16.124 22.794 16.124 22.541 C 16.124 20.772 14.685 19.334 12.916 19.334 C 12.663 19.334 12.457 19.128 12.457 18.875 C 12.457 18.622 12.663 18.416 12.916 18.416 C 15.19 18.416 17.041 20.267 17.041 22.541 C 17.041 22.794 16.835 23 16.582 23 Z',
        customStroke: '0.5px',
    },
    automotive: {
        path: 'M 22.481 10.401 L 16.408 8.216 L 13.862 5.026 C 13.415 4.48 12.746 4.162 12.039 4.162 L 5.754 4.162 C 4.975 4.166 4.249 4.554 3.813 5.199 L 1.684 8.342 C 1.242 8.988 1.004 9.752 1 10.534 L 1 16.734 C 1 17.167 1.352 17.519 1.786 17.519 L 3.467 17.519 C 3.839 18.888 5.082 19.838 6.5 19.838 C 7.918 19.838 9.161 18.888 9.533 17.519 L 14.467 17.519 C 14.839 18.888 16.082 19.838 17.5 19.838 C 18.918 19.838 20.161 18.888 20.533 17.519 L 22.214 17.519 C 22.648 17.519 23 17.167 23 16.734 L 23 11.139 C 23 10.808 22.793 10.513 22.481 10.401 L 22.481 10.401 Z  M 6.5 18.305 C 5.632 18.305 4.929 17.601 4.929 16.734 C 4.929 15.866 5.632 15.162 6.5 15.162 C 7.368 15.162 8.071 15.866 8.071 16.734 C 8.071 17.601 7.368 18.305 6.5 18.305 Z  M 17.5 18.305 C 16.632 18.305 15.929 17.601 15.929 16.734 C 15.929 15.866 16.632 15.162 17.5 15.162 C 18.368 15.162 19.071 15.866 19.071 16.734 C 19.071 17.601 18.368 18.305 17.5 18.305 Z  M 21.429 15.948 L 20.533 15.948 C 20.161 14.579 18.918 13.629 17.5 13.629 C 16.082 13.629 14.839 14.579 14.467 15.948 L 9.533 15.948 C 9.161 14.579 7.918 13.629 6.5 13.629 C 5.082 13.629 3.839 14.579 3.467 15.948 L 2.571 15.948 L 2.571 10.534 C 2.571 10.061 2.714 9.598 2.98 9.206 L 5.109 6.064 C 5.259 5.853 5.503 5.73 5.761 5.734 L 12.047 5.734 C 12.281 5.733 12.503 5.837 12.652 6.016 L 15.324 9.371 C 15.416 9.483 15.535 9.57 15.669 9.623 L 21.429 11.689 L 21.429 15.948 Z',
    },
    blockquote: {
        path: 'M 12.916 20.251 C 12.663 20.251 12.459 20.046 12.459 19.793 C 12.459 19.54 12.663 19.334 12.916 19.334 C 17.324 19.334 21.091 16.148 21.914 11.91 C 20.971 13.116 19.532 13.832 17.959 13.832 C 15.178 13.832 12.916 11.571 12.916 8.791 C 12.916 6.01 15.178 3.749 17.959 3.749 C 20.739 3.749 23 6.01 23 8.791 L 23 10.168 C 23 15.727 18.476 20.251 12.916 20.251 Z  M 17.959 4.666 C 15.684 4.666 13.834 6.516 13.834 8.791 C 13.834 11.065 15.684 12.916 17.959 12.916 C 20.233 12.916 22.084 11.065 22.084 8.791 C 22.084 6.516 20.233 4.666 17.959 4.666 Z  M 1.459 20.251 C 1.206 20.251 1 20.046 1 19.793 C 1 19.54 1.206 19.334 1.459 19.334 C 5.865 19.334 9.632 16.148 10.455 11.91 C 9.511 13.117 8.073 13.832 6.5 13.832 C 3.72 13.832 1.459 11.571 1.459 8.791 C 1.459 6.01 3.72 3.749 6.5 3.749 C 9.28 3.749 11.541 6.01 11.541 8.791 C 11.541 8.794 11.541 10.168 11.541 10.168 C 11.541 15.727 7.018 20.251 1.459 20.251 Z  M 6.5 4.666 C 4.226 4.666 2.375 6.516 2.375 8.791 C 2.375 11.065 4.226 12.916 6.5 12.916 C 8.774 12.916 10.625 11.065 10.625 8.791 C 10.625 6.516 8.774 4.666 6.5 4.666 Z',
        customStroke: '0.5px',
    },
    bold: {
        path: 'M 14.462 23 L 3.156 23 L 3.156 1 L 13.545 1 C 16.046 1 18.319 2.453 19.369 4.723 C 20.419 6.993 20.054 9.667 18.434 11.572 C 20.557 13.27 21.38 16.122 20.488 18.69 C 19.595 21.258 17.181 22.985 14.462 23 Z  M 6.823 19.333 L 14.438 19.333 C 15.956 19.333 17.188 18.102 17.188 16.583 C 17.188 15.065 15.956 13.833 14.438 13.833 L 6.823 13.833 L 6.823 19.333 Z  M 6.823 10.167 L 13.545 10.167 C 15.064 10.167 16.295 8.935 16.295 7.417 C 16.295 5.898 15.064 4.667 13.545 4.667 L 6.823 4.667 L 6.823 10.167 Z',
    },
    browsers: {
        path: 'M 7.875 23 C 7.117 23 6.5 22.383 6.5 21.625 L 6.5 17.5 L 2.375 17.5 C 1.617 17.5 1 16.883 1 16.125 L 1 2.375 C 1 1.617 1.617 1 2.375 1 L 16.125 1 C 16.883 1 17.5 1.617 17.5 2.375 L 17.5 6.5 L 21.625 6.5 C 22.383 6.5 23 7.117 23 7.875 L 23 21.625 C 23 22.383 22.383 23 21.625 23 L 7.875 23 L 7.875 23 Z  M 7.875 7.416 C 7.622 7.416 7.416 7.622 7.416 7.875 L 7.416 21.625 C 7.416 21.878 7.622 22.084 7.875 22.084 L 21.625 22.084 C 21.878 22.084 22.084 21.878 22.084 21.625 L 22.084 7.875 C 22.084 7.622 21.878 7.416 21.625 7.416 L 7.875 7.416 L 7.875 7.416 Z  M 2.375 1.916 C 2.122 1.916 1.916 2.122 1.916 2.375 L 1.916 16.125 C 1.916 16.378 2.122 16.584 2.375 16.584 L 6.5 16.584 L 6.5 7.875 C 6.5 7.117 7.117 6.5 7.875 6.5 L 16.584 6.5 L 16.584 2.375 C 16.584 2.122 16.378 1.916 16.125 1.916 L 2.375 1.916 L 2.375 1.916 Z',
        customStroke: '0.5px',
    },
    caret_down: {
        path: 'M 20 30.289 L 1 12.238 L 3.66 9.711 L 20 25.234 L 36.34 9.711 L 39 12.238 L 20 30.289 Z',
    },
    caret_left: {
        path: 'M 6.043 12 L 16.494 1 L 17.957 2.54 L 8.97 12 L 17.957 21.46 L 16.494 23 L 6.043 12 Z',
    },
    caret_right: {
        path: 'M 30.289 20 L 12.238 39 L 9.711 36.34 L 25.234 20 L 9.711 3.66 L 12.238 1 L 30.289 20 Z',
    },
    caret_up: {
        path: 'M 20 9.711 L 39 27.762 L 36.34 30.289 L 20 14.766 L 3.66 30.289 L 1 27.762 L 20 9.711 Z',
    },
    camera: {
        path: 'M 26.786 33.571 L 3.714 33.571 C 2.216 33.571 1 32.357 1 30.858 L 1 9.142 C 1 7.643 2.216 6.429 3.714 6.429 L 26.786 6.429 C 28.284 6.429 29.5 7.643 29.5 9.142 L 29.5 14.652 L 36.856 9.401 C 37.269 9.106 37.812 9.068 38.262 9.298 C 38.713 9.529 38.998 9.994 39 10.5 L 39 29.5 C 38.998 30.006 38.713 30.471 38.262 30.702 C 37.812 30.932 37.269 30.894 36.856 30.599 L 29.5 25.348 L 29.5 30.858 C 29.5 32.357 28.284 33.571 26.786 33.571 Z  M 3.714 9.142 L 3.714 30.858 L 26.786 30.858 L 26.786 22.714 C 26.788 22.207 27.073 21.745 27.524 21.513 C 27.975 21.282 28.517 21.321 28.93 21.615 L 36.286 26.868 L 36.286 13.132 L 28.93 18.385 C 28.517 18.679 27.975 18.718 27.524 18.487 C 27.073 18.255 26.788 17.793 26.786 17.286 L 26.786 9.142 L 3.714 9.142 Z',
    },
    categories: {
        path: 'M 4.74 4.143 L 5.094 4.842 L 5.526 5.714 L 8.857 5.714 L 8.857 9.643 L 2.571 9.643 L 2.571 4.143 L 4.74 4.143 Z  M 5.227 2.571 L 1.786 2.571 C 1.352 2.571 1 2.923 1 3.357 L 1 10.429 C 1 10.863 1.352 11.214 1.786 11.214 L 9.643 11.214 C 10.077 11.214 10.429 10.863 10.429 10.429 L 10.429 4.929 C 10.429 4.495 10.077 4.143 9.643 4.143 L 6.5 4.143 L 5.934 3.004 C 5.8 2.737 5.526 2.569 5.227 2.571 Z  M 17.311 4.143 L 17.665 4.842 L 18.097 5.714 L 21.429 5.714 L 21.429 9.643 L 15.143 9.643 L 15.143 4.143 L 17.311 4.143 Z  M 17.799 2.571 L 14.357 2.571 C 13.923 2.571 13.571 2.923 13.571 3.357 L 13.571 10.429 C 13.571 10.863 13.923 11.214 14.357 11.214 L 22.214 11.214 C 22.648 11.214 23 10.863 23 10.429 L 23 4.929 C 23 4.495 22.648 4.143 22.214 4.143 L 19.071 4.143 L 18.506 3.004 C 18.371 2.737 18.097 2.569 17.799 2.571 Z  M 4.74 14.357 L 5.094 15.056 L 5.526 15.929 L 8.857 15.929 L 8.857 19.857 L 2.571 19.857 L 2.571 14.357 L 4.74 14.357 Z  M 5.227 12.786 L 1.786 12.786 C 1.352 12.786 1 13.138 1 13.571 L 1 20.643 C 1 21.077 1.352 21.429 1.786 21.429 L 9.643 21.429 C 10.077 21.429 10.429 21.077 10.429 20.643 L 10.429 15.143 C 10.429 14.709 10.077 14.357 9.643 14.357 L 6.5 14.357 L 5.934 13.218 C 5.8 12.951 5.526 12.784 5.227 12.786 Z  M 17.311 14.357 L 17.665 15.056 L 18.097 15.929 L 21.429 15.929 L 21.429 19.857 L 15.143 19.857 L 15.143 14.357 L 17.311 14.357 Z  M 17.799 12.786 L 14.357 12.786 C 13.923 12.786 13.571 13.138 13.571 13.571 L 13.571 20.643 C 13.571 21.077 13.923 21.429 14.357 21.429 L 22.214 21.429 C 22.648 21.429 23 21.077 23 20.643 L 23 15.143 C 23 14.709 22.648 14.357 22.214 14.357 L 19.071 14.357 L 18.506 13.218 C 18.371 12.951 18.097 12.784 17.799 12.786 Z',
    },
    certifications: {
        path: 'M 18.286 12.786 L 19.788 15.695 L 23 16.162 L 20.643 18.286 L 21.249 21.429 L 18.286 19.661 L 15.323 21.429 L 15.929 18.286 L 13.571 16.162 L 16.871 15.695 L 18.286 12.786 L 18.286 12.786 Z  M 4.143 12 L 8.857 12 L 8.857 13.571 L 4.143 13.571 L 4.143 12 Z  M 4.143 8.857 L 12 8.857 L 12 10.429 L 4.143 10.429 L 4.143 8.857 Z  M 4.143 5.714 L 12 5.714 L 12 7.286 L 4.143 7.286 L 4.143 5.714 Z  M 12 19.857 L 2.571 19.857 L 2.571 4.143 L 21.429 4.143 L 21.429 12 L 23 12 L 23 4.143 C 23 3.275 22.296 2.571 21.429 2.571 L 2.571 2.571 C 1.704 2.571 1 3.275 1 4.143 L 1 19.857 C 1 20.725 1.704 21.429 2.571 21.429 L 12 21.429 L 12 19.857 Z',
    },
    chat_multiple: {
        path: 'M 36.286 6.429 L 9.142 6.429 C 7.514 6.429 6.429 7.514 6.429 9.142 L 6.429 28.142 C 6.429 29.771 7.514 30.858 9.142 30.858 L 20 30.858 L 20 28.142 L 9.142 28.142 L 9.142 9.142 L 36.286 9.142 L 36.286 28.142 L 26.514 28.142 L 20 37.371 L 22.171 39 L 27.871 30.858 L 36.286 30.858 C 37.914 30.858 39 29.771 39 28.142 L 39 9.142 C 39 7.514 37.914 6.429 36.286 6.429 Z  M 3.714 22.714 L 1 22.714 L 1 5.071 C 1 2.764 2.764 1 5.071 1 L 22.714 1 L 22.714 3.714 L 5.071 3.714 C 4.258 3.714 3.714 4.258 3.714 5.071 L 3.714 22.714 Z',
        customStroke: '0.5px',
    },
    check: {
        path: 'M 9.25 19.523 L 1 11.273 L 2.296 9.977 L 9.25 16.93 L 21.704 4.477 L 23 5.773 L 9.25 19.523 L 9.25 19.523 Z',
    },
    check_circle: {
        path: 'M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z',
    },
    close: {
        path: 'M 39 4.325 L 35.675 1 L 20 16.675 L 4.325 1 L 1 4.325 L 16.675 20 L 1 35.675 L 4.325 39 L 20 23.325 L 35.675 39 L 39 35.675 L 23.325 20 L 39 4.325 Z',
        customStroke: '0.5px',
    },
    close_small: {
        path: 'M 17.5 7.463 L 16.538 6.5 L 12 11.038 L 7.463 6.5 L 6.5 7.463 L 11.038 12 L 6.5 16.538 L 7.463 17.5 L 12 12.963 L 16.538 17.5 L 17.5 16.538 L 12.963 12 L 17.5 7.463 Z',
    },
    code_block: {
        path: 'M 12.652 19.857 L 14.679 17.83 L 13.571 16.714 L 10.429 19.857 L 13.571 23 L 14.687 21.892 L 12.652 19.857 L 12.652 19.857 Z  M 19.205 19.857 L 17.178 21.884 L 18.286 23 L 21.428 19.857 L 18.286 16.714 L 17.17 17.822 L 19.205 19.857 L 19.205 19.857 Z  M 8.857 21.429 L 4.143 21.429 L 4.143 2.572 L 10.429 2.572 L 10.429 7.286 C 10.431 8.153 11.133 8.855 12 8.857 L 16.714 8.857 L 16.714 13.572 L 18.286 13.572 L 18.286 7.286 C 18.291 7.077 18.205 6.876 18.05 6.736 L 12.55 1.236 C 12.41 1.081 12.209 0.995 12 1 L 4.143 1 C 3.276 1.003 2.574 1.705 2.572 2.572 L 2.572 21.429 C 2.574 22.295 3.276 22.997 4.143 23 L 8.857 23 L 8.857 21.429 Z  M 12 2.886 L 16.4 7.286 L 12 7.286 L 12 2.886 Z',
    },
    code: {
        path: 'M 23 11.999 L 17.867 17.133 L 16.833 16.099 L 20.925 11.999 L 16.833 7.9 L 17.867 6.866 L 23 11.999 L 23 11.999 Z  M 1 11.999 L 6.133 6.866 L 7.167 7.9 L 3.075 11.999 L 7.167 16.099 L 6.133 17.133 L 1 11.999 L 1 11.999 Z  M 9.374 18.954 L 13.202 4.667 L 14.619 5.046 L 10.79 19.333 L 9.374 18.954 Z',
    },
    collection: {
        path: 'M 4.759 20.707 C 4.107 20.707 3.541 20.245 3.411 19.607 L 1.027 7.69 C 1.009 7.601 1 7.509 1 7.415 C 1.001 6.658 1.617 6.042 2.375 6.042 L 8.297 6.042 C 8.948 6.042 9.515 6.505 9.645 7.142 L 9.9 8.427 C 9.943 8.638 10.132 8.792 10.349 8.792 L 13.833 8.792 L 13.833 8.334 C 13.833 7.576 14.45 6.959 15.208 6.959 L 17.957 6.959 C 18.716 6.959 19.332 7.576 19.332 8.334 L 19.332 8.792 L 21.624 8.792 C 21.718 8.792 21.81 8.801 21.901 8.82 C 22.643 8.972 23.123 9.699 22.972 10.442 L 21.602 19.584 C 21.468 20.24 20.901 20.707 20.25 20.707 L 4.759 20.707 Z  M 2.375 6.959 C 2.252 6.959 2.138 7.007 2.05 7.093 C 1.965 7.179 1.916 7.294 1.916 7.416 C 1.916 7.447 1.919 7.478 1.926 7.509 L 4.309 19.426 C 4.352 19.637 4.541 19.791 4.758 19.791 L 20.249 19.791 C 20.467 19.791 20.656 19.637 20.699 19.424 L 22.069 10.282 C 22.124 10.012 21.968 9.769 21.716 9.718 C 21.69 9.713 21.663 9.71 21.636 9.71 L 19.332 9.709 L 19.332 16.393 C 19.332 16.635 19.235 16.872 19.063 17.042 C 18.889 17.215 18.66 17.31 18.416 17.31 C 18.17 17.31 17.94 17.213 17.767 17.04 L 16.583 15.856 L 15.398 17.041 C 15.227 17.212 14.991 17.31 14.749 17.31 C 14.243 17.31 13.832 16.899 13.832 16.393 L 13.832 9.709 L 10.349 9.709 C 9.698 9.709 9.131 9.246 9.001 8.609 L 8.746 7.323 C 8.703 7.113 8.515 6.959 8.298 6.959 L 2.375 6.959 Z  M 15.208 7.876 C 14.955 7.876 14.749 8.081 14.749 8.334 L 14.749 16.393 L 16.258 14.884 C 16.346 14.797 16.46 14.75 16.583 14.75 C 16.706 14.75 16.82 14.797 16.907 14.884 L 18.416 16.392 L 18.416 8.334 C 18.416 8.081 18.21 7.876 17.957 7.876 L 15.208 7.876 Z  M 21.624 7.876 C 21.371 7.876 21.165 7.67 21.165 7.417 L 21.165 4.668 C 21.165 4.415 20.96 4.209 20.707 4.209 L 4.209 4.209 C 3.956 4.209 3.751 4.415 3.751 4.668 C 3.751 4.921 3.545 5.126 3.293 5.126 C 3.04 5.126 2.834 4.921 2.834 4.668 C 2.834 3.909 3.451 3.293 4.209 3.293 L 20.707 3.293 C 21.465 3.293 22.082 3.909 22.082 4.668 L 22.082 7.417 C 22.082 7.67 21.877 7.876 21.624 7.876 Z',
        customStroke: '0.5px',
    },
    comment: {
        path: 'M 22.361 37.642 L 20 36.286 L 25.429 26.786 L 33.571 26.786 C 35.07 26.786 36.286 25.57 36.286 24.071 L 36.286 7.786 C 36.286 6.287 35.07 5.071 33.571 5.071 L 6.429 5.071 C 4.93 5.071 3.714 6.287 3.714 7.786 L 3.714 24.071 C 3.714 25.57 4.93 26.786 6.429 26.786 L 18.642 26.786 L 18.642 29.5 L 6.429 29.5 C 3.43 29.5 1 27.07 1 24.071 L 1 7.786 C 1 4.788 3.43 2.358 6.429 2.358 L 33.571 2.358 C 36.57 2.358 39 4.788 39 7.786 L 39 24.071 C 39 27.07 36.57 29.5 33.571 29.5 L 27.002 29.5 L 22.361 37.642 Z  M 9.142 10.5 L 30.858 10.5 L 30.858 13.214 L 9.142 13.214 L 9.142 10.5 Z  M 9.142 18.642 L 22.714 18.642 L 22.714 21.358 L 9.142 21.358 L 9.142 18.642 Z',
    },
    communications: {
        path: 'M 16.741 23 C 16.533 23 16.351 22.866 16.288 22.668 L 15.507 20.156 L 8.502 20.156 L 7.719 22.667 C 7.657 22.866 7.475 23 7.266 23 C 7.219 23 7.172 22.994 7.128 22.979 C 7.005 22.942 6.907 22.859 6.847 22.747 C 6.789 22.635 6.777 22.506 6.814 22.386 L 10.871 9.358 C 10.394 9.003 10.105 8.437 10.105 7.84 C 10.105 6.795 10.954 5.945 12 5.945 C 13.045 5.945 13.895 6.795 13.895 7.84 C 13.895 8.444 13.614 8.996 13.134 9.355 L 17.192 22.387 C 17.27 22.636 17.13 22.902 16.881 22.98 C 16.836 22.994 16.789 23 16.741 23 Z  M 15.212 19.208 L 14.327 16.366 L 9.682 16.366 L 8.797 19.208 L 15.212 19.208 Z  M 14.032 15.419 L 12.255 9.715 L 12.224 9.72 C 12.151 9.728 12.076 9.733 12 9.733 C 11.921 9.733 11.845 9.728 11.769 9.718 C 11.763 9.718 11.758 9.717 11.752 9.717 L 9.977 15.419 L 14.032 15.419 Z  M 11.628 8.706 C 11.745 8.758 11.872 8.785 12.004 8.785 C 12.069 8.785 12.132 8.779 12.195 8.765 C 12.201 8.764 12.226 8.755 12.232 8.753 C 12.281 8.741 12.329 8.728 12.375 8.709 C 12.723 8.558 12.948 8.217 12.948 7.839 C 12.948 7.317 12.524 6.891 12 6.891 C 11.478 6.891 11.053 7.317 11.053 7.839 C 11.053 8.207 11.269 8.543 11.605 8.698 C 11.613 8.701 11.62 8.704 11.628 8.706 Z  M 17.302 12.665 C 17.175 12.665 17.057 12.616 16.967 12.527 C 16.877 12.438 16.829 12.318 16.829 12.192 C 16.829 12.064 16.878 11.946 16.967 11.856 C 19.183 9.64 19.183 6.033 16.967 3.817 C 16.878 3.728 16.829 3.608 16.829 3.481 C 16.829 3.355 16.878 3.236 16.967 3.146 C 17.056 3.056 17.177 3.008 17.302 3.008 C 17.428 3.008 17.548 3.058 17.637 3.147 C 20.224 5.732 20.224 9.94 17.637 12.526 C 17.548 12.616 17.429 12.665 17.302 12.665 Z  M 19.313 14.676 C 19.186 14.676 19.067 14.627 18.978 14.538 C 18.792 14.353 18.792 14.053 18.978 13.868 C 22.302 10.544 22.302 5.134 18.978 1.809 C 18.792 1.624 18.792 1.324 18.978 1.14 C 19.066 1.05 19.186 1.001 19.313 1.001 C 19.44 1.001 19.558 1.05 19.648 1.14 C 21.435 2.926 22.418 5.305 22.418 7.839 C 22.418 10.372 21.434 12.751 19.648 14.538 C 19.558 14.627 19.44 14.676 19.313 14.676 Z  M 6.698 12.665 C 6.571 12.665 6.453 12.616 6.363 12.527 C 3.777 9.941 3.777 5.733 6.363 3.148 C 6.453 3.058 6.573 3.008 6.698 3.008 C 6.824 3.008 6.944 3.058 7.034 3.147 C 7.124 3.236 7.172 3.356 7.172 3.483 C 7.172 3.608 7.123 3.728 7.034 3.818 C 4.818 6.034 4.818 9.641 7.034 11.857 C 7.123 11.946 7.172 12.065 7.172 12.192 C 7.172 12.32 7.123 12.438 7.034 12.528 C 6.945 12.618 6.826 12.665 6.698 12.665 Z  M 4.688 14.676 C 4.561 14.676 4.443 14.627 4.352 14.538 C 0.658 10.844 0.658 4.833 4.352 1.14 C 4.443 1.049 4.562 1 4.688 1 C 4.814 1 4.933 1.049 5.023 1.138 C 5.208 1.323 5.208 1.624 5.023 1.808 C 1.698 5.133 1.698 10.543 5.023 13.868 C 5.208 14.052 5.208 14.352 5.023 14.538 C 4.933 14.627 4.815 14.676 4.688 14.676 Z',
        customStroke: '0.5px',
    },
    community: {
        path: 'M 16.398 17.973 C 14.885 17.973 13.504 17.402 12.451 16.47 C 13.536 15.293 14.204 13.726 14.204 12 C 14.204 10.274 13.536 8.706 12.451 7.53 C 13.504 6.598 14.885 6.027 16.398 6.027 C 19.691 6.027 22.371 8.706 22.371 12 C 22.371 15.293 19.691 17.973 16.398 17.973 Z  M 1.629 12 C 1.629 8.706 4.309 6.027 7.602 6.027 C 9.116 6.027 10.496 6.598 11.55 7.53 C 10.465 8.706 9.796 10.274 9.796 11.999 C 9.796 13.726 10.465 15.293 11.55 16.47 C 10.496 17.402 9.116 17.973 7.603 17.973 C 4.308 17.973 1.629 15.293 1.629 12 Z  M 12 16.027 C 11.025 14.964 10.426 13.552 10.426 12 C 10.426 10.447 11.025 9.036 12 7.973 C 12.975 9.036 13.575 10.447 13.575 12 C 13.575 13.552 12.975 14.964 12.001 16.027 M 16.397 5.398 C 14.706 5.398 13.168 6.04 11.999 7.086 C 10.832 6.04 9.294 5.398 7.602 5.398 C 3.956 5.398 1 8.354 1 12 C 1 15.645 3.956 18.602 7.602 18.602 C 9.294 18.602 10.831 17.96 12 16.914 C 13.169 17.96 14.708 18.602 16.398 18.602 C 20.044 18.602 23 15.646 23 12 C 23 8.355 20.044 5.398 16.398 5.398',
        customStroke: '0.5px',
    },
    conflicts: {
        path: 'M 12 18.021 C 11.688 18.021 11.434 18.274 11.434 18.587 C 11.434 18.899 11.688 19.152 12 19.152 C 12.312 19.152 12.566 18.899 12.566 18.587 C 12.566 18.274 12.312 18.021 12 18.021 Z  M 11.623 13.874 L 12.378 13.874 L 12.378 17.267 L 11.623 17.267 L 11.623 13.874 Z  M 16.901 20.66 L 7.099 20.66 C 6.967 20.661 6.845 20.592 6.776 20.48 C 6.708 20.367 6.703 20.227 6.763 20.11 L 11.664 10.684 C 11.729 10.559 11.859 10.479 12 10.479 C 12.141 10.479 12.271 10.559 12.336 10.684 L 17.237 20.11 C 17.297 20.227 17.293 20.367 17.224 20.48 C 17.155 20.592 17.033 20.661 16.901 20.66 Z  M 7.721 19.906 L 16.279 19.906 L 12 11.676 L 7.721 19.906 Z  M 17.91 18.953 L 17.516 18.953 L 17.516 17.389 L 17.91 17.389 C 19.869 17.467 21.52 15.955 21.598 14.012 C 21.676 12.07 20.152 10.432 18.194 10.354 L 17.516 10.354 L 17.437 9.713 C 17.076 6.991 14.736 4.956 11.968 4.956 C 9.201 4.956 6.861 6.991 6.5 9.713 L 6.484 10.354 L 5.806 10.354 C 3.848 10.432 2.324 12.07 2.402 14.012 C 2.48 15.955 4.131 17.467 6.09 17.389 L 6.484 17.389 L 6.484 18.953 L 6.09 18.953 C 3.473 18.936 1.289 16.966 1.026 14.383 C 0.763 11.8 2.505 9.436 5.066 8.9 C 5.767 5.657 8.656 3.34 12 3.34 C 15.344 3.34 18.233 5.657 18.934 8.9 C 21.495 9.436 23.237 11.8 22.974 14.383 C 22.711 16.966 20.527 18.936 17.91 18.953 L 17.91 18.953 Z',
    },
    consumer: {
        path: 'M 7.064 21.096 C 7.064 20.259 7.743 19.58 8.58 19.58 C 9.416 19.58 10.096 20.259 10.096 21.096 C 10.096 21.932 9.416 22.612 8.58 22.612 C 7.743 22.612 7.064 21.932 7.064 21.096 Z  M 17.676 21.096 C 17.676 20.259 18.355 19.58 19.191 19.58 C 20.028 19.58 20.707 20.259 20.707 21.096 C 20.707 21.932 20.028 22.612 19.191 22.612 C 18.355 22.612 17.676 21.932 17.676 21.096 Z  M 22.223 5.178 L 5.411 5.178 L 4.79 1.995 C 4.717 1.636 4.398 1.381 4.032 1.388 L 1 1.388 L 1 2.904 L 3.41 2.904 L 6.306 17.458 C 6.379 17.816 6.698 18.071 7.064 18.064 L 20.707 18.064 L 20.707 16.548 L 7.685 16.548 L 7.064 13.516 L 20.707 13.516 C 21.069 13.525 21.386 13.277 21.465 12.925 L 22.981 6.103 C 23.033 5.875 22.976 5.636 22.828 5.456 C 22.68 5.275 22.457 5.173 22.223 5.178 Z  M 20.101 12 L 6.776 12 L 5.715 6.694 L 21.276 6.694 L 20.101 12 Z',
    },
    contribute: {
        path: 'M 8.388 16.318 L 9.134 15.571 L 11.031 17.467 L 15.041 13.456 L 15.789 14.204 L 11.031 18.963 L 8.388 16.318 Z  M 12 10.42 C 9.161 10.42 6.859 12.722 6.859 15.561 C 6.859 18.4 9.161 20.701 12 20.701 C 14.839 20.701 17.141 18.4 17.141 15.561 C 17.141 14.197 16.599 12.89 15.635 11.926 C 14.671 10.962 13.363 10.42 12 10.42 Z  M 12 19.967 C 9.567 19.967 7.594 17.994 7.594 15.561 C 7.594 13.127 9.567 11.155 12 11.155 C 14.433 11.155 16.406 13.127 16.406 15.561 C 16.406 16.729 15.942 17.85 15.116 18.676 C 14.289 19.503 13.169 19.967 12 19.967 Z  M 17.91 18.912 L 17.516 18.912 L 17.516 17.348 L 17.91 17.348 C 19.869 17.426 21.52 15.914 21.598 13.971 C 21.676 12.029 20.152 10.391 18.194 10.313 L 17.516 10.313 L 17.437 9.672 C 17.076 6.95 14.736 4.915 11.968 4.915 C 9.201 4.915 6.861 6.95 6.5 9.672 L 6.484 10.313 L 5.806 10.313 C 3.848 10.391 2.324 12.029 2.402 13.971 C 2.48 15.914 4.131 17.426 6.09 17.348 L 6.484 17.348 L 6.484 18.912 L 6.09 18.912 C 3.473 18.895 1.289 16.925 1.026 14.342 C 0.763 11.759 2.505 9.395 5.066 8.859 C 5.767 5.616 8.656 3.299 12 3.299 C 15.344 3.299 18.233 5.616 18.934 8.859 C 21.495 9.395 23.237 11.759 22.974 14.342 C 22.711 16.925 20.527 18.895 17.91 18.912 L 17.91 18.912 Z',
    },
    contribution: {
        path: 'M 14.571 37.642 C 14.024 37.641 13.531 37.309 13.322 36.801 L 6.876 21.358 L 1 21.358 L 1 18.642 L 7.786 18.642 C 8.334 18.646 8.826 18.977 9.034 19.484 L 14.571 32.594 L 25.51 3.239 C 25.709 2.707 26.218 2.356 26.786 2.358 C 27.36 2.368 27.864 2.736 28.047 3.28 L 33.191 18.642 L 39 18.642 L 39 21.358 L 32.214 21.358 C 31.631 21.359 31.112 20.986 30.925 20.434 L 26.786 7.786 L 15.848 36.761 C 15.649 37.293 15.139 37.644 14.571 37.642 Z',
    },
    cross: {
        path: 'M 12.014 22.535 C 11.953 22.535 11.895 22.522 11.837 22.499 C 11.832 22.497 4.366 19.232 4.366 19.232 L 1.693 20.566 C 1.628 20.597 1.555 20.616 1.479 20.616 C 1.297 20.616 1.133 20.515 1.05 20.351 C 0.994 20.236 0.984 20.106 1.025 19.985 C 1.065 19.863 1.151 19.766 1.265 19.708 L 3.873 18.407 L 3.873 9.605 C 3.873 9.55 3.884 9.495 3.906 9.438 C 3.909 9.431 3.921 9.404 3.924 9.396 C 3.945 9.357 3.969 9.322 3.997 9.291 C 4.001 9.285 4.022 9.262 4.027 9.258 C 4.068 9.218 4.112 9.19 4.159 9.168 C 4.162 9.168 11.536 5.941 11.536 5.941 L 11.536 1.945 C 11.536 1.68 11.75 1.465 12.014 1.465 C 12.28 1.465 12.494 1.68 12.494 1.945 L 12.494 5.941 L 19.865 9.165 C 19.917 9.189 19.961 9.218 20.003 9.258 C 20.01 9.264 20.027 9.282 20.033 9.289 C 20.062 9.322 20.085 9.357 20.104 9.392 C 20.11 9.407 20.117 9.421 20.123 9.436 C 20.145 9.494 20.156 9.55 20.156 9.605 L 20.156 18.407 L 22.735 19.694 C 22.849 19.75 22.935 19.848 22.975 19.97 C 23.016 20.093 23.006 20.222 22.95 20.336 C 22.868 20.5 22.703 20.602 22.521 20.602 C 22.447 20.602 22.372 20.585 22.306 20.55 L 19.662 19.232 L 12.206 22.494 C 12.198 22.497 12.188 22.502 12.179 22.503 C 12.122 22.524 12.069 22.535 12.014 22.535 Z  M 12.494 21.322 L 19.197 18.39 L 19.197 10.338 L 12.494 13.271 L 12.494 21.322 Z  M 11.536 21.322 L 11.536 13.27 L 4.833 10.337 L 4.833 18.389 L 11.536 21.322 Z  M 12.014 12.434 L 18.482 9.605 L 12.014 6.777 L 5.549 9.605 L 12.014 12.434 Z',
        customStroke: '0.5px',
    },
    delete: {
        path: 'M 14.571 14.571 L 17.286 14.571 L 17.286 30.858 L 14.571 30.858 L 14.571 14.571 Z  M 22.714 14.571 L 25.429 14.571 L 25.429 30.858 L 22.714 30.858 L 22.714 14.571 Z  M 3.714 6.429 L 3.714 9.142 L 6.429 9.142 L 6.429 36.286 C 6.429 37.784 7.643 39 9.142 39 L 30.858 39 C 32.357 39 33.571 37.784 33.571 36.286 L 33.571 9.142 L 36.286 9.142 L 36.286 6.429 L 3.714 6.429 Z  M 9.142 36.286 L 9.142 9.142 L 30.858 9.142 L 30.858 36.286 L 9.142 36.286 Z  M 14.571 1 L 25.429 1 L 25.429 3.714 L 14.571 3.714 L 14.571 1 Z',
    },
    document: {
        path: 'M 19.621 6.736 L 14.121 1.236 C 13.964 1.079 13.807 1 13.571 1 L 5.714 1 C 4.85 1 4.143 1.707 4.143 2.571 L 4.143 21.429 C 4.143 22.293 4.85 23 5.714 23 L 18.286 23 C 19.15 23 19.857 22.293 19.857 21.429 L 19.857 7.286 C 19.857 7.05 19.779 6.893 19.621 6.736 Z  M 13.571 2.886 L 17.971 7.286 L 13.571 7.286 L 13.571 2.886 Z  M 18.286 21.429 L 5.714 21.429 L 5.714 2.571 L 12 2.571 L 12 7.286 C 12 8.15 12.707 8.857 13.571 8.857 L 18.286 8.857 L 18.286 21.429 Z  M 7.286 16.714 L 16.714 16.714 L 16.714 18.286 L 7.286 18.286 L 7.286 16.714 Z  M 7.286 12 L 16.714 12 L 16.714 13.571 L 7.286 13.571 L 7.286 12 Z',
    },
    download: {
        path: 'M 30.209 28.148 L 29.527 28.148 L 29.527 25.426 L 30.209 25.426 C 33.591 25.562 36.443 22.928 36.578 19.547 C 36.713 16.163 34.081 13.311 30.699 13.176 L 29.527 13.176 L 29.392 12.06 C 28.768 7.319 24.727 3.776 19.946 3.776 C 15.164 3.776 11.123 7.319 10.499 12.06 L 10.473 13.176 L 9.301 13.176 C 5.919 13.311 3.287 16.163 3.422 19.547 C 3.557 22.928 6.409 25.562 9.791 25.426 L 10.473 25.426 L 10.473 28.148 L 9.791 28.148 C 5.272 28.12 1.499 24.688 1.045 20.19 C 0.59 15.694 3.598 11.577 8.022 10.644 C 9.233 4.997 14.225 0.962 20 0.962 C 25.775 0.962 30.767 4.997 31.978 10.644 C 36.402 11.577 39.41 15.694 38.955 20.19 C 38.501 24.688 34.728 28.12 30.209 28.148 Z  M 21.36 33.825 L 21.36 17.26 L 18.64 17.26 L 18.64 33.825 L 15.114 30.313 L 13.195 32.233 L 20 39.038 L 26.805 32.233 L 24.886 30.313 L 21.36 33.825 L 21.36 33.825 Z',
    },
    edit: {
        path: 'M 1 34.929 L 39 34.929 L 39 37.642 L 1 37.642 L 1 34.929 Z  M 32.758 11.858 C 33.842 10.771 33.842 9.142 32.758 8.058 C 32.758 8.058 32.758 8.058 32.758 8.058 L 27.871 3.171 C 26.786 2.086 25.158 2.086 24.071 3.171 C 24.071 3.171 24.071 3.171 24.071 3.171 L 3.714 23.529 L 3.714 32.214 L 12.4 32.214 L 32.758 11.858 Z  M 25.971 5.071 L 30.858 9.958 L 26.786 14.029 L 21.9 9.142 L 25.971 5.071 Z  M 6.429 29.5 L 6.429 24.614 L 20 11.042 L 24.886 15.929 L 11.314 29.5 L 6.429 29.5 Z',
    },
    electronics: {
        path: 'M 8.071 8.071 L 8.071 15.929 L 15.929 15.929 L 15.929 8.071 L 8.071 8.071 Z  M 14.357 14.357 L 9.643 14.357 L 9.643 9.643 L 14.357 9.643 L 14.357 14.357 Z  M 23 9.643 L 23 8.071 L 19.857 8.071 L 19.857 5.714 C 19.857 4.846 19.154 4.143 18.286 4.143 L 15.929 4.143 L 15.929 1 L 14.357 1 L 14.357 4.143 L 9.643 4.143 L 9.643 1 L 8.071 1 L 8.071 4.143 L 5.714 4.143 C 4.846 4.143 4.143 4.846 4.143 5.714 L 4.143 8.071 L 1 8.071 L 1 9.643 L 4.143 9.643 L 4.143 14.357 L 1 14.357 L 1 15.929 L 4.143 15.929 L 4.143 18.286 C 4.143 19.154 4.846 19.857 5.714 19.857 L 8.071 19.857 L 8.071 23 L 9.643 23 L 9.643 19.857 L 14.357 19.857 L 14.357 23 L 15.929 23 L 15.929 19.857 L 18.286 19.857 C 19.154 19.857 19.857 19.154 19.857 18.286 L 19.857 15.929 L 23 15.929 L 23 14.357 L 19.857 14.357 L 19.857 9.643 L 23 9.643 Z  M 18.286 18.286 L 5.714 18.286 L 5.714 5.714 L 18.286 5.714 L 18.286 18.286 Z',
    },
    email: {
        path: 'M 21.429 4.143 L 2.571 4.143 C 1.704 4.143 1 4.846 1 5.714 L 1 18.286 C 1 19.154 1.704 19.857 2.571 19.857 L 21.429 19.857 C 22.296 19.857 23 19.154 23 18.286 L 23 5.714 C 23 4.846 22.296 4.143 21.429 4.143 Z  M 19.7 5.714 L 12 11.041 L 4.3 5.714 L 19.7 5.714 Z  M 2.571 18.286 L 2.571 6.429 L 11.552 12.644 C 11.821 12.831 12.179 12.831 12.448 12.644 L 21.429 6.429 L 21.429 18.286 L 2.571 18.286 Z',
    },
    embed: {
        path: 'M 21.428 19.071 L 20.317 17.96 L 18.286 19.992 L 18.286 13.572 L 16.714 13.572 L 16.714 19.992 L 14.682 17.96 L 13.571 19.071 L 17.5 23 L 21.428 19.071 L 21.428 19.071 Z  M 12 21.429 L 4.143 21.429 L 4.143 2.572 L 10.429 2.572 L 10.429 7.286 C 10.431 8.153 11.133 8.855 12 8.857 L 16.714 8.857 L 16.714 11.214 L 18.286 11.214 L 18.286 7.286 C 18.291 7.077 18.205 6.876 18.05 6.736 L 12.55 1.236 C 12.41 1.081 12.209 0.995 12 1 L 4.143 1 C 3.276 1.003 2.574 1.705 2.572 2.572 L 2.572 21.429 C 2.574 22.295 3.276 22.997 4.143 23 L 12 23 L 12 21.429 Z  M 12 2.886 L 16.4 7.286 L 12 7.286 L 12 2.886 Z',
    },
    error: {
        path: 'M 12 1 C 5.871 1 1 5.871 1 12 C 1 18.129 5.871 23 12 23 C 18.129 23 23 18.129 23 12 C 23 5.871 18.129 1 12 1 Z  M 12 21.429 C 6.814 21.429 2.571 17.186 2.571 12 C 2.571 6.814 6.814 2.571 12 2.571 C 17.186 2.571 21.429 6.814 21.429 12 C 21.429 17.186 17.186 21.429 12 21.429 Z  M 16.243 17.5 L 12 13.257 L 7.757 17.5 L 6.5 16.243 L 10.743 12 L 6.5 7.757 L 7.757 6.5 L 12 10.743 L 16.243 6.5 L 17.5 7.757 L 13.257 12 L 17.5 16.243 L 16.243 17.5 Z',
    },
    expand: {
        path: 'M 26.786 1 L 26.786 3.714 L 34.373 3.714 L 21.358 16.716 L 23.271 18.642 L 36.286 5.627 L 36.286 13.214 L 39 13.214 L 39 1 L 26.786 1 L 26.786 1 Z  M 18.642 23.284 L 16.729 21.358 L 3.714 34.373 L 3.714 26.786 L 1 26.786 L 1 39 L 13.214 39 L 13.214 36.286 L 5.627 36.286 L 18.642 23.284 L 18.642 23.284 Z',
    },
    explode: {
        path: 'M 1.99 7.795 L 11.092 11.687 C 11.344 11.794 11.507 12.041 11.508 12.314 L 11.531 22.313 C 11.532 22.805 11.029 23.138 10.577 22.944 L 1.475 19.053 C 1.223 18.946 1.06 18.698 1.059 18.425 L 1.036 8.427 C 1.035 7.935 1.538 7.603 1.99 7.796 L 1.99 7.795 Z  M 1.842 8.897 L 1.82 18.15 L 10.569 21.788 L 10.591 12.535 L 1.842 8.897 Z  M 21.913 8.897 L 13.515 12.535 L 13.537 21.788 L 21.937 18.15 L 21.914 8.897 M 22.254 7.691 C 22.615 7.69 22.94 7.981 22.941 8.375 L 22.964 18.374 C 22.964 18.647 22.802 18.894 22.551 19.003 L 13.467 22.937 C 13.378 22.976 13.286 22.994 13.197 22.994 C 12.836 22.995 12.512 22.705 12.511 22.31 L 12.487 12.312 C 12.487 12.038 12.649 11.792 12.9 11.682 L 21.983 7.747 C 22.073 7.709 22.164 7.69 22.253 7.69 L 22.254 7.691 Z  M 11.933 2.06 L 3.22 5.949 L 11.952 9.798 L 20.665 5.909 L 11.933 2.059 M 11.931 1 C 12.026 1 12.12 1.019 12.209 1.059 L 21.786 5.28 C 22.329 5.519 22.331 6.29 21.788 6.531 L 12.232 10.799 C 12.144 10.838 12.049 10.857 11.955 10.857 C 11.859 10.857 11.765 10.839 11.676 10.8 L 2.1 6.578 C 1.556 6.337 1.555 5.569 2.097 5.326 L 11.654 1.06 C 11.742 1.02 11.837 1.001 11.931 1 Z',
        customStroke: '0.5px',
    },
    fablab: {
        path: 'M 15.424 7.126 C 15.424 5.779 13.787 4.687 11.766 4.687 C 11.316 4.687 10.884 4.742 10.485 4.841 L 9.292 4.163 L 12.001 2.598 L 19.793 7.099 C 20.385 6.756 20.915 6.45 21.347 6.201 C 19.405 3.08 15.947 1 12.001 1 C 8.061 1 4.606 3.074 2.664 6.189 C 3.11 6.447 3.641 6.753 4.224 7.089 L 6.635 5.696 L 8.196 6.6 C 8.14 6.769 8.109 6.945 8.109 7.126 C 8.109 8.472 9.747 9.564 11.766 9.564 C 13.787 9.564 15.424 8.472 15.424 7.126 Z  M 21.712 6.836 L 20.154 7.735 L 20.154 10.553 L 18.454 11.516 C 18.33 11.372 18.185 11.249 18.02 11.152 C 16.856 10.476 15.089 11.343 14.074 13.09 C 13.061 14.838 13.18 16.802 14.346 17.48 C 15.51 18.155 17.277 17.288 18.29 15.541 C 18.51 15.163 18.677 14.775 18.79 14.392 L 20.154 13.603 L 20.154 16.727 L 12.385 21.213 L 12.385 22.998 C 18.282 22.797 23 17.953 23 12.005 C 23 10.136 22.533 8.376 21.712 6.836 Z  M 9.545 17.608 C 9.621 17.577 9.693 17.543 9.765 17.5 C 10.93 16.824 11.051 14.859 10.037 13.111 C 9.022 11.365 7.256 10.496 6.091 11.173 C 4.927 11.849 4.806 13.814 5.821 15.562 C 5.97 15.819 6.135 16.056 6.313 16.273 L 6.313 18.15 L 3.847 16.727 L 3.847 7.718 L 2.296 6.822 C 1.47 8.367 1 10.13 1 12.005 C 1 17.965 5.74 22.816 11.654 23 L 11.654 21.235 L 9.545 20.017 L 9.545 17.608 Z',
        customStroke: '0',
    },
    facebook: {
        path: 'M 23 12.067 C 23 5.956 18.075 1 12 1 C 5.925 1 1 5.956 1 12.067 C 1 17.59 5.023 22.169 10.281 23 L 10.281 15.267 L 7.488 15.267 L 7.488 12.067 L 10.281 12.067 L 10.281 9.629 C 10.281 6.855 11.924 5.322 14.436 5.322 C 15.64 5.322 16.898 5.538 16.898 5.538 L 16.898 8.262 L 15.512 8.262 C 14.146 8.262 13.719 9.115 13.719 9.99 L 13.719 12.067 L 16.769 12.067 L 16.282 15.267 L 13.719 15.267 L 13.719 23 C 18.977 22.17 23 17.591 23 12.067 Z',
        customStroke: '0',
    },
    files: {
        path: 'M 7.875 11.656 L 16.126 11.656 L 16.126 13.031 L 7.875 13.031 L 7.875 11.656 Z  M 7.875 14.406 L 13.375 14.406 L 13.375 15.781 L 7.875 15.781 L 7.875 14.406 Z  M 12 5.468 L 12 5.468 C 14.639 5.472 16.905 7.343 17.408 9.933 L 17.586 10.858 L 18.513 11.026 C 20.439 11.373 21.783 13.132 21.61 15.082 C 21.438 17.032 19.807 18.528 17.85 18.532 L 6.153 18.532 C 4.195 18.529 2.563 17.033 2.39 15.083 C 2.217 13.133 3.56 11.373 5.487 11.026 L 6.414 10.858 L 6.592 9.933 C 7.096 7.343 9.362 5.472 12 5.468 Z  M 12 4.093 C 8.703 4.097 5.87 6.436 5.242 9.673 C 2.615 10.147 0.784 12.546 1.02 15.205 C 1.256 17.863 3.481 19.903 6.15 19.907 L 17.85 19.907 C 20.519 19.903 22.744 17.863 22.98 15.205 C 23.216 12.546 21.385 10.147 18.758 9.673 C 18.13 6.433 15.293 4.093 11.992 4.093 L 12 4.093 Z',
    },
    filter: {
        path: 'M 13.833 23 L 10.167 23 C 9.154 23 8.333 22.179 8.333 21.167 L 8.333 14.209 L 1.541 7.417 C 1.197 7.074 1.002 6.61 1 6.124 L 1 2.833 C 1 1.821 1.821 1 2.833 1 L 21.167 1 C 22.179 1 23 1.821 23 2.833 L 23 6.124 C 22.998 6.61 22.803 7.074 22.459 7.417 L 15.667 14.209 L 15.667 21.167 C 15.667 22.179 14.846 23 13.833 23 Z  M 2.833 2.833 L 2.833 6.124 L 10.167 13.458 L 10.167 21.167 L 13.833 21.167 L 13.833 13.458 L 21.167 6.124 L 21.167 2.833 L 2.833 2.833 Z',
    },
    flag: {
        path: 'M 4.143 23 L 2.571 23 L 2.571 1 L 21.429 1 L 16.871 8.071 L 21.429 15.143 L 4.143 15.143 L 4.143 23 Z  M 4.143 13.571 L 18.545 13.571 L 14.986 8.071 L 18.545 2.571 L 4.143 2.571 L 4.143 13.571 Z',
    },
    folder_add: {
        path: 'M 19.857 14.357 L 18.286 14.357 L 18.286 17.5 L 15.143 17.5 L 15.143 19.071 L 18.286 19.071 L 18.286 22.214 L 19.857 22.214 L 19.857 19.071 L 23 19.071 L 23 17.5 L 19.857 17.5 L 19.857 14.357 Z  M 21.429 4.929 L 12 4.929 L 9.329 2.257 C 9.014 1.943 8.621 1.786 8.229 1.786 L 2.571 1.786 C 1.707 1.786 1 2.493 1 3.357 L 1 19.071 C 1 19.936 1.707 20.643 2.571 20.643 L 13.571 20.643 L 13.571 19.071 L 2.571 19.071 L 2.571 3.357 L 8.229 3.357 L 10.9 6.029 L 11.371 6.5 L 21.429 6.5 L 21.429 12.786 L 23 12.786 L 23 6.5 C 23 5.636 22.293 4.929 21.429 4.929 Z',
    },
    folder: {
        path: 'M 8.205 4.143 L 10.892 6.822 L 11.348 7.286 L 21.429 7.286 L 21.429 19.857 L 2.571 19.857 L 2.571 4.143 L 8.205 4.143 Z  M 8.205 2.571 L 2.571 2.571 C 1.704 2.571 1 3.275 1 4.143 L 1 19.857 C 1 20.725 1.704 21.429 2.571 21.429 L 21.429 21.429 C 22.296 21.429 23 20.725 23 19.857 L 23 7.286 C 23 6.418 22.296 5.714 21.429 5.714 L 12 5.714 L 9.321 3.035 C 9.025 2.738 8.624 2.571 8.205 2.571 Z',
    },
    github: {
        path: 'M 12.003 1.002 Q 16.568 1.002 19.785 4.316 Q 22.999 7.63 23 12.294 Q 23 15.977 20.888 18.922 Q 18.777 21.868 15.488 22.997 L 15.292 22.997 Q 14.703 22.997 14.703 22.409 Q 14.703 22.359 14.727 21.304 Q 14.751 20.249 14.751 19.365 Q 14.751 17.94 13.966 17.253 Q 16.224 16.958 17.623 15.804 Q 19.021 14.65 19.021 11.705 Q 19.021 9.938 17.893 8.661 Q 18.383 7.236 17.794 5.665 L 17.549 5.665 Q 16.419 5.665 14.749 6.844 Q 13.326 6.451 12 6.451 Q 10.675 6.451 9.251 6.844 Q 7.581 5.665 6.451 5.665 L 6.206 5.665 Q 5.617 7.236 6.107 8.661 Q 4.979 9.938 4.979 11.705 Q 4.979 14.65 6.352 15.804 Q 7.727 16.958 9.986 17.253 Q 9.445 17.794 9.299 18.775 Q 8.709 19.07 8.021 19.07 Q 6.794 19.07 6.107 17.842 Q 5.468 16.762 4.388 16.664 Q 3.357 16.664 4.339 17.352 Q 5.076 17.744 5.566 19.021 Q 5.615 19.217 5.763 19.488 Q 5.909 19.757 6.572 20.198 Q 7.236 20.64 8.169 20.64 Q 8.856 20.64 9.248 20.542 L 9.248 22.458 Q 9.248 22.998 8.708 22.998 L 8.511 22.998 Q 5.172 21.869 3.087 18.949 Q 1 16.028 1 12.295 Q 1 7.631 4.215 4.317 Q 7.432 1.003 11.997 1.003 L 12.003 1.002 Z',
        customStroke: '0',
    },
    google: {
        path: 'M 12.222 10.424 L 22.606 10.424 Q 22.778 11.384 22.778 12.258 Q 22.778 15.366 21.474 17.808 Q 20.171 20.25 17.758 21.625 Q 15.344 23 12.222 23 Q 9.973 23 7.939 22.134 Q 5.906 21.267 4.43 19.791 Q 2.955 18.317 2.089 16.282 Q 1.222 14.249 1.222 12 Q 1.222 9.751 2.089 7.718 Q 2.955 5.683 4.43 4.209 Q 5.906 2.733 7.939 1.866 Q 9.973 1 12.222 1 Q 16.519 1 19.598 3.879 L 16.604 6.758 Q 14.843 5.054 12.222 5.054 Q 10.375 5.054 8.807 5.984 Q 7.238 6.915 6.321 8.512 Q 5.405 10.109 5.405 12 Q 5.405 13.891 6.321 15.488 Q 7.238 17.085 8.807 18.016 Q 10.375 18.946 12.222 18.946 Q 13.468 18.946 14.513 18.603 Q 15.559 18.259 16.232 17.744 Q 16.906 17.228 17.406 16.568 Q 17.908 15.91 18.144 15.323 Q 18.381 14.736 18.467 14.206 L 12.222 14.206 L 12.222 10.424 Z',
        customStroke: '0',
    },
    grid: {
        path: 'M 36.236 1 L 24.75 1 L 15.25 1 L 3.764 1 C 2.237 1 1 2.237 1 3.764 L 1 15.25 L 1 24.75 L 1 36.236 C 1 37.763 2.237 39 3.764 39 L 15.25 39 L 24.75 39 L 36.236 39 C 37.763 39 39 37.763 39 36.236 L 39 24.75 L 39 15.25 L 39 3.764 C 39 2.237 37.763 1 36.236 1 Z  M 36.626 3.374 L 36.626 12.874 L 27.126 12.874 L 27.126 3.374 L 36.626 3.374 Z  M 24.75 3.374 L 24.75 12.874 L 15.25 12.874 L 15.25 3.374 L 24.75 3.374 Z  M 24.75 15.25 L 24.75 24.75 L 15.25 24.75 L 15.25 15.25 L 24.75 15.25 Z  M 3.374 3.374 L 12.874 3.374 L 12.874 12.874 L 3.374 12.874 L 3.374 3.374 Z  M 3.374 15.25 L 12.874 15.25 L 12.874 24.75 L 3.374 24.75 L 3.374 15.25 Z  M 3.374 36.626 L 3.374 27.126 L 12.874 27.126 L 12.874 36.626 L 3.374 36.626 Z  M 15.25 36.626 L 15.25 27.126 L 24.75 27.126 L 24.75 36.626 L 15.25 36.626 Z  M 36.626 36.626 L 27.126 36.626 L 27.126 27.126 L 36.626 27.126 L 36.626 36.626 Z  M 36.626 24.75 L 27.126 24.75 L 27.126 15.25 L 36.626 15.25 L 36.626 24.75 Z',
        customStroke: '0.5px',
    },
    grid_list: {
        path: 'M 2.856 11.129 C 2.136 11.129 1.55 10.543 1.55 9.823 L 1.55 2.856 C 1.55 2.136 2.136 1.55 2.856 1.55 L 9.823 1.55 C 10.543 1.55 11.129 2.136 11.129 2.856 L 11.129 9.823 C 11.129 10.543 10.543 11.129 9.823 11.129 L 2.856 11.129 Z  M 2.856 2.421 C 2.616 2.421 2.421 2.616 2.421 2.856 L 2.421 9.823 C 2.421 10.063 2.616 10.258 2.856 10.258 L 9.823 10.258 C 10.063 10.258 10.258 10.063 10.258 9.823 L 10.258 2.856 C 10.258 2.616 10.063 2.421 9.823 2.421 L 2.856 2.421 Z  M 14.177 11.129 C 13.457 11.129 12.871 10.543 12.871 9.823 L 12.871 2.856 C 12.871 2.136 13.457 1.55 14.177 1.55 L 21.144 1.55 C 21.864 1.55 22.45 2.136 22.45 2.856 L 22.45 9.823 C 22.45 10.543 21.864 11.129 21.144 11.129 L 14.177 11.129 Z  M 14.177 2.421 C 13.937 2.421 13.742 2.616 13.742 2.856 L 13.742 9.823 C 13.742 10.063 13.937 10.258 14.177 10.258 L 21.144 10.258 C 21.384 10.258 21.579 10.063 21.579 9.823 L 21.579 2.856 C 21.579 2.616 21.384 2.421 21.144 2.421 L 14.177 2.421 Z  M 2.856 22.45 C 2.136 22.45 1.55 21.864 1.55 21.144 L 1.55 14.177 C 1.55 13.457 2.136 12.871 2.856 12.871 L 9.823 12.871 C 10.543 12.871 11.129 13.457 11.129 14.177 L 11.129 21.144 C 11.129 21.864 10.543 22.45 9.823 22.45 L 2.856 22.45 Z  M 2.856 13.742 C 2.616 13.742 2.421 13.937 2.421 14.177 L 2.421 21.144 C 2.421 21.384 2.616 21.579 2.856 21.579 L 9.823 21.579 C 10.063 21.579 10.258 21.384 10.258 21.144 L 10.258 14.177 C 10.258 13.937 10.063 13.742 9.823 13.742 L 2.856 13.742 Z  M 14.177 22.45 C 13.457 22.45 12.871 21.864 12.871 21.144 L 12.871 14.177 C 12.871 13.457 13.457 12.871 14.177 12.871 L 21.144 12.871 C 21.864 12.871 22.45 13.457 22.45 14.177 L 22.45 21.144 C 22.45 21.864 21.864 22.45 21.144 22.45 L 14.177 22.45 Z  M 14.177 13.742 C 13.937 13.742 13.742 13.937 13.742 14.177 L 13.742 21.144 C 13.742 21.384 13.937 21.579 14.177 21.579 L 21.144 21.579 C 21.384 21.579 21.579 21.384 21.579 21.144 L 21.579 14.177 C 21.579 13.937 21.384 13.742 21.144 13.742 L 14.177 13.742 Z',
        customStroke: '0.5px',
    },
    header_four: {
        path: 'M 2.375 23 C 1.617 23 1 22.383 1 21.625 L 1 6.041 C 1 5.284 1.617 4.666 2.375 4.666 L 3.75 4.666 L 3.75 2.375 C 3.75 1.617 4.367 1 5.125 1 L 21.625 1 C 22.383 1 23 1.617 23 2.375 L 23 18.875 C 23 19.633 22.383 20.25 21.625 20.25 L 19.334 20.25 L 19.334 21.625 C 19.334 22.383 18.716 23 17.959 23 L 2.375 23 Z  M 2.375 5.584 C 2.122 5.584 1.916 5.788 1.916 6.041 L 1.916 21.625 C 1.916 21.878 2.122 22.084 2.375 22.084 L 17.959 22.084 C 18.212 22.084 18.416 21.878 18.416 21.625 L 18.416 20.25 L 5.125 20.25 C 4.367 20.25 3.75 19.633 3.75 18.875 L 3.75 5.584 L 2.375 5.584 Z  M 5.125 1.916 C 4.872 1.916 4.666 2.122 4.666 2.375 L 4.666 18.875 C 4.666 19.128 4.872 19.334 5.125 19.334 L 21.625 19.334 C 21.878 19.334 22.084 19.128 22.084 18.875 L 22.084 2.375 C 22.084 2.122 21.878 1.916 21.625 1.916 L 5.125 1.916 Z  M 15.209 14.75 C 14.956 14.75 14.75 14.544 14.75 14.291 L 14.75 12.916 L 10.625 12.916 C 10.372 12.916 10.166 12.712 10.166 12.459 L 10.166 11.541 C 10.166 8.761 12.428 6.5 15.209 6.5 C 15.462 6.5 15.666 6.706 15.666 6.959 L 15.666 14.291 C 15.666 14.544 15.462 14.75 15.209 14.75 Z  M 14.75 12 L 14.75 7.441 C 12.676 7.671 11.084 9.427 11.084 11.541 L 11.084 12 L 14.75 12 Z',
        customStroke: '0.5px',
    },
    header_three: {
        path: 'M 2.375 23 C 1.617 23 1 22.383 1 21.625 L 1 6.041 C 1 5.284 1.617 4.666 2.375 4.666 L 3.75 4.666 L 3.75 2.375 C 3.75 1.617 4.367 1 5.125 1 L 21.625 1 C 22.383 1 23 1.617 23 2.375 L 23 18.875 C 23 19.633 22.383 20.25 21.625 20.25 L 19.334 20.25 L 19.334 21.625 C 19.334 22.383 18.716 23 17.959 23 L 2.375 23 Z  M 2.375 5.584 C 2.122 5.584 1.916 5.788 1.916 6.041 L 1.916 21.625 C 1.916 21.878 2.122 22.084 2.375 22.084 L 17.959 22.084 C 18.212 22.084 18.416 21.878 18.416 21.625 L 18.416 20.25 L 5.125 20.25 C 4.367 20.25 3.75 19.633 3.75 18.875 L 3.75 5.584 L 2.375 5.584 Z  M 5.125 1.916 C 4.872 1.916 4.666 2.122 4.666 2.375 L 4.666 18.875 C 4.666 19.128 4.872 19.334 5.125 19.334 L 21.625 19.334 C 21.878 19.334 22.084 19.128 22.084 18.875 L 22.084 2.375 C 22.084 2.122 21.878 1.916 21.625 1.916 L 5.125 1.916 Z  M 10.625 14.75 C 10.372 14.75 10.166 14.544 10.166 14.291 C 10.166 14.038 10.372 13.834 10.625 13.834 L 13.375 13.834 C 14.133 13.834 14.75 13.216 14.75 12.459 C 14.75 11.7 14.133 11.084 13.375 11.084 C 13.122 11.084 12.916 10.878 12.916 10.625 C 12.916 10.372 13.122 10.166 13.375 10.166 C 14.133 10.166 14.75 9.55 14.75 8.791 C 14.75 8.034 14.133 7.416 13.375 7.416 L 10.625 7.416 C 10.372 7.416 10.166 7.212 10.166 6.959 C 10.166 6.706 10.372 6.5 10.625 6.5 L 13.375 6.5 C 14.638 6.5 15.666 7.528 15.666 8.791 C 15.666 9.522 15.323 10.196 14.75 10.625 C 15.323 11.054 15.666 11.728 15.666 12.459 C 15.666 13.721 14.638 14.75 13.375 14.75 L 10.625 14.75 Z',
        customStroke: '0.5px',
    },
    header_two: {
        path: 'M 2.375 23 C 1.617 23 1 22.383 1 21.625 L 1 6.041 C 1 5.284 1.617 4.666 2.375 4.666 L 3.75 4.666 L 3.75 2.375 C 3.75 1.617 4.367 1 5.125 1 L 21.625 1 C 22.383 1 23 1.617 23 2.375 L 23 18.875 C 23 19.633 22.383 20.25 21.625 20.25 L 19.334 20.25 L 19.334 21.625 C 19.334 22.383 18.716 23 17.959 23 L 2.375 23 Z  M 2.375 5.584 C 2.122 5.584 1.916 5.788 1.916 6.041 L 1.916 21.625 C 1.916 21.878 2.122 22.084 2.375 22.084 L 17.959 22.084 C 18.212 22.084 18.416 21.878 18.416 21.625 L 18.416 20.25 L 5.125 20.25 C 4.367 20.25 3.75 19.633 3.75 18.875 L 3.75 5.584 L 2.375 5.584 Z  M 5.125 1.916 C 4.872 1.916 4.666 2.122 4.666 2.375 L 4.666 18.875 C 4.666 19.128 4.872 19.334 5.125 19.334 L 21.625 19.334 C 21.878 19.334 22.084 19.128 22.084 18.875 L 22.084 2.375 C 22.084 2.122 21.878 1.916 21.625 1.916 L 5.125 1.916 Z  M 11.084 14.75 C 10.895 14.75 10.722 14.631 10.655 14.454 C 10.587 14.277 10.638 14.074 10.78 13.948 L 14.073 11.042 C 14.914 10.301 15.377 9.894 15.171 8.882 C 15.074 8.402 14.796 7.99 14.388 7.718 C 14.087 7.518 13.737 7.413 13.38 7.413 C 13.257 7.413 13.132 7.426 13.011 7.451 C 12.159 7.624 11.541 8.38 11.541 9.25 C 11.541 9.503 11.337 9.709 11.084 9.709 C 10.831 9.709 10.625 9.503 10.625 9.25 C 10.624 7.947 11.55 6.811 12.828 6.552 C 13.01 6.516 13.196 6.497 13.381 6.497 C 13.917 6.497 14.441 6.655 14.894 6.954 C 15.506 7.361 15.924 7.98 16.07 8.7 C 16.381 10.232 15.554 10.96 14.679 11.73 L 12.295 13.834 L 16.125 13.834 C 16.378 13.834 16.584 14.038 16.584 14.291 C 16.584 14.544 16.378 14.75 16.125 14.75 L 11.084 14.75 Z',
        customStroke: '0.5px',
    },
    improve: {
        path: 'M 8.072 18.286 L 15.929 18.286 L 15.929 19.857 L 8.072 19.857 L 8.072 18.286 Z  M 9.643 21.429 L 14.357 21.429 L 14.357 23 L 9.643 23 L 9.643 21.429 Z  M 12 1 C 7.661 1 4.143 4.518 4.143 8.857 C 4.035 11.174 5.046 13.401 6.862 14.844 C 7.647 15.575 8.072 15.991 8.072 16.714 L 9.643 16.714 C 9.643 15.269 8.771 14.459 7.922 13.681 C 6.431 12.54 5.604 10.732 5.714 8.857 C 5.714 5.386 8.529 2.571 12 2.571 C 15.472 2.571 18.286 5.386 18.286 8.857 C 18.394 10.733 17.564 12.541 16.07 13.681 C 15.229 14.467 14.357 15.253 14.357 16.714 L 15.929 16.714 C 15.929 15.991 16.345 15.575 17.139 14.836 C 18.952 13.396 19.964 11.171 19.857 8.857 C 19.857 4.518 16.339 1 12 1 Z',
    },
    industrial: {
        path: 'M 22.631 5.046 C 22.388 4.906 22.088 4.906 21.845 5.046 L 15.143 8.37 L 15.143 5.714 C 15.142 5.442 15 5.189 14.768 5.047 C 14.536 4.905 14.247 4.892 14.004 5.015 L 7.286 8.37 L 7.286 2.571 C 7.286 2.137 6.934 1.786 6.5 1.786 L 1.786 1.786 C 1.352 1.786 1 2.137 1 2.571 L 1 22.214 L 23 22.214 L 23 5.714 C 23.001 5.443 22.861 5.19 22.631 5.046 L 22.631 5.046 Z  M 16.714 20.643 L 13.571 20.643 L 13.571 15.143 L 16.714 15.143 L 16.714 20.643 Z  M 21.429 20.643 L 18.286 20.643 L 18.286 14.357 C 18.286 13.923 17.934 13.571 17.5 13.571 L 12.786 13.571 C 12.352 13.571 12 13.923 12 14.357 L 12 20.643 L 2.571 20.643 L 2.571 3.357 L 5.714 3.357 L 5.714 10.916 L 13.571 6.987 L 13.571 10.916 L 21.429 6.987 L 21.429 20.643 Z',
    },
    info: {
        path: 'M 12.857 17.143 L 12.857 9.429 L 9.429 9.429 L 9.429 11.143 L 11.143 11.143 L 11.143 17.143 L 8.571 17.143 L 8.571 18.857 L 15.429 18.857 L 15.429 17.143 L 12.857 17.143 L 12.857 17.143 Z  M 12 4.286 C 11.29 4.286 10.714 4.861 10.714 5.571 C 10.714 6.282 11.29 6.857 12 6.857 C 12.71 6.857 13.286 6.282 13.286 5.571 C 13.286 4.861 12.71 4.286 12 4.286 Z  M 12 24 C 5.373 24 0 18.627 0 12 C 0 5.373 5.373 0 12 0 C 18.627 0 24 5.373 24 12 C 24 18.627 18.627 24 12 24 Z  M 12 1.714 C 6.319 1.714 1.714 6.319 1.714 12 C 1.714 17.681 6.319 22.286 12 22.286 C 17.681 22.286 22.286 17.681 22.286 12 C 22.286 6.319 17.681 1.714 12 1.714 Z',
    },
    instagram: {
        path: 'M 12 16.211 C 9.678 16.211 7.789 14.322 7.789 12 C 7.789 9.678 9.678 7.789 12 7.789 C 14.322 7.789 16.211 9.678 16.211 12 C 16.211 14.322 14.322 16.211 12 16.211 L 12 16.211 L 12 16.211 Z  M 12 6.07 C 8.73 6.07 6.07 8.73 6.07 12 C 6.07 15.27 8.73 17.93 12 17.93 C 15.27 17.93 17.93 15.27 17.93 12 C 17.93 8.73 15.27 6.07 12 6.07 L 12 6.07 L 12 6.07 Z  M 21.281 16.609 C 21.281 19.185 19.185 21.281 16.609 21.281 L 7.391 21.281 C 4.815 21.281 2.719 19.185 2.719 16.609 L 2.719 7.391 C 2.719 4.815 4.815 2.719 7.391 2.719 L 16.609 2.719 C 19.185 2.719 21.281 4.815 21.281 7.391 L 21.281 16.609 L 21.281 16.609 L 21.281 16.609 Z  M 16.609 1 L 7.391 1 C 3.867 1 1 3.867 1 7.391 L 1 16.609 C 1 20.133 3.867 23 7.391 23 L 16.609 23 C 20.133 23 23 20.133 23 16.609 L 23 7.391 C 23 3.867 20.133 1 16.609 1 L 16.609 1 L 16.609 1 Z  M 17.156 5.984 C 17.156 5.51 17.541 5.125 18.016 5.125 C 18.49 5.125 18.875 5.51 18.875 5.984 C 18.875 6.459 18.49 6.844 18.016 6.844 C 17.541 6.844 17.156 6.459 17.156 5.984 Z',
        customStroke: '0',
    },
    issue_open: {
        path: 'M 12 11.738 C 11.696 11.738 11.45 11.984 11.45 12.288 C 11.45 12.592 11.696 12.838 12 12.838 C 12.304 12.838 12.55 12.592 12.55 12.288 C 12.55 11.984 12.304 11.738 12 11.738 Z  M 11.634 7.705 L 12.472 7.705 L 12.472 11.006 L 11.634 11.006 L 11.634 7.705 Z  M 16.767 14.305 L 7.233 14.305 C 7.105 14.305 6.986 14.238 6.919 14.129 C 6.853 14.02 6.848 13.883 6.907 13.769 L 11.674 4.603 C 11.736 4.48 11.862 4.403 12 4.403 C 12.138 4.403 12.264 4.48 12.326 4.603 L 17.093 13.769 C 17.152 13.883 17.147 14.02 17.081 14.129 C 17.014 14.238 16.895 14.305 16.767 14.305 Z  M 7.838 13.571 L 16.162 13.571 L 12 5.567 L 7.838 13.571 Z  M 13.367 22.214 L 12 21.429 L 15.143 15.929 L 19.857 15.929 C 20.725 15.929 21.429 15.225 21.429 14.357 L 21.429 4.929 C 21.429 4.061 20.725 3.357 19.857 3.357 L 4.143 3.357 C 3.275 3.357 2.571 4.061 2.571 4.929 L 2.571 14.357 C 2.571 15.225 3.275 15.929 4.143 15.929 L 11.214 15.929 L 11.214 17.5 L 4.143 17.5 C 2.407 17.5 1 16.093 1 14.357 L 1 4.929 C 1 3.193 2.407 1.786 4.143 1.786 L 19.857 1.786 C 21.593 1.786 23 3.193 23 4.929 L 23 14.357 C 23 16.093 21.593 17.5 19.857 17.5 L 16.054 17.5 L 13.367 22.214 Z',
    },
    issue_closed: {
        path: 'M 11.267 13.729 L 6.552 9.014 L 7.293 8.273 L 11.267 12.247 L 18.383 5.131 L 19.124 5.871 L 11.267 13.729 Z  M 13.367 22.214 L 12 21.429 L 15.143 15.929 L 19.857 15.929 C 20.725 15.929 21.429 15.225 21.429 14.357 L 21.429 4.929 C 21.429 4.061 20.725 3.357 19.857 3.357 L 4.143 3.357 C 3.275 3.357 2.571 4.061 2.571 4.929 L 2.571 14.357 C 2.571 15.225 3.275 15.929 4.143 15.929 L 11.214 15.929 L 11.214 17.5 L 4.143 17.5 C 2.407 17.5 1 16.093 1 14.357 L 1 4.929 C 1 3.193 2.407 1.786 4.143 1.786 L 19.857 1.786 C 21.593 1.786 23 3.193 23 4.929 L 23 14.357 C 23 16.093 21.593 17.5 19.857 17.5 L 16.054 17.5 L 13.367 22.214 Z',
    },
    italic: {
        path: 'M 23 3.444 L 23 1 L 7.111 1 L 7.111 3.444 L 13.393 3.444 L 8.052 20.556 L 1 20.556 L 1 23 L 16.889 23 L 16.889 20.556 L 10.607 20.556 L 15.948 3.444 L 23 3.444 L 23 3.444 Z',
    },
    labels: {
        path: 'M 5.712 10.429 C 5.712 9.561 6.416 8.857 7.283 8.857 C 8.151 8.857 8.855 9.561 8.855 10.429 C 8.855 11.296 8.151 12 7.283 12 C 6.416 12 5.712 11.296 5.712 10.429 Z  M 11.998 23 C 11.789 23.001 11.588 22.919 11.44 22.772 L 3.033 14.357 C 2.738 14.064 2.571 13.665 2.569 13.249 L 2.569 7.286 C 2.569 6.418 3.273 5.714 4.141 5.714 L 10.104 5.714 C 10.52 5.716 10.919 5.883 11.212 6.178 L 19.627 14.585 C 19.776 14.733 19.859 14.933 19.859 15.143 C 19.859 15.352 19.776 15.553 19.627 15.701 L 12.556 22.772 C 12.407 22.919 12.207 23.001 11.998 23 Z  M 4.141 7.286 L 4.141 13.249 L 11.998 21.106 L 17.961 15.143 L 10.104 7.286 L 4.141 7.286 Z  M 21.198 9.871 L 12.783 1.464 C 12.49 1.168 12.092 1.002 11.676 1 L 5.712 1 C 4.844 1 4.141 1.704 4.141 2.571 L 4.141 4.143 L 5.712 4.143 L 5.712 2.571 L 11.676 2.571 L 19.533 10.429 L 18.511 11.442 L 19.627 12.558 L 21.198 10.986 C 21.347 10.839 21.431 10.638 21.431 10.429 C 21.431 10.219 21.347 10.018 21.198 9.871 Z',
    },
    launch: {
        path: 'M 19.615 23 L 2.692 23 C 1.758 23 1 22.242 1 21.308 L 1 4.385 C 1 3.45 1.758 2.692 2.692 2.692 L 10.308 2.692 L 10.308 4.385 L 2.692 4.385 L 2.692 21.308 L 19.615 21.308 L 19.615 13.692 L 21.308 13.692 L 21.308 21.308 C 21.308 22.242 20.55 23 19.615 23 Z  M 15.385 1 L 15.385 2.692 L 20.115 2.692 L 12.846 9.961 L 14.039 11.154 L 21.308 3.885 L 21.308 8.615 L 23 8.615 L 23 1 L 15.385 1 L 15.385 1 Z',
    },
    layers: {
        path: 'M 12 22.715 C 11.865 22.715 11.733 22.687 11.609 22.634 L 1.591 18.276 C 1.35 18.173 1.165 17.981 1.069 17.737 C 0.973 17.495 0.979 17.228 1.082 16.989 C 1.181 16.761 1.361 16.582 1.588 16.483 L 5.711 14.69 L 1.588 12.897 C 1.349 12.794 1.164 12.602 1.069 12.358 C 0.972 12.116 0.978 11.849 1.082 11.61 C 1.181 11.382 1.361 11.202 1.588 11.103 L 5.713 9.31 L 1.591 7.517 C 1.35 7.413 1.165 7.221 1.069 6.978 C 0.973 6.736 0.979 6.47 1.082 6.23 C 1.182 6.002 1.362 5.823 1.588 5.724 L 11.609 1.366 C 11.733 1.313 11.863 1.285 11.999 1.285 C 12.135 1.285 12.266 1.313 12.391 1.366 L 22.409 5.724 C 22.904 5.939 23.131 6.516 22.915 7.011 C 22.816 7.239 22.636 7.418 22.409 7.517 L 18.287 9.31 L 22.409 11.103 C 22.65 11.207 22.835 11.398 22.931 11.642 C 23.027 11.885 23.021 12.151 22.918 12.391 C 22.818 12.619 22.639 12.798 22.412 12.897 L 18.289 14.69 L 22.412 16.483 C 22.651 16.586 22.836 16.779 22.931 17.022 C 23.028 17.264 23.022 17.53 22.918 17.77 C 22.819 17.998 22.64 18.177 22.412 18.276 L 12.391 22.634 C 12.267 22.687 12.135 22.715 12 22.715 Z  M 1.98 17.38 L 12 21.737 L 22.021 17.38 L 17.062 15.223 L 12.391 17.255 C 12.267 17.308 12.135 17.336 12 17.336 C 11.865 17.336 11.733 17.308 11.609 17.255 L 6.939 15.224 L 1.98 17.38 Z  M 12 16.358 L 22.021 12.001 L 17.061 9.844 L 12.391 11.874 C 12.267 11.928 12.135 11.955 12 11.955 C 11.865 11.955 11.733 11.928 11.609 11.874 L 6.939 9.843 L 1.979 11.999 L 7.119 14.234 C 7.124 14.238 12 16.358 12 16.358 Z  M 1.98 6.62 L 12 10.978 L 22.021 6.62 L 12 2.263 L 1.98 6.62 Z',
        customStroke: '0.5px',
    },
    liked: {
        path: 'M 17.089 2.214 C 15.523 2.214 14.036 2.84 12.94 3.936 L 12 4.875 L 11.139 4.014 C 8.868 1.665 5.11 1.665 2.84 3.936 C 2.84 3.936 2.762 4.014 2.762 4.014 C 0.413 6.363 0.413 10.121 2.762 12.47 L 12 21.786 L 21.238 12.47 C 23.587 10.121 23.587 6.363 21.238 4.014 C 20.142 2.84 18.655 2.214 17.089 2.214 Z',
    },
    link: {
        path: 'M 21.708 4.869 C 20.883 4.042 19.764 3.577 18.596 3.577 C 17.428 3.577 16.308 4.042 15.484 4.869 L 16.523 5.909 C 17.265 5.168 18.346 4.878 19.359 5.149 C 20.372 5.421 21.164 6.212 21.435 7.225 C 21.707 8.238 21.417 9.319 20.675 10.061 L 14.817 15.919 C 13.673 17.066 11.816 17.067 10.669 15.923 C 9.523 14.778 9.521 12.921 10.665 11.775 L 11.698 10.735 L 10.665 9.695 L 9.626 10.735 C 8.798 11.559 8.333 12.679 8.333 13.847 C 8.333 15.015 8.798 16.135 9.626 16.959 C 10.454 17.777 11.574 18.232 12.738 18.226 C 13.91 18.23 15.036 17.766 15.864 16.937 L 21.722 11.079 C 23.432 9.36 23.425 6.581 21.708 4.869 Z  M 3.358 18.094 C 2.805 17.544 2.495 16.797 2.495 16.018 C 2.495 15.239 2.805 14.492 3.358 13.942 L 9.216 8.084 C 9.765 7.532 10.512 7.221 11.292 7.221 C 12.071 7.221 12.818 7.532 13.367 8.084 C 13.916 8.638 14.218 9.391 14.202 10.171 C 14.207 10.953 13.898 11.705 13.346 12.258 L 11.793 13.832 L 12.833 14.872 L 14.385 13.32 C 16.106 11.599 16.106 8.809 14.385 7.088 C 12.665 5.367 9.875 5.367 8.154 7.088 L 2.296 12.946 C 1.466 13.771 1 14.892 1 16.062 C 1 17.232 1.466 18.353 2.296 19.178 C 3.13 19.989 4.252 20.437 5.415 20.422 C 6.589 20.424 7.716 19.96 8.549 19.134 L 7.509 18.094 C 6.96 18.646 6.213 18.957 5.434 18.957 C 4.654 18.957 3.907 18.646 3.358 18.094 Z',
    },
    linkedin: {
        path: 'M 21.224 1 Q 21.969 1 22.484 1.487 Q 22.999 1.974 23 2.719 L 23 21.109 Q 23 21.854 22.484 22.427 Q 21.968 23 21.224 23 L 2.891 23 Q 2.146 23 1.573 22.427 Q 1 21.854 1 21.109 L 1 2.719 Q 1 1.974 1.545 1.487 Q 2.089 1 2.891 1 L 21.224 1 Z  M 7.818 19.332 L 7.818 9.536 L 4.666 9.536 L 4.666 19.332 L 7.818 19.332 Z  M 6.329 8.048 Q 7.074 8.048 7.561 7.561 Q 8.048 7.074 8.048 6.387 Q 8.048 5.641 7.589 5.155 Q 7.13 4.668 6.385 4.668 Q 5.64 4.668 5.153 5.155 Q 4.666 5.641 4.666 6.387 Q 4.666 7.074 5.125 7.561 Q 5.584 8.048 6.329 8.048 Z  M 19.332 19.332 L 19.332 13.603 Q 19.332 11.483 18.33 10.396 Q 17.327 9.308 15.723 9.307 Q 14.004 9.307 12.858 10.911 L 12.858 9.536 L 9.707 9.536 L 9.707 19.332 L 12.858 19.332 L 12.858 13.774 Q 12.858 13.202 12.974 12.974 Q 13.431 11.827 14.577 11.827 Q 16.181 11.827 16.181 13.947 L 16.181 19.332 L 19.332 19.332 Z',
        customStroke: '0',
    },
    list: {
        path: 'M 12 5.946 L 23 5.946 L 23 7.518 L 12 7.518 L 12 5.946 Z  M 4.143 7.981 L 2.108 5.946 L 1 7.054 L 4.143 10.197 L 10.429 3.911 L 9.321 2.803 L 4.143 7.981 L 4.143 7.981 Z  M 12 16.946 L 23 16.946 L 23 18.518 L 12 18.518 L 12 16.946 Z  M 4.143 18.981 L 2.108 16.946 L 1 18.054 L 4.143 21.197 L 10.429 14.911 L 9.321 13.803 L 4.143 18.981 L 4.143 18.981 Z',
    },
    locked: {
        path: 'M 30.858 17.286 L 28.142 17.286 L 28.142 9.142 C 28.142 4.646 24.498 1 20 1 C 15.502 1 11.858 4.646 11.858 9.142 L 11.858 17.286 L 9.142 17.286 C 7.643 17.286 6.429 18.501 6.429 20 L 6.429 36.286 C 6.429 37.784 7.643 39 9.142 39 L 30.858 39 C 32.357 39 33.571 37.784 33.571 36.286 L 33.571 20 C 33.571 18.501 32.357 17.286 30.858 17.286 Z  M 14.571 9.142 C 14.571 6.146 17.001 3.714 20 3.714 C 22.999 3.714 25.429 6.146 25.429 9.142 L 25.429 17.286 L 14.571 17.286 L 14.571 9.142 Z  M 30.858 36.286 L 9.142 36.286 L 9.142 20 L 30.858 20 L 30.858 36.286 Z',
    },
    loop: {
        path: 'M 4.042 14.802 C 3.896 14.795 3.762 14.718 3.681 14.597 L 1.08 10.724 C 1.01 10.62 0.986 10.496 1.008 10.374 C 1.033 10.252 1.102 10.147 1.206 10.077 C 1.284 10.025 1.373 9.997 1.465 9.997 C 1.622 9.997 1.767 10.075 1.853 10.204 L 3.362 12.449 C 3.298 8.444 6.017 4.834 9.976 3.846 L 10.063 3.824 C 10.701 3.674 11.354 3.598 12.008 3.598 C 14.407 3.598 16.699 4.632 18.292 6.436 C 18.462 6.629 18.444 6.924 18.251 7.095 C 18.165 7.17 18.055 7.212 17.942 7.212 C 17.809 7.212 17.681 7.154 17.591 7.053 C 16.177 5.45 14.14 4.531 12.008 4.531 C 11.428 4.531 10.847 4.599 10.281 4.734 L 10.202 4.753 C 6.359 5.711 3.87 9.392 4.352 13.27 L 6.701 10.457 C 6.789 10.351 6.92 10.29 7.059 10.29 C 7.168 10.29 7.275 10.329 7.358 10.399 C 7.555 10.564 7.581 10.859 7.416 11.056 L 4.426 14.637 C 4.336 14.742 4.046 14.802 4.042 14.802 Z  M 11.972 20.402 C 9.764 20.402 7.677 19.54 6.093 17.974 C 6.004 17.886 5.955 17.769 5.955 17.645 C 5.953 17.519 6.002 17.402 6.09 17.314 C 6.178 17.224 6.296 17.175 6.421 17.175 C 6.546 17.175 6.662 17.223 6.75 17.31 C 8.158 18.702 10.014 19.468 11.975 19.468 C 11.975 19.468 11.975 19.468 11.975 19.468 C 12.558 19.468 13.143 19.4 13.715 19.263 C 17.145 18.443 19.555 15.302 19.527 11.816 L 17.299 14.485 C 17.209 14.591 17.079 14.653 16.94 14.653 C 16.831 14.653 16.724 14.615 16.641 14.544 C 16.444 14.379 16.416 14.084 16.582 13.887 L 19.518 10.372 C 19.532 10.353 19.546 10.337 19.562 10.32 L 19.576 10.303 C 19.664 10.197 19.794 10.136 19.933 10.136 C 19.937 10.136 19.955 10.136 19.959 10.138 C 20.105 10.144 20.241 10.221 20.321 10.344 L 22.921 14.219 C 22.99 14.322 23.016 14.447 22.991 14.568 C 22.967 14.69 22.896 14.796 22.793 14.866 C 22.717 14.918 22.627 14.945 22.533 14.945 C 22.378 14.945 22.232 14.868 22.145 14.738 L 20.456 12.22 C 20.31 16.003 17.67 19.277 13.933 20.172 C 13.288 20.325 12.629 20.402 11.972 20.402 L 11.972 20.402 Z',
        customStroke: '0.5px',
    },
    marketplace: {
        path: 'M 17.5 2.474 L 23 12 L 17.5 21.526 L 6.5 21.526 L 1 12 L 6.5 2.474 L 17.5 2.474 Z  M 11.929 3.386 L 7.028 3.386 L 2.054 12.001 L 7.028 20.613 L 11.929 20.613 L 11.929 14.953 C 10.321 14.814 9.046 13.508 8.954 11.886 L 8.949 11.701 C 8.949 9.992 10.26 8.592 11.929 8.448 L 11.929 3.386 Z  M 16.973 3.386 L 12.936 3.386 L 12.936 8.516 C 14.334 8.831 15.391 10.042 15.474 11.515 L 15.479 11.701 C 15.479 13.256 14.392 14.557 12.937 14.886 L 12.936 20.613 L 16.973 20.613 L 21.946 12 L 16.973 3.387 L 16.973 3.386 Z  M 12.214 9.511 C 11.007 9.511 10.025 10.494 10.025 11.701 C 10.025 12.908 11.007 13.89 12.215 13.89 C 13.422 13.89 14.404 12.908 14.404 11.701 C 14.404 10.494 13.422 9.511 12.215 9.511 L 12.214 9.511 Z',
        customStroke: '0.5px',
    },
    medical: {
        path: 'M 11.084 18.416 C 10.578 18.416 10.166 18.006 10.166 17.5 L 10.166 15.666 L 8.334 15.666 C 7.828 15.666 7.416 15.256 7.416 14.75 L 7.416 12.916 C 7.416 12.41 7.828 12 8.334 12 L 10.166 12 L 10.166 10.166 C 10.166 9.662 10.578 9.25 11.084 9.25 L 12.916 9.25 C 13.422 9.25 13.834 9.662 13.834 10.166 L 13.834 12 L 15.666 12 C 16.172 12 16.584 12.41 16.584 12.916 L 16.584 14.75 C 16.584 15.256 16.172 15.666 15.666 15.666 L 13.834 15.666 L 13.834 17.5 C 13.834 18.006 13.422 18.416 12.916 18.416 L 11.084 18.416 Z  M 8.334 14.75 L 10.625 14.75 C 10.878 14.75 11.084 14.956 11.084 15.209 L 11.084 17.5 L 12.916 17.5 L 12.916 15.209 C 12.916 14.956 13.122 14.75 13.375 14.75 L 15.666 14.75 L 15.666 12.916 L 13.375 12.916 C 13.122 12.916 12.916 12.712 12.916 12.459 L 12.916 10.166 L 11.084 10.166 L 11.084 12.459 C 11.084 12.712 10.878 12.916 10.625 12.916 L 8.334 12.916 L 8.334 14.75 Z  M 3.291 21.166 C 2.028 21.166 1 20.138 1 18.875 L 1 7.875 C 1 6.611 2.028 5.584 3.291 5.584 L 8.334 5.584 L 8.334 4.666 C 8.334 3.656 9.156 2.834 10.166 2.834 L 13.834 2.834 C 14.844 2.834 15.666 3.656 15.666 4.666 L 15.666 5.584 L 20.709 5.584 C 21.972 5.584 23 6.611 23 7.875 L 23 18.875 C 23 20.138 21.972 21.166 20.709 21.166 L 3.291 21.166 Z  M 3.291 6.5 C 2.534 6.5 1.916 7.117 1.916 7.875 L 1.916 18.875 C 1.916 19.633 2.534 20.25 3.291 20.25 L 20.709 20.25 C 21.466 20.25 22.084 19.633 22.084 18.875 L 22.084 7.875 C 22.084 7.117 21.466 6.5 20.709 6.5 L 3.291 6.5 Z  M 14.75 5.584 L 14.75 4.666 C 14.75 4.162 14.34 3.75 13.834 3.75 L 10.166 3.75 C 9.662 3.75 9.25 4.162 9.25 4.666 L 9.25 5.584 L 14.75 5.584 Z',
        customStroke: '0.5px',
    },
    mesh: {
        path: 'M 1 39 L 28 39 L 39 28 L 39 2 L 12.5 2 L 1 12.5 L 1 39 M 34 3 L 3.5 11.5 L 13 3 L 34 3 M 36.5 3 L 27 12 L 5 12 L 36.5 3 M 37.5 3.5 L 28 35 L 28 12.5 L 37.5 3.5 M 38 4.5 L 38 28 L 28 38 L 38 4.5 M 27 13 L 27 37 L 3 13 L 27 13 M 2 14 L 26 38 L 2 38 L 2 14',
        customStroke: '1.5px',
    },
    brep: {
        path: 'M 26.48 2.46 C 18.81 2.61 11.14 2.47 3.47 2.52 C 1.31 2.89 2.67 6.04 2.31 7.61 C 2.33 12.73 2.22 17.84 2.34 22.96 C 2.53 24.55 1.73 26.29 2.71 27.71 C 4.07 29.38 5.82 30.68 7.3 32.25 C 8.99 33.88 10.64 35.54 12.24 37.26 C 14.06 38.09 16.12 37.39 18.04 37.64 C 23.73 37.64 29.43 37.6 35.12 37.66 C 37.37 38.66 38.63 36.01 37.87 34.2 C 37.9 27.21 37.84 20.21 37.89 13.22 C 36.88 11.04 34.61 9.91 33.11 8.13 C 31.31 6.37 29.55 4.57 27.75 2.81 C 27.38 2.56 26.92 2.47 26.48 2.46 Z M 26.03 3.6 C 28.06 3.93 28.97 6.07 30.51 7.2 C 32.28 8.93 34.12 10.6 35.76 12.45 C 28.25 12.43 20.73 12.5 13.21 12.42 C 10.17 9.61 7.28 6.65 4.36 3.72 C 11.43 3.68 18.51 3.8 25.57 3.65 C 25.72 3.61 25.88 3.62 26.03 3.6 Z M 3.55 4.58 C 6.47 7.5 9.47 10.35 12.34 13.31 C 12.47 20.73 12.37 28.16 12.4 35.58 C 9.43 32.71 6.47 29.83 3.55 26.9 C 3.45 19.46 3.47 12.02 3.55 4.58 Z M 16.67 13.58 C 18.12 13.88 19.5 14.03 20.88 13.63 C 22.34 14.34 23.76 13.35 25.21 13.78 C 26.66 14.27 28.05 13.16 29.51 13.94 C 30.87 13.46 32.18 13.76 33.58 13.97 C 35.39 12.45 37.79 14.85 36.47 16.76 C 36.81 17.91 36.65 19.54 36.46 20.94 C 37.2 22.58 35.88 24.34 36.68 25.95 C 36.11 27.4 36.73 28.78 36.62 30.2 C 35.91 31.66 37.29 32.98 36.4 34.44 C 36.37 35.27 37.17 36.98 35.54 36.3 C 34.21 35.72 32.97 37.11 31.58 36.14 C 30.12 36.71 28.64 36.22 27.05 36.23 C 25.6 36.96 24.15 35.6 22.87 36.51 C 21.26 36 19.67 36.45 18.09 36.34 C 16.61 35.48 14.81 37.64 13.73 35.76 C 13.01 34.1 14.39 32.48 13.47 30.76 C 13.62 29.73 14.33 29.43 13.54 28.5 C 13.68 26.96 13.97 25.52 13.45 24.09 C 14.52 22.41 12.95 21 13.78 19.36 C 13.73 17.89 13.35 16.55 13.91 15.07 C 12.73 13.4 14.73 13.66 15.8 14.01 C 16.2 14 16.28 13.53 16.67 13.58 Z M 17.02 14.83 C 15.09 16.66 19.39 15.75 17.02 14.83 Z M 20.61 14.83 C 18.57 16.58 22.91 15.85 20.61 14.83 Z M 24.14 14.83 C 22.2 16.66 26.5 15.75 24.14 14.83 Z M 31.25 14.83 C 29.32 16.66 33.63 15.77 31.25 14.83 Z M 27.66 14.84 C 25.81 16.79 30.06 15.63 27.66 14.84 Z M 34.78 14.84 C 32.92 16.79 37.19 15.62 34.78 14.84 Z M 25.87 16.6 C 24.05 18.57 28.34 17.33 25.87 16.6 Z M 15.17 16.61 C 13.48 18.66 17.64 17.22 15.17 16.61 Z M 22.29 16.61 C 20.6 18.67 24.74 17.21 22.29 16.61 Z M 18.7 16.61 C 17.09 18.76 21.23 17.1 18.7 16.61 Z M 29.4 16.61 C 27.74 18.73 31.85 17.16 29.4 16.61 Z M 32.93 16.61 C 31.32 18.75 35.46 17.12 32.93 16.61 Z M 27.61 18.37 C 25.96 20.44 30.11 18.92 27.61 18.37 Z M 16.91 18.38 C 15.38 20.53 19.45 18.8 16.91 18.38 Z M 24.02 18.38 C 22.48 20.53 26.58 18.82 24.02 18.38 Z M 31.14 18.38 C 29.61 20.53 33.68 18.8 31.14 18.38 Z M 20.44 18.39 C 19 20.6 23 18.71 20.44 18.39 Z M 34.67 18.39 C 33.23 20.59 37.23 18.71 34.67 18.39 Z M 15.29 20.09 C 13.21 21.77 17.58 21.18 15.29 20.09 Z M 22.41 20.09 C 20.33 21.78 24.69 21.17 22.41 20.09 Z M 18.88 20.09 C 16.69 21.66 21.13 21.3 18.88 20.09 Z M 29.52 20.09 C 27.44 21.75 31.81 21.19 29.52 20.09 Z M 25.94 20.1 C 23.93 21.23 28.29 21.37 25.94 20.1 Z M 33.05 20.1 C 31.04 21.29 35.42 21.32 33.05 20.1 Z M 27.67 21.85 C 25.8 23.82 30.08 22.63 27.67 21.85 Z M 20.55 21.86 C 18.68 23.79 22.97 22.65 20.55 21.86 Z M 34.78 21.86 C 32.91 23.77 37.18 22.68 34.78 21.86 Z M 16.97 21.86 C 15.23 23.89 19.42 22.54 16.97 21.86 Z M 24.08 21.86 C 22.34 23.89 26.53 22.54 24.08 21.86 Z M 31.19 21.86 C 29.46 23.89 33.63 22.52 31.19 21.86 Z M 15.18 23.63 C 13.48 25.62 17.66 24.24 15.18 23.63 Z M 22.29 23.63 C 20.6 25.62 24.77 24.25 22.29 23.63 Z M 29.4 23.63 C 27.71 25.63 31.89 24.24 29.4 23.63 Z M 18.7 23.63 C 17.09 25.75 21.23 24.12 18.7 23.63 Z M 25.81 23.63 C 24.22 25.75 28.35 24.11 25.81 23.63 Z M 32.93 23.63 C 31.33 25.75 35.46 24.11 32.93 23.63 Z M 27.73 25.35 C 25.7 26.51 30.08 26.61 27.73 25.35 Z M 34.84 25.36 C 32.84 26.45 37.16 26.67 34.84 25.36 Z M 16.91 25.4 C 15.38 27.55 19.45 25.81 16.91 25.4 Z M 20.44 25.4 C 18.99 27.59 23 25.76 20.44 25.4 Z M 24.03 25.4 C 22.5 27.55 26.56 25.81 24.03 25.4 Z M 31.14 25.4 C 29.63 27.55 33.67 25.8 31.14 25.4 Z M 15.23 27.11 C 13.35 28.99 17.61 27.97 15.23 27.11 Z M 18.82 27.11 C 16.8 28.89 21.19 28.08 18.82 27.11 Z M 22.34 27.11 C 20.46 29.01 24.71 27.95 22.34 27.11 Z M 25.93 27.11 C 23.92 28.89 28.3 28.08 25.93 27.11 Z M 29.46 27.11 C 27.59 28.99 31.83 27.96 29.46 27.11 Z M 33.04 27.11 C 31.03 28.89 35.41 28.08 33.04 27.11 Z M 16.97 28.88 C 15.24 30.93 19.41 29.5 16.97 28.88 Z M 24.08 28.88 C 22.38 30.92 26.52 29.51 24.08 28.88 Z M 31.2 28.88 C 29.48 30.93 33.63 29.51 31.2 28.88 Z M 34.72 28.88 C 33.05 30.97 37.21 29.46 34.72 28.88 Z M 20.5 28.89 C 18.85 31 22.98 29.42 20.5 28.89 Z M 27.61 28.89 C 25.96 31 30.1 29.42 27.61 28.89 Z M 15.12 30.66 C 13.63 32.83 17.67 31.05 15.12 30.66 Z M 18.7 30.66 C 17.13 32.77 21.2 31.11 18.7 30.66 Z M 22.23 30.66 C 20.74 32.83 24.78 31.05 22.23 30.66 Z M 25.82 30.66 C 24.24 32.75 28.33 31.13 25.82 30.66 Z M 29.34 30.66 C 27.86 32.83 31.9 31.05 29.34 30.66 Z M 32.93 30.66 C 31.36 32.78 35.45 31.11 32.93 30.66 Z M 17.08 32.36 C 14.96 33.98 19.37 33.52 17.08 32.36 Z M 31.31 32.36 C 29.17 34.01 33.59 33.5 31.31 32.36 Z M 27.72 32.37 C 25.66 34.09 30.04 33.41 27.72 32.37 Z M 34.84 32.37 C 32.78 34.1 37.18 33.39 34.84 32.37 Z M 20.67 32.37 C 18.46 33.88 22.87 33.62 20.67 32.37 Z M 24.2 32.37 C 22.06 33.96 26.48 33.54 24.2 32.37 Z M 15.23 34.13 C 13.34 36.02 17.6 34.98 15.23 34.13 Z M 18.76 34.13 C 16.94 36.12 21.21 34.88 18.76 34.13 Z M 22.29 34.13 C 20.6 36.23 24.74 34.73 22.29 34.13 Z M 25.87 34.13 C 24.05 36.12 28.31 34.87 25.87 34.13 Z M 29.4 34.13 C 27.71 36.18 31.85 34.78 29.4 34.13 Z M 32.99 34.13 C 31.17 36.14 35.42 34.85 32.99 34.13 Z',
        customStroke: '1.5px',
    },
    edges: {
        path: 'M 24.04 4.39 C 20.5 4.87 16.9 5.11 13.33 5.47 C 12.34 5.56 11.38 5.68 10.39 5.77 C 10 5.8 9.28 5.74 8.95 5.95 C 8.53 6.25 8.23 7.3 7.99 7.75 C 7.21 9.31 6.43 10.84 5.65 12.37 L 2.56 18.55 L 1.66 20.35 C 1.54 20.56 1.33 20.86 1.33 21.1 C 1.33 21.52 1.84 22.12 2.05 22.48 C 2.71 23.65 3.37 24.79 4.03 25.96 C 5.2 28 6.34 30.04 7.48 32.05 L 8.53 33.91 C 8.68 34.18 8.83 34.57 9.07 34.81 C 9.52 35.23 10.27 35.53 10.81 35.83 C 11.86 36.43 12.91 37.12 13.99 37.63 C 14.35 37.78 14.86 37.63 15.22 37.6 C 16.33 37.54 17.41 37.39 18.52 37.27 C 22.45 36.88 26.47 36.67 30.37 36.1 C 30.67 36.04 30.79 35.8 30.91 35.53 L 31.63 34.09 C 32.65 32.02 33.73 29.98 34.78 27.91 C 35.68 26.08 36.58 24.22 37.54 22.42 C 37.84 21.85 38.14 21.25 38.44 20.65 C 38.56 20.41 38.8 20.08 38.83 19.78 C 38.86 19.42 38.23 18.67 38.02 18.28 C 37.3 16.99 36.55 15.73 35.83 14.44 L 32.05 7.81 L 31.03 6.01 C 30.91 5.77 30.76 5.38 30.55 5.23 C 30.16 4.99 29.32 5.05 28.87 4.99 C 27.85 4.84 26.83 4.72 25.81 4.57 C 25.24 4.48 24.61 4.33 24.04 4.39 M 28.9 5.26 V 5.32 C 25.72 5.74 22.51 5.98 19.33 6.28 C 17.59 6.46 15.7 6.88 13.96 6.82 C 12.64 6.76 11.32 6.31 10 6.13 L 11.71 5.95 L 15.1 5.62 L 20.92 5.05 L 24.37 4.72 L 28.9 5.29 M 30.04 5.53 C 30.49 5.47 30.61 5.89 30.79 6.22 L 32.14 8.56 C 33.73 11.38 35.32 14.17 36.94 16.99 C 37.33 17.68 37.72 18.4 38.14 19.09 C 38.29 19.33 38.56 19.66 38.47 19.96 C 38.08 21.19 37.24 22.42 36.64 23.59 C 35.29 26.26 33.94 28.93 32.59 31.6 C 32.08 32.59 31.57 33.61 31.06 34.6 C 30.91 34.93 30.7 35.59 30.4 35.8 C 30.13 35.98 29.56 35.92 29.23 35.95 C 28.15 36.07 27.04 36.13 25.96 36.25 C 22.15 36.64 18.31 37.18 14.47 37.39 C 14.08 37.39 13.93 36.88 13.75 36.58 C 13.24 35.71 12.76 34.84 12.25 33.97 C 10.72 31.24 9.19 28.51 7.63 25.81 L 6.52 23.86 C 6.4 23.65 6.1 23.32 6.13 23.05 C 6.13 22.72 6.49 22.27 6.64 21.97 C 8.44 18.43 10.21 14.92 11.98 11.38 C 12.49 10.39 13 9.43 13.48 8.44 C 13.66 8.08 13.84 7.42 14.17 7.18 C 14.44 6.97 15.13 7.03 15.49 7 C 16.45 6.94 17.44 6.82 18.43 6.7 C 22.3 6.31 26.17 5.98 30.04 5.53 M 13.81 7.09 C 13.3 8.29 12.64 9.43 12.07 10.57 C 10.66 13.36 9.25 16.12 7.84 18.91 C 7.36 19.87 6.88 20.86 6.4 21.82 C 6.28 22.03 6.04 22.72 5.8 22.78 C 5.53 22.84 4.93 22.48 4.66 22.36 C 3.67 21.94 2.65 21.55 1.66 21.1 C 1.84 20.5 2.23 19.93 2.5 19.39 L 4.33 15.76 C 5.89 12.61 7.33 9.31 9.1 6.28 C 10.63 6.58 12.25 7.03 13.81 7.09 M 22.81 11.74 C 17.65 11.83 13.84 16.45 13.39 21.34 C 13.03 25.12 14.92 29.2 18.67 30.49 C 19.57 30.79 20.5 30.88 21.43 30.85 C 26.74 30.79 30.79 25.09 30.58 20.11 C 30.4 15.82 27.43 11.68 22.81 11.74 M 16.15 28.57 C 16.57 28.27 17.38 28.24 17.92 28.06 C 18.88 27.7 19.78 27.16 20.56 26.5 C 23.74 23.86 25.3 19.39 24.16 15.37 C 23.98 14.68 23.68 13.96 23.32 13.33 C 23.05 12.91 22.69 12.52 22.48 12.1 C 22.99 11.98 23.38 12.55 23.68 12.91 C 24.55 13.93 25.15 15.19 25.45 16.54 C 26.32 20.68 24.52 25.33 20.86 27.58 C 19.9 28.18 18.85 28.6 17.71 28.78 C 17.11 28.87 16.63 28.96 16.15 28.57 M 16.96 29.23 V 29.2 C 18.19 29.05 19.33 28.78 20.44 28.18 C 24.55 25.93 26.77 20.89 25.72 16.33 C 25.45 15.28 25 14.23 24.37 13.33 C 24.04 12.91 23.65 12.52 23.35 12.1 C 23.83 12.16 24.28 12.67 24.61 13 C 25.6 13.99 26.35 15.19 26.71 16.54 C 27.97 20.89 26.08 25.93 22.15 28.3 C 21.07 28.93 19.9 29.29 18.67 29.44 C 18.1 29.53 17.44 29.56 16.96 29.23 M 21.73 12.16 C 22.33 12.07 22.72 12.94 22.99 13.39 C 23.86 14.86 24.25 16.54 24.25 18.25 C 24.22 21.73 22.27 25.33 19.24 27.1 C 18.31 27.64 17.14 28.15 16.06 28.21 C 15.55 28.24 15.1 27.28 14.86 26.92 C 14.02 25.39 13.66 23.68 13.66 21.97 C 13.72 17.5 17.11 12.7 21.73 12.16 M 25.15 12.43 L 25.09 12.49 L 25.15 12.43 M 24.58 12.49 C 25.45 13.06 26.26 13.66 26.89 14.53 C 29.17 17.62 28.99 22.12 27.07 25.33 C 25.27 28.36 21.58 30.91 17.95 29.86 V 29.8 C 24.25 29.77 28.42 22.87 27.19 17.11 C 26.95 15.94 26.44 14.83 25.75 13.87 C 25.51 13.54 25.27 13.24 25 12.94 C 24.88 12.82 24.64 12.67 24.58 12.49 M 25.24 12.49 C 29.59 13.96 31 19.21 29.83 23.23 C 28.9 26.56 26.26 29.59 22.81 30.34 C 21.79 30.58 20.74 30.55 19.72 30.43 V 30.37 C 21.7 30.37 23.68 29.38 25.15 28.12 C 29.59 24.19 30.52 16.15 25.18 12.52 L 25.24 12.49 M 1.9 21.52 C 2.77 21.94 3.64 22.27 4.51 22.63 C 4.9 22.78 5.44 22.9 5.74 23.17 C 6.1 23.47 6.31 24.07 6.52 24.49 L 8.14 27.34 L 11.89 33.97 C 12.46 34.96 13.3 36.04 13.63 37.12 C 12.7 36.58 11.77 36.04 10.81 35.5 C 10.33 35.23 9.7 34.99 9.31 34.6 C 9.07 34.39 8.92 34 8.74 33.73 L 7.72 31.9 C 6.58 29.92 5.44 27.91 4.33 25.9 C 3.76 24.88 3.13 23.83 2.56 22.81 C 2.35 22.48 1.9 21.91 1.9 21.52 Z',
        customStroke: '2px',
    },
    faces: {
        path: 'M 24.1 3.47 C 23.95 3.47 23.8 3.47 23.65 3.49 C 20 3.97 16.31 4.22 12.66 4.59 C 11.65 4.68 10.64 4.8 9.63 4.88 C 9.24 4.91 8.5 4.85 8.17 5.08 C 7.71 5.38 7.41 6.45 7.17 6.94 C 6.38 8.52 5.57 10.1 4.78 11.68 L 1.6 18.03 L 0.67 19.89 C 0.56 20.11 0.33 20.42 0.33 20.67 C 0.32 21.1 0.86 21.72 1.06 22.09 C 1.73 23.28 2.41 24.47 3.09 25.66 C 4.28 27.74 5.45 29.83 6.63 31.91 L 7.71 33.82 C 7.88 34.11 8.03 34.49 8.28 34.73 C 8.74 35.17 9.51 35.46 10.07 35.76 C 11.15 36.37 12.22 37.1 13.34 37.61 C 13.7 37.78 14.23 37.61 14.61 37.58 C 15.74 37.51 16.86 37.36 17.98 37.25 C 22.02 36.84 26.13 36.64 30.15 36.06 C 30.47 36.01 30.58 35.74 30.71 35.48 L 31.44 34.01 C 32.5 31.89 33.6 29.79 34.66 27.66 C 35.59 25.79 36.51 23.88 37.5 22.04 C 37.82 21.45 38.12 20.84 38.43 20.23 C 38.55 19.98 38.8 19.64 38.82 19.35 C 38.85 18.89 38.22 18.13 37.99 17.74 C 37.24 16.42 36.49 15.1 35.74 13.78 L 31.88 6.99 L 30.82 5.13 C 30.7 4.9 30.55 4.5 30.33 4.35 C 29.93 4.1 29.05 4.15 28.59 4.08 C 27.55 3.93 26.5 3.8 25.46 3.66 C 25.03 3.6 24.56 3.49 24.1 3.47 z M 24 3.81 L 28.64 4.4 L 28.64 4.45 C 25.38 4.86 22.09 5.11 18.82 5.43 C 17.02 5.61 15.09 6.04 13.29 5.96 C 11.94 5.91 10.58 5.45 9.24 5.28 L 11 5.07 L 14.47 4.73 L 20.43 4.15 L 24 3.81 z M 29.81 4.66 C 30.27 4.6 30.4 5.04 30.58 5.38 L 31.94 7.77 C 33.59 10.65 35.22 13.54 36.87 16.42 C 37.28 17.14 37.68 17.85 38.09 18.57 C 38.23 18.82 38.53 19.16 38.44 19.45 C 38.08 20.64 37.3 21.8 36.7 22.91 C 36.81 22.72 37.11 22.12 37.17 22.01 C 37.92 20.66 38.41 19.59 38.42 19.34 C 38.42 19.26 37.44 17.49 36.25 15.39 C 35.05 13.29 33.25 10.12 32.24 8.34 C 31.23 6.56 30.33 5.01 30.25 4.9 C 30.09 4.7 30.09 4.7 29.53 4.74 C 29.21 4.76 27.7 4.9 26.18 5.06 C 20.21 5.68 14.85 6.2 14.45 6.2 C 13.59 6.2 13.38 6.35 13.01 7.25 C 12.8 7.75 7.21 18.82 6.15 20.84 C 5.71 21.68 5.34 22.44 5.31 22.53 C 5.26 22.72 5.21 22.64 6.54 24.95 C 9.13 29.48 13.01 36.31 13.15 36.6 C 13.24 36.77 13.39 37 13.5 37.11 C 13.6 37.22 13.75 37.3 13.85 37.3 C 14.67 37.3 18.19 36.97 22.1 36.52 C 24.39 36.26 27.16 35.98 29.13 35.81 C 29.64 35.77 30.08 35.7 30.17 35.64 C 30.25 35.59 30.43 35.31 30.55 35.03 C 30.68 34.75 30.96 34.17 31.18 33.74 C 31.4 33.32 32.66 30.82 33.98 28.19 C 34.91 26.35 35.55 25.13 36.2 23.88 C 34.95 26.38 33.66 28.87 32.41 31.37 C 31.9 32.4 31.37 33.43 30.85 34.45 C 30.68 34.78 30.5 35.46 30.19 35.68 C 29.89 35.87 29.32 35.8 28.98 35.85 C 27.86 35.99 26.73 36.06 25.61 36.17 C 21.7 36.56 17.76 37.13 13.83 37.33 C 13.41 37.35 13.26 36.82 13.08 36.51 C 12.58 35.61 12.07 34.71 11.56 33.82 C 9.96 31.04 8.39 28.25 6.8 25.46 L 5.66 23.46 C 5.53 23.23 5.25 22.9 5.26 22.63 C 5.28 22.28 5.62 21.81 5.78 21.5 C 7.64 17.9 9.46 14.28 11.28 10.65 C 11.79 9.64 12.31 8.63 12.81 7.62 C 12.99 7.27 13.19 6.59 13.5 6.35 C 13.79 6.13 14.51 6.18 14.86 6.16 C 15.87 6.08 16.88 5.95 17.89 5.86 C 21.86 5.46 25.84 5.1 29.81 4.66 z M 8.31 5.42 C 9.87 5.72 11.56 6.19 13.15 6.26 C 12.63 7.48 11.94 8.64 11.35 9.82 C 9.92 12.68 8.45 15.52 7.03 18.38 C 6.53 19.37 6.04 20.36 5.53 21.36 C 5.42 21.58 5.17 22.28 4.93 22.34 C 4.63 22.42 4.03 22.03 3.76 21.92 C 2.74 21.49 1.69 21.1 0.68 20.62 C 0.86 20.01 1.26 19.43 1.55 18.86 L 3.41 15.15 C 5.03 11.92 6.49 8.54 8.31 5.42 z M 22.72 11.01 C 24.59 11.08 26.31 11.82 27.66 13.16 C 28.35 13.86 28.83 14.55 29.31 15.52 C 29.93 16.76 30.23 17.91 30.32 19.24 C 29.98 14.97 26.99 10.97 22.38 11.03 C 17.11 11.1 13.21 15.84 12.72 20.84 C 12.76 19.97 12.88 19.42 13.17 18.51 C 14.4 14.67 17.32 11.87 20.83 11.17 C 21.47 11.04 22.11 10.99 22.72 11.01 z M 22.23 11.38 C 22.67 11.42 23 11.91 23.26 12.22 C 24.15 13.28 24.79 14.57 25.08 15.93 C 25.97 20.2 24.13 24.97 20.38 27.29 C 19.39 27.9 18.3 28.33 17.15 28.51 C 16.55 28.61 16.05 28.68 15.54 28.3 C 15.99 27.99 16.82 27.96 17.35 27.77 C 18.34 27.42 19.28 26.85 20.09 26.17 C 23.34 23.47 24.95 18.86 23.78 14.76 C 23.57 14.03 23.29 13.31 22.9 12.66 C 22.64 12.22 22.27 11.83 22.04 11.39 C 22.11 11.37 22.17 11.37 22.23 11.38 z M 22.92 11.39 C 23.42 11.45 23.9 11.98 24.24 12.32 C 25.25 13.32 26.01 14.56 26.4 15.93 C 27.68 20.42 25.72 25.58 21.7 28 C 20.59 28.67 19.41 29.04 18.13 29.19 C 17.54 29.27 16.88 29.31 16.37 28.98 L 16.37 28.93 C 17.63 28.77 18.82 28.5 19.94 27.89 C 24.18 25.6 26.44 20.4 25.36 15.74 C 25.09 14.64 24.63 13.57 23.97 12.66 C 23.65 12.21 23.24 11.83 22.92 11.39 z M 21.26 11.45 C 21.89 11.37 22.3 12.23 22.58 12.71 C 23.46 14.21 23.86 15.96 23.85 17.69 C 23.83 21.28 21.82 24.96 18.72 26.78 C 17.76 27.34 16.58 27.86 15.44 27.92 C 14.93 27.95 14.46 26.97 14.24 26.59 C 13.35 25.03 12.98 23.29 13 21.5 C 13.06 16.93 16.53 12.02 21.26 11.45 z M 24.19 11.78 C 25.09 12.38 25.91 13 26.56 13.88 C 28.92 17.05 28.72 21.67 26.74 24.97 C 24.89 28.06 21.12 30.67 17.4 29.62 L 17.4 29.57 C 23.86 29.52 28.13 22.44 26.87 16.52 C 26.62 15.32 26.1 14.18 25.39 13.2 C 25.16 12.87 24.91 12.55 24.63 12.27 C 24.49 12.12 24.24 11.97 24.19 11.78 z M 24.88 11.78 C 29.34 13.29 30.78 18.67 29.59 22.82 C 28.62 26.23 25.93 29.33 22.38 30.12 C 21.33 30.36 20.26 30.34 19.21 30.2 L 19.21 30.15 C 21.24 30.15 23.28 29.13 24.78 27.82 C 29.33 23.81 30.3 15.55 24.83 11.83 L 24.88 11.78 z M 30.35 19.83 C 30.35 19.88 30.36 19.93 30.36 19.99 C 30.36 20.06 30.34 20.13 30.34 20.2 C 30.35 20.08 30.35 19.95 30.35 19.83 z M 30.31 20.84 C 30.2 22.18 29.88 23.42 29.23 24.74 C 28.19 26.9 26.62 28.58 24.79 29.59 C 27.86 27.87 30 24.31 30.31 20.84 z M 0.93 21.06 C 1.81 21.47 2.72 21.82 3.62 22.19 C 4 22.35 4.55 22.47 4.87 22.75 C 5.22 23.06 5.44 23.69 5.68 24.09 L 7.35 27.03 L 11.21 33.82 C 11.79 34.83 12.65 35.94 13 37.04 C 12.01 36.52 11.04 35.95 10.07 35.4 C 9.58 35.11 8.93 34.87 8.51 34.49 C 8.27 34.25 8.12 33.87 7.95 33.57 L 6.9 31.72 C 5.73 29.66 4.54 27.63 3.4 25.56 C 2.82 24.49 2.2 23.44 1.6 22.38 C 1.4 22.03 0.93 21.46 0.93 21.06 z M 12.72 22.76 C 13.02 26 14.89 29.11 18.09 30.23 C 17.92 30.17 17.75 30.13 17.59 30.06 C 15.23 29.05 13.51 26.81 12.86 23.92 C 12.77 23.52 12.74 23.19 12.72 22.76 z M 24.7 29.63 C 24.44 29.78 24.17 29.91 23.89 30.03 C 24.17 29.91 24.44 29.78 24.7 29.63 z M 23.79 30.06 C 23.2 30.3 22.59 30.49 21.95 30.58 C 20.67 30.78 19.34 30.65 18.17 30.26 C 19.08 30.56 20.01 30.65 20.97 30.64 C 21.96 30.63 22.9 30.42 23.79 30.06 z',
        customStroke: '0.75px',
    },
    notification: {
        path: 'M 21.634 15.641 L 19.586 13.593 L 19.586 10.104 C 19.581 6.202 16.638 2.931 12.758 2.516 L 12.758 1 L 11.242 1 L 11.242 2.517 C 7.375 2.958 4.446 6.213 4.414 10.103 L 4.414 13.593 L 2.366 15.641 C 2.215 15.777 2.133 15.971 2.137 16.173 L 2.137 18.448 C 2.124 18.653 2.2 18.854 2.345 19 C 2.49 19.144 2.691 19.221 2.896 19.207 L 8.207 19.207 C 8.207 21.302 9.906 23 12 23 C 14.094 23 15.794 21.302 15.794 19.206 L 21.104 19.206 C 21.309 19.221 21.51 19.144 21.655 19 C 21.8 18.854 21.876 18.653 21.863 18.448 L 21.863 16.172 C 21.867 15.971 21.785 15.777 21.634 15.642 L 21.634 15.641 Z  M 12 21.483 C 10.742 21.483 9.724 20.464 9.724 19.206 L 14.276 19.206 C 14.276 20.464 13.257 21.483 12 21.483 Z  M 20.346 17.689 L 3.656 17.689 L 3.656 16.475 L 5.704 14.427 C 5.854 14.292 5.935 14.098 5.931 13.896 L 5.931 10.103 C 5.931 6.751 8.648 4.033 12 4.033 C 15.352 4.033 18.069 6.751 18.069 10.103 L 18.069 13.896 C 18.064 14.098 18.146 14.292 18.296 14.427 L 20.346 16.476 L 20.346 17.69 L 20.346 17.689 Z',
    },
    ordered_list: {
        path: 'M 11.154 17.077 L 23 17.077 L 23 18.769 L 11.154 18.769 L 11.154 17.077 Z  M 11.154 5.231 L 23 5.231 L 23 6.923 L 11.154 6.923 L 11.154 5.231 Z  M 4.385 8.615 L 4.385 1.846 L 2.692 1.846 L 2.692 2.692 L 1 2.692 L 1 4.385 L 2.692 4.385 L 2.692 8.615 L 1 8.615 L 1 10.308 L 2.692 10.308 L 4.385 10.308 L 6.077 10.308 L 6.077 8.615 L 4.385 8.615 L 4.385 8.615 Z  M 6.077 22.154 L 1 22.154 L 1 18.769 C 1 17.835 1.758 17.077 2.692 17.077 L 4.385 17.077 L 4.385 15.385 L 1 15.385 L 1 13.692 L 4.385 13.692 C 5.319 13.692 6.077 14.45 6.077 15.385 L 6.077 17.077 C 6.077 18.012 5.319 18.769 4.385 18.769 L 2.692 18.769 L 2.692 20.462 L 6.077 20.462 L 6.077 22.154 Z',
    },
    organisation: {
        path: 'M 19.333 10.533 L 17.867 10.533 L 17.867 12 L 19.333 12 C 20.548 12.001 21.532 12.986 21.533 14.2 L 21.533 17.133 L 23 17.133 L 23 14.2 C 22.998 12.176 21.357 10.536 19.333 10.533 L 19.333 10.533 Z  M 17.867 3.2 C 19.082 3.2 20.067 4.185 20.067 5.4 C 20.067 6.615 19.082 7.6 17.867 7.6 C 16.652 7.6 15.667 6.615 15.667 5.4 C 15.667 4.185 16.652 3.2 17.867 3.2 Z  M 17.867 1.733 C 15.842 1.733 14.2 3.375 14.2 5.4 C 14.2 7.425 15.842 9.067 17.867 9.067 C 19.892 9.067 21.533 7.425 21.533 5.4 C 21.533 3.375 19.892 1.733 17.867 1.733 Z  M 17.133 22.267 L 15.667 22.267 L 15.667 20.8 C 15.665 19.586 14.681 18.601 13.467 18.6 L 10.533 18.6 C 9.319 18.601 8.335 19.586 8.333 20.8 L 8.333 22.267 L 6.867 22.267 L 6.867 20.8 C 6.869 18.776 8.509 17.136 10.533 17.133 L 13.467 17.133 C 15.491 17.136 17.131 18.776 17.133 20.8 L 17.133 22.267 Z  M 12 9.8 C 13.215 9.8 14.2 10.785 14.2 12 C 14.2 13.215 13.215 14.2 12 14.2 C 10.785 14.2 9.8 13.215 9.8 12 C 9.8 10.785 10.785 9.8 12 9.8 Z  M 12 8.333 C 9.975 8.333 8.333 9.975 8.333 12 C 8.333 14.025 9.975 15.667 12 15.667 C 14.025 15.667 15.667 14.025 15.667 12 C 15.667 9.975 14.025 8.333 12 8.333 Z  M 6.133 10.533 L 4.667 10.533 C 2.643 10.536 1.002 12.176 1 14.2 L 1 17.133 L 2.467 17.133 L 2.467 14.2 C 2.468 12.986 3.452 12.001 4.667 12 L 6.133 12 L 6.133 10.533 Z  M 6.133 3.2 C 7.348 3.2 8.333 4.185 8.333 5.4 C 8.333 6.615 7.348 7.6 6.133 7.6 C 4.918 7.6 3.933 6.615 3.933 5.4 C 3.933 4.185 4.918 3.2 6.133 3.2 Z  M 6.133 1.733 C 4.108 1.733 2.467 3.375 2.467 5.4 C 2.467 7.425 4.108 9.067 6.133 9.067 C 8.158 9.067 9.8 7.425 9.8 5.4 C 9.8 3.375 8.158 1.733 6.133 1.733 Z',
    },
    overview: {
        path: 'M 5.125 22.542 C 4.367 22.542 3.75 21.924 3.75 21.167 L 3.75 10.815 L 1.783 12.782 C 1.696 12.869 1.581 12.916 1.458 12.916 C 1.336 12.916 1.221 12.869 1.134 12.783 C 0.955 12.604 0.955 12.313 1.134 12.135 L 11.676 1.593 C 11.763 1.506 11.878 1.458 12 1.458 C 12.122 1.458 12.237 1.506 12.324 1.592 L 22.866 12.134 C 23.045 12.313 23.045 12.603 22.866 12.782 C 22.78 12.868 22.664 12.916 22.542 12.916 C 22.419 12.916 22.304 12.868 22.217 12.782 L 20.25 10.815 L 20.25 21.167 C 20.25 21.924 19.633 22.542 18.875 22.542 L 5.125 22.542 Z  M 18.875 21.625 C 19.128 21.625 19.333 21.42 19.333 21.167 L 19.333 9.898 L 12 2.565 L 4.667 9.898 L 4.667 21.167 C 4.667 21.42 4.872 21.625 5.125 21.625 L 18.875 21.625 Z',
        customStroke: '0.5px',
    },
    pen: {
        path: 'M 22.4 8 C 23.2 7.2 23.2 6 22.4 5.2 C 22.4 5.2 22.4 5.2 22.4 5.2 L 18.8 1.6 C 18 0.8 16.8 0.8 16 1.6 C 16 1.6 16 1.6 16 1.6 L 1 16.6 L 1 23 L 7.4 23 L 22.4 8 Z  M 17.4 3 L 21 6.6 L 18 9.6 L 14.4 6 L 17.4 3 Z  M 3 21 L 3 17.4 L 13 7.4 L 16.6 11 L 6.6 21 L 3 21 Z',
    },
    photo: {
        path: 'M 37.642 34.929 L 2.358 34.929 C 1.608 34.929 1 34.321 1 33.571 L 1 10.5 C 1 9.75 1.608 9.142 2.358 9.142 L 11.124 9.142 L 13.445 5.683 C 13.695 5.303 14.117 5.075 14.571 5.071 L 25.429 5.071 C 25.883 5.075 26.305 5.303 26.555 5.683 L 28.876 9.142 L 37.642 9.142 C 38.392 9.142 39 9.75 39 10.5 L 39 33.571 C 39 34.321 38.392 34.929 37.642 34.929 Z  M 3.714 32.214 L 36.286 32.214 L 36.286 11.858 L 28.142 11.858 C 27.688 11.854 27.267 11.626 27.016 11.246 L 24.696 7.786 L 15.304 7.786 L 12.984 11.246 C 12.733 11.626 12.312 11.854 11.858 11.858 L 3.714 11.858 L 3.714 32.214 Z  M 20 29.5 C 15.502 29.5 11.858 25.854 11.858 21.358 C 11.858 16.86 15.502 13.214 20 13.214 C 24.498 13.214 28.142 16.86 28.142 21.358 C 28.142 25.854 24.498 29.5 20 29.5 Z  M 20 15.929 C 17.001 15.929 14.571 18.359 14.571 21.358 C 14.571 24.354 17.001 26.786 20 26.786 C 22.999 26.786 25.429 24.354 25.429 21.358 C 25.429 18.359 22.999 15.929 20 15.929 Z',
        customStroke: '0.5px',
    },
    pinned: {
        path: 'M 12 6.762 C 10.409 6.762 9.119 8.052 9.119 9.643 C 9.119 11.234 10.409 12.524 12 12.524 C 13.591 12.524 14.881 11.234 14.881 9.643 C 14.879 8.053 13.59 6.764 12 6.762 L 12 6.762 L 12 6.762 Z  M 12 14.445 C 9.348 14.445 7.198 12.295 7.198 9.643 C 7.198 6.991 9.348 4.841 12 4.841 C 14.652 4.841 16.802 6.991 16.802 9.643 C 16.799 12.294 14.651 14.442 12 14.445 L 12 14.445 L 12 14.445 Z  M 5.097 14.824 C 5.098 14.825 5.322 15.12 5.373 15.184 L 12 23 L 18.636 15.173 C 18.678 15.12 18.903 14.823 18.904 14.822 C 20.034 13.332 20.646 11.513 20.643 9.643 C 20.643 4.87 16.774 1 12 1 C 7.226 1 3.357 4.87 3.357 9.643 C 3.355 11.514 3.966 13.334 5.097 14.824 L 5.097 14.824 L 5.097 14.824 Z',
    },
    play: {
        path: 'M 3.29 23 C 2.784 23 2.373 22.59 2.373 22.083 L 2.373 1.92 C 2.372 1.591 2.547 1.287 2.832 1.123 C 3.115 0.959 3.465 0.959 3.748 1.123 L 21.162 11.204 C 21.449 11.367 21.627 11.672 21.627 12.002 C 21.627 12.332 21.449 12.636 21.162 12.799 L 3.748 22.881 C 3.609 22.96 3.45 23.001 3.29 23 Z  M 4.206 3.506 L 4.206 20.498 L 18.871 12.002 L 4.206 3.506 Z',
    },
    product: {
        path: 'M 1.355 10.58 L 3.323 10.58 C 3.44 11.001 3.608 11.404 3.823 11.783 L 2.43 13.176 C 2.363 13.242 2.326 13.332 2.326 13.427 C 2.326 13.521 2.363 13.611 2.43 13.678 L 3.935 15.184 C 4.074 15.322 4.298 15.322 4.437 15.184 L 5.83 13.79 C 6.209 14.005 6.612 14.173 7.032 14.29 L 7.032 16.258 C 7.032 16.454 7.191 16.613 7.387 16.613 L 9.516 16.613 C 9.712 16.613 9.871 16.454 9.871 16.258 L 9.871 14.29 C 10.291 14.173 10.694 14.005 11.073 13.79 L 12.466 15.184 C 12.607 15.316 12.827 15.316 12.968 15.184 L 14.474 13.678 C 14.54 13.611 14.577 13.521 14.577 13.427 C 14.577 13.332 14.54 13.242 14.474 13.176 L 13.08 11.783 C 13.296 11.404 13.464 11.001 13.58 10.58 L 15.548 10.58 C 15.745 10.58 15.903 10.422 15.903 10.226 L 15.903 8.097 C 15.903 7.901 15.745 7.742 15.548 7.742 L 13.58 7.742 C 13.464 7.322 13.296 6.919 13.08 6.54 L 14.473 5.147 C 14.54 5.08 14.577 4.99 14.577 4.896 C 14.577 4.802 14.54 4.712 14.473 4.645 L 12.968 3.139 C 12.83 3.001 12.605 3.001 12.466 3.139 L 11.073 4.533 C 10.694 4.317 10.291 4.149 9.871 4.033 L 9.871 2.065 C 9.871 1.868 9.712 1.71 9.516 1.71 L 7.387 1.71 C 7.191 1.71 7.032 1.868 7.032 2.065 L 7.032 4.033 C 6.612 4.149 6.209 4.317 5.83 4.533 L 4.437 3.139 C 4.296 3.006 4.076 3.006 3.935 3.139 L 2.429 4.645 C 2.363 4.712 2.326 4.802 2.326 4.896 C 2.326 4.99 2.363 5.08 2.429 5.147 L 3.823 6.54 C 3.608 6.919 3.44 7.322 3.323 7.742 L 1.355 7.742 C 1.159 7.742 1 7.901 1 8.097 L 1 10.226 C 1 10.422 1.159 10.58 1.355 10.58 L 1.355 10.58 Z  M 1.71 8.452 L 3.601 8.452 C 3.768 8.452 3.912 8.336 3.947 8.173 C 4.064 7.641 4.275 7.135 4.569 6.677 C 4.66 6.537 4.639 6.353 4.521 6.235 L 3.182 4.896 L 4.186 3.892 L 5.525 5.231 C 5.643 5.349 5.827 5.369 5.968 5.279 C 6.425 4.984 6.932 4.774 7.463 4.657 C 7.626 4.622 7.742 4.477 7.742 4.31 L 7.742 2.42 L 9.161 2.42 L 9.161 4.31 C 9.161 4.477 9.277 4.622 9.44 4.657 C 9.971 4.774 10.478 4.984 10.935 5.279 C 11.076 5.369 11.26 5.349 11.378 5.231 L 12.717 3.892 L 13.721 4.896 L 12.382 6.235 C 12.263 6.353 12.244 6.537 12.334 6.677 C 12.629 7.135 12.839 7.642 12.955 8.173 C 12.991 8.336 13.135 8.452 13.302 8.452 L 15.193 8.452 L 15.193 9.871 L 13.302 9.871 C 13.135 9.871 12.991 9.988 12.955 10.15 C 12.839 10.682 12.629 11.188 12.334 11.645 C 12.244 11.786 12.264 11.97 12.382 12.088 L 13.721 13.427 L 12.717 14.431 L 11.378 13.091 C 11.26 12.973 11.076 12.954 10.935 13.044 C 10.478 13.339 9.972 13.549 9.44 13.665 C 9.278 13.701 9.161 13.845 9.161 14.012 L 9.161 15.903 L 7.742 15.903 L 7.742 14.012 C 7.742 13.845 7.625 13.701 7.463 13.665 C 6.931 13.549 6.425 13.339 5.968 13.044 C 5.827 12.954 5.643 12.973 5.525 13.091 L 4.186 14.431 L 3.183 13.427 L 4.521 12.088 C 4.64 11.97 4.66 11.786 4.569 11.645 C 4.275 11.188 4.064 10.681 3.947 10.15 C 3.912 9.986 3.768 9.871 3.601 9.871 L 1.71 9.871 L 1.71 8.452 Z  M 8.452 12 C 10.019 12 11.29 10.729 11.29 9.161 C 11.29 7.594 10.019 6.323 8.452 6.323 C 6.884 6.323 5.613 7.594 5.613 9.161 C 5.615 10.728 6.884 11.998 8.452 12 Z  M 8.452 7.032 C 9.627 7.032 10.58 7.986 10.58 9.161 C 10.58 10.337 9.627 11.29 8.452 11.29 C 7.276 11.29 6.323 10.337 6.323 9.161 C 6.324 7.986 7.276 7.034 8.452 7.032 Z  M 8.452 13.065 C 10.607 13.065 12.355 11.317 12.355 9.161 C 12.355 7.005 10.607 5.258 8.452 5.258 C 6.296 5.258 4.548 7.005 4.548 9.161 C 4.551 11.316 6.297 13.062 8.452 13.065 Z  M 8.452 5.968 C 10.216 5.968 11.645 7.397 11.645 9.161 C 11.645 10.925 10.216 12.355 8.452 12.355 C 6.688 12.355 5.258 10.925 5.258 9.161 C 5.26 7.399 6.689 5.97 8.452 5.968 Z  M 21.226 18.032 L 21.226 15.193 C 21.226 14.998 21.067 14.839 20.871 14.839 L 20.161 14.839 L 20.161 12 C 20.161 11.804 20.002 11.645 19.807 11.645 L 16.613 11.645 C 16.417 11.645 16.258 11.804 16.258 12 L 16.258 14.839 L 14.484 14.839 C 14.288 14.839 14.129 14.998 14.129 15.193 L 14.129 18.032 L 2.774 18.032 C 1.795 18.034 1.001 18.827 1 19.807 L 1 20.516 C 1.001 21.496 1.795 22.289 2.774 22.29 L 21.226 22.29 C 22.205 22.289 22.999 21.496 23 20.516 L 23 19.807 C 22.999 18.827 22.205 18.034 21.226 18.032 L 21.226 18.032 Z  M 20.516 18.032 L 18.032 18.032 L 18.032 15.548 L 20.516 15.548 L 20.516 18.032 Z  M 16.968 12.355 L 19.452 12.355 L 19.452 14.839 L 16.968 14.839 L 16.968 12.355 Z  M 14.839 15.548 L 17.323 15.548 L 17.323 18.032 L 14.839 18.032 L 14.839 15.548 Z  M 22.29 20.516 C 22.29 21.104 21.814 21.58 21.226 21.58 L 2.774 21.58 C 2.186 21.58 1.71 21.104 1.71 20.516 L 1.71 19.807 C 1.71 19.219 2.186 18.742 2.774 18.742 L 21.226 18.742 C 21.814 18.742 22.29 19.219 22.29 19.807 L 22.29 20.516 Z  M 12 19.097 C 11.412 19.097 10.935 19.573 10.935 20.161 C 10.935 20.749 11.412 21.226 12 21.226 C 12.588 21.226 13.065 20.749 13.065 20.161 C 13.065 19.573 12.588 19.097 12 19.097 L 12 19.097 Z  M 12 20.516 C 11.804 20.516 11.645 20.357 11.645 20.161 C 11.645 19.965 11.804 19.807 12 19.807 C 12.196 19.807 12.355 19.965 12.355 20.161 C 12.355 20.357 12.196 20.516 12 20.516 Z  M 8.452 19.097 C 7.864 19.097 7.387 19.573 7.387 20.161 C 7.387 20.749 7.864 21.226 8.452 21.226 C 9.039 21.226 9.516 20.749 9.516 20.161 C 9.516 19.573 9.039 19.097 8.452 19.097 L 8.452 19.097 Z  M 8.452 20.516 C 8.255 20.516 8.097 20.357 8.097 20.161 C 8.097 19.965 8.255 19.807 8.452 19.807 C 8.648 19.807 8.807 19.965 8.807 20.161 C 8.807 20.357 8.648 20.516 8.452 20.516 Z  M 15.548 19.097 C 14.961 19.097 14.484 19.573 14.484 20.161 C 14.484 20.749 14.961 21.226 15.548 21.226 C 16.136 21.226 16.613 20.749 16.613 20.161 C 16.613 19.573 16.136 19.097 15.548 19.097 L 15.548 19.097 Z  M 15.548 20.516 C 15.352 20.516 15.193 20.357 15.193 20.161 C 15.193 19.965 15.352 19.807 15.548 19.807 C 15.745 19.807 15.903 19.965 15.903 20.161 C 15.903 20.357 15.745 20.516 15.548 20.516 Z  M 4.903 19.097 C 4.316 19.097 3.839 19.573 3.839 20.161 C 3.839 20.749 4.316 21.226 4.903 21.226 C 5.491 21.226 5.968 20.749 5.968 20.161 C 5.968 19.573 5.491 19.097 4.903 19.097 L 4.903 19.097 Z  M 4.903 20.516 C 4.707 20.516 4.548 20.357 4.548 20.161 C 4.548 19.965 4.707 19.807 4.903 19.807 C 5.099 19.807 5.258 19.965 5.258 20.161 C 5.258 20.357 5.099 20.516 4.903 20.516 Z  M 19.097 19.097 C 18.509 19.097 18.032 19.573 18.032 20.161 C 18.032 20.749 18.509 21.226 19.097 21.226 C 19.684 21.226 20.161 20.749 20.161 20.161 C 20.161 19.573 19.684 19.097 19.097 19.097 L 19.097 19.097 Z  M 19.097 20.516 C 18.901 20.516 18.742 20.357 18.742 20.161 C 18.742 19.965 18.901 19.807 19.097 19.807 C 19.293 19.807 19.452 19.965 19.452 20.161 C 19.452 20.357 19.293 20.516 19.097 20.516 Z',
        customStroke: '0.5px',
    },
    remove: {
        path: 'M 1.792 20.792 C 1.355 20.792 1 20.437 1 20 C 1 19.563 1.355 19.208 1.792 19.208 L 38.208 19.208 C 38.645 19.208 39 19.563 39 20 C 39 20.437 38.645 20.792 38.208 20.792 L 1.792 20.792 L 1.792 20.792 Z',
    },
    reset: {
        path: 'M 17.516 19.052 L 17.516 17.489 L 17.91 17.489 C 19.869 17.567 21.52 16.055 21.598 14.112 C 21.676 12.169 20.152 10.532 18.194 10.454 L 17.516 10.454 L 17.437 9.813 C 17.076 7.091 14.736 5.056 11.968 5.056 C 9.201 5.056 6.861 7.091 6.5 9.813 L 6.484 10.454 L 5.806 10.454 C 3.848 10.532 2.324 12.169 2.402 14.112 C 2.48 16.055 4.131 17.567 6.09 17.489 L 6.484 17.489 L 6.484 19.052 L 6.09 19.052 C 3.473 19.036 1.289 17.065 1.026 14.483 C 0.763 11.9 2.505 9.535 5.066 9 C 5.767 5.756 8.656 3.44 12 3.44 C 15.344 3.44 18.233 5.756 18.934 9 C 21.495 9.535 23.237 11.9 22.974 14.483 C 22.711 17.065 20.527 19.036 17.91 19.052 L 17.516 19.052 Z  M 12 10.536 C 9.208 10.536 6.988 12.756 6.988 15.548 C 6.988 18.341 9.208 20.56 12 20.56 C 14.792 20.56 17.012 18.341 17.012 15.548 C 17.012 12.756 14.792 10.536 12 10.536 Z  M 12 19.749 C 9.69 19.749 7.799 17.859 7.799 15.548 C 7.799 13.238 9.69 11.348 12 11.348 C 14.31 11.348 16.201 13.238 16.201 15.548 C 16.201 17.859 14.31 19.749 12 19.749 Z  M 13.933 18.054 L 12 16.121 L 10.067 18.054 L 9.494 17.482 L 11.427 15.548 L 9.494 13.615 L 10.067 13.042 L 12 14.976 L 13.933 13.042 L 14.506 13.615 L 12.573 15.548 L 14.506 17.482 L 13.933 18.054 Z',
    },
    robotics: {
        path: 'M 13.571 7.286 L 15.143 7.286 L 15.143 8.857 L 13.571 8.857 L 13.571 7.286 Z  M 8.857 7.286 L 10.429 7.286 L 10.429 8.857 L 8.857 8.857 L 8.857 7.286 Z  M 19.857 15.143 L 15.929 15.143 L 15.929 13.571 L 16.714 13.571 C 17.582 13.57 18.285 12.867 18.286 12 L 18.286 8.857 L 19.857 8.857 L 19.857 7.286 L 18.286 7.286 L 18.286 5.714 C 18.285 4.847 17.582 4.144 16.714 4.143 L 15.143 4.143 L 15.143 1 L 13.571 1 L 13.571 4.143 L 10.429 4.143 L 10.429 1 L 8.857 1 L 8.857 4.143 L 7.286 4.143 C 6.418 4.144 5.715 4.847 5.714 5.714 L 5.714 7.286 L 4.143 7.286 L 4.143 8.857 L 5.714 8.857 L 5.714 12 C 5.715 12.867 6.418 13.57 7.286 13.571 L 8.071 13.571 L 8.071 15.143 L 4.143 15.143 C 3.275 15.144 2.572 15.847 2.571 16.714 L 2.571 23 L 4.143 23 L 4.143 16.714 L 19.857 16.714 L 19.857 23 L 21.429 23 L 21.429 16.714 C 21.428 15.847 20.725 15.144 19.857 15.143 L 19.857 15.143 Z  M 7.286 5.714 L 16.714 5.714 L 16.714 12 L 7.286 12 L 7.286 5.714 Z  M 9.643 13.571 L 14.357 13.571 L 14.357 15.143 L 9.643 15.143 L 9.643 13.571 Z',
    },
    rotate: {
        path: 'M 18.464 19.476 C 18.581 19.476 18.693 19.522 18.776 19.605 C 18.842 19.671 18.885 19.756 18.9 19.847 L 18.905 19.916 L 18.905 21.679 C 18.905 21.922 18.707 22.119 18.464 22.119 C 18.249 22.119 18.068 21.964 18.031 21.757 L 18.024 21.679 L 18.024 21.005 C 13.972 23.928 8.426 23.61 4.736 20.242 C 4.556 20.079 4.543 19.8 4.707 19.62 C 4.871 19.44 5.15 19.427 5.329 19.591 C 8.615 22.588 13.507 22.953 17.195 20.51 L 17.419 20.357 L 16.262 20.357 C 16.018 20.357 15.821 20.16 15.821 19.917 C 15.821 19.7 15.977 19.52 16.183 19.483 L 16.262 19.476 L 18.464 19.476 Z  M 12.005 3.566 C 12.207 3.566 12.406 3.603 12.602 3.676 C 12.76 3.702 12.916 3.781 13.073 3.859 L 18.335 6.922 C 18.99 7.289 19.408 7.995 19.408 8.754 L 19.408 14.854 C 19.408 15.01 19.382 15.194 19.357 15.35 C 19.313 15.633 19.263 15.828 19.202 15.937 C 19.135 16.056 18.995 16.2 18.78 16.372 C 18.675 16.503 18.544 16.607 18.388 16.686 L 13.1 19.723 C 12.76 19.905 12.393 20.011 12.026 20.011 C 11.66 20.011 11.294 19.905 10.953 19.723 L 5.665 16.686 L 5.272 16.372 C 5.016 16.185 4.856 16.04 4.792 15.937 C 4.716 15.813 4.667 15.618 4.644 15.351 C 4.619 15.194 4.593 15.037 4.593 14.854 L 4.593 8.754 C 4.593 7.995 5.01 7.289 5.665 6.922 L 10.927 3.859 C 11.084 3.781 11.241 3.728 11.398 3.676 C 11.6 3.603 11.803 3.566 12.005 3.566 Z  M 5.796 8.911 L 5.796 14.854 C 5.796 15.194 5.979 15.508 6.267 15.665 L 11.398 18.623 L 11.398 12.157 L 5.796 8.911 Z  M 18.204 8.911 L 12.602 12.158 L 12.602 18.623 L 17.733 15.665 C 18.021 15.481 18.204 15.194 18.204 14.854 L 18.204 8.911 Z  M 12 4.776 C 11.843 4.776 11.66 4.827 11.529 4.906 L 6.398 7.864 L 12 11.111 L 17.602 7.864 L 12.471 4.906 C 12.314 4.827 12.157 4.776 12 4.776 Z  M 18.761 3.758 C 18.878 3.864 18.929 4.025 18.895 4.178 C 18.861 4.332 18.749 4.456 18.598 4.503 C 18.448 4.552 18.284 4.515 18.167 4.409 C 14.883 1.412 9.99 1.046 6.302 3.49 L 6.078 3.643 L 7.235 3.643 C 7.479 3.643 7.676 3.841 7.676 4.084 C 7.676 4.299 7.52 4.48 7.314 4.517 L 7.235 4.524 L 5.033 4.524 C 4.817 4.524 4.637 4.369 4.599 4.162 L 4.592 4.085 L 4.592 2.322 C 4.592 2.078 4.79 1.881 5.033 1.881 C 5.248 1.881 5.429 2.037 5.466 2.243 L 5.473 2.322 L 5.473 2.995 C 9.525 0.072 15.071 0.39 18.761 3.758 Z',
    },
    search: {
        path: 'M 23 21.852 L 16.853 15.672 C 19.905 11.988 19.524 6.556 15.987 3.335 C 12.45 0.113 7.006 0.24 3.623 3.623 C 0.24 7.006 0.113 12.45 3.335 15.987 C 6.556 19.524 11.988 19.905 15.672 16.853 L 21.852 23 L 23 21.852 Z  M 2.644 9.972 C 2.644 5.925 5.925 2.644 9.972 2.644 C 14.019 2.644 17.3 5.925 17.3 9.972 C 17.3 14.019 14.019 17.3 9.972 17.3 C 5.925 17.3 2.644 14.019 2.644 9.972 Z',
    },
    services: {
        path: 'M 8.956 1 C 7.453 0.995 5.981 1.431 4.723 2.254 L 9.739 7.27 C 10.077 7.558 10.284 7.97 10.313 8.413 C 10.343 8.855 10.192 9.291 9.896 9.621 C 9.566 9.917 9.13 10.068 8.687 10.038 C 8.245 10.009 7.833 9.802 7.545 9.464 L 2.372 4.449 C 1.478 5.765 1.012 7.325 1.04 8.916 C 1.057 13.28 4.591 16.814 8.956 16.832 C 9.642 16.835 10.326 16.756 10.993 16.596 L 16.244 21.848 C 17.781 23.384 20.272 23.384 21.809 21.848 C 23.346 20.311 23.346 17.82 21.809 16.283 L 16.558 11.032 C 16.718 10.365 16.797 9.68 16.793 8.994 C 16.835 6.889 16.028 4.855 14.554 3.351 C 13.079 1.847 11.062 1 8.956 1 L 8.956 1 Z  M 15.225 8.916 C 15.224 9.473 15.145 10.027 14.99 10.562 L 14.755 11.424 L 15.382 12.051 L 20.633 17.302 C 21.085 17.73 21.341 18.325 21.339 18.948 C 21.357 19.573 21.099 20.175 20.633 20.594 C 20.204 21.044 19.609 21.299 18.987 21.299 C 18.365 21.299 17.771 21.044 17.342 20.594 L 12.091 15.342 L 11.464 14.716 L 10.601 14.951 C 10.066 15.105 9.512 15.185 8.956 15.186 C 7.29 15.181 5.69 14.536 4.488 13.383 C 3.259 12.226 2.576 10.604 2.607 8.916 C 2.608 8.333 2.687 7.753 2.842 7.192 L 6.291 10.64 C 6.879 11.281 7.701 11.658 8.57 11.687 C 9.439 11.717 10.284 11.396 10.915 10.797 C 11.514 10.166 11.835 9.321 11.806 8.452 C 11.776 7.583 11.399 6.761 10.758 6.173 L 7.31 2.724 C 7.817 2.564 8.346 2.485 8.877 2.489 C 10.543 2.494 12.142 3.139 13.345 4.292 C 14.548 5.531 15.222 7.189 15.225 8.916 Z',
    },
    settings: {
        path: 'M 20.663 12.599 C 20.663 12.402 20.663 12.205 20.663 12 C 20.663 11.795 20.663 11.598 20.663 11.393 L 22.176 10.07 C 22.752 9.562 22.878 8.714 22.476 8.06 L 20.616 4.908 C 20.335 4.421 19.815 4.121 19.253 4.121 C 19.082 4.119 18.911 4.146 18.749 4.199 L 16.834 4.845 C 16.503 4.626 16.158 4.428 15.802 4.255 L 15.4 2.269 C 15.251 1.52 14.587 0.986 13.824 1 L 10.136 1 C 9.373 0.986 8.709 1.52 8.56 2.269 L 8.159 4.255 C 7.799 4.428 7.452 4.626 7.119 4.845 L 5.243 4.168 C 5.079 4.125 4.908 4.109 4.739 4.121 C 4.177 4.121 3.657 4.421 3.376 4.908 L 1.516 8.06 C 1.137 8.712 1.272 9.541 1.839 10.038 L 3.329 11.401 C 3.329 11.598 3.329 11.795 3.329 12 C 3.329 12.205 3.329 12.402 3.329 12.607 L 1.839 13.93 C 1.256 14.432 1.119 15.281 1.516 15.94 L 3.376 19.092 C 3.657 19.579 4.177 19.879 4.739 19.879 C 4.91 19.881 5.081 19.854 5.243 19.801 L 7.158 19.155 C 7.489 19.374 7.833 19.572 8.19 19.745 L 8.592 21.731 C 8.741 22.48 9.405 23.014 10.168 23 L 13.887 23 C 14.65 23.014 15.314 22.48 15.463 21.731 L 15.865 19.745 C 16.224 19.572 16.572 19.374 16.905 19.155 L 18.812 19.801 C 18.974 19.854 19.145 19.881 19.316 19.879 C 19.878 19.879 20.398 19.579 20.679 19.092 L 22.476 15.94 C 22.855 15.288 22.719 14.459 22.153 13.962 L 20.663 12.599 Z  M 19.253 18.304 L 16.55 17.39 C 15.918 17.925 15.194 18.344 14.415 18.627 L 13.855 21.455 L 10.136 21.455 L 9.577 18.658 C 8.803 18.368 8.084 17.95 7.449 17.421 L 4.739 18.304 L 2.879 15.152 L 5.023 13.261 C 4.877 12.445 4.877 11.61 5.023 10.794 L 2.879 8.848 L 4.739 5.696 L 7.442 6.61 C 8.074 6.075 8.797 5.656 9.577 5.373 L 10.136 2.545 L 13.855 2.545 L 14.415 5.342 C 15.188 5.632 15.907 6.05 16.542 6.579 L 19.253 5.696 L 21.112 8.848 L 18.969 10.739 C 19.115 11.555 19.115 12.39 18.969 13.206 L 21.112 15.152 L 19.253 18.304 Z  M 11.996 16.728 C 9.385 16.728 7.268 14.611 7.268 12 C 7.268 9.389 9.385 7.272 11.996 7.272 C 14.607 7.272 16.724 9.389 16.724 12 C 16.736 13.258 16.242 14.468 15.353 15.357 C 14.464 16.246 13.254 16.74 11.996 16.728 Z  M 11.996 8.848 C 11.154 8.829 10.341 9.154 9.746 9.75 C 9.15 10.345 8.825 11.158 8.844 12 C 8.825 12.842 9.15 13.655 9.746 14.25 C 10.341 14.846 11.154 15.171 11.996 15.152 C 12.838 15.171 13.651 14.846 14.246 14.25 C 14.842 13.655 15.167 12.842 15.148 12 C 15.167 11.158 14.842 10.345 14.246 9.75 C 13.651 9.154 12.838 8.829 11.996 8.848 L 11.996 8.848 Z',
    },
    sort: {
        path: 'M 12 23 L 5.583 16.583 L 6.876 15.291 L 12 20.406 L 17.124 15.291 L 18.417 16.583 L 12 23 L 12 23 Z  M 12 1 L 18.417 7.417 L 17.124 8.709 L 12 3.594 L 6.876 8.709 L 5.583 7.417 L 12 1 L 12 1 Z',
    },
    slack: {
        path: 'M 9.104 12.597 C 7.828 12.597 6.793 13.633 6.793 14.909 L 6.793 20.689 C 6.793 21.965 7.828 23 9.104 23 C 10.38 23 11.415 21.965 11.415 20.689 L 11.415 14.909 C 11.414 13.633 10.379 12.597 9.104 12.597 Z  M 1.016 14.909 C 1.016 16.185 2.051 17.221 3.328 17.221 C 4.605 17.221 5.641 16.185 5.641 14.909 L 5.641 12.596 L 3.33 12.596 C 3.329 12.596 3.329 12.596 3.328 12.596 C 2.051 12.596 1.016 13.631 1.016 14.909 Z  M 9.107 1 C 9.106 1 9.105 1 9.104 1 C 7.827 1 6.791 2.036 6.791 3.312 C 6.791 4.589 7.827 5.625 9.104 5.625 L 11.415 5.625 C 11.415 4.313 11.415 4.632 11.415 3.308 C 11.414 2.033 10.381 1 9.107 1 Z  M 3.312 11.423 L 9.104 11.423 C 10.381 11.423 11.417 10.388 11.417 9.11 C 11.417 7.833 10.381 6.798 9.104 6.798 L 3.312 6.798 C 2.036 6.798 1 7.833 1 9.11 C 1 10.388 2.036 11.423 3.312 11.423 Z  M 20.667 6.797 C 19.392 6.797 18.359 7.83 18.359 9.105 L 18.359 9.109 L 18.359 11.422 L 20.67 11.422 C 21.946 11.422 22.983 10.386 22.983 9.109 C 22.983 7.833 21.946 6.797 20.67 6.797 C 20.669 6.797 20.668 6.797 20.667 6.797 Z  M 12.585 3.312 L 12.585 9.11 C 12.585 10.386 13.62 11.422 14.896 11.422 C 16.172 11.422 17.208 10.386 17.208 9.11 L 17.208 3.312 C 17.208 2.036 16.172 1.002 14.896 1.002 C 13.62 1.002 12.585 2.036 12.585 3.312 Z  M 17.206 20.687 C 17.206 19.411 16.171 18.376 14.895 18.376 L 12.585 18.376 L 12.585 20.689 C 12.585 21.964 13.619 22.998 14.895 22.998 C 16.171 22.998 17.206 21.963 17.206 20.687 Z  M 20.687 12.596 L 14.895 12.596 C 13.619 12.596 12.583 13.631 12.583 14.909 C 12.583 16.185 13.619 17.221 14.895 17.221 L 20.687 17.221 C 21.964 17.221 23 16.185 23 14.909 C 23 13.631 21.964 12.596 20.687 12.596 Z',
    },
    success: {
        path: 'M 10.429 16.254 L 6.5 12.325 L 7.61 11.214 L 10.429 14.032 L 16.388 8.071 L 17.5 9.183 L 10.429 16.254 L 10.429 16.254 Z  M 12 1 C 5.925 1 1 5.925 1 12 C 1 18.075 5.925 23 12 23 C 18.075 23 23 18.075 23 12 C 23 5.925 18.075 1 12 1 Z  M 12 21.429 C 6.793 21.429 2.571 17.207 2.571 12 C 2.571 6.793 6.793 2.571 12 2.571 C 17.207 2.571 21.429 6.793 21.429 12 C 21.429 17.207 17.207 21.429 12 21.429 Z',
    },
    story: {
        path: 'M 14.357 7.286 L 19.857 7.286 L 19.857 8.857 L 14.357 8.857 L 14.357 7.286 Z  M 14.357 11.214 L 19.857 11.214 L 19.857 12.786 L 14.357 12.786 L 14.357 11.214 Z  M 14.357 15.143 L 19.857 15.143 L 19.857 16.714 L 14.357 16.714 L 14.357 15.143 Z  M 21.429 3.357 L 2.571 3.357 C 1.704 3.358 1.001 4.061 1 4.929 L 1 19.071 C 1.001 19.939 1.704 20.642 2.571 20.643 L 21.429 20.643 C 22.296 20.642 22.999 19.939 23 19.071 L 23 4.929 C 22.999 4.061 22.296 3.358 21.429 3.357 L 21.429 3.357 Z  M 2.571 4.929 L 11.214 4.929 L 11.214 19.071 L 2.571 19.071 L 2.571 4.929 Z  M 12.786 19.071 L 12.786 4.929 L 21.429 4.929 L 21.43 19.071 L 12.786 19.071 Z',
    },
    time: {
        path: 'M 12 23 C 5.925 23 1 18.075 1 12 C 1 5.925 5.925 1 12 1 C 18.075 1 23 5.925 23 12 C 23 18.075 18.075 23 12 23 Z  M 12 2.571 C 6.793 2.571 2.571 6.793 2.571 12 C 2.571 17.207 6.793 21.429 12 21.429 C 17.207 21.429 21.429 17.207 21.429 12 C 21.429 6.793 17.207 2.571 12 2.571 Z  M 15.606 16.714 L 11.214 12.322 L 11.214 4.929 L 12.786 4.929 L 12.786 11.67 L 16.714 15.606 L 15.606 16.714 L 15.606 16.714 Z',
    },
    time_travel: {
        path: 'M 13.363 12.906 C 13.112 12.906 12.909 12.703 12.909 12.453 L 12.909 7.455 C 12.909 7.204 13.112 7.001 13.363 7.001 C 13.614 7.001 13.817 7.204 13.817 7.455 L 13.817 11.998 L 17.907 11.998 C 18.158 11.998 18.361 12.202 18.361 12.453 C 18.361 12.703 18.158 12.906 17.907 12.906 L 13.363 12.906 Z  M 13.363 21.087 C 13.112 21.087 12.909 20.884 12.909 20.633 C 12.909 20.382 13.112 20.178 13.363 20.178 C 17.873 20.178 21.542 16.51 21.542 12 C 21.542 7.49 17.873 3.822 13.363 3.822 C 8.853 3.822 5.184 7.49 5.184 12 L 5.184 12.146 L 7.569 9.422 C 7.655 9.323 7.78 9.267 7.911 9.267 C 8.021 9.267 8.127 9.307 8.21 9.379 C 8.399 9.544 8.418 9.831 8.252 10.019 L 5.072 13.654 C 5.063 13.664 5.055 13.673 5.044 13.681 C 4.955 13.767 4.844 13.812 4.73 13.812 C 4.717 13.812 4.702 13.811 4.687 13.807 C 4.678 13.806 4.671 13.805 4.661 13.803 C 4.606 13.794 4.559 13.778 4.515 13.754 C 4.506 13.75 4.488 13.736 4.479 13.731 C 4.444 13.708 4.411 13.678 4.384 13.645 C 4.372 13.633 4.361 13.619 4.352 13.607 L 1.626 9.517 C 1.559 9.417 1.535 9.297 1.559 9.177 C 1.583 9.058 1.651 8.956 1.752 8.889 C 1.826 8.839 1.914 8.813 2.003 8.813 C 2.156 8.813 2.297 8.888 2.381 9.015 L 4.276 11.857 C 4.353 6.913 8.4 2.913 13.363 2.913 C 18.373 2.913 22.45 6.989 22.45 12 C 22.45 17.011 18.373 21.087 13.363 21.087 Z',
        customStroke: '0.5px',
    },
    twitter: {
        path: 'M 22.999 5.196 Q 22.161 6.501 20.762 7.526 L 20.762 8.086 Q 20.762 12.98 17.242 16.964 Q 13.724 20.949 7.898 20.949 Q 4.169 20.949 1 18.899 Q 1.746 18.993 2.073 18.993 Q 5.196 18.993 7.665 17.035 Q 6.22 16.988 5.056 16.125 Q 3.89 15.264 3.47 13.911 Q 4.03 14.005 4.31 14.005 Q 4.776 14.005 5.521 13.818 Q 3.983 13.491 2.934 12.256 Q 1.885 11.022 1.885 9.39 L 1.885 9.343 Q 2.911 9.902 3.937 9.902 Q 1.932 8.598 1.932 6.127 Q 1.932 4.961 2.538 3.89 Q 6.128 8.318 11.814 8.598 Q 11.72 8.271 11.72 7.572 Q 11.72 5.661 13.026 4.355 Q 14.331 3.051 16.243 3.051 Q 18.154 3.051 19.505 4.495 Q 20.902 4.262 22.395 3.377 Q 21.928 5.009 20.39 5.894 Q 21.835 5.754 23 5.194 L 22.999 5.196 Z',
        customStroke: '0',
    },
    uav: {
        path: 'M 16.125 21.166 C 15.872 21.166 15.666 20.962 15.666 20.709 L 15.666 18.875 C 15.666 18.622 15.872 18.416 16.125 18.416 C 16.378 18.416 16.584 18.622 16.584 18.875 L 16.584 19.334 L 17.959 19.334 C 18.212 19.334 18.416 19.128 18.416 18.875 C 18.515 17.038 17.75 15.286 16.357 14.123 C 16.106 14.507 15.676 14.75 15.209 14.75 L 8.791 14.75 C 8.324 14.75 7.894 14.507 7.643 14.123 C 6.252 15.286 5.485 17.032 5.584 18.85 C 5.584 19.126 5.785 19.334 6.041 19.334 L 7.416 19.334 L 7.416 18.875 C 7.416 18.622 7.622 18.416 7.875 18.416 C 8.128 18.416 8.334 18.622 8.334 18.875 L 8.334 20.709 C 8.334 20.962 8.128 21.166 7.875 21.166 C 7.622 21.166 7.416 20.962 7.416 20.709 L 7.416 20.25 L 6.041 20.25 C 5.284 20.25 4.666 19.633 4.666 18.875 C 4.547 16.65 5.597 14.459 7.416 13.139 L 7.416 11.332 C 6.953 11.163 6.512 11.084 6.041 11.084 L 2.834 11.084 C 1.822 11.084 1 10.261 1 9.25 C 1 8.239 1.822 7.416 2.834 7.416 L 2.834 6.041 C 2.834 5.455 3.209 4.937 3.75 4.745 L 3.75 4.209 C 3.75 3.956 3.956 3.75 4.209 3.75 C 4.462 3.75 4.666 3.956 4.666 4.209 L 4.666 4.745 C 5.208 4.937 5.584 5.455 5.584 6.041 L 5.584 7.416 L 6.041 7.416 C 7.096 7.416 7.839 7.017 8.625 6.594 C 9.547 6.096 10.501 5.584 12 5.584 C 13.499 5.584 14.453 6.096 15.375 6.594 C 16.163 7.017 16.905 7.416 17.959 7.416 L 18.416 7.416 L 18.416 6.041 C 18.416 5.455 18.792 4.937 19.334 4.745 L 19.334 4.209 C 19.334 3.956 19.538 3.75 19.791 3.75 C 20.044 3.75 20.25 3.956 20.25 4.209 L 20.25 4.745 C 20.791 4.937 21.166 5.455 21.166 6.041 L 21.166 7.416 C 22.178 7.416 23 8.239 23 9.25 C 23 10.261 22.178 11.084 21.166 11.084 L 17.959 11.084 C 17.488 11.084 17.047 11.163 16.584 11.332 L 16.584 13.139 C 18.402 14.459 19.453 16.656 19.334 18.9 C 19.334 19.249 19.191 19.591 18.93 19.849 C 18.669 20.108 18.324 20.25 17.959 20.25 L 16.584 20.25 L 16.584 20.709 C 16.584 20.962 16.378 21.166 16.125 21.166 Z  M 8.334 13.375 C 8.334 13.628 8.538 13.834 8.791 13.834 L 15.209 13.834 C 15.462 13.834 15.666 13.628 15.666 13.375 L 15.666 11.752 C 15.57 11.803 15.473 11.854 15.376 11.906 C 14.453 12.404 13.499 12.916 12 12.916 C 10.501 12.916 9.546 12.404 8.624 11.906 C 8.527 11.854 8.43 11.802 8.334 11.752 L 8.334 13.375 Z  M 2.834 8.334 C 2.328 8.334 1.916 8.745 1.916 9.25 C 1.916 9.755 2.328 10.166 2.834 10.166 L 6.041 10.166 C 7.327 10.166 8.207 10.641 9.058 11.1 C 9.88 11.543 10.732 12 12 12 C 13.268 12 14.12 11.543 14.942 11.1 C 15.793 10.641 16.673 10.166 17.959 10.166 L 21.166 10.166 C 21.672 10.166 22.084 9.755 22.084 9.25 C 22.084 8.745 21.672 8.334 21.166 8.334 L 17.959 8.334 C 16.674 8.334 15.793 7.859 14.942 7.401 C 14.118 6.957 13.268 6.5 12 6.5 C 10.732 6.5 9.882 6.957 9.06 7.4 C 8.207 7.859 7.327 8.334 6.041 8.334 L 2.834 8.334 Z  M 20.25 7.416 L 20.25 6.041 C 20.25 5.788 20.044 5.584 19.791 5.584 C 19.538 5.584 19.334 5.788 19.334 6.041 L 19.334 7.416 L 20.25 7.416 Z  M 4.666 7.416 L 4.666 6.041 C 4.666 5.788 4.462 5.584 4.209 5.584 C 3.956 5.584 3.75 5.788 3.75 6.041 L 3.75 7.416 L 4.666 7.416 Z  M 1.459 3.75 C 1.206 3.75 1 3.544 1 3.291 C 1 3.038 1.206 2.834 1.459 2.834 L 3.291 2.834 C 3.544 2.834 3.75 3.038 3.75 3.291 C 3.75 3.544 3.544 3.75 3.291 3.75 L 1.459 3.75 Z  M 5.125 3.75 C 4.872 3.75 4.666 3.544 4.666 3.291 C 4.666 3.038 4.872 2.834 5.125 2.834 L 6.959 2.834 C 7.212 2.834 7.416 3.038 7.416 3.291 C 7.416 3.544 7.212 3.75 6.959 3.75 L 5.125 3.75 Z  M 20.709 3.75 C 20.456 3.75 20.25 3.544 20.25 3.291 C 20.25 3.038 20.456 2.834 20.709 2.834 L 22.541 2.834 C 22.794 2.834 23 3.038 23 3.291 C 23 3.544 22.794 3.75 22.541 3.75 L 20.709 3.75 Z  M 17.041 3.75 C 16.788 3.75 16.584 3.544 16.584 3.291 C 16.584 3.038 16.788 2.834 17.041 2.834 L 18.875 2.834 C 19.128 2.834 19.334 3.038 19.334 3.291 C 19.334 3.544 19.128 3.75 18.875 3.75 L 17.041 3.75 Z',
        customStroke: '0.5px',
    },
    undo: {
        path: 'M 13.897 21.103 C 18.924 21.103 23 17.028 23 12 C 23 6.972 18.924 2.897 13.897 2.897 C 8.869 2.897 4.793 6.972 4.793 12 L 4.793 16.703 L 2.062 13.972 L 1 15.034 L 5.552 19.586 L 10.103 15.034 L 9.041 13.972 L 6.31 16.703 L 6.31 12 L 6.31 12 C 6.31 7.81 9.707 4.414 13.897 4.414 C 18.086 4.414 21.483 7.81 21.483 12 C 21.483 16.19 18.086 19.586 13.897 19.586 L 13.897 21.103 Z',
    },
    unliked: {
        path: 'M 17.067 3.752 C 18.222 3.751 19.329 4.215 20.138 5.04 C 21.855 6.783 21.855 9.581 20.138 11.324 L 12 19.565 L 3.862 11.324 C 2.145 9.581 2.145 6.783 3.862 5.04 C 4.671 4.216 5.778 3.751 6.933 3.751 C 8.088 3.751 9.195 4.216 10.005 5.04 L 12 7.082 L 13.987 5.056 C 14.794 4.221 15.906 3.75 17.067 3.752 Z  M 17.067 2.18 C 15.489 2.179 13.977 2.813 12.872 3.94 L 12 4.82 L 11.128 3.94 C 10.022 2.816 8.511 2.182 6.933 2.182 C 5.356 2.182 3.844 2.816 2.738 3.94 C 0.421 6.299 0.421 10.081 2.738 12.44 L 12 21.82 L 21.262 12.44 C 23.579 10.081 23.579 6.299 21.262 3.94 C 20.156 2.815 18.645 2.181 17.067 2.18 Z',
    },
    unordered_list: {
        path: 'M 1 6.077 C 1 4.676 2.137 3.538 3.538 3.538 C 4.939 3.538 6.077 4.676 6.077 6.077 C 6.077 7.478 4.939 8.615 3.538 8.615 C 2.137 8.615 1 7.478 1 6.077 Z  M 1 17.923 C 1 16.522 2.137 15.385 3.538 15.385 C 4.939 15.385 6.077 16.522 6.077 17.923 C 6.077 19.324 4.939 20.462 3.538 20.462 C 2.137 20.462 1 19.324 1 17.923 Z  M 11.154 17.077 L 23 17.077 L 23 18.769 L 11.154 18.769 L 11.154 17.077 Z  M 11.154 5.231 L 23 5.231 L 23 6.923 L 11.154 6.923 L 11.154 5.231 Z',
    },
    unpinned: {
        path: 'M 12 13.571 C 9.83 13.571 8.071 11.813 8.071 9.643 C 8.071 7.473 9.83 5.714 12 5.714 C 14.17 5.714 15.929 7.473 15.929 9.643 C 15.926 11.812 14.169 13.569 12 13.571 L 12 13.571 Z  M 12 7.286 C 10.698 7.286 9.643 8.341 9.643 9.643 C 9.643 10.945 10.698 12 12 12 C 13.302 12 14.357 10.945 14.357 9.643 C 14.356 8.342 13.301 7.287 12 7.286 L 12 7.286 Z  M 12 23 L 5.372 15.183 C 5.334 15.138 5.099 14.828 5.099 14.828 C 3.966 13.337 3.354 11.515 3.357 9.643 C 3.357 4.87 7.227 1 12 1 C 16.773 1 20.643 4.87 20.643 9.643 C 20.646 11.515 20.034 13.336 18.903 14.826 L 18.901 14.828 C 18.901 14.828 18.666 15.138 18.631 15.18 L 12 23 Z  M 6.353 13.882 C 6.353 13.882 6.536 14.124 6.578 14.176 L 12 20.57 L 17.429 14.167 C 17.464 14.124 17.648 13.88 17.648 13.88 C 18.573 12.661 19.073 11.173 19.071 9.643 C 19.071 5.737 15.905 2.571 12 2.571 C 8.095 2.571 4.929 5.737 4.929 9.643 C 4.927 11.174 5.427 12.663 6.353 13.882 L 6.353 13.882 Z',
    },
    upload: {
        path: 'M 8.06 13.959 L 9.171 15.071 L 11.212 13.037 L 11.212 22.628 L 12.788 22.628 L 12.788 13.037 L 14.829 15.071 L 15.94 13.959 L 12 10.019 L 8.06 13.959 L 8.06 13.959 Z  M 17.91 17.112 L 17.516 17.112 L 17.516 15.535 L 17.91 15.535 C 19.869 15.614 21.52 14.09 21.598 12.131 C 21.676 10.173 20.152 8.522 18.194 8.443 L 17.516 8.443 L 17.437 7.797 C 17.076 5.053 14.736 3.002 11.968 3.002 C 9.201 3.002 6.861 5.053 6.5 7.797 L 6.484 8.443 L 5.806 8.443 C 3.848 8.522 2.324 10.173 2.402 12.131 C 2.48 14.09 4.131 15.614 6.09 15.535 L 6.484 15.535 L 6.484 17.112 L 6.09 17.112 C 3.473 17.095 1.289 15.108 1.026 12.505 C 0.763 9.901 2.505 7.518 5.066 6.978 C 5.767 3.708 8.656 1.372 12 1.372 C 15.344 1.372 18.233 3.708 18.934 6.978 C 21.495 7.518 23.237 9.901 22.974 12.505 C 22.711 15.108 20.527 17.095 17.91 17.112 Z',
    },
    user: {
        path: 'M 19.7 23 L 17.5 23 L 17.5 19.7 C 17.5 17.877 16.023 16.4 14.2 16.4 L 9.8 16.4 C 7.977 16.4 6.5 17.877 6.5 19.7 L 6.5 23 L 4.3 23 L 4.3 19.7 C 4.3 16.662 6.762 14.2 9.8 14.2 L 14.2 14.2 C 17.238 14.2 19.7 16.662 19.7 19.7 L 19.7 23 Z  M 12 3.2 C 13.823 3.2 15.3 4.677 15.3 6.5 C 15.3 8.323 13.823 9.8 12 9.8 C 10.177 9.8 8.7 8.323 8.7 6.5 C 8.7 4.677 10.177 3.2 12 3.2 Z  M 12 1 C 8.962 1 6.5 3.462 6.5 6.5 C 6.5 9.538 8.962 12 12 12 C 15.038 12 17.5 9.538 17.5 6.5 C 17.5 3.462 15.038 1 12 1 Z',
    },
    view_off: {
        path: 'M 6.37 28.246 L 8.182 26.448 C 6.199 24.667 4.64 22.463 3.622 20 C 6.192 13.578 13.286 8.6 20 8.6 C 21.727 8.623 23.439 8.93 25.066 9.512 L 27.03 7.536 C 24.803 6.595 22.416 6.096 20 6.066 C 11.561 6.384 4.122 11.692 1.076 19.57 C 0.975 19.848 0.975 20.152 1.076 20.43 C 2.201 23.416 4.014 26.094 6.37 28.246 Z  M 14.934 19.658 C 15.115 17.148 17.11 15.153 19.62 14.972 L 21.912 12.666 C 19.299 11.977 16.514 12.73 14.604 14.642 C 12.692 16.552 11.939 19.337 12.628 21.95 L 14.934 19.658 Z  M 38.924 19.57 C 37.471 15.786 34.944 12.511 31.654 10.146 L 37.734 4.052 L 35.948 2.266 L 2.266 35.948 L 4.052 37.734 L 10.512 31.274 C 13.393 32.963 16.661 33.88 20 33.934 C 28.439 33.616 35.878 28.308 38.924 20.43 C 39.025 20.152 39.025 19.848 38.924 19.57 Z  M 25.066 20 C 25.056 21.805 24.087 23.467 22.52 24.365 C 20.955 25.263 19.029 25.259 17.466 24.358 L 24.358 17.466 C 24.812 18.235 25.057 19.107 25.066 20 Z  M 20 31.4 C 17.342 31.353 14.735 30.667 12.4 29.398 L 15.618 26.182 C 18.637 28.277 22.724 27.911 25.323 25.311 C 27.923 22.712 28.289 18.625 26.194 15.604 L 29.83 11.97 C 32.737 13.965 35.008 16.751 36.378 20 C 33.808 26.422 26.714 31.4 20 31.4 Z',
    },
    view: {
        path: 'M 38.924 19.57 C 35.878 11.692 28.439 6.384 20 6.066 C 11.561 6.384 4.122 11.692 1.076 19.57 C 0.975 19.848 0.975 20.152 1.076 20.43 C 4.122 28.308 11.561 33.616 20 33.934 C 28.439 33.616 35.878 28.308 38.924 20.43 C 39.025 20.152 39.025 19.848 38.924 19.57 Z  M 20 31.4 C 13.286 31.4 6.192 26.422 3.622 20 C 6.192 13.578 13.286 8.6 20 8.6 C 26.714 8.6 33.808 13.578 36.378 20 C 33.808 26.422 26.714 31.4 20 31.4 Z  M 20 12.4 C 15.803 12.4 12.4 15.803 12.4 20 C 12.4 24.197 15.803 27.6 20 27.6 C 24.197 27.6 27.6 24.197 27.6 20 C 27.6 15.803 24.197 12.4 20 12.4 Z  M 20 25.066 C 17.202 25.066 14.934 22.798 14.934 20 C 14.934 17.202 17.202 14.934 20 14.934 C 22.798 14.934 25.066 17.202 25.066 20 C 25.066 22.798 22.798 25.066 20 25.066 Z',
    },
    visualization: {
        path: 'M 14.154 1 L 1 1 L 1 14.168 L 3.923 14.168 L 3.923 3.923 L 14.154 3.923 L 14.154 1 Z  M 38.255 14.329 L 25.101 7.022 C 24.649 6.76 24.091 6.76 23.639 7.022 L 10.485 14.329 C 10.032 14.598 9.759 15.089 9.769 15.615 L 9.769 30.231 C 9.773 30.761 10.064 31.248 10.529 31.502 L 23.683 38.81 C 23.897 38.931 24.138 38.997 24.385 39 C 24.635 38.996 24.881 38.931 25.101 38.81 L 38.255 31.502 C 38.714 31.244 38.999 30.758 39 30.231 L 39 15.615 C 39.004 15.083 38.719 14.59 38.255 14.329 Z  M 22.923 35.054 L 12.692 29.368 L 12.692 18.085 L 22.923 23.771 L 22.923 35.054 Z  M 24.385 21.242 L 14.242 15.615 L 24.385 9.974 L 34.528 15.615 L 24.385 21.242 Z  M 36.077 29.368 L 25.846 35.054 L 25.846 23.771 L 36.077 18.085 L 36.077 29.368 Z',
        customStroke: '0.5px',
    },
    website: {
        path: 'M 12 1 C 5.925 1 1 5.925 1 12 C 1 18.075 5.925 23 12 23 C 18.075 23 23 18.075 23 12 C 23 5.925 18.075 1 12 1 Z  M 21.429 11.214 L 16.714 11.214 C 16.623 8.321 15.873 5.486 14.522 2.925 C 18.334 3.968 21.091 7.277 21.429 11.214 Z  M 12 21.429 C 11.825 21.44 11.649 21.44 11.474 21.429 C 9.846 18.833 8.942 15.849 8.857 12.786 L 15.143 12.786 C 15.065 15.846 14.169 18.83 12.55 21.429 C 12.367 21.441 12.183 21.441 12 21.429 Z  M 8.857 11.214 C 8.935 8.154 9.831 5.17 11.45 2.571 C 11.8 2.532 12.153 2.532 12.503 2.571 C 14.139 5.165 15.051 8.149 15.143 11.214 L 8.857 11.214 Z  M 9.454 2.925 C 8.112 5.488 7.37 8.322 7.286 11.214 L 2.571 11.214 C 2.909 7.277 5.666 3.968 9.478 2.925 L 9.454 2.925 Z  M 2.611 12.786 L 7.325 12.786 C 7.407 15.677 8.146 18.512 9.486 21.075 C 5.686 20.021 2.944 16.715 2.611 12.786 Z  M 14.522 21.075 C 15.873 18.514 16.623 15.679 16.714 12.786 L 21.429 12.786 C 21.091 16.723 18.334 20.032 14.522 21.075 Z',
    },
    youtube: {
        path: 'M 22.536 6.705 C 22.281 5.758 21.542 5.019 20.595 4.764 C 18.882 4.3 12 4.3 12 4.3 C 12 4.3 5.118 4.3 3.405 4.764 C 2.458 5.019 1.719 5.758 1.464 6.705 C 1.144 8.451 0.989 10.224 1.001 12 C 0.989 13.776 1.144 15.549 1.464 17.295 C 1.719 18.242 2.458 18.981 3.405 19.236 C 5.118 19.7 12 19.7 12 19.7 C 12 19.7 18.882 19.7 20.595 19.236 C 21.542 18.981 22.281 18.242 22.536 17.295 C 22.856 15.549 23.011 13.776 22.999 12 C 23.011 10.224 22.856 8.451 22.536 6.705 L 22.536 6.705 Z  M 9.8 15.3 L 9.8 8.7 L 15.512 12 L 9.8 15.3 Z',
        customStroke: '0',
    },
    warning: {
        path: 'M 12 17.108 C 11.349 17.108 10.822 17.636 10.822 18.286 C 10.822 18.937 11.349 19.465 12 19.465 C 12.651 19.465 13.178 18.937 13.178 18.286 C 13.178 17.636 12.651 17.108 12 17.108 Z  M 11.214 8.466 L 12.786 8.466 L 12.786 15.537 L 11.214 15.537 L 11.214 8.466 Z  M 22.213 22.607 L 1.787 22.607 C 1.513 22.608 1.258 22.465 1.115 22.23 C 0.972 21.996 0.962 21.704 1.088 21.46 L 11.301 1.82 C 11.435 1.558 11.705 1.393 12 1.393 C 12.295 1.393 12.565 1.558 12.699 1.82 L 22.912 21.46 C 23.038 21.704 23.028 21.996 22.885 22.23 C 22.742 22.465 22.487 22.608 22.213 22.607 Z  M 3.083 21.036 L 20.917 21.036 L 12 3.886 L 3.083 21.036 Z',
    },
    workspace: {
        path: 'M 11.999 18.252 C 8.552 18.252 5.748 15.447 5.748 11.999 C 5.748 8.553 8.552 5.748 11.999 5.748 C 15.446 5.748 18.251 8.553 18.251 11.999 C 18.251 15.447 15.446 18.251 11.999 18.251 L 11.999 18.252 Z  M 23 11.649 L 18.935 11.649 C 18.756 8.096 15.904 5.244 12.35 5.065 L 12.35 1.008 L 11.649 1.008 L 11.649 5.065 C 8.095 5.244 5.243 8.096 5.065 11.649 L 1 11.649 L 1 12.351 L 5.065 12.351 C 5.243 15.904 8.095 18.756 11.649 18.935 L 11.649 22.992 L 12.35 22.992 L 12.35 18.935 C 15.904 18.756 18.756 15.904 18.934 12.351 L 22.999 12.351 L 22.999 11.649 L 23 11.649 Z  M 12.526 8.81 L 11.824 8.81 L 11.824 11.586 L 9.049 11.586 L 9.049 12.287 L 11.824 12.287 L 11.824 15.062 L 12.526 15.062 L 12.526 12.287 L 15.301 12.287 L 15.301 11.586 L 12.526 11.586 L 12.526 8.81 Z',
        customStroke: '0.5px',
    },
    zoom_in: {
        path: 'M 14.037 9.148 L 10.778 9.148 L 10.778 5.889 L 9.148 5.889 L 9.148 9.148 L 5.889 9.148 L 5.889 10.778 L 9.148 10.778 L 9.148 14.037 L 10.778 14.037 L 10.778 10.778 L 14.037 10.778 L 14.037 9.148 L 14.037 9.148 Z  M 16.848 15.667 C 18.191 14.07 18.927 12.05 18.926 9.963 C 18.926 5.013 14.913 1 9.963 1 C 5.013 1 1 5.013 1 9.963 C 1 14.913 5.013 18.926 9.963 18.926 C 12.05 18.927 14.07 18.191 15.667 16.848 L 21.851 23 L 23 21.851 L 16.848 15.667 Z  M 9.963 17.296 C 5.913 17.296 2.63 14.013 2.63 9.963 C 2.63 5.913 5.913 2.63 9.963 2.63 C 14.013 2.63 17.296 5.913 17.296 9.963 C 17.296 14.013 14.013 17.296 9.963 17.296 Z',
    },
    plane: {
        path: 'M 35.313 37.091 L 4.707 37.186 C 3.747 37.258 2.801 36.925 2.097 36.269 C 1.393 35.613 0.996 34.692 1 33.73 L 4.895 5.977 C 5.015 4.244 6.452 2.896 8.189 2.887 L 31.583 2.804 C 33.323 2.797 34.773 4.134 34.907 5.869 L 39 33.611 C 39.013 34.575 38.622 35.5 37.921 36.161 C 37.22 36.823 36.274 37.16 35.313 37.091 L 35.313 37.091 Z  M 4.611 33.381 L 35.28 33.285 L 31.609 6.099 L 8.186 6.178 L 4.611 33.381 Z',
    },
    explode_layers: {
        path: 'M 2.71 12.738 L 18.432 19.458 C 18.866 19.644 19.148 20.071 19.149 20.543 L 19.19 37.813 C 19.192 38.663 18.324 39.238 17.543 38.904 L 1.821 32.183 C 1.386 31.997 1.104 31.571 1.103 31.098 L 1.062 13.828 C 1.06 12.978 1.928 12.404 2.71 12.738 Z  M 2.456 14.641 L 2.416 30.623 L 17.527 36.907 L 17.567 20.924 L 2.456 14.641 Z  M 37.125 14.641 L 22.617 20.924 L 22.654 36.907 L 37.163 30.623 L 37.125 14.641 Z  M 37.712 12.557 C 38.336 12.556 38.895 13.057 38.897 13.738 L 38.938 31.008 C 38.939 31.481 38.659 31.909 38.225 32.097 L 22.535 38.892 C 22.38 38.959 22.222 38.99 22.067 38.99 C 21.444 38.992 20.884 38.49 20.883 37.809 L 20.842 20.539 C 20.841 20.067 21.121 19.639 21.554 19.451 L 37.244 12.656 C 37.399 12.589 37.558 12.558 37.712 12.557 L 37.712 12.557 Z  M 19.885 2.83 L 4.835 9.549 L 19.917 16.198 L 34.967 9.478 L 19.885 2.83 Z  M 19.881 1 C 20.044 1 20.208 1.033 20.361 1.1 L 36.902 8.392 C 37.84 8.806 37.844 10.136 36.907 10.555 L 20.401 17.925 C 20.248 17.993 20.085 18.027 19.921 18.027 C 19.758 18.028 19.594 17.994 19.441 17.927 L 2.9 10.635 C 1.962 10.221 1.959 8.891 2.895 8.473 L 19.402 1.103 C 19.554 1.035 19.717 1 19.881 1 L 19.881 1 Z',
    },
    cylinder: {
        path: 'M 32.894 9.131 C 32.885 6.804 31.42 4.676 28.77 3.143 C 23.82 0.282 16.09 0.289 11.175 3.143 C 8.546 4.67 7.103 6.792 7.106 9.115 C 7.106 9.122 7.109 9.125 7.109 9.131 L 7.106 9.131 L 7.106 30.865 L 7.109 30.865 C 7.118 33.195 8.577 35.32 11.227 36.853 C 13.705 38.286 16.875 39 20.045 39 C 23.208 39 26.369 38.286 28.828 36.859 C 31.454 35.333 32.897 33.21 32.894 30.887 C 32.894 30.881 32.891 30.875 32.891 30.868 L 32.894 30.868 L 32.894 9.131 L 32.894 9.131 Z  M 12.726 5.816 C 14.685 4.679 17.32 4.11 19.964 4.11 C 22.609 4.11 25.254 4.679 27.228 5.816 C 28.865 6.764 29.808 7.978 29.811 9.152 C 29.811 10.326 28.915 11.497 27.283 12.443 C 23.366 14.723 16.724 14.717 12.772 12.44 C 11.138 11.494 10.199 10.283 10.195 9.112 C 10.192 7.935 11.091 6.764 12.726 5.816 Z  M 29.808 14.417 L 29.808 25.619 C 29.471 25.369 29.162 25.107 28.77 24.881 C 23.814 22.017 16.087 22.026 11.175 24.884 C 10.807 25.097 10.517 25.351 10.195 25.585 L 10.195 14.377 C 10.532 14.624 10.838 14.887 11.227 15.112 C 13.705 16.546 16.875 17.259 20.045 17.259 C 23.208 17.259 26.369 16.546 28.828 15.118 C 29.199 14.905 29.486 14.655 29.808 14.417 Z  M 27.28 34.183 C 23.366 36.46 16.724 36.454 12.775 34.177 C 11.141 33.232 10.202 32.021 10.199 30.85 C 10.199 29.673 11.095 28.505 12.726 27.56 C 14.685 26.42 17.323 25.851 19.968 25.851 C 22.606 25.851 25.254 26.42 27.228 27.557 C 28.865 28.508 29.808 29.719 29.811 30.893 C 29.808 32.064 28.912 33.235 27.28 34.183 Z',
    },
    torus: {
        path: 'M 18.61 5.2 C 17.8 5.32 16.96 5.32 16.15 5.47 C 13.57 5.89 10.99 6.73 8.74 8.08 C 7.42 8.86 6.07 9.79 4.99 10.9 C 1.93 14.08 0.28 18.52 1.3 22.99 C 1.57 24.22 2.05 25.36 2.65 26.41 C 3.43 27.85 4.51 29.08 5.68 30.16 C 10.39 34.48 17.2 35.86 23.29 35.08 C 26.02 34.75 28.78 33.88 31.21 32.47 C 32.98 31.48 34.54 30.19 35.89 28.66 C 36.91 27.52 37.72 26.14 38.29 24.7 C 40.12 19.96 38.74 14.62 35.29 11.08 C 31.69 7.42 26.77 5.59 21.85 5.23 C 20.8 5.17 19.66 5.05 18.61 5.2 M 4.9 14.68 L 5.17 13.42 L 4.81 13.33 C 5.11 12.85 5.71 11.95 6.28 11.77 C 6.76 11.62 7.51 12.13 7.87 12.4 C 9.25 13.39 10.12 15.25 9.91 16.99 C 9.82 17.65 9.67 18.31 9.37 18.88 C 9.25 19.09 9.13 19.36 8.89 19.45 C 8.62 19.57 8.23 19.39 7.96 19.33 L 7.63 20.77 C 8.05 20.8 8.62 20.83 8.98 21.04 C 9.4 21.25 9.67 21.76 10 22.09 C 10.66 22.75 11.44 23.35 12.22 23.83 C 14.77 25.36 17.8 26.11 20.74 25.96 C 23.83 25.81 27.13 24.76 29.5 22.63 C 30.07 22.15 30.55 21.64 31.03 21.04 C 31.24 20.77 31.51 20.44 31.39 20.05 C 31.27 19.6 30.88 19.21 30.58 18.88 C 29.68 17.77 28.45 16.9 27.22 16.27 C 23.59 14.35 19.24 13.93 15.37 15.22 C 13.87 15.7 12.61 16.57 11.2 17.26 C 11.68 14.56 9.88 11.65 7.54 10.63 C 8.11 10 8.95 9.55 9.67 9.16 C 11.05 8.44 12.43 7.84 13.93 7.45 C 20.14 5.74 27.52 6.49 32.74 10.69 C 34.33 11.95 35.71 13.51 36.64 15.37 C 38.95 20.08 37.45 25.6 33.67 28.96 C 32.14 30.34 30.43 31.39 28.57 32.2 C 26.05 33.28 23.2 33.88 20.47 33.88 C 16.96 33.88 13.42 33.28 10.24 31.63 C 7.39 30.1 4.69 27.85 3.31 24.7 C 2.8 23.56 2.53 22.39 2.38 21.13 C 2.17 19.45 2.56 17.71 3.13 16.18 C 3.31 15.76 3.55 14.83 4 14.62 C 4.27 14.5 4.63 14.62 4.9 14.68 M 3.64 16.18 L 4.06 17.62 L 5.32 17.08 L 4.99 15.82 L 3.64 16.18 M 19.03 15.94 C 21.94 15.58 25.15 16.51 27.64 18.1 C 28.27 18.49 28.84 18.97 29.35 19.51 C 29.53 19.69 29.83 19.93 29.83 20.23 C 29.83 20.44 29.65 20.62 29.5 20.77 C 29.14 21.16 28.75 21.52 28.33 21.88 C 26.5 23.35 24.19 24.13 21.94 24.4 C 18.76 24.82 15.28 24.22 12.58 22.39 C 11.92 21.97 11.32 21.52 10.78 20.95 C 10.6 20.77 10.27 20.5 10.27 20.23 C 10.27 19.99 10.54 19.75 10.69 19.6 C 11.11 19.15 11.56 18.76 12.04 18.4 C 14.2 16.87 16.51 16.27 19.03 15.94 M 4.99 18.97 V 19.06 L 6.1 20.05 C 6.61 19.6 7.03 18.94 6.43 18.43 C 6.31 18.31 6.19 18.19 6.01 18.19 C 5.65 18.19 5.23 18.73 4.99 18.97 Z',
        customStroke: '0.5px',
    },
    pan: {
        path: 'M 36.474 17.476 L 35.88 18.071 L 37.247 19.438 L 28.266 19.438 L 28.257 16.196 C 28.254 15.566 27.914 14.98 27.369 14.665 L 20.839 10.895 C 20.292 10.579 19.608 10.578 19.061 10.897 L 12.626 14.637 C 12.083 14.952 11.745 15.538 11.743 16.165 L 11.734 19.438 L 2.752 19.438 L 4.119 18.071 L 3.525 17.476 L 1 19.999 L 3.525 22.523 L 4.119 21.927 L 2.753 20.561 L 11.731 20.561 L 11.722 23.808 C 11.721 24.44 12.061 25.032 12.609 25.349 L 19.114 29.105 C 19.388 29.263 19.694 29.342 20.001 29.342 C 20.307 29.342 20.614 29.263 20.887 29.105 L 27.393 25.349 C 27.942 25.032 28.281 24.44 28.279 23.808 L 28.27 20.561 L 37.247 20.561 L 35.881 21.927 L 36.475 22.523 L 39 19.999 L 36.474 17.476 Z  M 26.278 15.521 L 19.999 19.169 L 13.682 15.522 L 19.961 11.874 L 26.278 15.521 Z  M 19.353 21.187 L 19.335 27.744 L 13.018 24.097 L 13.038 16.836 L 19.351 20.48 L 19.353 21.187 Z  M 26.986 24.095 L 20.669 27.742 L 20.649 20.48 L 26.965 16.833 L 26.986 24.095 Z',
    },
    orbit: {
        path: 'M 27.575 15.184 L 27.575 15.184 L 20.878 11.318 C 20.304 10.987 19.593 10.987 19.021 11.321 L 12.421 15.156 C 11.854 15.485 11.502 16.096 11.499 16.753 L 11.477 24.589 C 11.474 25.252 11.831 25.868 12.403 26.199 L 19.072 30.049 C 19.359 30.214 19.678 30.297 19.999 30.297 C 20.319 30.297 20.639 30.214 20.925 30.049 L 27.596 26.199 C 28.169 25.867 28.524 25.25 28.521 24.589 L 28.498 16.783 C 28.499 16.127 28.144 15.513 27.575 15.184 Z  M 19.302 21.902 L 19.283 28.562 L 12.878 24.864 L 12.9 17.5 L 19.301 21.196 L 19.302 21.902 Z  M 26.366 16.094 L 19.999 19.794 L 13.593 16.095 L 19.96 12.396 L 26.366 16.094 Z  M 27.128 24.862 L 20.723 28.561 L 20.702 21.197 L 27.105 17.498 L 27.128 24.862 Z  M 6.675 16.891 L 5.006 18.559 C 5.735 10.925 12.178 4.933 19.999 4.933 C 25.282 4.933 30.246 7.756 32.953 12.301 L 34.184 11.567 C 31.221 6.592 25.785 3.501 20.001 3.501 C 11.343 3.501 4.235 10.208 3.567 18.698 L 1.76 16.891 L 1 17.65 L 4.217 20.868 L 7.435 17.65 L 6.675 16.891 Z  M 39 22.458 L 35.782 19.24 L 32.563 22.458 L 33.324 23.218 L 34.985 21.557 C 34.202 29.135 27.781 35.066 19.999 35.066 C 14.682 35.066 9.86 32.348 7.103 27.794 L 5.877 28.536 C 8.896 33.522 14.176 36.499 19.998 36.499 C 28.62 36.499 35.709 29.846 36.426 21.406 L 38.239 23.22 L 39 22.458 Z',
    },
    nurbs: {
        path: 'M 1 38.53 L 1 35.363 C 14.253 35.363 18.505 31.661 18.505 20.128 C 18.505 6.974 21.352 1.47 39 1.47 L 39 4.637 C 23.094 4.637 21.672 8.652 21.672 20.128 C 21.672 33.371 15.877 38.53 1 38.53 Z',
    },
    geometry: {
        path: 'M 36.429 39.019 L 21.327 39.019 C 19.908 39.019 18.759 37.869 18.759 36.451 L 18.759 21.346 C 18.759 19.927 19.908 18.778 21.327 18.778 L 36.432 18.778 C 37.85 18.778 39 19.927 39 21.346 L 39 36.451 C 38.997 37.869 37.848 39.019 36.429 39.019 Z  M 21.274 36.503 L 36.482 36.503 L 36.482 21.293 L 21.274 21.293 L 21.274 36.503 Z  M 16.244 26.598 C 13.965 25.282 12.413 22.85 12.413 20.035 C 12.413 15.842 15.823 12.434 20.017 12.434 C 22.829 12.434 25.261 13.986 26.577 16.262 L 29.389 16.262 C 27.89 12.549 24.26 9.916 20.017 9.916 C 14.435 9.916 9.897 14.456 9.897 20.035 C 9.897 24.279 12.531 27.908 16.244 29.408 L 16.244 26.598 Z  M 7.382 20.038 C 7.382 19.608 7.467 19.2 7.51 18.78 L 4.328 18.78 L 11.155 5.124 L 13.285 9.385 C 13.992 8.937 14.744 8.565 15.537 8.261 L 12.229 1.645 C 11.786 0.76 10.524 0.76 10.081 1.645 L 1.129 19.555 C 0.729 20.352 1.31 21.293 2.203 21.293 L 7.475 21.293 C 7.435 20.878 7.382 20.463 7.382 20.038 Z',
    },
    cone: {
        path: 'M 33.822 27.631 L 19.999 1 L 6.202 27.569 C 4.786 28.965 4.485 30.348 4.488 31.218 C 4.491 32.549 5.146 35.074 9.506 37.018 C 12.468 38.336 16.264 39 20.052 39 C 23.839 39 27.621 38.339 30.559 37.018 C 34.869 35.086 35.512 32.578 35.512 31.254 C 35.509 30.386 35.214 29.018 33.822 27.631 Z  M 29.105 24.941 C 23.701 23.032 16.317 23.015 10.904 24.906 L 19.999 7.401 L 29.105 24.941 Z  M 29.353 34.324 C 24.235 36.628 15.869 36.622 10.704 34.319 C 8.662 33.407 7.441 32.248 7.438 31.209 C 7.438 30.186 8.636 29.038 10.645 28.136 C 13.205 26.991 16.577 26.416 19.951 26.416 C 23.329 26.416 26.709 26.991 29.288 28.142 C 31.335 29.056 32.559 30.218 32.562 31.257 C 32.562 32.277 31.364 33.425 29.353 34.324 Z',
    },
    annotation: {
        path: 'M 38.05 20.001 L 38.05 20.001 C 38.05 29.968 29.969 38.051 20 38.051 L 1.95 38.051 L 1.95 19.999 C 1.95 10.032 10.032 1.949 20 1.949 C 29.969 1.949 38.052 10.032 38.05 20.001 Z  M 39 20 C 39 25.035 36.996 29.871 33.433 33.433 C 29.871 36.996 25.035 39 20 39 C 20 39 20 39 20 39 L 1 39 L 1 20 C 1 14.965 3.004 10.129 6.567 6.567 C 10.129 3.004 14.965 1 20 1 C 25.035 1 29.871 3.004 33.433 6.567 C 36.996 10.12 39 14.965 39 20 C 39 20 39 20 39 20 L 39 20 Z',
    },
    annotation_feature: {
        path: 'M 20 3.271 C 29.224 3.271 36.729 10.776 36.729 20 C 36.729 29.224 29.224 36.729 20 36.729 L 3.271 36.729 L 3.271 20 C 3.271 10.776 10.776 3.271 20 3.271 Z  M 20 1 C 9.506 1 1 9.506 1 20 L 1 39 L 20 39 C 30.494 39 39 30.494 39 20 C 39 9.506 30.496 1 20 1 Z  M 20.152 10.085 C 14.617 10.085 10.085 14.617 10.085 20.152 C 10.085 25.688 14.617 30.219 20.152 30.219 C 25.688 30.219 30.219 25.688 30.219 20.152 C 30.219 14.617 25.69 10.085 20.152 10.085 Z  M 20.152 26.349 C 16.744 26.349 13.955 23.561 13.955 20.152 C 13.955 16.744 16.744 13.955 20.152 13.955 C 23.561 13.955 26.349 16.744 26.349 20.152 C 26.349 23.561 23.561 26.349 20.152 26.349 Z  M 18.035 20.307 C 18.035 19.053 19.053 18.035 20.307 18.035 C 21.56 18.035 22.578 19.053 22.578 20.307 C 22.578 21.56 21.56 22.578 20.307 22.578 C 19.053 22.578 18.035 21.56 18.035 20.307 Z',
    },
    annotation_part: {
        path: 'M 20 3.271 C 29.224 3.271 36.729 10.776 36.729 20 C 36.729 29.224 29.224 36.729 20 36.729 L 3.271 36.729 L 3.271 20 C 3.271 10.776 10.776 3.271 20 3.271 Z  M 20 1 C 9.506 1 1 9.506 1 20 L 1 39 L 20 39 C 30.494 39 39 30.494 39 20 C 39 9.506 30.496 1 20 1 Z  M 20.152 10.085 C 14.617 10.085 10.085 14.617 10.085 20.152 C 10.085 25.688 14.617 30.219 20.152 30.219 C 25.688 30.219 30.219 25.688 30.219 20.152 C 30.219 14.617 25.69 10.085 20.152 10.085 Z  M 20.152 26.349 C 16.744 26.349 13.955 23.561 13.955 20.152 C 13.955 16.744 16.744 13.955 20.152 13.955 C 23.561 13.955 26.349 16.744 26.349 20.152 C 26.349 23.561 23.561 26.349 20.152 26.349 Z',
    },
    back: {
        path: 'M 21.203 38.607 C 21.005 38.607 20.817 38.536 20.67 38.406 L 1.828 21.821 C 1.752 21.753 1.679 21.68 1.611 21.604 C 1.26 21.203 1.055 20.706 1.021 20.158 C 1.011 20.117 1 20.063 1 20 C 1 19.957 1.005 19.922 1.011 19.894 C 1.011 19.878 1.011 19.861 1.011 19.845 C 1.052 19.199 1.342 18.607 1.828 18.178 L 20.668 1.595 C 20.817 1.464 21.005 1.393 21.203 1.393 C 21.436 1.393 21.656 1.492 21.81 1.667 C 22.104 2.001 22.073 2.514 21.737 2.808 L 3.126 19.191 L 38.191 19.191 C 38.637 19.191 39 19.554 39 20 C 39 20.447 38.637 20.809 38.191 20.809 L 3.131 20.809 L 21.739 37.192 C 22.074 37.486 22.106 37.999 21.811 38.333 C 21.656 38.508 21.435 38.607 21.203 38.607 Z',
    },
    perspective: {
        path: 'M 7.357 21.013 L 7.357 30.824 L 7.357 30.824 L 7.357 30.824 L 33.499 27.723 L 33.499 21.013 L 31.4 21.013 L 31.4 18.987 L 31.4 18.987 L 31.4 18.987 L 33.499 18.987 L 33.499 12.077 L 7.357 9.162 L 7.357 18.987 L 8.6 18.987 L 8.6 21.013 L 7.357 21.013 Z  M 6.087 21.013 L 6.087 32.255 L 6.087 32.255 L 34.764 28.848 L 34.764 10.95 L 6.087 7.745 L 6.087 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 21.013 L 6.087 21.013 Z  M 1 18.987 L 3.533 18.987 L 3.533 21.013 L 1 21.013 L 1 18.987 L 1 18.987 L 1 18.987 L 1 18.987 L 1 18.987 L 1 18.987 L 1 18.987 L 1 18.987 Z  M 11.133 18.987 L 13.667 18.987 L 13.667 21.013 L 11.133 21.013 L 11.133 18.987 L 11.133 18.987 L 11.133 18.987 L 11.133 18.987 L 11.133 18.987 L 11.133 18.987 L 11.133 18.987 Z  M 16.2 18.987 L 18.733 18.987 L 18.733 21.013 L 16.2 21.013 L 16.2 18.987 L 16.2 18.987 L 16.2 18.987 L 16.2 18.987 L 16.2 18.987 L 16.2 18.987 Z  M 21.267 18.987 L 23.8 18.987 L 23.8 21.013 L 21.267 21.013 L 21.267 18.987 L 21.267 18.987 L 21.267 18.987 L 21.267 18.987 L 21.267 18.987 Z  M 26.333 18.987 L 28.867 18.987 L 28.867 21.013 L 26.333 21.013 L 26.333 18.987 L 26.333 18.987 L 26.333 18.987 L 26.333 18.987 Z  M 36.467 18.987 L 39 18.987 L 39 21.013 L 36.467 21.013 L 36.467 18.987 L 36.467 18.987 Z',
    },
    clip_section: {
        path: 'M 24.553 7.879 L 27.098 7.879 L 27.098 9.297 L 24.553 9.297 L 24.553 7.879 Z  M 32.24 10.479 L 30.822 10.479 L 30.822 9.297 L 29.64 9.297 L 29.64 7.879 L 32.24 7.879 L 32.24 10.479 Z  M 32.24 25.712 L 30.822 25.712 L 30.822 21.903 L 32.24 21.903 L 32.24 25.712 Z  M 32.24 18.095 L 30.822 18.095 L 30.822 14.286 L 32.24 14.286 L 32.24 18.095 Z  M 32.24 32.119 L 29.64 32.119 L 29.64 30.701 L 30.822 30.701 L 30.822 29.519 L 32.24 29.519 L 32.24 32.119 Z  M 24.553 30.701 L 27.098 30.701 L 27.098 32.119 L 24.553 32.119 L 24.553 30.701 Z  M 21.063 7.879 L 22.009 7.879 L 22.009 9.297 L 21.063 9.297 L 21.063 7.879 Z  M 21.063 30.701 L 22.009 30.701 L 22.009 32.119 L 21.063 32.119 L 21.063 30.701 Z  M 19.173 1 L 19.173 7.643 L 9.762 7.643 C 8.656 7.643 7.76 8.539 7.76 9.645 L 7.76 30.355 C 7.76 31.459 8.656 32.357 9.762 32.357 L 19.173 32.357 L 19.173 39 L 21.063 39 L 21.063 32.357 L 21.063 7.643 L 21.063 1 L 19.173 1 Z  M 9.653 30.465 L 9.653 9.534 L 19.175 9.534 L 19.175 30.465 L 9.653 30.465 Z',
    },
    actions: {
        path: 'M28.359 20q-2.344 0-4.219 1.133t-3.008 3.008-1.133 4.219q0 2.266 1.133 4.18t3.008 3.008 4.219 1.094q2.266 0 4.18-1.094t3.008-3.008 1.094-4.18q0-2.344-1.094-4.219t-3.008-3.008-4.18-1.133zM31.094 32.266l-3.594-3.594v-5.313h1.641v4.609l3.125 3.125zM30 5h-5.313q-0.547-1.484-1.797-2.422t-2.891-0.938-2.891 0.938-1.797 2.422h-5.313q-1.406 0-2.383 0.977t-0.977 2.383v25q0 1.328 0.977 2.305t2.383 0.977h10.156q-1.484-1.406-2.344-3.281h-7.813v-25h3.359v5h13.281v-5h3.359v8.438q1.719 0.234 3.359 1.016v-9.453q0-1.406-0.977-2.383t-2.383-0.977zM20 8.359q-0.703 0-1.172-0.508t-0.469-1.211q0-0.625 0.469-1.133t1.172-0.508 1.172 0.508 0.469 1.133q0 0.703-0.469 1.211t-1.172 0.508z',
        customStroke: '0.5px',
    },
    reset_camera: {
        path: 'M 26.847 25.42 L 26.847 22.671 L 30.519 25.293 C 30.634 25.375 30.772 25.42 30.913 25.42 C 31.288 25.42 31.59 25.116 31.59 24.742 L 31.59 15.258 C 31.59 15.117 31.547 14.979 31.464 14.863 C 31.245 14.559 30.823 14.489 30.519 14.707 L 26.847 17.329 L 26.847 14.579 C 26.846 13.831 26.24 13.225 25.491 13.225 L 13.975 13.225 C 13.227 13.226 12.621 13.831 12.621 14.579 L 12.621 25.42 C 12.622 26.167 13.227 26.774 13.975 26.775 L 25.493 26.775 C 26.24 26.774 26.847 26.167 26.847 25.42 Z  M 13.975 14.579 L 25.493 14.579 L 25.493 18.644 C 25.493 18.784 25.536 18.922 25.62 19.038 C 25.838 19.342 26.26 19.412 26.564 19.194 L 30.236 16.573 L 30.236 23.425 L 26.564 20.803 C 26.449 20.722 26.311 20.676 26.17 20.676 C 25.796 20.676 25.493 20.981 25.493 21.354 L 25.493 25.418 L 13.975 25.418 L 13.975 14.579 Z  M 21.338 2.339 C 12.07 2.339 4.462 9.519 3.748 18.607 L 1.812 16.671 L 1 17.483 L 4.444 20.928 L 7.889 17.483 L 7.076 16.671 L 5.288 18.458 C 6.067 10.286 12.966 3.871 21.338 3.871 C 30.23 3.871 37.465 11.106 37.465 19.999 C 37.465 28.893 30.23 36.127 21.338 36.127 L 21.338 37.661 C 31.076 37.661 39 29.738 39 19.999 C 39 10.261 31.076 2.339 21.338 2.339 Z',
    },
    line: {
        path: 'M 0.999 36.883 L 36.879 1.003 L 38.993 3.117 L 3.113 38.997 L 0.999 36.883 Z',
    },
    circle: {
        path: 'M 20.5 39.5 C 10.024 39.5 1.5 30.976 1.5 20.5 C 1.5 10.024 10.024 1.5 20.5 1.5 C 30.976 1.5 39.5 10.024 39.5 20.5 C 39.5 30.976 30.976 39.5 20.5 39.5 Z  M 20.5 4.423 C 11.637 4.423 4.423 11.637 4.423 20.5 C 4.423 29.363 11.637 36.577 20.5 36.577 C 29.363 36.577 36.577 29.363 36.577 20.5 C 36.577 11.637 29.363 4.423 20.5 4.423 Z',
    },
    ellipse: {
        path: 'M 11.731 39 C 8.645 39 5.926 38.053 3.938 36.061 C -1.674 30.449 0.978 18.994 9.983 9.985 C 18.985 0.983 30.444 -1.679 36.06 3.94 L 36.06 3.94 C 41.675 9.556 39.023 21.011 30.018 30.019 C 24.196 35.831 17.357 39 11.731 39 Z  M 28.323 4.516 C 23.644 4.516 17.504 7.403 12.454 12.452 C 5.091 19.819 2.32 29.499 6.409 33.587 C 10.497 37.676 20.177 34.912 27.547 27.545 C 34.91 20.179 37.677 10.496 33.589 6.407 C 32.303 5.124 30.465 4.516 28.323 4.516 Z',
    },
    helix: {
        path: 'M 39 11.984 L 36.784 9.767 C 33 13.548 29.839 13.445 26.629 12.774 C 26.168 9.905 26.438 7.015 29.824 3.629 L 27.607 1.412 C 23.72 5.3 23.105 8.877 23.397 12.05 C 20.553 11.47 17.494 11.322 14.616 14.2 C 11.418 17.395 11.944 20.815 12.662 23.913 C 9.245 23.392 5.308 23.702 1 28.016 L 3.216 30.233 C 7 26.449 10.167 26.552 13.374 27.226 C 13.835 30.095 13.565 32.985 10.183 36.371 L 12.399 38.588 C 16.287 34.7 16.901 31.123 16.609 27.95 C 19.45 28.53 22.513 28.681 25.388 25.8 C 28.582 22.605 28.056 19.182 27.338 16.087 C 30.758 16.605 34.692 16.291 39 11.984 Z  M 23.958 15.385 C 24.014 15.617 24.065 15.859 24.121 16.084 C 24.754 18.749 25.087 20.564 24.171 22.248 L 18.02 15.501 C 19.666 14.529 21.428 14.793 23.958 15.385 Z  M 16.045 24.618 C 15.992 24.383 15.939 24.141 15.885 23.916 C 15.249 21.251 14.917 19.436 15.832 17.752 L 21.983 24.499 C 20.34 25.468 18.581 25.21 16.045 24.618 Z',
    },
    helix_alt: {
        path: 'M 39 11.985 L 36.784 9.769 C 33 13.55 29.839 13.446 26.629 12.775 C 26.168 9.907 26.438 7.016 29.824 3.63 L 27.607 1.414 C 23.72 5.301 23.105 8.878 23.397 12.051 C 20.553 11.471 17.494 11.324 14.616 14.202 C 11.418 17.396 11.944 20.817 12.662 23.911 C 9.245 23.391 5.311 23.701 1 28.015 L 3.216 30.231 C 7.004 26.447 10.167 26.551 13.374 27.225 C 13.835 30.093 13.565 32.984 10.183 36.37 L 12.399 38.586 C 16.287 34.699 16.901 31.122 16.609 27.949 C 19.45 28.529 22.513 28.679 25.388 25.798 C 28.582 22.604 28.056 19.18 27.338 16.086 C 30.758 16.606 34.692 16.293 39 11.985 Z  M 23.171 23.585 C 21.149 25.61 19.202 25.356 16.045 24.62 C 15.992 24.384 15.939 24.143 15.885 23.917 C 15.08 20.541 14.725 18.525 16.832 16.418 C 18.86 14.39 20.817 14.65 23.958 15.387 C 24.014 15.619 24.065 15.86 24.121 16.086 C 24.924 19.462 25.278 21.478 23.171 23.585 Z',
    },
    hyperbola: {
        path: 'M 21.583 1 L 18.417 1 L 18.417 18.417 L 1 18.417 L 1 21.583 L 18.417 21.583 L 18.417 39 L 21.583 39 L 21.583 21.583 L 39 21.583 L 39 18.417 L 21.583 18.417 L 21.583 1 Z  M 35.181 11.396 C 31.891 11.396 29.215 8.72 29.215 5.43 L 29.215 1 L 26.048 1 L 26.048 5.43 C 26.048 10.465 30.146 14.563 35.181 14.563 L 39 14.563 L 39 11.396 L 35.181 11.396 Z  M 5.433 26.048 L 1 26.048 L 1 29.215 L 5.433 29.215 C 8.724 29.215 11.399 31.891 11.399 35.181 L 11.399 39 L 14.566 39 L 14.566 35.181 C 14.563 30.146 10.465 26.048 5.433 26.048 Z',
    },
    parabola: {
        path: 'M 26.162 20.082 C 25.19 25.434 24.37 28.99 21.583 29.915 L 21.583 1 L 18.417 1 L 18.417 29.915 C 15.63 28.99 14.81 25.434 13.838 20.086 C 12.774 14.221 11.45 6.922 4.002 6.922 L 4.002 10.088 C 8.48 10.088 9.528 14.078 10.722 20.649 C 11.71 26.096 12.875 32.147 18.417 33.139 L 18.417 39 L 21.583 39 L 21.583 33.139 C 27.122 32.151 28.287 26.096 29.278 20.649 C 30.472 14.078 31.52 10.088 35.998 10.088 L 35.998 6.922 C 28.55 6.922 27.226 14.221 26.162 20.082 Z',
    },
    sphere: {
        path: 'M 20.001 1 C 9.525 1 1 9.525 1 20.001 C 1 30.475 9.522 39 20.001 39 C 30.475 39 39 30.478 39 20.001 C 39 9.525 30.478 1 20.001 1 Z  M 20.001 3.975 C 26.98 3.975 32.869 8.487 35.062 14.728 C 31.364 12.651 25.582 11.557 20.001 11.557 C 14.418 11.557 8.639 12.651 4.938 14.728 C 7.134 8.49 13.023 3.975 20.001 3.975 Z  M 36.025 20.001 C 36.025 22.286 29.931 25.472 20.001 25.472 C 10.072 25.472 3.975 22.286 3.975 20.001 C 3.975 17.717 10.072 14.531 20.001 14.531 C 29.931 14.531 36.025 17.717 36.025 20.001 Z  M 20.001 36.025 C 13.023 36.025 7.134 31.513 4.938 25.275 C 8.639 27.352 14.418 28.446 20.001 28.446 C 25.582 28.446 31.364 27.352 35.062 25.275 C 32.869 31.513 26.983 36.025 20.001 36.025 Z',
    },
    render: {
        path: 'M 29.976 3.023 L 10.024 3.023 L 1 15.054 L 20 36.977 L 39 15.054 L 29.976 3.023 Z  M 34.632 13.664 L 27.388 13.664 L 22.4 5.683 L 28.646 5.683 L 34.632 13.664 Z  M 12.421 16.324 L 17.414 29.932 L 5.621 16.324 L 12.421 16.324 Z  M 15.254 16.324 L 24.746 16.324 L 19.999 29.255 L 15.254 16.324 Z  M 15.75 13.664 L 20 6.863 L 24.251 13.664 L 15.75 13.664 Z  M 27.579 16.324 L 34.379 16.324 L 22.584 29.933 L 27.579 16.324 Z  M 11.354 5.683 L 17.6 5.683 L 12.612 13.664 L 5.368 13.664 L 11.354 5.683 Z',
        customStroke: '0.5px',
    },
    standard_view: {
        path: 'M 13.214 1 L 1 1 L 1 13.214 L 3.714 13.214 L 3.714 3.714 L 13.214 3.714 L 13.214 1 Z  M 1 26.786 L 1 39 L 13.214 39 L 13.214 36.286 L 3.714 36.286 L 3.714 26.786 L 1 26.786 Z  M 39 13.214 L 39 1 L 26.786 1 L 26.786 3.714 L 36.286 3.714 L 36.286 13.214 L 39 13.214 Z  M 26.786 39 L 39 39 L 39 26.786 L 36.286 26.786 L 36.286 36.286 L 26.786 36.286 L 26.786 39 Z  M 32.879 12.034 L 20.665 5.248 C 20.245 5.005 19.728 5.005 19.308 5.248 L 7.094 12.034 C 6.677 12.28 6.424 12.73 6.429 13.214 L 6.429 26.786 C 6.429 27.275 6.694 27.726 7.121 27.966 L 19.335 34.752 C 19.755 34.995 20.272 34.995 20.692 34.752 L 32.906 27.966 C 33.323 27.72 33.576 27.27 33.571 26.786 L 33.571 13.214 C 33.571 12.725 33.306 12.273 32.879 12.034 Z  M 20 7.976 L 29.419 13.214 L 20 18.453 L 10.581 13.214 L 20 7.976 Z  M 9.143 15.521 L 18.643 20.801 L 18.643 31.264 L 9.143 25.985 L 9.143 15.521 Z  M 21.357 31.264 L 21.357 20.801 L 30.857 15.521 L 30.857 25.985 L 21.357 31.264 Z',
        customStroke: '0.5px',
    },
    axis: {
        path: 'M 31.895 36.185 L 26.927 36.185 L 26.927 39 L 36.625 39 L 36.625 29.148 L 33.854 29.148 L 33.854 34.195 L 21.385 21.527 L 19.999 22.547 L 19.999 24.101 L 31.895 36.185 Z  M 8.105 36.185 L 13.073 36.185 L 13.073 39 L 3.375 39 L 3.375 29.148 L 6.146 29.148 L 6.146 34.195 L 18.615 21.527 L 19.999 22.547 L 19.999 24.101 L 8.105 36.185 Z  M 18.613 12.26 L 18.613 21.527 L 19.999 22.547 L 21.385 21.527 L 21.385 12.26 L 21.385 6.629 L 21.385 6.387 L 24.967 10.026 L 26.927 8.036 L 19.999 1 L 13.073 8.036 L 15.031 10.026 L 18.613 6.387 L 18.613 6.629 L 18.613 12.26 Z',
    },
    axis_x: {
        path: 'M 8.105 36.185 L 13.073 36.185 L 13.073 39 L 3.375 39 L 3.375 29.148 L 6.146 29.148 L 6.146 34.195 L 18.615 21.527 L 19.999 22.547 L 19.999 24.101 L 8.105 36.185 Z',
    },
    axis_y: {
        path: 'M 32.084 36.185 L 27.038 36.185 L 27.038 39 L 36.89 39 L 36.89 29.148 L 34.074 29.148 L 34.074 34.195 L 21.407 21.527 L 19.999 22.547 L 19.999 24.101 L 32.084 36.185 Z',
    },
    axis_z: {
        path: 'M 18.591 12.26 L 18.591 21.527 L 19.999 22.547 L 21.407 21.527 L 21.407 12.26 L 21.407 6.629 L 21.407 6.387 L 25.046 10.026 L 27.038 8.036 L 19.999 1 L 12.962 8.036 L 14.952 10.026 L 18.591 6.387 L 18.591 6.629 L 18.591 12.26 Z',
    },
    collapse: {
        path: 'M 35.061 2.9 L 35.061 18.018 L 7.148 18.018 L 15.876 9.218 L 13.793 7.115 L 1 20.002 L 13.793 32.889 L 15.876 30.782 L 7.148 21.986 L 35.061 21.986 L 35.061 37.1 L 39 37.1 L 39 2.9 L 35.061 2.9 Z',
    },
    collapse_right: {
        path: 'M3.72 21.4V13.1h15.35l-4.8 4.84 1.14 1.16 7.04-7.1-7.04-7.08-1.14 1.16 4.8 4.84H3.72V2.6H1.55v18.8h2.17z',
    },
    send: {
        path: 'M 36.897 1.074 C 37.475 0.862 38.124 1.004 38.561 1.439 C 38.985 1.882 39.114 2.531 38.894 3.103 L 26.213 37.977 C 25.99 38.594 25.41 39.01 24.754 39.023 C 24.122 39.005 23.561 38.612 23.328 38.024 L 17.241 22.807 L 2.023 16.72 C 1.407 16.486 1 15.896 1 15.238 C 1 14.579 1.407 13.989 2.023 13.755 L 36.897 1.074 Z  M 20.331 21.903 L 24.754 32.999 L 34.788 5.211 L 7 15.245 L 18.033 19.731 L 25.689 12.075 L 27.924 14.31 L 20.331 21.903 Z',
    },
    more: {
        path: 'M 32.667 20 C 32.667 21.749 34.084 23.167 35.833 23.167 C 37.582 23.167 39 21.749 39 20 C 39 18.251 37.582 16.833 35.833 16.833 C 34.084 16.833 32.667 18.251 32.667 20 Z  M 16.833 20 C 16.833 21.749 18.251 23.167 20 23.167 C 21.749 23.167 23.167 21.749 23.167 20 C 23.167 18.251 21.749 16.833 20 16.833 C 18.251 16.833 16.833 18.251 16.833 20 Z  M 1 20 C 1 21.749 2.418 23.167 4.167 23.167 C 5.916 23.167 7.333 21.749 7.333 20 C 7.333 18.251 5.916 16.833 4.167 16.833 C 2.418 16.833 1 18.251 1 20 Z',
    },
    menu: {
        path: 'M4 4h16v2H4z M4 9h16v2H4z M4 14h16v2H4z M4 19h16v2H4z',
    },
    laptop: {
        path: 'M19.5 18h-15A1.5 1.5 0 013 16.5V6c0-.82.67-1.5 1.5-1.5h15c.83 0 1.5.68 1.5 1.5v10.5c0 .83-.67 1.5-1.5 1.5zM4.5 6v10.5h15V6zm0 0M1.5 19.5h21V21h-21zm0 0',
    },
    ruler: {
        path: 'M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z',
    },
};

var wikifactoryNew = __assign(__assign({}, global$2), { color: color, font: font$1, breakpoints: breakpoints$1, icons: icons$1 });

var getPrimaryColor = function (primaryColor) {
    switch (primaryColor) {
        case 'black':
            return {
                borderColor: 'black',
                backgroundColor: 'black',
                color: 'white',
            };
        case 'black-hollow':
            return {
                borderColor: 'black',
                backgroundColor: 'transparent',
                color: 'black',
            };
        case 'gray':
            return {
                borderColor: 'gray',
                backgroundColor: 'gray',
                color: 'white',
            };
        case 'gray-hollow':
            return {
                borderColor: 'gray',
                backgroundColor: 'transparent',
                color: 'gray',
            };
        case 'blue':
            return {
                borderColor: 'blue',
                backgroundColor: 'blue',
                color: 'white',
            };
        case 'blue-hollow':
            return {
                borderColor: 'blue',
                backgroundColor: 'transparent',
                color: 'blue',
            };
        case 'wf-blue':
            return {
                borderColor: wikifactoryNew.color.wfBlue,
                backgroundColor: 'transparent',
                color: wikifactoryNew.color.wfBlue,
            };
        default:
            return {};
    }
};

var Button = function (props) {
    var _a = props.primaryColor, primaryColor = _a === void 0 ? 'black' : _a, hidden = props.hidden, loading = props.loading, buttonProps = __rest(props, ["primaryColor", "hidden", "loading"]);
    var theme = getPrimaryColor(primaryColor);
    if (hidden)
        return null;
    var MButton = loading ? LoadingButton$1 : MuiButton;
    var loadingProp = {};
    if (loading)
        loadingProp.loading = loading;
    return (React__default.createElement(MButton, __assign({}, loadingProp, buttonProps, { sx: __assign(__assign({ borderRadius: '28px', '&:hover': theme, textTransform: 'capitalize' }, theme), props.sx) })));
};

var _g$8, _rect$4;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var SvgDownload$1 = function SvgDownload(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g$8 || (_g$8 = /*#__PURE__*/React$1.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#download_svg__clip0_702_8462)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M15.75 15v1.5h-7.5V15H7.5v1.5a.75.75 0 0 0 .75.75h7.5a.75.75 0 0 0 .75-.75V15zM15.75 11.25l-.529-.529-2.846 2.843V6.75h-.75v6.814L8.779 10.72l-.529.529L12 15z"
  }))), _rect$4 || (_rect$4 = /*#__PURE__*/React$1.createElement("rect", {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 11.5
  })));
};

var _path$e;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17
  }, props), /*#__PURE__*/React$1.createElement("path", {
    d: "M12.247 11.526h-.238v-.951h.238a2.142 2.142 0 0 0 .171-4.28h-.409l-.048-.39a3.33 3.33 0 0 0-6.6 0l-.01.39h-.41a2.142 2.142 0 0 0 .172 4.28h.238v.95h-.238a3.091 3.091 0 0 1-.618-6.115 4.28 4.28 0 0 1 8.37 0 3.091 3.091 0 0 1-.618 6.116",
    style: {
      strokeWidth: 0.47559
    }
  }), _path$e || (_path$e = /*#__PURE__*/React$1.createElement("path", {
    d: "m11.058 12.953-.67-.671-1.233 1.227V7.721h-.95v5.788l-1.233-1.227-.67.67 2.378 2.379z"
  })), /*#__PURE__*/React$1.createElement("path", {
    d: "M0 0h32v32H0z",
    style: {
      fill: "none"
    }
  }));
};

var _path$d;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 14,
    fill: "none"
  }, props), _path$d || (_path$d = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M9 6H8V3a3 3 0 1 0-6 0v3H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1M3 3a2 2 0 1 1 4 0v3H3zm6 10H1V7h8z"
  })));
};

var _g$7;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _g$7 || (_g$7 = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#unlock_svg__clip0_334_17852)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M12.965 7.5h-6v-3a2 2 0 0 1 4 0h1a3 3 0 1 0-6 0v3h-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1m0 7h-8v-6h8z"
  }))));
};

var _g$6, _rect$3;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var SvgUpload$1 = function SvgUpload(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0.1 0 24 24"
  }, props), _g$6 || (_g$6 = /*#__PURE__*/React$1.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#upload_svg__clip0_702_8469)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "m10.125 12.75.529.529.971-.968v4.564h.75v-4.564l.971.968.529-.529L12 10.875z"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M14.813 14.25h-.188v-.75h.188a1.689 1.689 0 0 0 .135-3.375h-.323l-.037-.308a2.625 2.625 0 0 0-5.205 0l-.008.308h-.322a1.689 1.689 0 1 0 .135 3.375h.187v.75h-.187A2.437 2.437 0 0 1 8.7 9.427a3.375 3.375 0 0 1 6.6 0 2.437 2.437 0 0 1-.487 4.823"
  }))), _rect$3 || (_rect$3 = /*#__PURE__*/React$1.createElement("rect", {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 12.5
  })));
};

var _path$c;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var SvgRightStartArrow = function SvgRightStartArrow(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$c || (_path$c = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M4.668 3.333v1h6.295l-8.295 8.295.705.705 8.295-8.295v6.295h1v-8z"
  })));
};

var DriveControl = function (props) {
    var _a = props.title, title = _a === void 0 ? 'Cloud Drive' : _a;
    // const { view, switchView } = useViewSwitch({
    //   view: 'grid',
    //   onViewChanged: props.onViewChanged,
    // });
    // const gridIconClassName = view.grid.className;
    // const viewIconClassName = view.tree.className;
    return (React__default.createElement("section", { className: 'flex justify-center items-center' },
        React__default.createElement("h1", { className: 'text-24 font-extrabold', style: { color: 'rgb(0, 0, 0, 0.87)' } }, title)));
};
var DriveAction = function (props) {
    var onLock = props.onLock, onDownload = props.onDownload, onUnlock = props.onUnlock, onSync = props.onSync, onUpload = props.onUpload, onCreateRFQ = props.onCreateRFQ, buttonsDisabled = props.buttonsDisabled;
    return (React__default.createElement("section", { className: 'flex items-center gap-x-2' },
        onCreateRFQ && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button, { size: 'small', primaryColor: 'black-hollow', variant: 'outlined', disabled: buttonsDisabled, onClick: onCreateRFQ },
                React__default.createElement("span", { className: 'text-10' }, "Create RFQ")),
            React__default.createElement(Divider$1, { orientation: 'vertical', flexItem: true }))),
        onDownload && (React__default.createElement(IconButton$1, { color: 'inherit', size: 'small', sx: { padding: 0, transition: '0.2s', height: 30 }, disabled: buttonsDisabled, onClick: onDownload },
            React__default.createElement(SvgDownload$1, null))),
        onUpload && (React__default.createElement(IconButton$1, { color: 'inherit', size: 'small', sx: { padding: 0, transition: '0.2s', height: 30 }, disabled: buttonsDisabled, onClick: onUpload },
            React__default.createElement(SvgUpload$1, null))),
        onSync && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button, { size: 'small', primaryColor: 'black-hollow', variant: 'outlined', onClick: onSync, endIcon: React__default.createElement("span", { style: {
                        marginLeft: '-5px',
                    } },
                    React__default.createElement(SvgDownload, null)) },
                React__default.createElement("span", { className: 'text-10 tracking-0.02' }, "Sync")),
            React__default.createElement(Divider$1, { orientation: 'vertical', flexItem: true }))),
        onUnlock && (React__default.createElement(Button, { primaryColor: 'blue-hollow', size: 'small', variant: 'outlined', onClick: onUnlock, disabled: buttonsDisabled, endIcon: React__default.createElement("span", { style: {
                    marginLeft: '-5px',
                } },
                React__default.createElement(SvgUnlock, null)) },
            React__default.createElement("span", { className: 'text-10 tracking-0.02' }, "Unlock"))),
        onLock && (React__default.createElement(Button, { primaryColor: 'blue-hollow', size: 'small', variant: 'outlined', onClick: onLock, disabled: buttonsDisabled, endIcon: React__default.createElement("span", { style: {
                    marginLeft: '-5px',
                } },
                React__default.createElement(SvgLock, null)) },
            React__default.createElement("span", { className: 'text-10 tracking-0.02' }, "Lock")))));
};
var FolderNavigate = function (props) {
    var breadcrumbs = props.breadcrumbs, onBreadcrumbClick = props.onBreadcrumbClick, onOpenLocalFolderClick = props.onOpenLocalFolderClick;
    if (!breadcrumbs || breadcrumbs.length === 0)
        return null;
    return (React__default.createElement("div", { className: 'flex items-center', style: { marginTop: '14px' } },
        React__default.createElement(MBreadcrumbs, { "aria-label": 'breadcrumb', sx: {
                '& .MuiBreadcrumbs-separator': { padding: '0' },
                '& .css-1wuw8dw-MuiBreadcrumbs-separator': {
                    marginLeft: '4px',
                    marginRight: '4px',
                },
            } }, breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function (breadcrumb, index) { return (React__default.createElement(Typography$1, { key: "".concat(index) },
            React__default.createElement("span", { onClick: function () {
                    onBreadcrumbClick === null || onBreadcrumbClick === void 0 ? void 0 : onBreadcrumbClick(breadcrumb, index);
                }, className: 'text-black-1000 text-16 font-bold cursor-pointer hover:text-primary hover:underline hover:font-extrabold' }, breadcrumb))); })),
        onOpenLocalFolderClick && (React__default.createElement(Box$1, { className: 'flex' },
            React__default.createElement(Tooltip$1, { componentsProps: {
                    tooltip: { sx: { backgroundColor: 'black' } },
                    arrow: { sx: { color: 'black' } },
                }, title: 'Open Local Folder', placement: 'right-start', arrow: true },
                React__default.createElement(Box$1, { className: 'hover:text-primary' },
                    React__default.createElement(SvgRightStartArrow, { "data-test-id": 'openLocalFolder-icon', className: 'ml-2.5 cursor-pointer', onClick: onOpenLocalFolderClick })))))));
};
var DriveToolBar = function (props) {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("section", { className: 'flex items-center justify-between mt-4 mb-2' },
            React__default.createElement(DriveControl, __assign({}, props)),
            React__default.createElement(DriveAction, __assign({}, props))),
        props.banner,
        React__default.createElement(FolderNavigate, __assign({}, props))));
};

var renderHeader$1 = function (column) {
    if (column.title instanceof Function) {
        return column.title();
    }
    return column.title;
};
var Header$1 = function (props) {
    var columns = props.columns;
    return (React__default.createElement(TableHead$1, { sx: { position: 'sticky', top: 0, backgroundColor: 'white' } },
        React__default.createElement(TableRow$1, null, columns.map(function (column, index) {
            var _a;
            return (React__default.createElement(TableCell$1, { sx: {
                    paddingTop: '4px',
                    paddingBottom: '4px',
                    fontWeight: 800,
                }, key: (_a = column === null || column === void 0 ? void 0 : column.key) !== null && _a !== void 0 ? _a : index, align: 'left', style: column.headerCellStyle }, renderHeader$1(column)));
        }))));
};

var renderCell$1 = function (_a) {
    var data = _a.data, column = _a.column, row = _a.row;
    if (column.renderCell) {
        return column.renderCell(data, row);
    }
    if (column.field) {
        return data[column.field];
    }
    return null;
};
var BodySkeleton$1 = function (_a) {
    var columns = _a.columns;
    return (React__default.createElement(TableRow$1, { className: 'hover:bg-gray-200' }, columns.map(function (column, columnIndex) { return (React__default.createElement(TableCell$1, { itemID: "".concat(columnIndex), key: columnIndex, align: 'left', style: column.bodyCellStyle },
        React__default.createElement(Typography$1, { component: 'div', variant: 'caption' },
            React__default.createElement(Skeleton$1, null)))); })));
};
var Body = function (_a) {
    var columns = _a.columns, dataSource = _a.dataSource, rowKey = _a.rowKey, _b = _a.loading, loading = _b === void 0 ? false : _b;
    return (React__default.createElement(TableBody$1, null, loading ? (React__default.createElement(BodySkeleton$1, { columns: columns })) : (dataSource.map(function (data, row) {
        var key = rowKey(data);
        return (React__default.createElement(TableRow$1, { key: key, className: 'hover:bg-gray-200' }, columns.map(function (column, columnIndex) { return (React__default.createElement(TableCell$1, { itemID: "cell-".concat(row, "-").concat(columnIndex), key: "".concat(key, "-").concat(columnIndex), align: 'left', style: column.bodyCellStyle }, renderCell$1({
            data: data,
            row: row,
            column: column,
        }))); })));
    }))));
};

var Table$1 = function (props) {
    return (React__default.createElement(TableContainer$1, { component: Paper$1, sx: { boxShadow: 'none', maxHeight: 400 }, className: "border border-gray-300 ".concat(props.className, " ") },
        React__default.createElement(MuiTable, { "aria-label": 'table' },
            React__default.createElement(Header$1, __assign({}, props)),
            React__default.createElement(Body, __assign({}, props)))));
};

const PUBLISH = 0;
const SUBSCRIBE = 1;
const RESET = 2;
const VALUE = 4;
function compose(a, b) {
  return (arg) => a(b(arg));
}
function thrush(arg, proc) {
  return proc(arg);
}
function curry2to1(proc, arg1) {
  return (arg2) => proc(arg1, arg2);
}
function curry1to0(proc, arg) {
  return () => proc(arg);
}
function tap(arg, proc) {
  proc(arg);
  return arg;
}
function tup(...args) {
  return args;
}
function call(proc) {
  proc();
}
function always(value) {
  return () => value;
}
function joinProc(...procs) {
  return () => {
    procs.map(call);
  };
}
function isDefined(arg) {
  return arg !== void 0;
}
function noop() {
}
function subscribe(emitter, subscription) {
  return emitter(SUBSCRIBE, subscription);
}
function publish(publisher, value) {
  publisher(PUBLISH, value);
}
function reset(emitter) {
  emitter(RESET);
}
function getValue(depot) {
  return depot(VALUE);
}
function connect(emitter, publisher) {
  return subscribe(emitter, curry2to1(publisher, PUBLISH));
}
function handleNext(emitter, subscription) {
  const unsub = emitter(SUBSCRIBE, (value) => {
    unsub();
    subscription(value);
  });
  return unsub;
}
function stream() {
  const subscriptions = [];
  return (action, arg) => {
    switch (action) {
      case RESET:
        subscriptions.splice(0, subscriptions.length);
        return;
      case SUBSCRIBE:
        subscriptions.push(arg);
        return () => {
          const indexOf = subscriptions.indexOf(arg);
          if (indexOf > -1) {
            subscriptions.splice(indexOf, 1);
          }
        };
      case PUBLISH:
        subscriptions.slice().forEach((subscription) => {
          subscription(arg);
        });
        return;
      default:
        throw new Error(`unrecognized action ${action}`);
    }
  };
}
function statefulStream(initial) {
  let value = initial;
  const innerSubject = stream();
  return (action, arg) => {
    switch (action) {
      case SUBSCRIBE:
        const subscription = arg;
        subscription(value);
        break;
      case PUBLISH:
        value = arg;
        break;
      case VALUE:
        return value;
    }
    return innerSubject(action, arg);
  };
}
function eventHandler(emitter) {
  let unsub;
  let currentSubscription;
  const cleanup = () => unsub && unsub();
  return function(action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        if (subscription) {
          if (currentSubscription === subscription) {
            return;
          }
          cleanup();
          currentSubscription = subscription;
          unsub = subscribe(emitter, subscription);
          return unsub;
        } else {
          cleanup();
          return noop;
        }
      case RESET:
        cleanup();
        currentSubscription = null;
        return;
      default:
        throw new Error(`unrecognized action ${action}`);
    }
  };
}
function streamFromEmitter(emitter) {
  return tap(stream(), (stream2) => connect(emitter, stream2));
}
function statefulStreamFromEmitter(emitter, initial) {
  return tap(statefulStream(initial), (stream2) => connect(emitter, stream2));
}
function combineOperators(...operators) {
  return (subscriber) => {
    return operators.reduceRight(thrush, subscriber);
  };
}
function pipe(source, ...operators) {
  const project = combineOperators(...operators);
  return (action, subscription) => {
    switch (action) {
      case SUBSCRIBE:
        return subscribe(source, project(subscription));
      case RESET:
        reset(source);
        return;
    }
  };
}
function defaultComparator(previous, next) {
  return previous === next;
}
function distinctUntilChanged(comparator = defaultComparator) {
  let current;
  return (done) => (next) => {
    if (!comparator(current, next)) {
      current = next;
      done(next);
    }
  };
}
function filter(predicate) {
  return (done) => (value) => {
    predicate(value) && done(value);
  };
}
function map(project) {
  return (done) => compose(done, project);
}
function mapTo(value) {
  return (done) => () => done(value);
}
function scan(scanner, initial) {
  return (done) => (value) => done(initial = scanner(initial, value));
}
function skip(times) {
  return (done) => (value) => {
    times > 0 ? times-- : done(value);
  };
}
function throttleTime(interval) {
  let currentValue = null;
  let timeout;
  return (done) => (value) => {
    currentValue = value;
    if (timeout) {
      return;
    }
    timeout = setTimeout(() => {
      timeout = void 0;
      done(currentValue);
    }, interval);
  };
}
function debounceTime(interval) {
  let currentValue;
  let timeout;
  return (done) => (value) => {
    currentValue = value;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      done(currentValue);
    }, interval);
  };
}
function withLatestFrom(...sources) {
  const values = new Array(sources.length);
  let called = 0;
  let pendingCall = null;
  const allCalled = Math.pow(2, sources.length) - 1;
  sources.forEach((source, index) => {
    const bit = Math.pow(2, index);
    subscribe(source, (value) => {
      const prevCalled = called;
      called = called | bit;
      values[index] = value;
      if (prevCalled !== allCalled && called === allCalled && pendingCall) {
        pendingCall();
        pendingCall = null;
      }
    });
  });
  return (done) => (value) => {
    const call2 = () => done([value].concat(values));
    if (called === allCalled) {
      call2();
    } else {
      pendingCall = call2;
    }
  };
}
function merge(...sources) {
  return function(action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        return joinProc(...sources.map((source) => subscribe(source, subscription)));
      case RESET:
        return;
      default:
        throw new Error(`unrecognized action ${action}`);
    }
  };
}
function duc(source, comparator = defaultComparator) {
  return pipe(source, distinctUntilChanged(comparator));
}
function combineLatest(...emitters) {
  const innerSubject = stream();
  const values = new Array(emitters.length);
  let called = 0;
  const allCalled = Math.pow(2, emitters.length) - 1;
  emitters.forEach((source, index) => {
    const bit = Math.pow(2, index);
    subscribe(source, (value) => {
      values[index] = value;
      called = called | bit;
      if (called === allCalled) {
        publish(innerSubject, values);
      }
    });
  });
  return function(action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        if (called === allCalled) {
          subscription(values);
        }
        return subscribe(innerSubject, subscription);
      case RESET:
        return reset(innerSubject);
      default:
        throw new Error(`unrecognized action ${action}`);
    }
  };
}
function system(constructor, dependencies = [], { singleton } = { singleton: true }) {
  return {
    id: id(),
    constructor,
    dependencies,
    singleton
  };
}
const id = () => Symbol();
function init(systemSpec) {
  const singletons = /* @__PURE__ */ new Map();
  const _init = ({ id: id2, constructor, dependencies, singleton }) => {
    if (singleton && singletons.has(id2)) {
      return singletons.get(id2);
    }
    const system2 = constructor(dependencies.map((e) => _init(e)));
    if (singleton) {
      singletons.set(id2, system2);
    }
    return system2;
  };
  return _init(systemSpec);
}
function omit(keys, obj) {
  const result = {};
  const index = {};
  let idx = 0;
  const len = keys.length;
  while (idx < len) {
    index[keys[idx]] = 1;
    idx += 1;
  }
  for (const prop in obj) {
    if (!index.hasOwnProperty(prop)) {
      result[prop] = obj[prop];
    }
  }
  return result;
}
const useIsomorphicLayoutEffect$2 = typeof document !== "undefined" ? React__default.useLayoutEffect : React__default.useEffect;
function systemToComponent(systemSpec, map2, Root) {
  const requiredPropNames = Object.keys(map2.required || {});
  const optionalPropNames = Object.keys(map2.optional || {});
  const methodNames = Object.keys(map2.methods || {});
  const eventNames = Object.keys(map2.events || {});
  const Context = React__default.createContext({});
  function applyPropsToSystem(system2, props) {
    if (system2["propsReady"]) {
      publish(system2["propsReady"], false);
    }
    for (const requiredPropName of requiredPropNames) {
      const stream2 = system2[map2.required[requiredPropName]];
      publish(stream2, props[requiredPropName]);
    }
    for (const optionalPropName of optionalPropNames) {
      if (optionalPropName in props) {
        const stream2 = system2[map2.optional[optionalPropName]];
        publish(stream2, props[optionalPropName]);
      }
    }
    if (system2["propsReady"]) {
      publish(system2["propsReady"], true);
    }
  }
  function buildMethods(system2) {
    return methodNames.reduce((acc, methodName) => {
      acc[methodName] = (value) => {
        const stream2 = system2[map2.methods[methodName]];
        publish(stream2, value);
      };
      return acc;
    }, {});
  }
  function buildEventHandlers(system2) {
    return eventNames.reduce((handlers, eventName) => {
      handlers[eventName] = eventHandler(system2[map2.events[eventName]]);
      return handlers;
    }, {});
  }
  const Component = React__default.forwardRef((propsWithChildren, ref) => {
    const { children, ...props } = propsWithChildren;
    const [system2] = React__default.useState(() => {
      return tap(init(systemSpec), (system22) => applyPropsToSystem(system22, props));
    });
    const [handlers] = React__default.useState(curry1to0(buildEventHandlers, system2));
    useIsomorphicLayoutEffect$2(() => {
      for (const eventName of eventNames) {
        if (eventName in props) {
          subscribe(handlers[eventName], props[eventName]);
        }
      }
      return () => {
        Object.values(handlers).map(reset);
      };
    }, [props, handlers, system2]);
    useIsomorphicLayoutEffect$2(() => {
      applyPropsToSystem(system2, props);
    });
    React__default.useImperativeHandle(ref, always(buildMethods(system2)));
    return React__default.createElement(
      Context.Provider,
      { value: system2 },
      Root ? React__default.createElement(
        Root,
        omit([...requiredPropNames, ...optionalPropNames, ...eventNames], props),
        children
      ) : children
    );
  });
  const usePublisher2 = (key) => {
    return React__default.useCallback(curry2to1(publish, React__default.useContext(Context)[key]), [key]);
  };
  const useEmitterValue2 = (key) => {
    const system2 = React__default.useContext(Context);
    const source = system2[key];
    const [value, setValue] = React__default.useState(curry1to0(getValue, source));
    useIsomorphicLayoutEffect$2(
      () => subscribe(source, (next) => {
        if (next !== value) {
          setValue(always(next));
        }
      }),
      [source, value]
    );
    return value;
  };
  const useEmitter2 = (key, callback) => {
    const context = React__default.useContext(Context);
    const source = context[key];
    useIsomorphicLayoutEffect$2(() => subscribe(source, callback), [callback, source]);
  };
  return {
    Component,
    usePublisher: usePublisher2,
    useEmitterValue: useEmitterValue2,
    useEmitter: useEmitter2
  };
}
const useIsomorphicLayoutEffect = typeof document !== "undefined" ? React__default.useLayoutEffect : React__default.useEffect;
const useIsomorphicLayoutEffect$1 = useIsomorphicLayoutEffect;
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
  LogLevel2[LogLevel2["INFO"] = 1] = "INFO";
  LogLevel2[LogLevel2["WARN"] = 2] = "WARN";
  LogLevel2[LogLevel2["ERROR"] = 3] = "ERROR";
  return LogLevel2;
})(LogLevel || {});
const CONSOLE_METHOD_MAP = {
  [
    0
    /* DEBUG */
  ]: "debug",
  [
    1
    /* INFO */
  ]: "log",
  [
    2
    /* WARN */
  ]: "warn",
  [
    3
    /* ERROR */
  ]: "error"
};
const getGlobalThis = () => typeof globalThis === "undefined" ? window : globalThis;
const loggerSystem = system(
  () => {
    const logLevel = statefulStream(
      3
      /* ERROR */
    );
    const log = statefulStream((label, message, level = 1) => {
      var _a;
      const currentLevel = (_a = getGlobalThis()["VIRTUOSO_LOG_LEVEL"]) != null ? _a : getValue(logLevel);
      if (level >= currentLevel) {
        console[CONSOLE_METHOD_MAP[level]](
          "%creact-virtuoso: %c%s %o",
          "color: #0253b3; font-weight: bold",
          "color: initial",
          label,
          message
        );
      }
    });
    return {
      log,
      logLevel
    };
  },
  [],
  { singleton: true }
);
function useSizeWithElRef(callback, enabled = true) {
  const ref = React__default.useRef(null);
  let callbackRef = (_el) => {
  };
  if (typeof ResizeObserver !== "undefined") {
    const observer = React__default.useMemo(() => {
      return new ResizeObserver((entries) => {
        const element = entries[0].target;
        if (element.offsetParent !== null) {
          callback(element);
        }
      });
    }, [callback]);
    callbackRef = (elRef) => {
      if (elRef && enabled) {
        observer.observe(elRef);
        ref.current = elRef;
      } else {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
        ref.current = null;
      }
    };
  }
  return { ref, callbackRef };
}
function useSize(callback, enabled = true) {
  return useSizeWithElRef(callback, enabled).callbackRef;
}
function useChangedListContentsSizes(callback, itemSize, enabled, scrollContainerStateCallback, log, gap, customScrollParent) {
  const memoedCallback = React__default.useCallback(
    (el) => {
      const ranges = getChangedChildSizes(el.children, itemSize, "offsetHeight", log);
      let scrollableElement = el.parentElement;
      while (!scrollableElement.dataset["virtuosoScroller"]) {
        scrollableElement = scrollableElement.parentElement;
      }
      const windowScrolling = scrollableElement.lastElementChild.dataset["viewportType"] === "window";
      const scrollTop = customScrollParent ? customScrollParent.scrollTop : windowScrolling ? window.pageYOffset || document.documentElement.scrollTop : scrollableElement.scrollTop;
      const scrollHeight = customScrollParent ? customScrollParent.scrollHeight : windowScrolling ? document.documentElement.scrollHeight : scrollableElement.scrollHeight;
      const viewportHeight = customScrollParent ? customScrollParent.offsetHeight : windowScrolling ? window.innerHeight : scrollableElement.offsetHeight;
      scrollContainerStateCallback({
        scrollTop: Math.max(scrollTop, 0),
        scrollHeight,
        viewportHeight
      });
      gap == null ? void 0 : gap(resolveGapValue$1("row-gap", getComputedStyle(el).rowGap, log));
      if (ranges !== null) {
        callback(ranges);
      }
    },
    [callback, itemSize, log, gap, customScrollParent, scrollContainerStateCallback]
  );
  return useSizeWithElRef(memoedCallback, enabled);
}
function getChangedChildSizes(children, itemSize, field, log) {
  const length = children.length;
  if (length === 0) {
    return null;
  }
  const results = [];
  for (let i = 0; i < length; i++) {
    const child = children.item(i);
    if (!child || child.dataset.index === void 0) {
      continue;
    }
    const index = parseInt(child.dataset.index);
    const knownSize = parseFloat(child.dataset.knownSize);
    const size = itemSize(child, field);
    if (size === 0) {
      log("Zero-sized element, this should not happen", { child }, LogLevel.ERROR);
    }
    if (size === knownSize) {
      continue;
    }
    const lastResult = results[results.length - 1];
    if (results.length === 0 || lastResult.size !== size || lastResult.endIndex !== index - 1) {
      results.push({ startIndex: index, endIndex: index, size });
    } else {
      results[results.length - 1].endIndex++;
    }
  }
  return results;
}
function resolveGapValue$1(property, value, log) {
  if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) {
    log(`${property} was not resolved to pixel value correctly`, value, LogLevel.WARN);
  }
  if (value === "normal") {
    return 0;
  }
  return parseInt(value != null ? value : "0", 10);
}
function correctItemSize(el, dimension) {
  return Math.round(el.getBoundingClientRect()[dimension]);
}
function approximatelyEqual(num1, num2) {
  return Math.abs(num1 - num2) < 1.01;
}
function useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, scrollerElement, scrollerRefCallback = noop, customScrollParent) {
  const scrollerRef = React__default.useRef(null);
  const scrollTopTarget = React__default.useRef(null);
  const timeoutRef = React__default.useRef(null);
  const handler = React__default.useCallback(
    (ev) => {
      const el = ev.target;
      const windowScroll = el === window || el === document;
      const scrollTop = windowScroll ? window.pageYOffset || document.documentElement.scrollTop : el.scrollTop;
      const scrollHeight = windowScroll ? document.documentElement.scrollHeight : el.scrollHeight;
      const viewportHeight = windowScroll ? window.innerHeight : el.offsetHeight;
      const call2 = () => {
        scrollContainerStateCallback({
          scrollTop: Math.max(scrollTop, 0),
          scrollHeight,
          viewportHeight
        });
      };
      if (ev.suppressFlushSync) {
        call2();
      } else {
        ReactDOM__default.flushSync(call2);
      }
      if (scrollTopTarget.current !== null) {
        if (scrollTop === scrollTopTarget.current || scrollTop <= 0 || scrollTop === scrollHeight - viewportHeight) {
          scrollTopTarget.current = null;
          smoothScrollTargetReached(true);
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
          }
        }
      }
    },
    [scrollContainerStateCallback, smoothScrollTargetReached]
  );
  React__default.useEffect(() => {
    const localRef = customScrollParent ? customScrollParent : scrollerRef.current;
    scrollerRefCallback(customScrollParent ? customScrollParent : scrollerRef.current);
    handler({ target: localRef, suppressFlushSync: true });
    localRef.addEventListener("scroll", handler, { passive: true });
    return () => {
      scrollerRefCallback(null);
      localRef.removeEventListener("scroll", handler);
    };
  }, [scrollerRef, handler, scrollerElement, scrollerRefCallback, customScrollParent]);
  function scrollToCallback(location) {
    const scrollerElement2 = scrollerRef.current;
    if (!scrollerElement2 || "offsetHeight" in scrollerElement2 && scrollerElement2.offsetHeight === 0) {
      return;
    }
    const isSmooth = location.behavior === "smooth";
    let offsetHeight;
    let scrollHeight;
    let scrollTop;
    if (scrollerElement2 === window) {
      scrollHeight = Math.max(correctItemSize(document.documentElement, "height"), document.documentElement.scrollHeight);
      offsetHeight = window.innerHeight;
      scrollTop = document.documentElement.scrollTop;
    } else {
      scrollHeight = scrollerElement2.scrollHeight;
      offsetHeight = correctItemSize(scrollerElement2, "height");
      scrollTop = scrollerElement2.scrollTop;
    }
    const maxScrollTop = scrollHeight - offsetHeight;
    location.top = Math.ceil(Math.max(Math.min(maxScrollTop, location.top), 0));
    if (approximatelyEqual(offsetHeight, scrollHeight) || location.top === scrollTop) {
      scrollContainerStateCallback({ scrollTop, scrollHeight, viewportHeight: offsetHeight });
      if (isSmooth) {
        smoothScrollTargetReached(true);
      }
      return;
    }
    if (isSmooth) {
      scrollTopTarget.current = location.top;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        timeoutRef.current = null;
        scrollTopTarget.current = null;
        smoothScrollTargetReached(true);
      }, 1e3);
    } else {
      scrollTopTarget.current = null;
    }
    scrollerElement2.scrollTo(location);
  }
  function scrollByCallback(location) {
    scrollerRef.current.scrollBy(location);
  }
  return { scrollerRef, scrollByCallback, scrollToCallback };
}
const domIOSystem = system(
  () => {
    const scrollContainerState = stream();
    const scrollTop = stream();
    const deviation = statefulStream(0);
    const smoothScrollTargetReached = stream();
    const statefulScrollTop = statefulStream(0);
    const viewportHeight = stream();
    const scrollHeight = stream();
    const headerHeight = statefulStream(0);
    const fixedHeaderHeight = statefulStream(0);
    const fixedFooterHeight = statefulStream(0);
    const footerHeight = statefulStream(0);
    const scrollTo = stream();
    const scrollBy = stream();
    const scrollingInProgress = statefulStream(false);
    connect(
      pipe(
        scrollContainerState,
        map(({ scrollTop: scrollTop2 }) => scrollTop2)
      ),
      scrollTop
    );
    connect(
      pipe(
        scrollContainerState,
        map(({ scrollHeight: scrollHeight2 }) => scrollHeight2)
      ),
      scrollHeight
    );
    connect(scrollTop, statefulScrollTop);
    return {
      // input
      scrollContainerState,
      scrollTop,
      viewportHeight,
      headerHeight,
      fixedHeaderHeight,
      fixedFooterHeight,
      footerHeight,
      scrollHeight,
      smoothScrollTargetReached,
      // signals
      scrollTo,
      scrollBy,
      // state
      statefulScrollTop,
      deviation,
      scrollingInProgress
    };
  },
  [],
  { singleton: true }
);
const NIL_NODE = { lvl: 0 };
function newAANode(k, v, lvl, l = NIL_NODE, r = NIL_NODE) {
  return { k, v, lvl, l, r };
}
function empty(node) {
  return node === NIL_NODE;
}
function newTree() {
  return NIL_NODE;
}
function remove(node, key) {
  if (empty(node))
    return NIL_NODE;
  const { k, l, r } = node;
  if (key === k) {
    if (empty(l)) {
      return r;
    } else if (empty(r)) {
      return l;
    } else {
      const [lastKey, lastValue] = last(l);
      return adjust(clone(node, { k: lastKey, v: lastValue, l: deleteLast(l) }));
    }
  } else if (key < k) {
    return adjust(clone(node, { l: remove(l, key) }));
  } else {
    return adjust(clone(node, { r: remove(r, key) }));
  }
}
function find(node, key) {
  if (empty(node)) {
    return;
  }
  if (key === node.k) {
    return node.v;
  } else if (key < node.k) {
    return find(node.l, key);
  } else {
    return find(node.r, key);
  }
}
function findMaxKeyValue(node, value, field = "k") {
  if (empty(node)) {
    return [-Infinity, void 0];
  }
  if (Number(node[field]) === value) {
    return [node.k, node.v];
  }
  if (Number(node[field]) < value) {
    const r = findMaxKeyValue(node.r, value, field);
    if (r[0] === -Infinity) {
      return [node.k, node.v];
    } else {
      return r;
    }
  }
  return findMaxKeyValue(node.l, value, field);
}
function insert(node, k, v) {
  if (empty(node)) {
    return newAANode(k, v, 1);
  }
  if (k === node.k) {
    return clone(node, { k, v });
  } else if (k < node.k) {
    return rebalance(clone(node, { l: insert(node.l, k, v) }));
  } else {
    return rebalance(clone(node, { r: insert(node.r, k, v) }));
  }
}
function walkWithin(node, start, end) {
  if (empty(node)) {
    return [];
  }
  const { k, v, l, r } = node;
  let result = [];
  if (k > start) {
    result = result.concat(walkWithin(l, start, end));
  }
  if (k >= start && k <= end) {
    result.push({ k, v });
  }
  if (k <= end) {
    result = result.concat(walkWithin(r, start, end));
  }
  return result;
}
function walk(node) {
  if (empty(node)) {
    return [];
  }
  return [...walk(node.l), { k: node.k, v: node.v }, ...walk(node.r)];
}
function last(node) {
  return empty(node.r) ? [node.k, node.v] : last(node.r);
}
function deleteLast(node) {
  return empty(node.r) ? node.l : adjust(clone(node, { r: deleteLast(node.r) }));
}
function clone(node, args) {
  return newAANode(
    args.k !== void 0 ? args.k : node.k,
    args.v !== void 0 ? args.v : node.v,
    args.lvl !== void 0 ? args.lvl : node.lvl,
    args.l !== void 0 ? args.l : node.l,
    args.r !== void 0 ? args.r : node.r
  );
}
function isSingle(node) {
  return empty(node) || node.lvl > node.r.lvl;
}
function rebalance(node) {
  return split(skew(node));
}
function adjust(node) {
  const { l, r, lvl } = node;
  if (r.lvl >= lvl - 1 && l.lvl >= lvl - 1) {
    return node;
  } else if (lvl > r.lvl + 1) {
    if (isSingle(l)) {
      return skew(clone(node, { lvl: lvl - 1 }));
    } else {
      if (!empty(l) && !empty(l.r)) {
        return clone(l.r, {
          l: clone(l, { r: l.r.l }),
          r: clone(node, {
            l: l.r.r,
            lvl: lvl - 1
          }),
          lvl
        });
      } else {
        throw new Error("Unexpected empty nodes");
      }
    }
  } else {
    if (isSingle(node)) {
      return split(clone(node, { lvl: lvl - 1 }));
    } else {
      if (!empty(r) && !empty(r.l)) {
        const rl = r.l;
        const rlvl = isSingle(rl) ? r.lvl - 1 : r.lvl;
        return clone(rl, {
          l: clone(node, {
            r: rl.l,
            lvl: lvl - 1
          }),
          r: split(clone(r, { l: rl.r, lvl: rlvl })),
          lvl: rl.lvl + 1
        });
      } else {
        throw new Error("Unexpected empty nodes");
      }
    }
  }
}
function rangesWithin(node, startIndex, endIndex) {
  if (empty(node)) {
    return [];
  }
  const adjustedStart = findMaxKeyValue(node, startIndex)[0];
  return toRanges(walkWithin(node, adjustedStart, endIndex));
}
function arrayToRanges(items, parser) {
  const length = items.length;
  if (length === 0) {
    return [];
  }
  let { index: start, value } = parser(items[0]);
  const result = [];
  for (let i = 1; i < length; i++) {
    const { index: nextIndex, value: nextValue } = parser(items[i]);
    result.push({ start, end: nextIndex - 1, value });
    start = nextIndex;
    value = nextValue;
  }
  result.push({ start, end: Infinity, value });
  return result;
}
function toRanges(nodes) {
  return arrayToRanges(nodes, ({ k: index, v: value }) => ({ index, value }));
}
function split(node) {
  const { r, lvl } = node;
  return !empty(r) && !empty(r.r) && r.lvl === lvl && r.r.lvl === lvl ? clone(r, { l: clone(node, { r: r.l }), lvl: lvl + 1 }) : node;
}
function skew(node) {
  const { l } = node;
  return !empty(l) && l.lvl === node.lvl ? clone(l, { r: clone(node, { l: l.r }) }) : node;
}
function findIndexOfClosestSmallerOrEqual(items, value, comparator, start = 0) {
  let end = items.length - 1;
  while (start <= end) {
    const index = Math.floor((start + end) / 2);
    const item = items[index];
    const match = comparator(item, value);
    if (match === 0) {
      return index;
    }
    if (match === -1) {
      if (end - start < 2) {
        return index - 1;
      }
      end = index - 1;
    } else {
      if (end === start) {
        return index;
      }
      start = index + 1;
    }
  }
  throw new Error(`Failed binary finding record in array - ${items.join(",")}, searched for ${value}`);
}
function findClosestSmallerOrEqual(items, value, comparator) {
  return items[findIndexOfClosestSmallerOrEqual(items, value, comparator)];
}
function findRange(items, startValue, endValue, comparator) {
  const startIndex = findIndexOfClosestSmallerOrEqual(items, startValue, comparator);
  const endIndex = findIndexOfClosestSmallerOrEqual(items, endValue, comparator, startIndex);
  return items.slice(startIndex, endIndex + 1);
}
const recalcSystem = system(
  () => {
    const recalcInProgress = statefulStream(false);
    return { recalcInProgress };
  },
  [],
  { singleton: true }
);
function rangeIncludes(refRange) {
  const { size, startIndex, endIndex } = refRange;
  return (range) => {
    return range.start === startIndex && (range.end === endIndex || range.end === Infinity) && range.value === size;
  };
}
function affectedGroupCount(offset, groupIndices) {
  let recognizedOffsetItems = 0;
  let groupIndex = 0;
  while (recognizedOffsetItems < offset) {
    recognizedOffsetItems += groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
    groupIndex++;
  }
  const offsetIsExact = recognizedOffsetItems === offset;
  return groupIndex - (offsetIsExact ? 0 : 1);
}
function insertRanges(sizeTree, ranges) {
  let syncStart = empty(sizeTree) ? 0 : Infinity;
  for (const range of ranges) {
    const { size, startIndex, endIndex } = range;
    syncStart = Math.min(syncStart, startIndex);
    if (empty(sizeTree)) {
      sizeTree = insert(sizeTree, 0, size);
      continue;
    }
    const overlappingRanges = rangesWithin(sizeTree, startIndex - 1, endIndex + 1);
    if (overlappingRanges.some(rangeIncludes(range))) {
      continue;
    }
    let firstPassDone = false;
    let shouldInsert = false;
    for (const { start: rangeStart, end: rangeEnd, value: rangeValue } of overlappingRanges) {
      if (!firstPassDone) {
        shouldInsert = rangeValue !== size;
        firstPassDone = true;
      } else {
        if (endIndex >= rangeStart || size === rangeValue) {
          sizeTree = remove(sizeTree, rangeStart);
        }
      }
      if (rangeEnd > endIndex && endIndex >= rangeStart) {
        if (rangeValue !== size) {
          sizeTree = insert(sizeTree, endIndex + 1, rangeValue);
        }
      }
    }
    if (shouldInsert) {
      sizeTree = insert(sizeTree, startIndex, size);
    }
  }
  return [sizeTree, syncStart];
}
function initialSizeState() {
  return {
    offsetTree: [],
    sizeTree: newTree(),
    groupOffsetTree: newTree(),
    lastIndex: 0,
    lastOffset: 0,
    lastSize: 0,
    groupIndices: []
  };
}
function indexComparator({ index: itemIndex }, index) {
  return index === itemIndex ? 0 : index < itemIndex ? -1 : 1;
}
function offsetComparator({ offset: itemOffset }, offset) {
  return offset === itemOffset ? 0 : offset < itemOffset ? -1 : 1;
}
function offsetPointParser(point) {
  return { index: point.index, value: point };
}
function rangesWithinOffsets(tree, startOffset, endOffset, minStartIndex = 0) {
  if (minStartIndex > 0) {
    startOffset = Math.max(startOffset, findClosestSmallerOrEqual(tree, minStartIndex, indexComparator).offset);
  }
  return arrayToRanges(findRange(tree, startOffset, endOffset, offsetComparator), offsetPointParser);
}
function createOffsetTree(prevOffsetTree, syncStart, sizeTree, gap) {
  let offsetTree = prevOffsetTree;
  let prevIndex = 0;
  let prevSize = 0;
  let prevOffset = 0;
  let startIndex = 0;
  if (syncStart !== 0) {
    startIndex = findIndexOfClosestSmallerOrEqual(offsetTree, syncStart - 1, indexComparator);
    const offsetInfo = offsetTree[startIndex];
    prevOffset = offsetInfo.offset;
    const kv = findMaxKeyValue(sizeTree, syncStart - 1);
    prevIndex = kv[0];
    prevSize = kv[1];
    if (offsetTree.length && offsetTree[startIndex].size === findMaxKeyValue(sizeTree, syncStart)[1]) {
      startIndex -= 1;
    }
    offsetTree = offsetTree.slice(0, startIndex + 1);
  } else {
    offsetTree = [];
  }
  for (const { start: startIndex2, value } of rangesWithin(sizeTree, syncStart, Infinity)) {
    const indexOffset = startIndex2 - prevIndex;
    const aOffset = indexOffset * prevSize + prevOffset + indexOffset * gap;
    offsetTree.push({
      offset: aOffset,
      size: value,
      index: startIndex2
    });
    prevIndex = startIndex2;
    prevOffset = aOffset;
    prevSize = value;
  }
  return {
    offsetTree,
    lastIndex: prevIndex,
    lastOffset: prevOffset,
    lastSize: prevSize
  };
}
function sizeStateReducer(state, [ranges, groupIndices, log, gap]) {
  if (ranges.length > 0) {
    log("received item sizes", ranges, LogLevel.DEBUG);
  }
  const sizeTree = state.sizeTree;
  let newSizeTree = sizeTree;
  let syncStart = 0;
  if (groupIndices.length > 0 && empty(sizeTree) && ranges.length === 2) {
    const groupSize = ranges[0].size;
    const itemSize = ranges[1].size;
    newSizeTree = groupIndices.reduce((tree, groupIndex) => {
      return insert(insert(tree, groupIndex, groupSize), groupIndex + 1, itemSize);
    }, newSizeTree);
  } else {
    [newSizeTree, syncStart] = insertRanges(newSizeTree, ranges);
  }
  if (newSizeTree === sizeTree) {
    return state;
  }
  const { offsetTree: newOffsetTree, lastIndex, lastSize, lastOffset } = createOffsetTree(state.offsetTree, syncStart, newSizeTree, gap);
  return {
    sizeTree: newSizeTree,
    offsetTree: newOffsetTree,
    lastIndex,
    lastOffset,
    lastSize,
    groupOffsetTree: groupIndices.reduce((tree, index) => {
      return insert(tree, index, offsetOf(index, newOffsetTree, gap));
    }, newTree()),
    groupIndices
  };
}
function offsetOf(index, tree, gap) {
  if (tree.length === 0) {
    return 0;
  }
  const { offset, index: startIndex, size } = findClosestSmallerOrEqual(tree, index, indexComparator);
  const itemCount = index - startIndex;
  const top = size * itemCount + (itemCount - 1) * gap + offset;
  return top > 0 ? top + gap : top;
}
function isGroupLocation(location) {
  return typeof location.groupIndex !== "undefined";
}
function originalIndexFromLocation(location, sizes, lastIndex) {
  if (isGroupLocation(location)) {
    return sizes.groupIndices[location.groupIndex] + 1;
  } else {
    const numericIndex = location.index === "LAST" ? lastIndex : location.index;
    let result = originalIndexFromItemIndex(numericIndex, sizes);
    result = Math.max(0, result, Math.min(lastIndex, result));
    return result;
  }
}
function originalIndexFromItemIndex(itemIndex, sizes) {
  if (!hasGroups(sizes)) {
    return itemIndex;
  }
  let groupOffset = 0;
  while (sizes.groupIndices[groupOffset] <= itemIndex + groupOffset) {
    groupOffset++;
  }
  return itemIndex + groupOffset;
}
function hasGroups(sizes) {
  return !empty(sizes.groupOffsetTree);
}
function sizeTreeToRanges(sizeTree) {
  return walk(sizeTree).map(({ k: startIndex, v: size }, index, sizeArray) => {
    const nextSize = sizeArray[index + 1];
    const endIndex = nextSize ? nextSize.k - 1 : Infinity;
    return { startIndex, endIndex, size };
  });
}
const SIZE_MAP = {
  offsetHeight: "height",
  offsetWidth: "width"
};
const sizeSystem = system(
  ([{ log }, { recalcInProgress }]) => {
    const sizeRanges = stream();
    const totalCount = stream();
    const statefulTotalCount = statefulStreamFromEmitter(totalCount, 0);
    const unshiftWith = stream();
    const shiftWith = stream();
    const firstItemIndex = statefulStream(0);
    const groupIndices = statefulStream([]);
    const fixedItemSize = statefulStream(void 0);
    const defaultItemSize = statefulStream(void 0);
    const itemSize = statefulStream((el, field) => correctItemSize(el, SIZE_MAP[field]));
    const data = statefulStream(void 0);
    const gap = statefulStream(0);
    const initial = initialSizeState();
    const sizes = statefulStreamFromEmitter(
      pipe(sizeRanges, withLatestFrom(groupIndices, log, gap), scan(sizeStateReducer, initial), distinctUntilChanged()),
      initial
    );
    const prevGroupIndices = statefulStreamFromEmitter(
      pipe(
        groupIndices,
        distinctUntilChanged(),
        scan((prev, curr) => ({ prev: prev.current, current: curr }), {
          prev: [],
          current: []
        }),
        map(({ prev }) => prev)
      ),
      []
    );
    connect(
      pipe(
        groupIndices,
        filter((indexes) => indexes.length > 0),
        withLatestFrom(sizes, gap),
        map(([groupIndices2, sizes2, gap2]) => {
          const groupOffsetTree = groupIndices2.reduce((tree, index, idx) => {
            return insert(tree, index, offsetOf(index, sizes2.offsetTree, gap2) || idx);
          }, newTree());
          return {
            ...sizes2,
            groupIndices: groupIndices2,
            groupOffsetTree
          };
        })
      ),
      sizes
    );
    connect(
      pipe(
        totalCount,
        withLatestFrom(sizes),
        filter(([totalCount2, { lastIndex }]) => {
          return totalCount2 < lastIndex;
        }),
        map(([totalCount2, { lastIndex, lastSize }]) => {
          return [
            {
              startIndex: totalCount2,
              endIndex: lastIndex,
              size: lastSize
            }
          ];
        })
      ),
      sizeRanges
    );
    connect(fixedItemSize, defaultItemSize);
    const trackItemSizes = statefulStreamFromEmitter(
      pipe(
        fixedItemSize,
        map((size) => size === void 0)
      ),
      true
    );
    connect(
      pipe(
        defaultItemSize,
        filter((value) => {
          return value !== void 0 && empty(getValue(sizes).sizeTree);
        }),
        map((size) => [{ startIndex: 0, endIndex: 0, size }])
      ),
      sizeRanges
    );
    const listRefresh = streamFromEmitter(
      pipe(
        sizeRanges,
        withLatestFrom(sizes),
        scan(
          ({ sizes: oldSizes }, [_, newSizes]) => {
            return {
              changed: newSizes !== oldSizes,
              sizes: newSizes
            };
          },
          { changed: false, sizes: initial }
        ),
        map((value) => value.changed)
      )
    );
    subscribe(
      pipe(
        firstItemIndex,
        scan(
          (prev, next) => {
            return { diff: prev.prev - next, prev: next };
          },
          { diff: 0, prev: 0 }
        ),
        map((val) => val.diff)
      ),
      (offset) => {
        const { groupIndices: groupIndices2 } = getValue(sizes);
        if (offset > 0) {
          publish(recalcInProgress, true);
          publish(unshiftWith, offset + affectedGroupCount(offset, groupIndices2));
        } else if (offset < 0) {
          const prevGroupIndicesValue = getValue(prevGroupIndices);
          if (prevGroupIndicesValue.length > 0) {
            offset -= affectedGroupCount(-offset, prevGroupIndicesValue);
          }
          publish(shiftWith, offset);
        }
      }
    );
    subscribe(pipe(firstItemIndex, withLatestFrom(log)), ([index, log2]) => {
      if (index < 0) {
        log2(
          "`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value",
          { firstItemIndex },
          LogLevel.ERROR
        );
      }
    });
    const beforeUnshiftWith = streamFromEmitter(unshiftWith);
    connect(
      pipe(
        unshiftWith,
        withLatestFrom(sizes),
        map(([unshiftWith2, sizes2]) => {
          const groupedMode = sizes2.groupIndices.length > 0;
          const initialRanges = [];
          const defaultSize = sizes2.lastSize;
          if (groupedMode) {
            const firstGroupSize = find(sizes2.sizeTree, 0);
            let prependedGroupItemsCount = 0;
            let groupIndex = 0;
            while (prependedGroupItemsCount < unshiftWith2) {
              const theGroupIndex = sizes2.groupIndices[groupIndex];
              const groupItemCount = sizes2.groupIndices.length === groupIndex + 1 ? Infinity : sizes2.groupIndices[groupIndex + 1] - theGroupIndex - 1;
              initialRanges.push({
                startIndex: theGroupIndex,
                endIndex: theGroupIndex,
                size: firstGroupSize
              });
              initialRanges.push({
                startIndex: theGroupIndex + 1,
                endIndex: theGroupIndex + 1 + groupItemCount - 1,
                size: defaultSize
              });
              groupIndex++;
              prependedGroupItemsCount += groupItemCount + 1;
            }
            const sizeTreeKV = walk(sizes2.sizeTree);
            const firstGroupIsExpanded = prependedGroupItemsCount !== unshiftWith2;
            if (firstGroupIsExpanded) {
              sizeTreeKV.shift();
            }
            return sizeTreeKV.reduce(
              (acc, { k: index, v: size }) => {
                let ranges = acc.ranges;
                if (acc.prevSize !== 0) {
                  ranges = [
                    ...acc.ranges,
                    {
                      startIndex: acc.prevIndex,
                      endIndex: index + unshiftWith2 - 1,
                      size: acc.prevSize
                    }
                  ];
                }
                return {
                  ranges,
                  prevIndex: index + unshiftWith2,
                  prevSize: size
                };
              },
              {
                ranges: initialRanges,
                prevIndex: unshiftWith2,
                prevSize: 0
              }
            ).ranges;
          }
          return walk(sizes2.sizeTree).reduce(
            (acc, { k: index, v: size }) => {
              return {
                ranges: [...acc.ranges, { startIndex: acc.prevIndex, endIndex: index + unshiftWith2 - 1, size: acc.prevSize }],
                prevIndex: index + unshiftWith2,
                prevSize: size
              };
            },
            {
              ranges: [],
              prevIndex: 0,
              prevSize: defaultSize
            }
          ).ranges;
        })
      ),
      sizeRanges
    );
    const shiftWithOffset = streamFromEmitter(
      pipe(
        shiftWith,
        withLatestFrom(sizes, gap),
        map(([shiftWith2, { offsetTree }, gap2]) => {
          const newFirstItemIndex = -shiftWith2;
          return offsetOf(newFirstItemIndex, offsetTree, gap2);
        })
      )
    );
    connect(
      pipe(
        shiftWith,
        withLatestFrom(sizes, gap),
        map(([shiftWith2, sizes2, gap2]) => {
          const groupedMode = sizes2.groupIndices.length > 0;
          if (groupedMode) {
            if (empty(sizes2.sizeTree)) {
              return sizes2;
            }
            let newSizeTree = newTree();
            const prevGroupIndicesValue = getValue(prevGroupIndices);
            let removedItemsCount = 0;
            let groupIndex = 0;
            let groupOffset = 0;
            while (removedItemsCount < -shiftWith2) {
              groupOffset = prevGroupIndicesValue[groupIndex];
              const groupItemCount = prevGroupIndicesValue[groupIndex + 1] - groupOffset - 1;
              groupIndex++;
              removedItemsCount += groupItemCount + 1;
            }
            newSizeTree = walk(sizes2.sizeTree).reduce((acc, { k, v }) => {
              return insert(acc, Math.max(0, k + shiftWith2), v);
            }, newSizeTree);
            const aGroupIsShrunk = removedItemsCount !== -shiftWith2;
            if (aGroupIsShrunk) {
              const firstGroupSize = find(sizes2.sizeTree, groupOffset);
              newSizeTree = insert(newSizeTree, 0, firstGroupSize);
              const nextItemSize = findMaxKeyValue(sizes2.sizeTree, -shiftWith2 + 1)[1];
              newSizeTree = insert(newSizeTree, 1, nextItemSize);
            }
            return {
              ...sizes2,
              sizeTree: newSizeTree,
              ...createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2)
            };
          } else {
            const newSizeTree = walk(sizes2.sizeTree).reduce((acc, { k, v }) => {
              return insert(acc, Math.max(0, k + shiftWith2), v);
            }, newTree());
            return {
              ...sizes2,
              sizeTree: newSizeTree,
              ...createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2)
            };
          }
        })
      ),
      sizes
    );
    return {
      // input
      data,
      totalCount,
      sizeRanges,
      groupIndices,
      defaultItemSize,
      fixedItemSize,
      unshiftWith,
      shiftWith,
      shiftWithOffset,
      beforeUnshiftWith,
      firstItemIndex,
      gap,
      // output
      sizes,
      listRefresh,
      statefulTotalCount,
      trackItemSizes,
      itemSize
    };
  },
  tup(loggerSystem, recalcSystem),
  { singleton: true }
);
const SUPPORTS_SCROLL_TO_OPTIONS = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function normalizeIndexLocation(location) {
  const result = typeof location === "number" ? { index: location } : location;
  if (!result.align) {
    result.align = "start";
  }
  if (!result.behavior || !SUPPORTS_SCROLL_TO_OPTIONS) {
    result.behavior = "auto";
  }
  if (!result.offset) {
    result.offset = 0;
  }
  return result;
}
const scrollToIndexSystem = system(
  ([
    { sizes, totalCount, listRefresh, gap },
    {
      scrollingInProgress,
      viewportHeight,
      scrollTo,
      smoothScrollTargetReached,
      headerHeight,
      footerHeight,
      fixedHeaderHeight,
      fixedFooterHeight
    },
    { log }
  ]) => {
    const scrollToIndex = stream();
    const topListHeight = statefulStream(0);
    let unsubscribeNextListRefresh = null;
    let cleartTimeoutRef = null;
    let unsubscribeListRefresh = null;
    function cleanup() {
      if (unsubscribeNextListRefresh) {
        unsubscribeNextListRefresh();
        unsubscribeNextListRefresh = null;
      }
      if (unsubscribeListRefresh) {
        unsubscribeListRefresh();
        unsubscribeListRefresh = null;
      }
      if (cleartTimeoutRef) {
        clearTimeout(cleartTimeoutRef);
        cleartTimeoutRef = null;
      }
      publish(scrollingInProgress, false);
    }
    connect(
      pipe(
        scrollToIndex,
        withLatestFrom(sizes, viewportHeight, totalCount, topListHeight, headerHeight, footerHeight, log),
        withLatestFrom(gap, fixedHeaderHeight, fixedFooterHeight),
        map(
          ([
            [location, sizes2, viewportHeight2, totalCount2, topListHeight2, headerHeight2, footerHeight2, log2],
            gap2,
            fixedHeaderHeight2,
            fixedFooterHeight2
          ]) => {
            const normalLocation = normalizeIndexLocation(location);
            const { align, behavior, offset } = normalLocation;
            const lastIndex = totalCount2 - 1;
            const index = originalIndexFromLocation(normalLocation, sizes2, lastIndex);
            let top = offsetOf(index, sizes2.offsetTree, gap2) + headerHeight2;
            if (align === "end") {
              top += fixedHeaderHeight2 + findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2;
              if (index === lastIndex) {
                top += footerHeight2;
              }
            } else if (align === "center") {
              top += (fixedHeaderHeight2 + findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2) / 2;
            } else {
              top -= topListHeight2;
            }
            if (offset) {
              top += offset;
            }
            const retry = (listChanged) => {
              cleanup();
              if (listChanged) {
                log2("retrying to scroll to", { location }, LogLevel.DEBUG);
                publish(scrollToIndex, location);
              } else {
                log2("list did not change, scroll successful", {}, LogLevel.DEBUG);
              }
            };
            cleanup();
            if (behavior === "smooth") {
              let listChanged = false;
              unsubscribeListRefresh = subscribe(listRefresh, (changed) => {
                listChanged = listChanged || changed;
              });
              unsubscribeNextListRefresh = handleNext(smoothScrollTargetReached, () => {
                retry(listChanged);
              });
            } else {
              unsubscribeNextListRefresh = handleNext(pipe(listRefresh, watchChangesFor(150)), retry);
            }
            cleartTimeoutRef = setTimeout(() => {
              cleanup();
            }, 1200);
            publish(scrollingInProgress, true);
            log2("scrolling from index to", { index, top, behavior }, LogLevel.DEBUG);
            return { top, behavior };
          }
        )
      ),
      scrollTo
    );
    return {
      scrollToIndex,
      topListHeight
    };
  },
  tup(sizeSystem, domIOSystem, loggerSystem),
  { singleton: true }
);
function watchChangesFor(limit) {
  return (done) => {
    const timeoutRef = setTimeout(() => {
      done(false);
    }, limit);
    return (value) => {
      if (value) {
        done(true);
        clearTimeout(timeoutRef);
      }
    };
  };
}
const UP = "up";
const DOWN = "down";
const NONE$1 = "none";
const INITIAL_BOTTOM_STATE = {
  atBottom: false,
  notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
  state: {
    offsetBottom: 0,
    scrollTop: 0,
    viewportHeight: 0,
    scrollHeight: 0
  }
};
const DEFAULT_AT_TOP_THRESHOLD = 0;
const stateFlagsSystem = system(([{ scrollContainerState, scrollTop, viewportHeight, headerHeight, footerHeight, scrollBy }]) => {
  const isAtBottom = statefulStream(false);
  const isAtTop = statefulStream(true);
  const atBottomStateChange = stream();
  const atTopStateChange = stream();
  const atBottomThreshold = statefulStream(4);
  const atTopThreshold = statefulStream(DEFAULT_AT_TOP_THRESHOLD);
  const isScrolling = statefulStreamFromEmitter(
    pipe(
      merge(pipe(duc(scrollTop), skip(1), mapTo(true)), pipe(duc(scrollTop), skip(1), mapTo(false), debounceTime(100))),
      distinctUntilChanged()
    ),
    false
  );
  const isScrollingBy = statefulStreamFromEmitter(
    pipe(merge(pipe(scrollBy, mapTo(true)), pipe(scrollBy, mapTo(false), debounceTime(200))), distinctUntilChanged()),
    false
  );
  connect(
    pipe(
      combineLatest(duc(scrollTop), duc(atTopThreshold)),
      map(([top, atTopThreshold2]) => top <= atTopThreshold2),
      distinctUntilChanged()
    ),
    isAtTop
  );
  connect(pipe(isAtTop, throttleTime(50)), atTopStateChange);
  const atBottomState = streamFromEmitter(
    pipe(
      combineLatest(scrollContainerState, duc(viewportHeight), duc(headerHeight), duc(footerHeight), duc(atBottomThreshold)),
      scan((current, [{ scrollTop: scrollTop2, scrollHeight }, viewportHeight2, _headerHeight, _footerHeight, atBottomThreshold2]) => {
        const isAtBottom2 = scrollTop2 + viewportHeight2 - scrollHeight > -atBottomThreshold2;
        const state = {
          viewportHeight: viewportHeight2,
          scrollTop: scrollTop2,
          scrollHeight
        };
        if (isAtBottom2) {
          let atBottomBecause;
          let scrollTopDelta;
          if (scrollTop2 > current.state.scrollTop) {
            atBottomBecause = "SCROLLED_DOWN";
            scrollTopDelta = current.state.scrollTop - scrollTop2;
          } else {
            atBottomBecause = "SIZE_DECREASED";
            scrollTopDelta = current.state.scrollTop - scrollTop2 || current.scrollTopDelta;
          }
          return {
            atBottom: true,
            state,
            atBottomBecause,
            scrollTopDelta
          };
        }
        let notAtBottomBecause;
        if (state.scrollHeight > current.state.scrollHeight) {
          notAtBottomBecause = "SIZE_INCREASED";
        } else if (viewportHeight2 < current.state.viewportHeight) {
          notAtBottomBecause = "VIEWPORT_HEIGHT_DECREASING";
        } else if (scrollTop2 < current.state.scrollTop) {
          notAtBottomBecause = "SCROLLING_UPWARDS";
        } else {
          notAtBottomBecause = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM";
        }
        return {
          atBottom: false,
          notAtBottomBecause,
          state
        };
      }, INITIAL_BOTTOM_STATE),
      distinctUntilChanged((prev, next) => {
        return prev && prev.atBottom === next.atBottom;
      })
    )
  );
  const lastJumpDueToItemResize = statefulStreamFromEmitter(
    pipe(
      scrollContainerState,
      scan(
        (current, { scrollTop: scrollTop2, scrollHeight, viewportHeight: viewportHeight2 }) => {
          if (!approximatelyEqual(current.scrollHeight, scrollHeight)) {
            const atBottom = scrollHeight - (scrollTop2 + viewportHeight2) < 1;
            if (current.scrollTop !== scrollTop2 && atBottom) {
              return {
                scrollHeight,
                scrollTop: scrollTop2,
                jump: current.scrollTop - scrollTop2,
                changed: true
              };
            } else {
              return {
                scrollHeight,
                scrollTop: scrollTop2,
                jump: 0,
                changed: true
              };
            }
          } else {
            return {
              scrollTop: scrollTop2,
              scrollHeight,
              jump: 0,
              changed: false
            };
          }
        },
        { scrollHeight: 0, jump: 0, scrollTop: 0, changed: false }
      ),
      filter((value) => value.changed),
      map((value) => value.jump)
    ),
    0
  );
  connect(
    pipe(
      atBottomState,
      map((state) => state.atBottom)
    ),
    isAtBottom
  );
  connect(pipe(isAtBottom, throttleTime(50)), atBottomStateChange);
  const scrollDirection = statefulStream(DOWN);
  connect(
    pipe(
      scrollContainerState,
      map(({ scrollTop: scrollTop2 }) => scrollTop2),
      distinctUntilChanged(),
      scan(
        (acc, scrollTop2) => {
          if (getValue(isScrollingBy)) {
            return { direction: acc.direction, prevScrollTop: scrollTop2 };
          }
          return { direction: scrollTop2 < acc.prevScrollTop ? UP : DOWN, prevScrollTop: scrollTop2 };
        },
        { direction: DOWN, prevScrollTop: 0 }
      ),
      map((value) => value.direction)
    ),
    scrollDirection
  );
  connect(pipe(scrollContainerState, throttleTime(50), mapTo(NONE$1)), scrollDirection);
  const scrollVelocity = statefulStream(0);
  connect(
    pipe(
      isScrolling,
      filter((value) => !value),
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      mapTo(0)
    ),
    scrollVelocity
  );
  connect(
    pipe(
      scrollTop,
      throttleTime(100),
      withLatestFrom(isScrolling),
      filter(([_, isScrolling2]) => !!isScrolling2),
      scan(([_, prev], [next]) => [prev, next], [0, 0]),
      map(([prev, next]) => next - prev)
    ),
    scrollVelocity
  );
  return {
    isScrolling,
    isAtTop,
    isAtBottom,
    atBottomState,
    atTopStateChange,
    atBottomStateChange,
    scrollDirection,
    atBottomThreshold,
    atTopThreshold,
    scrollVelocity,
    lastJumpDueToItemResize
  };
}, tup(domIOSystem));
const propsReadySystem = system(
  ([{ log }]) => {
    const propsReady = statefulStream(false);
    const didMount = streamFromEmitter(
      pipe(
        propsReady,
        filter((ready) => ready),
        distinctUntilChanged()
      )
    );
    subscribe(propsReady, (value) => {
      value && getValue(log)("props updated", {}, LogLevel.DEBUG);
    });
    return { propsReady, didMount };
  },
  tup(loggerSystem),
  { singleton: true }
);
function skipFrames(frameCount, callback) {
  if (frameCount == 0) {
    callback();
  } else {
    requestAnimationFrame(() => skipFrames(frameCount - 1, callback));
  }
}
function getInitialTopMostItemIndexNumber(location, totalCount) {
  const lastIndex = totalCount - 1;
  const index = typeof location === "number" ? location : location.index === "LAST" ? lastIndex : location.index;
  return index;
}
const initialTopMostItemIndexSystem = system(
  ([{ sizes, listRefresh, defaultItemSize }, { scrollTop }, { scrollToIndex }, { didMount }]) => {
    const scrolledToInitialItem = statefulStream(true);
    const initialTopMostItemIndex = statefulStream(0);
    const scrollScheduled = statefulStream(false);
    connect(
      pipe(
        didMount,
        withLatestFrom(initialTopMostItemIndex),
        filter(([_, location]) => !!location),
        mapTo(false)
      ),
      scrolledToInitialItem
    );
    subscribe(
      pipe(
        combineLatest(listRefresh, didMount),
        withLatestFrom(scrolledToInitialItem, sizes, defaultItemSize, scrollScheduled),
        filter(([[, didMount2], scrolledToInitialItem2, { sizeTree }, defaultItemSize2, scrollScheduled2]) => {
          return didMount2 && (!empty(sizeTree) || isDefined(defaultItemSize2)) && !scrolledToInitialItem2 && !scrollScheduled2;
        }),
        withLatestFrom(initialTopMostItemIndex)
      ),
      ([, initialTopMostItemIndex2]) => {
        publish(scrollScheduled, true);
        skipFrames(3, () => {
          handleNext(scrollTop, () => publish(scrolledToInitialItem, true));
          publish(scrollToIndex, initialTopMostItemIndex2);
        });
      }
    );
    return {
      scrolledToInitialItem,
      initialTopMostItemIndex
    };
  },
  tup(sizeSystem, domIOSystem, scrollToIndexSystem, propsReadySystem),
  { singleton: true }
);
function normalizeFollowOutput(follow) {
  if (!follow) {
    return false;
  }
  return follow === "smooth" ? "smooth" : "auto";
}
const behaviorFromFollowOutput = (follow, isAtBottom) => {
  if (typeof follow === "function") {
    return normalizeFollowOutput(follow(isAtBottom));
  }
  return isAtBottom && normalizeFollowOutput(follow);
};
const followOutputSystem = system(
  ([
    { totalCount, listRefresh },
    { isAtBottom, atBottomState },
    { scrollToIndex },
    { scrolledToInitialItem },
    { propsReady, didMount },
    { log },
    { scrollingInProgress }
  ]) => {
    const followOutput = statefulStream(false);
    const autoscrollToBottom = stream();
    let pendingScrollHandle = null;
    function scrollToBottom(followOutputBehavior) {
      publish(scrollToIndex, {
        index: "LAST",
        align: "end",
        behavior: followOutputBehavior
      });
    }
    subscribe(
      pipe(
        combineLatest(pipe(duc(totalCount), skip(1)), didMount),
        withLatestFrom(duc(followOutput), isAtBottom, scrolledToInitialItem, scrollingInProgress),
        map(([[totalCount2, didMount2], followOutput2, isAtBottom2, scrolledToInitialItem2, scrollingInProgress2]) => {
          let shouldFollow = didMount2 && scrolledToInitialItem2;
          let followOutputBehavior = "auto";
          if (shouldFollow) {
            followOutputBehavior = behaviorFromFollowOutput(followOutput2, isAtBottom2 || scrollingInProgress2);
            shouldFollow = shouldFollow && !!followOutputBehavior;
          }
          return { totalCount: totalCount2, shouldFollow, followOutputBehavior };
        }),
        filter(({ shouldFollow }) => shouldFollow)
      ),
      ({ totalCount: totalCount2, followOutputBehavior }) => {
        if (pendingScrollHandle) {
          pendingScrollHandle();
          pendingScrollHandle = null;
        }
        pendingScrollHandle = handleNext(listRefresh, () => {
          getValue(log)("following output to ", { totalCount: totalCount2 }, LogLevel.DEBUG);
          scrollToBottom(followOutputBehavior);
          pendingScrollHandle = null;
        });
      }
    );
    function trapNextSizeIncrease(followOutput2) {
      const cancel = handleNext(atBottomState, (state) => {
        if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "SIZE_INCREASED" && !pendingScrollHandle) {
          getValue(log)("scrolling to bottom due to increased size", {}, LogLevel.DEBUG);
          scrollToBottom("auto");
        }
      });
      setTimeout(cancel, 100);
    }
    subscribe(
      pipe(
        combineLatest(duc(followOutput), totalCount, propsReady),
        filter(([follow, , ready]) => follow && ready),
        scan(
          ({ value }, [, next]) => {
            return { refreshed: value === next, value: next };
          },
          { refreshed: false, value: 0 }
        ),
        filter(({ refreshed }) => refreshed),
        withLatestFrom(followOutput, totalCount)
      ),
      ([, followOutput2]) => {
        trapNextSizeIncrease(followOutput2 !== false);
      }
    );
    subscribe(autoscrollToBottom, () => {
      trapNextSizeIncrease(getValue(followOutput) !== false);
    });
    subscribe(combineLatest(duc(followOutput), atBottomState), ([followOutput2, state]) => {
      if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING") {
        scrollToBottom("auto");
      }
    });
    return { followOutput, autoscrollToBottom };
  },
  tup(sizeSystem, stateFlagsSystem, scrollToIndexSystem, initialTopMostItemIndexSystem, propsReadySystem, loggerSystem, domIOSystem)
);
function groupCountsToIndicesAndCount(counts) {
  return counts.reduce(
    (acc, groupCount) => {
      acc.groupIndices.push(acc.totalCount);
      acc.totalCount += groupCount + 1;
      return acc;
    },
    {
      totalCount: 0,
      groupIndices: []
    }
  );
}
const groupedListSystem = system(([{ totalCount, groupIndices, sizes }, { scrollTop, headerHeight }]) => {
  const groupCounts = stream();
  const topItemsIndexes = stream();
  const groupIndicesAndCount = streamFromEmitter(pipe(groupCounts, map(groupCountsToIndicesAndCount)));
  connect(
    pipe(
      groupIndicesAndCount,
      map((value) => value.totalCount)
    ),
    totalCount
  );
  connect(
    pipe(
      groupIndicesAndCount,
      map((value) => value.groupIndices)
    ),
    groupIndices
  );
  connect(
    pipe(
      combineLatest(scrollTop, sizes, headerHeight),
      filter(([_, sizes2]) => hasGroups(sizes2)),
      map(([scrollTop2, state, headerHeight2]) => findMaxKeyValue(state.groupOffsetTree, Math.max(scrollTop2 - headerHeight2, 0), "v")[0]),
      distinctUntilChanged(),
      map((index) => [index])
    ),
    topItemsIndexes
  );
  return { groupCounts, topItemsIndexes };
}, tup(sizeSystem, domIOSystem));
function tupleComparator(prev, current) {
  return !!(prev && prev[0] === current[0] && prev[1] === current[1]);
}
function rangeComparator(prev, next) {
  return !!(prev && prev.startIndex === next.startIndex && prev.endIndex === next.endIndex);
}
const TOP = "top";
const BOTTOM = "bottom";
const NONE = "none";
function getOverscan(overscan, end, direction) {
  if (typeof overscan === "number") {
    return direction === UP && end === TOP || direction === DOWN && end === BOTTOM ? overscan : 0;
  } else {
    if (direction === UP) {
      return end === TOP ? overscan.main : overscan.reverse;
    } else {
      return end === BOTTOM ? overscan.main : overscan.reverse;
    }
  }
}
function getViewportIncrease(value, end) {
  return typeof value === "number" ? value : value[end] || 0;
}
const sizeRangeSystem = system(
  ([{ scrollTop, viewportHeight, deviation, headerHeight, fixedHeaderHeight }]) => {
    const listBoundary = stream();
    const topListHeight = statefulStream(0);
    const increaseViewportBy = statefulStream(0);
    const overscan = statefulStream(0);
    const visibleRange = statefulStreamFromEmitter(
      pipe(
        combineLatest(
          duc(scrollTop),
          duc(viewportHeight),
          duc(headerHeight),
          duc(listBoundary, tupleComparator),
          duc(overscan),
          duc(topListHeight),
          duc(fixedHeaderHeight),
          duc(deviation),
          duc(increaseViewportBy)
        ),
        map(
          ([
            scrollTop2,
            viewportHeight2,
            headerHeight2,
            [listTop, listBottom],
            overscan2,
            topListHeight2,
            fixedHeaderHeight2,
            deviation2,
            increaseViewportBy2
          ]) => {
            const top = scrollTop2 - deviation2;
            const stickyHeaderHeight = topListHeight2 + fixedHeaderHeight2;
            const headerVisible = Math.max(headerHeight2 - top, 0);
            let direction = NONE;
            const topViewportAddition = getViewportIncrease(increaseViewportBy2, TOP);
            const bottomViewportAddition = getViewportIncrease(increaseViewportBy2, BOTTOM);
            listTop -= deviation2;
            listTop += headerHeight2 + fixedHeaderHeight2;
            listBottom += headerHeight2 + fixedHeaderHeight2;
            listBottom -= deviation2;
            if (listTop > scrollTop2 + stickyHeaderHeight - topViewportAddition) {
              direction = UP;
            }
            if (listBottom < scrollTop2 - headerVisible + viewportHeight2 + bottomViewportAddition) {
              direction = DOWN;
            }
            if (direction !== NONE) {
              return [
                Math.max(top - headerHeight2 - getOverscan(overscan2, TOP, direction) - topViewportAddition, 0),
                top - headerVisible - fixedHeaderHeight2 + viewportHeight2 + getOverscan(overscan2, BOTTOM, direction) + bottomViewportAddition
              ];
            }
            return null;
          }
        ),
        filter((value) => value != null),
        distinctUntilChanged(tupleComparator)
      ),
      [0, 0]
    );
    return {
      // input
      listBoundary,
      overscan,
      topListHeight,
      increaseViewportBy,
      // output
      visibleRange
    };
  },
  tup(domIOSystem),
  { singleton: true }
);
function probeItemSet(index, sizes, data) {
  if (hasGroups(sizes)) {
    const itemIndex = originalIndexFromItemIndex(index, sizes);
    const groupIndex = findMaxKeyValue(sizes.groupOffsetTree, itemIndex)[0];
    return [
      { index: groupIndex, size: 0, offset: 0 },
      { index: itemIndex, size: 0, offset: 0, data: data && data[0] }
    ];
  }
  return [{ index, size: 0, offset: 0, data: data && data[0] }];
}
const EMPTY_LIST_STATE = {
  items: [],
  topItems: [],
  offsetTop: 0,
  offsetBottom: 0,
  top: 0,
  bottom: 0,
  topListHeight: 0,
  totalCount: 0,
  firstItemIndex: 0
};
function transposeItems(items, sizes, firstItemIndex) {
  if (items.length === 0) {
    return [];
  }
  if (!hasGroups(sizes)) {
    return items.map((item) => ({ ...item, index: item.index + firstItemIndex, originalIndex: item.index }));
  }
  const startIndex = items[0].index;
  const endIndex = items[items.length - 1].index;
  const transposedItems = [];
  const groupRanges = rangesWithin(sizes.groupOffsetTree, startIndex, endIndex);
  let currentRange = void 0;
  let currentGroupIndex = 0;
  for (const item of items) {
    if (!currentRange || currentRange.end < item.index) {
      currentRange = groupRanges.shift();
      currentGroupIndex = sizes.groupIndices.indexOf(currentRange.start);
    }
    let transposedItem;
    if (item.index === currentRange.start) {
      transposedItem = {
        type: "group",
        index: currentGroupIndex
      };
    } else {
      transposedItem = {
        index: item.index - (currentGroupIndex + 1) + firstItemIndex,
        groupIndex: currentGroupIndex
      };
    }
    transposedItems.push({
      ...transposedItem,
      size: item.size,
      offset: item.offset,
      originalIndex: item.index,
      data: item.data
    });
  }
  return transposedItems;
}
function buildListState(items, topItems, totalCount, gap, sizes, firstItemIndex) {
  const { lastSize, lastOffset, lastIndex } = sizes;
  let offsetTop = 0;
  let bottom = 0;
  if (items.length > 0) {
    offsetTop = items[0].offset;
    const lastItem = items[items.length - 1];
    bottom = lastItem.offset + lastItem.size;
  }
  const itemCount = totalCount - lastIndex;
  const total = lastOffset + itemCount * lastSize + (itemCount - 1) * gap;
  const top = offsetTop;
  const offsetBottom = total - bottom;
  return {
    items: transposeItems(items, sizes, firstItemIndex),
    topItems: transposeItems(topItems, sizes, firstItemIndex),
    topListHeight: topItems.reduce((height, item) => item.size + height, 0),
    offsetTop,
    offsetBottom,
    top,
    bottom,
    totalCount,
    firstItemIndex
  };
}
function buildListStateFromItemCount(itemCount, initialTopMostItemIndex, sizes, firstItemIndex, gap, data) {
  let includedGroupsCount = 0;
  if (sizes.groupIndices.length > 0) {
    for (const index of sizes.groupIndices) {
      if (index - includedGroupsCount >= itemCount) {
        break;
      }
      includedGroupsCount++;
    }
  }
  const adjustedCount = itemCount + includedGroupsCount;
  const initialTopMostItemIndexNumber = getInitialTopMostItemIndexNumber(initialTopMostItemIndex, adjustedCount);
  const items = Array.from({ length: adjustedCount }).map((_, index) => ({
    index: index + initialTopMostItemIndexNumber,
    size: 0,
    offset: 0,
    data: data[index + initialTopMostItemIndexNumber]
  }));
  return buildListState(items, [], adjustedCount, gap, sizes, firstItemIndex);
}
const listStateSystem = system(
  ([
    { sizes, totalCount, data, firstItemIndex, gap },
    groupedListSystem2,
    { visibleRange, listBoundary, topListHeight: rangeTopListHeight },
    { scrolledToInitialItem, initialTopMostItemIndex },
    { topListHeight },
    stateFlags,
    { didMount },
    { recalcInProgress }
  ]) => {
    const topItemsIndexes = statefulStream([]);
    const initialItemCount = statefulStream(0);
    const itemsRendered = stream();
    connect(groupedListSystem2.topItemsIndexes, topItemsIndexes);
    const listState = statefulStreamFromEmitter(
      pipe(
        combineLatest(
          didMount,
          recalcInProgress,
          duc(visibleRange, tupleComparator),
          duc(totalCount),
          duc(sizes),
          duc(initialTopMostItemIndex),
          scrolledToInitialItem,
          duc(topItemsIndexes),
          duc(firstItemIndex),
          duc(gap),
          data
        ),
        filter(([mount, recalcInProgress2, , totalCount2, , , , , , , data2]) => {
          const dataChangeInProgress = data2 && data2.length !== totalCount2;
          return mount && !recalcInProgress2 && !dataChangeInProgress;
        }),
        map(
          ([
            ,
            ,
            [startOffset, endOffset],
            totalCount2,
            sizes2,
            initialTopMostItemIndex2,
            scrolledToInitialItem2,
            topItemsIndexes2,
            firstItemIndex2,
            gap2,
            data2
          ]) => {
            const sizesValue = sizes2;
            const { sizeTree, offsetTree } = sizesValue;
            const initialItemCountValue = getValue(initialItemCount);
            if (totalCount2 === 0) {
              return { ...EMPTY_LIST_STATE, totalCount: totalCount2 };
            }
            if (startOffset === 0 && endOffset === 0) {
              if (initialItemCountValue === 0) {
                return { ...EMPTY_LIST_STATE, totalCount: totalCount2 };
              } else {
                return buildListStateFromItemCount(initialItemCountValue, initialTopMostItemIndex2, sizes2, firstItemIndex2, gap2, data2 || []);
              }
            }
            if (empty(sizeTree)) {
              if (initialItemCountValue > 0) {
                return null;
              }
              const state = buildListState(
                probeItemSet(getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2), sizesValue, data2),
                [],
                totalCount2,
                gap2,
                sizesValue,
                firstItemIndex2
              );
              return state;
            }
            const topItems = [];
            if (topItemsIndexes2.length > 0) {
              const startIndex = topItemsIndexes2[0];
              const endIndex = topItemsIndexes2[topItemsIndexes2.length - 1];
              let offset = 0;
              for (const range of rangesWithin(sizeTree, startIndex, endIndex)) {
                const size = range.value;
                const rangeStartIndex = Math.max(range.start, startIndex);
                const rangeEndIndex = Math.min(range.end, endIndex);
                for (let i = rangeStartIndex; i <= rangeEndIndex; i++) {
                  topItems.push({ index: i, size, offset, data: data2 && data2[i] });
                  offset += size;
                }
              }
            }
            if (!scrolledToInitialItem2) {
              return buildListState([], topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
            }
            const minStartIndex = topItemsIndexes2.length > 0 ? topItemsIndexes2[topItemsIndexes2.length - 1] + 1 : 0;
            const offsetPointRanges = rangesWithinOffsets(offsetTree, startOffset, endOffset, minStartIndex);
            if (offsetPointRanges.length === 0) {
              return null;
            }
            const maxIndex = totalCount2 - 1;
            const items = tap([], (result) => {
              for (const range of offsetPointRanges) {
                const point = range.value;
                let offset = point.offset;
                let rangeStartIndex = range.start;
                const size = point.size;
                if (point.offset < startOffset) {
                  rangeStartIndex += Math.floor((startOffset - point.offset + gap2) / (size + gap2));
                  const itemCount = rangeStartIndex - range.start;
                  offset += itemCount * size + itemCount * gap2;
                }
                if (rangeStartIndex < minStartIndex) {
                  offset += (minStartIndex - rangeStartIndex) * size;
                  rangeStartIndex = minStartIndex;
                }
                const endIndex = Math.min(range.end, maxIndex);
                for (let i = rangeStartIndex; i <= endIndex; i++) {
                  if (offset >= endOffset) {
                    break;
                  }
                  result.push({ index: i, size, offset, data: data2 && data2[i] });
                  offset += size + gap2;
                }
              }
            });
            return buildListState(items, topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
          }
        ),
        //@ts-expect-error filter needs to be fixed
        filter((value) => value !== null),
        distinctUntilChanged()
      ),
      EMPTY_LIST_STATE
    );
    connect(
      pipe(
        data,
        filter(isDefined),
        map((data2) => data2 == null ? void 0 : data2.length)
      ),
      totalCount
    );
    connect(
      pipe(
        listState,
        map((value) => value.topListHeight)
      ),
      topListHeight
    );
    connect(topListHeight, rangeTopListHeight);
    connect(
      pipe(
        listState,
        map((state) => [state.top, state.bottom])
      ),
      listBoundary
    );
    connect(
      pipe(
        listState,
        map((state) => state.items)
      ),
      itemsRendered
    );
    const endReached = streamFromEmitter(
      pipe(
        listState,
        filter(({ items }) => items.length > 0),
        withLatestFrom(totalCount, data),
        filter(([{ items }, totalCount2]) => items[items.length - 1].originalIndex === totalCount2 - 1),
        map(([, totalCount2, data2]) => [totalCount2 - 1, data2]),
        distinctUntilChanged(tupleComparator),
        map(([count]) => count)
      )
    );
    const startReached = streamFromEmitter(
      pipe(
        listState,
        throttleTime(200),
        filter(({ items, topItems }) => {
          return items.length > 0 && items[0].originalIndex === topItems.length;
        }),
        map(({ items }) => items[0].index),
        distinctUntilChanged()
      )
    );
    const rangeChanged = streamFromEmitter(
      pipe(
        listState,
        filter(({ items }) => items.length > 0),
        map(({ items }) => {
          let startIndex = 0;
          let endIndex = items.length - 1;
          while (items[startIndex].type === "group" && startIndex < endIndex) {
            startIndex++;
          }
          while (items[endIndex].type === "group" && endIndex > startIndex) {
            endIndex--;
          }
          return {
            startIndex: items[startIndex].index,
            endIndex: items[endIndex].index
          };
        }),
        distinctUntilChanged(rangeComparator)
      )
    );
    return { listState, topItemsIndexes, endReached, startReached, rangeChanged, itemsRendered, initialItemCount, ...stateFlags };
  },
  tup(
    sizeSystem,
    groupedListSystem,
    sizeRangeSystem,
    initialTopMostItemIndexSystem,
    scrollToIndexSystem,
    stateFlagsSystem,
    propsReadySystem,
    recalcSystem
  ),
  { singleton: true }
);
const initialItemCountSystem = system(
  ([{ sizes, firstItemIndex, data, gap }, { initialTopMostItemIndex }, { initialItemCount, listState }, { didMount }]) => {
    connect(
      pipe(
        didMount,
        withLatestFrom(initialItemCount),
        filter(([, count]) => count !== 0),
        withLatestFrom(initialTopMostItemIndex, sizes, firstItemIndex, gap, data),
        map(([[, count], initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2 = []]) => {
          return buildListStateFromItemCount(count, initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2);
        })
      ),
      listState
    );
    return {};
  },
  tup(sizeSystem, initialTopMostItemIndexSystem, listStateSystem, propsReadySystem),
  { singleton: true }
);
const scrollSeekSystem = system(
  ([{ scrollVelocity }]) => {
    const isSeeking = statefulStream(false);
    const rangeChanged = stream();
    const scrollSeekConfiguration = statefulStream(false);
    connect(
      pipe(
        scrollVelocity,
        withLatestFrom(scrollSeekConfiguration, isSeeking, rangeChanged),
        filter(([_, config]) => !!config),
        map(([speed, config, isSeeking2, range]) => {
          const { exit, enter } = config;
          if (isSeeking2) {
            if (exit(speed, range)) {
              return false;
            }
          } else {
            if (enter(speed, range)) {
              return true;
            }
          }
          return isSeeking2;
        }),
        distinctUntilChanged()
      ),
      isSeeking
    );
    subscribe(
      pipe(combineLatest(isSeeking, scrollVelocity, rangeChanged), withLatestFrom(scrollSeekConfiguration)),
      ([[isSeeking2, velocity, range], config]) => isSeeking2 && config && config.change && config.change(velocity, range)
    );
    return { isSeeking, scrollSeekConfiguration, scrollVelocity, scrollSeekRangeChanged: rangeChanged };
  },
  tup(stateFlagsSystem),
  { singleton: true }
);
const topItemCountSystem = system(([{ topItemsIndexes }]) => {
  const topItemCount = statefulStream(0);
  connect(
    pipe(
      topItemCount,
      filter((length) => length > 0),
      map((length) => Array.from({ length }).map((_, index) => index))
    ),
    topItemsIndexes
  );
  return { topItemCount };
}, tup(listStateSystem));
const totalListHeightSystem = system(
  ([{ footerHeight, headerHeight, fixedHeaderHeight, fixedFooterHeight }, { listState }]) => {
    const totalListHeightChanged = stream();
    const totalListHeight = statefulStreamFromEmitter(
      pipe(
        combineLatest(footerHeight, fixedFooterHeight, headerHeight, fixedHeaderHeight, listState),
        map(([footerHeight2, fixedFooterHeight2, headerHeight2, fixedHeaderHeight2, listState2]) => {
          return footerHeight2 + fixedFooterHeight2 + headerHeight2 + fixedHeaderHeight2 + listState2.offsetBottom + listState2.bottom;
        })
      ),
      0
    );
    connect(duc(totalListHeight), totalListHeightChanged);
    return { totalListHeight, totalListHeightChanged };
  },
  tup(domIOSystem, listStateSystem),
  { singleton: true }
);
function simpleMemoize(func) {
  let called = false;
  let result;
  return () => {
    if (!called) {
      called = true;
      result = func();
    }
    return result;
  };
}
const isMobileSafari = simpleMemoize(() => {
  return /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent);
});
const upwardScrollFixSystem = system(
  ([
    { scrollBy, scrollTop, deviation, scrollingInProgress },
    { isScrolling, isAtBottom, scrollDirection, lastJumpDueToItemResize },
    { listState },
    { beforeUnshiftWith, shiftWithOffset, sizes, gap },
    { log },
    { recalcInProgress }
  ]) => {
    const deviationOffset = streamFromEmitter(
      pipe(
        listState,
        withLatestFrom(lastJumpDueToItemResize),
        scan(
          ([, prevItems, prevTotalCount, prevTotalHeight], [{ items, totalCount, bottom, offsetBottom }, lastJumpDueToItemResize2]) => {
            const totalHeight = bottom + offsetBottom;
            let newDev = 0;
            if (prevTotalCount === totalCount) {
              if (prevItems.length > 0 && items.length > 0) {
                const atStart = items[0].originalIndex === 0 && prevItems[0].originalIndex === 0;
                if (!atStart) {
                  newDev = totalHeight - prevTotalHeight;
                  if (newDev !== 0) {
                    newDev += lastJumpDueToItemResize2;
                  }
                }
              }
            }
            return [newDev, items, totalCount, totalHeight];
          },
          [0, [], 0, 0]
        ),
        filter(([amount]) => amount !== 0),
        withLatestFrom(scrollTop, scrollDirection, scrollingInProgress, isAtBottom, log, recalcInProgress),
        filter(([, scrollTop2, scrollDirection2, scrollingInProgress2, , , recalcInProgress2]) => {
          return !recalcInProgress2 && !scrollingInProgress2 && scrollTop2 !== 0 && scrollDirection2 === UP;
        }),
        map(([[amount], , , , , log2]) => {
          log2("Upward scrolling compensation", { amount }, LogLevel.DEBUG);
          return amount;
        })
      )
    );
    function scrollByWith(offset) {
      if (offset > 0) {
        publish(scrollBy, { top: -offset, behavior: "auto" });
        publish(deviation, 0);
      } else {
        publish(deviation, 0);
        publish(scrollBy, { top: -offset, behavior: "auto" });
      }
    }
    subscribe(pipe(deviationOffset, withLatestFrom(deviation, isScrolling)), ([offset, deviationAmount, isScrolling2]) => {
      if (isScrolling2 && isMobileSafari()) {
        publish(deviation, deviationAmount - offset);
      } else {
        scrollByWith(-offset);
      }
    });
    subscribe(
      pipe(
        combineLatest(statefulStreamFromEmitter(isScrolling, false), deviation, recalcInProgress),
        filter(([is, deviation2, recalc]) => !is && !recalc && deviation2 !== 0),
        map(([_, deviation2]) => deviation2),
        throttleTime(1)
      ),
      scrollByWith
    );
    connect(
      pipe(
        shiftWithOffset,
        map((offset) => {
          return { top: -offset };
        })
      ),
      scrollBy
    );
    subscribe(
      pipe(
        beforeUnshiftWith,
        withLatestFrom(sizes, gap),
        map(([offset, { lastSize: defaultItemSize, groupIndices, sizeTree }, gap2]) => {
          function getItemOffset(itemCount) {
            return itemCount * (defaultItemSize + gap2);
          }
          if (groupIndices.length === 0) {
            return getItemOffset(offset);
          } else {
            let amount = 0;
            const defaultGroupSize = find(sizeTree, 0);
            let recognizedOffsetItems = 0;
            let groupIndex = 0;
            while (recognizedOffsetItems < offset) {
              recognizedOffsetItems++;
              amount += defaultGroupSize;
              let groupItemCount = groupIndices.length === groupIndex + 1 ? Infinity : groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
              if (recognizedOffsetItems + groupItemCount > offset) {
                amount -= defaultGroupSize;
                groupItemCount = offset - recognizedOffsetItems + 1;
              }
              recognizedOffsetItems += groupItemCount;
              amount += getItemOffset(groupItemCount);
              groupIndex++;
            }
            return amount;
          }
        })
      ),
      (offset) => {
        publish(deviation, offset);
        requestAnimationFrame(() => {
          publish(scrollBy, { top: offset });
          requestAnimationFrame(() => {
            publish(deviation, 0);
            publish(recalcInProgress, false);
          });
        });
      }
    );
    return { deviation };
  },
  tup(domIOSystem, stateFlagsSystem, listStateSystem, sizeSystem, loggerSystem, recalcSystem)
);
const initialScrollTopSystem = system(
  ([{ didMount }, { scrollTo }, { listState }]) => {
    const initialScrollTop = statefulStream(0);
    subscribe(
      pipe(
        didMount,
        withLatestFrom(initialScrollTop),
        filter(([, offset]) => offset !== 0),
        map(([, offset]) => ({ top: offset }))
      ),
      (location) => {
        handleNext(
          pipe(
            listState,
            skip(1),
            filter((state) => state.items.length > 1)
          ),
          () => {
            requestAnimationFrame(() => {
              publish(scrollTo, location);
            });
          }
        );
      }
    );
    return {
      initialScrollTop
    };
  },
  tup(propsReadySystem, domIOSystem, listStateSystem),
  { singleton: true }
);
const alignToBottomSystem = system(
  ([{ viewportHeight }, { totalListHeight }]) => {
    const alignToBottom = statefulStream(false);
    const paddingTopAddition = statefulStreamFromEmitter(
      pipe(
        combineLatest(alignToBottom, viewportHeight, totalListHeight),
        filter(([enabled]) => enabled),
        map(([, viewportHeight2, totalListHeight2]) => {
          return Math.max(0, viewportHeight2 - totalListHeight2);
        }),
        throttleTime(0),
        distinctUntilChanged()
      ),
      0
    );
    return { alignToBottom, paddingTopAddition };
  },
  tup(domIOSystem, totalListHeightSystem),
  { singleton: true }
);
const windowScrollerSystem = system(([{ scrollTo, scrollContainerState }]) => {
  const windowScrollContainerState = stream();
  const windowViewportRect = stream();
  const windowScrollTo = stream();
  const useWindowScroll = statefulStream(false);
  const customScrollParent = statefulStream(void 0);
  connect(
    pipe(
      combineLatest(windowScrollContainerState, windowViewportRect),
      map(([{ viewportHeight, scrollTop: windowScrollTop, scrollHeight }, { offsetTop }]) => {
        return {
          scrollTop: Math.max(0, windowScrollTop - offsetTop),
          scrollHeight,
          viewportHeight
        };
      })
    ),
    scrollContainerState
  );
  connect(
    pipe(
      scrollTo,
      withLatestFrom(windowViewportRect),
      map(([scrollTo2, { offsetTop }]) => {
        return {
          ...scrollTo2,
          top: scrollTo2.top + offsetTop
        };
      })
    ),
    windowScrollTo
  );
  return {
    // config
    useWindowScroll,
    customScrollParent,
    // input
    windowScrollContainerState,
    windowViewportRect,
    // signals
    windowScrollTo
  };
}, tup(domIOSystem));
const defaultCalculateViewLocation = ({
  itemTop: itemTop2,
  itemBottom,
  viewportTop,
  viewportBottom,
  locationParams: { behavior, align, ...rest }
}) => {
  if (itemTop2 < viewportTop) {
    return { ...rest, behavior, align: align != null ? align : "start" };
  }
  if (itemBottom > viewportBottom) {
    return { ...rest, behavior, align: align != null ? align : "end" };
  }
  return null;
};
const scrollIntoViewSystem = system(
  ([
    { sizes, totalCount, gap },
    { scrollTop, viewportHeight, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollingInProgress },
    { scrollToIndex }
  ]) => {
    const scrollIntoView = stream();
    connect(
      pipe(
        scrollIntoView,
        withLatestFrom(sizes, viewportHeight, totalCount, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollTop),
        withLatestFrom(gap),
        map(([[viewLocation, sizes2, viewportHeight2, totalCount2, headerHeight2, fixedHeaderHeight2, fixedFooterHeight2, scrollTop2], gap2]) => {
          const { done, behavior, align, calculateViewLocation = defaultCalculateViewLocation, ...rest } = viewLocation;
          const actualIndex = originalIndexFromLocation(viewLocation, sizes2, totalCount2 - 1);
          const itemTop2 = offsetOf(actualIndex, sizes2.offsetTree, gap2) + headerHeight2 + fixedHeaderHeight2;
          const itemBottom = itemTop2 + findMaxKeyValue(sizes2.sizeTree, actualIndex)[1];
          const viewportTop = scrollTop2 + fixedHeaderHeight2;
          const viewportBottom = scrollTop2 + viewportHeight2 - fixedFooterHeight2;
          const location = calculateViewLocation({
            itemTop: itemTop2,
            itemBottom,
            viewportTop,
            viewportBottom,
            locationParams: { behavior, align, ...rest }
          });
          if (location) {
            done && handleNext(
              pipe(
                scrollingInProgress,
                filter((value) => value === false),
                // skips the initial publish of false, and the cleanup call.
                // but if scrollingInProgress is true, we skip the initial publish.
                skip(getValue(scrollingInProgress) ? 1 : 2)
              ),
              done
            );
          } else {
            done && done();
          }
          return location;
        }),
        filter((value) => value !== null)
      ),
      scrollToIndex
    );
    return {
      scrollIntoView
    };
  },
  tup(sizeSystem, domIOSystem, scrollToIndexSystem, listStateSystem, loggerSystem),
  { singleton: true }
);
const stateLoadSystem = system(
  ([
    { sizes, sizeRanges },
    { scrollTop },
    { initialTopMostItemIndex },
    { didMount },
    { useWindowScroll, windowScrollContainerState, windowViewportRect }
  ]) => {
    const getState = stream();
    const restoreStateFrom = statefulStream(void 0);
    const statefulWindowScrollContainerState = statefulStream(null);
    const statefulWindowViewportRect = statefulStream(null);
    connect(windowScrollContainerState, statefulWindowScrollContainerState);
    connect(windowViewportRect, statefulWindowViewportRect);
    subscribe(
      pipe(getState, withLatestFrom(sizes, scrollTop, useWindowScroll, statefulWindowScrollContainerState, statefulWindowViewportRect)),
      ([callback, sizes2, scrollTop2, useWindowScroll2, windowScrollContainerState2, windowViewportRect2]) => {
        const ranges = sizeTreeToRanges(sizes2.sizeTree);
        if (useWindowScroll2 && windowScrollContainerState2 !== null && windowViewportRect2 !== null) {
          scrollTop2 = windowScrollContainerState2.scrollTop - windowViewportRect2.offsetTop;
        }
        callback({ ranges, scrollTop: scrollTop2 });
      }
    );
    connect(pipe(restoreStateFrom, filter(isDefined), map(locationFromSnapshot)), initialTopMostItemIndex);
    connect(
      pipe(
        didMount,
        withLatestFrom(restoreStateFrom),
        filter(([, state]) => state !== void 0),
        distinctUntilChanged(),
        map(([, snapshot]) => {
          return snapshot.ranges;
        })
      ),
      sizeRanges
    );
    return {
      getState,
      restoreStateFrom
    };
  },
  tup(sizeSystem, domIOSystem, initialTopMostItemIndexSystem, propsReadySystem, windowScrollerSystem)
);
function locationFromSnapshot(snapshot) {
  return { offset: snapshot.scrollTop, index: 0, align: "start" };
}
const featureGroup1System = system(
  ([
    sizeRange,
    initialItemCount,
    propsReady,
    scrollSeek,
    totalListHeight,
    initialScrollTopSystem2,
    alignToBottom,
    windowScroller,
    scrollIntoView,
    logger
  ]) => {
    return {
      ...sizeRange,
      ...initialItemCount,
      ...propsReady,
      ...scrollSeek,
      ...totalListHeight,
      ...initialScrollTopSystem2,
      ...alignToBottom,
      ...windowScroller,
      ...scrollIntoView,
      ...logger
    };
  },
  tup(
    sizeRangeSystem,
    initialItemCountSystem,
    propsReadySystem,
    scrollSeekSystem,
    totalListHeightSystem,
    initialScrollTopSystem,
    alignToBottomSystem,
    windowScrollerSystem,
    scrollIntoViewSystem,
    loggerSystem
  )
);
const listSystem = system(
  ([
    {
      totalCount,
      sizeRanges,
      fixedItemSize,
      defaultItemSize,
      trackItemSizes,
      itemSize,
      data,
      firstItemIndex,
      groupIndices,
      statefulTotalCount,
      gap,
      sizes
    },
    { initialTopMostItemIndex, scrolledToInitialItem },
    domIO,
    stateLoad,
    followOutput,
    { listState, topItemsIndexes, ...flags },
    { scrollToIndex },
    _,
    { topItemCount },
    { groupCounts },
    featureGroup1
  ]) => {
    connect(flags.rangeChanged, featureGroup1.scrollSeekRangeChanged);
    connect(
      pipe(
        featureGroup1.windowViewportRect,
        map((value) => value.visibleHeight)
      ),
      domIO.viewportHeight
    );
    return {
      // input
      totalCount,
      data,
      firstItemIndex,
      sizeRanges,
      initialTopMostItemIndex,
      scrolledToInitialItem,
      topItemsIndexes,
      topItemCount,
      groupCounts,
      fixedItemHeight: fixedItemSize,
      defaultItemHeight: defaultItemSize,
      gap,
      ...followOutput,
      // output
      statefulTotalCount,
      listState,
      scrollToIndex,
      trackItemSizes,
      itemSize,
      groupIndices,
      // exported from stateFlagsSystem
      ...flags,
      // the bag of IO from featureGroup1System
      ...featureGroup1,
      ...domIO,
      sizes,
      ...stateLoad
    };
  },
  tup(
    sizeSystem,
    initialTopMostItemIndexSystem,
    domIOSystem,
    stateLoadSystem,
    followOutputSystem,
    listStateSystem,
    scrollToIndexSystem,
    upwardScrollFixSystem,
    topItemCountSystem,
    groupedListSystem,
    featureGroup1System
  )
);
const WEBKIT_STICKY = "-webkit-sticky";
const STICKY = "sticky";
const positionStickyCssValue = simpleMemoize(() => {
  if (typeof document === "undefined") {
    return STICKY;
  }
  const node = document.createElement("div");
  node.style.position = WEBKIT_STICKY;
  return node.style.position === WEBKIT_STICKY ? WEBKIT_STICKY : STICKY;
});
function useWindowViewportRectRef(callback, customScrollParent) {
  const viewportInfo = React__default.useRef(null);
  const calculateInfo = React__default.useCallback(
    (element) => {
      if (element === null || !element.offsetParent) {
        return;
      }
      const rect = element.getBoundingClientRect();
      const visibleWidth = rect.width;
      let visibleHeight, offsetTop;
      if (customScrollParent) {
        const customScrollParentRect = customScrollParent.getBoundingClientRect();
        const deltaTop = rect.top - customScrollParentRect.top;
        visibleHeight = customScrollParentRect.height - Math.max(0, deltaTop);
        offsetTop = deltaTop + customScrollParent.scrollTop;
      } else {
        visibleHeight = window.innerHeight - Math.max(0, rect.top);
        offsetTop = rect.top + window.pageYOffset;
      }
      viewportInfo.current = {
        offsetTop,
        visibleHeight,
        visibleWidth
      };
      callback(viewportInfo.current);
    },
    [callback, customScrollParent]
  );
  const { callbackRef, ref } = useSizeWithElRef(calculateInfo);
  const scrollAndResizeEventHandler = React__default.useCallback(() => {
    calculateInfo(ref.current);
  }, [calculateInfo, ref]);
  React__default.useEffect(() => {
    if (customScrollParent) {
      customScrollParent.addEventListener("scroll", scrollAndResizeEventHandler);
      const observer = new ResizeObserver(scrollAndResizeEventHandler);
      observer.observe(customScrollParent);
      return () => {
        customScrollParent.removeEventListener("scroll", scrollAndResizeEventHandler);
        observer.unobserve(customScrollParent);
      };
    } else {
      window.addEventListener("scroll", scrollAndResizeEventHandler);
      window.addEventListener("resize", scrollAndResizeEventHandler);
      return () => {
        window.removeEventListener("scroll", scrollAndResizeEventHandler);
        window.removeEventListener("resize", scrollAndResizeEventHandler);
      };
    }
  }, [scrollAndResizeEventHandler, customScrollParent]);
  return callbackRef;
}
const VirtuosoMockContext = React__default.createContext(void 0);
const VirtuosoGridMockContext = React__default.createContext(void 0);
function identity(value) {
  return value;
}
({ position: positionStickyCssValue(), zIndex: 1, overflowAnchor: "none" });
const scrollerStyle = {
  height: "100%",
  outline: "none",
  overflowY: "auto",
  position: "relative",
  WebkitOverflowScrolling: "touch"
};
const viewportStyle = {
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0
};
({
  width: "100%",
  position: positionStickyCssValue(),
  top: 0,
  zIndex: 1
});
function contextPropIfNotDomElement(element, context) {
  if (typeof element === "string") {
    return void 0;
  }
  return { context };
}
function itemPropIfNotDomElement(element, item) {
  return { item: typeof element === "string" ? void 0 : item };
}
function buildScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
  const Scroller2 = React__default.memo(function VirtuosoScroller({ style, children, ...props }) {
    const scrollContainerStateCallback = usePublisher2("scrollContainerState");
    const ScrollerComponent = useEmitterValue2("ScrollerComponent");
    const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
    const scrollerRefCallback = useEmitterValue2("scrollerRef");
    const context = useEmitterValue2("context");
    const { scrollerRef, scrollByCallback, scrollToCallback } = useScrollTop(
      scrollContainerStateCallback,
      smoothScrollTargetReached,
      ScrollerComponent,
      scrollerRefCallback
    );
    useEmitter2("scrollTo", scrollToCallback);
    useEmitter2("scrollBy", scrollByCallback);
    return React__default.createElement(
      ScrollerComponent,
      {
        ref: scrollerRef,
        style: { ...scrollerStyle, ...style },
        "data-test-id": "virtuoso-scroller",
        "data-virtuoso-scroller": true,
        tabIndex: 0,
        ...props,
        ...contextPropIfNotDomElement(ScrollerComponent, context)
      },
      children
    );
  });
  return Scroller2;
}
function buildWindowScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
  const Scroller2 = React__default.memo(function VirtuosoWindowScroller({ style, children, ...props }) {
    const scrollContainerStateCallback = usePublisher2("windowScrollContainerState");
    const ScrollerComponent = useEmitterValue2("ScrollerComponent");
    const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
    const totalListHeight = useEmitterValue2("totalListHeight");
    const deviation = useEmitterValue2("deviation");
    const customScrollParent = useEmitterValue2("customScrollParent");
    const context = useEmitterValue2("context");
    const { scrollerRef, scrollByCallback, scrollToCallback } = useScrollTop(
      scrollContainerStateCallback,
      smoothScrollTargetReached,
      ScrollerComponent,
      noop,
      customScrollParent
    );
    useIsomorphicLayoutEffect$1(() => {
      scrollerRef.current = customScrollParent ? customScrollParent : window;
      return () => {
        scrollerRef.current = null;
      };
    }, [scrollerRef, customScrollParent]);
    useEmitter2("windowScrollTo", scrollToCallback);
    useEmitter2("scrollBy", scrollByCallback);
    return React__default.createElement(
      ScrollerComponent,
      {
        style: { position: "relative", ...style, ...totalListHeight !== 0 ? { height: totalListHeight + deviation } : {} },
        "data-virtuoso-scroller": true,
        ...props,
        ...contextPropIfNotDomElement(ScrollerComponent, context)
      },
      children
    );
  });
  return Scroller2;
}
const INITIAL_GRID_STATE = {
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
};
const PROBE_GRID_STATE = {
  items: [{ index: 0 }],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
};
const { round, ceil, floor, min, max } = Math;
function buildProbeGridState(items) {
  return {
    ...PROBE_GRID_STATE,
    items
  };
}
function buildItems(startIndex, endIndex, data) {
  return Array.from({ length: endIndex - startIndex + 1 }).map((_, i) => {
    const dataItem = data === null ? null : data[i + startIndex];
    return { index: i + startIndex, data: dataItem };
  });
}
function gapComparator(prev, next) {
  return prev && prev.column === next.column && prev.row === next.row;
}
function dimensionComparator(prev, next) {
  return prev && prev.width === next.width && prev.height === next.height;
}
const gridSystem = /* @__PURE__ */ system(
  ([
    { overscan, visibleRange, listBoundary },
    { scrollTop, viewportHeight, scrollBy, scrollTo, smoothScrollTargetReached, scrollContainerState, footerHeight, headerHeight },
    stateFlags,
    scrollSeek,
    { propsReady, didMount },
    { windowViewportRect, useWindowScroll, customScrollParent, windowScrollContainerState, windowScrollTo },
    log
  ]) => {
    const totalCount = statefulStream(0);
    const initialItemCount = statefulStream(0);
    const gridState = statefulStream(INITIAL_GRID_STATE);
    const viewportDimensions = statefulStream({ height: 0, width: 0 });
    const itemDimensions = statefulStream({ height: 0, width: 0 });
    const scrollToIndex = stream();
    const scrollHeight = stream();
    const deviation = statefulStream(0);
    const data = statefulStream(null);
    const gap = statefulStream({ row: 0, column: 0 });
    const stateChanged = stream();
    const restoreStateFrom = stream();
    const stateRestoreInProgress = statefulStream(false);
    const initialTopMostItemIndex = statefulStream(0);
    const scrolledToInitialItem = statefulStream(true);
    const scrollScheduled = statefulStream(false);
    subscribe(
      pipe(
        didMount,
        withLatestFrom(initialTopMostItemIndex),
        filter(([_, location]) => !!location)
      ),
      () => {
        publish(scrolledToInitialItem, false);
        publish(initialItemCount, 0);
      }
    );
    subscribe(
      pipe(
        combineLatest(didMount, scrolledToInitialItem, itemDimensions, viewportDimensions, initialTopMostItemIndex, scrollScheduled),
        filter(([didMount2, scrolledToInitialItem2, itemDimensions2, viewportDimensions2, , scrollScheduled2]) => {
          return didMount2 && !scrolledToInitialItem2 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0 && !scrollScheduled2;
        })
      ),
      ([, , , , initialTopMostItemIndex2]) => {
        publish(scrollScheduled, true);
        skipFrames(1, () => {
          publish(scrollToIndex, initialTopMostItemIndex2);
        });
        handleNext(pipe(scrollTop), () => {
          publish(listBoundary, [0, 0]);
          publish(scrolledToInitialItem, true);
        });
      }
    );
    connect(
      pipe(
        restoreStateFrom,
        filter((value) => value !== void 0 && value !== null && value.scrollTop > 0),
        mapTo(0)
      ),
      initialItemCount
    );
    subscribe(
      pipe(
        didMount,
        withLatestFrom(restoreStateFrom),
        filter(([, snapshot]) => snapshot !== void 0 && snapshot !== null)
      ),
      ([, snapshot]) => {
        if (!snapshot) {
          return;
        }
        publish(viewportDimensions, snapshot.viewport), publish(itemDimensions, snapshot == null ? void 0 : snapshot.item);
        publish(gap, snapshot.gap);
        if (snapshot.scrollTop > 0) {
          publish(stateRestoreInProgress, true);
          handleNext(pipe(scrollTop, skip(1)), (_value) => {
            publish(stateRestoreInProgress, false);
          });
          publish(scrollTo, { top: snapshot.scrollTop });
        }
      }
    );
    connect(
      pipe(
        viewportDimensions,
        map(({ height }) => height)
      ),
      viewportHeight
    );
    connect(
      pipe(
        combineLatest(
          duc(viewportDimensions, dimensionComparator),
          duc(itemDimensions, dimensionComparator),
          duc(gap, (prev, next) => prev && prev.column === next.column && prev.row === next.row),
          duc(scrollTop)
        ),
        map(([viewport, item, gap2, scrollTop2]) => ({
          viewport,
          item,
          gap: gap2,
          scrollTop: scrollTop2
        }))
      ),
      stateChanged
    );
    connect(
      pipe(
        combineLatest(
          duc(totalCount),
          visibleRange,
          duc(gap, gapComparator),
          duc(itemDimensions, dimensionComparator),
          duc(viewportDimensions, dimensionComparator),
          duc(data),
          duc(initialItemCount),
          duc(stateRestoreInProgress),
          duc(scrolledToInitialItem),
          duc(initialTopMostItemIndex)
        ),
        filter(([, , , , , , , stateRestoreInProgress2]) => {
          return !stateRestoreInProgress2;
        }),
        map(
          ([
            totalCount2,
            [startOffset, endOffset],
            gap2,
            item,
            viewport,
            data2,
            initialItemCount2,
            ,
            scrolledToInitialItem2,
            initialTopMostItemIndex2
          ]) => {
            const { row: rowGap, column: columnGap } = gap2;
            const { height: itemHeight, width: itemWidth } = item;
            const { width: viewportWidth } = viewport;
            if (initialItemCount2 === 0 && (totalCount2 === 0 || viewportWidth === 0)) {
              return INITIAL_GRID_STATE;
            }
            if (itemWidth === 0) {
              const startIndex2 = getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2);
              const endIndex2 = startIndex2 === 0 ? Math.max(initialItemCount2 - 1, 0) : startIndex2;
              return buildProbeGridState(buildItems(startIndex2, endIndex2, data2));
            }
            const perRow = itemsPerRow(viewportWidth, itemWidth, columnGap);
            let startIndex;
            let endIndex;
            if (!scrolledToInitialItem2) {
              startIndex = 0;
              endIndex = -1;
            } else if (startOffset === 0 && endOffset === 0 && initialItemCount2 > 0) {
              startIndex = 0;
              endIndex = initialItemCount2 - 1;
            } else {
              startIndex = perRow * floor((startOffset + rowGap) / (itemHeight + rowGap));
              endIndex = perRow * ceil((endOffset + rowGap) / (itemHeight + rowGap)) - 1;
              endIndex = min(totalCount2 - 1, max(endIndex, perRow - 1));
              startIndex = min(endIndex, max(0, startIndex));
            }
            const items = buildItems(startIndex, endIndex, data2);
            const { top, bottom } = gridLayout(viewport, gap2, item, items);
            const rowCount = ceil(totalCount2 / perRow);
            const totalHeight = rowCount * itemHeight + (rowCount - 1) * rowGap;
            const offsetBottom = totalHeight - bottom;
            return { items, offsetTop: top, offsetBottom, top, bottom, itemHeight, itemWidth };
          }
        )
      ),
      gridState
    );
    connect(
      pipe(
        data,
        filter((data2) => data2 !== null),
        map((data2) => data2.length)
      ),
      totalCount
    );
    connect(
      pipe(
        combineLatest(viewportDimensions, itemDimensions, gridState, gap),
        filter(([viewportDimensions2, itemDimensions2, { items }]) => {
          return items.length > 0 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0;
        }),
        map(([viewportDimensions2, itemDimensions2, { items }, gap2]) => {
          const { top, bottom } = gridLayout(viewportDimensions2, gap2, itemDimensions2, items);
          return [top, bottom];
        }),
        distinctUntilChanged(tupleComparator)
      ),
      listBoundary
    );
    const hasScrolled = statefulStream(false);
    connect(
      pipe(
        scrollTop,
        withLatestFrom(hasScrolled),
        map(([scrollTop2, hasScrolled2]) => {
          return hasScrolled2 || scrollTop2 !== 0;
        })
      ),
      hasScrolled
    );
    const endReached = streamFromEmitter(
      pipe(
        duc(gridState),
        filter(({ items }) => items.length > 0),
        withLatestFrom(totalCount, hasScrolled),
        filter(([{ items }, totalCount2, hasScrolled2]) => hasScrolled2 && items[items.length - 1].index === totalCount2 - 1),
        map(([, totalCount2]) => totalCount2 - 1),
        distinctUntilChanged()
      )
    );
    const startReached = streamFromEmitter(
      pipe(
        duc(gridState),
        filter(({ items }) => {
          return items.length > 0 && items[0].index === 0;
        }),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        mapTo(0),
        distinctUntilChanged()
      )
    );
    const rangeChanged = streamFromEmitter(
      pipe(
        duc(gridState),
        withLatestFrom(stateRestoreInProgress),
        filter(([{ items }, stateRestoreInProgress2]) => items.length > 0 && !stateRestoreInProgress2),
        map(([{ items }]) => {
          return {
            startIndex: items[0].index,
            endIndex: items[items.length - 1].index
          };
        }),
        distinctUntilChanged(rangeComparator),
        throttleTime(0)
      )
    );
    connect(rangeChanged, scrollSeek.scrollSeekRangeChanged);
    connect(
      pipe(
        scrollToIndex,
        withLatestFrom(viewportDimensions, itemDimensions, totalCount, gap),
        map(([location, viewportDimensions2, itemDimensions2, totalCount2, gap2]) => {
          const normalLocation = normalizeIndexLocation(location);
          const { align, behavior, offset } = normalLocation;
          let index = normalLocation.index;
          if (index === "LAST") {
            index = totalCount2 - 1;
          }
          index = max(0, index, min(totalCount2 - 1, index));
          let top = itemTop(viewportDimensions2, gap2, itemDimensions2, index);
          if (align === "end") {
            top = round(top - viewportDimensions2.height + itemDimensions2.height);
          } else if (align === "center") {
            top = round(top - viewportDimensions2.height / 2 + itemDimensions2.height / 2);
          }
          if (offset) {
            top += offset;
          }
          return { top, behavior };
        })
      ),
      scrollTo
    );
    const totalListHeight = statefulStreamFromEmitter(
      pipe(
        gridState,
        map((gridState2) => {
          return gridState2.offsetBottom + gridState2.bottom;
        })
      ),
      0
    );
    connect(
      pipe(
        windowViewportRect,
        map((viewportInfo) => ({ width: viewportInfo.visibleWidth, height: viewportInfo.visibleHeight }))
      ),
      viewportDimensions
    );
    return {
      // input
      data,
      totalCount,
      viewportDimensions,
      itemDimensions,
      scrollTop,
      scrollHeight,
      overscan,
      scrollBy,
      scrollTo,
      scrollToIndex,
      smoothScrollTargetReached,
      windowViewportRect,
      windowScrollTo,
      useWindowScroll,
      customScrollParent,
      windowScrollContainerState,
      deviation,
      scrollContainerState,
      footerHeight,
      headerHeight,
      initialItemCount,
      gap,
      restoreStateFrom,
      ...scrollSeek,
      initialTopMostItemIndex,
      // output
      gridState,
      totalListHeight,
      ...stateFlags,
      startReached,
      endReached,
      rangeChanged,
      stateChanged,
      propsReady,
      stateRestoreInProgress,
      ...log
    };
  },
  tup(sizeRangeSystem, domIOSystem, stateFlagsSystem, scrollSeekSystem, propsReadySystem, windowScrollerSystem, loggerSystem)
);
function gridLayout(viewport, gap, item, items) {
  const { height: itemHeight } = item;
  if (itemHeight === void 0 || items.length === 0) {
    return { top: 0, bottom: 0 };
  }
  const top = itemTop(viewport, gap, item, items[0].index);
  const bottom = itemTop(viewport, gap, item, items[items.length - 1].index) + itemHeight;
  return { top, bottom };
}
function itemTop(viewport, gap, item, index) {
  const perRow = itemsPerRow(viewport.width, item.width, gap.column);
  const rowCount = floor(index / perRow);
  const top = rowCount * item.height + max(0, rowCount - 1) * gap.row;
  return top > 0 ? top + gap.row : top;
}
function itemsPerRow(viewportWidth, itemWidth, gap) {
  return max(1, floor((viewportWidth + gap) / (floor(itemWidth) + gap)));
}
const gridComponentPropsSystem = /* @__PURE__ */ system(() => {
  const itemContent = statefulStream((index) => `Item ${index}`);
  const components = statefulStream({});
  const context = statefulStream(null);
  const itemClassName = statefulStream("virtuoso-grid-item");
  const listClassName = statefulStream("virtuoso-grid-list");
  const computeItemKey = statefulStream(identity);
  const headerFooterTag = statefulStream("div");
  const scrollerRef = statefulStream(noop);
  const distinctProp = (propName, defaultValue = null) => {
    return statefulStreamFromEmitter(
      pipe(
        components,
        map((components2) => components2[propName]),
        distinctUntilChanged()
      ),
      defaultValue
    );
  };
  return {
    context,
    itemContent,
    components,
    computeItemKey,
    itemClassName,
    listClassName,
    headerFooterTag,
    scrollerRef,
    FooterComponent: distinctProp("Footer"),
    HeaderComponent: distinctProp("Header"),
    ListComponent: distinctProp("List", "div"),
    ItemComponent: distinctProp("Item", "div"),
    ScrollerComponent: distinctProp("Scroller", "div"),
    ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder", "div")
  };
});
const combinedSystem$1 = /* @__PURE__ */ system(([gridSystem2, gridComponentPropsSystem2]) => {
  return { ...gridSystem2, ...gridComponentPropsSystem2 };
}, tup(gridSystem, gridComponentPropsSystem));
const GridItems = /* @__PURE__ */ React__default.memo(function GridItems2() {
  const gridState = useEmitterValue$1("gridState");
  const listClassName = useEmitterValue$1("listClassName");
  const itemClassName = useEmitterValue$1("itemClassName");
  const itemContent = useEmitterValue$1("itemContent");
  const computeItemKey = useEmitterValue$1("computeItemKey");
  const isSeeking = useEmitterValue$1("isSeeking");
  const scrollHeightCallback = usePublisher$1("scrollHeight");
  const ItemComponent = useEmitterValue$1("ItemComponent");
  const ListComponent = useEmitterValue$1("ListComponent");
  const ScrollSeekPlaceholder = useEmitterValue$1("ScrollSeekPlaceholder");
  const context = useEmitterValue$1("context");
  const itemDimensions = usePublisher$1("itemDimensions");
  const gridGap = usePublisher$1("gap");
  const log = useEmitterValue$1("log");
  const stateRestoreInProgress = useEmitterValue$1("stateRestoreInProgress");
  const listRef = useSize((el) => {
    const scrollHeight = el.parentElement.parentElement.scrollHeight;
    scrollHeightCallback(scrollHeight);
    const firstItem = el.firstChild;
    if (firstItem) {
      const { width, height } = firstItem.getBoundingClientRect();
      itemDimensions({ width, height });
    }
    gridGap({
      row: resolveGapValue("row-gap", getComputedStyle(el).rowGap, log),
      column: resolveGapValue("column-gap", getComputedStyle(el).columnGap, log)
    });
  });
  if (stateRestoreInProgress) {
    return null;
  }
  return React__default.createElement(
    ListComponent,
    {
      ref: listRef,
      className: listClassName,
      ...contextPropIfNotDomElement(ListComponent, context),
      style: { paddingTop: gridState.offsetTop, paddingBottom: gridState.offsetBottom },
      "data-test-id": "virtuoso-item-list"
    },
    gridState.items.map((item) => {
      const key = computeItemKey(item.index, item.data, context);
      return isSeeking ? React__default.createElement(ScrollSeekPlaceholder, {
        key,
        ...contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
        index: item.index,
        height: gridState.itemHeight,
        width: gridState.itemWidth
      }) : React__default.createElement(
        ItemComponent,
        { ...contextPropIfNotDomElement(ItemComponent, context), className: itemClassName, "data-index": item.index, key },
        itemContent(item.index, item.data, context)
      );
    })
  );
});
const Header = React__default.memo(function VirtuosoHeader2() {
  const Header2 = useEmitterValue$1("HeaderComponent");
  const headerHeight = usePublisher$1("headerHeight");
  const headerFooterTag = useEmitterValue$1("headerFooterTag");
  const ref = useSize((el) => headerHeight(correctItemSize(el, "height")));
  const context = useEmitterValue$1("context");
  return Header2 ? React__default.createElement(headerFooterTag, { ref }, React__default.createElement(Header2, contextPropIfNotDomElement(Header2, context))) : null;
});
const Footer = React__default.memo(function VirtuosoGridFooter() {
  const Footer2 = useEmitterValue$1("FooterComponent");
  const footerHeight = usePublisher$1("footerHeight");
  const headerFooterTag = useEmitterValue$1("headerFooterTag");
  const ref = useSize((el) => footerHeight(correctItemSize(el, "height")));
  const context = useEmitterValue$1("context");
  return Footer2 ? React__default.createElement(headerFooterTag, { ref }, React__default.createElement(Footer2, contextPropIfNotDomElement(Footer2, context))) : null;
});
const Viewport$1 = ({ children }) => {
  const ctx = React__default.useContext(VirtuosoGridMockContext);
  const itemDimensions = usePublisher$1("itemDimensions");
  const viewportDimensions = usePublisher$1("viewportDimensions");
  const viewportRef = useSize((el) => {
    viewportDimensions(el.getBoundingClientRect());
  });
  React__default.useEffect(() => {
    if (ctx) {
      viewportDimensions({ height: ctx.viewportHeight, width: ctx.viewportWidth });
      itemDimensions({ height: ctx.itemHeight, width: ctx.itemWidth });
    }
  }, [ctx, viewportDimensions, itemDimensions]);
  return /* @__PURE__ */ React__default.createElement("div", { style: viewportStyle, ref: viewportRef }, children);
};
const WindowViewport$1 = ({ children }) => {
  const ctx = React__default.useContext(VirtuosoGridMockContext);
  const windowViewportRect = usePublisher$1("windowViewportRect");
  const itemDimensions = usePublisher$1("itemDimensions");
  const customScrollParent = useEmitterValue$1("customScrollParent");
  const viewportRef = useWindowViewportRectRef(windowViewportRect, customScrollParent);
  React__default.useEffect(() => {
    if (ctx) {
      itemDimensions({ height: ctx.itemHeight, width: ctx.itemWidth });
      windowViewportRect({ offsetTop: 0, visibleHeight: ctx.viewportHeight, visibleWidth: ctx.viewportWidth });
    }
  }, [ctx, windowViewportRect, itemDimensions]);
  return /* @__PURE__ */ React__default.createElement("div", { ref: viewportRef, style: viewportStyle }, children);
};
const GridRoot = /* @__PURE__ */ React__default.memo(function GridRoot2({ ...props }) {
  const useWindowScroll = useEmitterValue$1("useWindowScroll");
  const customScrollParent = useEmitterValue$1("customScrollParent");
  const TheScroller = customScrollParent || useWindowScroll ? WindowScroller$1 : Scroller$1;
  const TheViewport = customScrollParent || useWindowScroll ? WindowViewport$1 : Viewport$1;
  return /* @__PURE__ */ React__default.createElement(TheScroller, { ...props }, /* @__PURE__ */ React__default.createElement(TheViewport, null, /* @__PURE__ */ React__default.createElement(Header, null), /* @__PURE__ */ React__default.createElement(GridItems, null), /* @__PURE__ */ React__default.createElement(Footer, null)));
});
const {
  Component: Grid,
  usePublisher: usePublisher$1,
  useEmitterValue: useEmitterValue$1,
  useEmitter: useEmitter$1
} = /* @__PURE__ */ systemToComponent(
  combinedSystem$1,
  {
    optional: {
      context: "context",
      totalCount: "totalCount",
      overscan: "overscan",
      itemContent: "itemContent",
      components: "components",
      computeItemKey: "computeItemKey",
      data: "data",
      initialItemCount: "initialItemCount",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      listClassName: "listClassName",
      itemClassName: "itemClassName",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel",
      restoreStateFrom: "restoreStateFrom",
      initialTopMostItemIndex: "initialTopMostItemIndex"
    },
    methods: {
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      scrollToIndex: "scrollToIndex"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      stateChanged: "stateChanged"
    }
  },
  GridRoot
);
const Scroller$1 = /* @__PURE__ */ buildScroller({ usePublisher: usePublisher$1, useEmitterValue: useEmitterValue$1, useEmitter: useEmitter$1 });
const WindowScroller$1 = /* @__PURE__ */ buildWindowScroller({ usePublisher: usePublisher$1, useEmitterValue: useEmitterValue$1, useEmitter: useEmitter$1 });
function resolveGapValue(property, value, log) {
  if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) {
    log(`${property} was not resolved to pixel value correctly`, value, LogLevel.WARN);
  }
  if (value === "normal") {
    return 0;
  }
  return parseInt(value != null ? value : "0", 10);
}
const tableComponentPropsSystem = /* @__PURE__ */ system(() => {
  const itemContent = statefulStream((index) => /* @__PURE__ */ React__default.createElement("td", null, "Item $", index));
  const context = statefulStream(null);
  const fixedHeaderContent = statefulStream(null);
  const fixedFooterContent = statefulStream(null);
  const components = statefulStream({});
  const computeItemKey = statefulStream(identity);
  const scrollerRef = statefulStream(noop);
  const distinctProp = (propName, defaultValue = null) => {
    return statefulStreamFromEmitter(
      pipe(
        components,
        map((components2) => components2[propName]),
        distinctUntilChanged()
      ),
      defaultValue
    );
  };
  return {
    context,
    itemContent,
    fixedHeaderContent,
    fixedFooterContent,
    components,
    computeItemKey,
    scrollerRef,
    TableComponent: distinctProp("Table", "table"),
    TableHeadComponent: distinctProp("TableHead", "thead"),
    TableFooterComponent: distinctProp("TableFoot", "tfoot"),
    TableBodyComponent: distinctProp("TableBody", "tbody"),
    TableRowComponent: distinctProp("TableRow", "tr"),
    ScrollerComponent: distinctProp("Scroller", "div"),
    EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
    ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder"),
    FillerRow: distinctProp("FillerRow")
  };
});
const combinedSystem = /* @__PURE__ */ system(([listSystem2, propsSystem]) => {
  return { ...listSystem2, ...propsSystem };
}, tup(listSystem, tableComponentPropsSystem));
const DefaultScrollSeekPlaceholder = ({ height }) => /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { style: { height } }));
const DefaultFillerRow = ({ height }) => /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", { style: { height, padding: 0, border: 0 } }));
const ITEM_STYLE = { overflowAnchor: "none" };
const Items = /* @__PURE__ */ React__default.memo(function VirtuosoItems2() {
  const listState = useEmitterValue("listState");
  const sizeRanges = usePublisher("sizeRanges");
  const useWindowScroll = useEmitterValue("useWindowScroll");
  const customScrollParent = useEmitterValue("customScrollParent");
  const windowScrollContainerStateCallback = usePublisher("windowScrollContainerState");
  const _scrollContainerStateCallback = usePublisher("scrollContainerState");
  const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
  const itemContent = useEmitterValue("itemContent");
  const trackItemSizes = useEmitterValue("trackItemSizes");
  const itemSize = useEmitterValue("itemSize");
  const log = useEmitterValue("log");
  const { callbackRef, ref } = useChangedListContentsSizes(
    sizeRanges,
    itemSize,
    trackItemSizes,
    scrollContainerStateCallback,
    log,
    void 0,
    customScrollParent
  );
  const [deviation, setDeviation] = React__default.useState(0);
  useEmitter("deviation", (value) => {
    if (deviation !== value) {
      ref.current.style.marginTop = `${value}px`;
      setDeviation(value);
    }
  });
  const EmptyPlaceholder = useEmitterValue("EmptyPlaceholder");
  const ScrollSeekPlaceholder = useEmitterValue("ScrollSeekPlaceholder") || DefaultScrollSeekPlaceholder;
  const FillerRow = useEmitterValue("FillerRow") || DefaultFillerRow;
  const TableBodyComponent = useEmitterValue("TableBodyComponent");
  const TableRowComponent = useEmitterValue("TableRowComponent");
  const computeItemKey = useEmitterValue("computeItemKey");
  const isSeeking = useEmitterValue("isSeeking");
  const paddingTopAddition = useEmitterValue("paddingTopAddition");
  const firstItemIndex = useEmitterValue("firstItemIndex");
  const statefulTotalCount = useEmitterValue("statefulTotalCount");
  const context = useEmitterValue("context");
  if (statefulTotalCount === 0 && EmptyPlaceholder) {
    return React__default.createElement(EmptyPlaceholder, contextPropIfNotDomElement(EmptyPlaceholder, context));
  }
  const paddingTop = listState.offsetTop + paddingTopAddition + deviation;
  const paddingBottom = listState.offsetBottom;
  const paddingTopEl = paddingTop > 0 ? /* @__PURE__ */ React__default.createElement(FillerRow, { height: paddingTop, key: "padding-top", context }) : null;
  const paddingBottomEl = paddingBottom > 0 ? /* @__PURE__ */ React__default.createElement(FillerRow, { height: paddingBottom, key: "padding-bottom", context }) : null;
  const items = listState.items.map((item) => {
    const index = item.originalIndex;
    const key = computeItemKey(index + firstItemIndex, item.data, context);
    if (isSeeking) {
      return React__default.createElement(ScrollSeekPlaceholder, {
        ...contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
        key,
        index: item.index,
        height: item.size,
        type: item.type || "item"
      });
    }
    return React__default.createElement(
      TableRowComponent,
      {
        ...contextPropIfNotDomElement(TableRowComponent, context),
        ...itemPropIfNotDomElement(TableRowComponent, item.data),
        key,
        "data-index": index,
        "data-known-size": item.size,
        "data-item-index": item.index,
        style: ITEM_STYLE
      },
      itemContent(item.index, item.data, context)
    );
  });
  return React__default.createElement(
    TableBodyComponent,
    { ref: callbackRef, "data-test-id": "virtuoso-item-list", ...contextPropIfNotDomElement(TableBodyComponent, context) },
    [paddingTopEl, ...items, paddingBottomEl]
  );
});
const Viewport = ({ children }) => {
  const ctx = React__default.useContext(VirtuosoMockContext);
  const viewportHeight = usePublisher("viewportHeight");
  const fixedItemHeight = usePublisher("fixedItemHeight");
  const viewportRef = useSize(compose(viewportHeight, (el) => correctItemSize(el, "height")));
  React__default.useEffect(() => {
    if (ctx) {
      viewportHeight(ctx.viewportHeight);
      fixedItemHeight(ctx.itemHeight);
    }
  }, [ctx, viewportHeight, fixedItemHeight]);
  return /* @__PURE__ */ React__default.createElement("div", { style: viewportStyle, ref: viewportRef, "data-viewport-type": "element" }, children);
};
const WindowViewport = ({ children }) => {
  const ctx = React__default.useContext(VirtuosoMockContext);
  const windowViewportRect = usePublisher("windowViewportRect");
  const fixedItemHeight = usePublisher("fixedItemHeight");
  const customScrollParent = useEmitterValue("customScrollParent");
  const viewportRef = useWindowViewportRectRef(windowViewportRect, customScrollParent);
  React__default.useEffect(() => {
    if (ctx) {
      fixedItemHeight(ctx.itemHeight);
      windowViewportRect({ offsetTop: 0, visibleHeight: ctx.viewportHeight, visibleWidth: 100 });
    }
  }, [ctx, windowViewportRect, fixedItemHeight]);
  return /* @__PURE__ */ React__default.createElement("div", { ref: viewportRef, style: viewportStyle, "data-viewport-type": "window" }, children);
};
const TableRoot = /* @__PURE__ */ React__default.memo(function TableVirtuosoRoot(props) {
  const useWindowScroll = useEmitterValue("useWindowScroll");
  const customScrollParent = useEmitterValue("customScrollParent");
  const fixedHeaderHeight = usePublisher("fixedHeaderHeight");
  const fixedFooterHeight = usePublisher("fixedFooterHeight");
  const fixedHeaderContent = useEmitterValue("fixedHeaderContent");
  const fixedFooterContent = useEmitterValue("fixedFooterContent");
  const context = useEmitterValue("context");
  const theadRef = useSize(compose(fixedHeaderHeight, (el) => correctItemSize(el, "height")));
  const tfootRef = useSize(compose(fixedFooterHeight, (el) => correctItemSize(el, "height")));
  const TheScroller = customScrollParent || useWindowScroll ? WindowScroller : Scroller;
  const TheViewport = customScrollParent || useWindowScroll ? WindowViewport : Viewport;
  const TheTable = useEmitterValue("TableComponent");
  const TheTHead = useEmitterValue("TableHeadComponent");
  const TheTFoot = useEmitterValue("TableFooterComponent");
  const theHead = fixedHeaderContent ? React__default.createElement(
    TheTHead,
    {
      key: "TableHead",
      style: { zIndex: 2, position: "sticky", top: 0 },
      ref: theadRef,
      ...contextPropIfNotDomElement(TheTHead, context)
    },
    fixedHeaderContent()
  ) : null;
  const theFoot = fixedFooterContent ? React__default.createElement(
    TheTFoot,
    {
      key: "TableFoot",
      style: { zIndex: 1, position: "sticky", bottom: 0 },
      ref: tfootRef,
      ...contextPropIfNotDomElement(TheTFoot, context)
    },
    fixedFooterContent()
  ) : null;
  return /* @__PURE__ */ React__default.createElement(TheScroller, { ...props }, /* @__PURE__ */ React__default.createElement(TheViewport, null, React__default.createElement(
    TheTable,
    { style: { borderSpacing: 0, overflowAnchor: "none" }, ...contextPropIfNotDomElement(TheTable, context) },
    [theHead, /* @__PURE__ */ React__default.createElement(Items, { key: "TableBody" }), theFoot]
  )));
});
const {
  Component: Table,
  usePublisher,
  useEmitterValue,
  useEmitter
} = /* @__PURE__ */ systemToComponent(
  combinedSystem,
  {
    required: {},
    optional: {
      restoreStateFrom: "restoreStateFrom",
      context: "context",
      followOutput: "followOutput",
      firstItemIndex: "firstItemIndex",
      itemContent: "itemContent",
      fixedHeaderContent: "fixedHeaderContent",
      fixedFooterContent: "fixedFooterContent",
      overscan: "overscan",
      increaseViewportBy: "increaseViewportBy",
      totalCount: "totalCount",
      topItemCount: "topItemCount",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      components: "components",
      groupCounts: "groupCounts",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      computeItemKey: "computeItemKey",
      defaultItemHeight: "defaultItemHeight",
      fixedItemHeight: "fixedItemHeight",
      itemSize: "itemSize",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      data: "data",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      alignToBottom: "alignToBottom",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel"
    },
    methods: {
      scrollToIndex: "scrollToIndex",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      getState: "getState"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      totalListHeightChanged: "totalListHeightChanged",
      itemsRendered: "itemsRendered",
      groupIndices: "groupIndices"
    }
  },
  TableRoot
);
const Scroller = /* @__PURE__ */ buildScroller({ usePublisher, useEmitterValue, useEmitter });
const WindowScroller = /* @__PURE__ */ buildWindowScroller({ usePublisher, useEmitterValue, useEmitter });
const TableVirtuoso$1 = Table;

var renderCell = function (_a) {
    var data = _a.data, column = _a.column, row = _a.row;
    if (column.renderCell) {
        return column.renderCell(data, row);
    }
    if (column.field) {
        return data[column.field];
    }
    return null;
};
var BodySkeleton = function (_a) {
    var columns = _a.columns;
    return (React__default.createElement(React__default.Fragment, null, columns.map(function (column, columnIndex) { return (React__default.createElement(TableCell$1, { itemID: "".concat(columnIndex), key: columnIndex, align: 'left', style: column.bodyCellStyle },
        React__default.createElement(Typography$1, { component: 'div', variant: 'caption' },
            React__default.createElement(Skeleton$1, null)))); })));
};
var TableComponents = {
    // Scroller: React.forwardRef((props, ref: React.Ref<HTMLDivElement>) => (
    // eslint-disable-next-line react/display-name
    Scroller: React__default.forwardRef(function (props, ref) { return (React__default.createElement(TableContainer$1, __assign({ component: Paper$1 }, props, { ref: ref, sx: { boxShadow: 'none' }, className: "border border-gray-300 ".concat(props.className) }))); }),
    Table: function (props) { return (React__default.createElement(MuiTable, __assign({}, props, { style: { borderCollapse: 'separate', tableLayout: 'fixed' } }))); },
    TableHead: TableHead$1,
    // eslint-disable-next-line react/display-name
    TableRow: React__default.forwardRef(function (props, ref) { return (React__default.createElement(TableRow$1, __assign({}, props, { className: 'hover:bg-gray-200', ref: ref }))); }),
    TableBody: TableBody$1,
};
var renderHeader = function (column, SortLabel) {
    if (column.title instanceof Function) {
        return column.title(column);
    }
    return React__default.createElement(SortLabel, { column: column });
};
var TableVirtuoso = function (props) {
    var rowKey = props.rowKey, columns = props.columns, _a = props.maxHeight, maxHeight = _a === void 0 ? 400 : _a, height = props.height, _b = props.expectedRowHeight, expectedRowHeight = _b === void 0 ? 65 : _b, dataSource = props.dataSource, SortLabel = props.SortLabel;
    var tableHeight = height;
    if (!tableHeight) {
        // Have the height grow as the items.length does.
        // This is bad code with hardcoded values for our UI
        // Should just grow as the content grows inherently
        // to CSS flex/whatever behaviour. Virtuoso does not
        // seem to support that easily.
        var hardcodedGrowingHeight = 47 + 2;
        hardcodedGrowingHeight += expectedRowHeight * props.dataSource.length;
        hardcodedGrowingHeight = Math.min(hardcodedGrowingHeight, maxHeight);
        tableHeight = hardcodedGrowingHeight;
    }
    return (React__default.createElement(TableVirtuoso$1, { style: {
            height: tableHeight,
        }, 
        // fixedItemHeight={expectedRowHeight}
        className: props.className, data: dataSource, components: TableComponents, fixedHeaderContent: function () {
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(TableRow$1, null, columns.map(function (column, index) {
                    var _a;
                    return (React__default.createElement(TableCell$1, { sx: {
                            paddingTop: '4px',
                            paddingBottom: '4px',
                            fontWeight: 800,
                            backgroundColor: 'white',
                            whiteSpace: 'nowrap',
                        }, key: (_a = column === null || column === void 0 ? void 0 : column.key) !== null && _a !== void 0 ? _a : index, align: 'left', style: column.headerCellStyle }, renderHeader(column, SortLabel)));
                }))));
        }, itemContent: function (row, data) {
            if (props.loading)
                return React__default.createElement(BodySkeleton, { columns: columns });
            var key = rowKey(data);
            return (React__default.createElement(React__default.Fragment, { key: key }, columns.map(function (column, columnIndex) { return (React__default.createElement(TableCell$1, { itemID: "cell-".concat(row, "-").concat(columnIndex), key: "".concat(key, "-").concat(columnIndex), align: 'left', style: column.bodyCellStyle, sx: {
                    whiteSpace: 'nowrap',
                } }, renderCell({
                data: data,
                row: row,
                column: column,
            }))); })));
        } }));
};

var _path$b;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$b || (_path$b = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 10.584 4 6.563 4.56 6 8 9.458 11.44 6l.56.563z",
    clipRule: "evenodd"
  })));
};

var TreeNode = function (props) {
    var label = props.label, value = props.value, children = props.children, onTreeNodeClick = props.onTreeNodeClick, LeftIcon = props.LeftIcon, RightIcon = props.RightIcon, activeKey = props.activeKey, onSetActiveKey = props.onSetActiveKey, _a = props.valueKey, valueKey = _a === void 0 ? 'value' : _a, _b = props.childrenKey, childrenKey = _b === void 0 ? 'children' : _b, expandedKeys = props.expandedKeys, level = props.level, indent = props.indent, toggleTreeFolder = props.toggleTreeFolder, restData = __rest(props, ["label", "value", "children", "onTreeNodeClick", "LeftIcon", "RightIcon", "activeKey", "onSetActiveKey", "valueKey", "childrenKey", "expandedKeys", "level", "indent", "toggleTreeFolder"]);
    var isExpanded = expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.includes(value);
    var isLeaf = !(children === null || children === void 0 ? void 0 : children.length);
    var handleClick = function () {
        onSetActiveKey(value);
        if (isLeaf) {
            onTreeNodeClick === null || onTreeNodeClick === void 0 ? void 0 : onTreeNodeClick(value);
            return;
        }
        toggleTreeFolder(__assign({ id: value, label: label, value: value, children: children, onTreeNodeClick: onTreeNodeClick, LeftIcon: LeftIcon, RightIcon: RightIcon }, restData));
    };
    var isActiveItem = activeKey === value;
    return (React__default.createElement("div", null,
        React__default.createElement("div", { className: "cursor-pointer font-12 font-normal", onClick: handleClick },
            React__default.createElement("div", { "data-testid": "LeafNode-".concat(value), style: {
                    // Solve the css weight problem
                    background: isActiveItem ? '#e6e6e6' : '',
                    paddingLeft: level * indent,
                }, className: "flex w-full ".concat(isActiveItem ? 'bg-gray-200' : '', " justify-between hover:bg-gray-100 items-center select-none border-b p-2 border-gray-100 ") },
                React__default.createElement("div", { className: 'flex items-center' },
                    !isLeaf && (React__default.createElement(SvgArrow, { className: "text-black-1000 transition-transform duration-200 ml-2 ".concat(isExpanded ? '' : '-rotate-90') })),
                    LeftIcon,
                    React__default.createElement("span", { className: 'ml-2' },
                        label,
                        " ")),
                RightIcon)),
        isExpanded && (children === null || children === void 0 ? void 0 : children.length) > 0 && (React__default.createElement("div", { className: 'pl-4' }, children.map(function (childNode) { return (React__default.createElement(TreeNode, __assign({ key: childNode.id }, props, childNode, { valueKey: valueKey, childrenKey: childrenKey, expandedKeys: expandedKeys, toggleTreeFolder: toggleTreeFolder, value: childNode[valueKey], children: childNode[childrenKey] || [], onTreeNodeClick: onTreeNodeClick }))); })))));
};
var Tree = function (_a) {
    var data = _a.data, _b = _a.valueKey, valueKey = _b === void 0 ? 'value' : _b, _c = _a.childrenKey, childrenKey = _c === void 0 ? 'children' : _c, defaultExpandedKeys = _a.defaultExpandedKeys, currentActiveKey = _a.currentActiveKey, onTreeNodeClick = _a.onTreeNodeClick, onClickFolder = _a.onClickFolder, _d = _a.indent, indent = _d === void 0 ? 16 : _d;
    var _e = useState(defaultExpandedKeys || []), expandedKeys = _e[0], setExpandedKeys = _e[1];
    var _f = useState(currentActiveKey), activeKey = _f[0], setActiveKey = _f[1];
    useEffect(function () {
        setActiveKey(currentActiveKey);
    }, [currentActiveKey]);
    var toggleTreeFolder = function (folder) {
        onClickFolder === null || onClickFolder === void 0 ? void 0 : onClickFolder(folder);
        var folderKey = folder[valueKey];
        var isOpened = expandedKeys.includes(folderKey);
        var newExpandedKeys = isOpened
            ? expandedKeys.filter(function (k) { return k !== folderKey; })
            : expandedKeys.concat(folderKey);
        setExpandedKeys(newExpandedKeys);
    };
    return (React__default.createElement("div", null, data.map(function (node) { return (React__default.createElement(TreeNode, __assign({ key: node.id }, node, { indent: indent, activeKey: activeKey, onSetActiveKey: setActiveKey, valueKey: valueKey, childrenKey: childrenKey, expandedKeys: expandedKeys, toggleTreeFolder: toggleTreeFolder, value: node[valueKey], children: node[childrenKey], onTreeNodeClick: onTreeNodeClick }))); })));
};

var _path$a, _path2$4, _path3$4, _path4$4;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgRestChanges = function SvgRestChanges(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 77,
    fill: "none"
  }, props), _path$a || (_path$a = /*#__PURE__*/React$1.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    d: "M6.571 51.43V32.857h14.572l7.714 7.429h30.286l.742 7.424C62.505 43.07 64 37.71 64 32 64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32a31.86 31.86 0 0 0 6.571 19.43",
    clipRule: "evenodd"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m26.868 39.19-6.212-6.423H7.633v35.13H26v3.766H7.633a3.568 3.568 0 0 1-2.569-1.103A3.84 3.84 0 0 1 4 67.896V32.767c0-.999.383-1.957 1.064-2.664A3.568 3.568 0 0 1 7.633 29h13.023c.48 0 .954.098 1.396.288.443.191.845.47 1.183.823l6.194 6.423h26.938c.964 0 1.888.397 2.569 1.104A3.839 3.839 0 0 1 60 40.302V48h-3.633v-7.698H27.921z",
    clipRule: "evenodd"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    d: "m20.656 32.767.205-.198-.084-.088h-.121zm6.212 6.423.207-.196-.002-.002zM7.633 32.767v-.286h-.286v.286zm0 35.13h-.286v.285h.286zm18.367 0h.286v-.286H26zm0 3.766v.286h.286v-.285zM5.064 70.56l.206-.198zm0-40.457.206.199zM20.656 29v.286zm1.396.288.114-.262zm1.183.823-.206.198zm6.194 6.423-.206.199.084.087h.122zm29.507 1.104.206-.198zM60 40.302h-.286zM60 48v.286h.286V48zm-3.633 0h-.285v.286h.285zm0-7.698h.286v-.286h-.286zm-28.446 0-.207.196.084.09h.123zm-7.47-7.336 6.211 6.423.41-.397-6.21-6.423zm-12.818.087h13.023v-.572H7.633zm.285 34.843V32.767h-.571v35.13zM26 67.611H7.633v.571H26zm.286 4.052v-3.767h-.572v3.767zm-18.653.286H26v-.571H7.633zm-2.775-1.19a3.854 3.854 0 0 0 2.775 1.19v-.571a3.282 3.282 0 0 1-2.363-1.016zm-1.144-2.863c0 1.072.41 2.102 1.144 2.862l.412-.396a3.554 3.554 0 0 1-.984-2.466zm0-35.129v35.13h.572v-35.13zm1.144-2.862a4.125 4.125 0 0 0-1.144 2.862h.572c0-.926.355-1.813.984-2.465zm2.775-1.19c-1.043 0-2.04.429-2.775 1.19l.412.397a3.282 3.282 0 0 1 2.363-1.016zm13.023 0H7.633v.57h13.023zm1.51.31a3.808 3.808 0 0 0-1.51-.31v.57c.44 0 .876.09 1.283.266zm1.275.889a3.916 3.916 0 0 0-1.275-.888l-.227.525c.407.175.778.433 1.09.758zm6.193 6.422-6.193-6.423-.412.397 6.194 6.423zm26.733-.087H29.43v.571h26.938zm2.775 1.19a3.854 3.854 0 0 0-2.775-1.19v.571c.885 0 1.735.364 2.363 1.016zm1.144 2.863c0-1.072-.41-2.102-1.144-2.862l-.412.396c.63.652.984 1.539.984 2.466zm0 7.698v-7.698h-.572V48zm-3.919.286H60v-.572h-3.633zm-.285-7.984V48h.571v-7.698zm-28.161.285h28.446v-.571H27.921zm-1.26-1.2 1.053 1.111.414-.393-1.053-1.111z"
  })), _path4$4 || (_path4$4 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 2.057,
    d: "M47.828 75c2.21 0 4.37-.704 6.207-2.022 1.837-1.319 3.27-3.193 4.115-5.386a12.828 12.828 0 0 0 .636-6.933c-.431-2.328-1.496-4.466-3.058-6.144-1.562-1.678-3.553-2.821-5.72-3.284a10.458 10.458 0 0 0-6.456.682c-2.041.909-3.786 2.447-5.014 4.42A12.641 12.641 0 0 0 36.656 63v6.2l-4.495-4.171-1.304 1.4L37.587 73l6.728-6.571-1.303-1.4-4.495 4.171V63c0-1.978.547-3.911 1.57-5.556 1.023-1.644 2.477-2.926 4.178-3.683a8.715 8.715 0 0 1 5.38-.569c1.805.386 3.464 1.338 4.766 2.737 1.302 1.398 2.19 3.18 2.548 5.12.36 1.94.175 3.95-.53 5.778-.704 1.827-1.898 3.389-3.429 4.488A8.86 8.86 0 0 1 47.828 73z"
  })));
};

var _path$9;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgRest = function SvgRest(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13,
    fill: "currentColor"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React$1.createElement("path", {
    d: "M8.5 12.896a6 6 0 1 0-6-6v3.1l-1.8-1.8-.7.7 3 3 3-3-.7-.7-1.8 1.8v-3.1a5 5 0 1 1 5 5z"
  })));
};

var _path$8;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.56.758.499 1.818l4.94 4.94L.36 11.835l1.061 1.06L6.499 7.82l5.077 5.077 1.06-1.06L7.56 6.757l4.939-4.94-1.06-1.06-4.94 4.94z",
    clipRule: "evenodd"
  })));
};

var ExpandMore = {};

var _interopRequireDefault$4 = interopRequireDefaultExports$1;
Object.defineProperty(ExpandMore, "__esModule", {
  value: true
});
var default_1$4 = ExpandMore.default = void 0;
var _createSvgIcon$4 = _interopRequireDefault$4(requireCreateSvgIcon());
var _jsxRuntime$4 = requireJsxRuntime();
default_1$4 = ExpandMore.default = (0, _createSvgIcon$4.default)( /*#__PURE__*/(0, _jsxRuntime$4.jsx)("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

var IndeterminateCheckbox = function (props) {
    var defaultExpanded = props.defaultExpanded, _a = props.selectedValue, selectedValue = _a === void 0 ? [] : _a, _b = props.data, data = _b === void 0 ? [] : _b, _c = props.allText, allText = _c === void 0 ? 'All' : _c, onSelectChange = props.onSelectChange, accordionDetailsProps = props.accordionDetailsProps, _d = props.disableSelection, disableSelection = _d === void 0 ? false : _d;
    var values = data.map(function (item) { return item.value; });
    var indeterminate = selectedValue.length !== values.length && selectedValue.length > 0;
    var handleCheckAllChange = function (event, checked) {
        if (checked) {
            onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(values);
        }
        else {
            onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange([]);
        }
    };
    var handleSelectChange = function (value, checked) {
        if (checked) {
            onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(Array.from(new Set(__spreadArray(__spreadArray([], selectedValue, true), [value], false))));
        }
        else {
            onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(selectedValue.filter(function (item) { return item !== value; }));
        }
    };
    return (React__default.createElement(Accordion$1, { sx: {
            boxShadow: 'none',
            // Overlay mui style
            '::before': {
                content: "''",
                background: 'transparent',
            },
        }, className: 'w-full', defaultExpanded: defaultExpanded },
        React__default.createElement(AccordionSummary$1, { sx: {
                padding: 0,
                borderBottom: '1px solid #ECECEC',
            }, expandIcon: React__default.createElement(default_1$4, { htmlColor: 'black' }) },
            React__default.createElement("div", null,
                !disableSelection && (React__default.createElement(Checkbox$1, { indeterminate: indeterminate, checked: selectedValue.length === values.length, onChange: handleCheckAllChange, onClick: function (e) {
                        e.stopPropagation();
                    } })),
                React__default.createElement("span", { className: 'font-extrabold mr-1' }, allText),
                React__default.createElement("span", { className: 'text-gray-400' },
                    "(",
                    selectedValue.length,
                    ")"))),
        React__default.createElement(AccordionDetails$1, __assign({ sx: { padding: 0 } }, accordionDetailsProps), data.map(function (_a) {
            var label = _a.label, value = _a.value, details = _a.details, extra = _a.extra;
            return (React__default.createElement("div", { key: value }, details ? (React__default.createElement(Accordion$1, { sx: {
                    boxShadow: 'none',
                    // Overlay mui style
                    '::before': {
                        content: "''",
                        background: 'transparent',
                    },
                } },
                React__default.createElement("div", { className: 'flex justify-between items-center h-10' },
                    React__default.createElement(AccordionSummary$1, { sx: { padding: 0, width: 'fit-content' }, expandIcon: React__default.createElement(default_1$4, { htmlColor: '#444444' }) },
                        React__default.createElement(FormControlLabel$1, { label: label, disabled: disableSelection, sx: { margin: 0 }, control: disableSelection ? (React__default.createElement(React__default.Fragment, null)) : (React__default.createElement(Checkbox$1, { "data-testid": value, checked: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.includes(value), onChange: function (e, checked) {
                                    handleSelectChange(value, checked);
                                }, onClick: function (e) {
                                    e.stopPropagation();
                                } })) })),
                    extra),
                React__default.createElement(AccordionDetails$1, { sx: { padding: 0 } },
                    React__default.createElement("div", { className: 'pl-11 text-14 text-gray-800' }, details)))) : (React__default.createElement("div", { className: 'h-10 flex justify-between items-center' },
                React__default.createElement(FormControlLabel$1, { disabled: disableSelection, label: label, sx: { margin: 0 }, control: disableSelection ? (React__default.createElement("div", null)) : (React__default.createElement(Checkbox$1, { "data-testid": value, onChange: function (e, checked) {
                            handleSelectChange(value, checked);
                        }, checked: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.includes(value) })) }),
                extra))));
        }))));
};

var _a, _b;
var BannerVariant;
(function (BannerVariant) {
    BannerVariant["INFO"] = "info";
    BannerVariant["WARNING"] = "warning";
    BannerVariant["ERROR"] = "error";
    BannerVariant["SUCCESS"] = "success";
})(BannerVariant || (BannerVariant = {}));
var colors = (_a = {},
    _a[BannerVariant.INFO] = '#4D76FF',
    _a[BannerVariant.WARNING] = '#FFCB00',
    _a[BannerVariant.ERROR] = '#ff5858',
    _a[BannerVariant.SUCCESS] = '#4CDE8E',
    _a);
var severities = (_b = {},
    _b[BannerVariant.INFO] = 'info',
    _b[BannerVariant.WARNING] = 'warning',
    _b[BannerVariant.ERROR] = 'error',
    _b[BannerVariant.SUCCESS] = 'success',
    _b);
var Banner = function (props) {
    var text = props.text, _a = props.variant, variant = _a === void 0 ? BannerVariant.INFO : _a, _b = props.muiVariant, muiVariant = _b === void 0 ? 'outlined' : _b, className = props.className, children = props.children, rest = __rest(props, ["text", "variant", "muiVariant", "className", "children"]);
    var content = null;
    if (children)
        content = children;
    else if (text)
        content = React__default.createElement("span", { className: 'text-black-1000 text-14' }, text);
    var color = colors[variant];
    var severity = severities[variant];
    return (React__default.createElement(Alert$1, __assign({ className: className, severity: severity, variant: muiVariant, sx: {
            borderColor: color,
            padding: '0px 1rem',
            '& .MuiAlert-icon': { color: color },
        } }, rest), content));
};

var ResetChangesDialog = function (props) {
    var _a = props.resetList, resetList = _a === void 0 ? [] : _a, dialogProps = props.dialogProps, _b = props.icon, icon = _b === void 0 ? React__default.createElement(SvgRestChanges, { style: props.iconStyle }) : _b, _c = props.title, title = _c === void 0 ? 'Reset Changes' : _c, dialogTitle = props.dialogTitle, _d = props.description, description = _d === void 0 ? 'We will restore the last version of the following files.' : _d, dialogActionsProps = props.dialogActionsProps, dialogContentProps = props.dialogContentProps, dialogTitleProps = props.dialogTitleProps, titleStyle = props.titleStyle, descriptionStyle = props.descriptionStyle, defaultExpanded = props.defaultExpanded, _e = props.closeButton, closeButton = _e === void 0 ? 'Cancel' : _e, _f = props.confirmButton, confirmButton = _f === void 0 ? 'Reset Changes' : _f, closeButtonProps = props.closeButtonProps, confirmButtonProps = props.confirmButtonProps, onDialogConfirm = props.onDialogConfirm, onDialogClose = props.onDialogClose;
    var data = resetList.map(function (_a) {
        var id = _a.id, name = _a.name, revision = _a.revision, lastLocalChangeAuthorName = _a.lastLocalChangeAuthorName, lastLocalChangeTimestamp = _a.lastLocalChangeTimestamp;
        return ({
            label: name,
            value: id,
            extra: (React__default.createElement("div", { className: 'text-12' },
                "Restore to:",
                ' ',
                React__default.createElement("span", { className: 'text-gray-600' },
                    revision,
                    " \u2014 ",
                    lastLocalChangeTimestamp,
                    " by",
                    ' ',
                    lastLocalChangeAuthorName))),
        });
    });
    var numFilesAdded = resetList.reduce(function (count, item) { return (item.changeStatus === 'added' ? count + 1 : count); }, 0);
    return (React__default.createElement(Dialog$1, __assign({}, dialogProps),
        dialogTitle && (React__default.createElement(DialogTitle$1, __assign({}, dialogTitleProps), dialogTitle)),
        React__default.createElement(DialogContent$1, __assign({ sx: {
                width: '36.2rem',
                maxHeight: '29rem',
                padding: '2rem 2rem 0 2.5rem',
            } }, dialogContentProps, { className: 'flex justify-center items-center flex-col' }),
            React__default.createElement("div", { className: 'flex justify-center items-center flex-col' },
                icon,
                title && (React__default.createElement("div", { style: titleStyle, className: 'mt-2 text-18 font-extrabold w-fit h-fit' }, title)),
                description && React__default.createElement("div", { style: descriptionStyle }, description)),
            numFilesAdded > 0 && (React__default.createElement(Banner, { className: 'my-2 self-stretch', variant: 'warning', text: numFilesAdded > 1
                    ? "This will delete ".concat(numFilesAdded, " \"added\" files!")
                    : "This will delete ".concat(numFilesAdded, " \"added\" file!") })),
            React__default.createElement(IndeterminateCheckbox, { defaultExpanded: defaultExpanded, data: data, allText: 'Reset All', accordionDetailsProps: {
                    sx: { padding: 0, overflowY: 'auto', maxHeight: '10rem' },
                }, selectedValue: resetList.map(function (item) { return item.id; }), 
                // onSelectChange={onSelectChange}
                disableSelection: true })),
        React__default.createElement(DialogActions$1, __assign({ sx: {
                display: 'flex',
                justifyContent: 'center',
                padding: '0.75rem 2.5rem 2rem 2.5rem',
            } }, dialogActionsProps),
            React__default.createElement(Button, __assign({ primaryColor: 'black-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgClose, null), onClick: onDialogClose }, closeButtonProps), closeButton),
            React__default.createElement(Button, __assign({ style: { marginLeft: '0.75rem' }, primaryColor: 'blue-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgRest, null), onClick: function () {
                    onDialogConfirm === null || onDialogConfirm === void 0 ? void 0 : onDialogConfirm();
                } }, confirmButtonProps), confirmButton))));
};

var _path$7, _path2$3, _path3$3, _path4$3;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgConnected = function SvgConnected(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 73,
    fill: "none"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    d: "M7.071 51.43V32.857h14.572l7.714 7.429h30.286l.742 7.424c2.62-4.64 4.115-10 4.115-15.71 0-17.673-14.327-32-32-32C14.827 0 .5 14.327.5 32a31.86 31.86 0 0 0 6.571 19.43",
    clipRule: "evenodd"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m27.368 38.768-6.212-6.423H8.133v35.129H32.5v3.767H8.133a3.568 3.568 0 0 1-2.569-1.103A3.839 3.839 0 0 1 4.5 67.474v-35.13c0-.998.383-1.957 1.064-2.663a3.568 3.568 0 0 1 2.569-1.103h13.023c.48 0 .954.097 1.396.288.443.19.845.47 1.183.823l6.194 6.423h26.938c.964 0 1.888.397 2.569 1.103A3.839 3.839 0 0 1 60.5 39.88v9.264h-3.633v-9.264H28.421z",
    clipRule: "evenodd"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    d: "m21.156 32.345.205-.199-.084-.087h-.121zm6.212 6.423.207-.197-.002-.002zM8.133 32.345v-.286h-.286v.286zm0 35.129h-.286v.286h.286zm24.367 0h.286v-.286H32.5zm0 3.767v.286h.286v-.286zM5.564 70.138l.206-.199zm0-40.457.206.198zm15.592-1.103v.285zm1.396.288.114-.262zm1.183.823-.206.198zm6.194 6.423-.206.198.084.088h.122zm29.507 1.103.206-.198zM60.5 49.143v.286h.286v-.286zm-3.633 0h-.285v.286h.285zm0-9.264h.286v-.285h-.286zm-28.446 0-.207.197.084.089h.123zm-7.47-7.335 6.211 6.423.41-.398-6.21-6.423zm-12.818.087h13.023v-.572H8.133zm.285 34.843v-35.13h-.571v35.13zm24.082-.286H8.133v.572H32.5zm.286 4.053v-3.767h-.572v3.767zm-24.653.286H32.5v-.572H8.133zm-2.775-1.19a3.854 3.854 0 0 0 2.775 1.19v-.572A3.282 3.282 0 0 1 5.77 69.94zm-1.144-2.863c0 1.072.41 2.101 1.144 2.862l.412-.397a3.553 3.553 0 0 1-.984-2.465zm0-35.13v35.13h.572v-35.13zm1.144-2.861a4.125 4.125 0 0 0-1.144 2.862h.572c0-.927.355-1.813.984-2.466zm2.775-1.191c-1.043 0-2.04.43-2.775 1.19l.412.397a3.282 3.282 0 0 1 2.363-1.016zm13.023 0H8.133v.571h13.023zm1.51.312a3.806 3.806 0 0 0-1.51-.312v.571c.44 0 .876.09 1.283.265zm1.275.887a3.914 3.914 0 0 0-1.275-.887l-.227.524a3.34 3.34 0 0 1 1.09.759zm6.193 6.423-6.193-6.423-.412.396 6.194 6.423zm26.733-.088H29.93v.572h26.938zm2.775 1.191a3.854 3.854 0 0 0-2.775-1.19v.57c.885 0 1.735.365 2.363 1.017zm1.144 2.862c0-1.071-.41-2.101-1.144-2.862l-.412.397c.63.652.984 1.539.984 2.465zm0 9.264v-9.264h-.572v9.264zm-3.919.286H60.5v-.572h-3.633zm-.285-9.55v9.264h.571v-9.264zm-28.161.286h28.446v-.572H28.421zm-1.26-1.2 1.053 1.11.414-.392-1.053-1.112z"
  })), _path4$3 || (_path4$3 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.571,
    d: "m44.922 71.896-9.536-9.538 2.694-2.695 6.842 6.84 14.465-14.468 2.699 2.698z"
  })));
};

var _path$6;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    fill: "none"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React$1.createElement("path", {
    stroke: "currentColor",
    d: "M1 6.896c5.505-.167 16.516 0 16.516 0m0 0-6.393-6m6.393 6-6.393 6"
  })));
};

var LocalChangesConnectionDialog = function (props) {
    var _a = props.defaultChecked, defaultChecked = _a === void 0 ? true : _a, dialogProps = props.dialogProps, _b = props.icon, icon = _b === void 0 ? React__default.createElement(SvgConnected, { style: props.iconStyle }) : _b, _c = props.title, title = _c === void 0 ? 'Connection to Local Folder has been made. ' : _c, dialogTitle = props.dialogTitle, _d = props.description, description = _d === void 0 ? 'You can now sync, edit or add files you have created locally.' : _d, dialogActionsProps = props.dialogActionsProps, dialogContentProps = props.dialogContentProps, dialogTitleProps = props.dialogTitleProps, titleStyle = props.titleStyle, descriptionStyle = props.descriptionStyle, _e = props.confirmButton, confirmButton = _e === void 0 ? 'Continue' : _e, confirmButtonProps = props.confirmButtonProps, onDialogConfirm = props.onDialogConfirm, onCheckboxChange = props.onCheckboxChange;
    return (React__default.createElement(Dialog$1, __assign({}, dialogProps),
        React__default.createElement(Box$1, { sx: { padding: '3.5rem 2.5rem' } },
            dialogTitle && (React__default.createElement(DialogTitle$1, __assign({}, dialogTitleProps), dialogTitle)),
            React__default.createElement(DialogContent$1, __assign({ sx: { padding: 0 } }, dialogContentProps),
                React__default.createElement("div", { className: 'flex justify-center items-center flex-col' },
                    icon,
                    title && (React__default.createElement("div", { style: titleStyle, className: 'mt-3 text-18 font-extrabold leading-6' }, title)),
                    description && (React__default.createElement("div", { className: 'mt-3 leading-6', style: descriptionStyle }, description)))),
            React__default.createElement(DialogActions$1, __assign({ sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    marginTop: '0.75rem',
                    padding: 0,
                } }, dialogActionsProps),
                React__default.createElement(Button, __assign({ primaryColor: 'black-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgRightArrow, null), onClick: onDialogConfirm, className: 'text-sm', sx: { padding: '0.5rem 1.5rem', fontSize: '14px' } }, confirmButtonProps), confirmButton),
                React__default.createElement(FormControlLabel$1, { label: React__default.createElement("span", { className: 'text-12' }, "Don\u2019t show this again"), sx: { margin: 0 }, control: React__default.createElement(Checkbox$1, { defaultChecked: defaultChecked, onChange: onCheckboxChange }) })))));
};

var _rect$2;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgDot = function SvgDot(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/React$1.createElement("rect", {
    width: 12,
    height: 12,
    fill: "currentColor",
    rx: 6
  })));
};

var downloadingFileSyncProgress = function (download) {
    if (download) {
        var numFiles = download.numFiles, totalFiles = download.totalFiles, progress = download.progress;
        var totalSegment = totalFiles ? React__default.createElement("span", null,
            "/",
            totalFiles) : null;
        return (React__default.createElement(React__default.Fragment, null,
            "Downloading",
            ' ',
            React__default.createElement("span", { className: 'mx-1' },
                numFiles,
                totalSegment),
            "Files",
            progress !== undefined && (React__default.createElement("span", { className: 'text-gray-500 ml-1' },
                "(",
                progress.toFixed(0),
                "%)"))));
    }
    return null;
};
var uploadingFileSyncProgress = function (upload) {
    if (upload) {
        var numFiles = upload.numFiles, totalFiles = upload.totalFiles, progress = upload.progress;
        var totalSegment = totalFiles ? React__default.createElement("span", null,
            "/",
            totalFiles) : null;
        return (React__default.createElement(React__default.Fragment, null,
            "Uploading",
            ' ',
            React__default.createElement("span", { className: 'mx-1' },
                numFiles,
                totalSegment),
            "Files",
            progress !== undefined && (React__default.createElement("span", { className: 'text-gray-500 ml-1' },
                "(",
                progress.toFixed(0),
                "%)"))));
    }
    return null;
};
var fileSyncProgress = function (download, upload) {
    var downloading = downloadingFileSyncProgress(download);
    var uploading = uploadingFileSyncProgress(upload);
    var separator = download && upload ? React__default.createElement("span", { className: 'mx-2' }, "|") : null;
    return (React__default.createElement(React__default.Fragment, null,
        downloading,
        separator,
        uploading));
};
var ConnectionOverview = function (props) {
    var _a = props.status, status = _a === void 0 ? 'unconnected' : _a, customTitle = props.customTitle, upload = props.upload, download = props.download, actionBar = props.actionBar, boxProps = props.boxProps, tooltipProps = props.tooltipProps, reconnectButtonProps = props.reconnectButtonProps, connectButtonProps = props.connectButtonProps, onConnectClick = props.onConnectClick, onReconnectClick = props.onReconnectClick, onOpenLocalFolderClick = props.onOpenLocalFolderClick, rightAction = props.rightAction, _b = props.rightActionWrapperClassName, rightActionWrapperClassName = _b === void 0 ? '' : _b;
    var connectionMap = {
        synced: {
            title: 'Connected',
            actionBar: (React__default.createElement("div", { className: 'flex items-center' },
                React__default.createElement(SvgDot, { className: 'text-limeGreen-500' }),
                React__default.createElement("span", { className: 'ml-2' }, "Synced"))),
        },
        remoteContributions: {
            title: 'Connected',
            actionBar: (React__default.createElement("div", { className: 'flex items-center' },
                React__default.createElement(SvgDot, { className: 'text-yellow-500' }),
                React__default.createElement("span", { className: 'ml-2' }, "Cloud Contributions Available"))),
        },
        unconnected: {
            title: 'Local Folder Not Connected',
            actionBar: (React__default.createElement(Button, __assign({ primaryColor: 'blue', variant: 'contained', sx: { padding: '0.25rem 0.75rem' }, onClick: onConnectClick }, connectButtonProps), "Connect")),
        },
        disconnected: {
            title: 'Local Folder Disconnected',
            actionBar: (React__default.createElement(Button, __assign({ primaryColor: 'blue', variant: 'contained', sx: { padding: '0.25rem 0.75rem' }, onClick: onReconnectClick }, reconnectButtonProps), "Reconnect")),
        },
        syncing: {
            title: 'Connected',
            actionBar: (React__default.createElement("div", { className: 'flex items-center' },
                fileSyncProgress(download, upload),
                React__default.createElement(SvgDot, { className: 'text-yellow-500 ml-2' }))),
        },
        contributing: {
            title: 'Connected',
            actionBar: (React__default.createElement("div", { className: 'flex items-center' },
                React__default.createElement("span", { className: 'mr-2' }, "Contributing..."),
                React__default.createElement(SvgDot, { className: 'text-yellow-500' }))),
        },
        pulling: {
            title: 'Connected',
            actionBar: (React__default.createElement("div", { className: 'flex items-center' },
                React__default.createElement("span", { className: 'mr-2' }, "Updating local files..."),
                React__default.createElement(SvgDot, { className: 'text-yellow-500' }))),
        },
    };
    var shouldRenderOpenLocalFolder = [
        'synced',
        'contributing',
        'remoteContributions',
        'pulling',
        'syncing',
    ].includes(status);
    return (React__default.createElement(Box$1, __assign({ sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid #9E9E9E',
            padding: '0.5rem 0',
        } }, boxProps),
        React__default.createElement("div", { className: 'flex' },
            React__default.createElement(FileIcon, { type: 'folder', fileStatus: status }),
            React__default.createElement("div", { className: 'ml-2.5 font-extrabold' }, customTitle ||
                (shouldRenderOpenLocalFolder ? (React__default.createElement(Box$1, { className: 'flex items-center' },
                    connectionMap[status].title,
                    React__default.createElement(Tooltip$1, __assign({ componentsProps: {
                            tooltip: { sx: { backgroundColor: 'black' } },
                            arrow: { sx: { color: 'black' } },
                        }, title: 'Open Local Folder', placement: 'right-start', arrow: true }, tooltipProps),
                        React__default.createElement(Box$1, { className: 'hover:text-primary' },
                            React__default.createElement(SvgRightStartArrow, { "data-test-id": 'openLocalFolder-icon', className: 'ml-2.5 cursor-pointer', onClick: onOpenLocalFolderClick }))))) : (connectionMap[status].title)))),
        React__default.createElement("div", { className: rightActionWrapperClassName },
            actionBar || connectionMap[status].actionBar,
            " ",
            rightAction)));
};

var useConflictResolution = function () {
    var _a = useState({
        cloudResolutionSelected: false,
        localResolutionSelected: false,
    }), resolutionResult = _a[0], setResolutionResult = _a[1];
    var switchResolutionResult = function (result) {
        setResolutionResult({
            localResolutionSelected: result === 'local',
            cloudResolutionSelected: result === 'cloud',
        });
    };
    return { resolutionResult: resolutionResult, switchResolutionResult: switchResolutionResult };
};

var _path$5;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 15 12"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m3.101 5.09 4.167-3.745 4.166 3.745v5.682H9.168v-4h-4v4H3.101zm-1-.445L.334 6.234l.669.743L2.1 5.99v5.782h4.067v-4h2v4h4.266V5.989l1.1.988.668-.743-1.768-1.59v-.039h-.043L7.268 0 2.145 4.605h-.044z",
    clipRule: "evenodd"
  })));
};

var _path$4;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 10"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M12.84 4.926h-.5l-.001.468.467.031zM5.717 2.655l-.314.389.414.334.308-.434zM3.17 4.019l.125.484.411-.106-.038-.423zM5.97 7.508l.375-.33-.485-.553-.335.655zm5.217.614.388-.317-.296-.362-.381.27zm1.154-3.2v.004l1 .001v-.005zM8.918 1.5a3.422 3.422 0 0 1 3.422 3.422h1A4.422 4.422 0 0 0 8.918.5zM6.125 2.944A3.417 3.417 0 0 1 8.918 1.5v-1c-1.49 0-2.808.738-3.609 1.865zm-1.392-.136c.254 0 .486.088.67.236l.628-.778a2.062 2.062 0 0 0-1.298-.458zm-1.07 1.068c0-.59.48-1.068 1.07-1.068v-1a2.069 2.069 0 0 0-2.07 2.068zm.005.098a1.087 1.087 0 0 1-.004-.098h-1c0 .064.003.126.008.188zM1.834 6.393c0-.908.62-1.672 1.461-1.89l-.25-.968A2.952 2.952 0 0 0 .834 6.393zm1.951 1.95a1.951 1.951 0 0 1-1.951-1.95h-1a2.951 2.951 0 0 0 2.951 2.95zM5.524 7.28a1.951 1.951 0 0 1-1.739 1.064v1c1.147 0 2.14-.655 2.629-1.608zm3.394 1.064a3.413 3.413 0 0 1-2.573-1.166l-.752.66c.81.922 2 1.506 3.325 1.506zm1.979-.63a3.404 3.404 0 0 1-1.98.63v1c.953 0 1.837-.302 2.559-.815zm1.81.63c-.457 0-.865-.21-1.133-.539l-.775.633c.45.552 1.138.906 1.908.906zm1.46-1.461a1.46 1.46 0 0 1-1.46 1.46v1a2.46 2.46 0 0 0 2.46-2.46zm-1.36-1.458a1.46 1.46 0 0 1 1.36 1.458h1a2.46 2.46 0 0 0-2.294-2.455z"
  })));
};

var ConflictResolution = function (props) {
    var _a = props.data, data = _a === void 0 ? [] : _a, onTreeNodeClick = props.onTreeNodeClick, onResolveCheckIn = props.onResolveCheckIn, onResolveContinueWorking = props.onResolveContinueWorking, _b = props.conflictNum, conflictNum = _b === void 0 ? 0 : _b;
    var _c = useConflictResolution(), resolutionResult = _c.resolutionResult, switchResolutionResult = _c.switchResolutionResult;
    var cloudResolutionSelected = resolutionResult.cloudResolutionSelected, localResolutionSelected = resolutionResult.localResolutionSelected;
    var finishUpdateDisabled = !(cloudResolutionSelected || localResolutionSelected);
    return (React__default.createElement("div", { className: 'w-80 h-screen relative' },
        React__default.createElement("div", { className: 'flex items-center' },
            React__default.createElement(SvgInformation, { className: 'text-black-1000' }),
            React__default.createElement("span", { className: 'ml-2 text-14' },
                "There are ",
                conflictNum,
                " files that need your attention")),
        React__default.createElement(Tree, { data: data, onTreeNodeClick: onTreeNodeClick }),
        React__default.createElement("div", { className: 'mt-4  ml-6' },
            React__default.createElement("span", { className: 'text-16 font-extrabold' }, "Select All From :"),
            React__default.createElement("div", { className: 'flex items-center mt-2 cursor-pointer ml-4', onClick: function () {
                    switchResolutionResult('cloud');
                } },
                React__default.createElement(Checkbox$1, { sx: { padding: 0 }, checked: cloudResolutionSelected }),
                React__default.createElement(SvgCloud, null),
                React__default.createElement("span", { className: 'ml-1' }, "Cloud Drive")),
            React__default.createElement("div", { className: 'flex items-center mt-2 cursor-pointer ml-4', onClick: function () {
                    switchResolutionResult('local');
                } },
                React__default.createElement(Checkbox$1, { sx: { padding: 0 }, checked: localResolutionSelected }),
                React__default.createElement(SvgHome, null),
                React__default.createElement("span", { className: 'ml-1' }, "Local File")),
            React__default.createElement("div", { className: 'absolute inset-x-0 bottom-20 flex justify-center items-center flex-col gap-4' },
                React__default.createElement(Button, { disabled: finishUpdateDisabled, primaryColor: 'black-hollow', variant: 'outlined', onClick: function () {
                        onResolveContinueWorking === null || onResolveContinueWorking === void 0 ? void 0 : onResolveContinueWorking(cloudResolutionSelected ? 'cloud' : 'local');
                    } }, "Resolve & Continue Working"),
                React__default.createElement(Button, { disabled: finishUpdateDisabled, variant: 'contained', onClick: function () {
                        onResolveCheckIn === null || onResolveCheckIn === void 0 ? void 0 : onResolveCheckIn(cloudResolutionSelected ? 'cloud' : 'local');
                    } }, "Resolve & Check-In")))));
};

var Clear = {};

var _interopRequireDefault$3 = interopRequireDefaultExports$1;
Object.defineProperty(Clear, "__esModule", {
  value: true
});
var default_1$3 = Clear.default = void 0;
var _createSvgIcon$3 = _interopRequireDefault$3(requireCreateSvgIcon());
var _jsxRuntime$3 = requireJsxRuntime();
default_1$3 = Clear.default = (0, _createSvgIcon$3.default)( /*#__PURE__*/(0, _jsxRuntime$3.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

var VisibilityOff = {};

var _interopRequireDefault$2 = interopRequireDefaultExports$1;
Object.defineProperty(VisibilityOff, "__esModule", {
  value: true
});
var default_1$2 = VisibilityOff.default = void 0;
var _createSvgIcon$2 = _interopRequireDefault$2(requireCreateSvgIcon());
var _jsxRuntime$2 = requireJsxRuntime();
default_1$2 = VisibilityOff.default = (0, _createSvgIcon$2.default)( /*#__PURE__*/(0, _jsxRuntime$2.jsx)("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), 'VisibilityOff');

var _g$5, _defs$1;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgFileDetails = function SvgFileDetails(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React$1.createElement("g", {
    fill: "#000",
    clipPath: "url(#fileDetails_svg__a)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "m10.323.917 7.693 4.277c.096.054.177.131.233.224a.59.59 0 0 1 .085.304v5.55h-1.282V6.786l-6.41 3.565v7.14l.008-.004v1.415l-.327.181a.664.664 0 0 1-.646 0l-7.692-4.277a.627.627 0 0 1-.233-.224.59.59 0 0 1-.085-.304V5.722a.59.59 0 0 1 .085-.304.627.627 0 0 1 .233-.224L9.677.917a.665.665 0 0 1 .646 0m6.098 4.805L10 2.152l-6.42 3.57L10 9.292zm-7.062 4.629L2.95 6.786v7.14l6.41 3.565z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M19.783 12.5h-7.917v1.25h7.917zM19.783 15h-7.917v1.25h7.917zM15.616 17.5h-3.75v1.25h3.75z"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React$1.createElement("defs", null, /*#__PURE__*/React$1.createElement("clipPath", {
    id: "fileDetails_svg__a"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    d: "M0 0h20v20H0z"
  })))));
};

var useTableSort = function (rowsData, defaultColumn) {
    if (defaultColumn === void 0) { defaultColumn = null; }
    var _a = useState('desc'), order = _a[0], setOrder = _a[1];
    var _b = useState(defaultColumn), activeColumn = _b[0], setActiveColumn = _b[1];
    var orderBy = (activeColumn === null || activeColumn === void 0 ? void 0 : activeColumn.key) || '';
    var createSortHandler = function (column) {
        var newOrder = 'desc';
        if (orderBy === column.key) {
            newOrder = order === 'desc' ? 'asc' : 'desc';
        }
        setOrder(newOrder);
        setActiveColumn(column);
    };
    var sortedRows = rowsData.sort(function (a, b) {
        var sortingFunction = activeColumn === null || activeColumn === void 0 ? void 0 : activeColumn.sort;
        if (!sortingFunction)
            return 0;
        var factor = order === 'desc' ? 1 : -1;
        return factor * sortingFunction(a, b, factor);
    });
    var SortLabel = function (_a) {
        var column = _a.column;
        return column.sort ? (React__default.createElement(TableSortLabel$1, { active: orderBy === column.key, direction: orderBy === column.key ? order : 'desc', onClick: function () {
                createSortHandler(column);
            } }, "".concat(column.title))) : (column.title);
    };
    return [sortedRows, SortLabel];
};

var _g$4, _defs;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgRemoteLock = function SvgRemoteLock(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/React$1.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#remoteLock_svg__a)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fillRule: "evenodd",
    d: "M11 7h1a1 1 0 0 1 1 1H4v6h3.5v1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V4a3 3 0 1 1 6 0zM6.586 2.586A2 2 0 0 0 6 4v3h4V4a2 2 0 0 0-3.414-1.414",
    clipRule: "evenodd"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M9.086 15h4.745v-1.078c0-.4-.176-.784-.487-1.066a1.751 1.751 0 0 0-1.174-.443h-1.423c-.44 0-.863.16-1.174.443a1.445 1.445 0 0 0-.487 1.066zM9.95 10.473a1.509 1.509 0 1 0 3.017 0 1.509 1.509 0 0 0-3.018 0"
  }))), _defs || (_defs = /*#__PURE__*/React$1.createElement("defs", null, /*#__PURE__*/React$1.createElement("clipPath", {
    id: "remoteLock_svg__a"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

var createDriveTableColumns = function (props) {
    var _a = props.filteredDataSource, filteredDataSource = _a === void 0 ? [] : _a, onFileNameClick = props.onFileNameClick, onModifiedUserNameClick = props.onModifiedUserNameClick, onSelect = props.onSelect;
    var numSelectedRows = filteredDataSource.reduce(function (acc, item) { return (item.selection === 'selected' ? acc + 1 : acc); }, 0);
    var numPartiallySelectedRows = filteredDataSource.reduce(function (acc, item) { return (item.selection === 'partiallySelected' ? acc + 1 : acc); }, 0);
    var numRows = filteredDataSource.length;
    return [
        {
            title: '',
            key: 'locks',
            renderCell: function (record) {
                var isRemoteLock = record.isRemoteLock, fileType = record.fileType, fileLocked = record.fileLocked;
                var isFolder = fileType === 'folder';
                var tooltipText = isFolder
                    ? 'You locked some files inside this folder.'
                    : 'You locked this file, unlock it to allow other people to modify it.';
                if (isRemoteLock) {
                    tooltipText = isFolder
                        ? "Some files inside this folder are locked by ".concat(record.lockedBy, ".")
                        : "File has been locked by ".concat(record.lockedBy, ".");
                }
                return (React__default.createElement(React__default.Fragment, null, fileLocked && (React__default.createElement(Tooltip$1, { title: tooltipText, placement: 'right', componentsProps: {
                        tooltip: {
                            sx: { backgroundColor: 'black', maxWidth: 'none' },
                        },
                        arrow: { sx: { color: 'black' } },
                    }, arrow: true },
                    React__default.createElement("div", { className: record.fileLocked
                            ? 'flex h-full justify-center items-center'
                            : '' }, isRemoteLock ? (React__default.createElement(SvgRemoteLock, { className: 'text-black-1000 overflow-visible' })) : (React__default.createElement(SvgLock, { className: 'text-black-1000 overflow-visible' })))))));
            },
            bodyCellStyle: {
                paddingRight: '0px',
            },
            headerCellStyle: {
                width: '2%',
            },
        },
        {
            key: 'checkbox',
            title: function () {
                var checked = numSelectedRows === numRows;
                var selectAllCurrentlyVisible = function () {
                    var ids = filteredDataSource.map(function (data) { return data.id; });
                    onSelect === null || onSelect === void 0 ? void 0 : onSelect(ids, !checked);
                };
                return (React__default.createElement(Checkbox$1, { indeterminate: numPartiallySelectedRows > 0 ||
                        (numSelectedRows > 0 && numSelectedRows < numRows), checked: checked, size: 'small', onChange: selectAllCurrentlyVisible }));
            },
            renderCell: function (record) {
                return (React__default.createElement("div", { className: 'flex justify-center' },
                    React__default.createElement(FileIcon, { type: record.fileType, selection: record.selection, onClick: function () {
                            onSelect === null || onSelect === void 0 ? void 0 : onSelect([record.id], record.selection === 'unselected');
                        } })));
            },
            headerCellStyle: {
                width: '5%',
                textAlign: 'center',
                paddingLeft: '4px',
                paddingRight: '4px',
            },
        },
        {
            title: 'Filename',
            key: 'filename',
            renderCell: function (record) {
                var revisionChip = null;
                if (record.revision && record.revision > 1) {
                    revisionChip = (React__default.createElement(Chip$1, { label: "v".concat(record.revision), sx: {
                            height: 'auto',
                            marginLeft: '7px',
                            fontSize: '11px',
                            borderRadius: 0,
                            '& span': {
                                display: 'inline-flex',
                                alignItems: 'center',
                                marginBottom: '-1px',
                            },
                        }, variant: 'outlined', color: 'info', size: 'small' }));
                }
                return (React__default.createElement("div", { className: 'flex' },
                    React__default.createElement("span", { className: "mr-1 truncate ".concat(onFileNameClick ? 'hover:text-primary cursor-pointer' : ''), onClick: function () {
                            onFileNameClick === null || onFileNameClick === void 0 ? void 0 : onFileNameClick(record);
                        } },
                        React__default.createElement(Tooltip$1, { title: record.filename, placement: 'bottom', enterDelay: 400, componentsProps: {
                                tooltip: {
                                    sx: { backgroundColor: 'black', maxWidth: 'none' },
                                },
                                arrow: { sx: { color: 'black' } },
                            }, arrow: true },
                            React__default.createElement("span", null,
                                " ",
                                record.filename,
                                " "))),
                    React__default.createElement("div", { className: 'flex items-center' }, revisionChip)));
            },
            headerCellStyle: {
                width: '30%',
            },
            sort: function (a, b, factor) {
                if (a.fileType === 'folder' && b.fileType !== 'folder')
                    return factor * -1;
                if (a.fileType !== 'folder' && b.fileType === 'folder')
                    return factor * 1;
                return a.filename.localeCompare(b.filename);
            },
        },
        // {
        //   title: 'Revision',
        //   field: 'revision',
        // },
        // {
        //   title: 'Status / Maturity',
        //   renderCell: record => (
        //     <span>
        //       {record.status} / {record.maturity}
        //     </span>
        //   ),
        // },
        {
            title: 'Last Contribution',
            key: 'lastContribution',
            renderCell: function (record) {
                return (React__default.createElement("span", { className: 'max-w-full inline-block whitespace-nowrap overflow-hidden overflow-ellipsis box-border' }, record.lastContributionMessage));
            },
            headerCellStyle: {
                width: '25%',
            },
            sort: function (a, b) {
                return (a.lastContributionMessage || '').localeCompare(b.lastContributionMessage);
            },
        },
        {
            title: 'Last Modified',
            key: 'lastModified',
            renderCell: function (record) {
                var dateString = record.lastModified
                    ? format(new Date(record.lastModified), 'HH:mm dd/MM/yyyy')
                    : '一';
                var byAuthor = record.modifiedBy ? (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("span", { className: 'text-10 text-gray-400' }, "by"),
                    onModifiedUserNameClick ? (React__default.createElement("span", { className: 'ml-1 text-12 text-blue-500 cursor-pointer', onClick: function () {
                            onModifiedUserNameClick(record);
                        } }, record.modifiedBy)) : (React__default.createElement("span", { className: 'ml-1 text-12' }, record.modifiedBy)))) : null;
                return (React__default.createElement("span", null,
                    dateString,
                    " ",
                    byAuthor));
            },
            sort: function (a, b) {
                var timestamp1 = a.lastModified;
                var timestamp2 = b.lastModified;
                if (!timestamp1 || !timestamp2)
                    return 0;
                var epochTimestamp1 = typeof timestamp1 === 'string'
                    ? new Date(timestamp1).getTime()
                    : timestamp1;
                var epochTimestamp2 = typeof timestamp2 === 'string'
                    ? new Date(timestamp2).getTime()
                    : timestamp2;
                return epochTimestamp1 - epochTimestamp2;
            },
            headerCellStyle: {
                width: '15%',
            },
        },
        {
            title: 'Locked by',
            key: 'lockedBy',
            field: 'lockedBy',
            sort: function (a, b) {
                return a.lockedBy ? a.lockedBy.localeCompare(b.lockedBy) : -1;
            },
            headerCellStyle: {
                width: '13%',
            },
            bodyCellStyle: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                paddingRight: '4px',
            },
        },
        {
            title: 'Sync status',
            key: 'syncStatus',
            renderCell: function (record) {
                var progress = (record === null || record === void 0 ? void 0 : record.progress) || 0;
                var syncStatus = record === null || record === void 0 ? void 0 : record.syncStatus;
                var additional = null;
                if (syncStatus === 'downloading') {
                    additional = "".concat(progress.toFixed(0), "%");
                }
                return (React__default.createElement("div", null, syncStatus ? (React__default.createElement(SyncStatus, { status: record.syncStatus, additional: additional })) : ('一')));
            },
            headerCellStyle: {
                width: '15%',
            },
            bodyCellStyle: {
                paddingRight: '4px',
            },
            sort: function (a, b) {
                return a.syncStatus ? a.syncStatus.localeCompare(b.syncStatus) : -1;
            },
        },
    ];
};

var DriveTable = function (props) {
    var title = props.title, toolBar = props.toolBar, _a = props.banner, banner = _a === void 0 ? null : _a, lastContributionView = props.lastContributionView, _b = props.dataSource, dataSource = _b === void 0 ? [] : _b, onFileNameClick = props.onFileNameClick, _c = props.loading, loading = _c === void 0 ? false : _c, _d = props.hasFileDetailsButton, hasFileDetailsButton = _d === void 0 ? false : _d, onFileDetailsClick = props.onFileDetailsClick, onModifiedUserNameClick = props.onModifiedUserNameClick, onSelect = props.onSelect;
    var defaultFilter = function () { return true; };
    var _e = useState(function () { return defaultFilter; }), filter = _e[0], setFilter = _e[1];
    var filteredDataSource = dataSource.filter(filter);
    var columns = createDriveTableColumns({
        filteredDataSource: filteredDataSource,
        onFileNameClick: onFileNameClick,
        onModifiedUserNameClick: onModifiedUserNameClick,
        onSelect: onSelect,
    });
    if (hasFileDetailsButton) {
        columns.push({
            title: '',
            key: 'fileDetails',
            renderCell: function (record) {
                if (record.fileType !== 'file')
                    return null;
                return (React__default.createElement("div", { className: 'flex justify-center' },
                    React__default.createElement(IconButton$1, { onClick: function () {
                            onFileDetailsClick(record);
                        } },
                        React__default.createElement(SvgFileDetails, { className: 'text-black-1000 overflow-visible' }))));
            },
            headerCellStyle: {
                width: '4%',
            },
            bodyCellStyle: {
                padding: '0px',
            },
        });
    }
    var numFoldersBeforeFilter = dataSource.reduce(function (acc, row) { return (row.fileType === 'folder' ? acc + 1 : acc); }, 0);
    var numFilesBeforeFilter = dataSource.length - numFoldersBeforeFilter;
    var numFoldersAfterFilter = filteredDataSource.reduce(function (acc, row) { return (row.fileType === 'folder' ? acc + 1 : acc); }, 0);
    var numFilesAfterFilter = filteredDataSource.length - numFoldersAfterFilter;
    var numFoldersHidden = numFoldersBeforeFilter - numFoldersAfterFilter;
    var numFilesHidden = numFilesBeforeFilter - numFilesAfterFilter;
    var rowTextFilter = useRef(null);
    var _f = useTableSort(filteredDataSource, columns.find(function (column) { return column.key === 'filename'; })), sortedDataSource = _f[0], SortLabel = _f[1];
    var mainContent = null;
    if (loading || (sortedDataSource === null || sortedDataSource === void 0 ? void 0 : sortedDataSource.length)) {
        mainContent = (React__default.createElement(TableVirtuoso, { loading: loading, className: 'mt-4 select-none', columns: columns, dataSource: sortedDataSource, rowKey: function (record) { return record.id; }, maxHeight: 700, expectedRowHeight: 65, SortLabel: SortLabel }));
    }
    else if (numFilesHidden + numFoldersHidden > 0) {
        var filesText = numFilesHidden > 0
            ? "".concat(numFilesHidden, " file").concat(numFilesHidden > 1 ? 's' : '')
            : '';
        var foldersText = numFoldersHidden > 0
            ? "".concat(numFoldersHidden, " folder").concat(numFoldersHidden > 1 ? 's' : '')
            : '';
        var andText = numFilesHidden > 0 && numFoldersHidden > 0 ? ' and ' : '';
        var toBeVerbText = numFilesHidden + numFoldersHidden > 1 ? ' are' : ' is';
        mainContent = (React__default.createElement("div", { className: 'mt-8 border p-8 flex justify-center items-center flex-col' },
            React__default.createElement(default_1$2, { fontSize: 'large' }),
            React__default.createElement("p", { className: 'my-4' },
                filesText,
                andText,
                foldersText,
                toBeVerbText,
                " hidden by the filter"),
            React__default.createElement(Button, { size: 'small', primaryColor: 'black-hollow', variant: 'outlined', className: 'flex items-center', onClick: function () {
                    rowTextFilter.current.clear();
                }, endIcon: React__default.createElement("span", { style: {
                        marginLeft: '-5px',
                    } },
                    React__default.createElement(default_1$3, { viewBox: '-4 -1 32 32' })) },
                React__default.createElement("span", { className: '' }, "Clear filter"))));
    }
    else {
        mainContent = (React__default.createElement("div", { className: 'mt-8 border p-8' },
            React__default.createElement(EmptyDriveState, { status: 'noContribute' })));
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(DriveToolBar, __assign({ banner: banner }, toolBar, { title: title })),
        loading ? (React__default.createElement(Skeleton$1, null)) : (lastContributionView && (React__default.createElement(LastContributionView, __assign({ className: 'my-3.5' }, lastContributionView)))),
        React__default.createElement(RowTextFilter, { onSubmitFilter: function (newFilter) {
                setFilter(function () { return newFilter; });
            }, numFilesHidden: numFilesHidden, numFoldersHidden: numFoldersHidden, ref: rowTextFilter }),
        mainContent));
};

var _g$3;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React$1.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#upload_svg__clip0_1322_10181)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "m5.5 9.5.705.705L7.5 8.915V15h1V8.915l1.295 1.29.705-.705L8 7z"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M11.749 11.5h-.25v-1h.25a2.252 2.252 0 1 0 .18-4.5h-.43l-.05-.41a3.5 3.5 0 0 0-6.94 0l-.01.41h-.43a2.252 2.252 0 1 0 .18 4.5h.25v1h-.25a3.25 3.25 0 0 1-.65-6.43 4.5 4.5 0 0 1 8.8 0 3.25 3.25 0 0 1-.65 6.43"
  }))));
};

var _g$2;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React$1.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#warning_svg__clip0_324_18511)"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M6 .75a5.25 5.25 0 1 0 0 10.5A5.25 5.25 0 0 0 6 .75m0 9.75a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9"
  }), /*#__PURE__*/React$1.createElement("path", {
    d: "M6.375 3h-.75v4.125h.75zM6 8.25a.563.563 0 1 0 0 1.125.563.563 0 0 0 0-1.125"
  }))));
};

var _g$1, _rect$1;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgLockCircle = function SvgLockCircle(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#lockCircle_svg__clip0_1288_40334)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M16.965 11.5h-1v-3a3 3 0 1 0-6 0v3h-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1m-6-3a2 2 0 0 1 4 0v3h-4zm6 10h-8v-6h8z"
  }))), _rect$1 || (_rect$1 = /*#__PURE__*/React$1.createElement("rect", {
    width: 23,
    height: 23,
    x: 1.465,
    y: 1,
    stroke: "currentColor",
    rx: 11.5
  })));
};

var _g, _rect;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgUnLockCircle = function SvgUnLockCircle(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React$1.createElement("g", {
    clipPath: "url(#unLockCircle_svg__clip0_1288_40455)"
  }, /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    d: "M16.965 11.5h-6v-3a2 2 0 0 1 4 0h1a3 3 0 1 0-6 0v3h-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1m0 7h-8v-6h8z"
  }))), _rect || (_rect = /*#__PURE__*/React$1.createElement("rect", {
    width: 23,
    height: 23,
    x: 1.465,
    y: 1,
    stroke: "currentColor",
    rx: 11.5
  })));
};

var LocalChangesToolBar = function (props) {
    var expanded = props.expanded, defaultExpanded = props.defaultExpanded, resolveConflictsButtonProps = props.resolveConflictsButtonProps, contributeButtonProps = props.contributeButtonProps, restButtonProps = props.restButtonProps, lockButtonProps = props.lockButtonProps, unlockButtonProps = props.unlockButtonProps, buttonsDisabled = props.buttonsDisabled, onLockClick = props.onLockClick, onUnlockClick = props.onUnlockClick, onContributeClick = props.onContributeClick, onResolveConflictsClick = props.onResolveConflictsClick, onResetClick = props.onResetClick, _a = props.numRows, numRows = _a === void 0 ? 0 : _a, _b = props.numSelected, numSelected = _b === void 0 ? 0 : _b, rest = __rest(props, ["expanded", "defaultExpanded", "resolveConflictsButtonProps", "contributeButtonProps", "restButtonProps", "lockButtonProps", "unlockButtonProps", "buttonsDisabled", "onLockClick", "onUnlockClick", "onContributeClick", "onResolveConflictsClick", "onResetClick", "numRows", "numSelected"]);
    var toolBarExpanded = expanded || defaultExpanded;
    var selectionDisplay = null;
    if (numRows > 0) {
        if (numSelected === 0)
            selectionDisplay = "(".concat(numRows, ")");
        else
            selectionDisplay = "(".concat(numSelected, "/").concat(numRows, ")");
    }
    return (React__default.createElement(Accordion$1, __assign({ sx: {
            boxShadow: 'none',
            // Overlay mui style
            '::before': {
                content: "''",
                background: 'transparent',
            },
        }, expanded: expanded, defaultExpanded: defaultExpanded }, rest),
        React__default.createElement("div", { className: 'flex justify-between items-center h-8 ' },
            React__default.createElement(Tooltip$1, { title: React__default.createElement("div", { className: 'text-12' }, "Files you have locked, files you\u2019ve modified and new files you have created locally."), placement: 'right', componentsProps: {
                    tooltip: { sx: { backgroundColor: 'black', maxWidth: 'none' } },
                    arrow: { sx: { color: 'black' } },
                }, arrow: true },
                React__default.createElement(AccordionSummary$1, { className: 'flex', sx: {
                        padding: 0,
                        borderBottom: 'none',
                    }, expandIcon: React__default.createElement(default_1$4, { htmlColor: 'black' }) },
                    React__default.createElement("div", { "data-test-id": 'localDrive-title', className: 'font-extrabold text-24 leading-8' },
                        "Local Changes ",
                        selectionDisplay))),
            toolBarExpanded && (React__default.createElement("div", { className: 'flex gap-x-2' },
                onUnlockClick && (React__default.createElement(IconButton$1, __assign({ color: 'inherit', size: 'small', sx: { padding: 0, transition: '0.2s' }, onClick: onUnlockClick, disabled: buttonsDisabled }, unlockButtonProps),
                    React__default.createElement(SvgUnLockCircle, null))),
                onLockClick && (React__default.createElement(IconButton$1, __assign({ color: 'inherit', size: 'small', sx: { padding: 0, transition: '0.2s' }, onClick: onLockClick, disabled: buttonsDisabled }, lockButtonProps),
                    React__default.createElement(SvgLockCircle, null))),
                (onUnlockClick || onLockClick) && (React__default.createElement(Divider$1, { orientation: 'vertical', flexItem: true })),
                onResolveConflictsClick && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Button, __assign({ size: 'small', endIcon: React__default.createElement(SvgWarning, { className: '-ml-1 text-orange-500' }), primaryColor: 'black-hollow', variant: 'outlined', onClick: onResolveConflictsClick, disabled: buttonsDisabled }, resolveConflictsButtonProps),
                        React__default.createElement("span", { className: 'text-10 mr-2' }, " Resolve Conflicts")),
                    !(resolveConflictsButtonProps === null || resolveConflictsButtonProps === void 0 ? void 0 : resolveConflictsButtonProps.hidden) && (React__default.createElement(Divider$1, { orientation: 'vertical', flexItem: true, sx: { borderColor: 'black' } })))),
                React__default.createElement(Button, __assign({ size: 'small', endIcon: React__default.createElement(SvgRest, { className: '-ml-1' }), primaryColor: 'black-hollow', variant: 'outlined', onClick: onResetClick, disabled: buttonsDisabled }, restButtonProps),
                    React__default.createElement("span", { className: 'text-10' }, "Reset Changes")),
                React__default.createElement(Button, __assign({ size: 'small', primaryColor: 'blue-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgUpload, { className: '-ml-1' }), onClick: onContributeClick, disabled: buttonsDisabled && numSelected > 0 }, contributeButtonProps),
                    React__default.createElement("span", { className: 'text-10' }, "Contribute")))))));
};

var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

React__default.createContext(null);

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

function useSubscribe(props) {
    const _props = React__default.useRef(props);
    _props.current = props;
    React__default.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject.subscribe({
                next: _props.current.next,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!Array.isArray(data) && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                copy[key] = cloneObject(data[key]);
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                }
                else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(currentField)) {
                focusFieldBy(currentField, callback);
            }
        }
    }
};

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isBoolean = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isHTMLElement = (value) => {
    if (!isWeb) {
        return false;
    }
    const owner = value ? value.ownerDocument : 0;
    return (value instanceof
        (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement));
};

var isMessage = (value) => isString(value) || React__default.isValidElement(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) &&
        isUndefined(ref.value) &&
        isUndefined(inputValue)) ||
        (isHTMLElement(ref) && ref.value === '') ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (!isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path)
        ? path
        : isKey(path)
            ? [path]
            : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) {
        delete childObject[key];
    }
    if (index !== 0 &&
        ((isObject(childObject) && isEmptyObject(childObject)) ||
            (Array.isArray(childObject) && isEmptyArray(childObject)))) {
        unset(object, paths.slice(0, -1));
    }
    return object;
}

function createSubject() {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                deepEqual(data[key], formValues[key])
                    ? delete dirtyFieldsFromValues[key]
                    : (dirtyFieldsFromValues[key] = true);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: true,
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {},
    };
    let _fields = {};
    let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values)
        ? cloneObject(_options.defaultValues || _options.values) || {}
        : {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        watch: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = window.setTimeout(callback, wait);
    };
    const _updateValid = async (shouldUpdateValid) => {
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) {
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateIsValidating = (value) => _proxyFormState.isValidating &&
        _subjects.state.next({
            isValidating: value,
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
            isPreviousDirty = get(_formState.dirtyFields, name);
            isCurrentFieldPristine
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField =
                shouldUpdateField ||
                    (_proxyFormState.dirtyFields &&
                        isPreviousDirty !== !isCurrentFieldPristine);
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = get(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                set(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        (_proxyFormState.touchedFields &&
                            isPreviousFieldTouched !== isBlurEvent);
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name) => await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema();
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_stateFlags.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal, defaultValue);
    const _getFieldArray = (name) => compact(get(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.watch.next({
                            name,
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: _formValues,
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _subjects.state.next({
                    name,
                    dirtyFields: getDirtyFields(_defaultValues, _formValues),
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name,
        });
        !_stateFlags.mount && flushRootRender();
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        const field = get(_fields, name);
        const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.watch.next({
                    name,
                    type: event.type,
                });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({});
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                if (error) {
                    isValid = false;
                }
                else if (_proxyFormState.isValid) {
                    isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            field._f.deps &&
                trigger(field._f.deps);
            shouldRenderByError(name, isValid, error, fieldState);
        }
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            focusFieldBy(_fields, (key) => key && get(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_stateFlags.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name &&
            convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {},
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.watch.subscribe({
            next: (payload) => name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (get(_fields, fieldName)) {
                if (!options.keepValue) {
                    unset(_fields, fieldName);
                    unset(_formValues, fieldName);
                }
                !options.keepError && unset(_formState.errors, fieldName);
                !options.keepDirty && unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister &&
                    !options.keepDefaultValue &&
                    unset(_defaultValues, fieldName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        field
            ? disabledIsDefined &&
                set(_formValues, name, options.disabled
                    ? undefined
                    : get(_formValues, name, getFieldValue(field._f)))
            : updateValidAndValue(name, true, options.value);
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.shouldUseNativeValidation
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _stateFlags.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        focusFieldBy(_fields, (key) => key && get(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        if (_options.resolver) {
            const { errors, values } = await _executeSchema();
            _formState.errors = errors;
            fieldValues = values;
        }
        else {
            await executeBuiltInValidation(_fields);
        }
        unset(_formState.errors, 'root');
        if (isEmptyObject(_formState.errors)) {
            _subjects.state.next({
                errors: {},
            });
            await onValid(fieldValues, e);
        }
        else {
            if (onInvalid) {
                await onInvalid({ ..._formState.errors }, e);
            }
            _focusError();
        }
        _subjects.state.next({
            isSubmitted: true,
            isSubmitting: false,
            isSubmitSuccessful: isEmptyObject(_formState.errors),
            submitCount: _formState.submitCount + 1,
            errors: _formState.errors,
        });
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, get(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneUpdatedValues;
            _subjects.array.next({
                values,
            });
            _subjects.watch.next({
                values,
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        !_stateFlags.mount && flushRootRender();
        _stateFlags.mount =
            !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState) => {
        _formState = {
            ..._formState,
            ...updatedFormState,
        };
    };
    if (isFunction(_options.defaultValues)) {
        _options.defaultValues().then((values) => {
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false,
            });
        });
    }
    return {
        control: {
            register,
            unregister,
            getFieldState,
            _executeSchema,
            _focusError,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _getFieldArray,
            _reset,
            _updateFormState,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _stateFlags() {
                return _stateFlags;
            },
            set _stateFlags(value) {
                _stateFlags = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = React__default.useRef();
    const [formState, updateFormState] = React__default.useState({
        isDirty: false,
        isValidating: false,
        isLoading: true,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: isFunction(props.defaultValues)
            ? undefined
            : props.defaultValues,
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...createFormControl(props, () => updateFormState((formState) => ({ ...formState }))),
            formState,
        };
    }
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value) => {
            if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
                updateFormState({ ...control._formState });
            }
        },
    });
    React__default.useEffect(() => {
        if (!control._stateFlags.mount) {
            control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    React__default.useEffect(() => {
        if (props.values && !deepEqual(props.values, control._defaultValues)) {
            control._reset(props.values, control._options.resetOptions);
        }
    }, [props.values, control]);
    React__default.useEffect(() => {
        formState.submitCount && control._focusError();
    }, [control, formState.submitCount]);
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}

var _path$3, _path2$2, _path3$2, _path4$2;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgCheckIn = function SvgCheckIn(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 75,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    d: "M6.571 51.43V32.857h14.572l7.714 7.429h30.286l.742 7.424C62.505 43.07 64 37.71 64 32 64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32a31.86 31.86 0 0 0 6.571 19.43",
    clipRule: "evenodd"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m26.868 39.19-6.212-6.423H7.633v35.13H20v3.766H7.633a3.568 3.568 0 0 1-2.569-1.103A3.84 3.84 0 0 1 4 67.896V32.767c0-.999.383-1.957 1.064-2.664A3.568 3.568 0 0 1 7.633 29h13.023c.48 0 .954.098 1.396.288.443.191.845.47 1.183.823l6.194 6.423h26.938c.964 0 1.888.397 2.569 1.104A3.839 3.839 0 0 1 60 40.302v27.594c0 1-.383 1.958-1.064 2.664a3.568 3.568 0 0 1-2.569 1.103H44v-3.767h12.367V40.302H27.921z",
    clipRule: "evenodd"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    d: "m20.656 32.767.205-.198-.084-.088h-.121zm6.212 6.423.207-.196-.002-.002zM7.633 32.767v-.286h-.286v.286zm0 35.13h-.286v.285h.286zm12.367 0h.286v-.286H20zm0 3.766v.286h.286v-.285zM5.064 70.56l.206-.198zm0-40.457.206.199zM20.656 29v.286zm1.396.288.114-.262zm1.183.823-.206.198zm6.194 6.423-.206.199.084.087h.122zm29.507 1.104.206-.198zm0 32.922.206.198zM44 71.663h-.286v.286H44zm0-3.767v-.285h-.286v.285zm12.367 0v.286h.286v-.286zm0-27.594h.286v-.286h-.286zm-28.446 0-.207.196.084.09h.123zm-7.47-7.336 6.211 6.423.41-.397-6.21-6.423zm-12.818.087h13.023v-.572H7.633zm.285 34.843V32.767h-.571v35.13zM20 67.611H7.633v.571H20zm.286 4.052v-3.767h-.572v3.767zm-12.653.286H20v-.571H7.633zm-2.775-1.19a3.854 3.854 0 0 0 2.775 1.19v-.571a3.282 3.282 0 0 1-2.363-1.016zm-1.144-2.863c0 1.072.41 2.102 1.144 2.862l.412-.396a3.554 3.554 0 0 1-.984-2.466zm0-35.129v35.13h.572v-35.13zm1.144-2.862a4.125 4.125 0 0 0-1.144 2.862h.572c0-.926.355-1.813.984-2.465zm2.775-1.19c-1.043 0-2.04.429-2.775 1.19l.412.397a3.282 3.282 0 0 1 2.363-1.016zm13.023 0H7.633v.57h13.023zm1.51.31a3.808 3.808 0 0 0-1.51-.31v.57c.44 0 .876.09 1.283.266zm1.275.889a3.916 3.916 0 0 0-1.275-.888l-.227.525c.407.175.778.433 1.09.758zm6.193 6.422-6.193-6.423-.412.397 6.194 6.423zm26.733-.087H29.43v.571h26.938zm2.775 1.19a3.854 3.854 0 0 0-2.775-1.19v.571c.885 0 1.735.364 2.363 1.016zm1.144 2.863c0-1.072-.41-2.102-1.144-2.862l-.412.396c.63.652.984 1.539.984 2.466zm0 13.797V40.302h-.572v13.797zm0 13.797V54.1h-.572v13.797zm-1.144 2.862a4.125 4.125 0 0 0 1.144-2.862h-.572c0 .927-.355 1.814-.984 2.466zm-2.775 1.191c1.043 0 2.04-.43 2.775-1.19l-.412-.397a3.282 3.282 0 0 1-2.363 1.016zm-11.624 0h11.624v-.571H44.743zm-.743 0h.743v-.571H44zm-.286-4.053v3.767h.572v-3.767zm1.029-.285H44v.571h.743zm11.624 0H44.743v.571h11.624zm-.285-13.512v13.797h.571V54.1zm0-13.797v13.797h.571V40.302zm-28.161.285h28.446v-.571H27.921zm-1.26-1.2 1.053 1.111.414-.393-1.053-1.111z"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m32.103 50.437-9.927 9.586 2.778 2.877 5.017-4.844-.254 16.868 3.995.07.255-16.869 4.845 5.017 2.877-2.778z",
    clipRule: "evenodd"
  })));
};

var renderFileList = function (changesList) {
    var changesTitle = {
        added: 'Added Files',
        modified: 'Edited Files',
        renamed: 'Renamed Files',
        deleted: 'Deleted Files',
    };
    return (React__default.createElement(React__default.Fragment, null, changesList
        .filter(function (_a) {
        var files = _a.files;
        return files.length > 0;
    })
        .map(function (_a) {
        var type = _a.type, files = _a.files;
        return (React__default.createElement(Accordion$1, { key: type, sx: {
                boxShadow: 'none',
                // Overlay mui style
                '::before': {
                    content: "''",
                    background: 'transparent',
                },
            }, className: 'w-full', disableGutters: true },
            React__default.createElement(AccordionSummary$1, { sx: {
                    padding: 0,
                    borderBottom: '1px solid #ECECEC',
                }, expandIcon: React__default.createElement(default_1$4, { htmlColor: 'black' }) },
                React__default.createElement("div", { className: 'flex' },
                    React__default.createElement(WorkflowStatus, { textStyle: { display: 'none' }, status: type }),
                    React__default.createElement("span", { className: 'font-extrabold mr-1 ml-2' }, changesTitle[type]),
                    React__default.createElement("span", { className: 'text-gray-400' },
                        "(",
                        files.length,
                        ")"))),
            React__default.createElement(AccordionDetails$1, { sx: { padding: 0 } }, files.map(function (_a) {
                var id = _a.id, name = _a.name;
                return (React__default.createElement("div", { className: 'mt-2 mb-2 ml-6 text-sm text-black-400', key: id }, name));
            }))));
    })));
};
var ContributeDialog = function (props) {
    var _a = props.changesList, changesList = _a === void 0 ? [] : _a, dialogProps = props.dialogProps, _b = props.icon, icon = _b === void 0 ? React__default.createElement(SvgCheckIn, { style: props.iconStyle }) : _b, _c = props.titleText, titleText = _c === void 0 ? 'Confirm Contribution' : _c, _d = props.descriptionText, descriptionText = _d === void 0 ? 'Please review the following changes before contributing them.' : _d, titleStyle = props.titleStyle, descriptionStyle = props.descriptionStyle, closeButtonProps = props.closeButtonProps, confirmButtonProps = props.confirmButtonProps, onDialogConfirm = props.onDialogConfirm, onDialogClose = props.onDialogClose;
    var _e = useForm(), register = _e.register, handleSubmit = _e.handleSubmit, reset = _e.reset;
    useEffect(function () {
        if (!dialogProps.open) {
            reset();
        }
    }, [dialogProps.open]);
    return (React__default.createElement(Dialog$1, __assign({}, dialogProps),
        React__default.createElement("div", { className: 'px-14 py-8' },
            React__default.createElement(DialogContent$1, { sx: { padding: 0 } },
                React__default.createElement("div", { className: 'flex justify-center items-center flex-col' },
                    icon,
                    React__default.createElement("div", { style: titleStyle, className: 'mt-2 text-24 font-extrabold w-fit h-fit text-center' }, titleText)),
                React__default.createElement("div", null,
                    React__default.createElement("div", { className: 'mt-2 text-18 font-extrabold' },
                        changesList.reduce(function (acc, cur) { return acc + cur.files.length; }, 0),
                        React__default.createElement("span", { className: 'ml-1' }, "Changes")),
                    React__default.createElement("div", { className: 'mt-2 ', style: descriptionStyle }, descriptionText),
                    renderFileList(changesList)),
                React__default.createElement("form", { onSubmit: handleSubmit(function (data) {
                        onDialogConfirm === null || onDialogConfirm === void 0 ? void 0 : onDialogConfirm(data);
                    }), className: 'flex flex-col w-full' },
                    React__default.createElement(FormControl$1, { sx: { marginTop: '0.5rem' } },
                        React__default.createElement("label", { className: 'font-extrabold leading-6 mb-1 text-black-1000', htmlFor: 'title' }, "Contribution Title"),
                        React__default.createElement(MTextField, __assign({ size: 'small', name: 'title', placeholder: 'Summarise your changes' }, register('title')))),
                    React__default.createElement(FormControl$1, { sx: { marginTop: '0.5rem' } },
                        React__default.createElement("label", { className: 'font-extrabold leading-6 mb-1 text-black-1000', htmlFor: 'description' }, "Description"),
                        React__default.createElement(MTextField, __assign({ rows: 2, multiline: true, name: 'description', placeholder: 'Leave a message to let others know what the updates are about.' }, register('description')))),
                    React__default.createElement(DialogActions$1, { sx: { padding: 0, marginTop: '1rem' } },
                        React__default.createElement("div", { className: 'w-full flex justify-center' },
                            React__default.createElement(Button, __assign({ primaryColor: 'black-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgClose, null), onClick: function (e) {
                                    onDialogClose(e);
                                    reset();
                                } }, closeButtonProps),
                                React__default.createElement("span", { className: 'text-14' }, "Close")),
                            React__default.createElement(Button, __assign({ size: 'small', type: 'submit', style: { marginLeft: '0.75rem' }, primaryColor: 'blue-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgRightArrow, null) }, confirmButtonProps),
                                React__default.createElement("span", { className: 'text-14' }, "Confirm")))))))));
};

var toolTipProps = {
    tooltip: {
        sx: { backgroundColor: 'black', maxWidth: 'none' },
    },
    arrow: { sx: { color: 'black' } },
};
var LocalChangesTable = function (props) {
    var expanded = props.expanded, loading = props.loading, banner = props.banner, alertContent = props.alertContent, _a = props.alertVariant, alertVariant = _a === void 0 ? 'warning' : _a, _b = props.dataSource, dataSource = _b === void 0 ? [] : _b, _c = props.tableEmptyDriveStatus, tableEmptyDriveStatus = _c === void 0 ? 'noChange' : _c, _d = props.toolBar, toolBar = _d === void 0 ? {} : _d, onFileNameClick = props.onFileNameClick, onFilePathClick = props.onFilePathClick, onResetClick = props.onResetClick, onKeepCloudClick = props.onKeepCloudClick, onKeepLocalClick = props.onKeepLocalClick, onRetryClick = props.onRetryClick, 
    // onOpenIconClick,
    onAccordionChange = props.onAccordionChange, onSelect = props.onSelect, onSelectAll = props.onSelectAll, onRenderStatus = props.onRenderStatus, onRenderChangeCell = props.onRenderChangeCell, _e = props.tableClassName, tableClassName = _e === void 0 ? 'mt-8' : _e;
    var numRows = dataSource.length;
    var numSelectedRows = dataSource.reduce(function (prev, item) { return (item.selected ? prev + 1 : prev); }, 0);
    var numNotSelectedRows = dataSource.length - numSelectedRows;
    var columns = [
        {
            title: '',
            key: 'locks',
            renderCell: function (record) {
                var isRemoteLock = record.isRemoteLock, fileLocked = record.fileLocked, lockedBy = record.lockedBy;
                var shouldRenderLock = record.changeStatus !== 'added';
                var tooltipText = '';
                var icon = React__default.createElement("div", null);
                if (shouldRenderLock) {
                    tooltipText =
                        'File is not locked and could be changed by someone else while you work on it.';
                    icon = (React__default.createElement("div", null,
                        React__default.createElement(SvgUnlock, { className: 'text-yellow-500' })));
                    if (fileLocked) {
                        tooltipText = isRemoteLock
                            ? "File is locked by ".concat(lockedBy, " and can't be contributed.")
                            : "File is locked by you so it's safe to contribute.";
                        icon = isRemoteLock ? (React__default.createElement("div", { className: 'text-red-500' },
                            React__default.createElement(SvgRemoteLock, { className: 'overflow-visible' }))) : (React__default.createElement("div", { className: 'text-black-1000' },
                            React__default.createElement(SvgLock, { className: 'overflow-visible' })));
                    }
                }
                return (React__default.createElement("div", { className: 'flex h-full justify-center items-center' },
                    React__default.createElement(Tooltip$1, { title: tooltipText, placement: 'right', componentsProps: toolTipProps, arrow: true }, icon)));
            },
            bodyCellStyle: {
                paddingRight: '0px',
            },
            headerCellStyle: {
                width: '2%',
            },
        },
        {
            title: function () {
                return (React__default.createElement(Checkbox$1, { indeterminate: numSelectedRows > 0 && numNotSelectedRows > 0, checked: numSelectedRows === dataSource.length, size: 'small', onChange: onSelectAll }));
            },
            key: 'checkbox',
            renderCell: function (record) {
                var fileStatus = {
                    added: 'change',
                    modified: 'change',
                    renamed: 'change',
                    editing: 'change',
                };
                return (React__default.createElement("div", { className: 'flex justify-center' },
                    React__default.createElement(FileIcon, { selection: record.selected ? 'selected' : 'unselected', fileStatus: fileStatus[record.changeStatus] || 'default', onClick: function () {
                            onSelect === null || onSelect === void 0 ? void 0 : onSelect(record.id, !record.selected);
                        }, disabled: record.disabled })));
            },
            headerCellStyle: {
                width: '5%',
                textAlign: 'center',
                paddingLeft: '4px',
                paddingRight: '4px',
            },
        },
        {
            title: 'Filename',
            key: 'filename',
            renderCell: function (record) {
                return (React__default.createElement("div", { className: 'h-8' },
                    React__default.createElement("div", { className: 'flex' },
                        React__default.createElement(Tooltip$1, { title: record.filename.length > 19 ? record.filename : null, placement: 'top', componentsProps: toolTipProps, arrow: true },
                            React__default.createElement("span", { className: "mr-1 truncate ".concat(onFileNameClick ? 'hover:text-primary cursor-pointer' : ''), onClick: function () {
                                    onFileNameClick === null || onFileNameClick === void 0 ? void 0 : onFileNameClick(record.id);
                                } }, record.filename))),
                    React__default.createElement(Tooltip$1, { title: 'Show in local folder', placement: 'right', componentsProps: toolTipProps, arrow: true },
                        React__default.createElement("div", { className: 'inline-block max-w-full text-12 text-gray-600 hover:text-primary cursor-pointer truncate', style: { direction: 'rtl' }, onClick: function () {
                                onFilePathClick === null || onFilePathClick === void 0 ? void 0 : onFilePathClick(record.id, record.path);
                            } }, record.path))));
            },
            sort: function (a, b) { return a.filename.localeCompare(b.filename); },
        },
        {
            title: 'Change',
            key: 'changeStatus',
            renderCell: function (record) {
                var defaultCell = (React__default.createElement("div", null, (record === null || record === void 0 ? void 0 : record.changeStatus) ? (React__default.createElement(WorkflowStatus, { status: record.changeStatus })) : ('一')));
                if (onRenderChangeCell) {
                    return onRenderChangeCell(record, defaultCell);
                }
                return defaultCell;
            },
            bodyCellStyle: {
                minWidth: 120,
            },
            sort: function (a, b) { var _a; return a.changeStatus ? (_a = a.changeStatus) === null || _a === void 0 ? void 0 : _a.localeCompare(b.changeStatus) : -1; },
        },
        {
            title: 'Last Local Change',
            key: 'lastLocalChangeTimestamp',
            renderCell: function (record) {
                var dateString = record.lastLocalChangeTimestamp
                    ? format(new Date(record.lastLocalChangeTimestamp), 'HH:mm dd/MM/yyyy')
                    : '一';
                return React__default.createElement("span", null, dateString);
            },
            sort: function (a, b) {
                var timestamp1 = a.lastLocalChangeTimestamp;
                var timestamp2 = b.lastLocalChangeTimestamp;
                if (!timestamp1 || !timestamp2)
                    return 0;
                var epochTimestamp1 = typeof timestamp1 === 'string'
                    ? new Date(timestamp1).getTime()
                    : timestamp1;
                var epochTimestamp2 = typeof timestamp2 === 'string'
                    ? new Date(timestamp2).getTime()
                    : timestamp2;
                return epochTimestamp1 - epochTimestamp2;
            },
        },
        {
            title: 'File Size',
            key: 'fileSize',
            field: 'fileSize',
            sort: function (a, b) {
                var fileSizeA = parseFloat(a.fileSize);
                var fileSizeB = parseFloat(b.fileSize);
                if (Number.isNaN(fileSizeA) || Number.isNaN(fileSizeB)) {
                    return 0;
                }
                return fileSizeB - fileSizeA;
            },
        },
        {
            title: 'Status',
            key: 'syncStatus',
            renderCell: function (record) {
                var _a = record !== null && record !== void 0 ? record : {}, _b = _a.progress, progress = _b === void 0 ? 0 : _b, syncStatus = _a.syncStatus;
                var SyncStatusAdditional = {
                    conflict: (React__default.createElement("div", { className: 'text-black-1000 ml-1 overflow-auto w-full' },
                        React__default.createElement("a", { className: ' text-14 underline cursor-pointer', onClick: function () {
                                onKeepCloudClick === null || onKeepCloudClick === void 0 ? void 0 : onKeepCloudClick(record.id);
                            } }, "Keep Cloud"),
                        React__default.createElement("span", { className: 'mx-1' }, ","),
                        React__default.createElement("a", { className: ' text-14 underline cursor-pointer', onClick: function () {
                                onKeepLocalClick === null || onKeepLocalClick === void 0 ? void 0 : onKeepLocalClick(record.id);
                            } }, "Keep Local"))),
                    uploadFailed: (React__default.createElement("u", { className: 'cursor-pointer', onClick: function () {
                            onRetryClick === null || onRetryClick === void 0 ? void 0 : onRetryClick(record.id);
                        } }, "Retry")),
                    conflictResolved: (React__default.createElement("div", { className: 'flex' },
                        React__default.createElement("span", null, "(Kept Local)"),
                        React__default.createElement("u", { className: 'flex mx-1 cursor-pointer text-black-1000', onClick: function () {
                                onResetClick === null || onResetClick === void 0 ? void 0 : onResetClick(record.id);
                            } },
                            "Reset",
                            React__default.createElement(SvgRest, { className: 'ml-1' })))),
                    downloading: "".concat(progress.toFixed(0), "%"),
                    uploading: "".concat(progress.toFixed(0), "%"),
                };
                return (React__default.createElement("div", null, syncStatus ? (React__default.createElement(SyncStatus, { status: syncStatus, onRenderStatus: function (status) { return onRenderStatus(status, record); }, additional: SyncStatusAdditional[syncStatus] })) : ('一')));
            },
            headerCellStyle: {
                width: '30%',
            },
            sort: function (a, b) {
                return a.syncStatus ? a.syncStatus.localeCompare(b.syncStatus) : -1;
            },
        },
    ];
    var _f = useTableSort(dataSource, columns.find(function (column) { return column.key === 'filename'; })), sortedDataSource = _f[0], SortLabel = _f[1];
    var bannerChildren = typeof alertContent !== 'string' ? alertContent : null;
    var bannerText = typeof alertContent === 'string' ? alertContent : null;
    return (React__default.createElement("div", null,
        React__default.createElement("div", { className: 'mt-8' },
            React__default.createElement(LocalChangesToolBar, __assign({}, toolBar, { expanded: expanded, onChange: onAccordionChange, numRows: numRows, numSelected: numSelectedRows }))),
        expanded ? (React__default.createElement("div", null,
            banner,
            !banner && alertContent && (React__default.createElement(Banner, { className: 'mt-8', text: bannerText, variant: alertVariant }, bannerChildren)),
            loading || (sortedDataSource === null || sortedDataSource === void 0 ? void 0 : sortedDataSource.length) ? (React__default.createElement("div", { className: tableClassName },
                React__default.createElement(TableVirtuoso, { rowKey: function (record) { return record.id; }, dataSource: sortedDataSource, columns: columns, loading: loading, className: 'select-none', SortLabel: SortLabel }))) : (React__default.createElement("div", { className: 'mt-8 py-10 border border-gray-300' },
                React__default.createElement(EmptyDriveState, { status: tableEmptyDriveStatus }))))) : (React__default.createElement("div", { className: 'mt-8' },
            React__default.createElement(Divider$1, null)))));
};

var global$1 = {
    // Layout
    layout: {
        maxWidth: '1440px',
        paddingInline: '4vw',
        ratio: [3, 2],
    },
    // Border radius
    borderRadius: {
        xsmall: '0.2em',
        small: '0.3em',
        medium: '1em',
        large: '1.5em',
        xlarge: '3em',
    },
    // New space object (https://chakra-ui.com/docs/styled-system/theming/theme?scroll=true#spacing)
    space: {
        1: '0.25rem',
        2: '0.5rem',
        3: '0.75rem',
        4: '1rem',
        5: '1.25rem', // 24px
        6: '1.5rem',
        7: '1.75rem',
        8: '2rem',
    },
    // Spacing
    spacing: {
        xsmall: '0.25rem',
        small: '0.5rem',
        default: '1rem',
        medium: '1.5rem',
        large: '2rem',
        xlarge: '3rem',
        xxlarge: '4rem',
        xxxlarge: '5rem',
    },
    // Image
    image: {
        borderRadius: '6px',
        boxShadow: 'rgba(0, 0, 0, 0.25) 0px 25px 50px -12px',
    },
    transition: {
        duration: '256ms',
        func: 'ease-in-out',
    },
    shadow: {
        sm: '0px 6px 20px rgba(0, 0, 0, 0.2)',
    },
};

// Wikifactory Theme colors
var themeColors = {
    // WF colors
    wfWhite: '#ffffff',
    wfBlack: '#000000',
    wfGrey: '#3D3D3D',
    wfGrey900: '#444444',
    wfGrey800: '#646464',
    wfGrey700: '#777777',
    wfGrey600: '#8B8B8B',
    wfGrey500: '#9E9E9E',
    wfGrey400: '#B1B1B1',
    wfGrey300: '#C5C5C5',
    wfGrey200: '#D8D8D8',
    wfGrey100: '#f9f9f9',
    wfGrey50: '#F5F5F5',
    wfYellow: '#ffcb00',
    wfYellow900: '#FED119',
    wfYellow800: '#FFD632',
    wfYellow700: '#FFDB4D',
    wfYellow600: '#FFE066',
    wfYellow500: '#FFE680',
    wfYellow400: '#FFEB99',
    wfYellow300: '#FFEFB2',
    wfYellow200: '#FFF4CC',
    wfYellow100: '#FFFAE6',
    wfBlue: '#0f2eff',
    wfBlue900: '#1950FF',
    wfBlue800: '#3363FF',
    wfBlue700: '#4D76FF',
    wfBlue600: '#658BFF',
    wfBlue500: '#809DFF',
    wfBlue400: '#98B1FF',
    wfBlue300: '#B2C4FF',
    wfBlue200: '#CCD8FF',
    wfBlue100: '#E6ECFF',
    wfGreen: '#00d54c',
    wfGreen900: '#19D46E',
    wfGreen800: '#33D97E',
    wfGreen700: '#4CDE8E',
    wfGreen600: '#67E39E',
    wfGreen500: '#80E7AF',
    wfGreen400: '#98ECBF',
    wfGreen300: '#B2F1CF',
    wfGreen200: '#CCF6DF',
    wfGreen100: '#E6FBEF',
    wfOrange: '#ff4d00',
    wfOrange900: '#FF6E18',
    wfOrange800: '#FF7D34',
    wfOrange700: '#FF8E4C',
    wfOrange600: '#FF9E66',
    wfOrange500: '#FFAE7F',
    wfOrange400: '#FFBE98',
    wfOrange300: '#FFCFB2',
    wfOrange200: '#FFDECC',
    wfOrange100: '#FFEFE6',
    wfPurple: '#9000ff',
    wfPurple900: '#8F40FF',
    wfPurple800: '#9C56FF',
    wfPurple700: '#A86BFF',
    wfPurple600: '#B57FFF',
    wfPurple500: '#C095FF',
    wfPurple400: '#CDAAFF',
    wfPurple300: '#DAC0FF',
    wfPurple200: '#E6D5FF',
    wfPurple100: '#F3EAFF',
    wfPink: '#ff00ff',
    wfRed: '#ff1111',
    wfRed900: '#ff2929',
    wfRed800: '#ff4141',
    wfRed700: '#ff5858',
    wfRed600: '#ff7070',
    wfRed500: '#ff8888',
    wfRed400: '#ffa0a0',
    wfRed300: '#ffb8b8',
    wfRed200: '#ffcfcf',
    wfRed100: '#ffe7e7',
    // Theme colors
    primary: '#0f2eff',
    primaryLight: '#809DFF',
    primaryLightest: '#E6ECFF',
    primaryDark: '#00218E',
    // RGB colors (x, y, z axes colors)
    red: '#ff1111',
    green: '#11bb11',
    blue: '#1111ff',
    yellow: '#ffff00',
    cyan: '#00ffff',
    // Pin annotations
    pinNote: '#ff00ff',
    pinNoteDark: '#884dd9',
    pinInstanceNote: '#FFD700',
    pinInstanceNoteDark: '#FF8C00',
    // Markup
    markupDark: '#bfbf00',
    markup: '#ffff00',
};

var font = {
    // Font family
    family: {
        primary: '"HelveticaNowDisplay", Helvetica, sans-serif',
    },
    // Font weight
    weight: {
        regular: '300',
        normal: '400',
        bold: '700',
        xbold: '900',
    },
    // Line-height
    lineHeight: {
        small: '1',
        medium: '1.5',
        large: '2',
    },
    // Font Sizes
    size: {
        xxsmall: '0.5rem',
        xsmall: '0.75rem',
        small: '0.875rem',
        default: '1rem',
        medium: '1.25rem',
        xmedium: '1.5rem',
        large: '1.875rem',
        xlarge: '3rem',
        xxlarge: '4rem',
        xxxlarge: '5rem',
    },
};

var breakpoints = {
    // Breakpoints
    xsmall: '20em',
    small: '26em',
    medium: '40em',
    large: '59em',
    sxlarge: '70em',
    xlarge: '78em',
    xxlarge: '92em',
};

// Icons Theme paths
var icons = {
    home: {
        path: 'M12.4592 1.66034C12.3261 1.55645 12.1621 1.50003 11.9932 1.50003C11.8243 1.50003 11.6603 1.55645 11.5272 1.66034L0.75 10.0645L1.68203 11.2433L3 10.2157V19.5C3.00081 19.8976 3.15911 20.2786 3.44024 20.5598C3.72137 20.8409 4.10242 20.9992 4.5 21H19.5C19.8976 20.9993 20.2787 20.841 20.5599 20.5598C20.841 20.2787 20.9993 19.8976 21 19.5V10.2225L22.318 11.25L23.25 10.0711L12.4592 1.66034ZM13.5 19.5H10.5V13.5H13.5V19.5ZM15 19.5V13.5C14.9995 13.1023 14.8414 12.721 14.5602 12.4398C14.279 12.1586 13.8977 12.0004 13.5 12H10.5C10.1023 12.0004 9.721 12.1585 9.43978 12.4398C9.15856 12.721 9.0004 13.1023 9 13.5V19.5H4.5V9.04611L12 3.20361L19.5 9.05399V19.5H15Z',
    },
    profile: {
        path: 'M11.9997 7.42856C11.4346 7.42856 10.8822 7.59613 10.4124 7.91007C9.94252 8.22402 9.57632 8.67025 9.36007 9.19232C9.14382 9.71439 9.08724 10.2889 9.19748 10.8431C9.30772 11.3973 9.57984 11.9064 9.97942 12.306C10.379 12.7056 10.8881 12.9777 11.4423 13.0879C11.9966 13.1982 12.571 13.1416 13.0931 12.9254C13.6152 12.7091 14.0614 12.3429 14.3753 11.873C14.6893 11.4032 14.8569 10.8508 14.8569 10.2857C14.8569 9.52794 14.5558 8.80121 14.02 8.2654C13.4842 7.72958 12.7575 7.42856 11.9997 7.42856ZM11.9997 12C11.6607 12 11.3292 11.8994 11.0473 11.7111C10.7654 11.5227 10.5457 11.255 10.4159 10.9417C10.2862 10.6285 10.2522 10.2838 10.3184 9.95126C10.3845 9.61872 10.5478 9.31326 10.7875 9.07352C11.0273 8.83377 11.3327 8.6705 11.6653 8.60435C11.9978 8.53821 12.3425 8.57216 12.6557 8.70191C12.969 8.83166 13.2367 9.05138 13.4251 9.33329C13.6135 9.61521 13.714 9.94665 13.714 10.2857C13.7135 10.7402 13.5327 11.1759 13.2113 11.4973C12.89 11.8187 12.4542 11.9995 11.9997 12V12Z M12 4C10.4178 4 8.87103 4.46919 7.55544 5.34824C6.23985 6.22729 5.21447 7.47672 4.60897 8.93853C4.00347 10.4003 3.84504 12.0089 4.15372 13.5607C4.4624 15.1126 5.22433 16.538 6.34315 17.6569C7.46197 18.7757 8.88743 19.5376 10.4393 19.8463C11.9911 20.155 13.5997 19.9965 15.0615 19.391C16.5233 18.7855 17.7727 17.7602 18.6518 16.4446C19.5308 15.129 20 13.5822 20 12C19.9976 9.879 19.154 7.84556 17.6542 6.34578C16.1544 4.84601 14.121 4.00239 12 4V4ZM8.57143 17.9294V17.1429C8.57193 16.6884 8.7527 16.2526 9.07409 15.9312C9.39547 15.6098 9.83121 15.4291 10.2857 15.4286H13.7143C14.1688 15.4291 14.6045 15.6098 14.9259 15.9312C15.2473 16.2526 15.4281 16.6884 15.4286 17.1429V17.9294C14.3881 18.537 13.2049 18.8571 12 18.8571C10.7951 18.8571 9.61191 18.537 8.57143 17.9294ZM16.5671 17.1005C16.5558 16.3509 16.2504 15.6358 15.7167 15.1093C15.1831 14.5828 14.4639 14.287 13.7143 14.2857H10.2857C9.53606 14.287 8.81692 14.5828 8.28327 15.1093C7.74963 15.6358 7.44422 16.3509 7.43286 17.1005C6.39661 16.1752 5.66585 14.957 5.33734 13.6071C5.00883 12.2573 5.09806 10.8395 5.59323 9.54152C6.08839 8.24353 6.96613 7.12655 8.11021 6.33849C9.2543 5.55044 10.6108 5.12847 12 5.12847C13.3892 5.12847 14.7457 5.55044 15.8898 6.33849C17.0339 7.12655 17.9116 8.24353 18.4068 9.54152C18.9019 10.8395 18.9912 12.2573 18.6627 13.6071C18.3342 14.957 17.6034 16.1752 16.5671 17.1005V17.1005Z',
    },
    upgrade_account: {
        path: 'M17.143 8.51257L18.0532 10.2048L20 10.4383L18.5715 11.7092L18.8572 13.5893L17.143 12.5316L15.4287 13.5893L15.7144 11.7092L14.2859 10.4383L16.2858 10.2048L17.143 8.51257Z M15.4283 19.7942H14.2854V16.9738C14.2846 16.226 13.9833 15.5092 13.4476 14.9804C12.912 14.4517 12.1858 14.1543 11.4284 14.1534H7.99989C7.24243 14.1543 6.51624 14.4517 5.98063 14.9804C5.44502 15.5092 5.14372 16.226 5.14283 16.9738V19.7942H4V16.9738C4.00124 15.9269 4.42305 14.9233 5.17291 14.1831C5.92277 13.4429 6.93944 13.0265 7.99989 13.0252H11.4284C12.4888 13.0265 13.5055 13.4429 14.2554 14.1831C15.0052 14.9233 15.427 15.9269 15.4283 16.9738V19.7942Z M9.71376 5.12815C10.2788 5.12815 10.8312 5.29357 11.3011 5.60347C11.7709 5.91338 12.1371 6.35387 12.3534 6.86922C12.5696 7.38458 12.6262 7.95167 12.5159 8.49877C12.4057 9.04587 12.1336 9.54841 11.734 9.94285C11.3344 10.3373 10.8254 10.6059 10.2712 10.7147C9.71693 10.8236 9.14247 10.7677 8.62041 10.5542C8.09835 10.3408 7.65214 9.97927 7.3382 9.51546C7.02426 9.05165 6.8567 8.50636 6.8567 7.94854C6.8567 7.20053 7.15771 6.48315 7.69351 5.95423C8.22932 5.4253 8.95602 5.12815 9.71376 5.12815V5.12815ZM9.71376 4C8.92266 4 8.14932 4.23158 7.49154 4.66545C6.83376 5.09932 6.32109 5.716 6.01834 6.4375C5.7156 7.159 5.63639 7.95292 5.79073 8.71886C5.94506 9.4848 6.32602 10.1884 6.88541 10.7406C7.44481 11.2928 8.15752 11.6689 8.93342 11.8212C9.70933 11.9736 10.5136 11.8954 11.2445 11.5965C11.9753 11.2977 12.6 10.7916 13.0396 10.1422C13.4791 9.49289 13.7137 8.72948 13.7137 7.94854C13.7137 6.90132 13.2922 5.89699 12.5421 5.1565C11.792 4.41601 10.7746 4 9.71376 4V4Z',
    },
    sign_out: {
        path: 'M6.14286 20H13C13.303 19.9997 13.5935 19.8791 13.8077 19.6649C14.022 19.4506 14.1425 19.1601 14.1429 18.8571V17.1429H13V18.8571H6.14286V5.14286H13V6.85714H14.1429V5.14286C14.1425 4.83986 14.022 4.54937 13.8077 4.33512C13.5935 4.12087 13.303 4.00035 13 4H6.14286C5.83986 4.00035 5.54937 4.12087 5.33512 4.33512C5.12087 4.54937 5.00035 4.83986 5 5.14286V18.8571C5.00035 19.1601 5.12087 19.4506 5.33512 19.6649C5.54937 19.8791 5.83986 19.9997 6.14286 20V20Z M14.4776 14.6206L16.5268 12.5714H8.42847V11.4286H16.5268L14.4776 9.37941L15.2856 8.57141L18.7142 12L15.2856 15.4286L14.4776 14.6206Z',
    },
    profile_settings: {
        path: 'M19.7773 7.2215H17.4345C17.1488 5.90722 16.0059 4.93579 14.6345 4.93579C13.2631 4.93579 12.1202 5.90722 11.8345 7.2215H3.77734V8.36436H11.8345C12.1202 9.67865 13.2631 10.6501 14.6345 10.6501C16.0059 10.6501 17.1488 9.67865 17.4345 8.36436H19.7773V7.2215ZM14.6345 9.50722C13.6631 9.50722 12.9202 8.76436 12.9202 7.79293C12.9202 6.8215 13.6631 6.07865 14.6345 6.07865C15.6059 6.07865 16.3488 6.8215 16.3488 7.79293C16.3488 8.76436 15.6059 9.50722 14.6345 9.50722Z M3.77734 16.3644H6.1202C6.40592 17.6786 7.54877 18.6501 8.9202 18.6501C10.2916 18.6501 11.4345 17.6786 11.7202 16.3644H19.7773V15.2215H11.7202C11.4345 13.9072 10.2916 12.9358 8.9202 12.9358C7.54877 12.9358 6.40592 13.9072 6.1202 15.2215H3.77734V16.3644ZM8.9202 14.0786C9.89163 14.0786 10.6345 14.8215 10.6345 15.7929C10.6345 16.7644 9.89163 17.5072 8.9202 17.5072C7.94877 17.5072 7.20592 16.7644 7.20592 15.7929C7.20592 14.8215 7.94877 14.0786 8.9202 14.0786Z',
    },
    actions: {
        path: 'M28.359 20q-2.344 0-4.219 1.133t-3.008 3.008-1.133 4.219q0 2.266 1.133 4.18t3.008 3.008 4.219 1.094q2.266 0 4.18-1.094t3.008-3.008 1.094-4.18q0-2.344-1.094-4.219t-3.008-3.008-4.18-1.133zM31.094 32.266l-3.594-3.594v-5.313h1.641v4.609l3.125 3.125zM30 5h-5.313q-0.547-1.484-1.797-2.422t-2.891-0.938-2.891 0.938-1.797 2.422h-5.313q-1.406 0-2.383 0.977t-0.977 2.383v25q0 1.328 0.977 2.305t2.383 0.977h10.156q-1.484-1.406-2.344-3.281h-7.813v-25h3.359v5h13.281v-5h3.359v8.438q1.719 0.234 3.359 1.016v-9.453q0-1.406-0.977-2.383t-2.383-0.977zM20 8.359q-0.703 0-1.172-0.508t-0.469-1.211q0-0.625 0.469-1.133t1.172-0.508 1.172 0.508 0.469 1.133q0 0.703-0.469 1.211t-1.172 0.508z',
    },
    add: {
        path: 'M 13.375 10.625 L 13.375 1 L 10.625 1 L 10.625 10.625 L 1 10.625 L 1 13.375 L 10.625 13.375 L 10.625 23 L 13.375 23 L 13.375 13.375 L 23 13.375 L 23 10.625 L 13.375 10.625 Z',
    },
    aerospace: {
        path: 'M 5.156 17.729 L 11.439 11.446 L 12.55 12.557 L 6.267 18.84 L 5.156 17.729 Z  M 12.786 22.999 C 12.687 23 12.588 22.981 12.496 22.944 C 12.234 22.84 12.048 22.603 12.009 22.324 L 11.223 16.824 L 12.794 16.604 L 13.383 20.744 L 15.929 18.694 L 15.929 12.786 C 15.928 12.577 16.01 12.376 16.157 12.228 L 19.354 9.03 C 20.685 7.708 21.432 5.909 21.429 4.033 L 21.429 2.572 L 19.967 2.572 C 18.092 2.569 16.292 3.315 14.97 4.646 L 11.773 7.844 C 11.625 7.991 11.424 8.073 11.215 8.072 L 5.307 8.072 L 3.256 10.633 L 7.397 11.222 L 7.177 12.794 L 1.677 12.008 C 1.398 11.969 1.161 11.783 1.056 11.521 C 0.951 11.257 0.996 10.956 1.174 10.735 L 4.317 6.807 C 4.464 6.616 4.689 6.503 4.93 6.5 L 10.893 6.5 L 13.855 3.531 C 15.472 1.904 17.674 0.993 19.967 1.001 L 21.429 1.001 C 22.296 1.001 23 1.704 23 2.572 L 23 4.033 C 23.008 6.327 22.097 8.528 20.47 10.146 L 17.5 13.108 L 17.5 19.071 C 17.499 19.31 17.389 19.536 17.202 19.684 L 13.273 22.826 C 13.135 22.937 12.964 22.998 12.786 22.999 Z',
    },
    agriculture: {
        path: 'M 15.793 2.517 L 15.793 4.479 L 12.759 7.513 L 12.759 1 L 11.241 1 L 11.241 7.513 L 8.207 4.479 L 8.207 2.517 L 6.69 2.517 L 6.69 14.655 C 6.694 17.292 8.632 19.527 11.241 19.905 L 11.241 23 L 12.759 23 L 12.759 19.905 C 15.368 19.527 17.306 17.292 17.31 14.655 L 17.31 2.517 L 15.793 2.517 Z  M 11.241 18.371 C 9.477 18.009 8.209 16.457 8.207 14.655 L 8.207 12.693 L 11.241 15.728 L 11.241 18.371 Z  M 11.241 13.582 L 8.207 10.548 L 8.207 6.624 L 11.241 9.659 L 11.241 13.582 Z  M 12.759 9.659 L 15.793 6.624 L 15.793 10.548 L 12.759 13.582 L 12.759 9.659 Z  M 12.759 18.371 L 12.759 15.728 L 15.793 12.693 L 15.793 14.655 C 15.791 16.457 14.523 18.009 12.759 18.371 L 12.759 18.371 Z',
    },
    annotation: {
        path: 'M 38.05 20.001 L 38.05 20.001 C 38.05 29.968 29.969 38.051 20 38.051 L 1.95 38.051 L 1.95 19.999 C 1.95 10.032 10.032 1.949 20 1.949 C 29.969 1.949 38.052 10.032 38.05 20.001 Z  M 39 20 C 39 25.035 36.996 29.871 33.433 33.433 C 29.871 36.996 25.035 39 20 39 C 20 39 20 39 20 39 L 1 39 L 1 20 C 1 14.965 3.004 10.129 6.567 6.567 C 10.129 3.004 14.965 1 20 1 C 25.035 1 29.871 3.004 33.433 6.567 C 36.996 10.12 39 14.965 39 20 C 39 20 39 20 39 20 L 39 20 Z',
    },
    annotation_feature: {
        path: 'M 20 3.271 C 29.224 3.271 36.729 10.776 36.729 20 C 36.729 29.224 29.224 36.729 20 36.729 L 3.271 36.729 L 3.271 20 C 3.271 10.776 10.776 3.271 20 3.271 Z  M 20 1 C 9.506 1 1 9.506 1 20 L 1 39 L 20 39 C 30.494 39 39 30.494 39 20 C 39 9.506 30.496 1 20 1 Z  M 20.152 10.085 C 14.617 10.085 10.085 14.617 10.085 20.152 C 10.085 25.688 14.617 30.219 20.152 30.219 C 25.688 30.219 30.219 25.688 30.219 20.152 C 30.219 14.617 25.69 10.085 20.152 10.085 Z  M 20.152 26.349 C 16.744 26.349 13.955 23.561 13.955 20.152 C 13.955 16.744 16.744 13.955 20.152 13.955 C 23.561 13.955 26.349 16.744 26.349 20.152 C 26.349 23.561 23.561 26.349 20.152 26.349 Z  M 18.035 20.307 C 18.035 19.053 19.053 18.035 20.307 18.035 C 21.56 18.035 22.578 19.053 22.578 20.307 C 22.578 21.56 21.56 22.578 20.307 22.578 C 19.053 22.578 18.035 21.56 18.035 20.307 Z',
    },
    annotation_part: {
        path: 'M 20 3.271 C 29.224 3.271 36.729 10.776 36.729 20 C 36.729 29.224 29.224 36.729 20 36.729 L 3.271 36.729 L 3.271 20 C 3.271 10.776 10.776 3.271 20 3.271 Z  M 20 1 C 9.506 1 1 9.506 1 20 L 1 39 L 20 39 C 30.494 39 39 30.494 39 20 C 39 9.506 30.496 1 20 1 Z  M 20.152 10.085 C 14.617 10.085 10.085 14.617 10.085 20.152 C 10.085 25.688 14.617 30.219 20.152 30.219 C 25.688 30.219 30.219 25.688 30.219 20.152 C 30.219 14.617 25.69 10.085 20.152 10.085 Z  M 20.152 26.349 C 16.744 26.349 13.955 23.561 13.955 20.152 C 13.955 16.744 16.744 13.955 20.152 13.955 C 23.561 13.955 26.349 16.744 26.349 20.152 C 26.349 23.561 23.561 26.349 20.152 26.349 Z',
    },
    arrow_down: {
        path: 'M 20.8 14.2 L 19.59 12.99 L 12.88 19.59 L 12.88 1 L 11.12 1 L 11.12 19.59 L 4.41 12.99 L 3.2 14.2 L 12 23 L 20.8 14.2 Z',
    },
    arrow_left: {
        path: 'M 9.8 20.8 L 11.01 19.59 L 4.41 12.88 L 23 12.88 L 23 11.12 L 4.41 11.12 L 11.01 4.41 L 9.8 3.2 L 1 12 L 9.8 20.8 Z',
    },
    arrow_right: {
        path: 'M 14.2 3.2 L 12.99 4.41 L 19.59 11.12 L 1 11.12 L 1 12.88 L 19.59 12.88 L 12.99 19.59 L 14.2 20.8 L 23 12 L 14.2 3.2 Z',
    },
    arrow_up: {
        path: 'M 3.2 9.8 L 4.41 11.01 L 11.12 4.41 L 11.12 23 L 12.88 23 L 12.88 4.41 L 19.59 11.01 L 20.8 9.8 L 12 1 L 3.2 9.8 Z',
    },
    assembly: {
        path: 'M6.7 4.34v6.7h16.7v-6.7zm15.18 5.19H8.21V5.86h13.67v3.67zM6.7 19.73h16.7v-6.7H6.7zm1.52-5.18h13.67v3.66H8.2zM2.12 4.18H.6v15.64h1.52v-3.08h2.65v-1.52H2.12v-6.2h2.65V7.5H2.12zm0 0',
        customStroke: '0.5px',
    },
    sub_assembly: {
        path: 'M 6.7 4.34 M 6.7 15.73 h 16.7 v -6.7 H 6.7 z m 1.52 -5.18 h 13.67 v 3.66 H 8.2 z m -6.1 -6.37 H 0.6 V 19.82 h 1.52 v -7.08 h 2.65 v -1.52 H 2.12 l 0 -7.04 M 2.12 4.18',
        customStroke: '0.5px',
    },
    markup: {
        path: 'M 8.246 37.288 C 6.307 37.288 4.486 36.534 3.12 35.167 C 0.293 32.341 0.293 27.742 3.12 24.916 L 22.492 5.545 C 24.318 3.719 26.747 2.712 29.33 2.712 C 31.912 2.712 34.341 3.718 36.167 5.544 C 37.994 7.369 39 9.798 39 12.381 C 39 14.964 37.994 17.391 36.169 19.219 L 22.448 32.943 C 22.299 33.091 22.099 33.174 21.887 33.174 C 21.675 33.174 21.477 33.091 21.327 32.943 C 21.018 32.634 21.018 32.132 21.327 31.823 L 35.048 18.099 C 36.574 16.571 37.415 14.541 37.415 12.381 C 37.415 10.221 36.574 8.191 35.046 6.663 C 33.52 5.137 31.488 4.296 29.328 4.296 C 27.168 4.296 25.138 5.137 23.61 6.665 L 4.239 26.035 C 3.169 27.106 2.58 28.528 2.58 30.042 C 2.58 31.555 3.169 32.977 4.239 34.048 C 5.308 35.117 6.732 35.706 8.247 35.706 C 9.763 35.706 11.185 35.117 12.253 34.049 C 12.253 34.049 30.847 15.399 30.869 15.375 C 31.32 14.905 31.562 14.288 31.548 13.637 C 31.535 12.986 31.269 12.379 30.801 11.928 C 30.346 11.491 29.746 11.25 29.113 11.25 C 28.441 11.25 27.817 11.516 27.353 11.998 L 13.62 25.731 C 13.471 25.88 13.272 25.963 13.059 25.963 C 12.847 25.963 12.649 25.88 12.499 25.731 C 12.19 25.423 12.19 24.921 12.499 24.612 L 26.221 10.889 C 26.977 10.102 28.004 9.667 29.108 9.667 C 30.153 9.667 31.143 10.064 31.893 10.787 C 32.668 11.531 33.106 12.532 33.128 13.605 C 33.149 14.679 32.752 15.697 32.007 16.471 C 31.973 16.509 31.933 16.547 31.892 16.587 L 13.371 35.167 C 12.005 36.534 10.184 37.288 8.246 37.288 L 8.246 37.288 L 8.246 37.288 Z',
    },
    drawing: {
        path: 'M 8.44 21.316 C 7.681 20.539 7.027 19.639 6.466 18.712 C 6.136 18.163 5.893 17.434 5.317 17.101 C 4.009 16.348 2.47 17.68 3.034 19.084 C 3.598 20.482 4.597 21.817 5.572 22.951 C 5.872 23.302 6.832 24.022 6.784 24.514 C 6.712 25.261 5.965 26.161 5.632 26.821 C 4.657 28.756 3.394 30.739 2.665 32.776 C 2.488 33.268 2.683 33.904 2.707 34.414 C 2.773 35.887 2.74 37.594 3.082 39.028 C 4.303 38.638 5.494 37.558 6.58 36.883 C 7.135 36.538 7.915 36.19 8.32 35.671 C 9.241 34.489 9.799 32.776 10.468 31.435 C 11.029 30.316 11.815 29.14 12.163 27.937 C 14.179 28.489 15.997 29.284 18.115 29.488 C 23.446 30.004 28.981 28.264 32.923 24.592 C 34.378 23.236 35.623 21.706 36.613 19.975 C 37.039 19.231 37.48 18.319 36.895 17.521 C 36.361 16.792 35.257 16.663 34.567 17.251 C 34.135 17.62 33.931 18.238 33.637 18.712 C 33.061 19.636 32.422 20.536 31.66 21.316 C 30.463 18.445 28.864 15.688 27.472 12.907 C 27.001 11.962 26.38 10.996 26.023 10.003 C 25.831 9.475 26.329 8.572 26.368 7.996 C 26.476 6.442 26.134 4.876 25.204 3.604 C 22.936 0.508 18.349 0.16 15.586 2.794 C 14.179 4.132 13.6 6.097 13.732 7.996 C 13.771 8.563 14.236 9.397 14.104 9.931 C 13.825 11.026 12.985 12.19 12.478 13.204 C 11.137 15.886 9.595 18.547 8.44 21.316 M 19.456 4.225 C 23.539 3.544 24.682 9.751 20.572 10.489 C 16.579 11.209 15.43 4.894 19.456 4.225 M 26.449 25.111 C 24.709 25.588 23.14 26.188 21.316 26.362 C 18.565 26.623 16.237 25.819 13.651 25.111 C 13.972 24.094 14.641 23.092 15.121 22.135 L 18.172 16.033 C 18.709 14.959 19.057 13.294 20.563 13.675 C 20.869 13.753 20.986 14.143 21.109 14.395 L 22.15 16.48 L 24.979 22.135 C 25.465 23.107 26.083 24.088 26.449 25.111 M 29.35 30.691 C 29.563 31.888 30.499 33.175 31.042 34.264 C 31.279 34.738 31.483 35.395 31.852 35.782 C 32.566 36.529 33.763 37.03 34.633 37.591 C 35.371 38.068 36.175 38.761 37.015 39.028 L 37.324 35.233 L 37.456 32.851 L 34.711 27.343 C 34.03 27.574 33.43 28.249 32.848 28.672 C 31.774 29.452 30.58 30.181 29.353 30.691 Z',
    },
    attachment: {
        path: 'M 21.473 14.27 L 9.73 2.527 C 7.772 0.491 4.562 0.491 2.527 2.448 C 0.491 4.406 0.491 7.694 2.527 9.651 C 2.527 9.651 2.605 9.73 2.605 9.73 L 4.797 12 L 5.893 10.904 L 3.623 8.633 C 2.292 7.302 2.292 5.032 3.623 3.701 C 4.954 2.37 7.224 2.292 8.555 3.623 C 8.555 3.623 8.555 3.623 8.633 3.701 L 20.299 15.367 C 21.708 16.698 21.708 18.968 20.377 20.299 C 19.046 21.708 16.776 21.708 15.445 20.377 C 15.445 20.377 15.445 20.377 15.367 20.299 L 9.573 14.505 C 8.79 13.722 8.868 12.47 9.573 11.765 C 10.356 11.06 11.53 11.06 12.313 11.765 L 15.523 14.975 L 16.619 13.879 C 16.619 13.879 13.331 10.591 13.331 10.591 C 11.922 9.26 9.73 9.338 8.399 10.747 C 7.146 12.078 7.146 14.192 8.399 15.601 L 14.27 21.473 C 16.228 23.509 19.438 23.509 21.473 21.552 C 23.509 19.594 23.509 16.306 21.473 14.27 C 21.473 14.349 21.473 14.27 21.473 14.27 L 21.473 14.27 Z',
    },
    automation: {
        path: 'M 11.082 12.916 C 7.797 12.916 5.124 10.243 5.124 6.959 C 5.124 3.673 7.797 1 11.082 1 C 11.335 1 11.541 1.206 11.541 1.459 L 11.541 12.459 C 11.541 12.712 11.335 12.916 11.082 12.916 Z  M 10.624 1.937 C 8.035 2.169 6.041 4.33 6.041 6.959 C 6.041 9.586 8.035 11.747 10.624 11.98 L 10.624 1.937 Z  M 2.374 23 C 2.121 23 1.916 22.794 1.916 22.541 C 1.916 17.487 6.028 13.375 11.082 13.375 C 11.335 13.375 11.541 13.581 11.541 13.834 L 11.541 22.541 C 11.541 22.794 11.335 23 11.082 23 L 2.374 23 Z  M 10.624 22.084 L 10.624 14.304 C 6.429 14.535 3.076 17.888 2.845 22.084 L 10.624 22.084 Z  M 12.916 12.916 C 12.665 12.916 12.459 12.712 12.457 12.461 C 12.456 12.208 12.661 12.002 12.913 12 C 13.066 11.999 13.22 11.991 13.374 11.976 L 13.374 10.974 C 13.374 10.758 13.521 10.575 13.73 10.527 C 14.131 10.435 14.511 10.276 14.858 10.056 C 14.932 10.009 15.017 9.984 15.104 9.984 C 15.226 9.984 15.341 10.032 15.429 10.118 L 16.139 10.829 C 16.375 10.633 16.59 10.417 16.787 10.182 L 16.075 9.47 C 15.922 9.317 15.897 9.082 16.013 8.9 C 16.234 8.552 16.392 8.173 16.485 7.771 C 16.532 7.564 16.716 7.416 16.931 7.416 L 17.934 7.416 C 17.948 7.264 17.956 7.108 17.957 6.956 C 17.956 6.805 17.948 6.653 17.934 6.5 L 16.931 6.5 C 16.716 6.5 16.532 6.354 16.485 6.145 C 16.392 5.743 16.233 5.364 16.013 5.016 C 15.899 4.836 15.925 4.597 16.075 4.446 L 16.787 3.734 C 16.59 3.499 16.375 3.283 16.139 3.087 L 15.429 3.797 C 15.341 3.885 15.226 3.934 15.104 3.934 C 15.017 3.934 14.932 3.909 14.858 3.863 C 14.51 3.642 14.131 3.483 13.729 3.39 C 13.52 3.342 13.374 3.158 13.374 2.944 L 13.374 1.941 C 13.22 1.926 13.066 1.918 12.913 1.916 C 12.66 1.915 12.456 1.709 12.457 1.456 C 12.459 1.204 12.665 1 12.916 1 C 13.251 1.002 13.584 1.032 13.911 1.09 C 14.131 1.127 14.291 1.317 14.291 1.541 L 14.291 2.594 C 14.544 2.675 14.792 2.779 15.028 2.902 L 15.773 2.155 C 15.86 2.068 15.974 2.02 16.097 2.02 C 16.193 2.02 16.285 2.05 16.364 2.105 C 16.908 2.493 17.38 2.966 17.767 3.509 C 17.898 3.692 17.877 3.94 17.718 4.099 L 16.971 4.845 C 17.096 5.082 17.2 5.329 17.28 5.584 L 18.333 5.584 C 18.556 5.584 18.746 5.743 18.785 5.963 C 18.842 6.292 18.872 6.626 18.874 6.956 C 18.872 7.29 18.842 7.625 18.785 7.954 C 18.746 8.174 18.556 8.334 18.333 8.334 L 17.28 8.334 C 17.2 8.588 17.096 8.835 16.972 9.071 L 17.719 9.819 C 17.877 9.977 17.899 10.226 17.769 10.408 C 17.381 10.952 16.909 11.425 16.364 11.812 C 16.287 11.867 16.194 11.898 16.098 11.898 C 15.976 11.898 15.86 11.849 15.774 11.763 L 15.028 11.016 C 14.791 11.14 14.544 11.244 14.29 11.324 L 14.29 12.377 C 14.29 12.6 14.131 12.789 13.911 12.828 C 13.581 12.885 13.246 12.916 12.918 12.918 C 12.918 12.918 12.916 12.918 12.916 12.918 L 12.916 12.918 L 12.916 12.916 Z  M 12.916 9.25 C 12.663 9.25 12.457 9.044 12.457 8.791 C 12.457 8.538 12.663 8.334 12.916 8.334 C 13.674 8.334 14.291 7.716 14.291 6.959 C 14.291 6.2 13.674 5.584 12.916 5.584 C 12.663 5.584 12.457 5.378 12.457 5.125 C 12.457 4.872 12.663 4.666 12.916 4.666 C 14.179 4.666 15.207 5.694 15.207 6.959 C 15.207 8.222 14.179 9.25 12.916 9.25 Z  M 21.624 23 C 21.373 23 21.168 22.796 21.166 22.544 C 21.164 22.239 21.144 21.931 21.108 21.625 L 19.653 21.625 C 19.436 21.625 19.247 21.471 19.203 21.259 C 19.089 20.704 18.9 20.167 18.644 19.664 C 18.553 19.486 18.588 19.272 18.729 19.131 L 19.82 18.042 C 19.314 17.264 18.687 16.585 17.954 16.018 L 16.911 17.062 C 16.826 17.148 16.71 17.195 16.587 17.195 C 16.5 17.195 16.414 17.171 16.34 17.124 C 15.811 16.788 15.237 16.532 14.631 16.364 C 14.433 16.309 14.294 16.128 14.294 15.922 L 14.294 14.41 C 13.84 14.332 13.378 14.293 12.916 14.291 C 12.793 14.291 12.679 14.244 12.591 14.157 C 12.505 14.071 12.457 13.955 12.457 13.832 C 12.457 13.581 12.663 13.375 12.916 13.375 C 13.565 13.376 14.216 13.446 14.85 13.582 C 15.06 13.627 15.212 13.816 15.212 14.03 L 15.212 15.581 C 15.664 15.73 16.101 15.924 16.516 16.159 L 17.585 15.089 C 17.671 15.003 17.787 14.956 17.91 14.956 C 18.005 14.956 18.096 14.984 18.174 15.039 C 19.246 15.792 20.128 16.746 20.797 17.874 C 20.904 18.055 20.874 18.284 20.726 18.432 L 19.607 19.549 C 19.776 19.923 19.912 20.311 20.017 20.709 L 21.507 20.709 C 21.732 20.709 21.922 20.869 21.958 21.091 C 22.038 21.569 22.081 22.056 22.084 22.539 C 22.086 22.792 21.881 22.998 21.628 23 C 21.628 23 21.628 23 21.627 23 L 21.624 23 Z  M 16.582 23 C 16.329 23 16.124 22.794 16.124 22.541 C 16.124 20.772 14.685 19.334 12.916 19.334 C 12.663 19.334 12.457 19.128 12.457 18.875 C 12.457 18.622 12.663 18.416 12.916 18.416 C 15.19 18.416 17.041 20.267 17.041 22.541 C 17.041 22.794 16.835 23 16.582 23 Z',
        customStroke: '0.5px',
    },
    automotive: {
        path: 'M 22.481 10.401 L 16.408 8.216 L 13.862 5.026 C 13.415 4.48 12.746 4.162 12.039 4.162 L 5.754 4.162 C 4.975 4.166 4.249 4.554 3.813 5.199 L 1.684 8.342 C 1.242 8.988 1.004 9.752 1 10.534 L 1 16.734 C 1 17.167 1.352 17.519 1.786 17.519 L 3.467 17.519 C 3.839 18.888 5.082 19.838 6.5 19.838 C 7.918 19.838 9.161 18.888 9.533 17.519 L 14.467 17.519 C 14.839 18.888 16.082 19.838 17.5 19.838 C 18.918 19.838 20.161 18.888 20.533 17.519 L 22.214 17.519 C 22.648 17.519 23 17.167 23 16.734 L 23 11.139 C 23 10.808 22.793 10.513 22.481 10.401 L 22.481 10.401 Z  M 6.5 18.305 C 5.632 18.305 4.929 17.601 4.929 16.734 C 4.929 15.866 5.632 15.162 6.5 15.162 C 7.368 15.162 8.071 15.866 8.071 16.734 C 8.071 17.601 7.368 18.305 6.5 18.305 Z  M 17.5 18.305 C 16.632 18.305 15.929 17.601 15.929 16.734 C 15.929 15.866 16.632 15.162 17.5 15.162 C 18.368 15.162 19.071 15.866 19.071 16.734 C 19.071 17.601 18.368 18.305 17.5 18.305 Z  M 21.429 15.948 L 20.533 15.948 C 20.161 14.579 18.918 13.629 17.5 13.629 C 16.082 13.629 14.839 14.579 14.467 15.948 L 9.533 15.948 C 9.161 14.579 7.918 13.629 6.5 13.629 C 5.082 13.629 3.839 14.579 3.467 15.948 L 2.571 15.948 L 2.571 10.534 C 2.571 10.061 2.714 9.598 2.98 9.206 L 5.109 6.064 C 5.259 5.853 5.503 5.73 5.761 5.734 L 12.047 5.734 C 12.281 5.733 12.503 5.837 12.652 6.016 L 15.324 9.371 C 15.416 9.483 15.535 9.57 15.669 9.623 L 21.429 11.689 L 21.429 15.948 Z',
    },
    blockquote: {
        path: 'M 12.916 20.251 C 12.663 20.251 12.459 20.046 12.459 19.793 C 12.459 19.54 12.663 19.334 12.916 19.334 C 17.324 19.334 21.091 16.148 21.914 11.91 C 20.971 13.116 19.532 13.832 17.959 13.832 C 15.178 13.832 12.916 11.571 12.916 8.791 C 12.916 6.01 15.178 3.749 17.959 3.749 C 20.739 3.749 23 6.01 23 8.791 L 23 10.168 C 23 15.727 18.476 20.251 12.916 20.251 Z  M 17.959 4.666 C 15.684 4.666 13.834 6.516 13.834 8.791 C 13.834 11.065 15.684 12.916 17.959 12.916 C 20.233 12.916 22.084 11.065 22.084 8.791 C 22.084 6.516 20.233 4.666 17.959 4.666 Z  M 1.459 20.251 C 1.206 20.251 1 20.046 1 19.793 C 1 19.54 1.206 19.334 1.459 19.334 C 5.865 19.334 9.632 16.148 10.455 11.91 C 9.511 13.117 8.073 13.832 6.5 13.832 C 3.72 13.832 1.459 11.571 1.459 8.791 C 1.459 6.01 3.72 3.749 6.5 3.749 C 9.28 3.749 11.541 6.01 11.541 8.791 C 11.541 8.794 11.541 10.168 11.541 10.168 C 11.541 15.727 7.018 20.251 1.459 20.251 Z  M 6.5 4.666 C 4.226 4.666 2.375 6.516 2.375 8.791 C 2.375 11.065 4.226 12.916 6.5 12.916 C 8.774 12.916 10.625 11.065 10.625 8.791 C 10.625 6.516 8.774 4.666 6.5 4.666 Z',
        customStroke: '0.5px',
    },
    bold: {
        path: 'M 14.462 23 L 3.156 23 L 3.156 1 L 13.545 1 C 16.046 1 18.319 2.453 19.369 4.723 C 20.419 6.993 20.054 9.667 18.434 11.572 C 20.557 13.27 21.38 16.122 20.488 18.69 C 19.595 21.258 17.181 22.985 14.462 23 Z  M 6.823 19.333 L 14.438 19.333 C 15.956 19.333 17.188 18.102 17.188 16.583 C 17.188 15.065 15.956 13.833 14.438 13.833 L 6.823 13.833 L 6.823 19.333 Z  M 6.823 10.167 L 13.545 10.167 C 15.064 10.167 16.295 8.935 16.295 7.417 C 16.295 5.898 15.064 4.667 13.545 4.667 L 6.823 4.667 L 6.823 10.167 Z',
    },
    browsers: {
        path: 'M 7.875 23 C 7.117 23 6.5 22.383 6.5 21.625 L 6.5 17.5 L 2.375 17.5 C 1.617 17.5 1 16.883 1 16.125 L 1 2.375 C 1 1.617 1.617 1 2.375 1 L 16.125 1 C 16.883 1 17.5 1.617 17.5 2.375 L 17.5 6.5 L 21.625 6.5 C 22.383 6.5 23 7.117 23 7.875 L 23 21.625 C 23 22.383 22.383 23 21.625 23 L 7.875 23 L 7.875 23 Z  M 7.875 7.416 C 7.622 7.416 7.416 7.622 7.416 7.875 L 7.416 21.625 C 7.416 21.878 7.622 22.084 7.875 22.084 L 21.625 22.084 C 21.878 22.084 22.084 21.878 22.084 21.625 L 22.084 7.875 C 22.084 7.622 21.878 7.416 21.625 7.416 L 7.875 7.416 L 7.875 7.416 Z  M 2.375 1.916 C 2.122 1.916 1.916 2.122 1.916 2.375 L 1.916 16.125 C 1.916 16.378 2.122 16.584 2.375 16.584 L 6.5 16.584 L 6.5 7.875 C 6.5 7.117 7.117 6.5 7.875 6.5 L 16.584 6.5 L 16.584 2.375 C 16.584 2.122 16.378 1.916 16.125 1.916 L 2.375 1.916 L 2.375 1.916 Z',
        customStroke: '0.5px',
    },
    caret_down: {
        path: 'M 12 17.957 L 1 7.506 L 2.54 6.043 L 12 15.03 L 21.46 6.043 L 23 7.506 L 12 17.957 Z',
    },
    caret_left: {
        path: 'M 6.043 12 L 16.494 1 L 17.957 2.54 L 8.97 12 L 17.957 21.46 L 16.494 23 L 6.043 12 Z',
    },
    caret_right: {
        path: 'M 17.957 12 L 7.506 23 L 6.043 21.46 L 15.03 12 L 6.043 2.54 L 7.506 1 L 17.957 12 Z',
    },
    caret_up: {
        path: 'M 12 6.043 L 23 16.494 L 21.46 17.957 L 12 8.97 L 2.54 17.957 L 1 16.494 L 12 6.043 Z',
    },
    camera: {
        path: 'M 15.929 19.857 L 2.571 19.857 C 1.704 19.857 1 19.154 1 18.286 L 1 5.714 C 1 4.846 1.704 4.143 2.571 4.143 L 15.929 4.143 C 16.796 4.143 17.5 4.846 17.5 5.714 L 17.5 8.904 L 21.759 5.864 C 21.998 5.693 22.312 5.671 22.573 5.804 C 22.834 5.938 22.999 6.207 23 6.5 L 23 17.5 C 22.999 17.793 22.834 18.062 22.573 18.196 C 22.312 18.329 21.998 18.307 21.759 18.136 L 17.5 15.096 L 17.5 18.286 C 17.5 19.154 16.796 19.857 15.929 19.857 Z  M 2.571 5.714 L 2.571 18.286 L 15.929 18.286 L 15.929 13.571 C 15.93 13.278 16.095 13.01 16.356 12.876 C 16.617 12.742 16.931 12.765 17.17 12.935 L 21.429 15.976 L 21.429 8.024 L 17.17 11.065 C 16.931 11.235 16.617 11.258 16.356 11.124 C 16.095 10.99 15.93 10.722 15.929 10.429 L 15.929 5.714 L 2.571 5.714 Z',
    },
    categories: {
        path: 'M 4.74 4.143 L 5.094 4.842 L 5.526 5.714 L 8.857 5.714 L 8.857 9.643 L 2.571 9.643 L 2.571 4.143 L 4.74 4.143 Z  M 5.227 2.571 L 1.786 2.571 C 1.352 2.571 1 2.923 1 3.357 L 1 10.429 C 1 10.863 1.352 11.214 1.786 11.214 L 9.643 11.214 C 10.077 11.214 10.429 10.863 10.429 10.429 L 10.429 4.929 C 10.429 4.495 10.077 4.143 9.643 4.143 L 6.5 4.143 L 5.934 3.004 C 5.8 2.737 5.526 2.569 5.227 2.571 Z  M 17.311 4.143 L 17.665 4.842 L 18.097 5.714 L 21.429 5.714 L 21.429 9.643 L 15.143 9.643 L 15.143 4.143 L 17.311 4.143 Z  M 17.799 2.571 L 14.357 2.571 C 13.923 2.571 13.571 2.923 13.571 3.357 L 13.571 10.429 C 13.571 10.863 13.923 11.214 14.357 11.214 L 22.214 11.214 C 22.648 11.214 23 10.863 23 10.429 L 23 4.929 C 23 4.495 22.648 4.143 22.214 4.143 L 19.071 4.143 L 18.506 3.004 C 18.371 2.737 18.097 2.569 17.799 2.571 Z  M 4.74 14.357 L 5.094 15.056 L 5.526 15.929 L 8.857 15.929 L 8.857 19.857 L 2.571 19.857 L 2.571 14.357 L 4.74 14.357 Z  M 5.227 12.786 L 1.786 12.786 C 1.352 12.786 1 13.138 1 13.571 L 1 20.643 C 1 21.077 1.352 21.429 1.786 21.429 L 9.643 21.429 C 10.077 21.429 10.429 21.077 10.429 20.643 L 10.429 15.143 C 10.429 14.709 10.077 14.357 9.643 14.357 L 6.5 14.357 L 5.934 13.218 C 5.8 12.951 5.526 12.784 5.227 12.786 Z  M 17.311 14.357 L 17.665 15.056 L 18.097 15.929 L 21.429 15.929 L 21.429 19.857 L 15.143 19.857 L 15.143 14.357 L 17.311 14.357 Z  M 17.799 12.786 L 14.357 12.786 C 13.923 12.786 13.571 13.138 13.571 13.571 L 13.571 20.643 C 13.571 21.077 13.923 21.429 14.357 21.429 L 22.214 21.429 C 22.648 21.429 23 21.077 23 20.643 L 23 15.143 C 23 14.709 22.648 14.357 22.214 14.357 L 19.071 14.357 L 18.506 13.218 C 18.371 12.951 18.097 12.784 17.799 12.786 Z',
    },
    certifications: {
        path: 'M 18.286 12.786 L 19.788 15.695 L 23 16.162 L 20.643 18.286 L 21.249 21.429 L 18.286 19.661 L 15.323 21.429 L 15.929 18.286 L 13.571 16.162 L 16.871 15.695 L 18.286 12.786 L 18.286 12.786 Z  M 4.143 12 L 8.857 12 L 8.857 13.571 L 4.143 13.571 L 4.143 12 Z  M 4.143 8.857 L 12 8.857 L 12 10.429 L 4.143 10.429 L 4.143 8.857 Z  M 4.143 5.714 L 12 5.714 L 12 7.286 L 4.143 7.286 L 4.143 5.714 Z  M 12 19.857 L 2.571 19.857 L 2.571 4.143 L 21.429 4.143 L 21.429 12 L 23 12 L 23 4.143 C 23 3.275 22.296 2.571 21.429 2.571 L 2.571 2.571 C 1.704 2.571 1 3.275 1 4.143 L 1 19.857 C 1 20.725 1.704 21.429 2.571 21.429 L 12 21.429 L 12 19.857 Z',
    },
    chat_multiple: {
        path: 'M 21.429 4.143 L 5.714 4.143 C 4.771 4.143 4.143 4.771 4.143 5.714 L 4.143 16.714 C 4.143 17.657 4.771 18.286 5.714 18.286 L 12 18.286 L 12 16.714 L 5.714 16.714 L 5.714 5.714 L 21.429 5.714 L 21.429 16.714 L 15.771 16.714 L 12 22.057 L 13.257 23 L 16.557 18.286 L 21.429 18.286 C 22.371 18.286 23 17.657 23 16.714 L 23 5.714 C 23 4.771 22.371 4.143 21.429 4.143 Z  M 2.571 13.571 L 1 13.571 L 1 3.357 C 1 2.021 2.021 1 3.357 1 L 13.571 1 L 13.571 2.571 L 3.357 2.571 C 2.886 2.571 2.571 2.886 2.571 3.357 L 2.571 13.571 Z',
    },
    check: {
        path: 'M 9.25 19.523 L 1 11.273 L 2.296 9.977 L 9.25 16.93 L 21.704 4.477 L 23 5.773 L 9.25 19.523 L 9.25 19.523 Z',
    },
    check_circle: {
        path: 'M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z',
    },
    clip_section: {
        path: 'M14.73 4.73h1.53v.85h-1.53zm4.61 1.56h-.85v-.71h-.7v-.85h1.55zm0 9.14h-.85v-2.29h.85zm0-4.57h-.85V8.57h.85zm0 8.41H17.8v-.85h.7v-.7h.85zm-4.61-.85h1.53v.85h-1.53zm-2.1-13.7h.58v.86h-.57zm0 13.7h.58v.85h-.57zM11.5.6V4.6H5.86c-.66 0-1.2.54-1.2 1.2V18.2c0 .66.54 1.2 1.2 1.2h5.64v3.99h1.14V.6zM5.8 18.28V5.72h5.7v12.56zm0 0',
    },
    close: {
        path: 'M 23 2.925 L 21.075 1 L 12 10.075 L 2.925 1 L 1 2.925 L 10.075 12 L 1 21.075 L 2.925 23 L 12 13.925 L 21.075 23 L 23 21.075 L 13.925 12 L 23 2.925 Z',
    },
    close_small: {
        path: 'M 17.5 7.463 L 16.538 6.5 L 12 11.038 L 7.463 6.5 L 6.5 7.463 L 11.038 12 L 6.5 16.538 L 7.463 17.5 L 12 12.963 L 16.538 17.5 L 17.5 16.538 L 12.963 12 L 17.5 7.463 Z',
    },
    code_block: {
        path: 'M 12.652 19.857 L 14.679 17.83 L 13.571 16.714 L 10.429 19.857 L 13.571 23 L 14.687 21.892 L 12.652 19.857 L 12.652 19.857 Z  M 19.205 19.857 L 17.178 21.884 L 18.286 23 L 21.428 19.857 L 18.286 16.714 L 17.17 17.822 L 19.205 19.857 L 19.205 19.857 Z  M 8.857 21.429 L 4.143 21.429 L 4.143 2.572 L 10.429 2.572 L 10.429 7.286 C 10.431 8.153 11.133 8.855 12 8.857 L 16.714 8.857 L 16.714 13.572 L 18.286 13.572 L 18.286 7.286 C 18.291 7.077 18.205 6.876 18.05 6.736 L 12.55 1.236 C 12.41 1.081 12.209 0.995 12 1 L 4.143 1 C 3.276 1.003 2.574 1.705 2.572 2.572 L 2.572 21.429 C 2.574 22.295 3.276 22.997 4.143 23 L 8.857 23 L 8.857 21.429 Z  M 12 2.886 L 16.4 7.286 L 12 7.286 L 12 2.886 Z',
    },
    code: {
        path: 'M 23 11.999 L 17.867 17.133 L 16.833 16.099 L 20.925 11.999 L 16.833 7.9 L 17.867 6.866 L 23 11.999 L 23 11.999 Z  M 1 11.999 L 6.133 6.866 L 7.167 7.9 L 3.075 11.999 L 7.167 16.099 L 6.133 17.133 L 1 11.999 L 1 11.999 Z  M 9.374 18.954 L 13.202 4.667 L 14.619 5.046 L 10.79 19.333 L 9.374 18.954 Z',
    },
    collection: {
        path: 'M 4.759 20.707 C 4.107 20.707 3.541 20.245 3.411 19.607 L 1.027 7.69 C 1.009 7.601 1 7.509 1 7.415 C 1.001 6.658 1.617 6.042 2.375 6.042 L 8.297 6.042 C 8.948 6.042 9.515 6.505 9.645 7.142 L 9.9 8.427 C 9.943 8.638 10.132 8.792 10.349 8.792 L 13.833 8.792 L 13.833 8.334 C 13.833 7.576 14.45 6.959 15.208 6.959 L 17.957 6.959 C 18.716 6.959 19.332 7.576 19.332 8.334 L 19.332 8.792 L 21.624 8.792 C 21.718 8.792 21.81 8.801 21.901 8.82 C 22.643 8.972 23.123 9.699 22.972 10.442 L 21.602 19.584 C 21.468 20.24 20.901 20.707 20.25 20.707 L 4.759 20.707 Z  M 2.375 6.959 C 2.252 6.959 2.138 7.007 2.05 7.093 C 1.965 7.179 1.916 7.294 1.916 7.416 C 1.916 7.447 1.919 7.478 1.926 7.509 L 4.309 19.426 C 4.352 19.637 4.541 19.791 4.758 19.791 L 20.249 19.791 C 20.467 19.791 20.656 19.637 20.699 19.424 L 22.069 10.282 C 22.124 10.012 21.968 9.769 21.716 9.718 C 21.69 9.713 21.663 9.71 21.636 9.71 L 19.332 9.709 L 19.332 16.393 C 19.332 16.635 19.235 16.872 19.063 17.042 C 18.889 17.215 18.66 17.31 18.416 17.31 C 18.17 17.31 17.94 17.213 17.767 17.04 L 16.583 15.856 L 15.398 17.041 C 15.227 17.212 14.991 17.31 14.749 17.31 C 14.243 17.31 13.832 16.899 13.832 16.393 L 13.832 9.709 L 10.349 9.709 C 9.698 9.709 9.131 9.246 9.001 8.609 L 8.746 7.323 C 8.703 7.113 8.515 6.959 8.298 6.959 L 2.375 6.959 Z  M 15.208 7.876 C 14.955 7.876 14.749 8.081 14.749 8.334 L 14.749 16.393 L 16.258 14.884 C 16.346 14.797 16.46 14.75 16.583 14.75 C 16.706 14.75 16.82 14.797 16.907 14.884 L 18.416 16.392 L 18.416 8.334 C 18.416 8.081 18.21 7.876 17.957 7.876 L 15.208 7.876 Z  M 21.624 7.876 C 21.371 7.876 21.165 7.67 21.165 7.417 L 21.165 4.668 C 21.165 4.415 20.96 4.209 20.707 4.209 L 4.209 4.209 C 3.956 4.209 3.751 4.415 3.751 4.668 C 3.751 4.921 3.545 5.126 3.293 5.126 C 3.04 5.126 2.834 4.921 2.834 4.668 C 2.834 3.909 3.451 3.293 4.209 3.293 L 20.707 3.293 C 21.465 3.293 22.082 3.909 22.082 4.668 L 22.082 7.417 C 22.082 7.67 21.877 7.876 21.624 7.876 Z',
        customStroke: '0.5px',
    },
    comment: {
        path: 'M 13.367 22.214 L 12 21.429 L 15.143 15.929 L 19.857 15.929 C 20.725 15.929 21.429 15.225 21.429 14.357 L 21.429 4.929 C 21.429 4.061 20.725 3.357 19.857 3.357 L 4.143 3.357 C 3.275 3.357 2.571 4.061 2.571 4.929 L 2.571 14.357 C 2.571 15.225 3.275 15.929 4.143 15.929 L 11.214 15.929 L 11.214 17.5 L 4.143 17.5 C 2.407 17.5 1 16.093 1 14.357 L 1 4.929 C 1 3.193 2.407 1.786 4.143 1.786 L 19.857 1.786 C 21.593 1.786 23 3.193 23 4.929 L 23 14.357 C 23 16.093 21.593 17.5 19.857 17.5 L 16.054 17.5 L 13.367 22.214 Z  M 5.714 6.5 L 18.286 6.5 L 18.286 8.071 L 5.714 8.071 L 5.714 6.5 Z  M 5.714 11.214 L 13.571 11.214 L 13.571 12.786 L 5.714 12.786 L 5.714 11.214 Z',
    },
    communications: {
        path: 'M 16.741 23 C 16.533 23 16.351 22.866 16.288 22.668 L 15.507 20.156 L 8.502 20.156 L 7.719 22.667 C 7.657 22.866 7.475 23 7.266 23 C 7.219 23 7.172 22.994 7.128 22.979 C 7.005 22.942 6.907 22.859 6.847 22.747 C 6.789 22.635 6.777 22.506 6.814 22.386 L 10.871 9.358 C 10.394 9.003 10.105 8.437 10.105 7.84 C 10.105 6.795 10.954 5.945 12 5.945 C 13.045 5.945 13.895 6.795 13.895 7.84 C 13.895 8.444 13.614 8.996 13.134 9.355 L 17.192 22.387 C 17.27 22.636 17.13 22.902 16.881 22.98 C 16.836 22.994 16.789 23 16.741 23 Z  M 15.212 19.208 L 14.327 16.366 L 9.682 16.366 L 8.797 19.208 L 15.212 19.208 Z  M 14.032 15.419 L 12.255 9.715 L 12.224 9.72 C 12.151 9.728 12.076 9.733 12 9.733 C 11.921 9.733 11.845 9.728 11.769 9.718 C 11.763 9.718 11.758 9.717 11.752 9.717 L 9.977 15.419 L 14.032 15.419 Z  M 11.628 8.706 C 11.745 8.758 11.872 8.785 12.004 8.785 C 12.069 8.785 12.132 8.779 12.195 8.765 C 12.201 8.764 12.226 8.755 12.232 8.753 C 12.281 8.741 12.329 8.728 12.375 8.709 C 12.723 8.558 12.948 8.217 12.948 7.839 C 12.948 7.317 12.524 6.891 12 6.891 C 11.478 6.891 11.053 7.317 11.053 7.839 C 11.053 8.207 11.269 8.543 11.605 8.698 C 11.613 8.701 11.62 8.704 11.628 8.706 Z  M 17.302 12.665 C 17.175 12.665 17.057 12.616 16.967 12.527 C 16.877 12.438 16.829 12.318 16.829 12.192 C 16.829 12.064 16.878 11.946 16.967 11.856 C 19.183 9.64 19.183 6.033 16.967 3.817 C 16.878 3.728 16.829 3.608 16.829 3.481 C 16.829 3.355 16.878 3.236 16.967 3.146 C 17.056 3.056 17.177 3.008 17.302 3.008 C 17.428 3.008 17.548 3.058 17.637 3.147 C 20.224 5.732 20.224 9.94 17.637 12.526 C 17.548 12.616 17.429 12.665 17.302 12.665 Z  M 19.313 14.676 C 19.186 14.676 19.067 14.627 18.978 14.538 C 18.792 14.353 18.792 14.053 18.978 13.868 C 22.302 10.544 22.302 5.134 18.978 1.809 C 18.792 1.624 18.792 1.324 18.978 1.14 C 19.066 1.05 19.186 1.001 19.313 1.001 C 19.44 1.001 19.558 1.05 19.648 1.14 C 21.435 2.926 22.418 5.305 22.418 7.839 C 22.418 10.372 21.434 12.751 19.648 14.538 C 19.558 14.627 19.44 14.676 19.313 14.676 Z  M 6.698 12.665 C 6.571 12.665 6.453 12.616 6.363 12.527 C 3.777 9.941 3.777 5.733 6.363 3.148 C 6.453 3.058 6.573 3.008 6.698 3.008 C 6.824 3.008 6.944 3.058 7.034 3.147 C 7.124 3.236 7.172 3.356 7.172 3.483 C 7.172 3.608 7.123 3.728 7.034 3.818 C 4.818 6.034 4.818 9.641 7.034 11.857 C 7.123 11.946 7.172 12.065 7.172 12.192 C 7.172 12.32 7.123 12.438 7.034 12.528 C 6.945 12.618 6.826 12.665 6.698 12.665 Z  M 4.688 14.676 C 4.561 14.676 4.443 14.627 4.352 14.538 C 0.658 10.844 0.658 4.833 4.352 1.14 C 4.443 1.049 4.562 1 4.688 1 C 4.814 1 4.933 1.049 5.023 1.138 C 5.208 1.323 5.208 1.624 5.023 1.808 C 1.698 5.133 1.698 10.543 5.023 13.868 C 5.208 14.052 5.208 14.352 5.023 14.538 C 4.933 14.627 4.815 14.676 4.688 14.676 Z',
        customStroke: '0.5px',
    },
    community: {
        path: 'M 16.398 17.973 C 14.885 17.973 13.504 17.402 12.451 16.47 C 13.536 15.293 14.204 13.726 14.204 12 C 14.204 10.274 13.536 8.706 12.451 7.53 C 13.504 6.598 14.885 6.027 16.398 6.027 C 19.691 6.027 22.371 8.706 22.371 12 C 22.371 15.293 19.691 17.973 16.398 17.973 Z  M 1.629 12 C 1.629 8.706 4.309 6.027 7.602 6.027 C 9.116 6.027 10.496 6.598 11.55 7.53 C 10.465 8.706 9.796 10.274 9.796 11.999 C 9.796 13.726 10.465 15.293 11.55 16.47 C 10.496 17.402 9.116 17.973 7.603 17.973 C 4.308 17.973 1.629 15.293 1.629 12 Z  M 12 16.027 C 11.025 14.964 10.426 13.552 10.426 12 C 10.426 10.447 11.025 9.036 12 7.973 C 12.975 9.036 13.575 10.447 13.575 12 C 13.575 13.552 12.975 14.964 12.001 16.027 M 16.397 5.398 C 14.706 5.398 13.168 6.04 11.999 7.086 C 10.832 6.04 9.294 5.398 7.602 5.398 C 3.956 5.398 1 8.354 1 12 C 1 15.645 3.956 18.602 7.602 18.602 C 9.294 18.602 10.831 17.96 12 16.914 C 13.169 17.96 14.708 18.602 16.398 18.602 C 20.044 18.602 23 15.646 23 12 C 23 8.355 20.044 5.398 16.398 5.398',
        customStroke: '0.5px',
    },
    cone: {
        path: 'M 34.373 32.539 C 34.366 31.704 34.051 30.91 33.452 30.183 L 21.139 1.747 C 20.708 0.751 19.292 0.751 18.861 1.747 L 6.547 30.183 C 5.976 30.878 5.626 31.68 5.626 32.569 C 5.626 34.5 7.271 36.213 10.257 37.393 C 18.898 40.808 34.518 38.59 34.373 32.539 L 34.373 32.539 Z  M 20 5.363 L 29.681 27.721 C 24.274 25.609 15.73 25.608 10.319 27.721 L 20 5.363 Z  M 28.83 35.084 C 23.997 36.994 16.017 37 11.17 35.084 C 9.31 34.349 8.108 33.362 8.108 32.569 C 8.108 31.776 9.31 30.788 11.17 30.053 C 16.003 28.143 23.982 28.138 28.83 30.053 C 30.69 30.788 31.892 31.776 31.892 32.569 C 31.892 33.362 30.69 34.349 28.83 35.084 Z',
    },
    conflicts: {
        path: 'M 12 18.021 C 11.688 18.021 11.434 18.274 11.434 18.587 C 11.434 18.899 11.688 19.152 12 19.152 C 12.312 19.152 12.566 18.899 12.566 18.587 C 12.566 18.274 12.312 18.021 12 18.021 Z  M 11.623 13.874 L 12.378 13.874 L 12.378 17.267 L 11.623 17.267 L 11.623 13.874 Z  M 16.901 20.66 L 7.099 20.66 C 6.967 20.661 6.845 20.592 6.776 20.48 C 6.708 20.367 6.703 20.227 6.763 20.11 L 11.664 10.684 C 11.729 10.559 11.859 10.479 12 10.479 C 12.141 10.479 12.271 10.559 12.336 10.684 L 17.237 20.11 C 17.297 20.227 17.293 20.367 17.224 20.48 C 17.155 20.592 17.033 20.661 16.901 20.66 Z  M 7.721 19.906 L 16.279 19.906 L 12 11.676 L 7.721 19.906 Z  M 17.91 18.953 L 17.516 18.953 L 17.516 17.389 L 17.91 17.389 C 19.869 17.467 21.52 15.955 21.598 14.012 C 21.676 12.07 20.152 10.432 18.194 10.354 L 17.516 10.354 L 17.437 9.713 C 17.076 6.991 14.736 4.956 11.968 4.956 C 9.201 4.956 6.861 6.991 6.5 9.713 L 6.484 10.354 L 5.806 10.354 C 3.848 10.432 2.324 12.07 2.402 14.012 C 2.48 15.955 4.131 17.467 6.09 17.389 L 6.484 17.389 L 6.484 18.953 L 6.09 18.953 C 3.473 18.936 1.289 16.966 1.026 14.383 C 0.763 11.8 2.505 9.436 5.066 8.9 C 5.767 5.657 8.656 3.34 12 3.34 C 15.344 3.34 18.233 5.657 18.934 8.9 C 21.495 9.436 23.237 11.8 22.974 14.383 C 22.711 16.966 20.527 18.936 17.91 18.953 L 17.91 18.953 Z',
    },
    consumer: {
        path: 'M 7.064 21.096 C 7.064 20.259 7.743 19.58 8.58 19.58 C 9.416 19.58 10.096 20.259 10.096 21.096 C 10.096 21.932 9.416 22.612 8.58 22.612 C 7.743 22.612 7.064 21.932 7.064 21.096 Z  M 17.676 21.096 C 17.676 20.259 18.355 19.58 19.191 19.58 C 20.028 19.58 20.707 20.259 20.707 21.096 C 20.707 21.932 20.028 22.612 19.191 22.612 C 18.355 22.612 17.676 21.932 17.676 21.096 Z  M 22.223 5.178 L 5.411 5.178 L 4.79 1.995 C 4.717 1.636 4.398 1.381 4.032 1.388 L 1 1.388 L 1 2.904 L 3.41 2.904 L 6.306 17.458 C 6.379 17.816 6.698 18.071 7.064 18.064 L 20.707 18.064 L 20.707 16.548 L 7.685 16.548 L 7.064 13.516 L 20.707 13.516 C 21.069 13.525 21.386 13.277 21.465 12.925 L 22.981 6.103 C 23.033 5.875 22.976 5.636 22.828 5.456 C 22.68 5.275 22.457 5.173 22.223 5.178 Z  M 20.101 12 L 6.776 12 L 5.715 6.694 L 21.276 6.694 L 20.101 12 Z',
    },
    contribute: {
        path: 'M 8.388 16.318 L 9.134 15.571 L 11.031 17.467 L 15.041 13.456 L 15.789 14.204 L 11.031 18.963 L 8.388 16.318 Z  M 12 10.42 C 9.161 10.42 6.859 12.722 6.859 15.561 C 6.859 18.4 9.161 20.701 12 20.701 C 14.839 20.701 17.141 18.4 17.141 15.561 C 17.141 14.197 16.599 12.89 15.635 11.926 C 14.671 10.962 13.363 10.42 12 10.42 Z  M 12 19.967 C 9.567 19.967 7.594 17.994 7.594 15.561 C 7.594 13.127 9.567 11.155 12 11.155 C 14.433 11.155 16.406 13.127 16.406 15.561 C 16.406 16.729 15.942 17.85 15.116 18.676 C 14.289 19.503 13.169 19.967 12 19.967 Z  M 17.91 18.912 L 17.516 18.912 L 17.516 17.348 L 17.91 17.348 C 19.869 17.426 21.52 15.914 21.598 13.971 C 21.676 12.029 20.152 10.391 18.194 10.313 L 17.516 10.313 L 17.437 9.672 C 17.076 6.95 14.736 4.915 11.968 4.915 C 9.201 4.915 6.861 6.95 6.5 9.672 L 6.484 10.313 L 5.806 10.313 C 3.848 10.391 2.324 12.029 2.402 13.971 C 2.48 15.914 4.131 17.426 6.09 17.348 L 6.484 17.348 L 6.484 18.912 L 6.09 18.912 C 3.473 18.895 1.289 16.925 1.026 14.342 C 0.763 11.759 2.505 9.395 5.066 8.859 C 5.767 5.616 8.656 3.299 12 3.299 C 15.344 3.299 18.233 5.616 18.934 8.859 C 21.495 9.395 23.237 11.759 22.974 14.342 C 22.711 16.925 20.527 18.895 17.91 18.912 L 17.91 18.912 Z',
    },
    contribution: {
        path: 'M 8.857 22.214 C 8.54 22.213 8.255 22.021 8.134 21.727 L 4.402 12.786 L 1 12.786 L 1 11.214 L 4.929 11.214 C 5.246 11.216 5.531 11.408 5.651 11.701 L 8.857 19.291 L 15.19 2.296 C 15.305 1.988 15.6 1.785 15.929 1.786 C 16.261 1.792 16.553 2.005 16.659 2.32 L 19.637 11.214 L 23 11.214 L 23 12.786 L 19.071 12.786 C 18.734 12.787 18.433 12.571 18.325 12.251 L 15.929 4.929 L 9.596 21.704 C 9.481 22.012 9.186 22.215 8.857 22.214 Z',
    },
    cross: {
        path: 'M 12.014 22.535 C 11.953 22.535 11.895 22.522 11.837 22.499 C 11.832 22.497 4.366 19.232 4.366 19.232 L 1.693 20.566 C 1.628 20.597 1.555 20.616 1.479 20.616 C 1.297 20.616 1.133 20.515 1.05 20.351 C 0.994 20.236 0.984 20.106 1.025 19.985 C 1.065 19.863 1.151 19.766 1.265 19.708 L 3.873 18.407 L 3.873 9.605 C 3.873 9.55 3.884 9.495 3.906 9.438 C 3.909 9.431 3.921 9.404 3.924 9.396 C 3.945 9.357 3.969 9.322 3.997 9.291 C 4.001 9.285 4.022 9.262 4.027 9.258 C 4.068 9.218 4.112 9.19 4.159 9.168 C 4.162 9.168 11.536 5.941 11.536 5.941 L 11.536 1.945 C 11.536 1.68 11.75 1.465 12.014 1.465 C 12.28 1.465 12.494 1.68 12.494 1.945 L 12.494 5.941 L 19.865 9.165 C 19.917 9.189 19.961 9.218 20.003 9.258 C 20.01 9.264 20.027 9.282 20.033 9.289 C 20.062 9.322 20.085 9.357 20.104 9.392 C 20.11 9.407 20.117 9.421 20.123 9.436 C 20.145 9.494 20.156 9.55 20.156 9.605 L 20.156 18.407 L 22.735 19.694 C 22.849 19.75 22.935 19.848 22.975 19.97 C 23.016 20.093 23.006 20.222 22.95 20.336 C 22.868 20.5 22.703 20.602 22.521 20.602 C 22.447 20.602 22.372 20.585 22.306 20.55 L 19.662 19.232 L 12.206 22.494 C 12.198 22.497 12.188 22.502 12.179 22.503 C 12.122 22.524 12.069 22.535 12.014 22.535 Z  M 12.494 21.322 L 19.197 18.39 L 19.197 10.338 L 12.494 13.271 L 12.494 21.322 Z  M 11.536 21.322 L 11.536 13.27 L 4.833 10.337 L 4.833 18.389 L 11.536 21.322 Z  M 12.014 12.434 L 18.482 9.605 L 12.014 6.777 L 5.549 9.605 L 12.014 12.434 Z',
        customStroke: '0.5px',
    },
    cylinder: {
        path: 'M 36.359 7.997 C 36.37 7.885 36.376 7.772 36.376 7.657 C 36.376 3.287 28.138 1 20 1 L 20 1 L 20 1 C 11.862 1 3.624 3.287 3.624 7.657 C 3.624 7.772 3.63 7.885 3.641 7.997 L 3.641 7.997 L 3.624 7.997 L 3.624 32.32 C 3.624 32.328 3.624 32.335 3.624 32.343 C 3.624 36.713 11.862 39 20 39 C 28.138 39 36.376 36.713 36.376 32.343 L 36.376 32.343 L 36.376 32.343 L 36.359 7.997 Z  M 33.46 11.617 C 30.344 13.398 25.152 14.315 20 14.315 C 14.848 14.315 9.656 13.398 6.54 11.617 L 6.54 28.383 C 9.656 26.602 14.848 25.685 20 25.685 L 20 25.685 L 20 25.685 C 25.152 25.685 30.344 26.602 33.46 28.383 L 33.46 11.617 Z  M 6.54 32.343 C 6.54 33.662 11.65 36.084 20 36.084 L 20 36.084 L 20 36.084 C 28.35 36.084 33.46 33.662 33.46 32.343 L 33.46 32.343 C 33.46 31.023 28.35 28.601 20 28.601 C 11.668 28.601 6.562 31.013 6.54 32.334 L 6.54 32.343 L 6.54 32.343 L 6.54 32.343 Z  M 20 11.399 C 11.65 11.399 6.54 8.976 6.54 7.657 C 6.54 6.338 11.65 3.916 20 3.916 C 28.35 3.916 33.46 6.338 33.46 7.657 C 33.46 8.977 28.35 11.399 20 11.399 L 20 11.399 L 20 11.399 L 20 11.399 Z',
    },
    delete: {
        path: 'M 8.857 8.857 L 10.429 8.857 L 10.429 18.286 L 8.857 18.286 L 8.857 8.857 Z  M 13.571 8.857 L 15.143 8.857 L 15.143 18.286 L 13.571 18.286 L 13.571 8.857 Z  M 2.571 4.143 L 2.571 5.714 L 4.143 5.714 L 4.143 21.429 C 4.143 22.296 4.846 23 5.714 23 L 18.286 23 C 19.154 23 19.857 22.296 19.857 21.429 L 19.857 5.714 L 21.429 5.714 L 21.429 4.143 L 2.571 4.143 Z  M 5.714 21.429 L 5.714 5.714 L 18.286 5.714 L 18.286 21.429 L 5.714 21.429 Z  M 8.857 1 L 15.143 1 L 15.143 2.571 L 8.857 2.571 L 8.857 1 Z',
    },
    document: {
        path: 'M 19.621 6.736 L 14.121 1.236 C 13.964 1.079 13.807 1 13.571 1 L 5.714 1 C 4.85 1 4.143 1.707 4.143 2.571 L 4.143 21.429 C 4.143 22.293 4.85 23 5.714 23 L 18.286 23 C 19.15 23 19.857 22.293 19.857 21.429 L 19.857 7.286 C 19.857 7.05 19.779 6.893 19.621 6.736 Z  M 13.571 2.886 L 17.971 7.286 L 13.571 7.286 L 13.571 2.886 Z  M 18.286 21.429 L 5.714 21.429 L 5.714 2.571 L 12 2.571 L 12 7.286 C 12 8.15 12.707 8.857 13.571 8.857 L 18.286 8.857 L 18.286 21.429 Z  M 7.286 16.714 L 16.714 16.714 L 16.714 18.286 L 7.286 18.286 L 7.286 16.714 Z  M 7.286 12 L 16.714 12 L 16.714 13.571 L 7.286 13.571 L 7.286 12 Z',
    },
    download: {
        path: 'M 17.899 16.708 L 17.505 16.708 L 17.505 15.135 L 17.899 15.135 C 19.853 15.214 21.501 13.692 21.579 11.738 C 21.657 9.783 20.136 8.135 18.182 8.057 L 17.505 8.057 L 17.427 7.412 C 17.066 4.673 14.731 2.626 11.969 2.626 C 9.206 2.626 6.871 4.673 6.51 7.412 L 6.495 8.057 L 5.818 8.057 C 3.864 8.135 2.343 9.783 2.421 11.738 C 2.499 13.692 4.147 15.214 6.101 15.135 L 6.495 15.135 L 6.495 16.708 L 6.101 16.708 C 3.49 16.692 1.31 14.709 1.048 12.11 C 0.785 9.512 2.523 7.133 5.079 6.594 C 5.779 3.331 8.663 1 12 1 C 15.337 1 18.221 3.331 18.921 6.594 C 21.477 7.133 23.215 9.512 22.952 12.11 C 22.69 14.709 20.51 16.692 17.899 16.708 Z  M 12.786 19.988 L 12.786 10.417 L 11.214 10.417 L 11.214 19.988 L 9.177 17.959 L 8.068 19.068 L 12 23 L 15.932 19.068 L 14.823 17.959 L 12.786 19.988 L 12.786 19.988 Z',
    },
    edit: {
        path: 'M 1 20.643 L 23 20.643 L 23 22.214 L 1 22.214 L 1 20.643 Z  M 19.386 7.286 C 20.014 6.657 20.014 5.714 19.386 5.086 C 19.386 5.086 19.386 5.086 19.386 5.086 L 16.557 2.257 C 15.929 1.629 14.986 1.629 14.357 2.257 C 14.357 2.257 14.357 2.257 14.357 2.257 L 2.571 14.043 L 2.571 19.071 L 7.6 19.071 L 19.386 7.286 Z  M 15.457 3.357 L 18.286 6.186 L 15.929 8.543 L 13.1 5.714 L 15.457 3.357 Z  M 4.143 17.5 L 4.143 14.671 L 12 6.814 L 14.829 9.643 L 6.971 17.5 L 4.143 17.5 Z',
    },
    electronics: {
        path: 'M 8.071 8.071 L 8.071 15.929 L 15.929 15.929 L 15.929 8.071 L 8.071 8.071 Z  M 14.357 14.357 L 9.643 14.357 L 9.643 9.643 L 14.357 9.643 L 14.357 14.357 Z  M 23 9.643 L 23 8.071 L 19.857 8.071 L 19.857 5.714 C 19.857 4.846 19.154 4.143 18.286 4.143 L 15.929 4.143 L 15.929 1 L 14.357 1 L 14.357 4.143 L 9.643 4.143 L 9.643 1 L 8.071 1 L 8.071 4.143 L 5.714 4.143 C 4.846 4.143 4.143 4.846 4.143 5.714 L 4.143 8.071 L 1 8.071 L 1 9.643 L 4.143 9.643 L 4.143 14.357 L 1 14.357 L 1 15.929 L 4.143 15.929 L 4.143 18.286 C 4.143 19.154 4.846 19.857 5.714 19.857 L 8.071 19.857 L 8.071 23 L 9.643 23 L 9.643 19.857 L 14.357 19.857 L 14.357 23 L 15.929 23 L 15.929 19.857 L 18.286 19.857 C 19.154 19.857 19.857 19.154 19.857 18.286 L 19.857 15.929 L 23 15.929 L 23 14.357 L 19.857 14.357 L 19.857 9.643 L 23 9.643 Z  M 18.286 18.286 L 5.714 18.286 L 5.714 5.714 L 18.286 5.714 L 18.286 18.286 Z',
    },
    email: {
        path: 'M 21.429 4.143 L 2.571 4.143 C 1.704 4.143 1 4.846 1 5.714 L 1 18.286 C 1 19.154 1.704 19.857 2.571 19.857 L 21.429 19.857 C 22.296 19.857 23 19.154 23 18.286 L 23 5.714 C 23 4.846 22.296 4.143 21.429 4.143 Z  M 19.7 5.714 L 12 11.041 L 4.3 5.714 L 19.7 5.714 Z  M 2.571 18.286 L 2.571 6.429 L 11.552 12.644 C 11.821 12.831 12.179 12.831 12.448 12.644 L 21.429 6.429 L 21.429 18.286 L 2.571 18.286 Z',
    },
    embed: {
        path: 'M 21.428 19.071 L 20.317 17.96 L 18.286 19.992 L 18.286 13.572 L 16.714 13.572 L 16.714 19.992 L 14.682 17.96 L 13.571 19.071 L 17.5 23 L 21.428 19.071 L 21.428 19.071 Z  M 12 21.429 L 4.143 21.429 L 4.143 2.572 L 10.429 2.572 L 10.429 7.286 C 10.431 8.153 11.133 8.855 12 8.857 L 16.714 8.857 L 16.714 11.214 L 18.286 11.214 L 18.286 7.286 C 18.291 7.077 18.205 6.876 18.05 6.736 L 12.55 1.236 C 12.41 1.081 12.209 0.995 12 1 L 4.143 1 C 3.276 1.003 2.574 1.705 2.572 2.572 L 2.572 21.429 C 2.574 22.295 3.276 22.997 4.143 23 L 12 23 L 12 21.429 Z  M 12 2.886 L 16.4 7.286 L 12 7.286 L 12 2.886 Z',
    },
    error: {
        path: 'M 12 1 C 5.871 1 1 5.871 1 12 C 1 18.129 5.871 23 12 23 C 18.129 23 23 18.129 23 12 C 23 5.871 18.129 1 12 1 Z  M 12 21.429 C 6.814 21.429 2.571 17.186 2.571 12 C 2.571 6.814 6.814 2.571 12 2.571 C 17.186 2.571 21.429 6.814 21.429 12 C 21.429 17.186 17.186 21.429 12 21.429 Z  M 16.243 17.5 L 12 13.257 L 7.757 17.5 L 6.5 16.243 L 10.743 12 L 6.5 7.757 L 7.757 6.5 L 12 10.743 L 16.243 6.5 L 17.5 7.757 L 13.257 12 L 17.5 16.243 L 16.243 17.5 Z',
    },
    expand: {
        path: 'M 15.929 1 L 15.929 2.571 L 20.321 2.571 L 12.786 10.099 L 13.894 11.214 L 21.429 3.679 L 21.429 8.071 L 23 8.071 L 23 1 L 15.929 1 L 15.929 1 Z  M 11.214 13.901 L 10.106 12.786 L 2.571 20.321 L 2.571 15.929 L 1 15.929 L 1 23 L 8.071 23 L 8.071 21.429 L 3.679 21.429 L 11.214 13.901 L 11.214 13.901 Z',
    },
    explode: {
        path: 'M 1.99 7.795 L 11.092 11.687 C 11.344 11.794 11.507 12.041 11.508 12.314 L 11.531 22.313 C 11.532 22.805 11.029 23.138 10.577 22.944 L 1.475 19.053 C 1.223 18.946 1.06 18.698 1.059 18.425 L 1.036 8.427 C 1.035 7.935 1.538 7.603 1.99 7.796 L 1.99 7.795 Z  M 1.842 8.897 L 1.82 18.15 L 10.569 21.788 L 10.591 12.535 L 1.842 8.897 Z  M 21.913 8.897 L 13.515 12.535 L 13.537 21.788 L 21.937 18.15 L 21.914 8.897 M 22.254 7.691 C 22.615 7.69 22.94 7.981 22.941 8.375 L 22.964 18.374 C 22.964 18.647 22.802 18.894 22.551 19.003 L 13.467 22.937 C 13.378 22.976 13.286 22.994 13.197 22.994 C 12.836 22.995 12.512 22.705 12.511 22.31 L 12.487 12.312 C 12.487 12.038 12.649 11.792 12.9 11.682 L 21.983 7.747 C 22.073 7.709 22.164 7.69 22.253 7.69 L 22.254 7.691 Z  M 11.933 2.06 L 3.22 5.949 L 11.952 9.798 L 20.665 5.909 L 11.933 2.059 M 11.931 1 C 12.026 1 12.12 1.019 12.209 1.059 L 21.786 5.28 C 22.329 5.519 22.331 6.29 21.788 6.531 L 12.232 10.799 C 12.144 10.838 12.049 10.857 11.955 10.857 C 11.859 10.857 11.765 10.839 11.676 10.8 L 2.1 6.578 C 1.556 6.337 1.555 5.569 2.097 5.326 L 11.654 1.06 C 11.742 1.02 11.837 1.001 11.931 1 Z',
        customStroke: '0.5px',
    },
    explode_layers: {
        path: 'M 2.71 12.738 L 18.432 19.458 C 18.866 19.644 19.148 20.071 19.149 20.543 L 19.19 37.813 C 19.192 38.663 18.324 39.238 17.543 38.904 L 1.821 32.183 C 1.386 31.997 1.104 31.571 1.103 31.098 L 1.062 13.828 C 1.06 12.978 1.928 12.404 2.71 12.738 Z  M 2.456 14.641 L 2.416 30.623 L 17.527 36.907 L 17.567 20.924 L 2.456 14.641 Z  M 37.125 14.641 L 22.617 20.924 L 22.654 36.907 L 37.163 30.623 L 37.125 14.641 Z  M 37.712 12.557 C 38.336 12.556 38.895 13.057 38.897 13.738 L 38.938 31.008 C 38.939 31.481 38.659 31.909 38.225 32.097 L 22.535 38.892 C 22.38 38.959 22.222 38.99 22.067 38.99 C 21.444 38.992 20.884 38.49 20.883 37.809 L 20.842 20.539 C 20.841 20.067 21.121 19.639 21.554 19.451 L 37.244 12.656 C 37.399 12.589 37.558 12.558 37.712 12.557 L 37.712 12.557 Z  M 19.885 2.83 L 4.835 9.549 L 19.917 16.198 L 34.967 9.478 L 19.885 2.83 Z  M 19.881 1 C 20.044 1 20.208 1.033 20.361 1.1 L 36.902 8.392 C 37.84 8.806 37.844 10.136 36.907 10.555 L 20.401 17.925 C 20.248 17.993 20.085 18.027 19.921 18.027 C 19.758 18.028 19.594 17.994 19.441 17.927 L 2.9 10.635 C 1.962 10.221 1.959 8.891 2.895 8.473 L 19.402 1.103 C 19.554 1.035 19.717 1 19.881 1 L 19.881 1 Z',
    },
    fablab: {
        path: 'M 15.424 7.126 C 15.424 5.779 13.787 4.687 11.766 4.687 C 11.316 4.687 10.884 4.742 10.485 4.841 L 9.292 4.163 L 12.001 2.598 L 19.793 7.099 C 20.385 6.756 20.915 6.45 21.347 6.201 C 19.405 3.08 15.947 1 12.001 1 C 8.061 1 4.606 3.074 2.664 6.189 C 3.11 6.447 3.641 6.753 4.224 7.089 L 6.635 5.696 L 8.196 6.6 C 8.14 6.769 8.109 6.945 8.109 7.126 C 8.109 8.472 9.747 9.564 11.766 9.564 C 13.787 9.564 15.424 8.472 15.424 7.126 Z  M 21.712 6.836 L 20.154 7.735 L 20.154 10.553 L 18.454 11.516 C 18.33 11.372 18.185 11.249 18.02 11.152 C 16.856 10.476 15.089 11.343 14.074 13.09 C 13.061 14.838 13.18 16.802 14.346 17.48 C 15.51 18.155 17.277 17.288 18.29 15.541 C 18.51 15.163 18.677 14.775 18.79 14.392 L 20.154 13.603 L 20.154 16.727 L 12.385 21.213 L 12.385 22.998 C 18.282 22.797 23 17.953 23 12.005 C 23 10.136 22.533 8.376 21.712 6.836 Z  M 9.545 17.608 C 9.621 17.577 9.693 17.543 9.765 17.5 C 10.93 16.824 11.051 14.859 10.037 13.111 C 9.022 11.365 7.256 10.496 6.091 11.173 C 4.927 11.849 4.806 13.814 5.821 15.562 C 5.97 15.819 6.135 16.056 6.313 16.273 L 6.313 18.15 L 3.847 16.727 L 3.847 7.718 L 2.296 6.822 C 1.47 8.367 1 10.13 1 12.005 C 1 17.965 5.74 22.816 11.654 23 L 11.654 21.235 L 9.545 20.017 L 9.545 17.608 Z',
        customStroke: '0',
    },
    facebook: {
        path: 'M 23 12.067 C 23 5.956 18.075 1 12 1 C 5.925 1 1 5.956 1 12.067 C 1 17.59 5.023 22.169 10.281 23 L 10.281 15.267 L 7.488 15.267 L 7.488 12.067 L 10.281 12.067 L 10.281 9.629 C 10.281 6.855 11.924 5.322 14.436 5.322 C 15.64 5.322 16.898 5.538 16.898 5.538 L 16.898 8.262 L 15.512 8.262 C 14.146 8.262 13.719 9.115 13.719 9.99 L 13.719 12.067 L 16.769 12.067 L 16.282 15.267 L 13.719 15.267 L 13.719 23 C 18.977 22.17 23 17.591 23 12.067 Z',
        customStroke: '0',
    },
    wechat: {
        path: 'M22.13 15.6c0-2.97-2.82-5.37-6.33-5.37-3.48 0-6.33 2.4-6.33 5.38s2.81 5.38 6.33 5.38a7.37 7.37 0 003.04-.66l2.5 1.07-.29-2.78a4.92 4.92 0 001.08-3.01zm-8.45-1.45a.89.89 0 11.88-.88.86.86 0 01-.88.88zm4.27 0a.89.89 0 11.89-.88.89.89 0 01-.89.88zM15.8 9.53a8.67 8.67 0 012.75.48c0-.13.04-.23.04-.35 0-3.9-3.74-7.06-8.36-7.06S1.87 5.76 1.87 9.69a6.46 6.46 0 001.42 3.99l-.38 3.67 3.3-1.42a9.21 9.21 0 002.66.76 5.9 5.9 0 01-.13-1.08c.03-3.36 3.2-6.08 7.06-6.08zm-2.76-4.15a1.2 1.2 0 11-1.2 1.2 1.2 1.2 0 011.2-1.2zM7.41 7.76a1.17 1.17 0 01-1.17-1.2 1.19 1.19 0 111.17 1.2z',
    },
    files: {
        path: 'M 7.875 11.656 L 16.126 11.656 L 16.126 13.031 L 7.875 13.031 L 7.875 11.656 Z  M 7.875 14.406 L 13.375 14.406 L 13.375 15.781 L 7.875 15.781 L 7.875 14.406 Z  M 12 5.468 L 12 5.468 C 14.639 5.472 16.905 7.343 17.408 9.933 L 17.586 10.858 L 18.513 11.026 C 20.439 11.373 21.783 13.132 21.61 15.082 C 21.438 17.032 19.807 18.528 17.85 18.532 L 6.153 18.532 C 4.195 18.529 2.563 17.033 2.39 15.083 C 2.217 13.133 3.56 11.373 5.487 11.026 L 6.414 10.858 L 6.592 9.933 C 7.096 7.343 9.362 5.472 12 5.468 Z  M 12 4.093 C 8.703 4.097 5.87 6.436 5.242 9.673 C 2.615 10.147 0.784 12.546 1.02 15.205 C 1.256 17.863 3.481 19.903 6.15 19.907 L 17.85 19.907 C 20.519 19.903 22.744 17.863 22.98 15.205 C 23.216 12.546 21.385 10.147 18.758 9.673 C 18.13 6.433 15.293 4.093 11.992 4.093 L 12 4.093 Z',
    },
    filter: {
        path: 'M 13.833 23 L 10.167 23 C 9.154 23 8.333 22.179 8.333 21.167 L 8.333 14.209 L 1.541 7.417 C 1.197 7.074 1.002 6.61 1 6.124 L 1 2.833 C 1 1.821 1.821 1 2.833 1 L 21.167 1 C 22.179 1 23 1.821 23 2.833 L 23 6.124 C 22.998 6.61 22.803 7.074 22.459 7.417 L 15.667 14.209 L 15.667 21.167 C 15.667 22.179 14.846 23 13.833 23 Z  M 2.833 2.833 L 2.833 6.124 L 10.167 13.458 L 10.167 21.167 L 13.833 21.167 L 13.833 13.458 L 21.167 6.124 L 21.167 2.833 L 2.833 2.833 Z',
    },
    flag: {
        path: 'M 4.143 23 L 2.571 23 L 2.571 1 L 21.429 1 L 16.871 8.071 L 21.429 15.143 L 4.143 15.143 L 4.143 23 Z  M 4.143 13.571 L 18.545 13.571 L 14.986 8.071 L 18.545 2.571 L 4.143 2.571 L 4.143 13.571 Z',
    },
    folder_add: {
        path: 'M 19.857 14.357 L 18.286 14.357 L 18.286 17.5 L 15.143 17.5 L 15.143 19.071 L 18.286 19.071 L 18.286 22.214 L 19.857 22.214 L 19.857 19.071 L 23 19.071 L 23 17.5 L 19.857 17.5 L 19.857 14.357 Z  M 21.429 4.929 L 12 4.929 L 9.329 2.257 C 9.014 1.943 8.621 1.786 8.229 1.786 L 2.571 1.786 C 1.707 1.786 1 2.493 1 3.357 L 1 19.071 C 1 19.936 1.707 20.643 2.571 20.643 L 13.571 20.643 L 13.571 19.071 L 2.571 19.071 L 2.571 3.357 L 8.229 3.357 L 10.9 6.029 L 11.371 6.5 L 21.429 6.5 L 21.429 12.786 L 23 12.786 L 23 6.5 C 23 5.636 22.293 4.929 21.429 4.929 Z',
    },
    folder: {
        path: 'M 8.205 4.143 L 10.892 6.822 L 11.348 7.286 L 21.429 7.286 L 21.429 19.857 L 2.571 19.857 L 2.571 4.143 L 8.205 4.143 Z  M 8.205 2.571 L 2.571 2.571 C 1.704 2.571 1 3.275 1 4.143 L 1 19.857 C 1 20.725 1.704 21.429 2.571 21.429 L 21.429 21.429 C 22.296 21.429 23 20.725 23 19.857 L 23 7.286 C 23 6.418 22.296 5.714 21.429 5.714 L 12 5.714 L 9.321 3.035 C 9.025 2.738 8.624 2.571 8.205 2.571 Z',
    },
    geometry: {
        path: 'M 36.429 39.019 L 21.327 39.019 C 19.908 39.019 18.759 37.869 18.759 36.451 L 18.759 21.346 C 18.759 19.927 19.908 18.778 21.327 18.778 L 36.432 18.778 C 37.85 18.778 39 19.927 39 21.346 L 39 36.451 C 38.997 37.869 37.848 39.019 36.429 39.019 Z  M 21.274 36.503 L 36.482 36.503 L 36.482 21.293 L 21.274 21.293 L 21.274 36.503 Z  M 16.244 26.598 C 13.965 25.282 12.413 22.85 12.413 20.035 C 12.413 15.842 15.823 12.434 20.017 12.434 C 22.829 12.434 25.261 13.986 26.577 16.262 L 29.389 16.262 C 27.89 12.549 24.26 9.916 20.017 9.916 C 14.435 9.916 9.897 14.456 9.897 20.035 C 9.897 24.279 12.531 27.908 16.244 29.408 L 16.244 26.598 Z  M 7.382 20.038 C 7.382 19.608 7.467 19.2 7.51 18.78 L 4.328 18.78 L 11.155 5.124 L 13.285 9.385 C 13.992 8.937 14.744 8.565 15.537 8.261 L 12.229 1.645 C 11.786 0.76 10.524 0.76 10.081 1.645 L 1.129 19.555 C 0.729 20.352 1.31 21.293 2.203 21.293 L 7.475 21.293 C 7.435 20.878 7.382 20.463 7.382 20.038 Z',
    },
    github: {
        path: 'M 12.003 1.002 Q 16.568 1.002 19.785 4.316 Q 22.999 7.63 23 12.294 Q 23 15.977 20.888 18.922 Q 18.777 21.868 15.488 22.997 L 15.292 22.997 Q 14.703 22.997 14.703 22.409 Q 14.703 22.359 14.727 21.304 Q 14.751 20.249 14.751 19.365 Q 14.751 17.94 13.966 17.253 Q 16.224 16.958 17.623 15.804 Q 19.021 14.65 19.021 11.705 Q 19.021 9.938 17.893 8.661 Q 18.383 7.236 17.794 5.665 L 17.549 5.665 Q 16.419 5.665 14.749 6.844 Q 13.326 6.451 12 6.451 Q 10.675 6.451 9.251 6.844 Q 7.581 5.665 6.451 5.665 L 6.206 5.665 Q 5.617 7.236 6.107 8.661 Q 4.979 9.938 4.979 11.705 Q 4.979 14.65 6.352 15.804 Q 7.727 16.958 9.986 17.253 Q 9.445 17.794 9.299 18.775 Q 8.709 19.07 8.021 19.07 Q 6.794 19.07 6.107 17.842 Q 5.468 16.762 4.388 16.664 Q 3.357 16.664 4.339 17.352 Q 5.076 17.744 5.566 19.021 Q 5.615 19.217 5.763 19.488 Q 5.909 19.757 6.572 20.198 Q 7.236 20.64 8.169 20.64 Q 8.856 20.64 9.248 20.542 L 9.248 22.458 Q 9.248 22.998 8.708 22.998 L 8.511 22.998 Q 5.172 21.869 3.087 18.949 Q 1 16.028 1 12.295 Q 1 7.631 4.215 4.317 Q 7.432 1.003 11.997 1.003 L 12.003 1.002 Z',
        customStroke: '0',
    },
    gitlab: {
        path: 'M22.93 13.76l-1.17-3.72-2.32-7.4a.92.92 0 00-.88-.64.9.9 0 00-.87.65l-2.2 7.02H8.51L6.31 2.65A.9.9 0 005.44 2c-.4 0-.75.26-.88.65l-2.32 7.39-1.17 3.72c-.18.57.01 1.18.47 1.52L11.7 22.9l.02.01h-.01c.02 0 .04.02.05.03h.02l.03.02h.03v.01h.02l.04.02h.03a.5.5 0 00.15 0h.04l.04-.01h.01v-.01h.01l.03-.01.02-.01h.01v-.01h.02a.5.5 0 00.04-.04h.01l10.16-7.62c.46-.34.65-.95.47-1.52zM18.57 3.34l1.99 6.33h-3.99l2-6.33zm1.64 7.4l-.81 1.07-6 7.93 2.84-9h3.97zm-8.7 11.9zm-.91-2.9l-6.8-9h3.97l2.83 9zM5.43 3.34l2 6.33H3.45l1.98-6.33zM2.15 14.42a.3.3 0 01-.1-.33l.87-2.76 6.4 8.47-7.17-5.38zm9.53 8.46h-.01l-.01-.01-.02-.02.05.04h-.01zm.32-2.15l-1.67-5.3-1.47-4.7h6.29l-3.15 10zm.34 2.14h-.01v.01l-.02.01a.68.68 0 01.03-.02zm9.5-8.45l-7.17 5.38 6.4-8.47.88 2.76a.3.3 0 01-.1.33z',
    },
    google: {
        path: 'M 12.222 10.424 L 22.606 10.424 Q 22.778 11.384 22.778 12.258 Q 22.778 15.366 21.474 17.808 Q 20.171 20.25 17.758 21.625 Q 15.344 23 12.222 23 Q 9.973 23 7.939 22.134 Q 5.906 21.267 4.43 19.791 Q 2.955 18.317 2.089 16.282 Q 1.222 14.249 1.222 12 Q 1.222 9.751 2.089 7.718 Q 2.955 5.683 4.43 4.209 Q 5.906 2.733 7.939 1.866 Q 9.973 1 12.222 1 Q 16.519 1 19.598 3.879 L 16.604 6.758 Q 14.843 5.054 12.222 5.054 Q 10.375 5.054 8.807 5.984 Q 7.238 6.915 6.321 8.512 Q 5.405 10.109 5.405 12 Q 5.405 13.891 6.321 15.488 Q 7.238 17.085 8.807 18.016 Q 10.375 18.946 12.222 18.946 Q 13.468 18.946 14.513 18.603 Q 15.559 18.259 16.232 17.744 Q 16.906 17.228 17.406 16.568 Q 17.908 15.91 18.144 15.323 Q 18.381 14.736 18.467 14.206 L 12.222 14.206 L 12.222 10.424 Z',
        customStroke: '0',
    },
    grid: {
        path: 'M 36.236 1 L 24.75 1 L 15.25 1 L 3.764 1 C 2.237 1 1 2.237 1 3.764 L 1 15.25 L 1 24.75 L 1 36.236 C 1 37.763 2.237 39 3.764 39 L 15.25 39 L 24.75 39 L 36.236 39 C 37.763 39 39 37.763 39 36.236 L 39 24.75 L 39 15.25 L 39 3.764 C 39 2.237 37.763 1 36.236 1 Z  M 36.626 3.374 L 36.626 12.874 L 27.126 12.874 L 27.126 3.374 L 36.626 3.374 Z  M 24.75 3.374 L 24.75 12.874 L 15.25 12.874 L 15.25 3.374 L 24.75 3.374 Z  M 24.75 15.25 L 24.75 24.75 L 15.25 24.75 L 15.25 15.25 L 24.75 15.25 Z  M 3.374 3.374 L 12.874 3.374 L 12.874 12.874 L 3.374 12.874 L 3.374 3.374 Z  M 3.374 15.25 L 12.874 15.25 L 12.874 24.75 L 3.374 24.75 L 3.374 15.25 Z  M 3.374 36.626 L 3.374 27.126 L 12.874 27.126 L 12.874 36.626 L 3.374 36.626 Z  M 15.25 36.626 L 15.25 27.126 L 24.75 27.126 L 24.75 36.626 L 15.25 36.626 Z  M 36.626 36.626 L 27.126 36.626 L 27.126 27.126 L 36.626 27.126 L 36.626 36.626 Z  M 36.626 24.75 L 27.126 24.75 L 27.126 15.25 L 36.626 15.25 L 36.626 24.75 Z',
        customStroke: '0.5px',
    },
    grid_list: {
        path: 'M 2.856 11.129 C 2.136 11.129 1.55 10.543 1.55 9.823 L 1.55 2.856 C 1.55 2.136 2.136 1.55 2.856 1.55 L 9.823 1.55 C 10.543 1.55 11.129 2.136 11.129 2.856 L 11.129 9.823 C 11.129 10.543 10.543 11.129 9.823 11.129 L 2.856 11.129 Z  M 2.856 2.421 C 2.616 2.421 2.421 2.616 2.421 2.856 L 2.421 9.823 C 2.421 10.063 2.616 10.258 2.856 10.258 L 9.823 10.258 C 10.063 10.258 10.258 10.063 10.258 9.823 L 10.258 2.856 C 10.258 2.616 10.063 2.421 9.823 2.421 L 2.856 2.421 Z  M 14.177 11.129 C 13.457 11.129 12.871 10.543 12.871 9.823 L 12.871 2.856 C 12.871 2.136 13.457 1.55 14.177 1.55 L 21.144 1.55 C 21.864 1.55 22.45 2.136 22.45 2.856 L 22.45 9.823 C 22.45 10.543 21.864 11.129 21.144 11.129 L 14.177 11.129 Z  M 14.177 2.421 C 13.937 2.421 13.742 2.616 13.742 2.856 L 13.742 9.823 C 13.742 10.063 13.937 10.258 14.177 10.258 L 21.144 10.258 C 21.384 10.258 21.579 10.063 21.579 9.823 L 21.579 2.856 C 21.579 2.616 21.384 2.421 21.144 2.421 L 14.177 2.421 Z  M 2.856 22.45 C 2.136 22.45 1.55 21.864 1.55 21.144 L 1.55 14.177 C 1.55 13.457 2.136 12.871 2.856 12.871 L 9.823 12.871 C 10.543 12.871 11.129 13.457 11.129 14.177 L 11.129 21.144 C 11.129 21.864 10.543 22.45 9.823 22.45 L 2.856 22.45 Z  M 2.856 13.742 C 2.616 13.742 2.421 13.937 2.421 14.177 L 2.421 21.144 C 2.421 21.384 2.616 21.579 2.856 21.579 L 9.823 21.579 C 10.063 21.579 10.258 21.384 10.258 21.144 L 10.258 14.177 C 10.258 13.937 10.063 13.742 9.823 13.742 L 2.856 13.742 Z  M 14.177 22.45 C 13.457 22.45 12.871 21.864 12.871 21.144 L 12.871 14.177 C 12.871 13.457 13.457 12.871 14.177 12.871 L 21.144 12.871 C 21.864 12.871 22.45 13.457 22.45 14.177 L 22.45 21.144 C 22.45 21.864 21.864 22.45 21.144 22.45 L 14.177 22.45 Z  M 14.177 13.742 C 13.937 13.742 13.742 13.937 13.742 14.177 L 13.742 21.144 C 13.742 21.384 13.937 21.579 14.177 21.579 L 21.144 21.579 C 21.384 21.579 21.579 21.384 21.579 21.144 L 21.579 14.177 C 21.579 13.937 21.384 13.742 21.144 13.742 L 14.177 13.742 Z',
        customStroke: '0.5px',
    },
    header_four: {
        path: 'M 2.375 23 C 1.617 23 1 22.383 1 21.625 L 1 6.041 C 1 5.284 1.617 4.666 2.375 4.666 L 3.75 4.666 L 3.75 2.375 C 3.75 1.617 4.367 1 5.125 1 L 21.625 1 C 22.383 1 23 1.617 23 2.375 L 23 18.875 C 23 19.633 22.383 20.25 21.625 20.25 L 19.334 20.25 L 19.334 21.625 C 19.334 22.383 18.716 23 17.959 23 L 2.375 23 Z  M 2.375 5.584 C 2.122 5.584 1.916 5.788 1.916 6.041 L 1.916 21.625 C 1.916 21.878 2.122 22.084 2.375 22.084 L 17.959 22.084 C 18.212 22.084 18.416 21.878 18.416 21.625 L 18.416 20.25 L 5.125 20.25 C 4.367 20.25 3.75 19.633 3.75 18.875 L 3.75 5.584 L 2.375 5.584 Z  M 5.125 1.916 C 4.872 1.916 4.666 2.122 4.666 2.375 L 4.666 18.875 C 4.666 19.128 4.872 19.334 5.125 19.334 L 21.625 19.334 C 21.878 19.334 22.084 19.128 22.084 18.875 L 22.084 2.375 C 22.084 2.122 21.878 1.916 21.625 1.916 L 5.125 1.916 Z  M 15.209 14.75 C 14.956 14.75 14.75 14.544 14.75 14.291 L 14.75 12.916 L 10.625 12.916 C 10.372 12.916 10.166 12.712 10.166 12.459 L 10.166 11.541 C 10.166 8.761 12.428 6.5 15.209 6.5 C 15.462 6.5 15.666 6.706 15.666 6.959 L 15.666 14.291 C 15.666 14.544 15.462 14.75 15.209 14.75 Z  M 14.75 12 L 14.75 7.441 C 12.676 7.671 11.084 9.427 11.084 11.541 L 11.084 12 L 14.75 12 Z',
        customStroke: '0.5px',
    },
    header_three: {
        path: 'M 2.375 23 C 1.617 23 1 22.383 1 21.625 L 1 6.041 C 1 5.284 1.617 4.666 2.375 4.666 L 3.75 4.666 L 3.75 2.375 C 3.75 1.617 4.367 1 5.125 1 L 21.625 1 C 22.383 1 23 1.617 23 2.375 L 23 18.875 C 23 19.633 22.383 20.25 21.625 20.25 L 19.334 20.25 L 19.334 21.625 C 19.334 22.383 18.716 23 17.959 23 L 2.375 23 Z  M 2.375 5.584 C 2.122 5.584 1.916 5.788 1.916 6.041 L 1.916 21.625 C 1.916 21.878 2.122 22.084 2.375 22.084 L 17.959 22.084 C 18.212 22.084 18.416 21.878 18.416 21.625 L 18.416 20.25 L 5.125 20.25 C 4.367 20.25 3.75 19.633 3.75 18.875 L 3.75 5.584 L 2.375 5.584 Z  M 5.125 1.916 C 4.872 1.916 4.666 2.122 4.666 2.375 L 4.666 18.875 C 4.666 19.128 4.872 19.334 5.125 19.334 L 21.625 19.334 C 21.878 19.334 22.084 19.128 22.084 18.875 L 22.084 2.375 C 22.084 2.122 21.878 1.916 21.625 1.916 L 5.125 1.916 Z  M 10.625 14.75 C 10.372 14.75 10.166 14.544 10.166 14.291 C 10.166 14.038 10.372 13.834 10.625 13.834 L 13.375 13.834 C 14.133 13.834 14.75 13.216 14.75 12.459 C 14.75 11.7 14.133 11.084 13.375 11.084 C 13.122 11.084 12.916 10.878 12.916 10.625 C 12.916 10.372 13.122 10.166 13.375 10.166 C 14.133 10.166 14.75 9.55 14.75 8.791 C 14.75 8.034 14.133 7.416 13.375 7.416 L 10.625 7.416 C 10.372 7.416 10.166 7.212 10.166 6.959 C 10.166 6.706 10.372 6.5 10.625 6.5 L 13.375 6.5 C 14.638 6.5 15.666 7.528 15.666 8.791 C 15.666 9.522 15.323 10.196 14.75 10.625 C 15.323 11.054 15.666 11.728 15.666 12.459 C 15.666 13.721 14.638 14.75 13.375 14.75 L 10.625 14.75 Z',
        customStroke: '0.5px',
    },
    header_two: {
        path: 'M 2.375 23 C 1.617 23 1 22.383 1 21.625 L 1 6.041 C 1 5.284 1.617 4.666 2.375 4.666 L 3.75 4.666 L 3.75 2.375 C 3.75 1.617 4.367 1 5.125 1 L 21.625 1 C 22.383 1 23 1.617 23 2.375 L 23 18.875 C 23 19.633 22.383 20.25 21.625 20.25 L 19.334 20.25 L 19.334 21.625 C 19.334 22.383 18.716 23 17.959 23 L 2.375 23 Z  M 2.375 5.584 C 2.122 5.584 1.916 5.788 1.916 6.041 L 1.916 21.625 C 1.916 21.878 2.122 22.084 2.375 22.084 L 17.959 22.084 C 18.212 22.084 18.416 21.878 18.416 21.625 L 18.416 20.25 L 5.125 20.25 C 4.367 20.25 3.75 19.633 3.75 18.875 L 3.75 5.584 L 2.375 5.584 Z  M 5.125 1.916 C 4.872 1.916 4.666 2.122 4.666 2.375 L 4.666 18.875 C 4.666 19.128 4.872 19.334 5.125 19.334 L 21.625 19.334 C 21.878 19.334 22.084 19.128 22.084 18.875 L 22.084 2.375 C 22.084 2.122 21.878 1.916 21.625 1.916 L 5.125 1.916 Z  M 11.084 14.75 C 10.895 14.75 10.722 14.631 10.655 14.454 C 10.587 14.277 10.638 14.074 10.78 13.948 L 14.073 11.042 C 14.914 10.301 15.377 9.894 15.171 8.882 C 15.074 8.402 14.796 7.99 14.388 7.718 C 14.087 7.518 13.737 7.413 13.38 7.413 C 13.257 7.413 13.132 7.426 13.011 7.451 C 12.159 7.624 11.541 8.38 11.541 9.25 C 11.541 9.503 11.337 9.709 11.084 9.709 C 10.831 9.709 10.625 9.503 10.625 9.25 C 10.624 7.947 11.55 6.811 12.828 6.552 C 13.01 6.516 13.196 6.497 13.381 6.497 C 13.917 6.497 14.441 6.655 14.894 6.954 C 15.506 7.361 15.924 7.98 16.07 8.7 C 16.381 10.232 15.554 10.96 14.679 11.73 L 12.295 13.834 L 16.125 13.834 C 16.378 13.834 16.584 14.038 16.584 14.291 C 16.584 14.544 16.378 14.75 16.125 14.75 L 11.084 14.75 Z',
        customStroke: '0.5px',
    },
    improve: {
        path: 'M 8.072 18.286 L 15.929 18.286 L 15.929 19.857 L 8.072 19.857 L 8.072 18.286 Z  M 9.643 21.429 L 14.357 21.429 L 14.357 23 L 9.643 23 L 9.643 21.429 Z  M 12 1 C 7.661 1 4.143 4.518 4.143 8.857 C 4.035 11.174 5.046 13.401 6.862 14.844 C 7.647 15.575 8.072 15.991 8.072 16.714 L 9.643 16.714 C 9.643 15.269 8.771 14.459 7.922 13.681 C 6.431 12.54 5.604 10.732 5.714 8.857 C 5.714 5.386 8.529 2.571 12 2.571 C 15.472 2.571 18.286 5.386 18.286 8.857 C 18.394 10.733 17.564 12.541 16.07 13.681 C 15.229 14.467 14.357 15.253 14.357 16.714 L 15.929 16.714 C 15.929 15.991 16.345 15.575 17.139 14.836 C 18.952 13.396 19.964 11.171 19.857 8.857 C 19.857 4.518 16.339 1 12 1 Z',
    },
    industrial: {
        path: 'M 22.631 5.046 C 22.388 4.906 22.088 4.906 21.845 5.046 L 15.143 8.37 L 15.143 5.714 C 15.142 5.442 15 5.189 14.768 5.047 C 14.536 4.905 14.247 4.892 14.004 5.015 L 7.286 8.37 L 7.286 2.571 C 7.286 2.137 6.934 1.786 6.5 1.786 L 1.786 1.786 C 1.352 1.786 1 2.137 1 2.571 L 1 22.214 L 23 22.214 L 23 5.714 C 23.001 5.443 22.861 5.19 22.631 5.046 L 22.631 5.046 Z  M 16.714 20.643 L 13.571 20.643 L 13.571 15.143 L 16.714 15.143 L 16.714 20.643 Z  M 21.429 20.643 L 18.286 20.643 L 18.286 14.357 C 18.286 13.923 17.934 13.571 17.5 13.571 L 12.786 13.571 C 12.352 13.571 12 13.923 12 14.357 L 12 20.643 L 2.571 20.643 L 2.571 3.357 L 5.714 3.357 L 5.714 10.916 L 13.571 6.987 L 13.571 10.916 L 21.429 6.987 L 21.429 20.643 Z',
    },
    info: {
        path: 'M 12.857 17.143 L 12.857 9.429 L 9.429 9.429 L 9.429 11.143 L 11.143 11.143 L 11.143 17.143 L 8.571 17.143 L 8.571 18.857 L 15.429 18.857 L 15.429 17.143 L 12.857 17.143 L 12.857 17.143 Z  M 12 4.286 C 11.29 4.286 10.714 4.861 10.714 5.571 C 10.714 6.282 11.29 6.857 12 6.857 C 12.71 6.857 13.286 6.282 13.286 5.571 C 13.286 4.861 12.71 4.286 12 4.286 Z  M 12 24 C 5.373 24 0 18.627 0 12 C 0 5.373 5.373 0 12 0 C 18.627 0 24 5.373 24 12 C 24 18.627 18.627 24 12 24 Z  M 12 1.714 C 6.319 1.714 1.714 6.319 1.714 12 C 1.714 17.681 6.319 22.286 12 22.286 C 17.681 22.286 22.286 17.681 22.286 12 C 22.286 6.319 17.681 1.714 12 1.714 Z',
    },
    instagram: {
        path: 'M 12 16.211 C 9.678 16.211 7.789 14.322 7.789 12 C 7.789 9.678 9.678 7.789 12 7.789 C 14.322 7.789 16.211 9.678 16.211 12 C 16.211 14.322 14.322 16.211 12 16.211 L 12 16.211 L 12 16.211 Z  M 12 6.07 C 8.73 6.07 6.07 8.73 6.07 12 C 6.07 15.27 8.73 17.93 12 17.93 C 15.27 17.93 17.93 15.27 17.93 12 C 17.93 8.73 15.27 6.07 12 6.07 L 12 6.07 L 12 6.07 Z  M 21.281 16.609 C 21.281 19.185 19.185 21.281 16.609 21.281 L 7.391 21.281 C 4.815 21.281 2.719 19.185 2.719 16.609 L 2.719 7.391 C 2.719 4.815 4.815 2.719 7.391 2.719 L 16.609 2.719 C 19.185 2.719 21.281 4.815 21.281 7.391 L 21.281 16.609 L 21.281 16.609 L 21.281 16.609 Z  M 16.609 1 L 7.391 1 C 3.867 1 1 3.867 1 7.391 L 1 16.609 C 1 20.133 3.867 23 7.391 23 L 16.609 23 C 20.133 23 23 20.133 23 16.609 L 23 7.391 C 23 3.867 20.133 1 16.609 1 L 16.609 1 L 16.609 1 Z  M 17.156 5.984 C 17.156 5.51 17.541 5.125 18.016 5.125 C 18.49 5.125 18.875 5.51 18.875 5.984 C 18.875 6.459 18.49 6.844 18.016 6.844 C 17.541 6.844 17.156 6.459 17.156 5.984 Z',
        customStroke: '0',
    },
    issue_open: {
        path: 'M 12 11.738 C 11.696 11.738 11.45 11.984 11.45 12.288 C 11.45 12.592 11.696 12.838 12 12.838 C 12.304 12.838 12.55 12.592 12.55 12.288 C 12.55 11.984 12.304 11.738 12 11.738 Z  M 11.634 7.705 L 12.472 7.705 L 12.472 11.006 L 11.634 11.006 L 11.634 7.705 Z  M 16.767 14.305 L 7.233 14.305 C 7.105 14.305 6.986 14.238 6.919 14.129 C 6.853 14.02 6.848 13.883 6.907 13.769 L 11.674 4.603 C 11.736 4.48 11.862 4.403 12 4.403 C 12.138 4.403 12.264 4.48 12.326 4.603 L 17.093 13.769 C 17.152 13.883 17.147 14.02 17.081 14.129 C 17.014 14.238 16.895 14.305 16.767 14.305 Z  M 7.838 13.571 L 16.162 13.571 L 12 5.567 L 7.838 13.571 Z  M 13.367 22.214 L 12 21.429 L 15.143 15.929 L 19.857 15.929 C 20.725 15.929 21.429 15.225 21.429 14.357 L 21.429 4.929 C 21.429 4.061 20.725 3.357 19.857 3.357 L 4.143 3.357 C 3.275 3.357 2.571 4.061 2.571 4.929 L 2.571 14.357 C 2.571 15.225 3.275 15.929 4.143 15.929 L 11.214 15.929 L 11.214 17.5 L 4.143 17.5 C 2.407 17.5 1 16.093 1 14.357 L 1 4.929 C 1 3.193 2.407 1.786 4.143 1.786 L 19.857 1.786 C 21.593 1.786 23 3.193 23 4.929 L 23 14.357 C 23 16.093 21.593 17.5 19.857 17.5 L 16.054 17.5 L 13.367 22.214 Z',
    },
    issue_closed: {
        path: 'M 11.267 13.729 L 6.552 9.014 L 7.293 8.273 L 11.267 12.247 L 18.383 5.131 L 19.124 5.871 L 11.267 13.729 Z  M 13.367 22.214 L 12 21.429 L 15.143 15.929 L 19.857 15.929 C 20.725 15.929 21.429 15.225 21.429 14.357 L 21.429 4.929 C 21.429 4.061 20.725 3.357 19.857 3.357 L 4.143 3.357 C 3.275 3.357 2.571 4.061 2.571 4.929 L 2.571 14.357 C 2.571 15.225 3.275 15.929 4.143 15.929 L 11.214 15.929 L 11.214 17.5 L 4.143 17.5 C 2.407 17.5 1 16.093 1 14.357 L 1 4.929 C 1 3.193 2.407 1.786 4.143 1.786 L 19.857 1.786 C 21.593 1.786 23 3.193 23 4.929 L 23 14.357 C 23 16.093 21.593 17.5 19.857 17.5 L 16.054 17.5 L 13.367 22.214 Z',
    },
    italic: {
        path: 'M 23 3.444 L 23 1 L 7.111 1 L 7.111 3.444 L 13.393 3.444 L 8.052 20.556 L 1 20.556 L 1 23 L 16.889 23 L 16.889 20.556 L 10.607 20.556 L 15.948 3.444 L 23 3.444 L 23 3.444 Z',
    },
    labels: {
        path: 'M 5.712 10.429 C 5.712 9.561 6.416 8.857 7.283 8.857 C 8.151 8.857 8.855 9.561 8.855 10.429 C 8.855 11.296 8.151 12 7.283 12 C 6.416 12 5.712 11.296 5.712 10.429 Z  M 11.998 23 C 11.789 23.001 11.588 22.919 11.44 22.772 L 3.033 14.357 C 2.738 14.064 2.571 13.665 2.569 13.249 L 2.569 7.286 C 2.569 6.418 3.273 5.714 4.141 5.714 L 10.104 5.714 C 10.52 5.716 10.919 5.883 11.212 6.178 L 19.627 14.585 C 19.776 14.733 19.859 14.933 19.859 15.143 C 19.859 15.352 19.776 15.553 19.627 15.701 L 12.556 22.772 C 12.407 22.919 12.207 23.001 11.998 23 Z  M 4.141 7.286 L 4.141 13.249 L 11.998 21.106 L 17.961 15.143 L 10.104 7.286 L 4.141 7.286 Z  M 21.198 9.871 L 12.783 1.464 C 12.49 1.168 12.092 1.002 11.676 1 L 5.712 1 C 4.844 1 4.141 1.704 4.141 2.571 L 4.141 4.143 L 5.712 4.143 L 5.712 2.571 L 11.676 2.571 L 19.533 10.429 L 18.511 11.442 L 19.627 12.558 L 21.198 10.986 C 21.347 10.839 21.431 10.638 21.431 10.429 C 21.431 10.219 21.347 10.018 21.198 9.871 Z',
    },
    launch: {
        path: 'M 19.615 23 L 2.692 23 C 1.758 23 1 22.242 1 21.308 L 1 4.385 C 1 3.45 1.758 2.692 2.692 2.692 L 10.308 2.692 L 10.308 4.385 L 2.692 4.385 L 2.692 21.308 L 19.615 21.308 L 19.615 13.692 L 21.308 13.692 L 21.308 21.308 C 21.308 22.242 20.55 23 19.615 23 Z  M 15.385 1 L 15.385 2.692 L 20.115 2.692 L 12.846 9.961 L 14.039 11.154 L 21.308 3.885 L 21.308 8.615 L 23 8.615 L 23 1 L 15.385 1 L 15.385 1 Z',
    },
    layers: {
        path: 'M 12 22.715 C 11.865 22.715 11.733 22.687 11.609 22.634 L 1.591 18.276 C 1.35 18.173 1.165 17.981 1.069 17.737 C 0.973 17.495 0.979 17.228 1.082 16.989 C 1.181 16.761 1.361 16.582 1.588 16.483 L 5.711 14.69 L 1.588 12.897 C 1.349 12.794 1.164 12.602 1.069 12.358 C 0.972 12.116 0.978 11.849 1.082 11.61 C 1.181 11.382 1.361 11.202 1.588 11.103 L 5.713 9.31 L 1.591 7.517 C 1.35 7.413 1.165 7.221 1.069 6.978 C 0.973 6.736 0.979 6.47 1.082 6.23 C 1.182 6.002 1.362 5.823 1.588 5.724 L 11.609 1.366 C 11.733 1.313 11.863 1.285 11.999 1.285 C 12.135 1.285 12.266 1.313 12.391 1.366 L 22.409 5.724 C 22.904 5.939 23.131 6.516 22.915 7.011 C 22.816 7.239 22.636 7.418 22.409 7.517 L 18.287 9.31 L 22.409 11.103 C 22.65 11.207 22.835 11.398 22.931 11.642 C 23.027 11.885 23.021 12.151 22.918 12.391 C 22.818 12.619 22.639 12.798 22.412 12.897 L 18.289 14.69 L 22.412 16.483 C 22.651 16.586 22.836 16.779 22.931 17.022 C 23.028 17.264 23.022 17.53 22.918 17.77 C 22.819 17.998 22.64 18.177 22.412 18.276 L 12.391 22.634 C 12.267 22.687 12.135 22.715 12 22.715 Z  M 1.98 17.38 L 12 21.737 L 22.021 17.38 L 17.062 15.223 L 12.391 17.255 C 12.267 17.308 12.135 17.336 12 17.336 C 11.865 17.336 11.733 17.308 11.609 17.255 L 6.939 15.224 L 1.98 17.38 Z  M 12 16.358 L 22.021 12.001 L 17.061 9.844 L 12.391 11.874 C 12.267 11.928 12.135 11.955 12 11.955 C 11.865 11.955 11.733 11.928 11.609 11.874 L 6.939 9.843 L 1.979 11.999 L 7.119 14.234 C 7.124 14.238 12 16.358 12 16.358 Z  M 1.98 6.62 L 12 10.978 L 22.021 6.62 L 12 2.263 L 1.98 6.62 Z',
        customStroke: '0.5px',
    },
    liked: {
        path: 'M 17.089 2.214 C 15.523 2.214 14.036 2.84 12.94 3.936 L 12 4.875 L 11.139 4.014 C 8.868 1.665 5.11 1.665 2.84 3.936 C 2.84 3.936 2.762 4.014 2.762 4.014 C 0.413 6.363 0.413 10.121 2.762 12.47 L 12 21.786 L 21.238 12.47 C 23.587 10.121 23.587 6.363 21.238 4.014 C 20.142 2.84 18.655 2.214 17.089 2.214 Z',
    },
    link: {
        path: 'M 21.708 4.869 C 20.883 4.042 19.764 3.577 18.596 3.577 C 17.428 3.577 16.308 4.042 15.484 4.869 L 16.523 5.909 C 17.265 5.168 18.346 4.878 19.359 5.149 C 20.372 5.421 21.164 6.212 21.435 7.225 C 21.707 8.238 21.417 9.319 20.675 10.061 L 14.817 15.919 C 13.673 17.066 11.816 17.067 10.669 15.923 C 9.523 14.778 9.521 12.921 10.665 11.775 L 11.698 10.735 L 10.665 9.695 L 9.626 10.735 C 8.798 11.559 8.333 12.679 8.333 13.847 C 8.333 15.015 8.798 16.135 9.626 16.959 C 10.454 17.777 11.574 18.232 12.738 18.226 C 13.91 18.23 15.036 17.766 15.864 16.937 L 21.722 11.079 C 23.432 9.36 23.425 6.581 21.708 4.869 Z  M 3.358 18.094 C 2.805 17.544 2.495 16.797 2.495 16.018 C 2.495 15.239 2.805 14.492 3.358 13.942 L 9.216 8.084 C 9.765 7.532 10.512 7.221 11.292 7.221 C 12.071 7.221 12.818 7.532 13.367 8.084 C 13.916 8.638 14.218 9.391 14.202 10.171 C 14.207 10.953 13.898 11.705 13.346 12.258 L 11.793 13.832 L 12.833 14.872 L 14.385 13.32 C 16.106 11.599 16.106 8.809 14.385 7.088 C 12.665 5.367 9.875 5.367 8.154 7.088 L 2.296 12.946 C 1.466 13.771 1 14.892 1 16.062 C 1 17.232 1.466 18.353 2.296 19.178 C 3.13 19.989 4.252 20.437 5.415 20.422 C 6.589 20.424 7.716 19.96 8.549 19.134 L 7.509 18.094 C 6.96 18.646 6.213 18.957 5.434 18.957 C 4.654 18.957 3.907 18.646 3.358 18.094 Z',
    },
    linkedin: {
        path: 'M 21.224 1 Q 21.969 1 22.484 1.487 Q 22.999 1.974 23 2.719 L 23 21.109 Q 23 21.854 22.484 22.427 Q 21.968 23 21.224 23 L 2.891 23 Q 2.146 23 1.573 22.427 Q 1 21.854 1 21.109 L 1 2.719 Q 1 1.974 1.545 1.487 Q 2.089 1 2.891 1 L 21.224 1 Z  M 7.818 19.332 L 7.818 9.536 L 4.666 9.536 L 4.666 19.332 L 7.818 19.332 Z  M 6.329 8.048 Q 7.074 8.048 7.561 7.561 Q 8.048 7.074 8.048 6.387 Q 8.048 5.641 7.589 5.155 Q 7.13 4.668 6.385 4.668 Q 5.64 4.668 5.153 5.155 Q 4.666 5.641 4.666 6.387 Q 4.666 7.074 5.125 7.561 Q 5.584 8.048 6.329 8.048 Z  M 19.332 19.332 L 19.332 13.603 Q 19.332 11.483 18.33 10.396 Q 17.327 9.308 15.723 9.307 Q 14.004 9.307 12.858 10.911 L 12.858 9.536 L 9.707 9.536 L 9.707 19.332 L 12.858 19.332 L 12.858 13.774 Q 12.858 13.202 12.974 12.974 Q 13.431 11.827 14.577 11.827 Q 16.181 11.827 16.181 13.947 L 16.181 19.332 L 19.332 19.332 Z',
        customStroke: '0',
    },
    list: {
        path: 'M 12 5.946 L 23 5.946 L 23 7.518 L 12 7.518 L 12 5.946 Z  M 4.143 7.981 L 2.108 5.946 L 1 7.054 L 4.143 10.197 L 10.429 3.911 L 9.321 2.803 L 4.143 7.981 L 4.143 7.981 Z  M 12 16.946 L 23 16.946 L 23 18.518 L 12 18.518 L 12 16.946 Z  M 4.143 18.981 L 2.108 16.946 L 1 18.054 L 4.143 21.197 L 10.429 14.911 L 9.321 13.803 L 4.143 18.981 L 4.143 18.981 Z',
    },
    locked: {
        path: 'M 18.286 10.429 L 16.714 10.429 L 16.714 5.714 C 16.714 3.111 14.604 1 12 1 C 9.396 1 7.286 3.111 7.286 5.714 L 7.286 10.429 L 5.714 10.429 C 4.846 10.429 4.143 11.132 4.143 12 L 4.143 21.429 C 4.143 22.296 4.846 23 5.714 23 L 18.286 23 C 19.154 23 19.857 22.296 19.857 21.429 L 19.857 12 C 19.857 11.132 19.154 10.429 18.286 10.429 Z  M 8.857 5.714 C 8.857 3.979 10.264 2.571 12 2.571 C 13.736 2.571 15.143 3.979 15.143 5.714 L 15.143 10.429 L 8.857 10.429 L 8.857 5.714 Z  M 18.286 21.429 L 5.714 21.429 L 5.714 12 L 18.286 12 L 18.286 21.429 Z',
    },
    loop: {
        path: 'M 4.042 14.802 C 3.896 14.795 3.762 14.718 3.681 14.597 L 1.08 10.724 C 1.01 10.62 0.986 10.496 1.008 10.374 C 1.033 10.252 1.102 10.147 1.206 10.077 C 1.284 10.025 1.373 9.997 1.465 9.997 C 1.622 9.997 1.767 10.075 1.853 10.204 L 3.362 12.449 C 3.298 8.444 6.017 4.834 9.976 3.846 L 10.063 3.824 C 10.701 3.674 11.354 3.598 12.008 3.598 C 14.407 3.598 16.699 4.632 18.292 6.436 C 18.462 6.629 18.444 6.924 18.251 7.095 C 18.165 7.17 18.055 7.212 17.942 7.212 C 17.809 7.212 17.681 7.154 17.591 7.053 C 16.177 5.45 14.14 4.531 12.008 4.531 C 11.428 4.531 10.847 4.599 10.281 4.734 L 10.202 4.753 C 6.359 5.711 3.87 9.392 4.352 13.27 L 6.701 10.457 C 6.789 10.351 6.92 10.29 7.059 10.29 C 7.168 10.29 7.275 10.329 7.358 10.399 C 7.555 10.564 7.581 10.859 7.416 11.056 L 4.426 14.637 C 4.336 14.742 4.046 14.802 4.042 14.802 Z  M 11.972 20.402 C 9.764 20.402 7.677 19.54 6.093 17.974 C 6.004 17.886 5.955 17.769 5.955 17.645 C 5.953 17.519 6.002 17.402 6.09 17.314 C 6.178 17.224 6.296 17.175 6.421 17.175 C 6.546 17.175 6.662 17.223 6.75 17.31 C 8.158 18.702 10.014 19.468 11.975 19.468 C 11.975 19.468 11.975 19.468 11.975 19.468 C 12.558 19.468 13.143 19.4 13.715 19.263 C 17.145 18.443 19.555 15.302 19.527 11.816 L 17.299 14.485 C 17.209 14.591 17.079 14.653 16.94 14.653 C 16.831 14.653 16.724 14.615 16.641 14.544 C 16.444 14.379 16.416 14.084 16.582 13.887 L 19.518 10.372 C 19.532 10.353 19.546 10.337 19.562 10.32 L 19.576 10.303 C 19.664 10.197 19.794 10.136 19.933 10.136 C 19.937 10.136 19.955 10.136 19.959 10.138 C 20.105 10.144 20.241 10.221 20.321 10.344 L 22.921 14.219 C 22.99 14.322 23.016 14.447 22.991 14.568 C 22.967 14.69 22.896 14.796 22.793 14.866 C 22.717 14.918 22.627 14.945 22.533 14.945 C 22.378 14.945 22.232 14.868 22.145 14.738 L 20.456 12.22 C 20.31 16.003 17.67 19.277 13.933 20.172 C 13.288 20.325 12.629 20.402 11.972 20.402 L 11.972 20.402 Z',
        customStroke: '0.5px',
    },
    marketplace: {
        path: 'M 17.5 2.474 L 23 12 L 17.5 21.526 L 6.5 21.526 L 1 12 L 6.5 2.474 L 17.5 2.474 Z  M 11.929 3.386 L 7.028 3.386 L 2.054 12.001 L 7.028 20.613 L 11.929 20.613 L 11.929 14.953 C 10.321 14.814 9.046 13.508 8.954 11.886 L 8.949 11.701 C 8.949 9.992 10.26 8.592 11.929 8.448 L 11.929 3.386 Z  M 16.973 3.386 L 12.936 3.386 L 12.936 8.516 C 14.334 8.831 15.391 10.042 15.474 11.515 L 15.479 11.701 C 15.479 13.256 14.392 14.557 12.937 14.886 L 12.936 20.613 L 16.973 20.613 L 21.946 12 L 16.973 3.387 L 16.973 3.386 Z  M 12.214 9.511 C 11.007 9.511 10.025 10.494 10.025 11.701 C 10.025 12.908 11.007 13.89 12.215 13.89 C 13.422 13.89 14.404 12.908 14.404 11.701 C 14.404 10.494 13.422 9.511 12.215 9.511 L 12.214 9.511 Z',
        customStroke: '0.5px',
    },
    medical: {
        path: 'M 11.084 18.416 C 10.578 18.416 10.166 18.006 10.166 17.5 L 10.166 15.666 L 8.334 15.666 C 7.828 15.666 7.416 15.256 7.416 14.75 L 7.416 12.916 C 7.416 12.41 7.828 12 8.334 12 L 10.166 12 L 10.166 10.166 C 10.166 9.662 10.578 9.25 11.084 9.25 L 12.916 9.25 C 13.422 9.25 13.834 9.662 13.834 10.166 L 13.834 12 L 15.666 12 C 16.172 12 16.584 12.41 16.584 12.916 L 16.584 14.75 C 16.584 15.256 16.172 15.666 15.666 15.666 L 13.834 15.666 L 13.834 17.5 C 13.834 18.006 13.422 18.416 12.916 18.416 L 11.084 18.416 Z  M 8.334 14.75 L 10.625 14.75 C 10.878 14.75 11.084 14.956 11.084 15.209 L 11.084 17.5 L 12.916 17.5 L 12.916 15.209 C 12.916 14.956 13.122 14.75 13.375 14.75 L 15.666 14.75 L 15.666 12.916 L 13.375 12.916 C 13.122 12.916 12.916 12.712 12.916 12.459 L 12.916 10.166 L 11.084 10.166 L 11.084 12.459 C 11.084 12.712 10.878 12.916 10.625 12.916 L 8.334 12.916 L 8.334 14.75 Z  M 3.291 21.166 C 2.028 21.166 1 20.138 1 18.875 L 1 7.875 C 1 6.611 2.028 5.584 3.291 5.584 L 8.334 5.584 L 8.334 4.666 C 8.334 3.656 9.156 2.834 10.166 2.834 L 13.834 2.834 C 14.844 2.834 15.666 3.656 15.666 4.666 L 15.666 5.584 L 20.709 5.584 C 21.972 5.584 23 6.611 23 7.875 L 23 18.875 C 23 20.138 21.972 21.166 20.709 21.166 L 3.291 21.166 Z  M 3.291 6.5 C 2.534 6.5 1.916 7.117 1.916 7.875 L 1.916 18.875 C 1.916 19.633 2.534 20.25 3.291 20.25 L 20.709 20.25 C 21.466 20.25 22.084 19.633 22.084 18.875 L 22.084 7.875 C 22.084 7.117 21.466 6.5 20.709 6.5 L 3.291 6.5 Z  M 14.75 5.584 L 14.75 4.666 C 14.75 4.162 14.34 3.75 13.834 3.75 L 10.166 3.75 C 9.662 3.75 9.25 4.162 9.25 4.666 L 9.25 5.584 L 14.75 5.584 Z',
        customStroke: '0.5px',
    },
    mesh: {
        path: 'M 1 39 L 28 39 L 39 28 L 39 2 L 12.5 2 L 1 12.5 L 1 39 M 34 3 L 3.5 11.5 L 13 3 L 34 3 M 36.5 3 L 27 12 L 5 12 L 36.5 3 M 37.5 3.5 L 28 35 L 28 12.5 L 37.5 3.5 M 38 4.5 L 38 28 L 28 38 L 38 4.5 M 27 13 L 27 37 L 3 13 L 27 13 M 2 14 L 26 38 L 2 38 L 2 14',
        customStroke: '1.5px',
    },
    brep: {
        path: 'M 26.48 2.46 C 18.81 2.61 11.14 2.47 3.47 2.52 C 1.31 2.89 2.67 6.04 2.31 7.61 C 2.33 12.73 2.22 17.84 2.34 22.96 C 2.53 24.55 1.73 26.29 2.71 27.71 C 4.07 29.38 5.82 30.68 7.3 32.25 C 8.99 33.88 10.64 35.54 12.24 37.26 C 14.06 38.09 16.12 37.39 18.04 37.64 C 23.73 37.64 29.43 37.6 35.12 37.66 C 37.37 38.66 38.63 36.01 37.87 34.2 C 37.9 27.21 37.84 20.21 37.89 13.22 C 36.88 11.04 34.61 9.91 33.11 8.13 C 31.31 6.37 29.55 4.57 27.75 2.81 C 27.38 2.56 26.92 2.47 26.48 2.46 Z M 26.03 3.6 C 28.06 3.93 28.97 6.07 30.51 7.2 C 32.28 8.93 34.12 10.6 35.76 12.45 C 28.25 12.43 20.73 12.5 13.21 12.42 C 10.17 9.61 7.28 6.65 4.36 3.72 C 11.43 3.68 18.51 3.8 25.57 3.65 C 25.72 3.61 25.88 3.62 26.03 3.6 Z M 3.55 4.58 C 6.47 7.5 9.47 10.35 12.34 13.31 C 12.47 20.73 12.37 28.16 12.4 35.58 C 9.43 32.71 6.47 29.83 3.55 26.9 C 3.45 19.46 3.47 12.02 3.55 4.58 Z M 16.67 13.58 C 18.12 13.88 19.5 14.03 20.88 13.63 C 22.34 14.34 23.76 13.35 25.21 13.78 C 26.66 14.27 28.05 13.16 29.51 13.94 C 30.87 13.46 32.18 13.76 33.58 13.97 C 35.39 12.45 37.79 14.85 36.47 16.76 C 36.81 17.91 36.65 19.54 36.46 20.94 C 37.2 22.58 35.88 24.34 36.68 25.95 C 36.11 27.4 36.73 28.78 36.62 30.2 C 35.91 31.66 37.29 32.98 36.4 34.44 C 36.37 35.27 37.17 36.98 35.54 36.3 C 34.21 35.72 32.97 37.11 31.58 36.14 C 30.12 36.71 28.64 36.22 27.05 36.23 C 25.6 36.96 24.15 35.6 22.87 36.51 C 21.26 36 19.67 36.45 18.09 36.34 C 16.61 35.48 14.81 37.64 13.73 35.76 C 13.01 34.1 14.39 32.48 13.47 30.76 C 13.62 29.73 14.33 29.43 13.54 28.5 C 13.68 26.96 13.97 25.52 13.45 24.09 C 14.52 22.41 12.95 21 13.78 19.36 C 13.73 17.89 13.35 16.55 13.91 15.07 C 12.73 13.4 14.73 13.66 15.8 14.01 C 16.2 14 16.28 13.53 16.67 13.58 Z M 17.02 14.83 C 15.09 16.66 19.39 15.75 17.02 14.83 Z M 20.61 14.83 C 18.57 16.58 22.91 15.85 20.61 14.83 Z M 24.14 14.83 C 22.2 16.66 26.5 15.75 24.14 14.83 Z M 31.25 14.83 C 29.32 16.66 33.63 15.77 31.25 14.83 Z M 27.66 14.84 C 25.81 16.79 30.06 15.63 27.66 14.84 Z M 34.78 14.84 C 32.92 16.79 37.19 15.62 34.78 14.84 Z M 25.87 16.6 C 24.05 18.57 28.34 17.33 25.87 16.6 Z M 15.17 16.61 C 13.48 18.66 17.64 17.22 15.17 16.61 Z M 22.29 16.61 C 20.6 18.67 24.74 17.21 22.29 16.61 Z M 18.7 16.61 C 17.09 18.76 21.23 17.1 18.7 16.61 Z M 29.4 16.61 C 27.74 18.73 31.85 17.16 29.4 16.61 Z M 32.93 16.61 C 31.32 18.75 35.46 17.12 32.93 16.61 Z M 27.61 18.37 C 25.96 20.44 30.11 18.92 27.61 18.37 Z M 16.91 18.38 C 15.38 20.53 19.45 18.8 16.91 18.38 Z M 24.02 18.38 C 22.48 20.53 26.58 18.82 24.02 18.38 Z M 31.14 18.38 C 29.61 20.53 33.68 18.8 31.14 18.38 Z M 20.44 18.39 C 19 20.6 23 18.71 20.44 18.39 Z M 34.67 18.39 C 33.23 20.59 37.23 18.71 34.67 18.39 Z M 15.29 20.09 C 13.21 21.77 17.58 21.18 15.29 20.09 Z M 22.41 20.09 C 20.33 21.78 24.69 21.17 22.41 20.09 Z M 18.88 20.09 C 16.69 21.66 21.13 21.3 18.88 20.09 Z M 29.52 20.09 C 27.44 21.75 31.81 21.19 29.52 20.09 Z M 25.94 20.1 C 23.93 21.23 28.29 21.37 25.94 20.1 Z M 33.05 20.1 C 31.04 21.29 35.42 21.32 33.05 20.1 Z M 27.67 21.85 C 25.8 23.82 30.08 22.63 27.67 21.85 Z M 20.55 21.86 C 18.68 23.79 22.97 22.65 20.55 21.86 Z M 34.78 21.86 C 32.91 23.77 37.18 22.68 34.78 21.86 Z M 16.97 21.86 C 15.23 23.89 19.42 22.54 16.97 21.86 Z M 24.08 21.86 C 22.34 23.89 26.53 22.54 24.08 21.86 Z M 31.19 21.86 C 29.46 23.89 33.63 22.52 31.19 21.86 Z M 15.18 23.63 C 13.48 25.62 17.66 24.24 15.18 23.63 Z M 22.29 23.63 C 20.6 25.62 24.77 24.25 22.29 23.63 Z M 29.4 23.63 C 27.71 25.63 31.89 24.24 29.4 23.63 Z M 18.7 23.63 C 17.09 25.75 21.23 24.12 18.7 23.63 Z M 25.81 23.63 C 24.22 25.75 28.35 24.11 25.81 23.63 Z M 32.93 23.63 C 31.33 25.75 35.46 24.11 32.93 23.63 Z M 27.73 25.35 C 25.7 26.51 30.08 26.61 27.73 25.35 Z M 34.84 25.36 C 32.84 26.45 37.16 26.67 34.84 25.36 Z M 16.91 25.4 C 15.38 27.55 19.45 25.81 16.91 25.4 Z M 20.44 25.4 C 18.99 27.59 23 25.76 20.44 25.4 Z M 24.03 25.4 C 22.5 27.55 26.56 25.81 24.03 25.4 Z M 31.14 25.4 C 29.63 27.55 33.67 25.8 31.14 25.4 Z M 15.23 27.11 C 13.35 28.99 17.61 27.97 15.23 27.11 Z M 18.82 27.11 C 16.8 28.89 21.19 28.08 18.82 27.11 Z M 22.34 27.11 C 20.46 29.01 24.71 27.95 22.34 27.11 Z M 25.93 27.11 C 23.92 28.89 28.3 28.08 25.93 27.11 Z M 29.46 27.11 C 27.59 28.99 31.83 27.96 29.46 27.11 Z M 33.04 27.11 C 31.03 28.89 35.41 28.08 33.04 27.11 Z M 16.97 28.88 C 15.24 30.93 19.41 29.5 16.97 28.88 Z M 24.08 28.88 C 22.38 30.92 26.52 29.51 24.08 28.88 Z M 31.2 28.88 C 29.48 30.93 33.63 29.51 31.2 28.88 Z M 34.72 28.88 C 33.05 30.97 37.21 29.46 34.72 28.88 Z M 20.5 28.89 C 18.85 31 22.98 29.42 20.5 28.89 Z M 27.61 28.89 C 25.96 31 30.1 29.42 27.61 28.89 Z M 15.12 30.66 C 13.63 32.83 17.67 31.05 15.12 30.66 Z M 18.7 30.66 C 17.13 32.77 21.2 31.11 18.7 30.66 Z M 22.23 30.66 C 20.74 32.83 24.78 31.05 22.23 30.66 Z M 25.82 30.66 C 24.24 32.75 28.33 31.13 25.82 30.66 Z M 29.34 30.66 C 27.86 32.83 31.9 31.05 29.34 30.66 Z M 32.93 30.66 C 31.36 32.78 35.45 31.11 32.93 30.66 Z M 17.08 32.36 C 14.96 33.98 19.37 33.52 17.08 32.36 Z M 31.31 32.36 C 29.17 34.01 33.59 33.5 31.31 32.36 Z M 27.72 32.37 C 25.66 34.09 30.04 33.41 27.72 32.37 Z M 34.84 32.37 C 32.78 34.1 37.18 33.39 34.84 32.37 Z M 20.67 32.37 C 18.46 33.88 22.87 33.62 20.67 32.37 Z M 24.2 32.37 C 22.06 33.96 26.48 33.54 24.2 32.37 Z M 15.23 34.13 C 13.34 36.02 17.6 34.98 15.23 34.13 Z M 18.76 34.13 C 16.94 36.12 21.21 34.88 18.76 34.13 Z M 22.29 34.13 C 20.6 36.23 24.74 34.73 22.29 34.13 Z M 25.87 34.13 C 24.05 36.12 28.31 34.87 25.87 34.13 Z M 29.4 34.13 C 27.71 36.18 31.85 34.78 29.4 34.13 Z M 32.99 34.13 C 31.17 36.14 35.42 34.85 32.99 34.13 Z',
        customStroke: '1.5px',
    },
    edges: {
        path: 'M 24.04 4.39 C 20.5 4.87 16.9 5.11 13.33 5.47 C 12.34 5.56 11.38 5.68 10.39 5.77 C 10 5.8 9.28 5.74 8.95 5.95 C 8.53 6.25 8.23 7.3 7.99 7.75 C 7.21 9.31 6.43 10.84 5.65 12.37 L 2.56 18.55 L 1.66 20.35 C 1.54 20.56 1.33 20.86 1.33 21.1 C 1.33 21.52 1.84 22.12 2.05 22.48 C 2.71 23.65 3.37 24.79 4.03 25.96 C 5.2 28 6.34 30.04 7.48 32.05 L 8.53 33.91 C 8.68 34.18 8.83 34.57 9.07 34.81 C 9.52 35.23 10.27 35.53 10.81 35.83 C 11.86 36.43 12.91 37.12 13.99 37.63 C 14.35 37.78 14.86 37.63 15.22 37.6 C 16.33 37.54 17.41 37.39 18.52 37.27 C 22.45 36.88 26.47 36.67 30.37 36.1 C 30.67 36.04 30.79 35.8 30.91 35.53 L 31.63 34.09 C 32.65 32.02 33.73 29.98 34.78 27.91 C 35.68 26.08 36.58 24.22 37.54 22.42 C 37.84 21.85 38.14 21.25 38.44 20.65 C 38.56 20.41 38.8 20.08 38.83 19.78 C 38.86 19.42 38.23 18.67 38.02 18.28 C 37.3 16.99 36.55 15.73 35.83 14.44 L 32.05 7.81 L 31.03 6.01 C 30.91 5.77 30.76 5.38 30.55 5.23 C 30.16 4.99 29.32 5.05 28.87 4.99 C 27.85 4.84 26.83 4.72 25.81 4.57 C 25.24 4.48 24.61 4.33 24.04 4.39 M 28.9 5.26 V 5.32 C 25.72 5.74 22.51 5.98 19.33 6.28 C 17.59 6.46 15.7 6.88 13.96 6.82 C 12.64 6.76 11.32 6.31 10 6.13 L 11.71 5.95 L 15.1 5.62 L 20.92 5.05 L 24.37 4.72 L 28.9 5.29 M 30.04 5.53 C 30.49 5.47 30.61 5.89 30.79 6.22 L 32.14 8.56 C 33.73 11.38 35.32 14.17 36.94 16.99 C 37.33 17.68 37.72 18.4 38.14 19.09 C 38.29 19.33 38.56 19.66 38.47 19.96 C 38.08 21.19 37.24 22.42 36.64 23.59 C 35.29 26.26 33.94 28.93 32.59 31.6 C 32.08 32.59 31.57 33.61 31.06 34.6 C 30.91 34.93 30.7 35.59 30.4 35.8 C 30.13 35.98 29.56 35.92 29.23 35.95 C 28.15 36.07 27.04 36.13 25.96 36.25 C 22.15 36.64 18.31 37.18 14.47 37.39 C 14.08 37.39 13.93 36.88 13.75 36.58 C 13.24 35.71 12.76 34.84 12.25 33.97 C 10.72 31.24 9.19 28.51 7.63 25.81 L 6.52 23.86 C 6.4 23.65 6.1 23.32 6.13 23.05 C 6.13 22.72 6.49 22.27 6.64 21.97 C 8.44 18.43 10.21 14.92 11.98 11.38 C 12.49 10.39 13 9.43 13.48 8.44 C 13.66 8.08 13.84 7.42 14.17 7.18 C 14.44 6.97 15.13 7.03 15.49 7 C 16.45 6.94 17.44 6.82 18.43 6.7 C 22.3 6.31 26.17 5.98 30.04 5.53 M 13.81 7.09 C 13.3 8.29 12.64 9.43 12.07 10.57 C 10.66 13.36 9.25 16.12 7.84 18.91 C 7.36 19.87 6.88 20.86 6.4 21.82 C 6.28 22.03 6.04 22.72 5.8 22.78 C 5.53 22.84 4.93 22.48 4.66 22.36 C 3.67 21.94 2.65 21.55 1.66 21.1 C 1.84 20.5 2.23 19.93 2.5 19.39 L 4.33 15.76 C 5.89 12.61 7.33 9.31 9.1 6.28 C 10.63 6.58 12.25 7.03 13.81 7.09 M 22.81 11.74 C 17.65 11.83 13.84 16.45 13.39 21.34 C 13.03 25.12 14.92 29.2 18.67 30.49 C 19.57 30.79 20.5 30.88 21.43 30.85 C 26.74 30.79 30.79 25.09 30.58 20.11 C 30.4 15.82 27.43 11.68 22.81 11.74 M 16.15 28.57 C 16.57 28.27 17.38 28.24 17.92 28.06 C 18.88 27.7 19.78 27.16 20.56 26.5 C 23.74 23.86 25.3 19.39 24.16 15.37 C 23.98 14.68 23.68 13.96 23.32 13.33 C 23.05 12.91 22.69 12.52 22.48 12.1 C 22.99 11.98 23.38 12.55 23.68 12.91 C 24.55 13.93 25.15 15.19 25.45 16.54 C 26.32 20.68 24.52 25.33 20.86 27.58 C 19.9 28.18 18.85 28.6 17.71 28.78 C 17.11 28.87 16.63 28.96 16.15 28.57 M 16.96 29.23 V 29.2 C 18.19 29.05 19.33 28.78 20.44 28.18 C 24.55 25.93 26.77 20.89 25.72 16.33 C 25.45 15.28 25 14.23 24.37 13.33 C 24.04 12.91 23.65 12.52 23.35 12.1 C 23.83 12.16 24.28 12.67 24.61 13 C 25.6 13.99 26.35 15.19 26.71 16.54 C 27.97 20.89 26.08 25.93 22.15 28.3 C 21.07 28.93 19.9 29.29 18.67 29.44 C 18.1 29.53 17.44 29.56 16.96 29.23 M 21.73 12.16 C 22.33 12.07 22.72 12.94 22.99 13.39 C 23.86 14.86 24.25 16.54 24.25 18.25 C 24.22 21.73 22.27 25.33 19.24 27.1 C 18.31 27.64 17.14 28.15 16.06 28.21 C 15.55 28.24 15.1 27.28 14.86 26.92 C 14.02 25.39 13.66 23.68 13.66 21.97 C 13.72 17.5 17.11 12.7 21.73 12.16 M 25.15 12.43 L 25.09 12.49 L 25.15 12.43 M 24.58 12.49 C 25.45 13.06 26.26 13.66 26.89 14.53 C 29.17 17.62 28.99 22.12 27.07 25.33 C 25.27 28.36 21.58 30.91 17.95 29.86 V 29.8 C 24.25 29.77 28.42 22.87 27.19 17.11 C 26.95 15.94 26.44 14.83 25.75 13.87 C 25.51 13.54 25.27 13.24 25 12.94 C 24.88 12.82 24.64 12.67 24.58 12.49 M 25.24 12.49 C 29.59 13.96 31 19.21 29.83 23.23 C 28.9 26.56 26.26 29.59 22.81 30.34 C 21.79 30.58 20.74 30.55 19.72 30.43 V 30.37 C 21.7 30.37 23.68 29.38 25.15 28.12 C 29.59 24.19 30.52 16.15 25.18 12.52 L 25.24 12.49 M 1.9 21.52 C 2.77 21.94 3.64 22.27 4.51 22.63 C 4.9 22.78 5.44 22.9 5.74 23.17 C 6.1 23.47 6.31 24.07 6.52 24.49 L 8.14 27.34 L 11.89 33.97 C 12.46 34.96 13.3 36.04 13.63 37.12 C 12.7 36.58 11.77 36.04 10.81 35.5 C 10.33 35.23 9.7 34.99 9.31 34.6 C 9.07 34.39 8.92 34 8.74 33.73 L 7.72 31.9 C 6.58 29.92 5.44 27.91 4.33 25.9 C 3.76 24.88 3.13 23.83 2.56 22.81 C 2.35 22.48 1.9 21.91 1.9 21.52 Z',
        customStroke: '2px',
    },
    faces: {
        path: 'M 24.1 3.47 C 23.95 3.47 23.8 3.47 23.65 3.49 C 20 3.97 16.31 4.22 12.66 4.59 C 11.65 4.68 10.64 4.8 9.63 4.88 C 9.24 4.91 8.5 4.85 8.17 5.08 C 7.71 5.38 7.41 6.45 7.17 6.94 C 6.38 8.52 5.57 10.1 4.78 11.68 L 1.6 18.03 L 0.67 19.89 C 0.56 20.11 0.33 20.42 0.33 20.67 C 0.32 21.1 0.86 21.72 1.06 22.09 C 1.73 23.28 2.41 24.47 3.09 25.66 C 4.28 27.74 5.45 29.83 6.63 31.91 L 7.71 33.82 C 7.88 34.11 8.03 34.49 8.28 34.73 C 8.74 35.17 9.51 35.46 10.07 35.76 C 11.15 36.37 12.22 37.1 13.34 37.61 C 13.7 37.78 14.23 37.61 14.61 37.58 C 15.74 37.51 16.86 37.36 17.98 37.25 C 22.02 36.84 26.13 36.64 30.15 36.06 C 30.47 36.01 30.58 35.74 30.71 35.48 L 31.44 34.01 C 32.5 31.89 33.6 29.79 34.66 27.66 C 35.59 25.79 36.51 23.88 37.5 22.04 C 37.82 21.45 38.12 20.84 38.43 20.23 C 38.55 19.98 38.8 19.64 38.82 19.35 C 38.85 18.89 38.22 18.13 37.99 17.74 C 37.24 16.42 36.49 15.1 35.74 13.78 L 31.88 6.99 L 30.82 5.13 C 30.7 4.9 30.55 4.5 30.33 4.35 C 29.93 4.1 29.05 4.15 28.59 4.08 C 27.55 3.93 26.5 3.8 25.46 3.66 C 25.03 3.6 24.56 3.49 24.1 3.47 z M 24 3.81 L 28.64 4.4 L 28.64 4.45 C 25.38 4.86 22.09 5.11 18.82 5.43 C 17.02 5.61 15.09 6.04 13.29 5.96 C 11.94 5.91 10.58 5.45 9.24 5.28 L 11 5.07 L 14.47 4.73 L 20.43 4.15 L 24 3.81 z M 29.81 4.66 C 30.27 4.6 30.4 5.04 30.58 5.38 L 31.94 7.77 C 33.59 10.65 35.22 13.54 36.87 16.42 C 37.28 17.14 37.68 17.85 38.09 18.57 C 38.23 18.82 38.53 19.16 38.44 19.45 C 38.08 20.64 37.3 21.8 36.7 22.91 C 36.81 22.72 37.11 22.12 37.17 22.01 C 37.92 20.66 38.41 19.59 38.42 19.34 C 38.42 19.26 37.44 17.49 36.25 15.39 C 35.05 13.29 33.25 10.12 32.24 8.34 C 31.23 6.56 30.33 5.01 30.25 4.9 C 30.09 4.7 30.09 4.7 29.53 4.74 C 29.21 4.76 27.7 4.9 26.18 5.06 C 20.21 5.68 14.85 6.2 14.45 6.2 C 13.59 6.2 13.38 6.35 13.01 7.25 C 12.8 7.75 7.21 18.82 6.15 20.84 C 5.71 21.68 5.34 22.44 5.31 22.53 C 5.26 22.72 5.21 22.64 6.54 24.95 C 9.13 29.48 13.01 36.31 13.15 36.6 C 13.24 36.77 13.39 37 13.5 37.11 C 13.6 37.22 13.75 37.3 13.85 37.3 C 14.67 37.3 18.19 36.97 22.1 36.52 C 24.39 36.26 27.16 35.98 29.13 35.81 C 29.64 35.77 30.08 35.7 30.17 35.64 C 30.25 35.59 30.43 35.31 30.55 35.03 C 30.68 34.75 30.96 34.17 31.18 33.74 C 31.4 33.32 32.66 30.82 33.98 28.19 C 34.91 26.35 35.55 25.13 36.2 23.88 C 34.95 26.38 33.66 28.87 32.41 31.37 C 31.9 32.4 31.37 33.43 30.85 34.45 C 30.68 34.78 30.5 35.46 30.19 35.68 C 29.89 35.87 29.32 35.8 28.98 35.85 C 27.86 35.99 26.73 36.06 25.61 36.17 C 21.7 36.56 17.76 37.13 13.83 37.33 C 13.41 37.35 13.26 36.82 13.08 36.51 C 12.58 35.61 12.07 34.71 11.56 33.82 C 9.96 31.04 8.39 28.25 6.8 25.46 L 5.66 23.46 C 5.53 23.23 5.25 22.9 5.26 22.63 C 5.28 22.28 5.62 21.81 5.78 21.5 C 7.64 17.9 9.46 14.28 11.28 10.65 C 11.79 9.64 12.31 8.63 12.81 7.62 C 12.99 7.27 13.19 6.59 13.5 6.35 C 13.79 6.13 14.51 6.18 14.86 6.16 C 15.87 6.08 16.88 5.95 17.89 5.86 C 21.86 5.46 25.84 5.1 29.81 4.66 z M 8.31 5.42 C 9.87 5.72 11.56 6.19 13.15 6.26 C 12.63 7.48 11.94 8.64 11.35 9.82 C 9.92 12.68 8.45 15.52 7.03 18.38 C 6.53 19.37 6.04 20.36 5.53 21.36 C 5.42 21.58 5.17 22.28 4.93 22.34 C 4.63 22.42 4.03 22.03 3.76 21.92 C 2.74 21.49 1.69 21.1 0.68 20.62 C 0.86 20.01 1.26 19.43 1.55 18.86 L 3.41 15.15 C 5.03 11.92 6.49 8.54 8.31 5.42 z M 22.72 11.01 C 24.59 11.08 26.31 11.82 27.66 13.16 C 28.35 13.86 28.83 14.55 29.31 15.52 C 29.93 16.76 30.23 17.91 30.32 19.24 C 29.98 14.97 26.99 10.97 22.38 11.03 C 17.11 11.1 13.21 15.84 12.72 20.84 C 12.76 19.97 12.88 19.42 13.17 18.51 C 14.4 14.67 17.32 11.87 20.83 11.17 C 21.47 11.04 22.11 10.99 22.72 11.01 z M 22.23 11.38 C 22.67 11.42 23 11.91 23.26 12.22 C 24.15 13.28 24.79 14.57 25.08 15.93 C 25.97 20.2 24.13 24.97 20.38 27.29 C 19.39 27.9 18.3 28.33 17.15 28.51 C 16.55 28.61 16.05 28.68 15.54 28.3 C 15.99 27.99 16.82 27.96 17.35 27.77 C 18.34 27.42 19.28 26.85 20.09 26.17 C 23.34 23.47 24.95 18.86 23.78 14.76 C 23.57 14.03 23.29 13.31 22.9 12.66 C 22.64 12.22 22.27 11.83 22.04 11.39 C 22.11 11.37 22.17 11.37 22.23 11.38 z M 22.92 11.39 C 23.42 11.45 23.9 11.98 24.24 12.32 C 25.25 13.32 26.01 14.56 26.4 15.93 C 27.68 20.42 25.72 25.58 21.7 28 C 20.59 28.67 19.41 29.04 18.13 29.19 C 17.54 29.27 16.88 29.31 16.37 28.98 L 16.37 28.93 C 17.63 28.77 18.82 28.5 19.94 27.89 C 24.18 25.6 26.44 20.4 25.36 15.74 C 25.09 14.64 24.63 13.57 23.97 12.66 C 23.65 12.21 23.24 11.83 22.92 11.39 z M 21.26 11.45 C 21.89 11.37 22.3 12.23 22.58 12.71 C 23.46 14.21 23.86 15.96 23.85 17.69 C 23.83 21.28 21.82 24.96 18.72 26.78 C 17.76 27.34 16.58 27.86 15.44 27.92 C 14.93 27.95 14.46 26.97 14.24 26.59 C 13.35 25.03 12.98 23.29 13 21.5 C 13.06 16.93 16.53 12.02 21.26 11.45 z M 24.19 11.78 C 25.09 12.38 25.91 13 26.56 13.88 C 28.92 17.05 28.72 21.67 26.74 24.97 C 24.89 28.06 21.12 30.67 17.4 29.62 L 17.4 29.57 C 23.86 29.52 28.13 22.44 26.87 16.52 C 26.62 15.32 26.1 14.18 25.39 13.2 C 25.16 12.87 24.91 12.55 24.63 12.27 C 24.49 12.12 24.24 11.97 24.19 11.78 z M 24.88 11.78 C 29.34 13.29 30.78 18.67 29.59 22.82 C 28.62 26.23 25.93 29.33 22.38 30.12 C 21.33 30.36 20.26 30.34 19.21 30.2 L 19.21 30.15 C 21.24 30.15 23.28 29.13 24.78 27.82 C 29.33 23.81 30.3 15.55 24.83 11.83 L 24.88 11.78 z M 30.35 19.83 C 30.35 19.88 30.36 19.93 30.36 19.99 C 30.36 20.06 30.34 20.13 30.34 20.2 C 30.35 20.08 30.35 19.95 30.35 19.83 z M 30.31 20.84 C 30.2 22.18 29.88 23.42 29.23 24.74 C 28.19 26.9 26.62 28.58 24.79 29.59 C 27.86 27.87 30 24.31 30.31 20.84 z M 0.93 21.06 C 1.81 21.47 2.72 21.82 3.62 22.19 C 4 22.35 4.55 22.47 4.87 22.75 C 5.22 23.06 5.44 23.69 5.68 24.09 L 7.35 27.03 L 11.21 33.82 C 11.79 34.83 12.65 35.94 13 37.04 C 12.01 36.52 11.04 35.95 10.07 35.4 C 9.58 35.11 8.93 34.87 8.51 34.49 C 8.27 34.25 8.12 33.87 7.95 33.57 L 6.9 31.72 C 5.73 29.66 4.54 27.63 3.4 25.56 C 2.82 24.49 2.2 23.44 1.6 22.38 C 1.4 22.03 0.93 21.46 0.93 21.06 z M 12.72 22.76 C 13.02 26 14.89 29.11 18.09 30.23 C 17.92 30.17 17.75 30.13 17.59 30.06 C 15.23 29.05 13.51 26.81 12.86 23.92 C 12.77 23.52 12.74 23.19 12.72 22.76 z M 24.7 29.63 C 24.44 29.78 24.17 29.91 23.89 30.03 C 24.17 29.91 24.44 29.78 24.7 29.63 z M 23.79 30.06 C 23.2 30.3 22.59 30.49 21.95 30.58 C 20.67 30.78 19.34 30.65 18.17 30.26 C 19.08 30.56 20.01 30.65 20.97 30.64 C 21.96 30.63 22.9 30.42 23.79 30.06 z',
        customStroke: '0.75px',
    },
    notification: {
        path: 'M 21.634 15.641 L 19.586 13.593 L 19.586 10.104 C 19.581 6.202 16.638 2.931 12.758 2.516 L 12.758 1 L 11.242 1 L 11.242 2.517 C 7.375 2.958 4.446 6.213 4.414 10.103 L 4.414 13.593 L 2.366 15.641 C 2.215 15.777 2.133 15.971 2.137 16.173 L 2.137 18.448 C 2.124 18.653 2.2 18.854 2.345 19 C 2.49 19.144 2.691 19.221 2.896 19.207 L 8.207 19.207 C 8.207 21.302 9.906 23 12 23 C 14.094 23 15.794 21.302 15.794 19.206 L 21.104 19.206 C 21.309 19.221 21.51 19.144 21.655 19 C 21.8 18.854 21.876 18.653 21.863 18.448 L 21.863 16.172 C 21.867 15.971 21.785 15.777 21.634 15.642 L 21.634 15.641 Z  M 12 21.483 C 10.742 21.483 9.724 20.464 9.724 19.206 L 14.276 19.206 C 14.276 20.464 13.257 21.483 12 21.483 Z  M 20.346 17.689 L 3.656 17.689 L 3.656 16.475 L 5.704 14.427 C 5.854 14.292 5.935 14.098 5.931 13.896 L 5.931 10.103 C 5.931 6.751 8.648 4.033 12 4.033 C 15.352 4.033 18.069 6.751 18.069 10.103 L 18.069 13.896 C 18.064 14.098 18.146 14.292 18.296 14.427 L 20.346 16.476 L 20.346 17.69 L 20.346 17.689 Z',
    },
    nurbs: {
        path: 'M 33 5.498 L 32.308 5.496 C 29.777 5.488 27.296 5.479 24.914 5.672 L 8.914 5.672 C 8.532 3.861 6.924 2.5 5 2.5 C 2.792 2.5 1 4.292 1 6.5 C 1 8.708 2.792 10.5 5 10.5 C 6.929 10.5 8.541 9.131 8.917 7.313 L 17.477 7.313 C 15.617 8.094 13.877 9.206 12.292 10.792 C 6.944 16.142 6.968 23.266 6.996 30.808 L 6.998 31.5 L 6 31.5 C 5.448 31.5 5 31.948 5 32.5 L 5 36.5 C 5 37.052 5.448 37.5 6 37.5 L 10 37.5 C 10.552 37.5 11 37.052 11 36.5 L 11 32.5 C 11 31.948 10.552 31.5 10 31.5 L 8.998 31.5 L 8.996 30.8 C 8.968 23.376 8.946 16.966 13.706 12.206 C 18.466 7.446 24.876 7.472 32.3 7.496 L 33 7.498 L 33 8.5 C 33 9.052 33.448 9.5 34 9.5 L 38 9.5 C 38.552 9.5 39 9.052 39 8.5 L 39 4.5 C 39 3.948 38.552 3.5 38 3.5 L 34 3.5 C 33.448 3.5 33 3.948 33 4.5 L 33 5.498 Z',
    },
    orbit: {
        path: 'M 27.575 15.184 L 27.575 15.184 L 20.878 11.318 C 20.304 10.987 19.593 10.987 19.021 11.321 L 12.421 15.156 C 11.854 15.485 11.502 16.096 11.499 16.753 L 11.477 24.589 C 11.474 25.252 11.831 25.868 12.403 26.199 L 19.072 30.049 C 19.359 30.214 19.678 30.297 19.999 30.297 C 20.319 30.297 20.639 30.214 20.925 30.049 L 27.596 26.199 C 28.169 25.867 28.524 25.25 28.521 24.589 L 28.498 16.783 C 28.499 16.127 28.144 15.513 27.575 15.184 Z  M 19.302 21.902 L 19.283 28.562 L 12.878 24.864 L 12.9 17.5 L 19.301 21.196 L 19.302 21.902 Z  M 26.366 16.094 L 19.999 19.794 L 13.593 16.095 L 19.96 12.396 L 26.366 16.094 Z  M 27.128 24.862 L 20.723 28.561 L 20.702 21.197 L 27.105 17.498 L 27.128 24.862 Z  M 6.675 16.891 L 5.006 18.559 C 5.735 10.925 12.178 4.933 19.999 4.933 C 25.282 4.933 30.246 7.756 32.953 12.301 L 34.184 11.567 C 31.221 6.592 25.785 3.501 20.001 3.501 C 11.343 3.501 4.235 10.208 3.567 18.698 L 1.76 16.891 L 1 17.65 L 4.217 20.868 L 7.435 17.65 L 6.675 16.891 Z  M 39 22.458 L 35.782 19.24 L 32.563 22.458 L 33.324 23.218 L 34.985 21.557 C 34.202 29.135 27.781 35.066 19.999 35.066 C 14.682 35.066 9.86 32.348 7.103 27.794 L 5.877 28.536 C 8.896 33.522 14.176 36.499 19.998 36.499 C 28.62 36.499 35.709 29.846 36.426 21.406 L 38.239 23.22 L 39 22.458 Z',
    },
    ordered_list: {
        path: 'M 11.154 17.077 L 23 17.077 L 23 18.769 L 11.154 18.769 L 11.154 17.077 Z  M 11.154 5.231 L 23 5.231 L 23 6.923 L 11.154 6.923 L 11.154 5.231 Z  M 4.385 8.615 L 4.385 1.846 L 2.692 1.846 L 2.692 2.692 L 1 2.692 L 1 4.385 L 2.692 4.385 L 2.692 8.615 L 1 8.615 L 1 10.308 L 2.692 10.308 L 4.385 10.308 L 6.077 10.308 L 6.077 8.615 L 4.385 8.615 L 4.385 8.615 Z  M 6.077 22.154 L 1 22.154 L 1 18.769 C 1 17.835 1.758 17.077 2.692 17.077 L 4.385 17.077 L 4.385 15.385 L 1 15.385 L 1 13.692 L 4.385 13.692 C 5.319 13.692 6.077 14.45 6.077 15.385 L 6.077 17.077 C 6.077 18.012 5.319 18.769 4.385 18.769 L 2.692 18.769 L 2.692 20.462 L 6.077 20.462 L 6.077 22.154 Z',
    },
    organisation: {
        path: 'M 19.333 10.533 L 17.867 10.533 L 17.867 12 L 19.333 12 C 20.548 12.001 21.532 12.986 21.533 14.2 L 21.533 17.133 L 23 17.133 L 23 14.2 C 22.998 12.176 21.357 10.536 19.333 10.533 L 19.333 10.533 Z  M 17.867 3.2 C 19.082 3.2 20.067 4.185 20.067 5.4 C 20.067 6.615 19.082 7.6 17.867 7.6 C 16.652 7.6 15.667 6.615 15.667 5.4 C 15.667 4.185 16.652 3.2 17.867 3.2 Z  M 17.867 1.733 C 15.842 1.733 14.2 3.375 14.2 5.4 C 14.2 7.425 15.842 9.067 17.867 9.067 C 19.892 9.067 21.533 7.425 21.533 5.4 C 21.533 3.375 19.892 1.733 17.867 1.733 Z  M 17.133 22.267 L 15.667 22.267 L 15.667 20.8 C 15.665 19.586 14.681 18.601 13.467 18.6 L 10.533 18.6 C 9.319 18.601 8.335 19.586 8.333 20.8 L 8.333 22.267 L 6.867 22.267 L 6.867 20.8 C 6.869 18.776 8.509 17.136 10.533 17.133 L 13.467 17.133 C 15.491 17.136 17.131 18.776 17.133 20.8 L 17.133 22.267 Z  M 12 9.8 C 13.215 9.8 14.2 10.785 14.2 12 C 14.2 13.215 13.215 14.2 12 14.2 C 10.785 14.2 9.8 13.215 9.8 12 C 9.8 10.785 10.785 9.8 12 9.8 Z  M 12 8.333 C 9.975 8.333 8.333 9.975 8.333 12 C 8.333 14.025 9.975 15.667 12 15.667 C 14.025 15.667 15.667 14.025 15.667 12 C 15.667 9.975 14.025 8.333 12 8.333 Z  M 6.133 10.533 L 4.667 10.533 C 2.643 10.536 1.002 12.176 1 14.2 L 1 17.133 L 2.467 17.133 L 2.467 14.2 C 2.468 12.986 3.452 12.001 4.667 12 L 6.133 12 L 6.133 10.533 Z  M 6.133 3.2 C 7.348 3.2 8.333 4.185 8.333 5.4 C 8.333 6.615 7.348 7.6 6.133 7.6 C 4.918 7.6 3.933 6.615 3.933 5.4 C 3.933 4.185 4.918 3.2 6.133 3.2 Z  M 6.133 1.733 C 4.108 1.733 2.467 3.375 2.467 5.4 C 2.467 7.425 4.108 9.067 6.133 9.067 C 8.158 9.067 9.8 7.425 9.8 5.4 C 9.8 3.375 8.158 1.733 6.133 1.733 Z',
    },
    overview: {
        path: 'M 5.125 22.542 C 4.367 22.542 3.75 21.924 3.75 21.167 L 3.75 10.815 L 1.783 12.782 C 1.696 12.869 1.581 12.916 1.458 12.916 C 1.336 12.916 1.221 12.869 1.134 12.783 C 0.955 12.604 0.955 12.313 1.134 12.135 L 11.676 1.593 C 11.763 1.506 11.878 1.458 12 1.458 C 12.122 1.458 12.237 1.506 12.324 1.592 L 22.866 12.134 C 23.045 12.313 23.045 12.603 22.866 12.782 C 22.78 12.868 22.664 12.916 22.542 12.916 C 22.419 12.916 22.304 12.868 22.217 12.782 L 20.25 10.815 L 20.25 21.167 C 20.25 21.924 19.633 22.542 18.875 22.542 L 5.125 22.542 Z  M 18.875 21.625 C 19.128 21.625 19.333 21.42 19.333 21.167 L 19.333 9.898 L 12 2.565 L 4.667 9.898 L 4.667 21.167 C 4.667 21.42 4.872 21.625 5.125 21.625 L 18.875 21.625 Z',
        customStroke: '0.5px',
    },
    pan: {
        path: 'M 36.474 17.476 L 35.88 18.071 L 37.247 19.438 L 28.266 19.438 L 28.257 16.196 C 28.254 15.566 27.914 14.98 27.369 14.665 L 20.839 10.895 C 20.292 10.579 19.608 10.578 19.061 10.897 L 12.626 14.637 C 12.083 14.952 11.745 15.538 11.743 16.165 L 11.734 19.438 L 2.752 19.438 L 4.119 18.071 L 3.525 17.476 L 1 19.999 L 3.525 22.523 L 4.119 21.927 L 2.753 20.561 L 11.731 20.561 L 11.722 23.808 C 11.721 24.44 12.061 25.032 12.609 25.349 L 19.114 29.105 C 19.388 29.263 19.694 29.342 20.001 29.342 C 20.307 29.342 20.614 29.263 20.887 29.105 L 27.393 25.349 C 27.942 25.032 28.281 24.44 28.279 23.808 L 28.27 20.561 L 37.247 20.561 L 35.881 21.927 L 36.475 22.523 L 39 19.999 L 36.474 17.476 Z  M 26.278 15.521 L 19.999 19.169 L 13.682 15.522 L 19.961 11.874 L 26.278 15.521 Z  M 19.353 21.187 L 19.335 27.744 L 13.018 24.097 L 13.038 16.836 L 19.351 20.48 L 19.353 21.187 Z  M 26.986 24.095 L 20.669 27.742 L 20.649 20.48 L 26.965 16.833 L 26.986 24.095 Z',
    },
    pen: {
        path: 'M 22.4 8 C 23.2 7.2 23.2 6 22.4 5.2 C 22.4 5.2 22.4 5.2 22.4 5.2 L 18.8 1.6 C 18 0.8 16.8 0.8 16 1.6 C 16 1.6 16 1.6 16 1.6 L 1 16.6 L 1 23 L 7.4 23 L 22.4 8 Z  M 17.4 3 L 21 6.6 L 18 9.6 L 14.4 6 L 17.4 3 Z  M 3 21 L 3 17.4 L 13 7.4 L 16.6 11 L 6.6 21 L 3 21 Z',
    },
    perspective: {
        path: 'M 7.357 21.013 L 7.357 30.824 L 7.357 30.824 L 7.357 30.824 L 33.499 27.723 L 33.499 21.013 L 31.4 21.013 L 31.4 18.987 L 31.4 18.987 L 31.4 18.987 L 33.499 18.987 L 33.499 12.077 L 7.357 9.162 L 7.357 18.987 L 8.6 18.987 L 8.6 21.013 L 7.357 21.013 Z  M 6.087 21.013 L 6.087 32.255 L 6.087 32.255 L 34.764 28.848 L 34.764 10.95 L 6.087 7.745 L 6.087 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 18.987 L 6.067 21.013 L 6.087 21.013 Z  M 1 18.987 L 3.533 18.987 L 3.533 21.013 L 1 21.013 L 1 18.987 L 1 18.987 L 1 18.987 L 1 18.987 L 1 18.987 L 1 18.987 L 1 18.987 L 1 18.987 Z  M 11.133 18.987 L 13.667 18.987 L 13.667 21.013 L 11.133 21.013 L 11.133 18.987 L 11.133 18.987 L 11.133 18.987 L 11.133 18.987 L 11.133 18.987 L 11.133 18.987 L 11.133 18.987 Z  M 16.2 18.987 L 18.733 18.987 L 18.733 21.013 L 16.2 21.013 L 16.2 18.987 L 16.2 18.987 L 16.2 18.987 L 16.2 18.987 L 16.2 18.987 L 16.2 18.987 Z  M 21.267 18.987 L 23.8 18.987 L 23.8 21.013 L 21.267 21.013 L 21.267 18.987 L 21.267 18.987 L 21.267 18.987 L 21.267 18.987 L 21.267 18.987 Z  M 26.333 18.987 L 28.867 18.987 L 28.867 21.013 L 26.333 21.013 L 26.333 18.987 L 26.333 18.987 L 26.333 18.987 L 26.333 18.987 Z  M 36.467 18.987 L 39 18.987 L 39 21.013 L 36.467 21.013 L 36.467 18.987 L 36.467 18.987 Z',
    },
    photo: {
        path: 'M21.64 20.16H2.36a.74.74 0 01-.74-.74V6.8c0-.41.33-.74.74-.74h4.79l1.27-1.9c.13-.2.37-.33.61-.33h5.94c.24 0 .48.13.61.34l1.27 1.89h4.79c.41 0 .74.33.74.74v12.6c0 .42-.33.75-.74.75zM3.1 18.67h17.8V7.55h-4.45a.74.74 0 01-.62-.33l-1.26-1.9H9.43l-1.26 1.9a.74.74 0 01-.62.33H3.1v11.12zM12 17.2a4.45 4.45 0 110-8.9 4.45 4.45 0 010 8.9zm0-7.41a2.97 2.97 0 100 5.93 2.97 2.97 0 000-5.93z',
        customStroke: '0.5px',
    },
    pinned: {
        path: 'M 12 6.762 C 10.409 6.762 9.119 8.052 9.119 9.643 C 9.119 11.234 10.409 12.524 12 12.524 C 13.591 12.524 14.881 11.234 14.881 9.643 C 14.879 8.053 13.59 6.764 12 6.762 L 12 6.762 L 12 6.762 Z  M 12 14.445 C 9.348 14.445 7.198 12.295 7.198 9.643 C 7.198 6.991 9.348 4.841 12 4.841 C 14.652 4.841 16.802 6.991 16.802 9.643 C 16.799 12.294 14.651 14.442 12 14.445 L 12 14.445 L 12 14.445 Z  M 5.097 14.824 C 5.098 14.825 5.322 15.12 5.373 15.184 L 12 23 L 18.636 15.173 C 18.678 15.12 18.903 14.823 18.904 14.822 C 20.034 13.332 20.646 11.513 20.643 9.643 C 20.643 4.87 16.774 1 12 1 C 7.226 1 3.357 4.87 3.357 9.643 C 3.355 11.514 3.966 13.334 5.097 14.824 L 5.097 14.824 L 5.097 14.824 Z',
    },
    plane: {
        path: 'M 20 1.005 L 1 8.042 L 1 31.958 L 20 38.995 L 39 31.958 L 39 8.042 L 20 1.005 Z  M 18.516 35.28 L 3.969 29.892 L 3.969 11.207 L 18.516 16.595 L 18.516 35.28 Z  M 6.758 9.075 L 20 4.17 L 33.242 9.075 L 20 13.979 L 6.758 9.075 Z  M 36.031 29.892 L 21.484 35.28 L 21.484 16.595 L 36.031 11.207 L 36.031 29.892 Z',
    },
    play: {
        path: 'M 3.29 23 C 2.784 23 2.373 22.59 2.373 22.083 L 2.373 1.92 C 2.372 1.591 2.547 1.287 2.832 1.123 C 3.115 0.959 3.465 0.959 3.748 1.123 L 21.162 11.204 C 21.449 11.367 21.627 11.672 21.627 12.002 C 21.627 12.332 21.449 12.636 21.162 12.799 L 3.748 22.881 C 3.609 22.96 3.45 23.001 3.29 23 Z  M 4.206 3.506 L 4.206 20.498 L 18.871 12.002 L 4.206 3.506 Z',
    },
    product: {
        path: 'M 1.355 10.58 L 3.323 10.58 C 3.44 11.001 3.608 11.404 3.823 11.783 L 2.43 13.176 C 2.363 13.242 2.326 13.332 2.326 13.427 C 2.326 13.521 2.363 13.611 2.43 13.678 L 3.935 15.184 C 4.074 15.322 4.298 15.322 4.437 15.184 L 5.83 13.79 C 6.209 14.005 6.612 14.173 7.032 14.29 L 7.032 16.258 C 7.032 16.454 7.191 16.613 7.387 16.613 L 9.516 16.613 C 9.712 16.613 9.871 16.454 9.871 16.258 L 9.871 14.29 C 10.291 14.173 10.694 14.005 11.073 13.79 L 12.466 15.184 C 12.607 15.316 12.827 15.316 12.968 15.184 L 14.474 13.678 C 14.54 13.611 14.577 13.521 14.577 13.427 C 14.577 13.332 14.54 13.242 14.474 13.176 L 13.08 11.783 C 13.296 11.404 13.464 11.001 13.58 10.58 L 15.548 10.58 C 15.745 10.58 15.903 10.422 15.903 10.226 L 15.903 8.097 C 15.903 7.901 15.745 7.742 15.548 7.742 L 13.58 7.742 C 13.464 7.322 13.296 6.919 13.08 6.54 L 14.473 5.147 C 14.54 5.08 14.577 4.99 14.577 4.896 C 14.577 4.802 14.54 4.712 14.473 4.645 L 12.968 3.139 C 12.83 3.001 12.605 3.001 12.466 3.139 L 11.073 4.533 C 10.694 4.317 10.291 4.149 9.871 4.033 L 9.871 2.065 C 9.871 1.868 9.712 1.71 9.516 1.71 L 7.387 1.71 C 7.191 1.71 7.032 1.868 7.032 2.065 L 7.032 4.033 C 6.612 4.149 6.209 4.317 5.83 4.533 L 4.437 3.139 C 4.296 3.006 4.076 3.006 3.935 3.139 L 2.429 4.645 C 2.363 4.712 2.326 4.802 2.326 4.896 C 2.326 4.99 2.363 5.08 2.429 5.147 L 3.823 6.54 C 3.608 6.919 3.44 7.322 3.323 7.742 L 1.355 7.742 C 1.159 7.742 1 7.901 1 8.097 L 1 10.226 C 1 10.422 1.159 10.58 1.355 10.58 L 1.355 10.58 Z  M 1.71 8.452 L 3.601 8.452 C 3.768 8.452 3.912 8.336 3.947 8.173 C 4.064 7.641 4.275 7.135 4.569 6.677 C 4.66 6.537 4.639 6.353 4.521 6.235 L 3.182 4.896 L 4.186 3.892 L 5.525 5.231 C 5.643 5.349 5.827 5.369 5.968 5.279 C 6.425 4.984 6.932 4.774 7.463 4.657 C 7.626 4.622 7.742 4.477 7.742 4.31 L 7.742 2.42 L 9.161 2.42 L 9.161 4.31 C 9.161 4.477 9.277 4.622 9.44 4.657 C 9.971 4.774 10.478 4.984 10.935 5.279 C 11.076 5.369 11.26 5.349 11.378 5.231 L 12.717 3.892 L 13.721 4.896 L 12.382 6.235 C 12.263 6.353 12.244 6.537 12.334 6.677 C 12.629 7.135 12.839 7.642 12.955 8.173 C 12.991 8.336 13.135 8.452 13.302 8.452 L 15.193 8.452 L 15.193 9.871 L 13.302 9.871 C 13.135 9.871 12.991 9.988 12.955 10.15 C 12.839 10.682 12.629 11.188 12.334 11.645 C 12.244 11.786 12.264 11.97 12.382 12.088 L 13.721 13.427 L 12.717 14.431 L 11.378 13.091 C 11.26 12.973 11.076 12.954 10.935 13.044 C 10.478 13.339 9.972 13.549 9.44 13.665 C 9.278 13.701 9.161 13.845 9.161 14.012 L 9.161 15.903 L 7.742 15.903 L 7.742 14.012 C 7.742 13.845 7.625 13.701 7.463 13.665 C 6.931 13.549 6.425 13.339 5.968 13.044 C 5.827 12.954 5.643 12.973 5.525 13.091 L 4.186 14.431 L 3.183 13.427 L 4.521 12.088 C 4.64 11.97 4.66 11.786 4.569 11.645 C 4.275 11.188 4.064 10.681 3.947 10.15 C 3.912 9.986 3.768 9.871 3.601 9.871 L 1.71 9.871 L 1.71 8.452 Z  M 8.452 12 C 10.019 12 11.29 10.729 11.29 9.161 C 11.29 7.594 10.019 6.323 8.452 6.323 C 6.884 6.323 5.613 7.594 5.613 9.161 C 5.615 10.728 6.884 11.998 8.452 12 Z  M 8.452 7.032 C 9.627 7.032 10.58 7.986 10.58 9.161 C 10.58 10.337 9.627 11.29 8.452 11.29 C 7.276 11.29 6.323 10.337 6.323 9.161 C 6.324 7.986 7.276 7.034 8.452 7.032 Z  M 8.452 13.065 C 10.607 13.065 12.355 11.317 12.355 9.161 C 12.355 7.005 10.607 5.258 8.452 5.258 C 6.296 5.258 4.548 7.005 4.548 9.161 C 4.551 11.316 6.297 13.062 8.452 13.065 Z  M 8.452 5.968 C 10.216 5.968 11.645 7.397 11.645 9.161 C 11.645 10.925 10.216 12.355 8.452 12.355 C 6.688 12.355 5.258 10.925 5.258 9.161 C 5.26 7.399 6.689 5.97 8.452 5.968 Z  M 21.226 18.032 L 21.226 15.193 C 21.226 14.998 21.067 14.839 20.871 14.839 L 20.161 14.839 L 20.161 12 C 20.161 11.804 20.002 11.645 19.807 11.645 L 16.613 11.645 C 16.417 11.645 16.258 11.804 16.258 12 L 16.258 14.839 L 14.484 14.839 C 14.288 14.839 14.129 14.998 14.129 15.193 L 14.129 18.032 L 2.774 18.032 C 1.795 18.034 1.001 18.827 1 19.807 L 1 20.516 C 1.001 21.496 1.795 22.289 2.774 22.29 L 21.226 22.29 C 22.205 22.289 22.999 21.496 23 20.516 L 23 19.807 C 22.999 18.827 22.205 18.034 21.226 18.032 L 21.226 18.032 Z  M 20.516 18.032 L 18.032 18.032 L 18.032 15.548 L 20.516 15.548 L 20.516 18.032 Z  M 16.968 12.355 L 19.452 12.355 L 19.452 14.839 L 16.968 14.839 L 16.968 12.355 Z  M 14.839 15.548 L 17.323 15.548 L 17.323 18.032 L 14.839 18.032 L 14.839 15.548 Z  M 22.29 20.516 C 22.29 21.104 21.814 21.58 21.226 21.58 L 2.774 21.58 C 2.186 21.58 1.71 21.104 1.71 20.516 L 1.71 19.807 C 1.71 19.219 2.186 18.742 2.774 18.742 L 21.226 18.742 C 21.814 18.742 22.29 19.219 22.29 19.807 L 22.29 20.516 Z  M 12 19.097 C 11.412 19.097 10.935 19.573 10.935 20.161 C 10.935 20.749 11.412 21.226 12 21.226 C 12.588 21.226 13.065 20.749 13.065 20.161 C 13.065 19.573 12.588 19.097 12 19.097 L 12 19.097 Z  M 12 20.516 C 11.804 20.516 11.645 20.357 11.645 20.161 C 11.645 19.965 11.804 19.807 12 19.807 C 12.196 19.807 12.355 19.965 12.355 20.161 C 12.355 20.357 12.196 20.516 12 20.516 Z  M 8.452 19.097 C 7.864 19.097 7.387 19.573 7.387 20.161 C 7.387 20.749 7.864 21.226 8.452 21.226 C 9.039 21.226 9.516 20.749 9.516 20.161 C 9.516 19.573 9.039 19.097 8.452 19.097 L 8.452 19.097 Z  M 8.452 20.516 C 8.255 20.516 8.097 20.357 8.097 20.161 C 8.097 19.965 8.255 19.807 8.452 19.807 C 8.648 19.807 8.807 19.965 8.807 20.161 C 8.807 20.357 8.648 20.516 8.452 20.516 Z  M 15.548 19.097 C 14.961 19.097 14.484 19.573 14.484 20.161 C 14.484 20.749 14.961 21.226 15.548 21.226 C 16.136 21.226 16.613 20.749 16.613 20.161 C 16.613 19.573 16.136 19.097 15.548 19.097 L 15.548 19.097 Z  M 15.548 20.516 C 15.352 20.516 15.193 20.357 15.193 20.161 C 15.193 19.965 15.352 19.807 15.548 19.807 C 15.745 19.807 15.903 19.965 15.903 20.161 C 15.903 20.357 15.745 20.516 15.548 20.516 Z  M 4.903 19.097 C 4.316 19.097 3.839 19.573 3.839 20.161 C 3.839 20.749 4.316 21.226 4.903 21.226 C 5.491 21.226 5.968 20.749 5.968 20.161 C 5.968 19.573 5.491 19.097 4.903 19.097 L 4.903 19.097 Z  M 4.903 20.516 C 4.707 20.516 4.548 20.357 4.548 20.161 C 4.548 19.965 4.707 19.807 4.903 19.807 C 5.099 19.807 5.258 19.965 5.258 20.161 C 5.258 20.357 5.099 20.516 4.903 20.516 Z  M 19.097 19.097 C 18.509 19.097 18.032 19.573 18.032 20.161 C 18.032 20.749 18.509 21.226 19.097 21.226 C 19.684 21.226 20.161 20.749 20.161 20.161 C 20.161 19.573 19.684 19.097 19.097 19.097 L 19.097 19.097 Z  M 19.097 20.516 C 18.901 20.516 18.742 20.357 18.742 20.161 C 18.742 19.965 18.901 19.807 19.097 19.807 C 19.293 19.807 19.452 19.965 19.452 20.161 C 19.452 20.357 19.293 20.516 19.097 20.516 Z',
        customStroke: '0.5px',
    },
    remove: {
        path: 'M 1 10.625 L 23 10.625 L 23 13.375 L 1 13.375 L 1 10.625 Z',
    },
    reset: {
        path: 'M 17.516 19.052 L 17.516 17.489 L 17.91 17.489 C 19.869 17.567 21.52 16.055 21.598 14.112 C 21.676 12.169 20.152 10.532 18.194 10.454 L 17.516 10.454 L 17.437 9.813 C 17.076 7.091 14.736 5.056 11.968 5.056 C 9.201 5.056 6.861 7.091 6.5 9.813 L 6.484 10.454 L 5.806 10.454 C 3.848 10.532 2.324 12.169 2.402 14.112 C 2.48 16.055 4.131 17.567 6.09 17.489 L 6.484 17.489 L 6.484 19.052 L 6.09 19.052 C 3.473 19.036 1.289 17.065 1.026 14.483 C 0.763 11.9 2.505 9.535 5.066 9 C 5.767 5.756 8.656 3.44 12 3.44 C 15.344 3.44 18.233 5.756 18.934 9 C 21.495 9.535 23.237 11.9 22.974 14.483 C 22.711 17.065 20.527 19.036 17.91 19.052 L 17.516 19.052 Z  M 12 10.536 C 9.208 10.536 6.988 12.756 6.988 15.548 C 6.988 18.341 9.208 20.56 12 20.56 C 14.792 20.56 17.012 18.341 17.012 15.548 C 17.012 12.756 14.792 10.536 12 10.536 Z  M 12 19.749 C 9.69 19.749 7.799 17.859 7.799 15.548 C 7.799 13.238 9.69 11.348 12 11.348 C 14.31 11.348 16.201 13.238 16.201 15.548 C 16.201 17.859 14.31 19.749 12 19.749 Z  M 13.933 18.054 L 12 16.121 L 10.067 18.054 L 9.494 17.482 L 11.427 15.548 L 9.494 13.615 L 10.067 13.042 L 12 14.976 L 13.933 13.042 L 14.506 13.615 L 12.573 15.548 L 14.506 17.482 L 13.933 18.054 Z',
    },
    robotics: {
        path: 'M 13.571 7.286 L 15.143 7.286 L 15.143 8.857 L 13.571 8.857 L 13.571 7.286 Z  M 8.857 7.286 L 10.429 7.286 L 10.429 8.857 L 8.857 8.857 L 8.857 7.286 Z  M 19.857 15.143 L 15.929 15.143 L 15.929 13.571 L 16.714 13.571 C 17.582 13.57 18.285 12.867 18.286 12 L 18.286 8.857 L 19.857 8.857 L 19.857 7.286 L 18.286 7.286 L 18.286 5.714 C 18.285 4.847 17.582 4.144 16.714 4.143 L 15.143 4.143 L 15.143 1 L 13.571 1 L 13.571 4.143 L 10.429 4.143 L 10.429 1 L 8.857 1 L 8.857 4.143 L 7.286 4.143 C 6.418 4.144 5.715 4.847 5.714 5.714 L 5.714 7.286 L 4.143 7.286 L 4.143 8.857 L 5.714 8.857 L 5.714 12 C 5.715 12.867 6.418 13.57 7.286 13.571 L 8.071 13.571 L 8.071 15.143 L 4.143 15.143 C 3.275 15.144 2.572 15.847 2.571 16.714 L 2.571 23 L 4.143 23 L 4.143 16.714 L 19.857 16.714 L 19.857 23 L 21.429 23 L 21.429 16.714 C 21.428 15.847 20.725 15.144 19.857 15.143 L 19.857 15.143 Z  M 7.286 5.714 L 16.714 5.714 L 16.714 12 L 7.286 12 L 7.286 5.714 Z  M 9.643 13.571 L 14.357 13.571 L 14.357 15.143 L 9.643 15.143 L 9.643 13.571 Z',
    },
    rotate: {
        path: 'M 18.464 19.476 C 18.581 19.476 18.693 19.522 18.776 19.605 C 18.842 19.671 18.885 19.756 18.9 19.847 L 18.905 19.916 L 18.905 21.679 C 18.905 21.922 18.707 22.119 18.464 22.119 C 18.249 22.119 18.068 21.964 18.031 21.757 L 18.024 21.679 L 18.024 21.005 C 13.972 23.928 8.426 23.61 4.736 20.242 C 4.556 20.079 4.543 19.8 4.707 19.62 C 4.871 19.44 5.15 19.427 5.329 19.591 C 8.615 22.588 13.507 22.953 17.195 20.51 L 17.419 20.357 L 16.262 20.357 C 16.018 20.357 15.821 20.16 15.821 19.917 C 15.821 19.7 15.977 19.52 16.183 19.483 L 16.262 19.476 L 18.464 19.476 Z  M 12.005 3.566 C 12.207 3.566 12.406 3.603 12.602 3.676 C 12.76 3.702 12.916 3.781 13.073 3.859 L 18.335 6.922 C 18.99 7.289 19.408 7.995 19.408 8.754 L 19.408 14.854 C 19.408 15.01 19.382 15.194 19.357 15.35 C 19.313 15.633 19.263 15.828 19.202 15.937 C 19.135 16.056 18.995 16.2 18.78 16.372 C 18.675 16.503 18.544 16.607 18.388 16.686 L 13.1 19.723 C 12.76 19.905 12.393 20.011 12.026 20.011 C 11.66 20.011 11.294 19.905 10.953 19.723 L 5.665 16.686 L 5.272 16.372 C 5.016 16.185 4.856 16.04 4.792 15.937 C 4.716 15.813 4.667 15.618 4.644 15.351 C 4.619 15.194 4.593 15.037 4.593 14.854 L 4.593 8.754 C 4.593 7.995 5.01 7.289 5.665 6.922 L 10.927 3.859 C 11.084 3.781 11.241 3.728 11.398 3.676 C 11.6 3.603 11.803 3.566 12.005 3.566 Z  M 5.796 8.911 L 5.796 14.854 C 5.796 15.194 5.979 15.508 6.267 15.665 L 11.398 18.623 L 11.398 12.157 L 5.796 8.911 Z  M 18.204 8.911 L 12.602 12.158 L 12.602 18.623 L 17.733 15.665 C 18.021 15.481 18.204 15.194 18.204 14.854 L 18.204 8.911 Z  M 12 4.776 C 11.843 4.776 11.66 4.827 11.529 4.906 L 6.398 7.864 L 12 11.111 L 17.602 7.864 L 12.471 4.906 C 12.314 4.827 12.157 4.776 12 4.776 Z  M 18.761 3.758 C 18.878 3.864 18.929 4.025 18.895 4.178 C 18.861 4.332 18.749 4.456 18.598 4.503 C 18.448 4.552 18.284 4.515 18.167 4.409 C 14.883 1.412 9.99 1.046 6.302 3.49 L 6.078 3.643 L 7.235 3.643 C 7.479 3.643 7.676 3.841 7.676 4.084 C 7.676 4.299 7.52 4.48 7.314 4.517 L 7.235 4.524 L 5.033 4.524 C 4.817 4.524 4.637 4.369 4.599 4.162 L 4.592 4.085 L 4.592 2.322 C 4.592 2.078 4.79 1.881 5.033 1.881 C 5.248 1.881 5.429 2.037 5.466 2.243 L 5.473 2.322 L 5.473 2.995 C 9.525 0.072 15.071 0.39 18.761 3.758 Z',
    },
    search: {
        path: 'M 23 21.852 L 16.853 15.672 C 19.905 11.988 19.524 6.556 15.987 3.335 C 12.45 0.113 7.006 0.24 3.623 3.623 C 0.24 7.006 0.113 12.45 3.335 15.987 C 6.556 19.524 11.988 19.905 15.672 16.853 L 21.852 23 L 23 21.852 Z  M 2.644 9.972 C 2.644 5.925 5.925 2.644 9.972 2.644 C 14.019 2.644 17.3 5.925 17.3 9.972 C 17.3 14.019 14.019 17.3 9.972 17.3 C 5.925 17.3 2.644 14.019 2.644 9.972 Z',
    },
    services: {
        path: 'M 8.956 1 C 7.453 0.995 5.981 1.431 4.723 2.254 L 9.739 7.27 C 10.077 7.558 10.284 7.97 10.313 8.413 C 10.343 8.855 10.192 9.291 9.896 9.621 C 9.566 9.917 9.13 10.068 8.687 10.038 C 8.245 10.009 7.833 9.802 7.545 9.464 L 2.372 4.449 C 1.478 5.765 1.012 7.325 1.04 8.916 C 1.057 13.28 4.591 16.814 8.956 16.832 C 9.642 16.835 10.326 16.756 10.993 16.596 L 16.244 21.848 C 17.781 23.384 20.272 23.384 21.809 21.848 C 23.346 20.311 23.346 17.82 21.809 16.283 L 16.558 11.032 C 16.718 10.365 16.797 9.68 16.793 8.994 C 16.835 6.889 16.028 4.855 14.554 3.351 C 13.079 1.847 11.062 1 8.956 1 L 8.956 1 Z  M 15.225 8.916 C 15.224 9.473 15.145 10.027 14.99 10.562 L 14.755 11.424 L 15.382 12.051 L 20.633 17.302 C 21.085 17.73 21.341 18.325 21.339 18.948 C 21.357 19.573 21.099 20.175 20.633 20.594 C 20.204 21.044 19.609 21.299 18.987 21.299 C 18.365 21.299 17.771 21.044 17.342 20.594 L 12.091 15.342 L 11.464 14.716 L 10.601 14.951 C 10.066 15.105 9.512 15.185 8.956 15.186 C 7.29 15.181 5.69 14.536 4.488 13.383 C 3.259 12.226 2.576 10.604 2.607 8.916 C 2.608 8.333 2.687 7.753 2.842 7.192 L 6.291 10.64 C 6.879 11.281 7.701 11.658 8.57 11.687 C 9.439 11.717 10.284 11.396 10.915 10.797 C 11.514 10.166 11.835 9.321 11.806 8.452 C 11.776 7.583 11.399 6.761 10.758 6.173 L 7.31 2.724 C 7.817 2.564 8.346 2.485 8.877 2.489 C 10.543 2.494 12.142 3.139 13.345 4.292 C 14.548 5.531 15.222 7.189 15.225 8.916 Z',
    },
    settings: {
        path: 'M 20.663 12.599 C 20.663 12.402 20.663 12.205 20.663 12 C 20.663 11.795 20.663 11.598 20.663 11.393 L 22.176 10.07 C 22.752 9.562 22.878 8.714 22.476 8.06 L 20.616 4.908 C 20.335 4.421 19.815 4.121 19.253 4.121 C 19.082 4.119 18.911 4.146 18.749 4.199 L 16.834 4.845 C 16.503 4.626 16.158 4.428 15.802 4.255 L 15.4 2.269 C 15.251 1.52 14.587 0.986 13.824 1 L 10.136 1 C 9.373 0.986 8.709 1.52 8.56 2.269 L 8.159 4.255 C 7.799 4.428 7.452 4.626 7.119 4.845 L 5.243 4.168 C 5.079 4.125 4.908 4.109 4.739 4.121 C 4.177 4.121 3.657 4.421 3.376 4.908 L 1.516 8.06 C 1.137 8.712 1.272 9.541 1.839 10.038 L 3.329 11.401 C 3.329 11.598 3.329 11.795 3.329 12 C 3.329 12.205 3.329 12.402 3.329 12.607 L 1.839 13.93 C 1.256 14.432 1.119 15.281 1.516 15.94 L 3.376 19.092 C 3.657 19.579 4.177 19.879 4.739 19.879 C 4.91 19.881 5.081 19.854 5.243 19.801 L 7.158 19.155 C 7.489 19.374 7.833 19.572 8.19 19.745 L 8.592 21.731 C 8.741 22.48 9.405 23.014 10.168 23 L 13.887 23 C 14.65 23.014 15.314 22.48 15.463 21.731 L 15.865 19.745 C 16.224 19.572 16.572 19.374 16.905 19.155 L 18.812 19.801 C 18.974 19.854 19.145 19.881 19.316 19.879 C 19.878 19.879 20.398 19.579 20.679 19.092 L 22.476 15.94 C 22.855 15.288 22.719 14.459 22.153 13.962 L 20.663 12.599 Z  M 19.253 18.304 L 16.55 17.39 C 15.918 17.925 15.194 18.344 14.415 18.627 L 13.855 21.455 L 10.136 21.455 L 9.577 18.658 C 8.803 18.368 8.084 17.95 7.449 17.421 L 4.739 18.304 L 2.879 15.152 L 5.023 13.261 C 4.877 12.445 4.877 11.61 5.023 10.794 L 2.879 8.848 L 4.739 5.696 L 7.442 6.61 C 8.074 6.075 8.797 5.656 9.577 5.373 L 10.136 2.545 L 13.855 2.545 L 14.415 5.342 C 15.188 5.632 15.907 6.05 16.542 6.579 L 19.253 5.696 L 21.112 8.848 L 18.969 10.739 C 19.115 11.555 19.115 12.39 18.969 13.206 L 21.112 15.152 L 19.253 18.304 Z  M 11.996 16.728 C 9.385 16.728 7.268 14.611 7.268 12 C 7.268 9.389 9.385 7.272 11.996 7.272 C 14.607 7.272 16.724 9.389 16.724 12 C 16.736 13.258 16.242 14.468 15.353 15.357 C 14.464 16.246 13.254 16.74 11.996 16.728 Z  M 11.996 8.848 C 11.154 8.829 10.341 9.154 9.746 9.75 C 9.15 10.345 8.825 11.158 8.844 12 C 8.825 12.842 9.15 13.655 9.746 14.25 C 10.341 14.846 11.154 15.171 11.996 15.152 C 12.838 15.171 13.651 14.846 14.246 14.25 C 14.842 13.655 15.167 12.842 15.148 12 C 15.167 11.158 14.842 10.345 14.246 9.75 C 13.651 9.154 12.838 8.829 11.996 8.848 L 11.996 8.848 Z',
    },
    sort: {
        path: 'M 12 23 L 5.583 16.583 L 6.876 15.291 L 12 20.406 L 17.124 15.291 L 18.417 16.583 L 12 23 L 12 23 Z  M 12 1 L 18.417 7.417 L 17.124 8.709 L 12 3.594 L 6.876 8.709 L 5.583 7.417 L 12 1 L 12 1 Z',
    },
    slack: {
        path: 'M 9.104 12.597 C 7.828 12.597 6.793 13.633 6.793 14.909 L 6.793 20.689 C 6.793 21.965 7.828 23 9.104 23 C 10.38 23 11.415 21.965 11.415 20.689 L 11.415 14.909 C 11.414 13.633 10.379 12.597 9.104 12.597 Z  M 1.016 14.909 C 1.016 16.185 2.051 17.221 3.328 17.221 C 4.605 17.221 5.641 16.185 5.641 14.909 L 5.641 12.596 L 3.33 12.596 C 3.329 12.596 3.329 12.596 3.328 12.596 C 2.051 12.596 1.016 13.631 1.016 14.909 Z  M 9.107 1 C 9.106 1 9.105 1 9.104 1 C 7.827 1 6.791 2.036 6.791 3.312 C 6.791 4.589 7.827 5.625 9.104 5.625 L 11.415 5.625 C 11.415 4.313 11.415 4.632 11.415 3.308 C 11.414 2.033 10.381 1 9.107 1 Z  M 3.312 11.423 L 9.104 11.423 C 10.381 11.423 11.417 10.388 11.417 9.11 C 11.417 7.833 10.381 6.798 9.104 6.798 L 3.312 6.798 C 2.036 6.798 1 7.833 1 9.11 C 1 10.388 2.036 11.423 3.312 11.423 Z  M 20.667 6.797 C 19.392 6.797 18.359 7.83 18.359 9.105 L 18.359 9.109 L 18.359 11.422 L 20.67 11.422 C 21.946 11.422 22.983 10.386 22.983 9.109 C 22.983 7.833 21.946 6.797 20.67 6.797 C 20.669 6.797 20.668 6.797 20.667 6.797 Z  M 12.585 3.312 L 12.585 9.11 C 12.585 10.386 13.62 11.422 14.896 11.422 C 16.172 11.422 17.208 10.386 17.208 9.11 L 17.208 3.312 C 17.208 2.036 16.172 1.002 14.896 1.002 C 13.62 1.002 12.585 2.036 12.585 3.312 Z  M 17.206 20.687 C 17.206 19.411 16.171 18.376 14.895 18.376 L 12.585 18.376 L 12.585 20.689 C 12.585 21.964 13.619 22.998 14.895 22.998 C 16.171 22.998 17.206 21.963 17.206 20.687 Z  M 20.687 12.596 L 14.895 12.596 C 13.619 12.596 12.583 13.631 12.583 14.909 C 12.583 16.185 13.619 17.221 14.895 17.221 L 20.687 17.221 C 21.964 17.221 23 16.185 23 14.909 C 23 13.631 21.964 12.596 20.687 12.596 Z',
    },
    success: {
        path: 'M 10.429 16.254 L 6.5 12.325 L 7.61 11.214 L 10.429 14.032 L 16.388 8.071 L 17.5 9.183 L 10.429 16.254 L 10.429 16.254 Z  M 12 1 C 5.925 1 1 5.925 1 12 C 1 18.075 5.925 23 12 23 C 18.075 23 23 18.075 23 12 C 23 5.925 18.075 1 12 1 Z  M 12 21.429 C 6.793 21.429 2.571 17.207 2.571 12 C 2.571 6.793 6.793 2.571 12 2.571 C 17.207 2.571 21.429 6.793 21.429 12 C 21.429 17.207 17.207 21.429 12 21.429 Z',
    },
    story: {
        path: 'M 14.357 7.286 L 19.857 7.286 L 19.857 8.857 L 14.357 8.857 L 14.357 7.286 Z  M 14.357 11.214 L 19.857 11.214 L 19.857 12.786 L 14.357 12.786 L 14.357 11.214 Z  M 14.357 15.143 L 19.857 15.143 L 19.857 16.714 L 14.357 16.714 L 14.357 15.143 Z  M 21.429 3.357 L 2.571 3.357 C 1.704 3.358 1.001 4.061 1 4.929 L 1 19.071 C 1.001 19.939 1.704 20.642 2.571 20.643 L 21.429 20.643 C 22.296 20.642 22.999 19.939 23 19.071 L 23 4.929 C 22.999 4.061 22.296 3.358 21.429 3.357 L 21.429 3.357 Z  M 2.571 4.929 L 11.214 4.929 L 11.214 19.071 L 2.571 19.071 L 2.571 4.929 Z  M 12.786 19.071 L 12.786 4.929 L 21.429 4.929 L 21.43 19.071 L 12.786 19.071 Z',
    },
    time: {
        path: 'M 12 23 C 5.925 23 1 18.075 1 12 C 1 5.925 5.925 1 12 1 C 18.075 1 23 5.925 23 12 C 23 18.075 18.075 23 12 23 Z  M 12 2.571 C 6.793 2.571 2.571 6.793 2.571 12 C 2.571 17.207 6.793 21.429 12 21.429 C 17.207 21.429 21.429 17.207 21.429 12 C 21.429 6.793 17.207 2.571 12 2.571 Z  M 15.606 16.714 L 11.214 12.322 L 11.214 4.929 L 12.786 4.929 L 12.786 11.67 L 16.714 15.606 L 15.606 16.714 L 15.606 16.714 Z',
    },
    time_travel: {
        path: 'M 13.363 12.906 C 13.112 12.906 12.909 12.703 12.909 12.453 L 12.909 7.455 C 12.909 7.204 13.112 7.001 13.363 7.001 C 13.614 7.001 13.817 7.204 13.817 7.455 L 13.817 11.998 L 17.907 11.998 C 18.158 11.998 18.361 12.202 18.361 12.453 C 18.361 12.703 18.158 12.906 17.907 12.906 L 13.363 12.906 Z  M 13.363 21.087 C 13.112 21.087 12.909 20.884 12.909 20.633 C 12.909 20.382 13.112 20.178 13.363 20.178 C 17.873 20.178 21.542 16.51 21.542 12 C 21.542 7.49 17.873 3.822 13.363 3.822 C 8.853 3.822 5.184 7.49 5.184 12 L 5.184 12.146 L 7.569 9.422 C 7.655 9.323 7.78 9.267 7.911 9.267 C 8.021 9.267 8.127 9.307 8.21 9.379 C 8.399 9.544 8.418 9.831 8.252 10.019 L 5.072 13.654 C 5.063 13.664 5.055 13.673 5.044 13.681 C 4.955 13.767 4.844 13.812 4.73 13.812 C 4.717 13.812 4.702 13.811 4.687 13.807 C 4.678 13.806 4.671 13.805 4.661 13.803 C 4.606 13.794 4.559 13.778 4.515 13.754 C 4.506 13.75 4.488 13.736 4.479 13.731 C 4.444 13.708 4.411 13.678 4.384 13.645 C 4.372 13.633 4.361 13.619 4.352 13.607 L 1.626 9.517 C 1.559 9.417 1.535 9.297 1.559 9.177 C 1.583 9.058 1.651 8.956 1.752 8.889 C 1.826 8.839 1.914 8.813 2.003 8.813 C 2.156 8.813 2.297 8.888 2.381 9.015 L 4.276 11.857 C 4.353 6.913 8.4 2.913 13.363 2.913 C 18.373 2.913 22.45 6.989 22.45 12 C 22.45 17.011 18.373 21.087 13.363 21.087 Z',
        customStroke: '0.5px',
    },
    torus: {
        path: 'M 18.61 5.2 C 17.8 5.32 16.96 5.32 16.15 5.47 C 13.57 5.89 10.99 6.73 8.74 8.08 C 7.42 8.86 6.07 9.79 4.99 10.9 C 1.93 14.08 0.28 18.52 1.3 22.99 C 1.57 24.22 2.05 25.36 2.65 26.41 C 3.43 27.85 4.51 29.08 5.68 30.16 C 10.39 34.48 17.2 35.86 23.29 35.08 C 26.02 34.75 28.78 33.88 31.21 32.47 C 32.98 31.48 34.54 30.19 35.89 28.66 C 36.91 27.52 37.72 26.14 38.29 24.7 C 40.12 19.96 38.74 14.62 35.29 11.08 C 31.69 7.42 26.77 5.59 21.85 5.23 C 20.8 5.17 19.66 5.05 18.61 5.2 M 4.9 14.68 L 5.17 13.42 L 4.81 13.33 C 5.11 12.85 5.71 11.95 6.28 11.77 C 6.76 11.62 7.51 12.13 7.87 12.4 C 9.25 13.39 10.12 15.25 9.91 16.99 C 9.82 17.65 9.67 18.31 9.37 18.88 C 9.25 19.09 9.13 19.36 8.89 19.45 C 8.62 19.57 8.23 19.39 7.96 19.33 L 7.63 20.77 C 8.05 20.8 8.62 20.83 8.98 21.04 C 9.4 21.25 9.67 21.76 10 22.09 C 10.66 22.75 11.44 23.35 12.22 23.83 C 14.77 25.36 17.8 26.11 20.74 25.96 C 23.83 25.81 27.13 24.76 29.5 22.63 C 30.07 22.15 30.55 21.64 31.03 21.04 C 31.24 20.77 31.51 20.44 31.39 20.05 C 31.27 19.6 30.88 19.21 30.58 18.88 C 29.68 17.77 28.45 16.9 27.22 16.27 C 23.59 14.35 19.24 13.93 15.37 15.22 C 13.87 15.7 12.61 16.57 11.2 17.26 C 11.68 14.56 9.88 11.65 7.54 10.63 C 8.11 10 8.95 9.55 9.67 9.16 C 11.05 8.44 12.43 7.84 13.93 7.45 C 20.14 5.74 27.52 6.49 32.74 10.69 C 34.33 11.95 35.71 13.51 36.64 15.37 C 38.95 20.08 37.45 25.6 33.67 28.96 C 32.14 30.34 30.43 31.39 28.57 32.2 C 26.05 33.28 23.2 33.88 20.47 33.88 C 16.96 33.88 13.42 33.28 10.24 31.63 C 7.39 30.1 4.69 27.85 3.31 24.7 C 2.8 23.56 2.53 22.39 2.38 21.13 C 2.17 19.45 2.56 17.71 3.13 16.18 C 3.31 15.76 3.55 14.83 4 14.62 C 4.27 14.5 4.63 14.62 4.9 14.68 M 3.64 16.18 L 4.06 17.62 L 5.32 17.08 L 4.99 15.82 L 3.64 16.18 M 19.03 15.94 C 21.94 15.58 25.15 16.51 27.64 18.1 C 28.27 18.49 28.84 18.97 29.35 19.51 C 29.53 19.69 29.83 19.93 29.83 20.23 C 29.83 20.44 29.65 20.62 29.5 20.77 C 29.14 21.16 28.75 21.52 28.33 21.88 C 26.5 23.35 24.19 24.13 21.94 24.4 C 18.76 24.82 15.28 24.22 12.58 22.39 C 11.92 21.97 11.32 21.52 10.78 20.95 C 10.6 20.77 10.27 20.5 10.27 20.23 C 10.27 19.99 10.54 19.75 10.69 19.6 C 11.11 19.15 11.56 18.76 12.04 18.4 C 14.2 16.87 16.51 16.27 19.03 15.94 M 4.99 18.97 V 19.06 L 6.1 20.05 C 6.61 19.6 7.03 18.94 6.43 18.43 C 6.31 18.31 6.19 18.19 6.01 18.19 C 5.65 18.19 5.23 18.73 4.99 18.97 Z',
        customStroke: '0.5px',
    },
    twitter: {
        path: 'M 22.999 5.196 Q 22.161 6.501 20.762 7.526 L 20.762 8.086 Q 20.762 12.98 17.242 16.964 Q 13.724 20.949 7.898 20.949 Q 4.169 20.949 1 18.899 Q 1.746 18.993 2.073 18.993 Q 5.196 18.993 7.665 17.035 Q 6.22 16.988 5.056 16.125 Q 3.89 15.264 3.47 13.911 Q 4.03 14.005 4.31 14.005 Q 4.776 14.005 5.521 13.818 Q 3.983 13.491 2.934 12.256 Q 1.885 11.022 1.885 9.39 L 1.885 9.343 Q 2.911 9.902 3.937 9.902 Q 1.932 8.598 1.932 6.127 Q 1.932 4.961 2.538 3.89 Q 6.128 8.318 11.814 8.598 Q 11.72 8.271 11.72 7.572 Q 11.72 5.661 13.026 4.355 Q 14.331 3.051 16.243 3.051 Q 18.154 3.051 19.505 4.495 Q 20.902 4.262 22.395 3.377 Q 21.928 5.009 20.39 5.894 Q 21.835 5.754 23 5.194 L 22.999 5.196 Z',
        customStroke: '0',
    },
    uav: {
        path: 'M 16.125 21.166 C 15.872 21.166 15.666 20.962 15.666 20.709 L 15.666 18.875 C 15.666 18.622 15.872 18.416 16.125 18.416 C 16.378 18.416 16.584 18.622 16.584 18.875 L 16.584 19.334 L 17.959 19.334 C 18.212 19.334 18.416 19.128 18.416 18.875 C 18.515 17.038 17.75 15.286 16.357 14.123 C 16.106 14.507 15.676 14.75 15.209 14.75 L 8.791 14.75 C 8.324 14.75 7.894 14.507 7.643 14.123 C 6.252 15.286 5.485 17.032 5.584 18.85 C 5.584 19.126 5.785 19.334 6.041 19.334 L 7.416 19.334 L 7.416 18.875 C 7.416 18.622 7.622 18.416 7.875 18.416 C 8.128 18.416 8.334 18.622 8.334 18.875 L 8.334 20.709 C 8.334 20.962 8.128 21.166 7.875 21.166 C 7.622 21.166 7.416 20.962 7.416 20.709 L 7.416 20.25 L 6.041 20.25 C 5.284 20.25 4.666 19.633 4.666 18.875 C 4.547 16.65 5.597 14.459 7.416 13.139 L 7.416 11.332 C 6.953 11.163 6.512 11.084 6.041 11.084 L 2.834 11.084 C 1.822 11.084 1 10.261 1 9.25 C 1 8.239 1.822 7.416 2.834 7.416 L 2.834 6.041 C 2.834 5.455 3.209 4.937 3.75 4.745 L 3.75 4.209 C 3.75 3.956 3.956 3.75 4.209 3.75 C 4.462 3.75 4.666 3.956 4.666 4.209 L 4.666 4.745 C 5.208 4.937 5.584 5.455 5.584 6.041 L 5.584 7.416 L 6.041 7.416 C 7.096 7.416 7.839 7.017 8.625 6.594 C 9.547 6.096 10.501 5.584 12 5.584 C 13.499 5.584 14.453 6.096 15.375 6.594 C 16.163 7.017 16.905 7.416 17.959 7.416 L 18.416 7.416 L 18.416 6.041 C 18.416 5.455 18.792 4.937 19.334 4.745 L 19.334 4.209 C 19.334 3.956 19.538 3.75 19.791 3.75 C 20.044 3.75 20.25 3.956 20.25 4.209 L 20.25 4.745 C 20.791 4.937 21.166 5.455 21.166 6.041 L 21.166 7.416 C 22.178 7.416 23 8.239 23 9.25 C 23 10.261 22.178 11.084 21.166 11.084 L 17.959 11.084 C 17.488 11.084 17.047 11.163 16.584 11.332 L 16.584 13.139 C 18.402 14.459 19.453 16.656 19.334 18.9 C 19.334 19.249 19.191 19.591 18.93 19.849 C 18.669 20.108 18.324 20.25 17.959 20.25 L 16.584 20.25 L 16.584 20.709 C 16.584 20.962 16.378 21.166 16.125 21.166 Z  M 8.334 13.375 C 8.334 13.628 8.538 13.834 8.791 13.834 L 15.209 13.834 C 15.462 13.834 15.666 13.628 15.666 13.375 L 15.666 11.752 C 15.57 11.803 15.473 11.854 15.376 11.906 C 14.453 12.404 13.499 12.916 12 12.916 C 10.501 12.916 9.546 12.404 8.624 11.906 C 8.527 11.854 8.43 11.802 8.334 11.752 L 8.334 13.375 Z  M 2.834 8.334 C 2.328 8.334 1.916 8.745 1.916 9.25 C 1.916 9.755 2.328 10.166 2.834 10.166 L 6.041 10.166 C 7.327 10.166 8.207 10.641 9.058 11.1 C 9.88 11.543 10.732 12 12 12 C 13.268 12 14.12 11.543 14.942 11.1 C 15.793 10.641 16.673 10.166 17.959 10.166 L 21.166 10.166 C 21.672 10.166 22.084 9.755 22.084 9.25 C 22.084 8.745 21.672 8.334 21.166 8.334 L 17.959 8.334 C 16.674 8.334 15.793 7.859 14.942 7.401 C 14.118 6.957 13.268 6.5 12 6.5 C 10.732 6.5 9.882 6.957 9.06 7.4 C 8.207 7.859 7.327 8.334 6.041 8.334 L 2.834 8.334 Z  M 20.25 7.416 L 20.25 6.041 C 20.25 5.788 20.044 5.584 19.791 5.584 C 19.538 5.584 19.334 5.788 19.334 6.041 L 19.334 7.416 L 20.25 7.416 Z  M 4.666 7.416 L 4.666 6.041 C 4.666 5.788 4.462 5.584 4.209 5.584 C 3.956 5.584 3.75 5.788 3.75 6.041 L 3.75 7.416 L 4.666 7.416 Z  M 1.459 3.75 C 1.206 3.75 1 3.544 1 3.291 C 1 3.038 1.206 2.834 1.459 2.834 L 3.291 2.834 C 3.544 2.834 3.75 3.038 3.75 3.291 C 3.75 3.544 3.544 3.75 3.291 3.75 L 1.459 3.75 Z  M 5.125 3.75 C 4.872 3.75 4.666 3.544 4.666 3.291 C 4.666 3.038 4.872 2.834 5.125 2.834 L 6.959 2.834 C 7.212 2.834 7.416 3.038 7.416 3.291 C 7.416 3.544 7.212 3.75 6.959 3.75 L 5.125 3.75 Z  M 20.709 3.75 C 20.456 3.75 20.25 3.544 20.25 3.291 C 20.25 3.038 20.456 2.834 20.709 2.834 L 22.541 2.834 C 22.794 2.834 23 3.038 23 3.291 C 23 3.544 22.794 3.75 22.541 3.75 L 20.709 3.75 Z  M 17.041 3.75 C 16.788 3.75 16.584 3.544 16.584 3.291 C 16.584 3.038 16.788 2.834 17.041 2.834 L 18.875 2.834 C 19.128 2.834 19.334 3.038 19.334 3.291 C 19.334 3.544 19.128 3.75 18.875 3.75 L 17.041 3.75 Z',
        customStroke: '0.5px',
    },
    undo: {
        path: 'M 13.897 21.103 C 18.924 21.103 23 17.028 23 12 C 23 6.972 18.924 2.897 13.897 2.897 C 8.869 2.897 4.793 6.972 4.793 12 L 4.793 16.703 L 2.062 13.972 L 1 15.034 L 5.552 19.586 L 10.103 15.034 L 9.041 13.972 L 6.31 16.703 L 6.31 12 L 6.31 12 C 6.31 7.81 9.707 4.414 13.897 4.414 C 18.086 4.414 21.483 7.81 21.483 12 C 21.483 16.19 18.086 19.586 13.897 19.586 L 13.897 21.103 Z',
    },
    unliked: {
        path: 'M 17.067 3.752 C 18.222 3.751 19.329 4.215 20.138 5.04 C 21.855 6.783 21.855 9.581 20.138 11.324 L 12 19.565 L 3.862 11.324 C 2.145 9.581 2.145 6.783 3.862 5.04 C 4.671 4.216 5.778 3.751 6.933 3.751 C 8.088 3.751 9.195 4.216 10.005 5.04 L 12 7.082 L 13.987 5.056 C 14.794 4.221 15.906 3.75 17.067 3.752 Z  M 17.067 2.18 C 15.489 2.179 13.977 2.813 12.872 3.94 L 12 4.82 L 11.128 3.94 C 10.022 2.816 8.511 2.182 6.933 2.182 C 5.356 2.182 3.844 2.816 2.738 3.94 C 0.421 6.299 0.421 10.081 2.738 12.44 L 12 21.82 L 21.262 12.44 C 23.579 10.081 23.579 6.299 21.262 3.94 C 20.156 2.815 18.645 2.181 17.067 2.18 Z',
    },
    unordered_list: {
        path: 'M 1 6.077 C 1 4.676 2.137 3.538 3.538 3.538 C 4.939 3.538 6.077 4.676 6.077 6.077 C 6.077 7.478 4.939 8.615 3.538 8.615 C 2.137 8.615 1 7.478 1 6.077 Z  M 1 17.923 C 1 16.522 2.137 15.385 3.538 15.385 C 4.939 15.385 6.077 16.522 6.077 17.923 C 6.077 19.324 4.939 20.462 3.538 20.462 C 2.137 20.462 1 19.324 1 17.923 Z  M 11.154 17.077 L 23 17.077 L 23 18.769 L 11.154 18.769 L 11.154 17.077 Z  M 11.154 5.231 L 23 5.231 L 23 6.923 L 11.154 6.923 L 11.154 5.231 Z',
    },
    unpinned: {
        path: 'M 12 13.571 C 9.83 13.571 8.071 11.813 8.071 9.643 C 8.071 7.473 9.83 5.714 12 5.714 C 14.17 5.714 15.929 7.473 15.929 9.643 C 15.926 11.812 14.169 13.569 12 13.571 L 12 13.571 Z  M 12 7.286 C 10.698 7.286 9.643 8.341 9.643 9.643 C 9.643 10.945 10.698 12 12 12 C 13.302 12 14.357 10.945 14.357 9.643 C 14.356 8.342 13.301 7.287 12 7.286 L 12 7.286 Z  M 12 23 L 5.372 15.183 C 5.334 15.138 5.099 14.828 5.099 14.828 C 3.966 13.337 3.354 11.515 3.357 9.643 C 3.357 4.87 7.227 1 12 1 C 16.773 1 20.643 4.87 20.643 9.643 C 20.646 11.515 20.034 13.336 18.903 14.826 L 18.901 14.828 C 18.901 14.828 18.666 15.138 18.631 15.18 L 12 23 Z  M 6.353 13.882 C 6.353 13.882 6.536 14.124 6.578 14.176 L 12 20.57 L 17.429 14.167 C 17.464 14.124 17.648 13.88 17.648 13.88 C 18.573 12.661 19.073 11.173 19.071 9.643 C 19.071 5.737 15.905 2.571 12 2.571 C 8.095 2.571 4.929 5.737 4.929 9.643 C 4.927 11.174 5.427 12.663 6.353 13.882 L 6.353 13.882 Z',
    },
    upload: {
        path: 'M 8.06 13.959 L 9.171 15.071 L 11.212 13.037 L 11.212 22.628 L 12.788 22.628 L 12.788 13.037 L 14.829 15.071 L 15.94 13.959 L 12 10.019 L 8.06 13.959 L 8.06 13.959 Z  M 17.91 17.112 L 17.516 17.112 L 17.516 15.535 L 17.91 15.535 C 19.869 15.614 21.52 14.09 21.598 12.131 C 21.676 10.173 20.152 8.522 18.194 8.443 L 17.516 8.443 L 17.437 7.797 C 17.076 5.053 14.736 3.002 11.968 3.002 C 9.201 3.002 6.861 5.053 6.5 7.797 L 6.484 8.443 L 5.806 8.443 C 3.848 8.522 2.324 10.173 2.402 12.131 C 2.48 14.09 4.131 15.614 6.09 15.535 L 6.484 15.535 L 6.484 17.112 L 6.09 17.112 C 3.473 17.095 1.289 15.108 1.026 12.505 C 0.763 9.901 2.505 7.518 5.066 6.978 C 5.767 3.708 8.656 1.372 12 1.372 C 15.344 1.372 18.233 3.708 18.934 6.978 C 21.495 7.518 23.237 9.901 22.974 12.505 C 22.711 15.108 20.527 17.095 17.91 17.112 Z',
    },
    user: {
        path: 'M 19.7 23 L 17.5 23 L 17.5 19.7 C 17.5 17.877 16.023 16.4 14.2 16.4 L 9.8 16.4 C 7.977 16.4 6.5 17.877 6.5 19.7 L 6.5 23 L 4.3 23 L 4.3 19.7 C 4.3 16.662 6.762 14.2 9.8 14.2 L 14.2 14.2 C 17.238 14.2 19.7 16.662 19.7 19.7 L 19.7 23 Z  M 12 3.2 C 13.823 3.2 15.3 4.677 15.3 6.5 C 15.3 8.323 13.823 9.8 12 9.8 C 10.177 9.8 8.7 8.323 8.7 6.5 C 8.7 4.677 10.177 3.2 12 3.2 Z  M 12 1 C 8.962 1 6.5 3.462 6.5 6.5 C 6.5 9.538 8.962 12 12 12 C 15.038 12 17.5 9.538 17.5 6.5 C 17.5 3.462 15.038 1 12 1 Z',
    },
    view_off: {
        path: 'M 4.109 16.774 L 5.158 15.733 C 4.01 14.702 3.107 13.426 2.518 12 C 4.006 8.282 8.113 5.4 12 5.4 C 13 5.413 13.991 5.591 14.933 5.928 L 16.07 4.784 C 14.781 4.239 13.399 3.95 12 3.933 C 7.114 4.117 2.807 7.19 1.044 11.751 C 0.985 11.912 0.985 12.088 1.044 12.249 C 1.695 13.978 2.745 15.528 4.109 16.774 Z  M 9.067 11.802 C 9.172 10.349 10.327 9.194 11.78 9.089 L 13.107 7.754 C 11.594 7.355 9.982 7.791 8.876 8.898 C 7.769 10.004 7.333 11.616 7.732 13.129 L 9.067 11.802 Z  M 22.956 11.751 C 22.115 9.56 20.652 7.664 18.747 6.295 L 22.267 2.767 L 21.233 1.733 L 1.733 21.233 L 2.767 22.267 L 6.507 18.527 C 8.175 19.505 10.067 20.036 12 20.067 C 16.886 19.883 21.193 16.81 22.956 12.249 C 23.015 12.088 23.015 11.912 22.956 11.751 Z  M 14.933 12 C 14.927 13.045 14.366 14.007 13.459 14.527 C 12.553 15.047 11.438 15.045 10.533 14.523 L 14.523 10.533 C 14.786 10.978 14.928 11.483 14.933 12 Z  M 12 18.6 C 10.461 18.573 8.952 18.176 7.6 17.441 L 9.463 15.579 C 11.211 16.792 13.577 16.58 15.082 15.075 C 16.587 13.57 16.799 11.204 15.586 9.455 L 17.691 7.351 C 19.374 8.506 20.689 10.119 21.482 12 C 19.994 15.718 15.887 18.6 12 18.6 Z',
    },
    view: {
        path: 'M 22.956 11.751 C 21.193 7.19 16.886 4.117 12 3.933 C 7.114 4.117 2.807 7.19 1.044 11.751 C 0.985 11.912 0.985 12.088 1.044 12.249 C 2.807 16.81 7.114 19.883 12 20.067 C 16.886 19.883 21.193 16.81 22.956 12.249 C 23.015 12.088 23.015 11.912 22.956 11.751 Z  M 12 18.6 C 8.113 18.6 4.006 15.718 2.518 12 C 4.006 8.282 8.113 5.4 12 5.4 C 15.887 5.4 19.994 8.282 21.482 12 C 19.994 15.718 15.887 18.6 12 18.6 Z  M 12 7.6 C 9.57 7.6 7.6 9.57 7.6 12 C 7.6 14.43 9.57 16.4 12 16.4 C 14.43 16.4 16.4 14.43 16.4 12 C 16.4 9.57 14.43 7.6 12 7.6 Z  M 12 14.933 C 10.38 14.933 9.067 13.62 9.067 12 C 9.067 10.38 10.38 9.067 12 9.067 C 13.62 9.067 14.933 10.38 14.933 12 C 14.933 13.62 13.62 14.933 12 14.933 Z',
    },
    visualization: {
        path: 'M 11.997 4.878 C 12.172 4.878 12.345 4.909 12.515 4.973 C 12.651 4.997 12.787 5.064 12.923 5.132 L 17.48 7.786 C 18.047 8.102 18.41 8.715 18.41 9.372 L 18.41 14.656 C 18.41 14.791 18.387 14.95 18.364 15.086 L 21.587 16.953 L 21.328 16.173 L 21.316 16.108 C 21.298 15.933 21.408 15.765 21.583 15.715 C 21.779 15.659 21.984 15.772 22.041 15.969 L 22.964 18.084 L 22.977 18.146 C 22.992 18.288 23.042 18.497 22.921 18.571 C 22.874 18.718 22.619 18.754 22.456 18.757 L 20.317 18.7 L 20.25 18.696 C 20.077 18.667 19.943 18.518 19.94 18.337 L 19.945 18.27 C 19.973 18.097 20.123 17.963 20.304 17.96 L 21.157 17.877 L 17.866 15.971 C 17.798 16.055 17.717 16.128 17.624 16.187 L 17.526 16.243 L 12.946 18.873 C 12.651 19.032 12.333 19.122 12.016 19.122 C 11.699 19.122 11.381 19.032 11.086 18.873 L 6.506 16.243 L 6.166 15.971 L 2.87 17.88 L 3.696 17.96 C 3.878 17.963 4.027 18.097 4.055 18.27 L 4.06 18.337 C 4.057 18.518 3.923 18.667 3.75 18.696 L 3.683 18.7 L 1.544 18.757 C 1.382 18.754 1.126 18.718 1.079 18.571 C 0.958 18.497 1.008 18.288 1.024 18.145 L 1.036 18.083 L 1.959 15.97 C 2.016 15.772 2.221 15.659 2.418 15.715 C 2.593 15.765 2.701 15.933 2.684 16.108 L 2.671 16.173 L 2.411 16.956 L 5.622 15.086 C 5.606 14.996 5.591 14.905 5.583 14.808 L 5.576 14.656 L 5.576 9.372 C 5.576 8.715 5.939 8.103 6.506 7.785 L 11.064 5.132 C 11.2 5.064 11.336 5.019 11.472 4.973 C 11.647 4.909 11.822 4.878 11.997 4.878 Z  M 6.62 9.509 L 6.62 14.656 C 6.62 14.95 6.778 15.222 7.028 15.358 L 11.472 17.92 L 11.472 12.321 L 6.62 9.509 L 6.62 9.509 Z  M 17.367 9.509 L 12.515 12.32 L 12.515 17.92 L 16.959 15.358 C 17.209 15.199 17.368 14.95 17.368 14.656 L 17.368 9.509 L 17.367 9.509 Z  M 11.993 5.926 C 11.858 5.926 11.699 5.971 11.584 6.039 L 7.141 8.602 L 11.993 11.413 L 16.845 8.602 L 12.401 6.039 C 12.266 5.971 12.129 5.926 11.993 5.926 Z',
        customStroke: '0.5px',
    },
    website: {
        path: 'M 12 1 C 5.925 1 1 5.925 1 12 C 1 18.075 5.925 23 12 23 C 18.075 23 23 18.075 23 12 C 23 5.925 18.075 1 12 1 Z  M 21.429 11.214 L 16.714 11.214 C 16.623 8.321 15.873 5.486 14.522 2.925 C 18.334 3.968 21.091 7.277 21.429 11.214 Z  M 12 21.429 C 11.825 21.44 11.649 21.44 11.474 21.429 C 9.846 18.833 8.942 15.849 8.857 12.786 L 15.143 12.786 C 15.065 15.846 14.169 18.83 12.55 21.429 C 12.367 21.441 12.183 21.441 12 21.429 Z  M 8.857 11.214 C 8.935 8.154 9.831 5.17 11.45 2.571 C 11.8 2.532 12.153 2.532 12.503 2.571 C 14.139 5.165 15.051 8.149 15.143 11.214 L 8.857 11.214 Z  M 9.454 2.925 C 8.112 5.488 7.37 8.322 7.286 11.214 L 2.571 11.214 C 2.909 7.277 5.666 3.968 9.478 2.925 L 9.454 2.925 Z  M 2.611 12.786 L 7.325 12.786 C 7.407 15.677 8.146 18.512 9.486 21.075 C 5.686 20.021 2.944 16.715 2.611 12.786 Z  M 14.522 21.075 C 15.873 18.514 16.623 15.679 16.714 12.786 L 21.429 12.786 C 21.091 16.723 18.334 20.032 14.522 21.075 Z',
    },
    youtube: {
        path: 'M 22.536 6.705 C 22.281 5.758 21.542 5.019 20.595 4.764 C 18.882 4.3 12 4.3 12 4.3 C 12 4.3 5.118 4.3 3.405 4.764 C 2.458 5.019 1.719 5.758 1.464 6.705 C 1.144 8.451 0.989 10.224 1.001 12 C 0.989 13.776 1.144 15.549 1.464 17.295 C 1.719 18.242 2.458 18.981 3.405 19.236 C 5.118 19.7 12 19.7 12 19.7 C 12 19.7 18.882 19.7 20.595 19.236 C 21.542 18.981 22.281 18.242 22.536 17.295 C 22.856 15.549 23.011 13.776 22.999 12 C 23.011 10.224 22.856 8.451 22.536 6.705 L 22.536 6.705 Z  M 9.8 15.3 L 9.8 8.7 L 15.512 12 L 9.8 15.3 Z',
        customStroke: '0',
    },
    warning: {
        path: 'M 12 17.108 C 11.349 17.108 10.822 17.636 10.822 18.286 C 10.822 18.937 11.349 19.465 12 19.465 C 12.651 19.465 13.178 18.937 13.178 18.286 C 13.178 17.636 12.651 17.108 12 17.108 Z  M 11.214 8.466 L 12.786 8.466 L 12.786 15.537 L 11.214 15.537 L 11.214 8.466 Z  M 22.213 22.607 L 1.787 22.607 C 1.513 22.608 1.258 22.465 1.115 22.23 C 0.972 21.996 0.962 21.704 1.088 21.46 L 11.301 1.82 C 11.435 1.558 11.705 1.393 12 1.393 C 12.295 1.393 12.565 1.558 12.699 1.82 L 22.912 21.46 C 23.038 21.704 23.028 21.996 22.885 22.23 C 22.742 22.465 22.487 22.608 22.213 22.607 Z  M 3.083 21.036 L 20.917 21.036 L 12 3.886 L 3.083 21.036 Z',
    },
    workspace: {
        path: 'M 11.999 18.252 C 8.552 18.252 5.748 15.447 5.748 11.999 C 5.748 8.553 8.552 5.748 11.999 5.748 C 15.446 5.748 18.251 8.553 18.251 11.999 C 18.251 15.447 15.446 18.251 11.999 18.251 L 11.999 18.252 Z  M 23 11.649 L 18.935 11.649 C 18.756 8.096 15.904 5.244 12.35 5.065 L 12.35 1.008 L 11.649 1.008 L 11.649 5.065 C 8.095 5.244 5.243 8.096 5.065 11.649 L 1 11.649 L 1 12.351 L 5.065 12.351 C 5.243 15.904 8.095 18.756 11.649 18.935 L 11.649 22.992 L 12.35 22.992 L 12.35 18.935 C 15.904 18.756 18.756 15.904 18.934 12.351 L 22.999 12.351 L 22.999 11.649 L 23 11.649 Z  M 12.526 8.81 L 11.824 8.81 L 11.824 11.586 L 9.049 11.586 L 9.049 12.287 L 11.824 12.287 L 11.824 15.062 L 12.526 15.062 L 12.526 12.287 L 15.301 12.287 L 15.301 11.586 L 12.526 11.586 L 12.526 8.81 Z',
        customStroke: '0.5px',
    },
    zoom_in: {
        path: 'M 14.037 9.148 L 10.778 9.148 L 10.778 5.889 L 9.148 5.889 L 9.148 9.148 L 5.889 9.148 L 5.889 10.778 L 9.148 10.778 L 9.148 14.037 L 10.778 14.037 L 10.778 10.778 L 14.037 10.778 L 14.037 9.148 L 14.037 9.148 Z  M 16.848 15.667 C 18.191 14.07 18.927 12.05 18.926 9.963 C 18.926 5.013 14.913 1 9.963 1 C 5.013 1 1 5.013 1 9.963 C 1 14.913 5.013 18.926 9.963 18.926 C 12.05 18.927 14.07 18.191 15.667 16.848 L 21.851 23 L 23 21.851 L 16.848 15.667 Z  M 9.963 17.296 C 5.913 17.296 2.63 14.013 2.63 9.963 C 2.63 5.913 5.913 2.63 9.963 2.63 C 14.013 2.63 17.296 5.913 17.296 9.963 C 17.296 14.013 14.013 17.296 9.963 17.296 Z',
    },
    zoom_out: {
        path: 'M 14.037 9.148 L 5.889 9.148 L 5.889 10.778 L 14.037 10.778 L 14.037 9.148 L 14.037 9.148 Z M 16.848 15.667 C 18.191 14.07 18.927 12.05 18.926 9.963 C 18.926 5.013 14.913 1 9.963 1 C 5.013 1 1 5.013 1 9.963 C 1 14.913 5.013 18.926 9.963 18.926 C 12.05 18.927 14.07 18.191 15.667 16.848 L 21.851 23 L 23 21.851 L 16.848 15.667 Z M 9.963 17.296 C 5.913 17.296 2.63 14.013 2.63 9.963 C 2.63 5.913 5.913 2.63 9.963 2.63 C 14.013 2.63 17.296 5.913 17.296 9.963 C 17.296 14.013 14.013 17.296 9.963 17.296 Z',
    },
    reset_camera: {
        path: 'M 26.847 25.42 L 26.847 22.671 L 30.519 25.293 C 30.634 25.375 30.772 25.42 30.913 25.42 C 31.288 25.42 31.59 25.116 31.59 24.742 L 31.59 15.258 C 31.59 15.117 31.547 14.979 31.464 14.863 C 31.245 14.559 30.823 14.489 30.519 14.707 L 26.847 17.329 L 26.847 14.579 C 26.846 13.831 26.24 13.225 25.491 13.225 L 13.975 13.225 C 13.227 13.226 12.621 13.831 12.621 14.579 L 12.621 25.42 C 12.622 26.167 13.227 26.774 13.975 26.775 L 25.493 26.775 C 26.24 26.774 26.847 26.167 26.847 25.42 Z  M 13.975 14.579 L 25.493 14.579 L 25.493 18.644 C 25.493 18.784 25.536 18.922 25.62 19.038 C 25.838 19.342 26.26 19.412 26.564 19.194 L 30.236 16.573 L 30.236 23.425 L 26.564 20.803 C 26.449 20.722 26.311 20.676 26.17 20.676 C 25.796 20.676 25.493 20.981 25.493 21.354 L 25.493 25.418 L 13.975 25.418 L 13.975 14.579 Z  M 21.338 2.339 C 12.07 2.339 4.462 9.519 3.748 18.607 L 1.812 16.671 L 1 17.483 L 4.444 20.928 L 7.889 17.483 L 7.076 16.671 L 5.288 18.458 C 6.067 10.286 12.966 3.871 21.338 3.871 C 30.23 3.871 37.465 11.106 37.465 19.999 C 37.465 28.893 30.23 36.127 21.338 36.127 L 21.338 37.661 C 31.076 37.661 39 29.738 39 19.999 C 39 10.261 31.076 2.339 21.338 2.339 Z',
    },
    line: {
        path: 'M 0.999 36.883 L 36.879 1.003 L 38.993 3.117 L 3.113 38.997 L 0.999 36.883 Z',
    },
    circle: {
        path: 'M 20.5 39.5 C 10.024 39.5 1.5 30.976 1.5 20.5 C 1.5 10.024 10.024 1.5 20.5 1.5 C 30.976 1.5 39.5 10.024 39.5 20.5 C 39.5 30.976 30.976 39.5 20.5 39.5 Z  M 20.5 4.423 C 11.637 4.423 4.423 11.637 4.423 20.5 C 4.423 29.363 11.637 36.577 20.5 36.577 C 29.363 36.577 36.577 29.363 36.577 20.5 C 36.577 11.637 29.363 4.423 20.5 4.423 Z',
    },
    ellipse: {
        path: 'M 11.731 39 C 8.645 39 5.926 38.053 3.938 36.061 C -1.674 30.449 0.978 18.994 9.983 9.985 C 18.985 0.983 30.444 -1.679 36.06 3.94 L 36.06 3.94 C 41.675 9.556 39.023 21.011 30.018 30.019 C 24.196 35.831 17.357 39 11.731 39 Z  M 28.323 4.516 C 23.644 4.516 17.504 7.403 12.454 12.452 C 5.091 19.819 2.32 29.499 6.409 33.587 C 10.497 37.676 20.177 34.912 27.547 27.545 C 34.91 20.179 37.677 10.496 33.589 6.407 C 32.303 5.124 30.465 4.516 28.323 4.516 Z',
    },
    helix: {
        path: 'M 39 11.984 L 36.784 9.767 C 33 13.548 29.839 13.445 26.629 12.774 C 26.168 9.905 26.438 7.015 29.824 3.629 L 27.607 1.412 C 23.72 5.3 23.105 8.877 23.397 12.05 C 20.553 11.47 17.494 11.322 14.616 14.2 C 11.418 17.395 11.944 20.815 12.662 23.913 C 9.245 23.392 5.308 23.702 1 28.016 L 3.216 30.233 C 7 26.449 10.167 26.552 13.374 27.226 C 13.835 30.095 13.565 32.985 10.183 36.371 L 12.399 38.588 C 16.287 34.7 16.901 31.123 16.609 27.95 C 19.45 28.53 22.513 28.681 25.388 25.8 C 28.582 22.605 28.056 19.182 27.338 16.087 C 30.758 16.605 34.692 16.291 39 11.984 Z  M 23.958 15.385 C 24.014 15.617 24.065 15.859 24.121 16.084 C 24.754 18.749 25.087 20.564 24.171 22.248 L 18.02 15.501 C 19.666 14.529 21.428 14.793 23.958 15.385 Z  M 16.045 24.618 C 15.992 24.383 15.939 24.141 15.885 23.916 C 15.249 21.251 14.917 19.436 15.832 17.752 L 21.983 24.499 C 20.34 25.468 18.581 25.21 16.045 24.618 Z',
    },
    helix_alt: {
        path: 'M 39 11.985 L 36.784 9.769 C 33 13.55 29.839 13.446 26.629 12.775 C 26.168 9.907 26.438 7.016 29.824 3.63 L 27.607 1.414 C 23.72 5.301 23.105 8.878 23.397 12.051 C 20.553 11.471 17.494 11.324 14.616 14.202 C 11.418 17.396 11.944 20.817 12.662 23.911 C 9.245 23.391 5.311 23.701 1 28.015 L 3.216 30.231 C 7.004 26.447 10.167 26.551 13.374 27.225 C 13.835 30.093 13.565 32.984 10.183 36.37 L 12.399 38.586 C 16.287 34.699 16.901 31.122 16.609 27.949 C 19.45 28.529 22.513 28.679 25.388 25.798 C 28.582 22.604 28.056 19.18 27.338 16.086 C 30.758 16.606 34.692 16.293 39 11.985 Z  M 23.171 23.585 C 21.149 25.61 19.202 25.356 16.045 24.62 C 15.992 24.384 15.939 24.143 15.885 23.917 C 15.08 20.541 14.725 18.525 16.832 16.418 C 18.86 14.39 20.817 14.65 23.958 15.387 C 24.014 15.619 24.065 15.86 24.121 16.086 C 24.924 19.462 25.278 21.478 23.171 23.585 Z',
    },
    hyperbola: {
        path: 'M 21.583 1 L 18.417 1 L 18.417 18.417 L 1 18.417 L 1 21.583 L 18.417 21.583 L 18.417 39 L 21.583 39 L 21.583 21.583 L 39 21.583 L 39 18.417 L 21.583 18.417 L 21.583 1 Z  M 35.181 11.396 C 31.891 11.396 29.215 8.72 29.215 5.43 L 29.215 1 L 26.048 1 L 26.048 5.43 C 26.048 10.465 30.146 14.563 35.181 14.563 L 39 14.563 L 39 11.396 L 35.181 11.396 Z  M 5.433 26.048 L 1 26.048 L 1 29.215 L 5.433 29.215 C 8.724 29.215 11.399 31.891 11.399 35.181 L 11.399 39 L 14.566 39 L 14.566 35.181 C 14.563 30.146 10.465 26.048 5.433 26.048 Z',
    },
    parabola: {
        path: 'M 26.162 20.082 C 25.19 25.434 24.37 28.99 21.583 29.915 L 21.583 1 L 18.417 1 L 18.417 29.915 C 15.63 28.99 14.81 25.434 13.838 20.086 C 12.774 14.221 11.45 6.922 4.002 6.922 L 4.002 10.088 C 8.48 10.088 9.528 14.078 10.722 20.649 C 11.71 26.096 12.875 32.147 18.417 33.139 L 18.417 39 L 21.583 39 L 21.583 33.139 C 27.122 32.151 28.287 26.096 29.278 20.649 C 30.472 14.078 31.52 10.088 35.998 10.088 L 35.998 6.922 C 28.55 6.922 27.226 14.221 26.162 20.082 Z',
    },
    sphere: {
        path: 'M 20.001 1 C 9.525 1 1 9.525 1 20.001 C 1 30.475 9.522 39 20.001 39 C 30.475 39 39 30.478 39 20.001 C 39 9.525 30.478 1 20.001 1 Z  M 20.001 3.975 C 26.98 3.975 32.869 8.487 35.062 14.728 C 31.364 12.651 25.582 11.557 20.001 11.557 C 14.418 11.557 8.639 12.651 4.938 14.728 C 7.134 8.49 13.023 3.975 20.001 3.975 Z  M 36.025 20.001 C 36.025 22.286 29.931 25.472 20.001 25.472 C 10.072 25.472 3.975 22.286 3.975 20.001 C 3.975 17.717 10.072 14.531 20.001 14.531 C 29.931 14.531 36.025 17.717 36.025 20.001 Z  M 20.001 36.025 C 13.023 36.025 7.134 31.513 4.938 25.275 C 8.639 27.352 14.418 28.446 20.001 28.446 C 25.582 28.446 31.364 27.352 35.062 25.275 C 32.869 31.513 26.983 36.025 20.001 36.025 Z',
    },
    render: {
        path: 'M 29.976 3.023 L 10.024 3.023 L 1 15.054 L 20 36.977 L 39 15.054 L 29.976 3.023 Z  M 34.632 13.664 L 27.388 13.664 L 22.4 5.683 L 28.646 5.683 L 34.632 13.664 Z  M 12.421 16.324 L 17.414 29.932 L 5.621 16.324 L 12.421 16.324 Z  M 15.254 16.324 L 24.746 16.324 L 19.999 29.255 L 15.254 16.324 Z  M 15.75 13.664 L 20 6.863 L 24.251 13.664 L 15.75 13.664 Z  M 27.579 16.324 L 34.379 16.324 L 22.584 29.933 L 27.579 16.324 Z  M 11.354 5.683 L 17.6 5.683 L 12.612 13.664 L 5.368 13.664 L 11.354 5.683 Z',
        customStroke: '0.5px',
    },
    standard_view: {
        path: 'M 13.214 1 L 1 1 L 1 13.214 L 3.714 13.214 L 3.714 3.714 L 13.214 3.714 L 13.214 1 Z  M 1 26.786 L 1 39 L 13.214 39 L 13.214 36.286 L 3.714 36.286 L 3.714 26.786 L 1 26.786 Z  M 39 13.214 L 39 1 L 26.786 1 L 26.786 3.714 L 36.286 3.714 L 36.286 13.214 L 39 13.214 Z  M 26.786 39 L 39 39 L 39 26.786 L 36.286 26.786 L 36.286 36.286 L 26.786 36.286 L 26.786 39 Z  M 32.879 12.034 L 20.665 5.248 C 20.245 5.005 19.728 5.005 19.308 5.248 L 7.094 12.034 C 6.677 12.28 6.424 12.73 6.429 13.214 L 6.429 26.786 C 6.429 27.275 6.694 27.726 7.121 27.966 L 19.335 34.752 C 19.755 34.995 20.272 34.995 20.692 34.752 L 32.906 27.966 C 33.323 27.72 33.576 27.27 33.571 26.786 L 33.571 13.214 C 33.571 12.725 33.306 12.273 32.879 12.034 Z  M 20 7.976 L 29.419 13.214 L 20 18.453 L 10.581 13.214 L 20 7.976 Z  M 9.143 15.521 L 18.643 20.801 L 18.643 31.264 L 9.143 25.985 L 9.143 15.521 Z  M 21.357 31.264 L 21.357 20.801 L 30.857 15.521 L 30.857 25.985 L 21.357 31.264 Z',
        customStroke: '0.5px',
    },
    axis: {
        path: 'M 31.895 36.185 L 26.927 36.185 L 26.927 39 L 36.625 39 L 36.625 29.148 L 33.854 29.148 L 33.854 34.195 L 21.385 21.527 L 19.999 22.547 L 19.999 24.101 L 31.895 36.185 Z  M 8.105 36.185 L 13.073 36.185 L 13.073 39 L 3.375 39 L 3.375 29.148 L 6.146 29.148 L 6.146 34.195 L 18.615 21.527 L 19.999 22.547 L 19.999 24.101 L 8.105 36.185 Z  M 18.613 12.26 L 18.613 21.527 L 19.999 22.547 L 21.385 21.527 L 21.385 12.26 L 21.385 6.629 L 21.385 6.387 L 24.967 10.026 L 26.927 8.036 L 19.999 1 L 13.073 8.036 L 15.031 10.026 L 18.613 6.387 L 18.613 6.629 L 18.613 12.26 Z',
    },
    axis_x: {
        path: 'M 8.105 36.185 L 13.073 36.185 L 13.073 39 L 3.375 39 L 3.375 29.148 L 6.146 29.148 L 6.146 34.195 L 18.615 21.527 L 19.999 22.547 L 19.999 24.101 L 8.105 36.185 Z',
    },
    axis_y: {
        path: 'M 32.084 36.185 L 27.038 36.185 L 27.038 39 L 36.89 39 L 36.89 29.148 L 34.074 29.148 L 34.074 34.195 L 21.407 21.527 L 19.999 22.547 L 19.999 24.101 L 32.084 36.185 Z',
    },
    axis_z: {
        path: 'M 18.591 12.26 L 18.591 21.527 L 19.999 22.547 L 21.407 21.527 L 21.407 12.26 L 21.407 6.629 L 21.407 6.387 L 25.046 10.026 L 27.038 8.036 L 19.999 1 L 12.962 8.036 L 14.952 10.026 L 18.591 6.387 L 18.591 6.629 L 18.591 12.26 Z',
    },
    collapse: {
        path: 'M 20.284 2.595 L 20.284 10.91 L 4.931 10.91 L 9.732 6.07 L 8.586 4.913 L 1.55 12.001 L 8.586 19.089 L 9.732 17.93 L 4.931 13.092 L 20.284 13.092 L 20.284 21.405 L 22.45 21.405 L 22.45 2.595 L 20.284 2.595 Z',
    },
    collapse_right: {
        path: 'M3.72 21.4V13.1h15.35l-4.8 4.84 1.14 1.16 7.04-7.1-7.04-7.08-1.14 1.16 4.8 4.84H3.72V2.6H1.55v18.8h2.17z',
    },
    send: {
        path: 'M 36.897 1.074 C 37.475 0.862 38.124 1.004 38.561 1.439 C 38.985 1.882 39.114 2.531 38.894 3.103 L 26.213 37.977 C 25.99 38.594 25.41 39.01 24.754 39.023 C 24.122 39.005 23.561 38.612 23.328 38.024 L 17.241 22.807 L 2.023 16.72 C 1.407 16.486 1 15.896 1 15.238 C 1 14.579 1.407 13.989 2.023 13.755 L 36.897 1.074 Z  M 20.331 21.903 L 24.754 32.999 L 34.788 5.211 L 7 15.245 L 18.033 19.731 L 25.689 12.075 L 27.924 14.31 L 20.331 21.903 Z',
    },
    more: {
        path: 'M 32.667 20 C 32.667 21.749 34.084 23.167 35.833 23.167 C 37.582 23.167 39 21.749 39 20 C 39 18.251 37.582 16.833 35.833 16.833 C 34.084 16.833 32.667 18.251 32.667 20 Z  M 16.833 20 C 16.833 21.749 18.251 23.167 20 23.167 C 21.749 23.167 23.167 21.749 23.167 20 C 23.167 18.251 21.749 16.833 20 16.833 C 18.251 16.833 16.833 18.251 16.833 20 Z  M 1 20 C 1 21.749 2.418 23.167 4.167 23.167 C 5.916 23.167 7.333 21.749 7.333 20 C 7.333 18.251 5.916 16.833 4.167 16.833 C 2.418 16.833 1 18.251 1 20 Z',
    },
    lightning: {
        path: 'M8.707 22.441a.75.75 0 01-.45-.804l1.364-8.887H6a.743.743 0 01-.602-.277.739.739 0 01-.148-.645l2.25-9.75a.75.75 0 01.75-.578h7.5a.75.75 0 01.734.914L15.188 8.25h3.562c.285 0 .547.164.676.422a.751.751 0 01-.082.75l-9.75 12.75A.76.76 0 019 22.5a.833.833 0 01-.293-.059zM13.312 9.75l1.5-6.75h-5.96l-1.907 8.25h4.434l-1.195 7.71 7.066-9.21zm0 0',
    },
    virtual_private_cloud: {
        path: 'M15 15v-2.25a3 3 0 00-6 0V15c-.83 0-1.5.67-1.5 1.5V21c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4.5c0-.83-.67-1.5-1.5-1.5zm-4.5-2.25a1.5 1.5 0 013 0V15h-3zM9 21v-4.5h6V21zm0 0 M19.37 7.59a7.5 7.5 0 00-14.74 0 5.63 5.63 0 00.99 11.16H6v-1.5h-.38a4.13 4.13 0 01-.73-8.19l1.02-.18.2-1a6 6 0 0111.79 0l.2 1 1 .18a4.13 4.13 0 01-.72 8.19H18v1.5h.38a5.63 5.63 0 001-11.16zm0 0',
    },
    choices: {
        path: 'M15.75 3v1.5h2.7L12 10.94 5.56 4.5h2.69V3H3v5.25h1.5v-2.7l6.75 6.76V21h1.5v-8.7l6.75-6.74v2.69H21V3zm0 0',
    },
    loop_arrow: {
        path: 'M17.7 14.56l1.8 1.94h-3.75V18h3.75l-1.8 1.94L18.74 21l3.75-3.75-3.75-3.75zm0 0M9.75 4.5A6.74 6.74 0 004.15 15l1.24-.83a5.25 5.25 0 114.36 2.33H1.5V18h8.25a6.75 6.75 0 000-13.5zm0 0',
    },
    menu: {
        path: 'M21 4.5H3V6h18V4.5zM21 18H3v1.5h18V18zm0-9H3v1.5h18V9zm0 4.5H3V15h18v-1.5z',
    },
    kebab_menu: {
        path: 'M13.5 6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0 0M13.5 12a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0 0M13.5 18a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0 0',
    },
    laptop: {
        path: 'M19.5 18h-15A1.5 1.5 0 013 16.5V6c0-.82.67-1.5 1.5-1.5h15c.83 0 1.5.68 1.5 1.5v10.5c0 .83-.67 1.5-1.5 1.5zM4.5 6v10.5h15V6zm0 0M1.5 19.5h21V21h-21zm0 0',
    },
    switcher: {
        path: 'M10.5 3h3v3h-3zm0 0M3 3h3v3H3zm0 0M18 3h3v3h-3zm0 0M10.5 10.5h3v3h-3zm0 0M3 10.5h3v3H3zm0 0M18 10.5h3v3h-3zm0 0M10.5 18h3v3h-3zm0 0M3 18h3v3H3zm0 0M18 18h3v3h-3zm0 0',
    },
    import: {
        path: 'M10.9 1.1a.73.73 0 00-.74 0l-8.8 5.13a.73.73 0 00-.36.64v10.26a.73.73 0 00.36.64l8.8 5.13a.73.73 0 00.74 0l7.45-4.35-1.1-1.05-5.98 3.49v-8.62a.73.73 0 00-.35-.63L3.15 6.9l7.38-4.3 7.13 4.15 1.06-1.08L10.9 1.1zM2.47 8.19v8.52L9.8 21v-8.22L2.47 8.2zm16.4-.59l-4.67 4.67 4.67 4.67 1.04-1.04L17 13H23v-1.47h-6l2.9-2.9-1.03-1.03z',
    },
    hour_glass: {
        path: 'M7.2 2H6v1.18h1.2v3.57c0 1.77.9 3.42 2.4 4.4l1.3.85-1.3.85a5.27 5.27 0 00-2.4 4.4v3.57H6V22H18v-1.18h-1.26v-3.57c0-1.77-.9-3.42-2.4-4.4L13.05 12l1.29-.85a5.27 5.27 0 002.4-4.4V3.18H18V2H7.21zm8.34 1.18H8.4v3.57c0 .29.03.57.09.84v-.1h6.97c.04-.24.07-.49.07-.74V3.18zm0 14.07v3.57H8.4v-1.88c1.23-.11 2.02-.6 2.78-1.07l.33-.2a7.32 7.32 0 013.95-1.13c.04.23.07.47.07.7zm-3.57-5.96l1.7-1.11c.6-.4 1.07-.92 1.39-1.52H8.89c.32.6.79 1.13 1.38 1.52l1.7 1.11zm0 1.42l-1.7 1.11a4.1 4.1 0 00-1.86 3.43v.5c.86-.09 1.41-.43 2.13-.87l.35-.22a8.38 8.38 0 014.2-1.28 4.14 4.14 0 00-1.42-1.56l-1.7-1.11z',
    },
    fork: {
        path: 'M18.85 13.37c-.6 0-1.2.21-1.67.6-.48.36-.83.88-.97 1.47h-3.55V8.56h3.54a2.74 2.74 0 005.42-.7 2.77 2.77 0 00-2.4-2.71 2.77 2.77 0 00-3 2.04h-3.56a1.39 1.39 0 00-1.38 1.39v2.73H7.76a2.77 2.77 0 00-4.73-1.12 2.77 2.77 0 001.72 4.54 2.74 2.74 0 003.01-2.05h3.54v2.77c0 .35.13.7.4.97a1.39 1.39 0 00.96.4h3.54a2.77 2.77 0 002.11 2 2.74 2.74 0 002.72-1.01 2.74 2.74 0 00.3-2.9 2.64 2.64 0 00-1.01-1.12 2.77 2.77 0 00-1.46-.41h-.01zm0-6.87a1.42 1.42 0 011.26.85 1.39 1.39 0 01-.28 1.5 1.39 1.39 0 01-1.5.3 1.42 1.42 0 01-.6-.52 1.39 1.39 0 01.16-1.73 1.39 1.39 0 01.97-.4h-.01zM5.09 13.37a1.39 1.39 0 01-1.26-.84 1.39 1.39 0 01.3-1.5c.2-.18.45-.34.69-.37a1.45 1.45 0 01.81.06 1.39 1.39 0 01.45 2.26 1.35 1.35 0 01-.99.4zm13.77 4.13a1.39 1.39 0 01-.97-2.36 1.39 1.39 0 011.5-.28c.25.1.46.28.62.5a1.39 1.39 0 01-1.15 2.14zm0 0',
    },
    cube: {
        path: 'M21.38 6.1l-9-5.25a.75.75 0 00-.76 0l-9 5.25a.75.75 0 00-.37.65v10.5c0 .27.14.51.37.65l9 5.25c.24.14.52.14.76 0l9-5.25a.75.75 0 00.37-.65V6.75a.75.75 0 00-.37-.65zM12 2.37l7.51 4.38L12 11.13 4.49 6.75zM3.75 8.05l7.5 4.38v8.77l-7.5-4.38zm9 13.15v-8.77l7.5-4.38v8.77zm0 0',
    },
    user_plus: {
        path: 'M24 10.5h-3v-3h-1.5v3h-3V12h3v3H21v-3h3zm0 0M9 3a3.75 3.75 0 110 7.5A3.75 3.75 0 019 3m0-1.5A5.25 5.25 0 109 12 5.25 5.25 0 009 1.5zm0 0M16.5 22.5H15v-3.75A3.75 3.75 0 0011.25 15h-4.5A3.75 3.75 0 003 18.75v3.75H1.5v-3.75c0-2.9 2.35-5.25 5.25-5.25h4.5c2.9 0 5.25 2.35 5.25 5.25zm0 0',
    },
    two: {
        path: 'M3.23 17.84h6.83v1.39H1.52l.03-.71c.08-1.07.32-1.98.73-2.75a5.28 5.28 0 012.1-2L6 12.84c.82-.48 1.4-.96 1.74-1.42.35-.46.53-1.01.53-1.67a2.2 2.2 0 00-.7-1.7 2.56 2.56 0 00-1.87-.66c-1.8 0-2.7.93-2.7 2.78H1.5a4.02 4.02 0 011.1-3.07A4.33 4.33 0 015.76 6c1.23 0 2.22.34 2.98 1.04a3.54 3.54 0 011.14 2.7c0 1.67-.98 3.08-2.94 4.22l-1.38.8c-.8.48-1.37.95-1.73 1.42-.35.44-.55 1-.6 1.66zm0 0M11.8 6.29h4.36c1.96 0 3.51.57 4.65 1.71 1.13 1.14 1.69 2.72 1.69 4.76 0 2.01-.56 3.6-1.7 4.74a6.27 6.27 0 01-4.64 1.73H11.8zm1.52 11.55h2.84c1.52 0 2.7-.44 3.5-1.34a5.32 5.32 0 001.24-3.74c0-1.6-.41-2.85-1.24-3.74-.8-.9-1.98-1.35-3.5-1.35h-2.84zm0 0',
    },
    markup_view: {
        path: 'M12.73 3.97V1h-1.5v2.97a8.07 8.07 0 00-7.26 7.26H1v1.5h2.97a8.07 8.07 0 007.26 7.3V23h1.5v-2.97a8.07 8.07 0 007.3-7.3H23v-1.5h-2.97a8.07 8.07 0 00-7.3-7.26zM12 18.57a6.57 6.57 0 100-13.14 6.57 6.57 0 000 13.14zm-.77-5.84H6.87v-1.5h4.36V6.87h1.5v4.36h4.4v1.5h-4.4v4.4h-1.5v-4.4z',
    },
    share: {
        path: 'M19.35 13.44a.61.61 0 00-.62.6v2.33l-6.95 3.98V12a.6.6 0 00-.31-.53L4.22 7.3l6.95-4 3.79 2.19a.61.61 0 00.6-1.08l-4.1-2.34a.6.6 0 00-.6 0L2.7 6.77a.55.55 0 00-.27.48v9.46c0 .21.12.42.31.54l8.18 4.7c.18.09.38.09.54 0l8.18-4.71a.6.6 0 00.32-.53v-2.66c0-.34-.28-.6-.6-.61zM3.6 8.37l6.96 3.99v7.99l-6.96-4V8.37zm17.98-.86v-.09a.44.44 0 00-.04-.19v-.05a.63.63 0 00-.16-.2h-.04a.63.63 0 00-.2-.09l-4.08-.81a.63.63 0 00-.25 1.22l2.45.48-4.3 2.45a.61.61 0 00-.22.82c.1.2.31.31.53.31.1 0 .2-.02.3-.08l4.2-2.38-.98 2.45a.61.61 0 00.34.82l.23.04a.6.6 0 00.56-.4l1.63-4.09c.03-.06.03-.13.03-.21zm0 0',
    },
    user_settings: {
        path: 'M9.75 12a5.26 5.26 0 10-.01-10.51A5.26 5.26 0 009.75 12zm0-9a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5zm0 0M24 19.5V18h-1.2a4.1 4.1 0 00-.66-1.58l.85-.85-1.06-1.06-.85.85c-.46-.32-1-.55-1.58-.66v-1.2H18v1.2a4.1 4.1 0 00-1.58.66l-.85-.85-1.06 1.06.85.85c-.32.46-.55 1-.66 1.58h-1.2v1.5h1.2c.1.58.34 1.12.66 1.58l-.85.85 1.06 1.06.85-.85c.46.32 1 .55 1.58.66V24h1.5v-1.2a4.1 4.1 0 001.58-.66l.85.85 1.06-1.06-.85-.85c.32-.46.55-1 .66-1.58zm-5.25 1.88a2.63 2.63 0 110-5.26 2.63 2.63 0 010 5.25zm0 0M13.2 14.78A7.51 7.51 0 001.5 21v3H3v-3a6 6 0 019.35-4.97l.63.42.84-1.25zm0 0',
    },
    dashboard: {
        path: 'M19.5 4.5v3h-15v-3zm0-1.5h-15A1.5 1.5 0 003 4.5v3A1.5 1.5 0 004.5 9h15A1.5 1.5 0 0021 7.5v-3A1.5 1.5 0 0019.5 3zm0 0M7.5 12v7.5h-3V12zm0-1.5h-3A1.5 1.5 0 003 12v7.5A1.5 1.5 0 004.5 21h3A1.5 1.5 0 009 19.5V12a1.5 1.5 0 00-1.5-1.5zm0 0M19.5 12v7.5H12V12zm0-1.5H12a1.5 1.5 0 00-1.5 1.5v7.5A1.5 1.5 0 0012 21h7.5a1.5 1.5 0 001.5-1.5V12a1.5 1.5 0 00-1.5-1.5zm0 0',
    },
    part: {
        path: 'M17.3 13.01a.67.67 0 00-.07-.26h-.01a.53.53 0 00-.18-.18l-.02-.02-2.38-1.34a.56.56 0 10-.55.99l1.49.84-3.86 2.19-.05.04-.1.08-.05.08-.05.1-.02.11-.01.08v4.35l-3.6-2.04v-4.67l4.44-2.48.05-.05.1-.08a.28.28 0 00.05-.08c0-.04.03-.07.04-.1.03-.05.03-.08.03-.12l.01-.06V8.62l1.72-1.72a.57.57 0 00.17-.4V5.3H16c.3 0 .56-.26.56-.57V2.97a.57.57 0 00-.56-.58.58.58 0 00-.57.58v1.2H8.57v-1.2a.57.57 0 00-1.13 0v1.77c0 .3.26.56.57.56h1.55v1.22c0 .14.05.29.16.4l1.73 1.72v1.43L7 12.55a.52.52 0 00-.3.48v5.33c0 .2.11.4.3.48l4.72 2.69h.03c.08.05.16.08.26.08a.53.53 0 00.24-.07h.03l4.74-2.68a.56.56 0 00.28-.5V13.01zm-6.62-6.75V5.3h2.64v.97L12 7.58l-1.32-1.32zm5.5 11.76l-3.6 2.04v-4.03l3.6-2.04v4.03zm0 0',
    },
    factory: {
        path: 'M20.84 6.1a.65.65 0 0 0-.65 0L14.6 8.9V6.66a.7.7 0 0 0-.08-.33.66.66 0 0 0-.54-.34.63.63 0 0 0-.32.07L8.08 8.91V4a.68.68 0 0 0-.2-.47.65.65 0 0 0-.45-.2H3.5a.65.65 0 0 0-.47.2.68.68 0 0 0-.19.46v16.7h18.3V6.66a.67.67 0 0 0-.3-.57zm-4.92 13.25H13.3v-4.68h2.62v4.68zm3.92 0h-2.61V14a.68.68 0 0 0-.2-.47.65.65 0 0 0-.46-.2h-3.91a.65.65 0 0 0-.47.2.68.68 0 0 0-.19.47v5.34H4.16V4.66h2.61v6.43l6.53-3.34v3.34l6.55-3.35v11.6zm0 0',
    },
    ruler: {
        path: 'M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z',
    },
    box: {
        path: 'M33.6149 9.76473L17.037 0.199951L0.662606 9.71777L0.599976 29.0508L17.1309 38.6L33.6619 29.0508L33.6149 9.76473ZM32.0651 10.657V10.8136L31.9242 10.5788L32.0651 10.657ZM17.0527 2.0002L31.2981 10.2187L17.1622 18.4842L3.01075 10.1717L17.0527 2.0002ZM2.22804 11.5337L16.3639 19.8461V36.3301L2.18108 28.1429L2.22804 11.5337ZM17.9293 36.3301V19.8304L32.0651 11.565L32.1121 28.1272L17.9293 36.3301Z',
    },
    file: {
        path: 'M 13.873,-2 H 2.0000002 V 26 H 22 V 5.9619999 Z M 4.0260002,4.9999997e-8 V 24 H 19.973 V 8.0819999 h -8.19 v -8.08199985 H 4.0270002 Z M 13.81,0.75600005 V 6.0819999 h 5.436 z',
    },
    warning_circle: {
        path: 'M11.0001 1.59998C9.10139 1.59998 7.24533 2.16301 5.66661 3.21787C4.0879 4.27273 2.85745 5.77204 2.13085 7.52621C1.40424 9.28038 1.21413 11.2106 1.58455 13.0728C1.95497 14.9351 2.86928 16.6456 4.21186 17.9882C5.55445 19.3308 7.265 20.2451 9.12722 20.6155C10.9894 20.9859 12.9197 20.7958 14.6738 20.0692C16.428 19.3426 17.9273 18.1122 18.9822 16.5334C20.0371 14.9547 20.6001 13.0987 20.6001 11.2C20.6001 8.6539 19.5887 6.2121 17.7883 4.41175C15.988 2.6114 13.5462 1.59998 11.0001 1.59998ZM11.0001 19.4285C9.37263 19.4285 7.78172 18.9459 6.42854 18.0418C5.07536 17.1376 4.02068 15.8525 3.39788 14.3489C2.77508 12.8453 2.61213 11.1908 2.92963 9.59466C3.24713 7.99847 4.03082 6.53228 5.18161 5.3815C6.3324 4.23071 7.79859 3.44701 9.39477 3.12951C10.991 2.81201 12.6455 2.97497 14.149 3.59777C15.6526 4.22057 16.9377 5.27524 17.8419 6.62843C18.7461 7.98161 19.2287 9.57252 19.2287 11.2C19.2287 13.3823 18.3617 15.4753 16.8186 17.0185C15.2754 18.5616 13.1824 19.4285 11.0001 19.4285Z M11.525 5.6499H10.175V13.0749H11.525V5.6499Z M10.8501 15.1C10.6498 15.1 10.4541 15.1594 10.2876 15.2706C10.1211 15.3819 9.99129 15.54 9.91466 15.725C9.83802 15.91 9.81797 16.1136 9.85704 16.31C9.89611 16.5064 9.99254 16.6868 10.1341 16.8284C10.2757 16.97 10.4562 17.0664 10.6526 17.1055C10.849 17.1446 11.0525 17.1245 11.2376 17.0479C11.4226 16.9713 11.5807 16.8415 11.6919 16.675C11.8032 16.5085 11.8626 16.3127 11.8626 16.1125C11.8626 15.8439 11.7559 15.5864 11.566 15.3965C11.3762 15.2066 11.1186 15.1 10.8501 15.1Z',
    },
    download_local: {
        path: 'M13 12V14H3V12H2V14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H13C13.2652 15 13.5196 14.8946 13.7071 14.7071C13.8946 14.5196 14 14.2652 14 14V12H13Z M13 7L12.295 6.295L8.5 10.085V1H7.5V10.085L3.705 6.295L3 7L8 12L13 7Z',
    },
};

var wikifactory = __assign(__assign({}, global$1), { color: themeColors, font: font, breakpoints: breakpoints, icons: icons });

var themes = {
    wikifactory: wikifactory,
    wikifactoryNew: wikifactoryNew,
};

var OpenInSolidworksDialog = function (props) {
    var _a = props.title, title = _a === void 0 ? 'Open In Solidworks ' : _a, _b = props.description, description = _b === void 0 ? 'Allow Wikifactory to open the file in Solidworks' : _b, _c = props.closeButtonText, closeButtonText = _c === void 0 ? 'Cancel' : _c, _d = props.confirmButtonText, confirmButtonText = _d === void 0 ? 'Open' : _d, dialogProps = props.dialogProps, dialogContentProps = props.dialogContentProps, closeButtonProps = props.closeButtonProps, confirmButtonProps = props.confirmButtonProps, titleStyle = props.titleStyle, descriptionStyle = props.descriptionStyle, dialogActionsProps = props.dialogActionsProps, onDialogClose = props.onDialogClose, onDialogConfirm = props.onDialogConfirm;
    return (React__default.createElement(Dialog$1, __assign({}, dialogProps),
        React__default.createElement(DialogContent$1, __assign({ className: 'flex justify-center items-center flex-col', sx: { width: '26rem', padding: '2rem 2rem 0 2rem' } }, dialogContentProps),
            React__default.createElement("div", { style: titleStyle, className: 'font-extrabold text-18' }, title),
            React__default.createElement("div", { style: descriptionStyle, className: 'mt-2' }, description)),
        React__default.createElement(DialogActions$1, __assign({ sx: {
                display: 'flex',
                justifyContent: 'center',
                padding: '0.75rem 2.5rem 2rem 2.5rem',
            } }, dialogActionsProps),
            React__default.createElement(Button, __assign({ primaryColor: 'black-hollow', variant: 'outlined', onClick: onDialogClose }, closeButtonProps), closeButtonText),
            React__default.createElement(Button, __assign({ style: { marginLeft: '0.75rem' }, primaryColor: 'blue-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgRightArrow, null), onClick: onDialogConfirm }, confirmButtonProps), confirmButtonText))));
};

var _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React$1.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.53 1.426 5.5 11.456.468 6.426l1.06-1.06L5.5 9.334l8.97-8.97z",
    clipRule: "evenodd"
  })));
};

var _path$1, _path2$1, _path3$1, _path4$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgResolveConflicts = function SvgResolveConflicts(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 73,
    fill: "none"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    d: "M6.571 51.43V32.857h14.572l7.714 7.429h30.286l.742 7.424C62.505 43.07 64 37.71 64 32 64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32a31.86 31.86 0 0 0 6.571 19.43",
    clipRule: "evenodd"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m26.868 38.768-6.212-6.423H7.633v35.129H32v3.767H7.633a3.568 3.568 0 0 1-2.569-1.103A3.839 3.839 0 0 1 4 67.474v-35.13c0-.998.383-1.957 1.064-2.663a3.568 3.568 0 0 1 2.569-1.103h13.023c.48 0 .954.097 1.396.288.443.19.845.47 1.183.823l6.194 6.423h26.938c.964 0 1.888.397 2.569 1.103A3.839 3.839 0 0 1 60 39.88v9.264h-3.633v-9.264H27.921z",
    clipRule: "evenodd"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    d: "m20.656 32.345.205-.199-.084-.087h-.121zm6.212 6.423.207-.197-.002-.002zM7.633 32.345v-.286h-.286v.286zm0 35.129h-.286v.286h.286zm24.367 0h.286v-.286H32zm0 3.767v.286h.286v-.286zM5.064 70.138l.206-.199zm0-40.457.206.198zm15.592-1.103v.285zm1.396.288.114-.262zm1.183.823-.206.198zm6.194 6.423-.206.198.084.088h.122zm29.507 1.103.206-.198zM60 49.143v.286h.286v-.286zm-3.633 0h-.285v.286h.285zm0-9.264h.286v-.285h-.286zm-28.446 0-.207.197.084.089h.123zm-7.47-7.335 6.211 6.423.41-.398-6.21-6.423zm-12.818.087h13.023v-.572H7.633zm.285 34.843v-35.13h-.571v35.13zM32 67.188H7.633v.572H32zm.286 4.053v-3.767h-.572v3.767zm-24.653.286H32v-.572H7.633zm-2.775-1.19a3.854 3.854 0 0 0 2.775 1.19v-.572A3.282 3.282 0 0 1 5.27 69.94zm-1.144-2.863c0 1.072.41 2.101 1.144 2.862l.412-.397a3.553 3.553 0 0 1-.984-2.465zm0-35.13v35.13h.572v-35.13zm1.144-2.861a4.125 4.125 0 0 0-1.144 2.862h.572c0-.927.355-1.813.984-2.466zm2.775-1.191c-1.043 0-2.04.43-2.775 1.19l.412.397a3.282 3.282 0 0 1 2.363-1.016zm13.023 0H7.633v.571h13.023zm1.51.312a3.806 3.806 0 0 0-1.51-.312v.571c.44 0 .876.09 1.283.265zm1.275.887a3.914 3.914 0 0 0-1.275-.887l-.227.524a3.34 3.34 0 0 1 1.09.759zm6.193 6.423-6.193-6.423-.412.396 6.194 6.423zm26.733-.088H29.43v.572h26.938zm2.775 1.191a3.854 3.854 0 0 0-2.775-1.19v.57c.885 0 1.735.365 2.363 1.017zm1.144 2.862c0-1.071-.41-2.101-1.144-2.862l-.412.397c.63.652.984 1.539.984 2.465zm0 9.264v-9.264h-.572v9.264zm-3.919.286H60v-.572h-3.633zm-.285-9.55v9.264h.571v-9.264zm-28.161.286h28.446v-.572H27.921zm-1.26-1.2 1.053 1.11.414-.392-1.053-1.112z"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.571,
    d: "m44.422 71.896-9.535-9.538 2.694-2.695 6.841 6.84 14.466-14.468 2.699 2.698z"
  })));
};

var ResolveConflictsDialog = function (props) {
    var _a = props.selectedIds, selectedIds = _a === void 0 ? [] : _a, _b = props.resolveConflictsList, resolveConflictsList = _b === void 0 ? [] : _b, _c = props.allText, allText = _c === void 0 ? 'Resolve All' : _c, _d = props.title, title = _d === void 0 ? 'Resolve Conflicts' : _d, _e = props.closeButtonText, closeButtonText = _e === void 0 ? 'Cancel' : _e, _f = props.confirmButtonText, confirmButtonText = _f === void 0 ? 'Confirm' : _f, defaultExpanded = props.defaultExpanded, dialogProps = props.dialogProps, dialogContentProps = props.dialogContentProps, closeButtonProps = props.closeButtonProps, confirmButtonProps = props.confirmButtonProps, titleStyle = props.titleStyle, dialogActionsProps = props.dialogActionsProps, onDialogClose = props.onDialogClose, onDialogConfirm = props.onDialogConfirm, onSelectChange = props.onSelectChange;
    return (React__default.createElement(Dialog$1, __assign({}, dialogProps),
        React__default.createElement(DialogContent$1, __assign({ sx: { width: '36rem', padding: '2rem 2rem 0 2rem' } }, dialogContentProps),
            React__default.createElement("div", { className: 'flex items-center flex-col' },
                React__default.createElement(SvgResolveConflicts, null),
                React__default.createElement("div", { style: titleStyle, className: 'mt-2 font-extrabold text-18' }, title)),
            React__default.createElement(IndeterminateCheckbox, { allText: allText, defaultExpanded: defaultExpanded, selectedValue: selectedIds, data: resolveConflictsList.map(function (_a) {
                    var id = _a.id, name = _a.name, type = _a.type, message = _a.message, lastLocalChangeAuthorName = _a.lastLocalChangeAuthorName, lastLocalChangeTimestamp = _a.lastLocalChangeTimestamp;
                    return ({
                        label: (React__default.createElement("div", null,
                            React__default.createElement("span", null, name),
                            type && (React__default.createElement("span", { className: 'ml-2 text-14 text-gray-500' },
                                "(Kept ",
                                type,
                                ")")))),
                        value: id,
                        details: message,
                        extra: (React__default.createElement("div", { className: 'text-10' },
                            React__default.createElement("span", null, lastLocalChangeTimestamp),
                            React__default.createElement("span", { className: 'text-gray-700' }, lastLocalChangeAuthorName &&
                                " by ".concat(lastLocalChangeAuthorName)))),
                    });
                }), accordionDetailsProps: {
                    sx: { padding: 0, overflowY: 'auto', maxHeight: '10rem' },
                }, onSelectChange: onSelectChange })),
        React__default.createElement(DialogActions$1, __assign({ sx: {
                display: 'flex',
                justifyContent: 'center',
                padding: '0.75rem 2.5rem 2rem 2.5rem',
            } }, dialogActionsProps),
            React__default.createElement(Button, __assign({ primaryColor: 'black-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgClose, null), onClick: onDialogClose }, closeButtonProps), closeButtonText),
            React__default.createElement(Button, __assign({ style: { marginLeft: '0.75rem' }, primaryColor: 'blue-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgCheck, null), onClick: onDialogConfirm }, confirmButtonProps), confirmButtonText))));
};

var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCheckout = function SvgCheckout(props) {
  return /*#__PURE__*/React$1.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 76,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React$1.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    d: "M6.571 51.93V33.357h14.572l7.714 7.429h30.286l.742 7.424C62.505 43.57 64 38.21 64 32.5c0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32a31.86 31.86 0 0 0 6.571 19.43",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m26.868 39.69-6.212-6.423H7.633v35.13H20v3.766H7.633a3.568 3.568 0 0 1-2.569-1.103A3.84 3.84 0 0 1 4 68.396V33.267c0-.999.383-1.957 1.064-2.664A3.568 3.568 0 0 1 7.633 29.5h13.023c.48 0 .954.098 1.396.288.443.191.845.47 1.183.823l6.194 6.423h26.938c.964 0 1.888.397 2.569 1.104A3.839 3.839 0 0 1 60 40.802v27.594c0 1-.383 1.958-1.064 2.664a3.568 3.568 0 0 1-2.569 1.103H44v-3.767h12.367V40.802H27.921z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    d: "m20.656 33.267.205-.198-.084-.088h-.121zm6.212 6.423.207-.196-.002-.002zM7.633 33.267v-.286h-.286v.286zm0 35.13h-.286v.285h.286zm12.367 0h.286v-.286H20zm0 3.766v.286h.286v-.285zM5.064 71.06l.206-.198zm0-40.457.206.199zM20.656 29.5v.286zm1.396.288.114-.262zm1.183.823-.206.198zm6.194 6.423-.206.199.084.087h.122zm29.507 1.104.206-.198zm0 32.922.206.198zM44 72.163h-.286v.286H44zm0-3.767v-.285h-.286v.285zm12.367 0v.286h.286v-.286zm0-27.594h.286v-.286h-.286zm-28.446 0-.207.196.084.09h.123zm-7.47-7.336 6.211 6.423.41-.397-6.21-6.423zm-12.818.087h13.023v-.572H7.633zm.285 34.843V33.267h-.571v35.13zM20 68.111H7.633v.571H20zm.286 4.052v-3.767h-.572v3.767zm-12.653.286H20v-.571H7.633zm-2.775-1.19a3.854 3.854 0 0 0 2.775 1.19v-.571a3.282 3.282 0 0 1-2.363-1.016zm-1.144-2.863c0 1.072.41 2.102 1.144 2.862l.412-.396a3.554 3.554 0 0 1-.984-2.466zm0-35.129v35.13h.572v-35.13zm1.144-2.862a4.125 4.125 0 0 0-1.144 2.862h.572c0-.926.355-1.813.984-2.465zm2.775-1.19c-1.043 0-2.04.429-2.775 1.19l.412.397a3.282 3.282 0 0 1 2.363-1.016zm13.023 0H7.633v.57h13.023zm1.51.31a3.808 3.808 0 0 0-1.51-.31v.57c.44 0 .876.09 1.283.266zm1.275.889a3.916 3.916 0 0 0-1.275-.888l-.227.525c.407.175.778.433 1.09.758zm6.193 6.422-6.193-6.423-.412.397 6.194 6.423zm26.733-.087H29.43v.571h26.938zm2.775 1.19a3.854 3.854 0 0 0-2.775-1.19v.571c.885 0 1.735.364 2.363 1.016zm1.144 2.863c0-1.072-.41-2.102-1.144-2.862l-.412.396c.63.652.984 1.539.984 2.466zm0 13.797V40.802h-.572v13.797zm0 13.797V54.6h-.572v13.797zm-1.144 2.862a4.125 4.125 0 0 0 1.144-2.862h-.572c0 .927-.355 1.814-.984 2.466zm-2.775 1.191c1.043 0 2.04-.43 2.775-1.19l-.412-.397a3.282 3.282 0 0 1-2.363 1.016zm-11.624 0h11.624v-.571H44.743zm-.743 0h.743v-.571H44zm-.286-4.053v3.767h.572v-3.767zm1.029-.285H44v.571h.743zm11.624 0H44.743v.571h11.624zm-.285-13.512v13.797h.571V54.6zm0-13.797v13.797h.571V40.802zm-28.161.285h28.446v-.571H27.921zm-1.26-1.2 1.053 1.111.414-.393-1.053-1.111z"
  })), _path4 || (_path4 = /*#__PURE__*/React$1.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m31.762 75.493 9.926-9.586-2.778-2.877-5.017 4.844.254-16.868-3.995-.07-.254 16.869-4.845-5.017-2.878 2.778z",
    clipRule: "evenodd"
  })));
};

var AssemlyCheckOutDialog = function (props) {
    var _a = props.checkOutList, checkOutList = _a === void 0 ? [] : _a, selectedIds = props.selectedIds, defaultExpanded = props.defaultExpanded, _b = props.title, title = _b === void 0 ? 'Assemly Check Out ' : _b, _c = props.subTitle, subTitle = _c === void 0 ? 'Assembly-Name.sldasm' : _c, _d = props.description, description = _d === void 0 ? 'Select the parts that you would like to Check Out' : _d, _e = props.closeButtonText, closeButtonText = _e === void 0 ? 'Close' : _e, _f = props.confirmButtonText, confirmButtonText = _f === void 0 ? 'Confirm' : _f, dialogProps = props.dialogProps, dialogContentProps = props.dialogContentProps, closeButtonProps = props.closeButtonProps, confirmButtonProps = props.confirmButtonProps, titleStyle = props.titleStyle, descriptionStyle = props.descriptionStyle, dialogActionsProps = props.dialogActionsProps, onDialogClose = props.onDialogClose, onDialogConfirm = props.onDialogConfirm, onSelectChange = props.onSelectChange;
    return (React__default.createElement(Dialog$1, __assign({}, dialogProps),
        React__default.createElement(DialogContent$1, __assign({ sx: { width: '38rem', maxHeight: '29rem', padding: '2rem 2rem 0 2rem' } }, dialogContentProps),
            React__default.createElement("div", { style: titleStyle, className: 'flex items-center flex-col' },
                React__default.createElement(SvgCheckout, null),
                React__default.createElement("div", { className: 'mt-2 font-extrabold text-24 text-24' }, title)),
            React__default.createElement("div", { className: 'font-extrabold text-18' }, subTitle),
            React__default.createElement("div", { style: descriptionStyle, className: 'mt-2' }, description),
            React__default.createElement(IndeterminateCheckbox, { data: checkOutList.map(function (_a) {
                    var id = _a.id, name = _a.name;
                    return ({
                        label: name,
                        value: id,
                    });
                }), allText: 'Select All', accordionDetailsProps: {
                    sx: { paddingLeft: '2rem', overflowY: 'auto', maxHeight: '10rem' },
                }, defaultExpanded: defaultExpanded, selectedValue: selectedIds, onSelectChange: onSelectChange })),
        React__default.createElement(DialogActions$1, __assign({ sx: {
                display: 'flex',
                justifyContent: 'center',
                padding: '0.75rem 2.5rem 2rem 2.5rem',
            } }, dialogActionsProps),
            React__default.createElement(Button, __assign({ primaryColor: 'black-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgClose, null), onClick: onDialogClose }, closeButtonProps), closeButtonText),
            React__default.createElement(Button, __assign({ style: { marginLeft: '0.75rem' }, primaryColor: 'blue-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgRightArrow, null), onClick: onDialogConfirm }, confirmButtonProps), confirmButtonText))));
};

var Circle = {};

var _interopRequireDefault$1 = interopRequireDefaultExports$1;
Object.defineProperty(Circle, "__esModule", {
  value: true
});
var default_1$1 = Circle.default = void 0;
var _createSvgIcon$1 = _interopRequireDefault$1(requireCreateSvgIcon());
var _jsxRuntime$1 = requireJsxRuntime();
default_1$1 = Circle.default = (0, _createSvgIcon$1.default)( /*#__PURE__*/(0, _jsxRuntime$1.jsx)("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2"
}), 'Circle');

var RadioButtonUnchecked = {};

var _interopRequireDefault = interopRequireDefaultExports$1;
Object.defineProperty(RadioButtonUnchecked, "__esModule", {
  value: true
});
var default_1 = RadioButtonUnchecked.default = void 0;
var _createSvgIcon = _interopRequireDefault(requireCreateSvgIcon());
var _jsxRuntime = requireJsxRuntime();
default_1 = RadioButtonUnchecked.default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'RadioButtonUnchecked');

var getActiveItemIndex = function (activeStep, length) {
    if (activeStep >= length) {
        return length - 1;
    }
    if (activeStep < 0) {
        return 0;
    }
    return activeStep;
};
var StepperDialog = function (props) {
    var _a = props.activeStep, activeStep = _a === void 0 ? 0 : _a, _b = props.items, items = _b === void 0 ? [] : _b, dialogContentProps = props.dialogContentProps, dialogActionsProps = props.dialogActionsProps, stepperProps = props.stepperProps, titleProps = props.titleProps, onNextClick = props.onNextClick, onStepClick = props.onStepClick, rest = __rest(props, ["activeStep", "items", "dialogContentProps", "dialogActionsProps", "stepperProps", "titleProps", "onNextClick", "onStepClick"]);
    var activeItemIndex = getActiveItemIndex(activeStep, items.length);
    var activeItem = items[activeItemIndex];
    return (React__default.createElement(Dialog$1, __assign({}, rest),
        React__default.createElement(DialogContent$1, __assign({ sx: { width: 500, gap: 2 }, className: 'flex items-center flex-col' }, dialogContentProps), activeItem === null || activeItem === void 0 ? void 0 :
            activeItem.icon,
            React__default.createElement("div", __assign({ className: 'text-18 font-extrabold' }, titleProps), activeItem.title),
            React__default.createElement("div", null, activeItem === null || activeItem === void 0 ? void 0 : activeItem.content),
            React__default.createElement(DialogActions$1, __assign({ className: 'flex items-center flex-col' }, dialogActionsProps),
                React__default.createElement("div", { onClick: function (e) { return onNextClick === null || onNextClick === void 0 ? void 0 : onNextClick(e); } }, activeItem === null || activeItem === void 0 ? void 0 : activeItem.nextButton),
                React__default.createElement(Stepper$1, __assign({ className: 'mt-2', activeStep: activeStep }, stepperProps), items.map(function (_, index) { return (React__default.createElement(Step$1, { key: index },
                    React__default.createElement(IconButton$1, { color: 'inherit', sx: { padding: 0 }, onClick: function (e) {
                            onStepClick === null || onStepClick === void 0 ? void 0 : onStepClick(e, index);
                        } }, activeItemIndex === index ? (React__default.createElement(default_1$1, { sx: { fontSize: 12 } })) : (React__default.createElement(default_1, { sx: { fontSize: 12 } }))))); }))))));
};

var VoxelDialog = function (props) {
    var title = props.title, titleProps = props.titleProps, _a = props.wrapClassName, wrapClassName = _a === void 0 ? '' : _a, contentProps = props.contentProps, actionsProps = props.actionsProps, closeButtonProps = props.closeButtonProps, confirmButtonProps = props.confirmButtonProps, icon = props.icon, children = props.children, onClose = props.onClose, onConfirm = props.onConfirm, _b = props.actions, actions = _b === void 0 ? (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button, __assign({ primaryColor: 'black-hollow', variant: 'outlined', onClick: onClose, children: 'Cancel' }, closeButtonProps)),
        React__default.createElement(Button, __assign({ primaryColor: 'blue-hollow', variant: 'outlined', endIcon: React__default.createElement(SvgRightArrow, null), onClick: onConfirm, children: 'Confirm' }, confirmButtonProps)))) : _b, rest = __rest(props, ["title", "titleProps", "wrapClassName", "contentProps", "actionsProps", "closeButtonProps", "confirmButtonProps", "icon", "children", "onClose", "onConfirm", "actions"]);
    return (React__default.createElement(Dialog$1, __assign({}, rest),
        React__default.createElement("div", { className: "p-4 ".concat(wrapClassName) },
            icon && React__default.createElement("div", { className: 'flex justify-center' }, icon),
            React__default.createElement("div", __assign({ className: 'mt-2 text-center text-24 font-extrabold' }, titleProps), title),
            React__default.createElement(DialogContent$1, __assign({}, contentProps), children),
            React__default.createElement(DialogActions$1, __assign({ sx: { display: 'flex', justifyContent: 'center' } }, actionsProps), actions))));
};

var VoxelAccordion = function (props) {
    return (React__default.createElement(Accordion$1, __assign({ sx: {
            boxShadow: 'none',
            // Overlay mui style
            '::before': {
                content: "''",
                background: 'transparent',
            },
        }, className: 'w-full', disableGutters: true }, props)));
};
VoxelAccordion.Summary = function (props) {
    return (React__default.createElement(AccordionSummary$1, __assign({ sx: {
            padding: 0,
            borderBottom: '1px solid #ECECEC',
        }, expandIcon: React__default.createElement(default_1$4, { htmlColor: 'black' }) }, props)));
};
VoxelAccordion.Details = function (props) {
    return (React__default.createElement(AccordionDetails$1, __assign({ sx: { padding: 0 }, className: 'mt-2 mb-2 ml-6 text-sm text-black-400' }, props)));
};

var FileChangesList = function (props) {
    var changesList = props.changesList;
    return (React__default.createElement(VoxelAccordion, null,
        React__default.createElement(VoxelAccordion.Summary, null,
            React__default.createElement("div", { className: 'mt-2 text-18 font-extrabold' },
                changesList.reduce(function (acc, cur) { return acc + cur.files.length; }, 0),
                React__default.createElement("span", { className: 'ml-1' }, "Changes"))),
        React__default.createElement(VoxelAccordion.Details, null, changesList
            .filter(function (item) { var _a; return (_a = item.files) === null || _a === void 0 ? void 0 : _a.length; })
            .map(function (_a) {
            var type = _a.type, files = _a.files;
            return (React__default.createElement(VoxelAccordion, { key: type },
                React__default.createElement(VoxelAccordion.Summary, null,
                    React__default.createElement("div", { className: 'flex' },
                        React__default.createElement(WorkflowStatus, { textStyle: { display: 'none' }, status: type }),
                        React__default.createElement("span", { className: 'font-extrabold mr-1 ml-2' }, "added"),
                        React__default.createElement("span", { className: 'text-gray-400' },
                            "(",
                            files.length,
                            ")"))),
                files.map(function (_a) {
                    var id = _a.id, name = _a.name;
                    return (React__default.createElement(VoxelAccordion.Details, { key: id }, name));
                })));
        }))));
};

var AutoComplete = function (_a) {
    var _b = _a.textProps, textProps = _b === void 0 ? {} : _b, inputValue = _a.inputValue, muiAutoCompleteProps = __rest(_a, ["textProps", "inputValue"]);
    var _c = useState(''), value = _c[0], setValue = _c[1];
    useEffect(function () {
        setValue(inputValue);
    }, [inputValue]);
    return (React__default.createElement(Autocomplete$1, __assign({ disableCloseOnSelect: true }, muiAutoCompleteProps, { inputValue: value, renderInput: function (params) {
            return (React__default.createElement(MTextField, __assign({ value: 'standard', variant: 'standard' }, params, textProps, { onChange: function (e) {
                    var _a;
                    setValue(e.target.value);
                    (_a = textProps.onChange) === null || _a === void 0 ? void 0 : _a.call(textProps, e);
                }, onKeyDown: function (e) {
                    var _a;
                    var clearValue = (_a = textProps.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(textProps, e, value, params);
                    if (clearValue) {
                        setValue('');
                    }
                } })));
        } })));
};

var VoxelMuiThemeProvider = ThemeProvider;
var createTheme = createTheme$1;

var Select = function (_a) {
    var children = _a.children, options = _a.options, selectProps = __rest(_a, ["children", "options"]);
    var renderContent = useMemo(function () {
        if (children)
            return children;
        return options === null || options === void 0 ? void 0 : options.map(function (_a) {
            var value = _a.value, label = _a.label, rest = __rest(_a, ["value", "label"]);
            return (React__default.createElement(MenuItem$1, __assign({ value: value, key: value === null || value === void 0 ? void 0 : value.toString() }, rest), label));
        });
    }, [options, children]);
    return (React__default.createElement(MSelect, __assign({ className: 'h-10', fullWidth: true }, selectProps), renderContent));
};

var TextButton = function (_a) {
    var text = _a.text, onClick = _a.onClick;
    return (React__default.createElement("button", { className: 'text-black underline hover:text-blue-500 cursor-pointer', onClick: function () {
            onClick === null || onClick === void 0 ? void 0 : onClick();
        } }, text));
};

var useFormControlLabels = function (_a) {
    var items = _a.items;
    if (!(items === null || items === void 0 ? void 0 : items.length))
        return null;
    return items.map(function (item) {
        return React__default.createElement(FormControlLabel$1, __assign({}, item));
    });
};

var useGetMenuItems = function (_a) {
    var items = _a.items, activityKey = _a.activityKey;
    var _b = useState(), selectedKey = _b[0], setSelectedKey = _b[1];
    useEffect(function () {
        setSelectedKey(activityKey);
    }, [activityKey]);
    var menuItems = useMemo(function () {
        if (!(items === null || items === void 0 ? void 0 : items.length))
            return null;
        return items.map(function (_a) {
            var _b;
            var key = _a.key, value = _a.value, icon = _a.icon, label = _a.label, divider = _a.divider, isActive = _a.isActive, iconWrapperStyle = _a.iconWrapperStyle, rowStyle = _a.rowStyle, rowClassName = _a.rowClassName, itemProps = __rest(_a, ["key", "value", "icon", "label", "divider", "isActive", "iconWrapperStyle", "rowStyle", "rowClassName"]);
            return (React__default.createElement("div", { style: rowStyle, className: rowClassName, key: (_b = key !== null && key !== void 0 ? key : String(value)) !== null && _b !== void 0 ? _b : String(label) },
                React__default.createElement(MenuItem$1, __assign({ value: value, selected: isActive !== null && isActive !== void 0 ? isActive : (selectedKey && value === selectedKey) }, itemProps),
                    icon && (React__default.createElement(ListItemIcon$1, { style: iconWrapperStyle }, icon)),
                    label),
                divider));
        });
    }, [items]);
    return {
        menuItems: menuItems,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
    };
};

var MenuList = function (_a) {
    var items = _a.items, children = _a.children, menuTitle = _a.menuTitle, activityKey = _a.activityKey, menuListProps = __rest(_a, ["items", "children", "menuTitle", "activityKey"]);
    var menuItems = useGetMenuItems({
        items: items,
        activityKey: activityKey,
    }).menuItems;
    return (React__default.createElement(MMenuList, __assign({ dense: true }, menuListProps),
        menuTitle,
        menuItems || children));
};

var Breadcrumbs = function (_a) {
    var items = _a.items, children = _a.children, breadcrumbsProps = __rest(_a, ["items", "children"]);
    var renderContent = useMemo(function () {
        if (children)
            return children;
        return items === null || items === void 0 ? void 0 : items.map(function (_a) {
            var label = _a.label;
            // TODO: need refactor when click item can rightly jump
            return React__default.createElement(Typography$1, { color: 'text.primary' }, label);
        });
    }, [items, children]);
    return (React__default.createElement(MBreadcrumbs, __assign({ "aria-label": 'breadcrumb' }, breadcrumbsProps), renderContent));
};

var RadioGroup = function (_a) {
    var items = _a.items, children = _a.children, groupProps = __rest(_a, ["items", "children"]);
    var renderContent = useFormControlLabels({
        items: items === null || items === void 0 ? void 0 : items.map(function (_a) {
            var radioProps = _a.radioProps, rest = __rest(_a, ["radioProps"]);
            return (__assign({ control: React__default.createElement(Radio$1, __assign({}, (radioProps || {}))) }, rest));
        }),
    });
    return React__default.createElement(MRadioGroup, __assign({}, groupProps), renderContent || children);
};

var Switch = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, style = _a.style, left = _a.left, right = _a.right, switchProps = __rest(_a, ["className", "style", "left", "right"]);
    return (React__default.createElement("div", { className: " flex items-center ".concat(className), style: style },
        left,
        React__default.createElement(MSwitch, __assign({}, switchProps)),
        right));
};

var List = function (_a) {
    var items = _a.items, children = _a.children, listProps = __rest(_a, ["items", "children"]);
    return (React__default.createElement(MList, __assign({ dense: true }, listProps), children ||
        (items === null || items === void 0 ? void 0 : items.map(function (_a, index) {
            var _b;
            var content = _a.content, key = _a.key, rest = __rest(_a, ["content", "key"]);
            var showKey = (_b = (key || (content === null || content === void 0 ? void 0 : content.key))) !== null && _b !== void 0 ? _b : index;
            return (React__default.createElement(ListItem$1, __assign({ key: showKey }, rest), content));
        }))));
};

var Progress = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'linear' : _b, progressProps = __rest(_a, ["type"]);
    return type === 'linear' ? (React__default.createElement(LinearProgress$1, __assign({}, progressProps))) : (React__default.createElement(CircularProgress$1, __assign({}, progressProps)));
};

var Drawer = function (_a) {
    var title = _a.title, children = _a.children, onClosePanel = _a.onClosePanel, _b = _a.titleClassName, titleClassName = _b === void 0 ? '' : _b, drawerProps = __rest(_a, ["title", "children", "onClosePanel", "titleClassName"]);
    return (React__default.createElement(MDrawer, __assign({ anchor: 'right', onClose: onClosePanel }, drawerProps),
        React__default.createElement("div", { className: "font-primary mb-6 flex items-center justify-between ".concat(titleClassName) },
            React__default.createElement("div", { className: ' font-extrabold text-24' }, title),
            React__default.createElement("div", { className: 'text-black-1000 cursor-pointer hover:opacity-70', onClick: onClosePanel },
                React__default.createElement(SvgClose, null))),
        children));
};

var DescriptionItem = function (_a) {
    var label = _a.label, value = _a.value, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.labelClassName, labelClassName = _c === void 0 ? '' : _c, _d = _a.valueClassName, valueClassName = _d === void 0 ? '' : _d, _e = _a.emptyPlaceholder, emptyPlaceholder = _e === void 0 ? '-' : _e;
    return (React__default.createElement("div", { className: "flex items-center text-14 justify-between font-primary ".concat(className) },
        React__default.createElement("div", { className: "text-black-1000 mr-1 ".concat(labelClassName) }, label),
        React__default.createElement("div", { className: "text-gray-600 ".concat(valueClassName) }, value !== null && value !== void 0 ? value : emptyPlaceholder)));
};
var DescriptionList = function (_a) {
    var title = _a.title, items = _a.items, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.itemClassName, itemClassName = _c === void 0 ? '' : _c, itemProps = __rest(_a, ["title", "items", "className", "itemClassName"]);
    return (React__default.createElement("div", { className: "flex flex-col gap-2 font-primary ".concat(className) },
        title && React__default.createElement("div", { className: 'font-extrabold' }, title),
        items.map(function (item) { return (React__default.createElement(DescriptionItem, __assign({ key: item.key, label: item.label, value: item.value, className: itemClassName }, itemProps))); })));
};

var createRecursiveFilter = function (s) {
    if (!s)
        return function () { return true; };
    var recursiveFilter = function (value) {
        if (value.filename.includes(s))
            return true;
        if (!value.children)
            return false;
        return value.children.some(recursiveFilter);
    };
    return recursiveFilter;
};
var RowTextFilter = forwardRef(function (_a, ref) {
    var onSubmitFilter = _a.onSubmitFilter, numFilesHidden = _a.numFilesHidden, numFoldersHidden = _a.numFoldersHidden;
    var _b = useState(''), filterValue = _b[0], setFilterValue = _b[1];
    var submitNewFilterText = function (text) {
        setFilterValue(text);
        onSubmitFilter(createRecursiveFilter(text));
    };
    var clear = function () {
        submitNewFilterText('');
    };
    useImperativeHandle(ref, function () { return ({
        clear: clear,
    }); }, []);
    var clearButton = filterValue ? (React__default.createElement(InputAdornment$1, { position: 'end' },
        numFilesHidden > 0 && (React__default.createElement(Chip$1, { className: 'ml-1', label: "".concat(numFilesHidden, " file").concat(numFilesHidden > 1 ? 's' : '', " hidden"), size: 'small' })),
        numFoldersHidden > 0 && (React__default.createElement(Chip$1, { className: 'ml-1', label: "".concat(numFoldersHidden, " folder").concat(numFoldersHidden > 1 ? 's' : '', " hidden"), size: 'small' })),
        React__default.createElement(IconButton$1, { "aria-label": 'clear filter', onClick: function () {
                clear();
            }, edge: 'end', size: 'small' },
            React__default.createElement(default_1$3, { fontSize: 'small' })))) : null;
    return (React__default.createElement(MTextField, { size: 'small', id: 'outlined-basic', label: 'Filter content', variant: 'outlined', value: filterValue, onChange: function (event) {
            submitNewFilterText(event.target.value);
        }, InputProps: {
            endAdornment: clearButton,
        }, fullWidth: true }));
});
RowTextFilter.displayName = 'RowTextFilter';

export { AssemlyCheckOutDialog, AutoComplete, Avatar, Banner, BannerVariant, Breadcrumbs, Button, ConflictResolution, ConnectionOverview, ContributeDialog, DescriptionItem, DescriptionList, Drawer, DriveTable, DriveToolBar, EmptyDriveState, FileChangesList, FileIcon, LastContributionView, List, LocalChangesConnectionDialog, LocalChangesTable, LocalChangesToolBar, MenuList, OpenInSolidworksDialog, Progress, RadioGroup, ResetChangesDialog, ResolveConflictsDialog, RowTextFilter, Select, StepperDialog, Switch, SyncStatus, Table$1 as Table, TableVirtuoso, TextButton, Tree, VoxelAccordion, VoxelDialog, VoxelMuiThemeProvider, WorkflowStatus, createTheme, themes };
